import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** The `Upload` scalar type represents a file upload. */
  Upload: any;
  /** The `DateTime` scalar represents an ISO-8601 compliant date time type. */
  DateTime: any;
  /** The built-in `Decimal` scalar type. */
  Decimal: any;
  /** The `Byte` scalar type represents non-fractional whole numeric values. Byte can represent values between 0 and 255. */
  Byte: any;
  UUID: any;
  Any: any;
  /** The `TimeSpan` scalar represents an ISO-8601 compliant duration type. */
  TimeSpan: any;
  /** The `Long` scalar type represents non-fractional signed whole 64-bit numeric values. Long can represent values between -(2^63) and 2^63 - 1. */
  Long: any;
};




export type DatabaseError = {
  __typename?: 'DatabaseError';
  id: Scalars['Int'];
  message?: Maybe<Scalars['String']>;
};


export type Query = {
  __typename?: 'Query';
  activities?: Maybe<Array<Maybe<Activity>>>;
  allMenus?: Maybe<Array<Maybe<Screen>>>;
  auditCodes?: Maybe<AuditCodesConnection>;
  audits?: Maybe<AuditsConnection>;
  availablePermissions?: Maybe<Array<Permission>>;
  budgetHolderByCode?: Maybe<BudgetHolder>;
  budgetHolderById?: Maybe<BudgetHolder>;
  budgetHolders?: Maybe<BudgetHoldersConnection>;
  carrierByCode?: Maybe<Carrier>;
  carrierById?: Maybe<Carrier>;
  carrierLeadTimes?: Maybe<Array<Maybe<CarrierLeadTime>>>;
  carrierModules?: Maybe<Array<Maybe<Scalars['String']>>>;
  carriers?: Maybe<CarriersConnection>;
  closeLoadMethods?: Maybe<Array<Maybe<Scalars['String']>>>;
  code?: Maybe<UdCode>;
  codeDefinitions?: Maybe<CodeDefinitionsConnection>;
  codes?: Maybe<CodesConnection>;
  codesForType?: Maybe<CodesForTypeConnection>;
  configurationForModule?: Maybe<Array<Maybe<ConfigOption>>>;
  coreVersion?: Maybe<Scalars['String']>;
  countries?: Maybe<CountriesConnection>;
  countryByCode?: Maybe<Country>;
  currencies?: Maybe<Array<Maybe<Scalars['String']>>>;
  currentRateForCurrency?: Maybe<ExchangeRate>;
  currentUser?: Maybe<WmsUserResult>;
  defaultForTable?: Maybe<TablePresetResult>;
  defaultMenu?: Maybe<Array<Maybe<MenuEntry>>>;
  despatchMethods?: Maybe<Array<Maybe<Scalars['String']>>>;
  destinationByCode?: Maybe<Destination>;
  destinationById?: Maybe<Destination>;
  destinationCodes?: Maybe<Array<Maybe<DestinationCode>>>;
  destinations?: Maybe<DestinationsConnection>;
  exchangeRateById?: Maybe<ExchangeRate>;
  exchangeRates?: Maybe<ExchangeRatesConnection>;
  exchangeRatesForCurrency?: Maybe<ExchangeRatesForCurrencyConnection>;
  goodsReceipt?: Maybe<GoodsReceiptQueryType>;
  handlingTypeByCode?: Maybe<HandlingType>;
  handlingTypeById?: Maybe<HandlingType>;
  handlingTypes?: Maybe<HandlingTypesConnection>;
  licencePlate?: Maybe<LicencePlateQueryType>;
  loadedModules?: Maybe<Array<Maybe<AssemblyName>>>;
  locationByCode?: Maybe<Location>;
  locationById?: Maybe<Location>;
  locationPhysicalTypes?: Maybe<Array<Maybe<LocationPhysicalTypeMetadata>>>;
  locationProcessTypes?: Maybe<Array<Maybe<LocationProcessTypeMetadata>>>;
  locations?: Maybe<LocationsConnection>;
  materialHandlingEquipment?: Maybe<MaterialHandlingEquipmentConnection>;
  materialHandlingEquipmentByCode?: Maybe<MaterialHandlingEquipment>;
  materialHandlingEquipmentById?: Maybe<MaterialHandlingEquipment>;
  maxWeeklySpends?: Maybe<Array<Maybe<MaxWeeklySpend>>>;
  orderEntries?: Maybe<Array<Maybe<OrderEntry>>>;
  orderEntry?: Maybe<OrderEntry>;
  orderTypes?: Maybe<Array<Maybe<OrderType>>>;
  packType?: Maybe<ProductPackTypeQueryType>;
  packingMethods?: Maybe<Array<Maybe<Scalars['String']>>>;
  pickConfirmMethods?: Maybe<Array<Maybe<Scalars['String']>>>;
  pickCreationMethods?: Maybe<Array<Maybe<Scalars['String']>>>;
  pickListTypes?: Maybe<Array<Maybe<PickListType>>>;
  pickOutputMethods?: Maybe<Array<Maybe<Scalars['String']>>>;
  poFormats?: Maybe<Array<Maybe<PoFormat>>>;
  poTransmissionMethods?: Maybe<Array<Maybe<PoTransmissionMethod>>>;
  postPickConfirmMethods?: Maybe<Array<Maybe<Scalars['String']>>>;
  postPickCreationMethods?: Maybe<Array<Maybe<Scalars['String']>>>;
  prePickCreationMethods?: Maybe<Array<Maybe<Scalars['String']>>>;
  preset?: Maybe<TablePresetResult>;
  presetTableNames?: Maybe<Array<Maybe<Scalars['String']>>>;
  presetsForTable?: Maybe<PresetsForTableConnection>;
  /** Returns a list of products for userContext.StockOwner */
  product?: Maybe<ProductConnection>;
  /**
   * Get a product using the product's code
   *
   *
   * **Returns:**
   * information about the product requested
   */
  productByCode?: Maybe<Product>;
  /**
   * Get a product using ID
   *
   *
   * **Returns:**
   * information about the product requested
   */
  productById?: Maybe<Product>;
  purchaseOrder?: Maybe<PurchaseOrderQueryType>;
  resources?: Maybe<ResourcesQuery>;
  routs?: Maybe<Array<Maybe<Route>>>;
  serverTime?: Maybe<Scalars['DateTime']>;
  services?: Maybe<Array<Maybe<Service>>>;
  stock?: Maybe<StockQueryType>;
  stockOwnerByCode?: Maybe<StockOwner>;
  stockOwnerById?: Maybe<StockOwner>;
  stockOwners?: Maybe<StockOwnersConnection>;
  storageTypeByCode?: Maybe<StorageType>;
  storageTypeById?: Maybe<StorageType>;
  storageTypes?: Maybe<StorageTypesConnection>;
  supplierByCode?: Maybe<Supplier>;
  supplierById?: Maybe<Supplier>;
  suppliers?: Maybe<SuppliersConnection>;
  userById?: Maybe<WmsUserResult>;
  userByUsername?: Maybe<WmsUserResult>;
  userPermission?: Maybe<UserPermission>;
  userPermissions?: Maybe<UserPermissionsConnection>;
  users?: Maybe<UsersConnection>;
  warehouseByCode?: Maybe<Warehouse>;
  warehouseById?: Maybe<Warehouse>;
  warehouseZone?: Maybe<WarehouseZone>;
  warehouseZones?: Maybe<WarehouseZonesConnection>;
  warehouses?: Maybe<WarehousesConnection>;
  zoneTypes?: Maybe<Array<Maybe<ZoneType>>>;
  zones?: Maybe<Array<Maybe<Zone>>>;
};


export type QueryAuditCodesArgs = {
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  where?: Maybe<AuditCodeFilterInput>;
  order?: Maybe<Array<AuditCodeSortInput>>;
};


export type QueryAuditsArgs = {
  userContext?: Maybe<UserContextInput>;
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  where?: Maybe<AuditEntryFilterInput>;
  order?: Maybe<Array<AuditEntrySortInput>>;
};


export type QueryAvailablePermissionsArgs = {
  userContext?: Maybe<UserContextInput>;
};


export type QueryBudgetHolderByCodeArgs = {
  userContext?: Maybe<UserContextInput>;
  code?: Maybe<Scalars['String']>;
};


export type QueryBudgetHolderByIdArgs = {
  userContext?: Maybe<UserContextInput>;
  id: Scalars['Int'];
};


export type QueryBudgetHoldersArgs = {
  userContext?: Maybe<UserContextInput>;
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  where?: Maybe<BudgetHolderFilterInput>;
  order?: Maybe<Array<BudgetHolderSortInput>>;
};


export type QueryCarrierByCodeArgs = {
  userContext?: Maybe<UserContextInput>;
  code?: Maybe<Scalars['String']>;
};


export type QueryCarrierByIdArgs = {
  userContext?: Maybe<UserContextInput>;
  id: Scalars['Int'];
};


export type QueryCarrierModulesArgs = {
  userContext?: Maybe<UserContextInput>;
};


export type QueryCarriersArgs = {
  userContext?: Maybe<UserContextInput>;
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  where?: Maybe<CarrierFilterInput>;
  order?: Maybe<Array<CarrierSortInput>>;
};


export type QueryCodeArgs = {
  userContext?: Maybe<UserContextInput>;
  id: Scalars['Int'];
};


export type QueryCodeDefinitionsArgs = {
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  where?: Maybe<CodeDefinitionFilterInput>;
  order?: Maybe<Array<CodeDefinitionSortInput>>;
};


export type QueryCodesArgs = {
  userContext?: Maybe<UserContextInput>;
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  where?: Maybe<UdCodeFilterInput>;
  order?: Maybe<Array<UdCodeSortInput>>;
};


export type QueryCodesForTypeArgs = {
  userContext?: Maybe<UserContextInput>;
  codeType?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  where?: Maybe<UdCodeFilterInput>;
  order?: Maybe<Array<UdCodeSortInput>>;
};


export type QueryConfigurationForModuleArgs = {
  userContext?: Maybe<UserContextInput>;
  module?: Maybe<Scalars['String']>;
};


export type QueryCountriesArgs = {
  userContext?: Maybe<UserContextInput>;
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  where?: Maybe<CountryFilterInput>;
  order?: Maybe<Array<CountrySortInput>>;
};


export type QueryCountryByCodeArgs = {
  userContext?: Maybe<UserContextInput>;
  code?: Maybe<Scalars['String']>;
};


export type QueryCurrenciesArgs = {
  userContext?: Maybe<UserContextInput>;
};


export type QueryCurrentRateForCurrencyArgs = {
  userContext?: Maybe<UserContextInput>;
  code: Currency;
  target: Currency;
};


export type QueryDefaultForTableArgs = {
  tableName?: Maybe<Scalars['String']>;
};


export type QueryDestinationByCodeArgs = {
  userContext?: Maybe<UserContextInput>;
  code?: Maybe<Scalars['String']>;
};


export type QueryDestinationByIdArgs = {
  userContext?: Maybe<UserContextInput>;
  id: Scalars['Int'];
};


export type QueryDestinationsArgs = {
  userContext?: Maybe<UserContextInput>;
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  where?: Maybe<DestinationFilterInput>;
  order?: Maybe<Array<DestinationSortInput>>;
};


export type QueryExchangeRateByIdArgs = {
  userContext?: Maybe<UserContextInput>;
  id: Scalars['Int'];
};


export type QueryExchangeRatesArgs = {
  userContext?: Maybe<UserContextInput>;
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  where?: Maybe<ExchangeRateFilter>;
  order_by?: Maybe<ExchangeRateSort>;
};


export type QueryExchangeRatesForCurrencyArgs = {
  userContext?: Maybe<UserContextInput>;
  code: Currency;
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  where?: Maybe<ExchangeRateFilter>;
  order_by?: Maybe<ExchangeRateSort>;
};


export type QueryHandlingTypeByCodeArgs = {
  userContext?: Maybe<UserContextInput>;
  code?: Maybe<Scalars['String']>;
};


export type QueryHandlingTypeByIdArgs = {
  userContext?: Maybe<UserContextInput>;
  id: Scalars['Int'];
};


export type QueryHandlingTypesArgs = {
  userContext?: Maybe<UserContextInput>;
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  where?: Maybe<HandlingTypeFilterInput>;
  order?: Maybe<Array<HandlingTypeSortInput>>;
};


export type QueryLocationByCodeArgs = {
  userContext?: Maybe<UserContextInput>;
  code?: Maybe<Scalars['String']>;
};


export type QueryLocationByIdArgs = {
  userContext?: Maybe<UserContextInput>;
  id: Scalars['Int'];
};


export type QueryLocationsArgs = {
  userContext?: Maybe<UserContextInput>;
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  where?: Maybe<LocationFilterInput>;
  order?: Maybe<Array<LocationSortInput>>;
};


export type QueryMaterialHandlingEquipmentArgs = {
  userContext?: Maybe<UserContextInput>;
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  where?: Maybe<MaterialHandlingEquipmentFilterInput>;
  order?: Maybe<Array<MaterialHandlingEquipmentSortInput>>;
};


export type QueryMaterialHandlingEquipmentByCodeArgs = {
  userContext?: Maybe<UserContextInput>;
  code?: Maybe<Scalars['String']>;
};


export type QueryMaterialHandlingEquipmentByIdArgs = {
  userContext?: Maybe<UserContextInput>;
  id: Scalars['Int'];
};


export type QueryOrderEntriesArgs = {
  where?: Maybe<OrderFilter>;
};


export type QueryOrderEntryArgs = {
  code: Scalars['String'];
};


export type QueryPresetArgs = {
  id: Scalars['Int'];
};


export type QueryPresetsForTableArgs = {
  tableName?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  where?: Maybe<TablePresetFilterInput>;
  order?: Maybe<Array<TablePresetSortInput>>;
};


export type QueryProductArgs = {
  context?: Maybe<UserContextInput>;
  includeLinked: Scalars['Boolean'];
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  where?: Maybe<ProductFilterInput>;
  order?: Maybe<Array<ProductSortInput>>;
};


export type QueryProductByCodeArgs = {
  context?: Maybe<UserContextInput>;
  code?: Maybe<Scalars['String']>;
};


export type QueryProductByIdArgs = {
  context?: Maybe<UserContextInput>;
  id: Scalars['Int'];
};


export type QueryStockOwnerByCodeArgs = {
  userContext?: Maybe<UserContextInput>;
  code?: Maybe<Scalars['String']>;
};


export type QueryStockOwnerByIdArgs = {
  userContext?: Maybe<UserContextInput>;
  id: Scalars['Int'];
};


export type QueryStockOwnersArgs = {
  userContext?: Maybe<UserContextInput>;
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  where?: Maybe<StockOwnerFilterInput>;
  order?: Maybe<Array<StockOwnerSortInput>>;
};


export type QueryStorageTypeByCodeArgs = {
  userContext?: Maybe<UserContextInput>;
  code?: Maybe<Scalars['String']>;
};


export type QueryStorageTypeByIdArgs = {
  userContext?: Maybe<UserContextInput>;
  id: Scalars['Int'];
};


export type QueryStorageTypesArgs = {
  userContext?: Maybe<UserContextInput>;
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  where?: Maybe<StorageTypeFilterInput>;
  order?: Maybe<Array<StorageTypeSortInput>>;
};


export type QuerySupplierByCodeArgs = {
  userContext?: Maybe<UserContextInput>;
  code?: Maybe<Scalars['String']>;
};


export type QuerySupplierByIdArgs = {
  userContext?: Maybe<UserContextInput>;
  id: Scalars['Int'];
};


export type QuerySuppliersArgs = {
  userContext?: Maybe<UserContextInput>;
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  where?: Maybe<SupplierFilterInput>;
  order?: Maybe<Array<SupplierSortInput>>;
};


export type QueryUserByIdArgs = {
  id?: Maybe<Scalars['String']>;
};


export type QueryUserByUsernameArgs = {
  username?: Maybe<Scalars['String']>;
};


export type QueryUserPermissionArgs = {
  userContext?: Maybe<UserContextInput>;
  id: Scalars['Int'];
};


export type QueryUserPermissionsArgs = {
  userContext?: Maybe<UserContextInput>;
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  where?: Maybe<UserPermissionFilterInput>;
  order?: Maybe<Array<UserPermissionSortInput>>;
};


export type QueryUsersArgs = {
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  where?: Maybe<WmsUserFilterInput>;
  order?: Maybe<Array<WmsUserSortInput>>;
};


export type QueryWarehouseByCodeArgs = {
  userContext?: Maybe<UserContextInput>;
  code?: Maybe<Scalars['String']>;
};


export type QueryWarehouseByIdArgs = {
  userContext?: Maybe<UserContextInput>;
  id: Scalars['Int'];
};


export type QueryWarehouseZoneArgs = {
  userContext?: Maybe<UserContextInput>;
  id: Scalars['Int'];
};


export type QueryWarehouseZonesArgs = {
  userContext?: Maybe<UserContextInput>;
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  where?: Maybe<WarehouseZoneFilterInput>;
  order?: Maybe<Array<WarehouseZoneSortInput>>;
};


export type QueryWarehousesArgs = {
  userContext?: Maybe<UserContextInput>;
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  where?: Maybe<WarehouseFilterInput>;
  order?: Maybe<Array<WarehouseSortInput>>;
};


export type QueryZonesArgs = {
  where?: Maybe<ZoneFilter>;
};

export type Mutation = {
  __typename?: 'Mutation';
  NOP?: Maybe<Scalars['String']>;
  addCarrierConfig?: Maybe<CarrierConfig>;
  /**
   * Adds an existing Storage Type to a Handling Type.
   *
   *
   * **Returns:**
   * The new mapping between HandlingType and StorageType. Note: only StorageTypeId and HandlingTypeId properties are populated.
   */
  addHandlingStorageType?: Maybe<HandlingStorageType>;
  addStockOwnerLink?: Maybe<StockOwnerLink>;
  addStorageTypeMHE?: Maybe<StorageTypeMhe>;
  addUser?: Maybe<WmsUserResult>;
  changePassword?: Maybe<WmsUserResult>;
  createBOMDefinition?: Maybe<BomDefinition>;
  createBudgetHolder?: Maybe<BudgetHolder>;
  createCarrier?: Maybe<Carrier>;
  createCarrierAccount?: Maybe<CarrierAccount>;
  createCarrierService?: Maybe<CarrierService>;
  createDestination?: Maybe<Destination>;
  createDestinationBudget?: Maybe<DestinationBudget>;
  createDestinationRoute?: Maybe<DestinationRoute>;
  createExchangeRate?: Maybe<ExchangeRate>;
  /**
   * Creates a new Handling Type
   *
   *
   * **Returns:**
   * The newly created HandlingType. Note linked data will not be populated.
   */
  createHandlingType?: Maybe<HandlingType>;
  createLocation?: Maybe<LocationResult>;
  createMaterialHandlingEquipment?: Maybe<MaterialHandlingEquipment>;
  createOrderEntry?: Maybe<OrderEntry>;
  createOrderStatus?: Maybe<OrderStatus>;
  createPreset?: Maybe<TablePresetResult>;
  /** Create a new product */
  createProduct?: Maybe<Product>;
  createProductBarcode?: Maybe<ProductBarcode>;
  createProductCategory?: Maybe<ProductCategory>;
  createProductDocument?: Maybe<ProductDocument>;
  createProductLicencePlate?: Maybe<LpDefinition>;
  createProductPickface?: Maybe<ProductPickface>;
  createProductStatus?: Maybe<ProductStatus>;
  createProductSupplier?: Maybe<ProductSupplier>;
  createStockOwner?: Maybe<StockOwner>;
  createStockOwnerCategoryDefinition?: Maybe<CategoryDefinition>;
  createStockOwnerPickConfirmMethod?: Maybe<PickConfirmMethod>;
  createStockOwnerPickMethod?: Maybe<PickMethod>;
  createStorageType?: Maybe<StorageType>;
  createSupplier?: Maybe<Supplier>;
  createUDC?: Maybe<UdCode>;
  createUserPermission?: Maybe<UserPermission>;
  createWarehouse?: Maybe<Warehouse>;
  createWarehouseZone?: Maybe<WarehouseZone>;
  createZone?: Maybe<Zone>;
  deleteBOMDefinition?: Maybe<BomDefinition>;
  deleteBudgetHolder?: Maybe<BudgetHolder>;
  deleteCarrier?: Maybe<Carrier>;
  deleteCarrierAccount?: Maybe<CarrierAccount>;
  deleteCarrierService?: Maybe<CarrierService>;
  deleteDestination?: Maybe<Destination>;
  deleteDestinationBudget?: Maybe<DestinationBudget>;
  deleteDestinationRoute?: Maybe<DestinationRoute>;
  deleteExchangeRate?: Maybe<ExchangeRate>;
  /**
   * Delete an existing Handling Type
   *
   *
   * **Returns:**
   * The HandlingType that was deleted.
   */
  deleteHandlingType?: Maybe<HandlingType>;
  deleteLocation?: Maybe<LocationResult>;
  deleteMaterialHandlingEquipment?: Maybe<MaterialHandlingEquipment>;
  deleteOrderEntry?: Maybe<OrderEntry>;
  deleteOrderStatus?: Maybe<OrderStatus>;
  deletePreset?: Maybe<TablePresetResult>;
  /** Delete a product */
  deleteProduct?: Maybe<Product>;
  deleteProductBarcode?: Maybe<ProductBarcode>;
  deleteProductCategory?: Maybe<ProductCategory>;
  deleteProductDocument?: Maybe<ProductDocument>;
  deleteProductLicencePlate?: Maybe<LpDefinition>;
  deleteProductPickface?: Maybe<ProductPickface>;
  deleteProductStatus?: Maybe<ProductStatus>;
  deleteProductSupplier?: Maybe<ProductSupplier>;
  deleteStockOwner?: Maybe<StockOwner>;
  deleteStockOwnerCategoryDefinition?: Maybe<CategoryDefinition>;
  deleteStockOwnerPickConfirmMethod?: Maybe<PickConfirmMethod>;
  deleteStockOwnerPickMethod?: Maybe<PickMethod>;
  deleteStorageType?: Maybe<StorageType>;
  deleteSupplier?: Maybe<Supplier>;
  deleteUDC?: Maybe<UdCode>;
  deleteUser?: Maybe<WmsUserResult>;
  deleteUserPermission?: Maybe<UserPermission>;
  deleteWarehouse?: Maybe<Warehouse>;
  deleteWarehouseZone?: Maybe<WarehouseZone>;
  deleteZone?: Maybe<Zone>;
  goodsReceipt?: Maybe<GoodsReceiptMutationType>;
  purchaseOrder?: Maybe<PurchaseOrderMutationType>;
  removeCarrierConfig?: Maybe<CarrierConfig>;
  /**
   * Removes a StorageType from a HandlingType. This does not delete the StorageType.
   *
   *
   * **Returns:**
   * The deleted mapping between HandlingType and StorageType.
   */
  removeHandlingStorageType?: Maybe<HandlingStorageType>;
  removeStockOwnerLink?: Maybe<StockOwnerLink>;
  removeStorageTypeMHE?: Maybe<StorageTypeMhe>;
  resources?: Maybe<ResourcesMutation>;
  setPasswordForUser?: Maybe<WmsUserResult>;
  updateBOMDefinition?: Maybe<BomDefinition>;
  updateBudgetHolder?: Maybe<BudgetHolder>;
  updateCarrier?: Maybe<Carrier>;
  updateCarrierAccount?: Maybe<CarrierAccount>;
  updateCarrierConfig?: Maybe<CarrierConfig>;
  updateCarrierService?: Maybe<CarrierService>;
  updateDestination?: Maybe<Destination>;
  updateDestinationBudget?: Maybe<DestinationBudget>;
  updateDestinationRoute?: Maybe<DestinationRoute>;
  updateExchangeRate?: Maybe<ExchangeRate>;
  /**
   * Update an existing Handling Type.
   * Note this method cannot update the StorageTypes member. Use Int32) and Int32).
   *
   *
   * **Returns:**
   * The updated HandlingType. Note linked properties may not populated.
   */
  updateHandlingType?: Maybe<HandlingType>;
  updateLocation?: Maybe<LocationResult>;
  updateLocationEx?: Maybe<LocationResult>;
  updateMaterialHandlingEquipment?: Maybe<MaterialHandlingEquipment>;
  updateOrderEntry?: Maybe<OrderEntry>;
  updateOrderStatus?: Maybe<OrderStatus>;
  updatePreset?: Maybe<TablePresetResult>;
  /** update a product */
  updateProduct?: Maybe<Product>;
  updateProductBarcode?: Maybe<ProductBarcode>;
  updateProductCategory?: Maybe<ProductCategory>;
  updateProductDocument?: Maybe<ProductDocument>;
  updateProductLicencePlate?: Maybe<LpDefinition>;
  updateProductPickface?: Maybe<ProductPickface>;
  updateProductStatus?: Maybe<ProductStatus>;
  updateProductSupplier?: Maybe<ProductSupplier>;
  updateStockOwner?: Maybe<StockOwner>;
  updateStockOwnerCategoryDefinition?: Maybe<CategoryDefinition>;
  updateStockOwnerEx?: Maybe<StockOwnerResult>;
  updateStockOwnerPickConfirmMethod?: Maybe<PickConfirmMethod>;
  updateStockOwnerPickMethod?: Maybe<PickMethod>;
  updateStorageType?: Maybe<StorageType>;
  updateSupplier?: Maybe<Supplier>;
  updateUDC?: Maybe<UdCode>;
  updateUser?: Maybe<WmsUserResult>;
  updateUserPermission?: Maybe<UserPermission>;
  updateWarehouse?: Maybe<Warehouse>;
  updateWarehouseZone?: Maybe<WarehouseZone>;
  updateZone?: Maybe<Zone>;
  uploadFile?: Maybe<UploadFileInfo>;
};


export type MutationAddCarrierConfigArgs = {
  userContext?: Maybe<UserContextInput>;
  carrierId: Scalars['Int'];
  accountId: Scalars['Int'];
  config?: Maybe<CarrierConfigInput>;
};


export type MutationAddHandlingStorageTypeArgs = {
  userContext?: Maybe<UserContextInput>;
  id: Scalars['Int'];
  storageTypeId: Scalars['Int'];
};


export type MutationAddStockOwnerLinkArgs = {
  userContext?: Maybe<UserContextInput>;
  stockOwnerId: Scalars['Int'];
  linkedStockOwnerId: Scalars['Int'];
};


export type MutationAddStorageTypeMheArgs = {
  userContext?: Maybe<UserContextInput>;
  id: Scalars['Int'];
  MHEId: Scalars['Int'];
};


export type MutationAddUserArgs = {
  input?: Maybe<UserInput>;
};


export type MutationChangePasswordArgs = {
  oldPassword?: Maybe<Scalars['String']>;
  newPassword?: Maybe<Scalars['String']>;
};


export type MutationCreateBomDefinitionArgs = {
  userContext?: Maybe<UserContextInput>;
  productId: Scalars['Int'];
  component?: Maybe<BomDefinitionInput>;
};


export type MutationCreateBudgetHolderArgs = {
  userContext?: Maybe<UserContextInput>;
  input?: Maybe<BudgetHolderInput>;
};


export type MutationCreateCarrierArgs = {
  userContext?: Maybe<UserContextInput>;
  input?: Maybe<CarrierInput>;
};


export type MutationCreateCarrierAccountArgs = {
  userContext?: Maybe<UserContextInput>;
  carrierId: Scalars['Int'];
  input?: Maybe<CarrierAccountInput>;
};


export type MutationCreateCarrierServiceArgs = {
  userContext?: Maybe<UserContextInput>;
  carrierId: Scalars['Int'];
  input?: Maybe<CarrierServiceInput>;
};


export type MutationCreateDestinationArgs = {
  userContext?: Maybe<UserContextInput>;
  input?: Maybe<DestinationInput>;
};


export type MutationCreateDestinationBudgetArgs = {
  userContext?: Maybe<UserContextInput>;
  destinationId: Scalars['Int'];
  input?: Maybe<DestinationBudgetInput>;
};


export type MutationCreateDestinationRouteArgs = {
  userContext?: Maybe<UserContextInput>;
  destinationId: Scalars['Int'];
  input?: Maybe<DestinationRouteInput>;
};


export type MutationCreateExchangeRateArgs = {
  userContext?: Maybe<UserContextInput>;
  input?: Maybe<ExchangeRateInput>;
};


export type MutationCreateHandlingTypeArgs = {
  userContext?: Maybe<UserContextInput>;
  input?: Maybe<HandlingTypeInput>;
};


export type MutationCreateLocationArgs = {
  userContext?: Maybe<UserContextInput>;
  input?: Maybe<LocationInput>;
};


export type MutationCreateMaterialHandlingEquipmentArgs = {
  userContext?: Maybe<UserContextInput>;
  input?: Maybe<MaterialHandlingEquipmentInput>;
};


export type MutationCreateOrderEntryArgs = {
  input: CreateOrderEntryInput;
};


export type MutationCreateOrderStatusArgs = {
  userContext?: Maybe<UserContextInput>;
  stockOwnerId: Scalars['Int'];
  input?: Maybe<OrderStatusInput>;
};


export type MutationCreatePresetArgs = {
  tableName?: Maybe<Scalars['String']>;
  preset?: Maybe<TablePresetInput>;
};


export type MutationCreateProductArgs = {
  userContext?: Maybe<UserContextInput>;
  input?: Maybe<ProductInput>;
};


export type MutationCreateProductBarcodeArgs = {
  userContext?: Maybe<UserContextInput>;
  productId: Scalars['Int'];
  productBarcode?: Maybe<ProductBarcodeInput>;
};


export type MutationCreateProductCategoryArgs = {
  userContext?: Maybe<UserContextInput>;
  productId: Scalars['Int'];
  category?: Maybe<ProductCategoryInput>;
};


export type MutationCreateProductDocumentArgs = {
  userContext?: Maybe<UserContextInput>;
  productId: Scalars['Int'];
  productDocument?: Maybe<ProductDocumentInput>;
};


export type MutationCreateProductLicencePlateArgs = {
  userContext?: Maybe<UserContextInput>;
  productId: Scalars['Int'];
  licencePlate?: Maybe<LpDefinitionInput>;
};


export type MutationCreateProductPickfaceArgs = {
  userContext?: Maybe<UserContextInput>;
  productId: Scalars['Int'];
  pickface?: Maybe<ProductPickfaceInput>;
};


export type MutationCreateProductStatusArgs = {
  userContext?: Maybe<UserContextInput>;
  stockOwnerId: Scalars['Int'];
  input?: Maybe<ProductStatusInput>;
};


export type MutationCreateProductSupplierArgs = {
  userContext?: Maybe<UserContextInput>;
  productId: Scalars['Int'];
  productSupplier?: Maybe<ProductSupplierInput>;
};


export type MutationCreateStockOwnerArgs = {
  userContext?: Maybe<UserContextInput>;
  input?: Maybe<StockOwnerInput>;
};


export type MutationCreateStockOwnerCategoryDefinitionArgs = {
  userContext?: Maybe<UserContextInput>;
  stockOwnerId: Scalars['Int'];
  input?: Maybe<CategoryDefinitionInput>;
};


export type MutationCreateStockOwnerPickConfirmMethodArgs = {
  userContext?: Maybe<UserContextInput>;
  stockOwnerId: Scalars['Int'];
  input?: Maybe<PickConfirmMethodInput>;
};


export type MutationCreateStockOwnerPickMethodArgs = {
  userContext?: Maybe<UserContextInput>;
  stockOwnerId: Scalars['Int'];
  input?: Maybe<PickMethodInput>;
};


export type MutationCreateStorageTypeArgs = {
  userContext?: Maybe<UserContextInput>;
  input?: Maybe<StorageTypeInput>;
};


export type MutationCreateSupplierArgs = {
  userContext?: Maybe<UserContextInput>;
  input?: Maybe<SupplierInput>;
};


export type MutationCreateUdcArgs = {
  userContext?: Maybe<UserContextInput>;
  input?: Maybe<UdCodeInput>;
};


export type MutationCreateUserPermissionArgs = {
  userContext?: Maybe<UserContextInput>;
  input?: Maybe<UserPermissionInput>;
};


export type MutationCreateWarehouseArgs = {
  userContext?: Maybe<UserContextInput>;
  input?: Maybe<WarehouseInput>;
};


export type MutationCreateWarehouseZoneArgs = {
  userContext?: Maybe<UserContextInput>;
  input?: Maybe<WarehouseZoneInput>;
};


export type MutationCreateZoneArgs = {
  input: ZoneInput;
};


export type MutationDeleteBomDefinitionArgs = {
  userContext?: Maybe<UserContextInput>;
  productId: Scalars['Int'];
  componentId: Scalars['Int'];
};


export type MutationDeleteBudgetHolderArgs = {
  userContext?: Maybe<UserContextInput>;
  id: Scalars['Int'];
};


export type MutationDeleteCarrierArgs = {
  userContext?: Maybe<UserContextInput>;
  id: Scalars['Int'];
};


export type MutationDeleteCarrierAccountArgs = {
  userContext?: Maybe<UserContextInput>;
  carrierId: Scalars['Int'];
  id: Scalars['Int'];
};


export type MutationDeleteCarrierServiceArgs = {
  userContext?: Maybe<UserContextInput>;
  carrierId: Scalars['Int'];
  id: Scalars['Int'];
};


export type MutationDeleteDestinationArgs = {
  userContext?: Maybe<UserContextInput>;
  id: Scalars['Int'];
};


export type MutationDeleteDestinationBudgetArgs = {
  userContext?: Maybe<UserContextInput>;
  destinationId: Scalars['Int'];
  id: Scalars['Int'];
};


export type MutationDeleteDestinationRouteArgs = {
  userContext?: Maybe<UserContextInput>;
  destinationId: Scalars['Int'];
  id: Scalars['Int'];
};


export type MutationDeleteExchangeRateArgs = {
  userContext?: Maybe<UserContextInput>;
  id: Scalars['Int'];
};


export type MutationDeleteHandlingTypeArgs = {
  userContext?: Maybe<UserContextInput>;
  id: Scalars['Int'];
};


export type MutationDeleteLocationArgs = {
  userContext?: Maybe<UserContextInput>;
  id: Scalars['Int'];
};


export type MutationDeleteMaterialHandlingEquipmentArgs = {
  userContext?: Maybe<UserContextInput>;
  id: Scalars['Int'];
};


export type MutationDeleteOrderEntryArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteOrderStatusArgs = {
  userContext?: Maybe<UserContextInput>;
  stockOwnerId: Scalars['Int'];
  id: Scalars['Int'];
};


export type MutationDeletePresetArgs = {
  id: Scalars['Int'];
};


export type MutationDeleteProductArgs = {
  userContext?: Maybe<UserContextInput>;
  id: Scalars['Int'];
};


export type MutationDeleteProductBarcodeArgs = {
  userContext?: Maybe<UserContextInput>;
  productId: Scalars['Int'];
  id: Scalars['Int'];
};


export type MutationDeleteProductCategoryArgs = {
  userContext?: Maybe<UserContextInput>;
  productId: Scalars['Int'];
  id: Scalars['Int'];
};


export type MutationDeleteProductDocumentArgs = {
  userContext?: Maybe<UserContextInput>;
  productId: Scalars['Int'];
  id: Scalars['Int'];
};


export type MutationDeleteProductLicencePlateArgs = {
  userContext?: Maybe<UserContextInput>;
  productId: Scalars['Int'];
  id: Scalars['Int'];
};


export type MutationDeleteProductPickfaceArgs = {
  userContext?: Maybe<UserContextInput>;
  productId: Scalars['Int'];
  id: Scalars['Int'];
};


export type MutationDeleteProductStatusArgs = {
  userContext?: Maybe<UserContextInput>;
  stockOwnerId: Scalars['Int'];
  id: Scalars['Int'];
};


export type MutationDeleteProductSupplierArgs = {
  userContext?: Maybe<UserContextInput>;
  productId: Scalars['Int'];
  id: Scalars['Int'];
};


export type MutationDeleteStockOwnerArgs = {
  userContext?: Maybe<UserContextInput>;
  id: Scalars['Int'];
};


export type MutationDeleteStockOwnerCategoryDefinitionArgs = {
  userContext?: Maybe<UserContextInput>;
  stockOwnerId: Scalars['Int'];
  id: Scalars['Int'];
};


export type MutationDeleteStockOwnerPickConfirmMethodArgs = {
  userContext?: Maybe<UserContextInput>;
  stockOwnerId: Scalars['Int'];
  id: Scalars['Int'];
};


export type MutationDeleteStockOwnerPickMethodArgs = {
  userContext?: Maybe<UserContextInput>;
  stockOwnerId: Scalars['Int'];
  id: Scalars['Int'];
};


export type MutationDeleteStorageTypeArgs = {
  userContext?: Maybe<UserContextInput>;
  id: Scalars['Int'];
};


export type MutationDeleteSupplierArgs = {
  userContext?: Maybe<UserContextInput>;
  id: Scalars['Int'];
};


export type MutationDeleteUdcArgs = {
  userContext?: Maybe<UserContextInput>;
  id: Scalars['Int'];
};


export type MutationDeleteUserArgs = {
  id?: Maybe<Scalars['String']>;
};


export type MutationDeleteUserPermissionArgs = {
  userContext?: Maybe<UserContextInput>;
  id: Scalars['Int'];
};


export type MutationDeleteWarehouseArgs = {
  userContext?: Maybe<UserContextInput>;
  id: Scalars['Int'];
};


export type MutationDeleteWarehouseZoneArgs = {
  userContext?: Maybe<UserContextInput>;
  id: Scalars['Int'];
};


export type MutationDeleteZoneArgs = {
  id: Scalars['ID'];
};


export type MutationRemoveCarrierConfigArgs = {
  userContext?: Maybe<UserContextInput>;
  carrierId: Scalars['Int'];
  accountId: Scalars['Int'];
  id: Scalars['Int'];
};


export type MutationRemoveHandlingStorageTypeArgs = {
  userContext?: Maybe<UserContextInput>;
  id: Scalars['Int'];
  storageTypeId: Scalars['Int'];
};


export type MutationRemoveStockOwnerLinkArgs = {
  userContext?: Maybe<UserContextInput>;
  stockOwnerId: Scalars['Int'];
  linkedStockOwnerId: Scalars['Int'];
};


export type MutationRemoveStorageTypeMheArgs = {
  userContext?: Maybe<UserContextInput>;
  id: Scalars['Int'];
  MHEId: Scalars['Int'];
};


export type MutationSetPasswordForUserArgs = {
  id?: Maybe<Scalars['String']>;
  newPassword?: Maybe<Scalars['String']>;
};


export type MutationUpdateBomDefinitionArgs = {
  userContext?: Maybe<UserContextInput>;
  productId: Scalars['Int'];
  componentId: Scalars['Int'];
  input?: Maybe<BomDefinitionUpdateInput>;
};


export type MutationUpdateBudgetHolderArgs = {
  userContext?: Maybe<UserContextInput>;
  id: Scalars['Int'];
  input?: Maybe<BudgetHolderUpdateInput>;
};


export type MutationUpdateCarrierArgs = {
  userContext?: Maybe<UserContextInput>;
  id: Scalars['Int'];
  input?: Maybe<CarrierUpdateInput>;
};


export type MutationUpdateCarrierAccountArgs = {
  userContext?: Maybe<UserContextInput>;
  carrierId: Scalars['Int'];
  id: Scalars['Int'];
  input?: Maybe<CarrierAccountUpdateInput>;
};


export type MutationUpdateCarrierConfigArgs = {
  userContext?: Maybe<UserContextInput>;
  carrierId: Scalars['Int'];
  accountId: Scalars['Int'];
  id: Scalars['Int'];
  input?: Maybe<CarrierConfigUpdateInput>;
};


export type MutationUpdateCarrierServiceArgs = {
  userContext?: Maybe<UserContextInput>;
  carrierId: Scalars['Int'];
  id: Scalars['Int'];
  input?: Maybe<CarrierServiceUpdateInput>;
};


export type MutationUpdateDestinationArgs = {
  userContext?: Maybe<UserContextInput>;
  id: Scalars['Int'];
  input?: Maybe<DestinationUpdateInput>;
};


export type MutationUpdateDestinationBudgetArgs = {
  userContext?: Maybe<UserContextInput>;
  destinationId: Scalars['Int'];
  id: Scalars['Int'];
  input?: Maybe<DestinationBudgetUpdateInput>;
};


export type MutationUpdateDestinationRouteArgs = {
  userContext?: Maybe<UserContextInput>;
  destinationId: Scalars['Int'];
  id: Scalars['Int'];
  input?: Maybe<DestinationRouteUpdateInput>;
};


export type MutationUpdateExchangeRateArgs = {
  userContext?: Maybe<UserContextInput>;
  id: Scalars['Int'];
  input?: Maybe<ExchangeRateUpdateInput>;
};


export type MutationUpdateHandlingTypeArgs = {
  userContext?: Maybe<UserContextInput>;
  id: Scalars['Int'];
  input?: Maybe<HandlingTypeUpdateInput>;
};


export type MutationUpdateLocationArgs = {
  userContext?: Maybe<UserContextInput>;
  id: Scalars['Int'];
  input?: Maybe<LocationUpdateInput>;
};


export type MutationUpdateLocationExArgs = {
  userContext?: Maybe<UserContextInput>;
  id: Scalars['Int'];
  input?: Maybe<Array<Maybe<OperationOfLocationInput>>>;
};


export type MutationUpdateMaterialHandlingEquipmentArgs = {
  userContext?: Maybe<UserContextInput>;
  id: Scalars['Int'];
  input?: Maybe<MaterialHandlingEquipmentUpdateInput>;
};


export type MutationUpdateOrderEntryArgs = {
  id: Scalars['ID'];
  input: UpdateOrderEntryInput;
};


export type MutationUpdateOrderStatusArgs = {
  userContext?: Maybe<UserContextInput>;
  stockOwnerId: Scalars['Int'];
  id: Scalars['Int'];
  input?: Maybe<OrderStatusUpdateInput>;
};


export type MutationUpdatePresetArgs = {
  preset?: Maybe<TablePresetInput>;
};


export type MutationUpdateProductArgs = {
  userContext?: Maybe<UserContextInput>;
  id: Scalars['Int'];
  input?: Maybe<ProductUpdateInput>;
};


export type MutationUpdateProductBarcodeArgs = {
  userContext?: Maybe<UserContextInput>;
  productId: Scalars['Int'];
  id: Scalars['Int'];
  input?: Maybe<ProductBarcodeUpdateInput>;
};


export type MutationUpdateProductCategoryArgs = {
  userContext?: Maybe<UserContextInput>;
  productId: Scalars['Int'];
  id: Scalars['Int'];
  input?: Maybe<ProductCategoryUpdateInput>;
};


export type MutationUpdateProductDocumentArgs = {
  userContext?: Maybe<UserContextInput>;
  productId: Scalars['Int'];
  id: Scalars['Int'];
  input?: Maybe<ProductDocumentUpdateInput>;
};


export type MutationUpdateProductLicencePlateArgs = {
  userContext?: Maybe<UserContextInput>;
  productId: Scalars['Int'];
  id: Scalars['Int'];
  input?: Maybe<LpDefinitionUpdateInput>;
};


export type MutationUpdateProductPickfaceArgs = {
  userContext?: Maybe<UserContextInput>;
  productId: Scalars['Int'];
  id: Scalars['Int'];
  input?: Maybe<ProductPickfaceUpdateInput>;
};


export type MutationUpdateProductStatusArgs = {
  userContext?: Maybe<UserContextInput>;
  stockOwnerId: Scalars['Int'];
  id: Scalars['Int'];
  input?: Maybe<ProductStatusUpdateInput>;
};


export type MutationUpdateProductSupplierArgs = {
  userContext?: Maybe<UserContextInput>;
  productId: Scalars['Int'];
  id: Scalars['Int'];
  input?: Maybe<ProductSupplierUpdateInput>;
};


export type MutationUpdateStockOwnerArgs = {
  userContext?: Maybe<UserContextInput>;
  id: Scalars['Int'];
  input?: Maybe<StockOwnerUpdateInput>;
};


export type MutationUpdateStockOwnerCategoryDefinitionArgs = {
  userContext?: Maybe<UserContextInput>;
  stockOwnerId: Scalars['Int'];
  id: Scalars['Int'];
  input?: Maybe<CategoryDefinitionUpdateInput>;
};


export type MutationUpdateStockOwnerExArgs = {
  userContext?: Maybe<UserContextInput>;
  id: Scalars['Int'];
  input?: Maybe<Array<Maybe<OperationOfStockOwnerInput>>>;
};


export type MutationUpdateStockOwnerPickConfirmMethodArgs = {
  userContext?: Maybe<UserContextInput>;
  stockOwnerId: Scalars['Int'];
  id: Scalars['Int'];
  input?: Maybe<PickConfirmMethodUpdateInput>;
};


export type MutationUpdateStockOwnerPickMethodArgs = {
  userContext?: Maybe<UserContextInput>;
  stockOwnerId: Scalars['Int'];
  id: Scalars['Int'];
  input?: Maybe<PickMethodUpdateInput>;
};


export type MutationUpdateStorageTypeArgs = {
  userContext?: Maybe<UserContextInput>;
  id: Scalars['Int'];
  input?: Maybe<StorageTypeUpdateInput>;
};


export type MutationUpdateSupplierArgs = {
  userContext?: Maybe<UserContextInput>;
  id: Scalars['Int'];
  input?: Maybe<SupplierUpdateInput>;
};


export type MutationUpdateUdcArgs = {
  userContext?: Maybe<UserContextInput>;
  id: Scalars['Int'];
  input?: Maybe<UdCodeUpdateInput>;
};


export type MutationUpdateUserArgs = {
  id?: Maybe<Scalars['String']>;
  input?: Maybe<UserUpdateInput>;
};


export type MutationUpdateUserPermissionArgs = {
  userContext?: Maybe<UserContextInput>;
  id: Scalars['Int'];
  input?: Maybe<UserPermissionUpdateInput>;
};


export type MutationUpdateWarehouseArgs = {
  userContext?: Maybe<UserContextInput>;
  id: Scalars['Int'];
  input?: Maybe<WarehouseUpdateInput>;
};


export type MutationUpdateWarehouseZoneArgs = {
  userContext?: Maybe<UserContextInput>;
  id: Scalars['Int'];
  input?: Maybe<WarehouseZoneUpdateInput>;
};


export type MutationUpdateZoneArgs = {
  input: ZoneInput;
};


export type MutationUploadFileArgs = {
  file?: Maybe<Scalars['Upload']>;
};

export type PurchaseOrder = {
  __typename?: 'PurchaseOrder';
  stockOwner?: Maybe<StockOwner>;
  warehouse?: Maybe<Warehouse>;
  supplier?: Maybe<Supplier>;
  id?: Maybe<Scalars['Int']>;
  instructions?: Maybe<Array<Maybe<PoInstruction>>>;
  items?: Maybe<Array<Maybe<PurchaseOrderItem>>>;
  stockOwnerId?: Maybe<Scalars['Int']>;
  warehouseId?: Maybe<Scalars['Int']>;
  referenceNumber: Scalars['String'];
  custReferences?: Maybe<Array<Maybe<Scalars['String']>>>;
  status?: Maybe<PurchaseOrderState>;
  type?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['Int']>;
  supplierId?: Maybe<Scalars['Int']>;
  currency?: Maybe<Currency>;
  totalValue?: Maybe<Scalars['Decimal']>;
  enteredBy?: Maybe<Scalars['String']>;
  entered?: Maybe<Scalars['DateTime']>;
  after?: Maybe<Scalars['DateTime']>;
  before?: Maybe<Scalars['DateTime']>;
  budgetHolder?: Maybe<Scalars['String']>;
  containerNo?: Maybe<Scalars['String']>;
  billOfLading?: Maybe<Scalars['String']>;
  crossDock?: Maybe<Scalars['Boolean']>;
  message?: Maybe<Scalars['String']>;
  parent?: Maybe<Scalars['String']>;
  carrier?: Maybe<Scalars['String']>;
  carrierService?: Maybe<Scalars['String']>;
  exportBatch?: Maybe<Scalars['String']>;
};

export type PurchaseOrderItem = {
  __typename?: 'PurchaseOrderItem';
  attributes?: Maybe<StockAttributes>;
  id?: Maybe<Scalars['Int']>;
  lineNumber?: Maybe<Scalars['String']>;
  lineStatus?: Maybe<Scalars['String']>;
  attributeId?: Maybe<Scalars['Int']>;
  productStatus?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['Decimal']>;
  quantityOrdered?: Maybe<Scalars['Decimal']>;
  quantityBooked?: Maybe<Scalars['Decimal']>;
  quantityDelivered?: Maybe<Scalars['Decimal']>;
  quantityManifested?: Maybe<Scalars['Decimal']>;
  quantityShipped?: Maybe<Scalars['Decimal']>;
  LPN?: Maybe<Scalars['String']>;
};

export type UpdatePoResponse = {
  __typename?: 'UpdatePOResponse';
  headerUpdated?: Maybe<PurchaseOrderHeader>;
  purchaseOrderItemsModified?: Maybe<Array<Maybe<PurchaseOrderItem>>>;
  purchaseOrderItemsDeleted?: Maybe<Array<Maybe<PurchaseOrderItem>>>;
  pOInstructionsModified?: Maybe<Array<Maybe<PoInstruction>>>;
  pOInstructionsDeleted?: Maybe<Array<Maybe<PoInstruction>>>;
};

export type GoodsReceipt = {
  __typename?: 'GoodsReceipt';
  stockOwner?: Maybe<StockOwner>;
  warehouse?: Maybe<Warehouse>;
  booked?: Maybe<Array<Maybe<GoodsBookLine>>>;
  received?: Maybe<Array<Maybe<GoodsReceiptLine>>>;
  id?: Maybe<Scalars['Int']>;
  goodsReceiptNumber: Scalars['String'];
  warehouseId?: Maybe<Scalars['Int']>;
  stockOwnerId?: Maybe<Scalars['Int']>;
  status?: Maybe<GoodsReceiptState>;
  isUnbooked?: Maybe<Scalars['Boolean']>;
  dateCreated?: Maybe<Scalars['DateTime']>;
  dateReceived?: Maybe<Scalars['DateTime']>;
  customerRef?: Maybe<Scalars['String']>;
  invoiceRef?: Maybe<Scalars['String']>;
  createdBy?: Maybe<Scalars['String']>;
  extra?: Maybe<GoodsReceipt_ExtraData>;
};

export type GoodsBookLine = {
  __typename?: 'GoodsBookLine';
  attributes?: Maybe<StockAttributes>;
  supplier?: Maybe<Supplier>;
  quantityReceived?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  quantityExpected: Scalars['Decimal'];
  LPN?: Maybe<Scalars['String']>;
  unReceived?: Maybe<Scalars['Boolean']>;
  receipts?: Maybe<Array<Maybe<GoodsReceiptLine>>>;
  header?: Maybe<GoodsReceipt>;
  attributeId?: Maybe<Scalars['Int']>;
  supplierId?: Maybe<Scalars['Int']>;
  purchaseOrder?: Maybe<Scalars['String']>;
  purchaseOrderLine?: Maybe<Scalars['String']>;
  packType: Scalars['String'];
  productStatus: Scalars['String'];
  bookLine?: Maybe<GoodsBookLine>;
  parentBookLineId?: Maybe<Scalars['Int']>;
};

export type GoodsReceiptLine = {
  __typename?: 'GoodsReceiptLine';
  attributes?: Maybe<StockAttributes>;
  supplier?: Maybe<Supplier>;
  licencePlate?: Maybe<LicencePlate>;
  id?: Maybe<Scalars['Int']>;
  quantityReceived: Scalars['Decimal'];
  licencePlateId?: Maybe<Scalars['Int']>;
  adHoc?: Maybe<Scalars['Boolean']>;
  header?: Maybe<GoodsReceipt>;
  attributeId?: Maybe<Scalars['Int']>;
  supplierId?: Maybe<Scalars['Int']>;
  purchaseOrder?: Maybe<Scalars['String']>;
  purchaseOrderLine?: Maybe<Scalars['String']>;
  packType: Scalars['String'];
  productStatus: Scalars['String'];
  bookLine?: Maybe<GoodsBookLine>;
  parentBookLineId?: Maybe<Scalars['Int']>;
};

export type UpdatedLines = {
  __typename?: 'UpdatedLines';
  headerUpdated?: Maybe<GoodsReceiptHeader>;
  bookLinesAdded?: Maybe<Array<Maybe<GoodsBookLine>>>;
  bookLinesDeleted?: Maybe<Array<Maybe<GoodsBookLine>>>;
  receiptLinesAdded?: Maybe<Array<Maybe<GoodsReceiptLine>>>;
  receiptLinesDeleted?: Maybe<Array<Maybe<GoodsReceiptLine>>>;
};

export type StockAttributes = IwmsAttributes & {
  __typename?: 'StockAttributes';
  productId?: Maybe<Scalars['Int']>;
  product?: Maybe<Product>;
  id?: Maybe<Scalars['Int']>;
  batch?: Maybe<Scalars['String']>;
  sellByDate?: Maybe<Scalars['DateTime']>;
  GRN?: Maybe<Scalars['String']>;
  PONumber?: Maybe<Scalars['String']>;
  serialNumber?: Maybe<Scalars['String']>;
  budgetHolder?: Maybe<Scalars['String']>;
  catchWeight?: Maybe<Scalars['Decimal']>;
  bestBeforeDate?: Maybe<Scalars['DateTime']>;
  killDate?: Maybe<Scalars['DateTime']>;
  productionDate?: Maybe<Scalars['DateTime']>;
  slaughterCode?: Maybe<Scalars['String']>;
  batchInfo?: Maybe<Scalars['String']>;
};

export type Stock = {
  __typename?: 'Stock';
  stockOwner?: Maybe<StockOwner>;
  product?: Maybe<Product>;
  location?: Maybe<Location>;
  id?: Maybe<Scalars['Int']>;
  warehouseId?: Maybe<Scalars['Int']>;
  warehouse?: Maybe<Warehouse>;
  stockOwnerId?: Maybe<Scalars['Int']>;
  productId?: Maybe<Scalars['Int']>;
  attributeId?: Maybe<Scalars['Int']>;
  attributes?: Maybe<StockAttributes>;
  status?: Maybe<Scalars['String']>;
  packType?: Maybe<Scalars['String']>;
  packs: Scalars['Decimal'];
  singles: Scalars['Decimal'];
  allocated: Scalars['Decimal'];
  locationId?: Maybe<Scalars['Int']>;
  licencePlateId?: Maybe<Scalars['Int']>;
  licencePlate?: Maybe<LicencePlate>;
};

export type CultureInfo = {
  __typename?: 'CultureInfo';
  displayName: Scalars['String'];
  englishName: Scalars['String'];
  isNeutralCulture: Scalars['Boolean'];
  LCID: Scalars['Int'];
  name: Scalars['String'];
  nativeName: Scalars['String'];
  threeLetterISOLanguageName: Scalars['String'];
  threeLetterWindowsLanguageName: Scalars['String'];
  twoLetterISOLanguageName: Scalars['String'];
};

export type ResourceIdItem = {
  __typename?: 'ResourceIdItem';
  value?: Maybe<Scalars['String']>;
  resourceId?: Maybe<Scalars['String']>;
  hasValue: Scalars['Boolean'];
};

export type ResourceIdListItem = {
  __typename?: 'ResourceIdListItem';
  value?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  selected: Scalars['Boolean'];
  style?: Maybe<Scalars['String']>;
  resourceId?: Maybe<Scalars['String']>;
  hasValue: Scalars['Boolean'];
};

export type StockOwner = {
  __typename?: 'StockOwner';
  /**
   * List of order statuses for the stock owner
   *
   * Mutations:
   *
   * CreateOrderStatus
   * DeleteOrderStatus
   * UpdateOrderStatus
   */
  orderStatuses?: Maybe<Array<Maybe<OrderStatus>>>;
  /**
   * List of statuses available for the stock associated with the
   * stock owner
   * Mutations:
   *
   * createStockOwnerStatus
   * deleteStockOwnerStatus
   * updateStockOwnerStatus
   */
  productStatuses?: Maybe<Array<Maybe<ProductStatus>>>;
  /**
   * List of product categories available for the stock associated with the
   * stock owner
   * Mutations:
   *
   * createStockOwnerCategoryDefinition
   * updateStockOwnerCategoryDefinition
   * deleteStockOwnerCategoryDefinition
   */
  categories?: Maybe<Array<Maybe<CategoryDefinition>>>;
  /**
   * List of pick definitions for the stock owner
   * Mutations:
   *
   * createStockOwnerPickMethod
   * deleteStockOwnerPickMethod
   * updateStockOwnerPickMethod
   */
  pickMethods?: Maybe<Array<Maybe<PickMethod>>>;
  /**
   * List of confirm methods for stock owner
   * Mutations:
   *
   * createStockOwnerConfirmMethod
   * deleteStockOwnerConfirmMethod
   * updateStockOwnerConfirmMethod
   */
  confirmMethods?: Maybe<Array<Maybe<PickConfirmMethod>>>;
  id?: Maybe<Scalars['Int']>;
  /** The unique code for this stock owner */
  code: Scalars['String'];
  /** The name of the stock owner */
  name: Scalars['String'];
  /** The status of the StockOwner. See  for possible values. */
  status: State;
  linkedStockOwners?: Maybe<Array<Maybe<StockOwnerLink>>>;
  /** Contact for the stock owner */
  contact?: Maybe<Contact>;
  /** Address of the stock owner */
  address?: Maybe<Address>;
  /** Cold storage ID associated with the stock owner */
  coldStoreID?: Maybe<Scalars['String']>;
  /** GLN (Global Location Number) for the stock owner */
  GLN?: Maybe<Scalars['String']>;
  /** VAT Number for the stock Owner */
  VATNumber?: Maybe<Scalars['String']>;
  /**
   * Warn when moving stock to a location that contains
   * a different status
   */
  warnMoveDifStatus?: Maybe<Scalars['Boolean']>;
  /** Require budget holder */
  requireBudhol?: Maybe<Scalars['Boolean']>;
  /** Require Product categories */
  requireProdCategories?: Maybe<Scalars['Boolean']>;
  /** Mask for barcodes that are scanned */
  scanBarcodeMask?: Maybe<Scalars['String']>;
  /** Mask for barcodes that are keyed in */
  keyedBarcodeMask?: Maybe<Scalars['String']>;
  /** Capture serials on receipt */
  captureSerialsOnRcpt?: Maybe<Scalars['Boolean']>;
  /** Require pallet ID to be entered */
  requirePalletID?: Maybe<Scalars['Boolean']>;
  /** Print pallet labels On Receipt */
  printPalLblsOnRcpt?: Maybe<Scalars['Boolean']>;
  /** Capture PO number on receipt */
  capturePONumOnRcpt?: Maybe<Scalars['Boolean']>;
  /** Allocation locations to pallet received */
  allocateLocOnRcpt?: Maybe<Scalars['Boolean']>;
  /** Close PO when the Goods receipt has been completed */
  closeComPoOnRcpt?: Maybe<Scalars['Boolean']>;
  /** Validate Batch against PO */
  validateBatchPO?: Maybe<Scalars['Boolean']>;
  /** Capture packaging information on receipt */
  capturePkgInfoOnRcpt?: Maybe<Scalars['Boolean']>;
  /** Putaway LP on Receipt */
  putwayLPOnRcpt?: Maybe<Scalars['Boolean']>;
  /** Confirm putaways on Receipt */
  confirmPutawaysOnRcpt?: Maybe<Scalars['Boolean']>;
  /** Goods receipt can only be closed by authorized user */
  reqAuthOnGRClose?: Maybe<Scalars['Boolean']>;
  /** Unbooked receipts by default */
  defaultUnbookedRcpt?: Maybe<Scalars['Boolean']>;
  /** Use identical pallets on Receipt */
  identicalPallets?: Maybe<Scalars['Boolean']>;
  /** Strict PO date validation */
  strictPODateVal?: Maybe<Scalars['Boolean']>;
  /** Receipt Verification - Split on Supplier Tollerance */
  splitSuppTolerance?: Maybe<Scalars['Boolean']>;
  /** Receipt verification - Putaway to default location */
  RVPutToDefLoc?: Maybe<Scalars['Boolean']>;
  /** RF Putaway Immediately */
  RFPutImmediately?: Maybe<Scalars['Boolean']>;
  /** Disable Confirm Putaway for Specified Locations */
  disablePutForSpecificLocs?: Maybe<Scalars['Boolean']>;
  /** Extra info must be entered on receipt */
  mandExtraInfoOnRcpt?: Maybe<Scalars['Boolean']>;
  /** Capture container type on receipt */
  captureContainerType?: Maybe<Scalars['Boolean']>;
  /** Only show booked products in the product F2 */
  F2ShowBookedProdsOnly?: Maybe<Scalars['Boolean']>;
  /** Generate PO Number automatically */
  autoGeneratePONumber?: Maybe<Scalars['Boolean']>;
  /** Allow Editing in Receipt verification */
  allowEditInRV?: Maybe<Scalars['Boolean']>;
  /** Print Carton Labels with Pallet Labels */
  GRPrintCrtnLbls?: Maybe<Scalars['Boolean']>;
  /** No Backflush when receiving from production */
  noBckFlushGRProduction?: Maybe<Scalars['Boolean']>;
  /** Print labels when receiving from production */
  printLblsGRProduction?: Maybe<Scalars['Boolean']>;
  /** Receipt and Booking Number must match */
  matchGRWithBookNo?: Maybe<Scalars['Boolean']>;
  /** Receipt verification - Suppress merging of pick faces */
  RVSuppressMergePF?: Maybe<Scalars['Boolean']>;
  /** Split PO lines on Print */
  spltPOLinesOnPrint?: Maybe<Scalars['Boolean']>;
  /** Make GRN number the budgetholder for received stock */
  makeGRNBudhol?: Maybe<Scalars['Boolean']>;
  /** Allow Short Shelf Life */
  allowShortShelfLife?: Maybe<Scalars['Boolean']>;
  /** Add products to PO that were not expected */
  allowAddProdsToPO?: Maybe<Scalars['Boolean']>;
  /** Capture Location on receipt */
  captureLocOnRcpt?: Maybe<Scalars['Boolean']>;
  /** Capture temperature on receipt */
  captureTempOnRcpt?: Maybe<Scalars['Boolean']>;
  /** Generate order numbers automatically */
  autoGenOrderNum?: Maybe<Scalars['Boolean']>;
  /** Display Errors in Order Entry */
  dispOrderEntryErrs?: Maybe<Scalars['Boolean']>;
  /** Require Proof of Delivery */
  requirePOD?: Maybe<Scalars['Boolean']>;
  /** Print Order Confirmation Report */
  printOrdConfRpt?: Maybe<Scalars['Boolean']>;
  /** Create pick once an order has been saved in order entry */
  createPickOnOrdEntry?: Maybe<Scalars['Boolean']>;
  /** Do not clear line customer reference */
  dontClearLineCustRef?: Maybe<Scalars['Boolean']>;
  /** Mandatory Line customer reference */
  mandLineCustref?: Maybe<Scalars['Boolean']>;
  /** Warn if there is a shortage of a product on the order */
  warnOnShortage?: Maybe<Scalars['Boolean']>;
  /** Print order report with PickList */
  printOrdRptWithPick?: Maybe<Scalars['Boolean']>;
  /** Print box packing Labels */
  printBoxPackLbls?: Maybe<Scalars['Boolean']>;
  /** GDPR Controlled */
  GDPRControlled?: Maybe<Scalars['Boolean']>;
  /** Force budgetholder to be entered in order entry */
  forceBudholOnEntry?: Maybe<Scalars['Boolean']>;
  /** Prevent batch from being entered in order entry */
  preventBatchOnEntry?: Maybe<Scalars['Boolean']>;
  /** Allow products to be swapped using generics in order entry. */
  swapGenericsOnEntry?: Maybe<Scalars['Boolean']>;
  /** Force Department in order entry. */
  forceDepartmentOnEntry?: Maybe<Scalars['Boolean']>;
  /** Pick Orders without shortages only. */
  cleanOrdersOnly?: Maybe<Scalars['Boolean']>;
  /** Create back orders when creating picks that are short */
  createBackOrders?: Maybe<Scalars['Boolean']>;
  /** Allow Shortage swapping */
  allowShortageSwap?: Maybe<Scalars['Boolean']>;
  /** Allow budgetholder swapping */
  allowBudholSwap?: Maybe<Scalars['Boolean']>;
  /** Change trays based on Priority */
  chngeTraysOnPri?: Maybe<Scalars['Boolean']>;
  /** Only create picks with no replens. */
  noReplenPicksOnly?: Maybe<Scalars['Boolean']>;
  /** Allow status swapping */
  allowStatusSwap?: Maybe<Scalars['Boolean']>;
  /** Pick cartons */
  pickCartons?: Maybe<Scalars['Boolean']>;
  /** Manual Picking - Do not split lists */
  MPNoSplitLists?: Maybe<Scalars['Boolean']>;
  /** Show Unpickable report */
  showUnpickableRpt?: Maybe<Scalars['Boolean']>;
  /** Allow LP Swapping */
  allowLPSwap?: Maybe<Scalars['Boolean']>;
  /** Allow Sell by date swapping */
  allowSBDSwap?: Maybe<Scalars['Boolean']>;
  /** Find carton ID by Weight */
  findCartonByWgt?: Maybe<Scalars['Boolean']>;
  /** Capture Carrier */
  captureCarrier?: Maybe<Scalars['Boolean']>;
  /** Allow Location swapping */
  allowLocSwap?: Maybe<Scalars['Boolean']>;
  /** Use BOM Picking */
  useBOMPicking?: Maybe<Scalars['Boolean']>;
  /** Require Despatch note */
  requireDespNote?: Maybe<Scalars['Boolean']>;
  /** RF Pick Assignment enumeration */
  RFPickAssignment?: Maybe<PickAssignment>;
  voicePickAssignment?: Maybe<PickAssignment>;
  /** Allow Batch swapping */
  allowBatchSwap?: Maybe<Scalars['Boolean']>;
  /** Required to confirm product */
  requireConfProduct?: Maybe<Scalars['Boolean']>;
  /** Require UPI check */
  requireUPICheck?: Maybe<Scalars['Boolean']>;
  /** Perform pick cage validation */
  cageValidation?: Maybe<Scalars['Boolean']>;
  /** Validate despatch note */
  despNoteValidation?: Maybe<Scalars['Boolean']>;
  /** Suppress Replenishment option */
  suppressReplenOpt?: Maybe<Scalars['Boolean']>;
  /** Use Loading */
  useLoading?: Maybe<Scalars['Boolean']>;
  /** Produce RF Manifest */
  produceRFManifest?: Maybe<Scalars['Boolean']>;
  /** Requires seal number to be entered */
  requireSealNo?: Maybe<Scalars['Boolean']>;
  /** Require truck to be specified */
  requireTruck?: Maybe<Scalars['Boolean']>;
  /** Require driver to be specified */
  requireDriver?: Maybe<Scalars['Boolean']>;
  /** Use Load order */
  useLoadOrder?: Maybe<Scalars['Boolean']>;
  loadOrder?: Maybe<LoadOrder>;
  /** Despatch lane for loading */
  despLane?: Maybe<Scalars['String']>;
  /** Maximum number of Loaders */
  maxLoaders?: Maybe<Scalars['Int']>;
  adhocLoading?: Maybe<Accessiblity>;
  /** Capture temperature at the start of Load */
  loadTempCaptureStart?: Maybe<Scalars['Boolean']>;
  /** Capture temperature at the end of Load */
  loadTempCaptureEnd?: Maybe<Scalars['Boolean']>;
  /** Capture temperature at LP Intervals */
  loadTempLPInterval?: Maybe<Scalars['Boolean']>;
  /** Capture time on pick confirm */
  captureTimeOnConfirm?: Maybe<FieldVisibility>;
  /** Capture check on pick confirm */
  captureCheckerOnConfirm?: Maybe<FieldVisibility>;
  /** Capture picker on pick confirm */
  capturePickerOnConfirm?: Maybe<FieldVisibility>;
  /** Default pick fail code */
  defPickFailCode?: Maybe<Scalars['String']>;
  /** Require despatch lane */
  requireDespatchLane?: Maybe<Scalars['Boolean']>;
  /** Use destination info for despatch email notification */
  useEmailFromDestination?: Maybe<Scalars['Boolean']>;
  /** Allow despatch reprints for unconfirmed picklists */
  reprntUnfinishedLists?: Maybe<Scalars['Boolean']>;
  /** Destock when short */
  destockShortOnSHort?: Maybe<Scalars['Boolean']>;
  /** Proportional box records on pick confirm */
  proportionalBoxesOnConfirm?: Maybe<Scalars['Boolean']>;
  /** Allow Loading in any Sequence */
  allowLoadAnySeq?: Maybe<Scalars['Boolean']>;
  /** LP Control in Manual box packing */
  MBPLPControl?: Maybe<Scalars['Boolean']>;
  /** Use stock owner defined despatch method in Manual box packing */
  MBPUseSODespMeth?: Maybe<Scalars['Boolean']>;
  /** Do not create despatch notes */
  noDespNotes?: Maybe<Scalars['Boolean']>;
  /** Preview despatch notes */
  previewDespNote?: Maybe<Scalars['Boolean']>;
  /** Turn BOMS to stock */
  BOMSToStock?: Maybe<Scalars['Boolean']>;
  /** Delay despatch */
  delayDespatch?: Maybe<Scalars['Boolean']>;
  /** RF Warning in Pick confirm */
  RFWarnInPckConf?: Maybe<Scalars['Boolean']>;
  /** No replen before pick confirm */
  noReplenPckConf?: Maybe<Scalars['Boolean']>;
  /** Print despatch note per list */
  despNotePerList?: Maybe<Scalars['Boolean']>;
  /** Always print box Labels */
  printBoxLbls?: Maybe<Scalars['Boolean']>;
  /** Disable immediate despatch */
  disablImmDesp?: Maybe<Scalars['Boolean']>;
  /** Allow future despatch dates */
  allowFutureDespDates?: Maybe<Scalars['Boolean']>;
  /** Capture Consignment Number at MBP */
  MBPCaptureConsNo?: Maybe<Scalars['Boolean']>;
  /** Optional consignment number */
  optConsNo?: Maybe<Scalars['Boolean']>;
  /** Print box label at pick confirm */
  boxLblsPickConf?: Maybe<Scalars['Boolean']>;
  /** Use LP IDs at Pick confirm */
  useLPIdsPickConfirm?: Maybe<Scalars['Boolean']>;
  /** Authorised Manual box packing */
  authMBP?: Maybe<Scalars['Boolean']>;
  /** Mandatory Container type */
  mandContainerType?: Maybe<Scalars['Boolean']>;
  /** Create PDF despatch notes */
  PDFDespNotes?: Maybe<Scalars['Boolean']>;
  /** Use despatch prefix */
  useDespPrefix?: Maybe<Scalars['Boolean']>;
  /** Number of despatch notes */
  noOfDespNotes?: Maybe<Scalars['Boolean']>;
  /** Confirm whole pick */
  confWholePick?: Maybe<Scalars['Boolean']>;
  /** Capture reason for delayed despatch */
  capReasonDelayDesp?: Maybe<Scalars['Boolean']>;
  /** Manual box packing - despatch note breakdown */
  MBPDespNoteBreakdwn?: Maybe<Scalars['Boolean']>;
  /** Don't close order when errors occur during label generation */
  dontCloseOrderOnLblFail?: Maybe<Scalars['Boolean']>;
  /** Capture the number of boxes per order */
  capBoxesPerOrder?: Maybe<Scalars['Boolean']>;
  /** Do not require carrier to be entered */
  carrierNotReq?: Maybe<Scalars['Boolean']>;
  /** Do not generate carrier labels at pick confirm */
  noCarrLblsPckConf?: Maybe<Scalars['Boolean']>;
  /** Copy carrier from parent order to back orders */
  copyCarrToBckOrd?: Maybe<Scalars['Boolean']>;
};

export type BudgetHolder = {
  __typename?: 'BudgetHolder';
  stockOwner?: Maybe<StockOwner>;
  id?: Maybe<Scalars['Int']>;
  code: Scalars['String'];
  description: Scalars['String'];
  status: State;
  warehouse?: Maybe<Warehouse>;
};

export type Product = {
  __typename?: 'Product';
  stockOwner?: Maybe<StockOwner>;
  /** Manufacturer of the product */
  manufacturer?: Maybe<UdCode>;
  id?: Maybe<Scalars['Int']>;
  /** The unique code for the product definition */
  code: Scalars['String'];
  /** Alternative code for product */
  altCode?: Maybe<Scalars['String']>;
  /** GTIN (Global Trade Item Number) for product */
  gTIN?: Maybe<Scalars['String']>;
  /** Substitute product */
  substitute?: Maybe<Scalars['String']>;
  /** Description of the product */
  description: Scalars['String'];
  /** Long description of the product */
  longDesc?: Maybe<Scalars['String']>;
  /** Generic linking code for similar products */
  linkCode?: Maybe<Scalars['String']>;
  /**
   * List of categories defined for the product
   * Mutations:
   *
   * CreateProductCategory
   * DeleteProductCategory
   * UpdateProductCategory
   */
  categories?: Maybe<Array<Maybe<ProductCategory>>>;
  /**
   * List of components for the product, should only be populated
   * if the SKUType of the product is set to either STOCK or NONSTOCK.
   * Mutations:
   *
   * CreateBOMDefinition
   * DeleteBOMDefinition
   * UpdateBOMDefinition
   */
  components?: Maybe<Array<Maybe<BomDefinition>>>;
  /**
   * List of suppliers for the product.
   * Mutations:
   *
   * CreateProductSupplier
   * DeleteProductSupplier
   * UpdateProductSupplier
   */
  suppliers?: Maybe<Array<Maybe<ProductSupplier>>>;
  /**
   * List of licence plates defined for the product.
   *             Mutations:
   *
   * CreateLPDefinition
   * DeleteLPDefinition
   * UpdateLPDefinition
   */
  licencePlates?: Maybe<Array<Maybe<LpDefinition>>>;
  /**
   * List of barcodes for the product.
   * Mutations:
   *
   * CreateProductBarcode
   * DeleteProductBarcode
   * UpdateProductBarcode
   */
  barcodes?: Maybe<Array<Maybe<ProductBarcode>>>;
  /**
   * List of Documents for the product.
   * Mutations:
   *
   * CreateProductDocument
   * DeleteProductDocument
   * UpdateProductDocument
   */
  documents?: Maybe<Array<Maybe<ProductDocument>>>;
  require?: Maybe<ProductRequiredData>;
  /** BOM type of the product */
  SKUType?: Maybe<BomType>;
  /** INCI (International Nomenclature of Cosmetic ingredients) code for product */
  INCICode?: Maybe<Scalars['String']>;
  /** Defines how stock will be used (i.e. for picking) */
  rotation?: Maybe<RotationRule>;
  /** Type of the product */
  type?: Maybe<Scalars['String']>;
  /** Storage type of the product */
  StorageType?: Maybe<Scalars['String']>;
  /** Facility category */
  facilityCat?: Maybe<Scalars['String']>;
  /** Default budget holder for the product */
  defBudhol?: Maybe<Scalars['String']>;
  /** Default warehouse for the product */
  defWH?: Maybe<Scalars['String']>;
  /** Default handling type for product */
  defHandType?: Maybe<Scalars['String']>;
  /** Default pack type of the product */
  defPackType?: Maybe<Scalars['String']>;
  /** Department code for the product */
  depCode?: Maybe<Scalars['String']>;
  /** Product rank */
  rank?: Maybe<Scalars['String']>;
  /** UN Code for the product */
  uNCode?: Maybe<Scalars['String']>;
  /** Band Quantity */
  bandQty?: Maybe<Scalars['Int']>;
  manufacturerCode?: Maybe<Scalars['String']>;
  /** Life cycle status */
  lifeCycleStatus?: Maybe<Scalars['String']>;
  /** Validate batch at packing */
  packValidateBatch?: Maybe<Scalars['Boolean']>;
  /** Collect packing type at packing */
  capturePackType?: Maybe<Scalars['Boolean']>;
  /** Pick part pallets as full pallets */
  pickPartPalletsAsFull?: Maybe<Scalars['Boolean']>;
  /** Pick in singles */
  pickSingles?: Maybe<Scalars['Boolean']>;
  pickDefId?: Maybe<Scalars['Int']>;
  /** Default pick definition for the product */
  defPickDefinition?: Maybe<PickMethod>;
  /**
   * List of pickface definitions for the product
   * Mutations:
   *
   * CreateProductPickface
   * DeleteProductPickface
   * UpdateProductPickface
   */
  pickfaces?: Maybe<Array<Maybe<ProductPickface>>>;
  /** Code for the default goods receipt status */
  defGRStatus: Scalars['String'];
  /** Minimum receipt shelf life */
  minRShlfLife?: Maybe<Scalars['Int']>;
  /** Minimum picking shelf life */
  minPShlfLife?: Maybe<Scalars['Int']>;
  /** Total shelf life */
  totShlfLife?: Maybe<Scalars['Int']>;
};

export type WmsUser = {
  __typename?: 'WMSUser';
  culture?: Maybe<Scalars['String']>;
  serverRole?: Maybe<ServerPermission>;
  userPermissions?: Maybe<Array<Maybe<UserPermission>>>;
  userMenus?: Maybe<Array<Maybe<MenuEntry>>>;
  forename?: Maybe<Scalars['String']>;
  surname?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  userName?: Maybe<Scalars['String']>;
  normalizedUserName?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumberConfirmed: Scalars['Boolean'];
  twoFactorEnabled: Scalars['Boolean'];
  lockoutEnd?: Maybe<Scalars['DateTime']>;
  lockoutEnabled: Scalars['Boolean'];
  accessFailedCount: Scalars['Int'];
};

export type WmsUserResult = WmsUser | DatabaseError | ValidationError;

export type Screen = {
  __typename?: 'Screen';
  action?: Maybe<Scalars['String']>;
  defaultTitle?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  screenCode?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  /** @deprecated Should never have been exposed */
  compareTo?: Maybe<Scalars['String']>;
};

export type CodeDefinition = {
  __typename?: 'CodeDefinition';
  id: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
};

export type AuditCode = {
  __typename?: 'AuditCode';
  id: Scalars['Int'];
  code?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  /** @deprecated Should not be used by client code */
  message?: Maybe<Scalars['String']>;
};

export type AuditEntryFilterInput = {
  and?: Maybe<Array<AuditEntryFilterInput>>;
  or?: Maybe<Array<AuditEntryFilterInput>>;
  id?: Maybe<ComparableNullableOfInt32OperationFilterInput>;
  warehouseId?: Maybe<ComparableNullableOfInt32OperationFilterInput>;
  warehouse?: Maybe<WarehouseFilterInput>;
  stockOwnerId?: Maybe<ComparableNullableOfInt32OperationFilterInput>;
  stockOwner?: Maybe<StockOwnerFilterInput>;
  eventTime?: Maybe<ComparableDateTimeOperationFilterInput>;
  auditCode?: Maybe<AuditCodeFilterInput>;
  code?: Maybe<StringOperationFilterInput>;
  userId?: Maybe<StringOperationFilterInput>;
  user?: Maybe<WmsUserFilterInput>;
  toLocationId?: Maybe<ComparableNullableOfInt32OperationFilterInput>;
  toLocation?: Maybe<LocationFilterInput>;
  fromLocationId?: Maybe<ComparableNullableOfInt32OperationFilterInput>;
  fromLocation?: Maybe<LocationFilterInput>;
  attributeId?: Maybe<ComparableNullableOfInt32OperationFilterInput>;
  attributes?: Maybe<IwmsAttributesFilterInput>;
  status?: Maybe<StringOperationFilterInput>;
  packType?: Maybe<StringOperationFilterInput>;
  packs?: Maybe<ComparableNullableOfDecimalOperationFilterInput>;
  singles?: Maybe<ComparableNullableOfDecimalOperationFilterInput>;
  metadata?: Maybe<ListStringOperationFilterInput>;
};

export type AuditEntry = {
  __typename?: 'AuditEntry';
  attributeId?: Maybe<Scalars['Int']>;
  attributes?: Maybe<IwmsAttributes>;
  message?: Maybe<Scalars['String']>;
  user?: Maybe<WmsUser>;
  fromLocationId?: Maybe<Scalars['Int']>;
  fromLocation?: Maybe<Location>;
  toLocationId?: Maybe<Scalars['Int']>;
  toLocation?: Maybe<Location>;
  auditCode?: Maybe<AuditCode>;
  id?: Maybe<Scalars['Int']>;
  warehouseId?: Maybe<Scalars['Int']>;
  warehouse?: Maybe<Warehouse>;
  stockOwnerId?: Maybe<Scalars['Int']>;
  stockOwner?: Maybe<StockOwner>;
  eventTime: Scalars['DateTime'];
  code?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  packType?: Maybe<Scalars['String']>;
  packs?: Maybe<Scalars['Decimal']>;
  singles?: Maybe<Scalars['Decimal']>;
  metadata?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type MenuEntry = {
  __typename?: 'MenuEntry';
  screen?: Maybe<Screen>;
  depth?: Maybe<Scalars['Int']>;
  parent?: Maybe<MenuEntry>;
  children?: Maybe<Array<Maybe<MenuEntry>>>;
  title?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  userId?: Maybe<Scalars['String']>;
  parentId?: Maybe<Scalars['Int']>;
  order?: Maybe<Scalars['Int']>;
  screenId?: Maybe<Scalars['Int']>;
  enabled?: Maybe<Scalars['Boolean']>;
  defaultGroupId?: Maybe<Scalars['String']>;
};

export type ProductSupplier = {
  __typename?: 'ProductSupplier';
  warehouse?: Maybe<Warehouse>;
  id?: Maybe<Scalars['Int']>;
  product?: Maybe<Product>;
  /** Id of the supplier */
  supplierId: Scalars['Int'];
  supplier?: Maybe<Supplier>;
  /** id of the associated warehouse */
  warehouseId?: Maybe<Scalars['Int']>;
  /** Is the supplier active for this product */
  active?: Maybe<Scalars['Boolean']>;
};

export enum ApplyPolicy {
  BeforeResolver = 'BEFORE_RESOLVER',
  AfterResolver = 'AFTER_RESOLVER'
}


export type AssemblyName = {
  __typename?: 'AssemblyName';
  name?: Maybe<Scalars['String']>;
  fullName: Scalars['String'];
  version?: Maybe<Scalars['String']>;
  cultureName?: Maybe<Scalars['String']>;
  processorArchitecture: ProcessorArchitecture;
  publicKeyToken?: Maybe<Array<Scalars['Byte']>>;
};

export type ResourcesQuery = {
  __typename?: 'ResourcesQuery';
  id?: Maybe<Scalars['String']>;
  resourceList?: Maybe<Array<Maybe<ResourceIdItem>>>;
  /**
   * Returns a shaped objects that can be displayed in an editable grid the grid view for locale ids
   * of resources.
   *
   * {
   *   "Locales": [
   *     "",
   *     "de",
   *     "fr"
   *   ],
   *   "Resources": [
   *     {
   *       "ResourceId": "AddressIsRequired",
   *       "Resources": [
   *         {
   *           "ResourceId": "AddressIsRequired",
   *           "LocaleId": "",
   *           "ResourceSet": "Resources",
   *           "Value": "An address is required."
   *         },
   *         {
   *           "ResourceId": "AddressIsRequired",
   *           "LocaleId": "de",
   *           "ResourceSet": "Resources",
   *           "Value": "Eine Addresse muss angegeben werden."
   *         },
   *         {
   *           "ResourceId": "AddressIsRequired",
   *           "LocaleId": "fr",
   *           "ResourceSet": "Resources",
   *           "Value": "Une adresse doit Ãªtre saisi."
   *         }
   *       ]
   *     },
   *     {}
   *     ]
   * }
   */
  allResourcesForResourceGrid?: Maybe<GridResult>;
  resourceListHtml?: Maybe<Array<Maybe<ResourceIdListItem>>>;
  /** Returns a list of all ResourceSets */
  resourceSets?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Returns a list of the all the LocaleIds used in a given resource set */
  allLocaleIds?: Maybe<Array<Maybe<CultureInfo>>>;
  /** Returns a resource string based on  resourceId, resourceSet,cultureName */
  resourceString?: Maybe<Scalars['String']>;
  /**
   * Returns all resources for a given Resource ID. Pass resourceId, and resourceSet
   * in an object map.
   */
  resourceItems?: Maybe<Array<Maybe<ResourceItemEx>>>;
  /**
   * Returns an individual ResourceIdtem for a resource ID and specific culture.
   * pass resourceId, resourceSet, cultureName in an object map.
   */
  resourceItem?: Maybe<ResourceItemEx>;
  cultures?: Maybe<CulturesConnection>;
  /** checks to see if the localiztion table exists */
  isLocalizationTable: Scalars['Boolean'];
  /** Determines whether a locale is an RTL language */
  isRtl: Scalars['Boolean'];
};


export type ResourcesQueryResourceListArgs = {
  resourceSet: Scalars['String'];
};


export type ResourcesQueryAllResourcesForResourceGridArgs = {
  resourceSet: Scalars['String'];
};


export type ResourcesQueryResourceListHtmlArgs = {
  resourceSet: Scalars['String'];
};


export type ResourcesQueryAllLocaleIdsArgs = {
  resourceSet: Scalars['String'];
};


export type ResourcesQueryResourceStringArgs = {
  resourceId: Scalars['String'];
  resourceSet: Scalars['String'];
  cultureName?: Maybe<Scalars['String']>;
};


export type ResourcesQueryResourceItemsArgs = {
  resourceId: Scalars['String'];
  resourceSet: Scalars['String'];
};


export type ResourcesQueryResourceItemArgs = {
  resourceId: Scalars['String'];
  resourceSet: Scalars['String'];
};


export type ResourcesQueryCulturesArgs = {
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  where?: Maybe<CultureInfoFilterInput>;
  order?: Maybe<Array<CultureInfoSortInput>>;
};


export type ResourcesQueryIsRtlArgs = {
  localeId?: Maybe<Scalars['String']>;
};

export type ResourcesMutation = {
  __typename?: 'ResourcesMutation';
  /**
   * Adds or updates a resource. Pass value, resourceId,resourceSet,localeId,comment
   * as a map.
   */
  updateResourceString: Scalars['Boolean'];
  /**
   * Updates just a comment for an individual resourceId. Pass resourceId, resourceSet and localeId
   * in a map.
   */
  updateComment: Scalars['Boolean'];
  /** Updates or Adds a resource if it doesn't exist */
  updateResource: Scalars['Boolean'];
  /** Deletes an entire resource set. */
  deleteResourceSet: Scalars['Boolean'];
  /**
   * Delete an individual resource. Pass resourceId, resourceSet and localeId
   * as a map. If localeId is null all the resources are deleted.
   */
  deleteResource: Scalars['Boolean'];
  /**
   * Renames a resource key to a new name.
   *
   * Requires a JSON object with the following properties:
   * {
   * }
   */
  renameResource: Scalars['Boolean'];
  /**
   * Renames all resource keys that match a property (ie. lblName.Text, lblName.ToolTip)
   * at once. This is useful if you decide to rename a meta:resourcekey in the ASP.NET
   * markup.
   */
  renameResourceProperty: Scalars['Boolean'];
  /** Renames a resource set to a new name. */
  renameResourceSet: Scalars['Boolean'];
  /**
   * Creates a new localization table as defined int he configuration if it doesn't
   * exist. If the table exists an error is returned.
   */
  createTable: Scalars['Boolean'];
  /** Backs up the resource table into a new table with the same name + _backup */
  backup: Scalars['Boolean'];
  /**
   * Clears the resource cache. Works only if using one of the Westwind
   * ASP.NET resource providers or managers.
   */
  reloadResources: Scalars['Boolean'];
  translate?: Maybe<Scalars['String']>;
  /**
   * Small helper that turns a camel case string into
   * space separated string.
   */
  fromCamelCase?: Maybe<Scalars['String']>;
  generateTestLanguage?: Maybe<TestLanguageStatistics>;
  generateGenericResourceSet: Scalars['Boolean'];
};


export type ResourcesMutationUpdateResourceStringArgs = {
  resourceSet: Scalars['String'];
  resourceId: Scalars['String'];
  localeId?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
  comment?: Maybe<Scalars['String']>;
};


export type ResourcesMutationUpdateCommentArgs = {
  resourceSet: Scalars['String'];
  resourceId: Scalars['String'];
  localeId?: Maybe<Scalars['String']>;
  comment?: Maybe<Scalars['String']>;
};


export type ResourcesMutationUpdateResourceArgs = {
  resource: ResourceItemInput;
};


export type ResourcesMutationDeleteResourceSetArgs = {
  resourceSet: Scalars['String'];
};


export type ResourcesMutationDeleteResourceArgs = {
  resourceId: Scalars['String'];
  resourceSet: Scalars['String'];
  localeId?: Maybe<Scalars['String']>;
};


export type ResourcesMutationRenameResourceArgs = {
  resourceId: Scalars['String'];
  newResourceId: Scalars['String'];
  resourceSet: Scalars['String'];
};


export type ResourcesMutationRenameResourcePropertyArgs = {
  property: Scalars['String'];
  newProperty: Scalars['String'];
  resourceSet: Scalars['String'];
};


export type ResourcesMutationRenameResourceSetArgs = {
  oldResourceSet: Scalars['String'];
  newResourceSet: Scalars['String'];
};


export type ResourcesMutationTranslateArgs = {
  text: Scalars['String'];
  from: Scalars['String'];
  to: Scalars['String'];
  service: Scalars['String'];
};


export type ResourcesMutationFromCamelCaseArgs = {
  camelCaseString?: Maybe<Scalars['String']>;
};


export type ResourcesMutationGenerateTestLanguageArgs = {
  resourceSet?: Maybe<Scalars['String']>;
  prefix?: Maybe<Scalars['String']>;
  suffix?: Maybe<Scalars['String']>;
};


export type ResourcesMutationGenerateGenericResourceSetArgs = {
  targetResourceSet?: Maybe<Scalars['String']>;
  minimumInstances?: Scalars['Int'];
};

export enum ServerPermission {
  User = 'USER',
  Manager = 'MANAGER',
  Administrator = 'ADMINISTRATOR',
  SuperUser = 'SUPER_USER'
}

export type UserPermission = {
  __typename?: 'UserPermission';
  id?: Maybe<Scalars['Int']>;
  userId?: Maybe<Scalars['String']>;
  warehouseId?: Maybe<Scalars['Int']>;
  warehouse?: Maybe<Warehouse>;
  stockOwnerId?: Maybe<Scalars['Int']>;
  stockOwner?: Maybe<StockOwner>;
  permissions?: Maybe<Array<Permission>>;
};

export type ValidationError = {
  __typename?: 'ValidationError';
  id: Scalars['Int'];
  /** @deprecated Use errors[].fieldName instead */
  field?: Maybe<Scalars['String']>;
  messages?: Maybe<Array<Maybe<Scalars['String']>>>;
  errors?: Maybe<Array<Maybe<FieldError>>>;
  any: Scalars['Boolean'];
};

export type ComparableNullableOfInt32OperationFilterInput = {
  eq?: Maybe<Scalars['Int']>;
  neq?: Maybe<Scalars['Int']>;
  in?: Maybe<Array<Maybe<Scalars['Int']>>>;
  nin?: Maybe<Array<Maybe<Scalars['Int']>>>;
  gt?: Maybe<Scalars['Int']>;
  ngt?: Maybe<Scalars['Int']>;
  gte?: Maybe<Scalars['Int']>;
  ngte?: Maybe<Scalars['Int']>;
  lt?: Maybe<Scalars['Int']>;
  nlt?: Maybe<Scalars['Int']>;
  lte?: Maybe<Scalars['Int']>;
  nlte?: Maybe<Scalars['Int']>;
};

export type WarehouseFilterInput = {
  and?: Maybe<Array<WarehouseFilterInput>>;
  or?: Maybe<Array<WarehouseFilterInput>>;
  id?: Maybe<ComparableNullableOfInt32OperationFilterInput>;
  code?: Maybe<StringOperationFilterInput>;
  companyName?: Maybe<StringOperationFilterInput>;
  warehouseName?: Maybe<StringOperationFilterInput>;
  address?: Maybe<AddressFilterInput>;
  telephone?: Maybe<StringOperationFilterInput>;
  VATNumber?: Maybe<StringOperationFilterInput>;
  customsId?: Maybe<StringOperationFilterInput>;
};

export type StockOwnerFilterInput = {
  and?: Maybe<Array<StockOwnerFilterInput>>;
  or?: Maybe<Array<StockOwnerFilterInput>>;
  id?: Maybe<ComparableNullableOfInt32OperationFilterInput>;
  /** The unique code for this stock owner */
  code?: Maybe<StringOperationFilterInput>;
  /** The name of the stock owner */
  name?: Maybe<StringOperationFilterInput>;
  /** The status of the StockOwner. See  for possible values. */
  status?: Maybe<NullableOfStateOperationFilterInput>;
  linkedStockOwners?: Maybe<ListFilterInputTypeOfStockOwnerLinkFilterInput>;
  /** Contact for the stock owner */
  contact?: Maybe<ContactFilterInput>;
  /** Address of the stock owner */
  address?: Maybe<AddressFilterInput>;
  /** Cold storage ID associated with the stock owner */
  coldStoreID?: Maybe<StringOperationFilterInput>;
  /** GLN (Global Location Number) for the stock owner */
  GLN?: Maybe<StringOperationFilterInput>;
  /** VAT Number for the stock Owner */
  VATNumber?: Maybe<StringOperationFilterInput>;
  /**
   * List of statuses available for the stock associated with the
   * stock owner
   * Mutations:
   *
   * createStockOwnerStatus
   * deleteStockOwnerStatus
   * updateStockOwnerStatus
   */
  productStatuses?: Maybe<ListFilterInputTypeOfProductStatusFilterInput>;
  /**
   * List of product categories available for the stock associated with the
   * stock owner
   * Mutations:
   *
   * createStockOwnerCategoryDefinition
   * updateStockOwnerCategoryDefinition
   * deleteStockOwnerCategoryDefinition
   */
  categories?: Maybe<ListFilterInputTypeOfCategoryDefinitionFilterInput>;
  /**
   * Warn when moving stock to a location that contains
   * a different status
   */
  warnMoveDifStatus?: Maybe<BooleanOperationFilterInput>;
  /** Require budget holder */
  requireBudhol?: Maybe<BooleanOperationFilterInput>;
  /** Require Product categories */
  requireProdCategories?: Maybe<BooleanOperationFilterInput>;
  /** Mask for barcodes that are scanned */
  scanBarcodeMask?: Maybe<StringOperationFilterInput>;
  /** Mask for barcodes that are keyed in */
  keyedBarcodeMask?: Maybe<StringOperationFilterInput>;
  /** Capture serials on receipt */
  captureSerialsOnRcpt?: Maybe<BooleanOperationFilterInput>;
  /** Require pallet ID to be entered */
  requirePalletID?: Maybe<BooleanOperationFilterInput>;
  /** Print pallet labels On Receipt */
  printPalLblsOnRcpt?: Maybe<BooleanOperationFilterInput>;
  /** Capture PO number on receipt */
  capturePONumOnRcpt?: Maybe<BooleanOperationFilterInput>;
  /** Allocation locations to pallet received */
  allocateLocOnRcpt?: Maybe<BooleanOperationFilterInput>;
  /** Close PO when the Goods receipt has been completed */
  closeComPoOnRcpt?: Maybe<BooleanOperationFilterInput>;
  /** Validate Batch against PO */
  validateBatchPO?: Maybe<BooleanOperationFilterInput>;
  /** Capture packaging information on receipt */
  capturePkgInfoOnRcpt?: Maybe<BooleanOperationFilterInput>;
  /** Putaway LP on Receipt */
  putwayLPOnRcpt?: Maybe<BooleanOperationFilterInput>;
  /** Confirm putaways on Receipt */
  confirmPutawaysOnRcpt?: Maybe<BooleanOperationFilterInput>;
  /** Goods receipt can only be closed by authorized user */
  reqAuthOnGRClose?: Maybe<BooleanOperationFilterInput>;
  /** Unbooked receipts by default */
  defaultUnbookedRcpt?: Maybe<BooleanOperationFilterInput>;
  /** Use identical pallets on Receipt */
  identicalPallets?: Maybe<BooleanOperationFilterInput>;
  /** Strict PO date validation */
  strictPODateVal?: Maybe<BooleanOperationFilterInput>;
  /** Receipt Verification - Split on Supplier Tollerance */
  splitSuppTolerance?: Maybe<BooleanOperationFilterInput>;
  /** Receipt verification - Putaway to default location */
  RVPutToDefLoc?: Maybe<BooleanOperationFilterInput>;
  /** RF Putaway Immediately */
  RFPutImmediately?: Maybe<BooleanOperationFilterInput>;
  /** Disable Confirm Putaway for Specified Locations */
  disablePutForSpecificLocs?: Maybe<BooleanOperationFilterInput>;
  /** Extra info must be entered on receipt */
  mandExtraInfoOnRcpt?: Maybe<BooleanOperationFilterInput>;
  /** Capture container type on receipt */
  captureContainerType?: Maybe<BooleanOperationFilterInput>;
  /** Only show booked products in the product F2 */
  F2ShowBookedProdsOnly?: Maybe<BooleanOperationFilterInput>;
  /** Generate PO Number automatically */
  autoGeneratePONumber?: Maybe<BooleanOperationFilterInput>;
  /** Allow Editing in Receipt verification */
  allowEditInRV?: Maybe<BooleanOperationFilterInput>;
  /** Print Carton Labels with Pallet Labels */
  GRPrintCrtnLbls?: Maybe<BooleanOperationFilterInput>;
  /** No Backflush when receiving from production */
  noBckFlushGRProduction?: Maybe<BooleanOperationFilterInput>;
  /** Print labels when receiving from production */
  printLblsGRProduction?: Maybe<BooleanOperationFilterInput>;
  /** Receipt and Booking Number must match */
  matchGRWithBookNo?: Maybe<BooleanOperationFilterInput>;
  /** Receipt verification - Suppress merging of pick faces */
  RVSuppressMergePF?: Maybe<BooleanOperationFilterInput>;
  /** Split PO lines on Print */
  spltPOLinesOnPrint?: Maybe<BooleanOperationFilterInput>;
  /** Make GRN number the budgetholder for received stock */
  makeGRNBudhol?: Maybe<BooleanOperationFilterInput>;
  /** Allow Short Shelf Life */
  allowShortShelfLife?: Maybe<BooleanOperationFilterInput>;
  /** Add products to PO that were not expected */
  allowAddProdsToPO?: Maybe<BooleanOperationFilterInput>;
  /** Capture Location on receipt */
  captureLocOnRcpt?: Maybe<BooleanOperationFilterInput>;
  /** Capture temperature on receipt */
  captureTempOnRcpt?: Maybe<BooleanOperationFilterInput>;
  /**
   * List of order statuses for the stock owner
   *
   * Mutations:
   *
   * CreateOrderStatus
   * DeleteOrderStatus
   * UpdateOrderStatus
   */
  orderStatuses?: Maybe<ListFilterInputTypeOfOrderStatusFilterInput>;
  /** Generate order numbers automatically */
  autoGenOrderNum?: Maybe<BooleanOperationFilterInput>;
  /** Display Errors in Order Entry */
  dispOrderEntryErrs?: Maybe<BooleanOperationFilterInput>;
  /** Require Proof of Delivery */
  requirePOD?: Maybe<BooleanOperationFilterInput>;
  /** Print Order Confirmation Report */
  printOrdConfRpt?: Maybe<BooleanOperationFilterInput>;
  /** Create pick once an order has been saved in order entry */
  createPickOnOrdEntry?: Maybe<BooleanOperationFilterInput>;
  /** Do not clear line customer reference */
  dontClearLineCustRef?: Maybe<BooleanOperationFilterInput>;
  /** Mandatory Line customer reference */
  mandLineCustref?: Maybe<BooleanOperationFilterInput>;
  /** Warn if there is a shortage of a product on the order */
  warnOnShortage?: Maybe<BooleanOperationFilterInput>;
  /** Print order report with PickList */
  printOrdRptWithPick?: Maybe<BooleanOperationFilterInput>;
  /** Print box packing Labels */
  printBoxPackLbls?: Maybe<BooleanOperationFilterInput>;
  /** GDPR Controlled */
  GDPRControlled?: Maybe<BooleanOperationFilterInput>;
  /** Force budgetholder to be entered in order entry */
  forceBudholOnEntry?: Maybe<BooleanOperationFilterInput>;
  /** Prevent batch from being entered in order entry */
  preventBatchOnEntry?: Maybe<BooleanOperationFilterInput>;
  /** Allow products to be swapped using generics in order entry. */
  swapGenericsOnEntry?: Maybe<BooleanOperationFilterInput>;
  /** Force Department in order entry. */
  forceDepartmentOnEntry?: Maybe<BooleanOperationFilterInput>;
  /**
   * List of pick definitions for the stock owner
   * Mutations:
   *
   * createStockOwnerPickMethod
   * deleteStockOwnerPickMethod
   * updateStockOwnerPickMethod
   */
  pickMethods?: Maybe<ListFilterInputTypeOfPickMethodFilterInput>;
  /** Pick Orders without shortages only. */
  cleanOrdersOnly?: Maybe<BooleanOperationFilterInput>;
  /** Create back orders when creating picks that are short */
  createBackOrders?: Maybe<BooleanOperationFilterInput>;
  /** Allow Shortage swapping */
  allowShortageSwap?: Maybe<BooleanOperationFilterInput>;
  /** Allow budgetholder swapping */
  allowBudholSwap?: Maybe<BooleanOperationFilterInput>;
  /** Change trays based on Priority */
  chngeTraysOnPri?: Maybe<BooleanOperationFilterInput>;
  /** Only create picks with no replens. */
  noReplenPicksOnly?: Maybe<BooleanOperationFilterInput>;
  /** Allow status swapping */
  allowStatusSwap?: Maybe<BooleanOperationFilterInput>;
  /** Pick cartons */
  pickCartons?: Maybe<BooleanOperationFilterInput>;
  /** Manual Picking - Do not split lists */
  MPNoSplitLists?: Maybe<BooleanOperationFilterInput>;
  /** Show Unpickable report */
  showUnpickableRpt?: Maybe<BooleanOperationFilterInput>;
  /** Allow LP Swapping */
  allowLPSwap?: Maybe<BooleanOperationFilterInput>;
  /** Allow Sell by date swapping */
  allowSBDSwap?: Maybe<BooleanOperationFilterInput>;
  /** Find carton ID by Weight */
  findCartonByWgt?: Maybe<BooleanOperationFilterInput>;
  /** Capture Carrier */
  captureCarrier?: Maybe<BooleanOperationFilterInput>;
  /** Allow Location swapping */
  allowLocSwap?: Maybe<BooleanOperationFilterInput>;
  /** Use BOM Picking */
  useBOMPicking?: Maybe<BooleanOperationFilterInput>;
  /** Require Despatch note */
  requireDespNote?: Maybe<BooleanOperationFilterInput>;
  /** RF Pick Assignment enumeration */
  RFPickAssignment?: Maybe<NullableOfPickAssignmentOperationFilterInput>;
  voicePickAssignment?: Maybe<NullableOfPickAssignmentOperationFilterInput>;
  /** Allow Batch swapping */
  allowBatchSwap?: Maybe<BooleanOperationFilterInput>;
  /** Required to confirm product */
  requireConfProduct?: Maybe<BooleanOperationFilterInput>;
  /** Require UPI check */
  requireUPICheck?: Maybe<BooleanOperationFilterInput>;
  /** Perform pick cage validation */
  cageValidation?: Maybe<BooleanOperationFilterInput>;
  /** Validate despatch note */
  despNoteValidation?: Maybe<BooleanOperationFilterInput>;
  /** Suppress Replenishment option */
  suppressReplenOpt?: Maybe<BooleanOperationFilterInput>;
  /** Use Loading */
  useLoading?: Maybe<BooleanOperationFilterInput>;
  /** Produce RF Manifest */
  produceRFManifest?: Maybe<BooleanOperationFilterInput>;
  /** Requires seal number to be entered */
  requireSealNo?: Maybe<BooleanOperationFilterInput>;
  /** Require truck to be specified */
  requireTruck?: Maybe<BooleanOperationFilterInput>;
  /** Require driver to be specified */
  requireDriver?: Maybe<BooleanOperationFilterInput>;
  /** Use Load order */
  useLoadOrder?: Maybe<BooleanOperationFilterInput>;
  loadOrder?: Maybe<NullableOfLoadOrderOperationFilterInput>;
  /** Despatch lane for loading */
  despLane?: Maybe<StringOperationFilterInput>;
  /** Maximum number of Loaders */
  maxLoaders?: Maybe<ComparableNullableOfInt32OperationFilterInput>;
  adhocLoading?: Maybe<NullableOfAccessiblityOperationFilterInput>;
  /** Capture temperature at the start of Load */
  loadTempCaptureStart?: Maybe<BooleanOperationFilterInput>;
  /** Capture temperature at the end of Load */
  loadTempCaptureEnd?: Maybe<BooleanOperationFilterInput>;
  /** Capture temperature at LP Intervals */
  loadTempLPInterval?: Maybe<BooleanOperationFilterInput>;
  /**
   * List of confirm methods for stock owner
   * Mutations:
   *
   * createStockOwnerConfirmMethod
   * deleteStockOwnerConfirmMethod
   * updateStockOwnerConfirmMethod
   */
  confirmMethods?: Maybe<ListFilterInputTypeOfPickConfirmMethodFilterInput>;
  /** Capture time on pick confirm */
  captureTimeOnConfirm?: Maybe<NullableOfFieldVisibilityOperationFilterInput>;
  /** Capture check on pick confirm */
  captureCheckerOnConfirm?: Maybe<NullableOfFieldVisibilityOperationFilterInput>;
  /** Capture picker on pick confirm */
  capturePickerOnConfirm?: Maybe<NullableOfFieldVisibilityOperationFilterInput>;
  /** Default pick fail code */
  defPickFailCode?: Maybe<StringOperationFilterInput>;
  /** Require despatch lane */
  requireDespatchLane?: Maybe<BooleanOperationFilterInput>;
  /** Use destination info for despatch email notification */
  useEmailFromDestination?: Maybe<BooleanOperationFilterInput>;
  /** Allow despatch reprints for unconfirmed picklists */
  reprntUnfinishedLists?: Maybe<BooleanOperationFilterInput>;
  /** Destock when short */
  destockShortOnSHort?: Maybe<BooleanOperationFilterInput>;
  /** Proportional box records on pick confirm */
  proportionalBoxesOnConfirm?: Maybe<BooleanOperationFilterInput>;
  /** Allow Loading in any Sequence */
  allowLoadAnySeq?: Maybe<BooleanOperationFilterInput>;
  /** LP Control in Manual box packing */
  MBPLPControl?: Maybe<BooleanOperationFilterInput>;
  /** Use stock owner defined despatch method in Manual box packing */
  MBPUseSODespMeth?: Maybe<BooleanOperationFilterInput>;
  /** Do not create despatch notes */
  noDespNotes?: Maybe<BooleanOperationFilterInput>;
  /** Preview despatch notes */
  previewDespNote?: Maybe<BooleanOperationFilterInput>;
  /** Turn BOMS to stock */
  BOMSToStock?: Maybe<BooleanOperationFilterInput>;
  /** Delay despatch */
  delayDespatch?: Maybe<BooleanOperationFilterInput>;
  /** RF Warning in Pick confirm */
  RFWarnInPckConf?: Maybe<BooleanOperationFilterInput>;
  /** No replen before pick confirm */
  noReplenPckConf?: Maybe<BooleanOperationFilterInput>;
  /** Print despatch note per list */
  despNotePerList?: Maybe<BooleanOperationFilterInput>;
  /** Always print box Labels */
  printBoxLbls?: Maybe<BooleanOperationFilterInput>;
  /** Disable immediate despatch */
  disablImmDesp?: Maybe<BooleanOperationFilterInput>;
  /** Allow future despatch dates */
  allowFutureDespDates?: Maybe<BooleanOperationFilterInput>;
  /** Capture Consignment Number at MBP */
  MBPCaptureConsNo?: Maybe<BooleanOperationFilterInput>;
  /** Optional consignment number */
  optConsNo?: Maybe<BooleanOperationFilterInput>;
  /** Print box label at pick confirm */
  boxLblsPickConf?: Maybe<BooleanOperationFilterInput>;
  /** Use LP IDs at Pick confirm */
  useLPIdsPickConfirm?: Maybe<BooleanOperationFilterInput>;
  /** Authorised Manual box packing */
  authMBP?: Maybe<BooleanOperationFilterInput>;
  /** Mandatory Container type */
  mandContainerType?: Maybe<BooleanOperationFilterInput>;
  /** Create PDF despatch notes */
  PDFDespNotes?: Maybe<BooleanOperationFilterInput>;
  /** Use despatch prefix */
  useDespPrefix?: Maybe<BooleanOperationFilterInput>;
  /** Number of despatch notes */
  noOfDespNotes?: Maybe<BooleanOperationFilterInput>;
  /** Confirm whole pick */
  confWholePick?: Maybe<BooleanOperationFilterInput>;
  /** Capture reason for delayed despatch */
  capReasonDelayDesp?: Maybe<BooleanOperationFilterInput>;
  /** Manual box packing - despatch note breakdown */
  MBPDespNoteBreakdwn?: Maybe<BooleanOperationFilterInput>;
  /** Don't close order when errors occur during label generation */
  dontCloseOrderOnLblFail?: Maybe<BooleanOperationFilterInput>;
  /** Capture the number of boxes per order */
  capBoxesPerOrder?: Maybe<BooleanOperationFilterInput>;
  /** Do not require carrier to be entered */
  carrierNotReq?: Maybe<BooleanOperationFilterInput>;
  /** Do not generate carrier labels at pick confirm */
  noCarrLblsPckConf?: Maybe<BooleanOperationFilterInput>;
  /** Copy carrier from parent order to back orders */
  copyCarrToBckOrd?: Maybe<BooleanOperationFilterInput>;
};

export type ComparableDateTimeOperationFilterInput = {
  eq?: Maybe<Scalars['DateTime']>;
  neq?: Maybe<Scalars['DateTime']>;
  in?: Maybe<Array<Scalars['DateTime']>>;
  nin?: Maybe<Array<Scalars['DateTime']>>;
  gt?: Maybe<Scalars['DateTime']>;
  ngt?: Maybe<Scalars['DateTime']>;
  gte?: Maybe<Scalars['DateTime']>;
  ngte?: Maybe<Scalars['DateTime']>;
  lt?: Maybe<Scalars['DateTime']>;
  nlt?: Maybe<Scalars['DateTime']>;
  lte?: Maybe<Scalars['DateTime']>;
  nlte?: Maybe<Scalars['DateTime']>;
};

export type AuditCodeFilterInput = {
  and?: Maybe<Array<AuditCodeFilterInput>>;
  or?: Maybe<Array<AuditCodeFilterInput>>;
  id?: Maybe<ComparableInt32OperationFilterInput>;
  name?: Maybe<StringOperationFilterInput>;
  description?: Maybe<StringOperationFilterInput>;
  message?: Maybe<StringOperationFilterInput>;
};

export type StringOperationFilterInput = {
  and?: Maybe<Array<StringOperationFilterInput>>;
  or?: Maybe<Array<StringOperationFilterInput>>;
  eq?: Maybe<Scalars['String']>;
  neq?: Maybe<Scalars['String']>;
  contains?: Maybe<Scalars['String']>;
  ncontains?: Maybe<Scalars['String']>;
  in?: Maybe<Array<Maybe<Scalars['String']>>>;
  nin?: Maybe<Array<Maybe<Scalars['String']>>>;
  startsWith?: Maybe<Scalars['String']>;
  nstartsWith?: Maybe<Scalars['String']>;
  endsWith?: Maybe<Scalars['String']>;
  nendsWith?: Maybe<Scalars['String']>;
};

export type WmsUserFilterInput = {
  and?: Maybe<Array<WmsUserFilterInput>>;
  or?: Maybe<Array<WmsUserFilterInput>>;
  concurrencyStamp?: Maybe<StringOperationFilterInput>;
  emailConfirmed?: Maybe<BooleanOperationFilterInput>;
  normalizedEmail?: Maybe<StringOperationFilterInput>;
  passwordHash?: Maybe<StringOperationFilterInput>;
  securityStamp?: Maybe<StringOperationFilterInput>;
  forename?: Maybe<StringOperationFilterInput>;
  surname?: Maybe<StringOperationFilterInput>;
  culture?: Maybe<StringOperationFilterInput>;
  id?: Maybe<StringOperationFilterInput>;
  userName?: Maybe<StringOperationFilterInput>;
  normalizedUserName?: Maybe<StringOperationFilterInput>;
  email?: Maybe<StringOperationFilterInput>;
  phoneNumber?: Maybe<StringOperationFilterInput>;
  phoneNumberConfirmed?: Maybe<BooleanOperationFilterInput>;
  twoFactorEnabled?: Maybe<BooleanOperationFilterInput>;
  lockoutEnd?: Maybe<ComparableNullableOfDateTimeOffsetOperationFilterInput>;
  lockoutEnabled?: Maybe<BooleanOperationFilterInput>;
  accessFailedCount?: Maybe<ComparableInt32OperationFilterInput>;
};

export type LocationFilterInput = {
  and?: Maybe<Array<LocationFilterInput>>;
  or?: Maybe<Array<LocationFilterInput>>;
  id?: Maybe<ComparableNullableOfInt32OperationFilterInput>;
  warehouse?: Maybe<WarehouseFilterInput>;
  code?: Maybe<StringOperationFilterInput>;
  /** The physical characteristics of the location such as whether it is drive-in or conventional racking */
  physicalCharacteristics?: Maybe<NullableOfLocationPhysicalTypeOperationFilterInput>;
  /** The process characteristics of the location such as whether it is uses a a picking face or despatch area */
  processCharacteristics?: Maybe<NullableOfLocationProcessTypeOperationFilterInput>;
  /** The storage temperature type of the location. e.g. Ambient, chilled or frozen */
  temperatureType?: Maybe<NullableOfLocationTemperatureTypeOperationFilterInput>;
  /** Additional location specific attributes (yet to be defined) */
  attributes?: Maybe<StringOperationFilterInput>;
  storageTypeId?: Maybe<ComparableNullableOfInt32OperationFilterInput>;
  storageType?: Maybe<StorageTypeFilterInput>;
  aisle?: Maybe<StringOperationFilterInput>;
  status?: Maybe<NullableOfLocationStatusOperationFilterInput>;
  checkCode?: Maybe<StringOperationFilterInput>;
  beam?: Maybe<StringOperationFilterInput>;
  beamSequence?: Maybe<StringOperationFilterInput>;
  zone?: Maybe<StringOperationFilterInput>;
  countZone?: Maybe<StringOperationFilterInput>;
  tier?: Maybe<ComparableNullableOfInt32OperationFilterInput>;
  elevation?: Maybe<ComparableNullableOfDecimalOperationFilterInput>;
  dimensions?: Maybe<DimensionFilterInput>;
  maxWeight?: Maybe<ComparableNullableOfDecimalOperationFilterInput>;
  pickZone?: Maybe<StringOperationFilterInput>;
  reservedProductId?: Maybe<ComparableNullableOfInt32OperationFilterInput>;
};

export type IwmsAttributesFilterInput = {
  and?: Maybe<Array<IwmsAttributesFilterInput>>;
  or?: Maybe<Array<IwmsAttributesFilterInput>>;
  id?: Maybe<ComparableNullableOfInt32OperationFilterInput>;
};

export type ComparableNullableOfDecimalOperationFilterInput = {
  eq?: Maybe<Scalars['Decimal']>;
  neq?: Maybe<Scalars['Decimal']>;
  in?: Maybe<Array<Maybe<Scalars['Decimal']>>>;
  nin?: Maybe<Array<Maybe<Scalars['Decimal']>>>;
  gt?: Maybe<Scalars['Decimal']>;
  ngt?: Maybe<Scalars['Decimal']>;
  gte?: Maybe<Scalars['Decimal']>;
  ngte?: Maybe<Scalars['Decimal']>;
  lt?: Maybe<Scalars['Decimal']>;
  nlt?: Maybe<Scalars['Decimal']>;
  lte?: Maybe<Scalars['Decimal']>;
  nlte?: Maybe<Scalars['Decimal']>;
};

export type ListStringOperationFilterInput = {
  all?: Maybe<StringOperationFilterInput>;
  none?: Maybe<StringOperationFilterInput>;
  some?: Maybe<StringOperationFilterInput>;
  any?: Maybe<Scalars['Boolean']>;
};

export type CultureInfoFilterInput = {
  and?: Maybe<Array<CultureInfoFilterInput>>;
  or?: Maybe<Array<CultureInfoFilterInput>>;
  parent?: Maybe<CultureInfoFilterInput>;
  lCID?: Maybe<ComparableInt32OperationFilterInput>;
  keyboardLayoutId?: Maybe<ComparableInt32OperationFilterInput>;
  name?: Maybe<StringOperationFilterInput>;
  ietfLanguageTag?: Maybe<StringOperationFilterInput>;
  displayName?: Maybe<StringOperationFilterInput>;
  nativeName?: Maybe<StringOperationFilterInput>;
  englishName?: Maybe<StringOperationFilterInput>;
  twoLetterISOLanguageName?: Maybe<StringOperationFilterInput>;
  threeLetterISOLanguageName?: Maybe<StringOperationFilterInput>;
  threeLetterWindowsLanguageName?: Maybe<StringOperationFilterInput>;
  compareInfo?: Maybe<CompareInfoFilterInput>;
  textInfo?: Maybe<TextInfoFilterInput>;
  isNeutralCulture?: Maybe<BooleanOperationFilterInput>;
  cultureTypes?: Maybe<CultureTypesOperationFilterInput>;
  numberFormat?: Maybe<NumberFormatInfoFilterInput>;
  dateTimeFormat?: Maybe<DateTimeFormatInfoFilterInput>;
  calendar?: Maybe<CalendarFilterInput>;
  optionalCalendars?: Maybe<ListFilterInputTypeOfCalendarFilterInput>;
  useUserOverride?: Maybe<BooleanOperationFilterInput>;
  isReadOnly?: Maybe<BooleanOperationFilterInput>;
};

export type CultureInfoSortInput = {
  parent?: Maybe<CultureInfoSortInput>;
  lCID?: Maybe<SortEnumType>;
  keyboardLayoutId?: Maybe<SortEnumType>;
  name?: Maybe<SortEnumType>;
  ietfLanguageTag?: Maybe<SortEnumType>;
  displayName?: Maybe<SortEnumType>;
  nativeName?: Maybe<SortEnumType>;
  englishName?: Maybe<SortEnumType>;
  twoLetterISOLanguageName?: Maybe<SortEnumType>;
  threeLetterISOLanguageName?: Maybe<SortEnumType>;
  threeLetterWindowsLanguageName?: Maybe<SortEnumType>;
  compareInfo?: Maybe<CompareInfoSortInput>;
  textInfo?: Maybe<TextInfoSortInput>;
  isNeutralCulture?: Maybe<SortEnumType>;
  cultureTypes?: Maybe<SortEnumType>;
  numberFormat?: Maybe<NumberFormatInfoSortInput>;
  dateTimeFormat?: Maybe<DateTimeFormatInfoSortInput>;
  calendar?: Maybe<CalendarSortInput>;
  useUserOverride?: Maybe<SortEnumType>;
  isReadOnly?: Maybe<SortEnumType>;
};

/** A connection to a list of items. */
export type CulturesConnection = {
  __typename?: 'CulturesConnection';
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A list of edges. */
  edges?: Maybe<Array<CulturesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<CultureInfo>>>;
  totalCount: Scalars['Int'];
};

export type AddressFilterInput = {
  and?: Maybe<Array<AddressFilterInput>>;
  or?: Maybe<Array<AddressFilterInput>>;
  /** Property or business name */
  name?: Maybe<StringOperationFilterInput>;
  /** Street address including house number and road */
  street1?: Maybe<StringOperationFilterInput>;
  /** Optional additional street name when Street1 is used for an apartment or block */
  street2?: Maybe<StringOperationFilterInput>;
  /** City, Town or Village */
  city?: Maybe<StringOperationFilterInput>;
  /** County or State */
  county?: Maybe<StringOperationFilterInput>;
  /** Postal or Zip code */
  postCode?: Maybe<StringOperationFilterInput>;
  /** Postal Country */
  country?: Maybe<StringOperationFilterInput>;
};

export type NullableOfStateOperationFilterInput = {
  eq?: Maybe<State>;
  neq?: Maybe<State>;
  in?: Maybe<Array<Maybe<State>>>;
  nin?: Maybe<Array<Maybe<State>>>;
};

export type ListFilterInputTypeOfStockOwnerLinkFilterInput = {
  all?: Maybe<StockOwnerLinkFilterInput>;
  none?: Maybe<StockOwnerLinkFilterInput>;
  some?: Maybe<StockOwnerLinkFilterInput>;
  any?: Maybe<Scalars['Boolean']>;
};

export type ContactFilterInput = {
  and?: Maybe<Array<ContactFilterInput>>;
  or?: Maybe<Array<ContactFilterInput>>;
  name?: Maybe<StringOperationFilterInput>;
  telephone?: Maybe<StringOperationFilterInput>;
  fax?: Maybe<StringOperationFilterInput>;
  email?: Maybe<StringOperationFilterInput>;
};

export type ListFilterInputTypeOfProductStatusFilterInput = {
  all?: Maybe<ProductStatusFilterInput>;
  none?: Maybe<ProductStatusFilterInput>;
  some?: Maybe<ProductStatusFilterInput>;
  any?: Maybe<Scalars['Boolean']>;
};

export type ListFilterInputTypeOfCategoryDefinitionFilterInput = {
  all?: Maybe<CategoryDefinitionFilterInput>;
  none?: Maybe<CategoryDefinitionFilterInput>;
  some?: Maybe<CategoryDefinitionFilterInput>;
  any?: Maybe<Scalars['Boolean']>;
};

export type BooleanOperationFilterInput = {
  eq?: Maybe<Scalars['Boolean']>;
  neq?: Maybe<Scalars['Boolean']>;
};

export type ListFilterInputTypeOfOrderStatusFilterInput = {
  all?: Maybe<OrderStatusFilterInput>;
  none?: Maybe<OrderStatusFilterInput>;
  some?: Maybe<OrderStatusFilterInput>;
  any?: Maybe<Scalars['Boolean']>;
};

export type ListFilterInputTypeOfPickMethodFilterInput = {
  all?: Maybe<PickMethodFilterInput>;
  none?: Maybe<PickMethodFilterInput>;
  some?: Maybe<PickMethodFilterInput>;
  any?: Maybe<Scalars['Boolean']>;
};

export type NullableOfPickAssignmentOperationFilterInput = {
  eq?: Maybe<PickAssignment>;
  neq?: Maybe<PickAssignment>;
  in?: Maybe<Array<Maybe<PickAssignment>>>;
  nin?: Maybe<Array<Maybe<PickAssignment>>>;
};

export type NullableOfLoadOrderOperationFilterInput = {
  eq?: Maybe<LoadOrder>;
  neq?: Maybe<LoadOrder>;
  in?: Maybe<Array<Maybe<LoadOrder>>>;
  nin?: Maybe<Array<Maybe<LoadOrder>>>;
};

export type NullableOfAccessiblityOperationFilterInput = {
  eq?: Maybe<Accessiblity>;
  neq?: Maybe<Accessiblity>;
  in?: Maybe<Array<Maybe<Accessiblity>>>;
  nin?: Maybe<Array<Maybe<Accessiblity>>>;
};

export type ListFilterInputTypeOfPickConfirmMethodFilterInput = {
  all?: Maybe<PickConfirmMethodFilterInput>;
  none?: Maybe<PickConfirmMethodFilterInput>;
  some?: Maybe<PickConfirmMethodFilterInput>;
  any?: Maybe<Scalars['Boolean']>;
};

export type NullableOfFieldVisibilityOperationFilterInput = {
  eq?: Maybe<FieldVisibility>;
  neq?: Maybe<FieldVisibility>;
  in?: Maybe<Array<Maybe<FieldVisibility>>>;
  nin?: Maybe<Array<Maybe<FieldVisibility>>>;
};

export type ComparableInt32OperationFilterInput = {
  eq?: Maybe<Scalars['Int']>;
  neq?: Maybe<Scalars['Int']>;
  in?: Maybe<Array<Scalars['Int']>>;
  nin?: Maybe<Array<Scalars['Int']>>;
  gt?: Maybe<Scalars['Int']>;
  ngt?: Maybe<Scalars['Int']>;
  gte?: Maybe<Scalars['Int']>;
  ngte?: Maybe<Scalars['Int']>;
  lt?: Maybe<Scalars['Int']>;
  nlt?: Maybe<Scalars['Int']>;
  lte?: Maybe<Scalars['Int']>;
  nlte?: Maybe<Scalars['Int']>;
};

export type ComparableNullableOfDateTimeOffsetOperationFilterInput = {
  eq?: Maybe<Scalars['DateTime']>;
  neq?: Maybe<Scalars['DateTime']>;
  in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  nin?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  gt?: Maybe<Scalars['DateTime']>;
  ngt?: Maybe<Scalars['DateTime']>;
  gte?: Maybe<Scalars['DateTime']>;
  ngte?: Maybe<Scalars['DateTime']>;
  lt?: Maybe<Scalars['DateTime']>;
  nlt?: Maybe<Scalars['DateTime']>;
  lte?: Maybe<Scalars['DateTime']>;
  nlte?: Maybe<Scalars['DateTime']>;
};

export type NullableOfLocationPhysicalTypeOperationFilterInput = {
  eq?: Maybe<LocationPhysicalType>;
  neq?: Maybe<LocationPhysicalType>;
  in?: Maybe<Array<Maybe<LocationPhysicalType>>>;
  nin?: Maybe<Array<Maybe<LocationPhysicalType>>>;
};

export type NullableOfLocationProcessTypeOperationFilterInput = {
  eq?: Maybe<LocationProcessType>;
  neq?: Maybe<LocationProcessType>;
  in?: Maybe<Array<Maybe<LocationProcessType>>>;
  nin?: Maybe<Array<Maybe<LocationProcessType>>>;
};

export type NullableOfLocationTemperatureTypeOperationFilterInput = {
  eq?: Maybe<LocationTemperatureType>;
  neq?: Maybe<LocationTemperatureType>;
  in?: Maybe<Array<Maybe<LocationTemperatureType>>>;
  nin?: Maybe<Array<Maybe<LocationTemperatureType>>>;
};

export type StorageTypeFilterInput = {
  and?: Maybe<Array<StorageTypeFilterInput>>;
  or?: Maybe<Array<StorageTypeFilterInput>>;
  id?: Maybe<ComparableNullableOfInt32OperationFilterInput>;
  code?: Maybe<StringOperationFilterInput>;
  description?: Maybe<StringOperationFilterInput>;
  MHEs?: Maybe<ListFilterInputTypeOfStorageTypeMheFilterInput>;
};

export type NullableOfLocationStatusOperationFilterInput = {
  eq?: Maybe<LocationStatus>;
  neq?: Maybe<LocationStatus>;
  in?: Maybe<Array<Maybe<LocationStatus>>>;
  nin?: Maybe<Array<Maybe<LocationStatus>>>;
};

export type DimensionFilterInput = {
  and?: Maybe<Array<DimensionFilterInput>>;
  or?: Maybe<Array<DimensionFilterInput>>;
  height?: Maybe<ComparableNullableOfDecimalOperationFilterInput>;
  width?: Maybe<ComparableNullableOfDecimalOperationFilterInput>;
  depth?: Maybe<ComparableNullableOfDecimalOperationFilterInput>;
  volume?: Maybe<ComparableNullableOfDecimalOperationFilterInput>;
};

export type CompareInfoFilterInput = {
  and?: Maybe<Array<CompareInfoFilterInput>>;
  or?: Maybe<Array<CompareInfoFilterInput>>;
  name?: Maybe<StringOperationFilterInput>;
  version?: Maybe<SortVersionFilterInput>;
  lCID?: Maybe<ComparableInt32OperationFilterInput>;
};

export type TextInfoFilterInput = {
  and?: Maybe<Array<TextInfoFilterInput>>;
  or?: Maybe<Array<TextInfoFilterInput>>;
  aNSICodePage?: Maybe<ComparableInt32OperationFilterInput>;
  oEMCodePage?: Maybe<ComparableInt32OperationFilterInput>;
  macCodePage?: Maybe<ComparableInt32OperationFilterInput>;
  eBCDICCodePage?: Maybe<ComparableInt32OperationFilterInput>;
  lCID?: Maybe<ComparableInt32OperationFilterInput>;
  cultureName?: Maybe<StringOperationFilterInput>;
  isReadOnly?: Maybe<BooleanOperationFilterInput>;
  listSeparator?: Maybe<StringOperationFilterInput>;
  isRightToLeft?: Maybe<BooleanOperationFilterInput>;
};

export type CultureTypesOperationFilterInput = {
  eq?: Maybe<CultureTypes>;
  neq?: Maybe<CultureTypes>;
  in?: Maybe<Array<CultureTypes>>;
  nin?: Maybe<Array<CultureTypes>>;
};

export type NumberFormatInfoFilterInput = {
  and?: Maybe<Array<NumberFormatInfoFilterInput>>;
  or?: Maybe<Array<NumberFormatInfoFilterInput>>;
  currencyDecimalDigits?: Maybe<ComparableInt32OperationFilterInput>;
  currencyDecimalSeparator?: Maybe<StringOperationFilterInput>;
  isReadOnly?: Maybe<BooleanOperationFilterInput>;
  currencyGroupSizes?: Maybe<ListComparableInt32OperationFilterInput>;
  numberGroupSizes?: Maybe<ListComparableInt32OperationFilterInput>;
  percentGroupSizes?: Maybe<ListComparableInt32OperationFilterInput>;
  currencyGroupSeparator?: Maybe<StringOperationFilterInput>;
  currencySymbol?: Maybe<StringOperationFilterInput>;
  naNSymbol?: Maybe<StringOperationFilterInput>;
  currencyNegativePattern?: Maybe<ComparableInt32OperationFilterInput>;
  numberNegativePattern?: Maybe<ComparableInt32OperationFilterInput>;
  percentPositivePattern?: Maybe<ComparableInt32OperationFilterInput>;
  percentNegativePattern?: Maybe<ComparableInt32OperationFilterInput>;
  negativeInfinitySymbol?: Maybe<StringOperationFilterInput>;
  negativeSign?: Maybe<StringOperationFilterInput>;
  numberDecimalDigits?: Maybe<ComparableInt32OperationFilterInput>;
  numberDecimalSeparator?: Maybe<StringOperationFilterInput>;
  numberGroupSeparator?: Maybe<StringOperationFilterInput>;
  currencyPositivePattern?: Maybe<ComparableInt32OperationFilterInput>;
  positiveInfinitySymbol?: Maybe<StringOperationFilterInput>;
  positiveSign?: Maybe<StringOperationFilterInput>;
  percentDecimalDigits?: Maybe<ComparableInt32OperationFilterInput>;
  percentDecimalSeparator?: Maybe<StringOperationFilterInput>;
  percentGroupSeparator?: Maybe<StringOperationFilterInput>;
  percentSymbol?: Maybe<StringOperationFilterInput>;
  perMilleSymbol?: Maybe<StringOperationFilterInput>;
  nativeDigits?: Maybe<ListStringOperationFilterInput>;
  digitSubstitution?: Maybe<DigitShapesOperationFilterInput>;
};

export type DateTimeFormatInfoFilterInput = {
  and?: Maybe<Array<DateTimeFormatInfoFilterInput>>;
  or?: Maybe<Array<DateTimeFormatInfoFilterInput>>;
  aMDesignator?: Maybe<StringOperationFilterInput>;
  calendar?: Maybe<CalendarFilterInput>;
  dateSeparator?: Maybe<StringOperationFilterInput>;
  firstDayOfWeek?: Maybe<DayOfWeekOperationFilterInput>;
  calendarWeekRule?: Maybe<CalendarWeekRuleOperationFilterInput>;
  fullDateTimePattern?: Maybe<StringOperationFilterInput>;
  longDatePattern?: Maybe<StringOperationFilterInput>;
  longTimePattern?: Maybe<StringOperationFilterInput>;
  monthDayPattern?: Maybe<StringOperationFilterInput>;
  pMDesignator?: Maybe<StringOperationFilterInput>;
  rFC1123Pattern?: Maybe<StringOperationFilterInput>;
  shortDatePattern?: Maybe<StringOperationFilterInput>;
  shortTimePattern?: Maybe<StringOperationFilterInput>;
  sortableDateTimePattern?: Maybe<StringOperationFilterInput>;
  timeSeparator?: Maybe<StringOperationFilterInput>;
  universalSortableDateTimePattern?: Maybe<StringOperationFilterInput>;
  yearMonthPattern?: Maybe<StringOperationFilterInput>;
  abbreviatedDayNames?: Maybe<ListStringOperationFilterInput>;
  shortestDayNames?: Maybe<ListStringOperationFilterInput>;
  dayNames?: Maybe<ListStringOperationFilterInput>;
  abbreviatedMonthNames?: Maybe<ListStringOperationFilterInput>;
  monthNames?: Maybe<ListStringOperationFilterInput>;
  isReadOnly?: Maybe<BooleanOperationFilterInput>;
  nativeCalendarName?: Maybe<StringOperationFilterInput>;
  abbreviatedMonthGenitiveNames?: Maybe<ListStringOperationFilterInput>;
  monthGenitiveNames?: Maybe<ListStringOperationFilterInput>;
};

export type CalendarFilterInput = {
  and?: Maybe<Array<CalendarFilterInput>>;
  or?: Maybe<Array<CalendarFilterInput>>;
  minSupportedDateTime?: Maybe<ComparableDateTimeOperationFilterInput>;
  maxSupportedDateTime?: Maybe<ComparableDateTimeOperationFilterInput>;
  algorithmType?: Maybe<CalendarAlgorithmTypeOperationFilterInput>;
  isReadOnly?: Maybe<BooleanOperationFilterInput>;
  eras?: Maybe<ListComparableInt32OperationFilterInput>;
  twoDigitYearMax?: Maybe<ComparableInt32OperationFilterInput>;
};

export type ListFilterInputTypeOfCalendarFilterInput = {
  all?: Maybe<CalendarFilterInput>;
  none?: Maybe<CalendarFilterInput>;
  some?: Maybe<CalendarFilterInput>;
  any?: Maybe<Scalars['Boolean']>;
};

export enum SortEnumType {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type CompareInfoSortInput = {
  name?: Maybe<SortEnumType>;
  version?: Maybe<SortVersionSortInput>;
  lCID?: Maybe<SortEnumType>;
};

export type TextInfoSortInput = {
  aNSICodePage?: Maybe<SortEnumType>;
  oEMCodePage?: Maybe<SortEnumType>;
  macCodePage?: Maybe<SortEnumType>;
  eBCDICCodePage?: Maybe<SortEnumType>;
  lCID?: Maybe<SortEnumType>;
  cultureName?: Maybe<SortEnumType>;
  isReadOnly?: Maybe<SortEnumType>;
  listSeparator?: Maybe<SortEnumType>;
  isRightToLeft?: Maybe<SortEnumType>;
};

export type NumberFormatInfoSortInput = {
  currencyDecimalDigits?: Maybe<SortEnumType>;
  currencyDecimalSeparator?: Maybe<SortEnumType>;
  isReadOnly?: Maybe<SortEnumType>;
  currencyGroupSeparator?: Maybe<SortEnumType>;
  currencySymbol?: Maybe<SortEnumType>;
  naNSymbol?: Maybe<SortEnumType>;
  currencyNegativePattern?: Maybe<SortEnumType>;
  numberNegativePattern?: Maybe<SortEnumType>;
  percentPositivePattern?: Maybe<SortEnumType>;
  percentNegativePattern?: Maybe<SortEnumType>;
  negativeInfinitySymbol?: Maybe<SortEnumType>;
  negativeSign?: Maybe<SortEnumType>;
  numberDecimalDigits?: Maybe<SortEnumType>;
  numberDecimalSeparator?: Maybe<SortEnumType>;
  numberGroupSeparator?: Maybe<SortEnumType>;
  currencyPositivePattern?: Maybe<SortEnumType>;
  positiveInfinitySymbol?: Maybe<SortEnumType>;
  positiveSign?: Maybe<SortEnumType>;
  percentDecimalDigits?: Maybe<SortEnumType>;
  percentDecimalSeparator?: Maybe<SortEnumType>;
  percentGroupSeparator?: Maybe<SortEnumType>;
  percentSymbol?: Maybe<SortEnumType>;
  perMilleSymbol?: Maybe<SortEnumType>;
  digitSubstitution?: Maybe<SortEnumType>;
};

export type DateTimeFormatInfoSortInput = {
  aMDesignator?: Maybe<SortEnumType>;
  calendar?: Maybe<CalendarSortInput>;
  dateSeparator?: Maybe<SortEnumType>;
  firstDayOfWeek?: Maybe<SortEnumType>;
  calendarWeekRule?: Maybe<SortEnumType>;
  fullDateTimePattern?: Maybe<SortEnumType>;
  longDatePattern?: Maybe<SortEnumType>;
  longTimePattern?: Maybe<SortEnumType>;
  monthDayPattern?: Maybe<SortEnumType>;
  pMDesignator?: Maybe<SortEnumType>;
  rFC1123Pattern?: Maybe<SortEnumType>;
  shortDatePattern?: Maybe<SortEnumType>;
  shortTimePattern?: Maybe<SortEnumType>;
  sortableDateTimePattern?: Maybe<SortEnumType>;
  timeSeparator?: Maybe<SortEnumType>;
  universalSortableDateTimePattern?: Maybe<SortEnumType>;
  yearMonthPattern?: Maybe<SortEnumType>;
  isReadOnly?: Maybe<SortEnumType>;
  nativeCalendarName?: Maybe<SortEnumType>;
};

export type CalendarSortInput = {
  minSupportedDateTime?: Maybe<SortEnumType>;
  maxSupportedDateTime?: Maybe<SortEnumType>;
  algorithmType?: Maybe<SortEnumType>;
  isReadOnly?: Maybe<SortEnumType>;
  twoDigitYearMax?: Maybe<SortEnumType>;
};

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** Indicates whether more edges exist following the set defined by the clients arguments. */
  hasNextPage: Scalars['Boolean'];
  /** Indicates whether more edges exist prior the set defined by the clients arguments. */
  hasPreviousPage: Scalars['Boolean'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
};

/** An edge in a connection. */
export type CulturesEdge = {
  __typename?: 'CulturesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<CultureInfo>;
};

export type StockOwnerLinkFilterInput = {
  and?: Maybe<Array<StockOwnerLinkFilterInput>>;
  or?: Maybe<Array<StockOwnerLinkFilterInput>>;
  parent?: Maybe<StockOwnerFilterInput>;
  child?: Maybe<StockOwnerFilterInput>;
};

export type ProductStatusFilterInput = {
  and?: Maybe<Array<ProductStatusFilterInput>>;
  or?: Maybe<Array<ProductStatusFilterInput>>;
  id?: Maybe<ComparableNullableOfInt32OperationFilterInput>;
  stockOwner?: Maybe<StockOwnerFilterInput>;
  code?: Maybe<StringOperationFilterInput>;
  description?: Maybe<StringOperationFilterInput>;
  adjustStock?: Maybe<BooleanOperationFilterInput>;
  processStatus?: Maybe<NullableOfProductProcessStatusOperationFilterInput>;
  targetStatuses?: Maybe<ListStringOperationFilterInput>;
};

export type CategoryDefinitionFilterInput = {
  and?: Maybe<Array<CategoryDefinitionFilterInput>>;
  or?: Maybe<Array<CategoryDefinitionFilterInput>>;
  id?: Maybe<ComparableNullableOfInt32OperationFilterInput>;
  stockOwner?: Maybe<StockOwnerFilterInput>;
  /** Code for the product category */
  code?: Maybe<StringOperationFilterInput>;
  /** Description for the category */
  description?: Maybe<StringOperationFilterInput>;
};

export type OrderStatusFilterInput = {
  and?: Maybe<Array<OrderStatusFilterInput>>;
  or?: Maybe<Array<OrderStatusFilterInput>>;
  id?: Maybe<ComparableNullableOfInt32OperationFilterInput>;
  stockOwner?: Maybe<StockOwnerFilterInput>;
  code?: Maybe<StringOperationFilterInput>;
  /** Description of the status */
  description?: Maybe<StringOperationFilterInput>;
  /** Purpose of the status */
  purpose?: Maybe<NullableOfOrderStatusPurposeOperationFilterInput>;
};

export type PickMethodFilterInput = {
  and?: Maybe<Array<PickMethodFilterInput>>;
  or?: Maybe<Array<PickMethodFilterInput>>;
  id?: Maybe<ComparableNullableOfInt32OperationFilterInput>;
  stockOwner?: Maybe<StockOwnerFilterInput>;
  /** Name of the pick method definition */
  name?: Maybe<StringOperationFilterInput>;
  /** Should this definition be used by default */
  default?: Maybe<BooleanOperationFilterInput>;
  /** Pre pick creation method to be executed */
  prePickMethod?: Maybe<StringOperationFilterInput>;
  /** pick creation method to be executed */
  pickingMethod?: Maybe<StringOperationFilterInput>;
  /** post pick creation method to be executed */
  postPickMethod?: Maybe<StringOperationFilterInput>;
  /** output method to be executed */
  outputMethod?: Maybe<StringOperationFilterInput>;
};

export type PickConfirmMethodFilterInput = {
  and?: Maybe<Array<PickConfirmMethodFilterInput>>;
  or?: Maybe<Array<PickConfirmMethodFilterInput>>;
  id?: Maybe<ComparableNullableOfInt32OperationFilterInput>;
  stockOwner?: Maybe<StockOwnerFilterInput>;
  /** Name of the pick confirm definition */
  name?: Maybe<StringOperationFilterInput>;
  /** Should the definition used by default */
  default?: Maybe<BooleanOperationFilterInput>;
  /** pick confirm method to be executed */
  pickConfMethod?: Maybe<StringOperationFilterInput>;
  /** post confirm method to be executed */
  postConfMethod?: Maybe<StringOperationFilterInput>;
  /** Packing method to be executed */
  packingMethod?: Maybe<StringOperationFilterInput>;
  /** Despatch method to be executed */
  despatchMethod?: Maybe<StringOperationFilterInput>;
  /** Load close method to be executed */
  loadCloseMethod?: Maybe<StringOperationFilterInput>;
};

export type ListFilterInputTypeOfStorageTypeMheFilterInput = {
  all?: Maybe<StorageTypeMheFilterInput>;
  none?: Maybe<StorageTypeMheFilterInput>;
  some?: Maybe<StorageTypeMheFilterInput>;
  any?: Maybe<Scalars['Boolean']>;
};

export type SortVersionFilterInput = {
  and?: Maybe<Array<SortVersionFilterInput>>;
  or?: Maybe<Array<SortVersionFilterInput>>;
  fullVersion?: Maybe<ComparableInt32OperationFilterInput>;
  sortId?: Maybe<ComparableGuidOperationFilterInput>;
};

export type ListComparableInt32OperationFilterInput = {
  all?: Maybe<ComparableInt32OperationFilterInput>;
  none?: Maybe<ComparableInt32OperationFilterInput>;
  some?: Maybe<ComparableInt32OperationFilterInput>;
  any?: Maybe<Scalars['Boolean']>;
};

export type DigitShapesOperationFilterInput = {
  eq?: Maybe<DigitShapes>;
  neq?: Maybe<DigitShapes>;
  in?: Maybe<Array<DigitShapes>>;
  nin?: Maybe<Array<DigitShapes>>;
};

export type DayOfWeekOperationFilterInput = {
  eq?: Maybe<DayOfWeek>;
  neq?: Maybe<DayOfWeek>;
  in?: Maybe<Array<DayOfWeek>>;
  nin?: Maybe<Array<DayOfWeek>>;
};

export type CalendarWeekRuleOperationFilterInput = {
  eq?: Maybe<CalendarWeekRule>;
  neq?: Maybe<CalendarWeekRule>;
  in?: Maybe<Array<CalendarWeekRule>>;
  nin?: Maybe<Array<CalendarWeekRule>>;
};

export type CalendarAlgorithmTypeOperationFilterInput = {
  eq?: Maybe<CalendarAlgorithmType>;
  neq?: Maybe<CalendarAlgorithmType>;
  in?: Maybe<Array<CalendarAlgorithmType>>;
  nin?: Maybe<Array<CalendarAlgorithmType>>;
};

export type SortVersionSortInput = {
  fullVersion?: Maybe<SortEnumType>;
  sortId?: Maybe<SortEnumType>;
};

export type NullableOfProductProcessStatusOperationFilterInput = {
  eq?: Maybe<ProductProcessStatus>;
  neq?: Maybe<ProductProcessStatus>;
  in?: Maybe<Array<Maybe<ProductProcessStatus>>>;
  nin?: Maybe<Array<Maybe<ProductProcessStatus>>>;
};

export type NullableOfOrderStatusPurposeOperationFilterInput = {
  eq?: Maybe<OrderStatusPurpose>;
  neq?: Maybe<OrderStatusPurpose>;
  in?: Maybe<Array<Maybe<OrderStatusPurpose>>>;
  nin?: Maybe<Array<Maybe<OrderStatusPurpose>>>;
};

export type StorageTypeMheFilterInput = {
  and?: Maybe<Array<StorageTypeMheFilterInput>>;
  or?: Maybe<Array<StorageTypeMheFilterInput>>;
  storageType?: Maybe<StorageTypeFilterInput>;
  MHEId?: Maybe<ComparableNullableOfInt32OperationFilterInput>;
  materialHandlingEquipment?: Maybe<MaterialHandlingEquipmentFilterInput>;
};

export type ComparableGuidOperationFilterInput = {
  eq?: Maybe<Scalars['UUID']>;
  neq?: Maybe<Scalars['UUID']>;
  in?: Maybe<Array<Scalars['UUID']>>;
  nin?: Maybe<Array<Scalars['UUID']>>;
  gt?: Maybe<Scalars['UUID']>;
  ngt?: Maybe<Scalars['UUID']>;
  gte?: Maybe<Scalars['UUID']>;
  ngte?: Maybe<Scalars['UUID']>;
  lt?: Maybe<Scalars['UUID']>;
  nlt?: Maybe<Scalars['UUID']>;
  lte?: Maybe<Scalars['UUID']>;
  nlte?: Maybe<Scalars['UUID']>;
};

export type MaterialHandlingEquipmentFilterInput = {
  and?: Maybe<Array<MaterialHandlingEquipmentFilterInput>>;
  or?: Maybe<Array<MaterialHandlingEquipmentFilterInput>>;
  id?: Maybe<ComparableNullableOfInt32OperationFilterInput>;
  code?: Maybe<StringOperationFilterInput>;
  description?: Maybe<StringOperationFilterInput>;
  /** Maximum weight this MHE can handle */
  maximumWeight?: Maybe<ComparableNullableOfDecimalOperationFilterInput>;
  /** Nominal width of MHE. */
  width?: Maybe<ComparableNullableOfDecimalOperationFilterInput>;
  /** Maximum location elevation accessible from this MHE. */
  heightLimit?: Maybe<ComparableNullableOfDecimalOperationFilterInput>;
  /** The class of MHE. This determines available processes. */
  class?: Maybe<NullableOfMheClassOperationFilterInput>;
};

export type NullableOfMheClassOperationFilterInput = {
  eq?: Maybe<MheClass>;
  neq?: Maybe<MheClass>;
  in?: Maybe<Array<Maybe<MheClass>>>;
  nin?: Maybe<Array<Maybe<MheClass>>>;
};

export type Subscription = {
  __typename?: 'Subscription';
  serverTime: Scalars['DateTime'];
  serverTimeAuth: Scalars['DateTime'];
  onServerTimeEvent: Scalars['DateTime'];
};

export type Warehouse = {
  __typename?: 'Warehouse';
  id?: Maybe<Scalars['Int']>;
  code: Scalars['String'];
  companyName?: Maybe<Scalars['String']>;
  warehouseName: Scalars['String'];
  address: Address;
  telephone?: Maybe<Scalars['String']>;
  VATNumber?: Maybe<Scalars['String']>;
  customsId?: Maybe<Scalars['String']>;
};

export type Supplier = {
  __typename?: 'Supplier';
  id?: Maybe<Scalars['Int']>;
  /** Internal code of the supplier */
  code: Scalars['String'];
  /** Master supplier */
  master?: Maybe<Scalars['String']>;
  /** Name of the supplier */
  name: Scalars['String'];
  /** The main address of the supplier */
  address: Address;
  /** Currency used by the supplier */
  currency?: Maybe<Currency>;
  /**
   * File Transmission Method.
   * Default value of None.
   */
  fileTransMeth?: Maybe<FileTransmission>;
  /** File Format */
  fileFormat?: Maybe<FileFormat>;
  /** Must order in layer quantities */
  mustOrderLayerQty?: Maybe<Scalars['Boolean']>;
  /** Maximum weekly spend */
  maxWeekSpend?: Maybe<Scalars['Decimal']>;
  /** Lead Time in Days */
  leadTime?: Maybe<Scalars['Int']>;
  orderDays?: Maybe<Array<DayOfWeek>>;
};

export type PoInstruction = {
  __typename?: 'POInstruction';
  id?: Maybe<Scalars['Int']>;
  type: PoInstructionType;
  message: Scalars['String'];
};

export enum PurchaseOrderState {
  Open = 'OPEN',
  Held = 'HELD',
  Completed = 'COMPLETED',
  Cancelled = 'CANCELLED',
  Exported = 'EXPORTED'
}

export enum Currency {
  Gbp = 'GBP',
  Eur = 'EUR',
  Usd = 'USD',
  Can = 'CAN',
  Jpy = 'JPY',
  Trl = 'TRL',
  Aud = 'AUD',
  Zmw = 'ZMW',
  Ugx = 'UGX',
  Rub = 'RUB',
  Afn = 'AFN',
  All = 'ALL',
  Dzd = 'DZD',
  Aoa = 'AOA',
  Xcd = 'XCD',
  Ars = 'ARS',
  Amd = 'AMD'
}


export type PurchaseOrderHeader = {
  __typename?: 'PurchaseOrderHeader';
  stockOwnerId?: Maybe<Scalars['Int']>;
  warehouseId?: Maybe<Scalars['Int']>;
  referenceNumber: Scalars['String'];
  custReferences?: Maybe<Array<Maybe<Scalars['String']>>>;
  status?: Maybe<PurchaseOrderState>;
  type?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['Int']>;
  supplierId?: Maybe<Scalars['Int']>;
  supplier?: Maybe<Supplier>;
  currency?: Maybe<Currency>;
  totalValue?: Maybe<Scalars['Decimal']>;
  enteredBy?: Maybe<Scalars['String']>;
  entered?: Maybe<Scalars['DateTime']>;
  after?: Maybe<Scalars['DateTime']>;
  before?: Maybe<Scalars['DateTime']>;
  budgetHolder?: Maybe<Scalars['String']>;
  containerNo?: Maybe<Scalars['String']>;
  billOfLading?: Maybe<Scalars['String']>;
  crossDock?: Maybe<Scalars['Boolean']>;
  message?: Maybe<Scalars['String']>;
  parent?: Maybe<Scalars['String']>;
  carrier?: Maybe<Scalars['String']>;
  carrierService?: Maybe<Scalars['String']>;
  exportBatch?: Maybe<Scalars['String']>;
};

export enum GoodsReceiptState {
  Open = 'OPEN',
  Held = 'HELD',
  Started = 'STARTED',
  AwaitingVerification = 'AWAITING_VERIFICATION',
  Closed = 'CLOSED',
  Exported = 'EXPORTED',
  Cancelled = 'CANCELLED'
}

export type GoodsReceipt_ExtraData = {
  __typename?: 'GoodsReceipt_ExtraData';
  type?: Maybe<Scalars['String']>;
  containerNo?: Maybe<Scalars['String']>;
  containerType?: Maybe<Scalars['String']>;
  condition?: Maybe<Scalars['String']>;
  sealNo?: Maybe<Scalars['String']>;
  carrier?: Maybe<Scalars['String']>;
  freightCost?: Maybe<Scalars['Decimal']>;
  vehicle?: Maybe<Scalars['String']>;
  trailer?: Maybe<Scalars['String']>;
  driver?: Maybe<Scalars['String']>;
  alternativeRef?: Maybe<Scalars['String']>;
  notes?: Maybe<Array<Maybe<Scalars['String']>>>;
  expected?: Maybe<Scalars['DateTime']>;
  unLoadingTime?: Maybe<Scalars['TimeSpan']>;
  unLoaders?: Maybe<Scalars['Int']>;
  assignedDock?: Maybe<Scalars['String']>;
};

export type LicencePlate = {
  __typename?: 'LicencePlate';
  id?: Maybe<Scalars['Int']>;
  LPN: Scalars['String'];
  lPTypeId?: Maybe<Scalars['Int']>;
  LPType?: Maybe<LicencePlateType>;
  locationId?: Maybe<Scalars['Int']>;
  location?: Maybe<Location>;
  outerId?: Maybe<Scalars['Int']>;
  outer?: Maybe<LicencePlate>;
  inners?: Maybe<Array<Maybe<LicencePlate>>>;
  owner?: Maybe<LpOwner>;
};

export type GoodsReceiptHeader = {
  __typename?: 'GoodsReceiptHeader';
  id?: Maybe<Scalars['Int']>;
  goodsReceiptNumber: Scalars['String'];
  warehouseId?: Maybe<Scalars['Int']>;
  warehouse?: Maybe<Warehouse>;
  stockOwnerId?: Maybe<Scalars['Int']>;
  stockOwner?: Maybe<StockOwner>;
  status?: Maybe<GoodsReceiptState>;
  isUnbooked?: Maybe<Scalars['Boolean']>;
  dateCreated?: Maybe<Scalars['DateTime']>;
  dateReceived?: Maybe<Scalars['DateTime']>;
  customerRef?: Maybe<Scalars['String']>;
  invoiceRef?: Maybe<Scalars['String']>;
  createdBy?: Maybe<Scalars['String']>;
  extra?: Maybe<GoodsReceipt_ExtraData>;
};

export type Location = {
  __typename?: 'Location';
  id?: Maybe<Scalars['Int']>;
  warehouse?: Maybe<Warehouse>;
  code: Scalars['String'];
  /** The physical characteristics of the location such as whether it is drive-in or conventional racking */
  physicalCharacteristics: LocationPhysicalType;
  /** The process characteristics of the location such as whether it is uses a a picking face or despatch area */
  processCharacteristics: LocationProcessType;
  /** The storage temperature type of the location. e.g. Ambient, chilled or frozen */
  temperatureType: LocationTemperatureType;
  /** Additional location specific attributes (yet to be defined) */
  attributes?: Maybe<Scalars['String']>;
  storageTypeId: Scalars['Int'];
  storageType?: Maybe<StorageType>;
  aisle?: Maybe<Scalars['String']>;
  status: LocationStatus;
  checkCode?: Maybe<Scalars['String']>;
  beam?: Maybe<Scalars['String']>;
  beamSequence?: Maybe<Scalars['String']>;
  zone: Scalars['String'];
  countZone?: Maybe<Scalars['String']>;
  tier: Scalars['Int'];
  elevation: Scalars['Decimal'];
  dimensions: Dimension;
  maxWeight: Scalars['Decimal'];
  pickZone?: Maybe<Scalars['String']>;
  reservedProductId?: Maybe<Scalars['Int']>;
};

export type OrderStatus = {
  __typename?: 'OrderStatus';
  id?: Maybe<Scalars['Int']>;
  stockOwner?: Maybe<StockOwner>;
  code: Scalars['String'];
  /** Description of the status */
  description: Scalars['String'];
  /** Purpose of the status */
  purpose: OrderStatusPurpose;
};

export type ProductStatus = {
  __typename?: 'ProductStatus';
  id?: Maybe<Scalars['Int']>;
  stockOwner?: Maybe<StockOwner>;
  code: Scalars['String'];
  description: Scalars['String'];
  adjustStock: Scalars['Boolean'];
  processStatus: ProductProcessStatus;
  targetStatuses?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type CategoryDefinition = {
  __typename?: 'CategoryDefinition';
  id?: Maybe<Scalars['Int']>;
  stockOwner?: Maybe<StockOwner>;
  /** Code for the product category */
  code: Scalars['String'];
  /** Description for the category */
  description?: Maybe<Scalars['String']>;
};

export type PickMethod = {
  __typename?: 'PickMethod';
  id?: Maybe<Scalars['Int']>;
  stockOwner?: Maybe<StockOwner>;
  /** Name of the pick method definition */
  name: Scalars['String'];
  /** Should this definition be used by default */
  default?: Maybe<Scalars['Boolean']>;
  /** Pre pick creation method to be executed */
  prePickMethod?: Maybe<Scalars['String']>;
  /** pick creation method to be executed */
  pickingMethod?: Maybe<Scalars['String']>;
  /** post pick creation method to be executed */
  postPickMethod?: Maybe<Scalars['String']>;
  /** output method to be executed */
  outputMethod?: Maybe<Scalars['String']>;
};

export type PickConfirmMethod = {
  __typename?: 'PickConfirmMethod';
  id?: Maybe<Scalars['Int']>;
  stockOwner?: Maybe<StockOwner>;
  /** Name of the pick confirm definition */
  name: Scalars['String'];
  /** Should the definition used by default */
  default?: Maybe<Scalars['Boolean']>;
  /** pick confirm method to be executed */
  pickConfMethod?: Maybe<Scalars['String']>;
  /** post confirm method to be executed */
  postConfMethod?: Maybe<Scalars['String']>;
  /** Packing method to be executed */
  packingMethod?: Maybe<Scalars['String']>;
  /** Despatch method to be executed */
  despatchMethod?: Maybe<Scalars['String']>;
  /** Load close method to be executed */
  loadCloseMethod?: Maybe<Scalars['String']>;
};

export enum State {
  Open = 'OPEN',
  Closed = 'CLOSED',
  OpeningSoon = 'OPENING_SOON',
  ClosingSoon = 'CLOSING_SOON'
}

export type StockOwnerLink = {
  __typename?: 'StockOwnerLink';
  parent?: Maybe<StockOwner>;
  child?: Maybe<StockOwner>;
};

export type Contact = {
  __typename?: 'Contact';
  name?: Maybe<Scalars['String']>;
  telephone?: Maybe<Scalars['String']>;
  fax?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
};

export type Address = {
  __typename?: 'Address';
  /** Property or business name */
  name?: Maybe<Scalars['String']>;
  /** Street address including house number and road */
  street1: Scalars['String'];
  /** Optional additional street name when Street1 is used for an apartment or block */
  street2?: Maybe<Scalars['String']>;
  /** City, Town or Village */
  city?: Maybe<Scalars['String']>;
  /** County or State */
  county?: Maybe<Scalars['String']>;
  /** Postal or Zip code */
  postCode?: Maybe<Scalars['String']>;
  /** Postal Country */
  country?: Maybe<Scalars['String']>;
};

export enum PickAssignment {
  /** Any pick for this StockOwner that has not yet been started will be offered */
  AnyAvailable = 'ANY_AVAILABLE',
  /** No picks for this StockOwner will be offered */
  NotAvailable = 'NOT_AVAILABLE',
  /** Only picks for this StockOwner that are assigned to the current user will be offered */
  AssignedOnly = 'ASSIGNED_ONLY'
}

export enum LoadOrder {
  /** Any containers for this StockOwner will loaded in delivery order */
  Delivery = 'DELIVERY',
  /** containers on Loads for this StockOwner can be loaded in any order */
  None = 'NONE',
  /** Any container for this StockOwner will be loaded in reverse delivery order */
  Reverse = 'REVERSE'
}

export enum Accessiblity {
  Deny = 'DENY',
  Allow = 'ALLOW',
  Warn = 'WARN'
}

export enum FieldVisibility {
  Undefined = 'UNDEFINED',
  NotRequired = 'NOT_REQUIRED',
  Required = 'REQUIRED',
  Optional = 'OPTIONAL',
  ReadOnly = 'READ_ONLY'
}

export type UdCode = {
  __typename?: 'UDCode';
  id?: Maybe<Scalars['Int']>;
  codeType?: Maybe<Scalars['String']>;
  code: Scalars['String'];
  description: Scalars['String'];
  longDescription?: Maybe<Scalars['String']>;
  stockOwnerId?: Maybe<Scalars['Int']>;
  stockOwner?: Maybe<StockOwner>;
};

export type ProductCategory = {
  __typename?: 'ProductCategory';
  id?: Maybe<Scalars['Int']>;
  product?: Maybe<Product>;
  /** Name of product product category */
  category: Scalars['String'];
  /** Value of the product product for this product. */
  attribute: Scalars['String'];
};

export type BomDefinition = {
  __typename?: 'BOMDefinition';
  id?: Maybe<Scalars['Int']>;
  /** Top level (Parent) SKU */
  parent?: Maybe<Product>;
  /** Id of the component product */
  childId: Scalars['Int'];
  /** Component that forms part of the parent SKU */
  child?: Maybe<Product>;
  /** Quantity of component that forms part of the parent SKU */
  qty: Scalars['Int'];
};

/**
 * Table containing a list of licence plate definition for the products
 * configured
 */
export type LpDefinition = {
  __typename?: 'LPDefinition';
  id?: Maybe<Scalars['Int']>;
  product?: Maybe<Product>;
  /** Handling type for licence plate */
  handType: Scalars['String'];
  /** Pack type for licence plate */
  packType?: Maybe<Scalars['String']>;
  /** Quantity for licence plate */
  quantity: Scalars['Int'];
  /** Name of document containing stack diagram */
  diagram?: Maybe<Scalars['String']>;
  /** Height of the unit associated with this licence plate */
  height?: Maybe<Scalars['Decimal']>;
  /** Width of the unit associated with this licence plate */
  width?: Maybe<Scalars['Decimal']>;
  /** Depth of the unit associated with this licence plate */
  depth?: Maybe<Scalars['Decimal']>;
  /** Weight of the unit associated with this licence plate */
  weight?: Maybe<Scalars['Decimal']>;
  /** Layer quantity */
  layerQty?: Maybe<Scalars['Int']>;
  /** Max layer Quantity */
  maxLayerQty?: Maybe<Scalars['Int']>;
};

export type ProductBarcode = {
  __typename?: 'ProductBarcode';
  id?: Maybe<Scalars['Int']>;
  product?: Maybe<Product>;
  /** Code for the barcode */
  barcode: Scalars['String'];
  /** Symbology of the barcode */
  symbology?: Maybe<Scalars['String']>;
  /** The quantity that the barcode represents */
  factor: Scalars['Int'];
  /** the type of unit that this barcode represents */
  unitType?: Maybe<Scalars['String']>;
};

export type ProductDocument = {
  __typename?: 'ProductDocument';
  id?: Maybe<Scalars['Int']>;
  /** Product associated with this document */
  product?: Maybe<Product>;
  /** Name of the document */
  name: Scalars['String'];
  /** Type of the document */
  type?: Maybe<Scalars['String']>;
  /** Usage of the document */
  usage?: Maybe<Scalars['String']>;
  /**
   * Date and time the document was uploaded(/changed?)
   * Set by the server
   */
  uploaded?: Maybe<Scalars['DateTime']>;
  /** User who uplaoded the document */
  uploadBy?: Maybe<Scalars['String']>;
};

export type ProductRequiredData = {
  __typename?: 'ProductRequiredData';
  /** Capture Expiry date */
  expiry?: Maybe<FieldVisibility>;
  /** Capture Best before data */
  bestBefore?: Maybe<FieldVisibility>;
  /** Capture Batch */
  batch?: Maybe<FieldVisibility>;
  /** Capture Product status */
  status?: Maybe<FieldVisibility>;
  /** Capture Pack Type */
  packType?: Maybe<FieldVisibility>;
  /** Capture Handling Type */
  handlingType?: Maybe<FieldVisibility>;
  /** Capture Serial Number (Singular) */
  serial?: Maybe<FieldVisibility>;
  /** Capture Carton licence plate */
  cartonLP?: Maybe<FieldVisibility>;
  /** Capture Pallet licence plate */
  palletLP?: Maybe<FieldVisibility>;
  /** Capture Temperature on arrival */
  arrivalTemp?: Maybe<FieldVisibility>;
  /** Capture Country of origin */
  originCntry?: Maybe<FieldVisibility>;
  /** Capture Additional Batch Information */
  batchInfo?: Maybe<FieldVisibility>;
  /** Capture Production date */
  productionDte?: Maybe<FieldVisibility>;
  /** Capture Kill date */
  killDte?: Maybe<FieldVisibility>;
  /** Capture Slaughter code */
  slaughterCode?: Maybe<FieldVisibility>;
  /** Capture Budgetholder */
  budgetHolder?: Maybe<FieldVisibility>;
  /** Collect serial numbers (Plural) */
  serials?: Maybe<FieldVisibility>;
  /** Collect Weight */
  weight?: Maybe<CollectWeight>;
};

export enum BomType {
  /** Standard product */
  Sku = 'SKU',
  /** BOMs that are composed at the point of despatch */
  NonStock = 'NON_STOCK',
  /** BOMs that are stocked in the warehouse */
  Stock = 'STOCK'
}

export enum RotationRule {
  /** Oldest stock will be used first */
  Fifo = 'FIFO',
  /** Stock that expires sooner with be used first */
  Fefo = 'FEFO',
  /** Newest stock will be used first */
  Lifo = 'LIFO',
  /** No rotation rule */
  None = 'NONE'
}

export type ProductPickface = {
  __typename?: 'ProductPickface';
  id?: Maybe<Scalars['Int']>;
  /** Product related to this pick face definition */
  product?: Maybe<Product>;
  /** Warehouse where the pickface is located */
  warehouse: Scalars['String'];
  /** Budget holder of the pickface */
  budhol?: Maybe<Scalars['String']>;
  /** Location name of the pickface */
  location?: Maybe<Scalars['String']>;
  /** Pickzone of the pickface */
  pickZone?: Maybe<Scalars['String']>;
  /** Maximum quantity allowed in the pickface */
  maxFaceQty?: Maybe<Scalars['Int']>;
  /** minimum quantity in the pickface before a replen is considered */
  replenTriggr?: Maybe<Scalars['Int']>;
  /** Replenishment multiple - replenishments will be in multiples of the quantity specified */
  replenMulti?: Maybe<Scalars['Int']>;
};

export type IwmsAttributes = {
  id?: Maybe<Scalars['Int']>;
};

export enum ProcessorArchitecture {
  None = 'NONE',
  Msil = 'MSIL',
  X86 = 'X86',
  Ia64 = 'IA64',
  Amd64 = 'AMD64',
  Arm = 'ARM'
}


export type GridResult = {
  __typename?: 'GridResult';
  resourceSet?: Maybe<Scalars['String']>;
  locales?: Maybe<Array<Maybe<Scalars['String']>>>;
  resources?: Maybe<Array<Maybe<ResourceItem>>>;
};

export type ResourceItemEx = {
  __typename?: 'ResourceItemEx';
  isRtl: Scalars['Boolean'];
  resourceList?: Maybe<Array<Maybe<ResourceString>>>;
  resourceId?: Maybe<Scalars['String']>;
  comment?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  localeId?: Maybe<Scalars['String']>;
  valueType: Scalars['Int'];
  updated: Scalars['DateTime'];
  resourceSet?: Maybe<Scalars['String']>;
  textFile?: Maybe<Scalars['String']>;
  binFile?: Maybe<Array<Scalars['Byte']>>;
  fileName?: Maybe<Scalars['String']>;
};

export type ResourceItemInput = {
  resourceId?: Maybe<Scalars['String']>;
  comment?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  localeId?: Maybe<Scalars['String']>;
  valueType: Scalars['Int'];
  updated: Scalars['DateTime'];
  resourceSet?: Maybe<Scalars['String']>;
  textFile?: Maybe<Scalars['String']>;
  binFile?: Maybe<Array<Scalars['Byte']>>;
  fileName?: Maybe<Scalars['String']>;
};

export type TestLanguageStatistics = {
  __typename?: 'TestLanguageStatistics';
  resourceSets?: Maybe<Array<Maybe<Scalars['String']>>>;
  testLocaleId?: Maybe<Scalars['String']>;
  resourceCount: Scalars['Int'];
  generationTime: Scalars['TimeSpan'];
};

export enum Permission {
  /** User is allowed to create or edit orders */
  CreateOrder = 'CREATE_ORDER',
  /** User is allowed to cancel and delete orders */
  DeleteOrder = 'DELETE_ORDER',
  /** User can authorise actions that require supervisor override */
  IsSupervisor = 'IS_SUPERVISOR'
}

export type FieldError = {
  __typename?: 'FieldError';
  fieldName?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  severity: Severity;
};

export enum LocationPhysicalType {
  /** The location is general purpose and no specific mechanical properties */
  General = 'GENERAL',
  /** The location is a gravity location. LPs are added at the back and removed from the front. Access to rear LPs is only possible by removing front LP. */
  Gravity = 'GRAVITY',
  /** The location is a drive-in location. It will be multiple LPs high and multiple LPs deep. There are special rules governing occupancy. */
  DriveIn = 'DRIVE_IN',
  /** The location is a robotic racking location. LPs are moved around in the rack by robotic shuttles. There may be special rules regarding adding or removing LPs from this type of racking.  */
  Robotic = 'ROBOTIC',
  /** The location is a cantilever racking location. There are no vertical dividers and width constraint rules are different. */
  Cantilever = 'CANTILEVER',
  /** The location can take 2 LPs front-back. Long reach FLTs are needed to access rear LP. */
  DoubleDeep = 'DOUBLE_DEEP',
  /** The location is a marked area of the floor. Elevation and Tier will always be zero. LPs may be stacked on top of each other. */
  BlockStack = 'BLOCK_STACK',
  /** Automated piece picking machine */
  AFrame = 'A_FRAME',
  /** The location is a Pick & Deposit station for narrow aisle operations */
  PandDStation = 'PAND_D_STATION',
  /** The location is a push-back location. LPs are added and removed from the front. Access to rear LPs is only possible by removing front LP. */
  PushBack = 'PUSH_BACK'
}

export enum LocationProcessType {
  /** The location is general purpose and can be used for warehouse stock */
  General = 'GENERAL',
  /** The location is for pallets being received into the warehouse. Stock in this location is not eligible for picking */
  GoodsReceipt = 'GOODS_RECEIPT',
  /** The location is for components for a production process. Stock in this location is not eligible for picking */
  Production = 'PRODUCTION',
  /** The location is for licence plates awaiting despatch.  Stock in this location has already been picked */
  DespatchLane = 'DESPATCH_LANE',
  /** The location is a picking face. The picking process will normally consume stock from this type of location. */
  PickFace = 'PICK_FACE',
  /** The location is a potential picking face.  */
  PotentialPickFace = 'POTENTIAL_PICK_FACE',
  /** The location is a packing bench or station. Stock may be moved here as part of a 2 stage pick &amp; pack process */
  PackingStation = 'PACKING_STATION',
  /** The location is being used a reservation location for a particular product. */
  ReservedForProduct = 'RESERVED_FOR_PRODUCT',
  /** The location is being used for ring fenced stock. Stock in this location is not eligible for picking. */
  RingFenced = 'RING_FENCED'
}

export enum LocationTemperatureType {
  /** The location has no temperature management. */
  NonControlled = 'NON_CONTROLLED',
  /** The location is nominally intended for stock that should be stored at room temperature 9 - 25 Celsius. Temperature checks may be applied. */
  Ambient = 'AMBIENT',
  /** The location is kept between 0 and 8 Celsius and is intended for stock that must be refrigerated. Temperature checks may be applied. */
  Chilled = 'CHILLED',
  /** The location is kept between -1 and -50 Celsius (usually &lt; -20) and is intended for stock that must be kept frozen. Temperature checks may be applied. */
  Frozen = 'FROZEN'
}

export enum LocationStatus {
  /** Location is available for use */
  Available = 'AVAILABLE',
  /** Location is damaged and cannot be used */
  Damaged = 'DAMAGED',
  /** Location is being constructed */
  UnderConstruction = 'UNDER_CONSTRUCTION',
  /** Location is currently not available for use */
  Unavailable = 'UNAVAILABLE'
}

export enum CultureTypes {
  NeutralCultures = 'NEUTRAL_CULTURES',
  SpecificCultures = 'SPECIFIC_CULTURES',
  InstalledWin32Cultures = 'INSTALLED_WIN32_CULTURES',
  AllCultures = 'ALL_CULTURES',
  UserCustomCulture = 'USER_CUSTOM_CULTURE',
  ReplacementCultures = 'REPLACEMENT_CULTURES',
  WindowsOnlyCultures = 'WINDOWS_ONLY_CULTURES',
  FrameworkCultures = 'FRAMEWORK_CULTURES'
}

export enum DigitShapes {
  Context = 'CONTEXT',
  None = 'NONE',
  NativeNational = 'NATIVE_NATIONAL'
}

export enum DayOfWeek {
  Sunday = 'SUNDAY',
  Monday = 'MONDAY',
  Tuesday = 'TUESDAY',
  Wednesday = 'WEDNESDAY',
  Thursday = 'THURSDAY',
  Friday = 'FRIDAY',
  Saturday = 'SATURDAY'
}

export enum CalendarWeekRule {
  FirstDay = 'FIRST_DAY',
  FirstFullWeek = 'FIRST_FULL_WEEK',
  FirstFourDayWeek = 'FIRST_FOUR_DAY_WEEK'
}

export enum CalendarAlgorithmType {
  Unknown = 'UNKNOWN',
  SolarCalendar = 'SOLAR_CALENDAR',
  LunarCalendar = 'LUNAR_CALENDAR',
  LunisolarCalendar = 'LUNISOLAR_CALENDAR'
}

export enum ProductProcessStatus {
  /** The stock is Good and can be put on pick */
  GoodStock = 'GOOD_STOCK',
  /** Quality Control - The stock is awaiting quality control checks */
  Qc = 'QC',
  /** The stock is quarantined because of some issue. This stock should not be picked */
  Quarantined = 'QUARANTINED',
  /** This stock could not be picked - e.g. short */
  PickFailed = 'PICK_FAILED',
  /** This stock is damaged. This stock should not be picked */
  Damaged = 'DAMAGED',
  /** This stock has exceeded the expiry date / shelf-life limits. */
  Expired = 'EXPIRED',
  /** This stock status is defined by the stock owner. Stock may be picked but only if specifically requested. */
  UserDefined = 'USER_DEFINED'
}

export enum OrderStatusPurpose {
  Unknown = 'UNKNOWN',
  Interfacing = 'INTERFACING',
  Editing = 'EDITING',
  Locked = 'LOCKED',
  AwaitingApproval = 'AWAITING_APPROVAL',
  Open = 'OPEN',
  OnPick = 'ON_PICK',
  PickStarted = 'PICK_STARTED',
  Picked = 'PICKED',
  PackInProgress = 'PACK_IN_PROGRESS',
  PackComplete = 'PACK_COMPLETE',
  AwaitingDespatch = 'AWAITING_DESPATCH',
  AwaitingInspection = 'AWAITING_INSPECTION',
  AwaitingDocumentation = 'AWAITING_DOCUMENTATION',
  LoadStarted = 'LOAD_STARTED',
  Loaded = 'LOADED',
  Despatched = 'DESPATCHED',
  Exported = 'EXPORTED'
}


export enum MheClass {
  None = 'NONE',
  Manual = 'MANUAL',
  VnaV = 'VNA_V',
  VnaK = 'VNA_K',
  Reach = 'REACH',
  Pallet = 'PALLET',
  ManUp = 'MAN_UP',
  HighLift = 'HIGH_LIFT',
  Stacker = 'STACKER',
  DrumLoader = 'DRUM_LOADER'
}

export type StorageTypeSortInput = {
  id?: Maybe<SortEnumType>;
  code?: Maybe<SortEnumType>;
  description?: Maybe<SortEnumType>;
};

/** A connection to a list of items. */
export type StorageTypesConnection = {
  __typename?: 'StorageTypesConnection';
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A list of edges. */
  edges?: Maybe<Array<StorageTypesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<StorageType>>>;
  totalCount: Scalars['Int'];
};

export type StorageTypeUpdateInput = {
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
};

export type StockOwnerSortInput = {
  id?: Maybe<SortEnumType>;
  /** The unique code for this stock owner */
  code?: Maybe<SortEnumType>;
  /** The name of the stock owner */
  name?: Maybe<SortEnumType>;
  /** The status of the StockOwner. See  for possible values. */
  status?: Maybe<SortEnumType>;
  /** Contact for the stock owner */
  contact?: Maybe<ContactSortInput>;
  /** Address of the stock owner */
  address?: Maybe<AddressSortInput>;
  /** Cold storage ID associated with the stock owner */
  coldStoreID?: Maybe<SortEnumType>;
  /** GLN (Global Location Number) for the stock owner */
  GLN?: Maybe<SortEnumType>;
  /** VAT Number for the stock Owner */
  VATNumber?: Maybe<SortEnumType>;
  /**
   * Warn when moving stock to a location that contains
   * a different status
   */
  warnMoveDifStatus?: Maybe<SortEnumType>;
  /** Require budget holder */
  requireBudhol?: Maybe<SortEnumType>;
  /** Require Product categories */
  requireProdCategories?: Maybe<SortEnumType>;
  /** Mask for barcodes that are scanned */
  scanBarcodeMask?: Maybe<SortEnumType>;
  /** Mask for barcodes that are keyed in */
  keyedBarcodeMask?: Maybe<SortEnumType>;
  /** Capture serials on receipt */
  captureSerialsOnRcpt?: Maybe<SortEnumType>;
  /** Require pallet ID to be entered */
  requirePalletID?: Maybe<SortEnumType>;
  /** Print pallet labels On Receipt */
  printPalLblsOnRcpt?: Maybe<SortEnumType>;
  /** Capture PO number on receipt */
  capturePONumOnRcpt?: Maybe<SortEnumType>;
  /** Allocation locations to pallet received */
  allocateLocOnRcpt?: Maybe<SortEnumType>;
  /** Close PO when the Goods receipt has been completed */
  closeComPoOnRcpt?: Maybe<SortEnumType>;
  /** Validate Batch against PO */
  validateBatchPO?: Maybe<SortEnumType>;
  /** Capture packaging information on receipt */
  capturePkgInfoOnRcpt?: Maybe<SortEnumType>;
  /** Putaway LP on Receipt */
  putwayLPOnRcpt?: Maybe<SortEnumType>;
  /** Confirm putaways on Receipt */
  confirmPutawaysOnRcpt?: Maybe<SortEnumType>;
  /** Goods receipt can only be closed by authorized user */
  reqAuthOnGRClose?: Maybe<SortEnumType>;
  /** Unbooked receipts by default */
  defaultUnbookedRcpt?: Maybe<SortEnumType>;
  /** Use identical pallets on Receipt */
  identicalPallets?: Maybe<SortEnumType>;
  /** Strict PO date validation */
  strictPODateVal?: Maybe<SortEnumType>;
  /** Receipt Verification - Split on Supplier Tollerance */
  splitSuppTolerance?: Maybe<SortEnumType>;
  /** Receipt verification - Putaway to default location */
  RVPutToDefLoc?: Maybe<SortEnumType>;
  /** RF Putaway Immediately */
  RFPutImmediately?: Maybe<SortEnumType>;
  /** Disable Confirm Putaway for Specified Locations */
  disablePutForSpecificLocs?: Maybe<SortEnumType>;
  /** Extra info must be entered on receipt */
  mandExtraInfoOnRcpt?: Maybe<SortEnumType>;
  /** Capture container type on receipt */
  captureContainerType?: Maybe<SortEnumType>;
  /** Only show booked products in the product F2 */
  F2ShowBookedProdsOnly?: Maybe<SortEnumType>;
  /** Generate PO Number automatically */
  autoGeneratePONumber?: Maybe<SortEnumType>;
  /** Allow Editing in Receipt verification */
  allowEditInRV?: Maybe<SortEnumType>;
  /** Print Carton Labels with Pallet Labels */
  GRPrintCrtnLbls?: Maybe<SortEnumType>;
  /** No Backflush when receiving from production */
  noBckFlushGRProduction?: Maybe<SortEnumType>;
  /** Print labels when receiving from production */
  printLblsGRProduction?: Maybe<SortEnumType>;
  /** Receipt and Booking Number must match */
  matchGRWithBookNo?: Maybe<SortEnumType>;
  /** Receipt verification - Suppress merging of pick faces */
  RVSuppressMergePF?: Maybe<SortEnumType>;
  /** Split PO lines on Print */
  spltPOLinesOnPrint?: Maybe<SortEnumType>;
  /** Make GRN number the budgetholder for received stock */
  makeGRNBudhol?: Maybe<SortEnumType>;
  /** Allow Short Shelf Life */
  allowShortShelfLife?: Maybe<SortEnumType>;
  /** Add products to PO that were not expected */
  allowAddProdsToPO?: Maybe<SortEnumType>;
  /** Capture Location on receipt */
  captureLocOnRcpt?: Maybe<SortEnumType>;
  /** Capture temperature on receipt */
  captureTempOnRcpt?: Maybe<SortEnumType>;
  /** Generate order numbers automatically */
  autoGenOrderNum?: Maybe<SortEnumType>;
  /** Display Errors in Order Entry */
  dispOrderEntryErrs?: Maybe<SortEnumType>;
  /** Require Proof of Delivery */
  requirePOD?: Maybe<SortEnumType>;
  /** Print Order Confirmation Report */
  printOrdConfRpt?: Maybe<SortEnumType>;
  /** Create pick once an order has been saved in order entry */
  createPickOnOrdEntry?: Maybe<SortEnumType>;
  /** Do not clear line customer reference */
  dontClearLineCustRef?: Maybe<SortEnumType>;
  /** Mandatory Line customer reference */
  mandLineCustref?: Maybe<SortEnumType>;
  /** Warn if there is a shortage of a product on the order */
  warnOnShortage?: Maybe<SortEnumType>;
  /** Print order report with PickList */
  printOrdRptWithPick?: Maybe<SortEnumType>;
  /** Print box packing Labels */
  printBoxPackLbls?: Maybe<SortEnumType>;
  /** GDPR Controlled */
  GDPRControlled?: Maybe<SortEnumType>;
  /** Force budgetholder to be entered in order entry */
  forceBudholOnEntry?: Maybe<SortEnumType>;
  /** Prevent batch from being entered in order entry */
  preventBatchOnEntry?: Maybe<SortEnumType>;
  /** Allow products to be swapped using generics in order entry. */
  swapGenericsOnEntry?: Maybe<SortEnumType>;
  /** Force Department in order entry. */
  forceDepartmentOnEntry?: Maybe<SortEnumType>;
  /** Pick Orders without shortages only. */
  cleanOrdersOnly?: Maybe<SortEnumType>;
  /** Create back orders when creating picks that are short */
  createBackOrders?: Maybe<SortEnumType>;
  /** Allow Shortage swapping */
  allowShortageSwap?: Maybe<SortEnumType>;
  /** Allow budgetholder swapping */
  allowBudholSwap?: Maybe<SortEnumType>;
  /** Change trays based on Priority */
  chngeTraysOnPri?: Maybe<SortEnumType>;
  /** Only create picks with no replens. */
  noReplenPicksOnly?: Maybe<SortEnumType>;
  /** Allow status swapping */
  allowStatusSwap?: Maybe<SortEnumType>;
  /** Pick cartons */
  pickCartons?: Maybe<SortEnumType>;
  /** Manual Picking - Do not split lists */
  MPNoSplitLists?: Maybe<SortEnumType>;
  /** Show Unpickable report */
  showUnpickableRpt?: Maybe<SortEnumType>;
  /** Allow LP Swapping */
  allowLPSwap?: Maybe<SortEnumType>;
  /** Allow Sell by date swapping */
  allowSBDSwap?: Maybe<SortEnumType>;
  /** Find carton ID by Weight */
  findCartonByWgt?: Maybe<SortEnumType>;
  /** Capture Carrier */
  captureCarrier?: Maybe<SortEnumType>;
  /** Allow Location swapping */
  allowLocSwap?: Maybe<SortEnumType>;
  /** Use BOM Picking */
  useBOMPicking?: Maybe<SortEnumType>;
  /** Require Despatch note */
  requireDespNote?: Maybe<SortEnumType>;
  /** RF Pick Assignment enumeration */
  RFPickAssignment?: Maybe<SortEnumType>;
  voicePickAssignment?: Maybe<SortEnumType>;
  /** Allow Batch swapping */
  allowBatchSwap?: Maybe<SortEnumType>;
  /** Required to confirm product */
  requireConfProduct?: Maybe<SortEnumType>;
  /** Require UPI check */
  requireUPICheck?: Maybe<SortEnumType>;
  /** Perform pick cage validation */
  cageValidation?: Maybe<SortEnumType>;
  /** Validate despatch note */
  despNoteValidation?: Maybe<SortEnumType>;
  /** Suppress Replenishment option */
  suppressReplenOpt?: Maybe<SortEnumType>;
  /** Use Loading */
  useLoading?: Maybe<SortEnumType>;
  /** Produce RF Manifest */
  produceRFManifest?: Maybe<SortEnumType>;
  /** Requires seal number to be entered */
  requireSealNo?: Maybe<SortEnumType>;
  /** Require truck to be specified */
  requireTruck?: Maybe<SortEnumType>;
  /** Require driver to be specified */
  requireDriver?: Maybe<SortEnumType>;
  /** Use Load order */
  useLoadOrder?: Maybe<SortEnumType>;
  loadOrder?: Maybe<SortEnumType>;
  /** Despatch lane for loading */
  despLane?: Maybe<SortEnumType>;
  /** Maximum number of Loaders */
  maxLoaders?: Maybe<SortEnumType>;
  adhocLoading?: Maybe<SortEnumType>;
  /** Capture temperature at the start of Load */
  loadTempCaptureStart?: Maybe<SortEnumType>;
  /** Capture temperature at the end of Load */
  loadTempCaptureEnd?: Maybe<SortEnumType>;
  /** Capture temperature at LP Intervals */
  loadTempLPInterval?: Maybe<SortEnumType>;
  /** Capture time on pick confirm */
  captureTimeOnConfirm?: Maybe<SortEnumType>;
  /** Capture check on pick confirm */
  captureCheckerOnConfirm?: Maybe<SortEnumType>;
  /** Capture picker on pick confirm */
  capturePickerOnConfirm?: Maybe<SortEnumType>;
  /** Default pick fail code */
  defPickFailCode?: Maybe<SortEnumType>;
  /** Require despatch lane */
  requireDespatchLane?: Maybe<SortEnumType>;
  /** Use destination info for despatch email notification */
  useEmailFromDestination?: Maybe<SortEnumType>;
  /** Allow despatch reprints for unconfirmed picklists */
  reprntUnfinishedLists?: Maybe<SortEnumType>;
  /** Destock when short */
  destockShortOnSHort?: Maybe<SortEnumType>;
  /** Proportional box records on pick confirm */
  proportionalBoxesOnConfirm?: Maybe<SortEnumType>;
  /** Allow Loading in any Sequence */
  allowLoadAnySeq?: Maybe<SortEnumType>;
  /** LP Control in Manual box packing */
  MBPLPControl?: Maybe<SortEnumType>;
  /** Use stock owner defined despatch method in Manual box packing */
  MBPUseSODespMeth?: Maybe<SortEnumType>;
  /** Do not create despatch notes */
  noDespNotes?: Maybe<SortEnumType>;
  /** Preview despatch notes */
  previewDespNote?: Maybe<SortEnumType>;
  /** Turn BOMS to stock */
  BOMSToStock?: Maybe<SortEnumType>;
  /** Delay despatch */
  delayDespatch?: Maybe<SortEnumType>;
  /** RF Warning in Pick confirm */
  RFWarnInPckConf?: Maybe<SortEnumType>;
  /** No replen before pick confirm */
  noReplenPckConf?: Maybe<SortEnumType>;
  /** Print despatch note per list */
  despNotePerList?: Maybe<SortEnumType>;
  /** Always print box Labels */
  printBoxLbls?: Maybe<SortEnumType>;
  /** Disable immediate despatch */
  disablImmDesp?: Maybe<SortEnumType>;
  /** Allow future despatch dates */
  allowFutureDespDates?: Maybe<SortEnumType>;
  /** Capture Consignment Number at MBP */
  MBPCaptureConsNo?: Maybe<SortEnumType>;
  /** Optional consignment number */
  optConsNo?: Maybe<SortEnumType>;
  /** Print box label at pick confirm */
  boxLblsPickConf?: Maybe<SortEnumType>;
  /** Use LP IDs at Pick confirm */
  useLPIdsPickConfirm?: Maybe<SortEnumType>;
  /** Authorised Manual box packing */
  authMBP?: Maybe<SortEnumType>;
  /** Mandatory Container type */
  mandContainerType?: Maybe<SortEnumType>;
  /** Create PDF despatch notes */
  PDFDespNotes?: Maybe<SortEnumType>;
  /** Use despatch prefix */
  useDespPrefix?: Maybe<SortEnumType>;
  /** Number of despatch notes */
  noOfDespNotes?: Maybe<SortEnumType>;
  /** Confirm whole pick */
  confWholePick?: Maybe<SortEnumType>;
  /** Capture reason for delayed despatch */
  capReasonDelayDesp?: Maybe<SortEnumType>;
  /** Manual box packing - despatch note breakdown */
  MBPDespNoteBreakdwn?: Maybe<SortEnumType>;
  /** Don't close order when errors occur during label generation */
  dontCloseOrderOnLblFail?: Maybe<SortEnumType>;
  /** Capture the number of boxes per order */
  capBoxesPerOrder?: Maybe<SortEnumType>;
  /** Do not require carrier to be entered */
  carrierNotReq?: Maybe<SortEnumType>;
  /** Do not generate carrier labels at pick confirm */
  noCarrLblsPckConf?: Maybe<SortEnumType>;
  /** Copy carrier from parent order to back orders */
  copyCarrToBckOrd?: Maybe<SortEnumType>;
};

/** A connection to a list of items. */
export type StockOwnersConnection = {
  __typename?: 'StockOwnersConnection';
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A list of edges. */
  edges?: Maybe<Array<StockOwnersEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<StockOwner>>>;
  totalCount: Scalars['Int'];
};

export type StockOwnerUpdateInput = {
  name?: Maybe<Scalars['String']>;
  status?: Maybe<State>;
  contact?: Maybe<ContactUpdateInput>;
  address?: Maybe<AddressUpdateInput>;
  coldStoreID?: Maybe<Scalars['String']>;
  GLN?: Maybe<Scalars['String']>;
  VATNumber?: Maybe<Scalars['String']>;
  warnMoveDifStatus?: Maybe<Scalars['Boolean']>;
  requireBudhol?: Maybe<Scalars['Boolean']>;
  requireProdCategories?: Maybe<Scalars['Boolean']>;
  scanBarcodeMask?: Maybe<Scalars['String']>;
  keyedBarcodeMask?: Maybe<Scalars['String']>;
  captureSerialsOnRcpt?: Maybe<Scalars['Boolean']>;
  requirePalletID?: Maybe<Scalars['Boolean']>;
  printPalLblsOnRcpt?: Maybe<Scalars['Boolean']>;
  capturePONumOnRcpt?: Maybe<Scalars['Boolean']>;
  allocateLocOnRcpt?: Maybe<Scalars['Boolean']>;
  closeComPoOnRcpt?: Maybe<Scalars['Boolean']>;
  validateBatchPO?: Maybe<Scalars['Boolean']>;
  capturePkgInfoOnRcpt?: Maybe<Scalars['Boolean']>;
  putwayLPOnRcpt?: Maybe<Scalars['Boolean']>;
  confirmPutawaysOnRcpt?: Maybe<Scalars['Boolean']>;
  reqAuthOnGRClose?: Maybe<Scalars['Boolean']>;
  defaultUnbookedRcpt?: Maybe<Scalars['Boolean']>;
  identicalPallets?: Maybe<Scalars['Boolean']>;
  strictPODateVal?: Maybe<Scalars['Boolean']>;
  splitSuppTolerance?: Maybe<Scalars['Boolean']>;
  RVPutToDefLoc?: Maybe<Scalars['Boolean']>;
  RFPutImmediately?: Maybe<Scalars['Boolean']>;
  disablePutForSpecificLocs?: Maybe<Scalars['Boolean']>;
  mandExtraInfoOnRcpt?: Maybe<Scalars['Boolean']>;
  captureContainerType?: Maybe<Scalars['Boolean']>;
  F2ShowBookedProdsOnly?: Maybe<Scalars['Boolean']>;
  autoGeneratePONumber?: Maybe<Scalars['Boolean']>;
  allowEditInRV?: Maybe<Scalars['Boolean']>;
  GRPrintCrtnLbls?: Maybe<Scalars['Boolean']>;
  noBckFlushGRProduction?: Maybe<Scalars['Boolean']>;
  printLblsGRProduction?: Maybe<Scalars['Boolean']>;
  matchGRWithBookNo?: Maybe<Scalars['Boolean']>;
  RVSuppressMergePF?: Maybe<Scalars['Boolean']>;
  spltPOLinesOnPrint?: Maybe<Scalars['Boolean']>;
  makeGRNBudhol?: Maybe<Scalars['Boolean']>;
  allowShortShelfLife?: Maybe<Scalars['Boolean']>;
  allowAddProdsToPO?: Maybe<Scalars['Boolean']>;
  captureLocOnRcpt?: Maybe<Scalars['Boolean']>;
  captureTempOnRcpt?: Maybe<Scalars['Boolean']>;
  autoGenOrderNum?: Maybe<Scalars['Boolean']>;
  dispOrderEntryErrs?: Maybe<Scalars['Boolean']>;
  requirePOD?: Maybe<Scalars['Boolean']>;
  printOrdConfRpt?: Maybe<Scalars['Boolean']>;
  createPickOnOrdEntry?: Maybe<Scalars['Boolean']>;
  dontClearLineCustRef?: Maybe<Scalars['Boolean']>;
  mandLineCustref?: Maybe<Scalars['Boolean']>;
  warnOnShortage?: Maybe<Scalars['Boolean']>;
  printOrdRptWithPick?: Maybe<Scalars['Boolean']>;
  printBoxPackLbls?: Maybe<Scalars['Boolean']>;
  GDPRControlled?: Maybe<Scalars['Boolean']>;
  forceBudholOnEntry?: Maybe<Scalars['Boolean']>;
  preventBatchOnEntry?: Maybe<Scalars['Boolean']>;
  swapGenericsOnEntry?: Maybe<Scalars['Boolean']>;
  forceDepartmentOnEntry?: Maybe<Scalars['Boolean']>;
  cleanOrdersOnly?: Maybe<Scalars['Boolean']>;
  createBackOrders?: Maybe<Scalars['Boolean']>;
  allowShortageSwap?: Maybe<Scalars['Boolean']>;
  allowBudholSwap?: Maybe<Scalars['Boolean']>;
  chngeTraysOnPri?: Maybe<Scalars['Boolean']>;
  noReplenPicksOnly?: Maybe<Scalars['Boolean']>;
  allowStatusSwap?: Maybe<Scalars['Boolean']>;
  pickCartons?: Maybe<Scalars['Boolean']>;
  MPNoSplitLists?: Maybe<Scalars['Boolean']>;
  showUnpickableRpt?: Maybe<Scalars['Boolean']>;
  allowLPSwap?: Maybe<Scalars['Boolean']>;
  allowSBDSwap?: Maybe<Scalars['Boolean']>;
  findCartonByWgt?: Maybe<Scalars['Boolean']>;
  captureCarrier?: Maybe<Scalars['Boolean']>;
  allowLocSwap?: Maybe<Scalars['Boolean']>;
  useBOMPicking?: Maybe<Scalars['Boolean']>;
  requireDespNote?: Maybe<Scalars['Boolean']>;
  RFPickAssignment?: Maybe<PickAssignment>;
  voicePickAssignment?: Maybe<PickAssignment>;
  allowBatchSwap?: Maybe<Scalars['Boolean']>;
  requireConfProduct?: Maybe<Scalars['Boolean']>;
  requireUPICheck?: Maybe<Scalars['Boolean']>;
  cageValidation?: Maybe<Scalars['Boolean']>;
  despNoteValidation?: Maybe<Scalars['Boolean']>;
  suppressReplenOpt?: Maybe<Scalars['Boolean']>;
  useLoading?: Maybe<Scalars['Boolean']>;
  produceRFManifest?: Maybe<Scalars['Boolean']>;
  requireSealNo?: Maybe<Scalars['Boolean']>;
  requireTruck?: Maybe<Scalars['Boolean']>;
  requireDriver?: Maybe<Scalars['Boolean']>;
  useLoadOrder?: Maybe<Scalars['Boolean']>;
  loadOrder?: Maybe<LoadOrder>;
  despLane?: Maybe<Scalars['String']>;
  maxLoaders?: Maybe<Scalars['Int']>;
  adhocLoading?: Maybe<Accessiblity>;
  loadTempCaptureStart?: Maybe<Scalars['Boolean']>;
  loadTempCaptureEnd?: Maybe<Scalars['Boolean']>;
  loadTempLPInterval?: Maybe<Scalars['Boolean']>;
  captureTimeOnConfirm?: Maybe<FieldVisibility>;
  captureCheckerOnConfirm?: Maybe<FieldVisibility>;
  capturePickerOnConfirm?: Maybe<FieldVisibility>;
  defPickFailCode?: Maybe<Scalars['String']>;
  requireDespatchLane?: Maybe<Scalars['Boolean']>;
  useEmailFromDestination?: Maybe<Scalars['Boolean']>;
  reprntUnfinishedLists?: Maybe<Scalars['Boolean']>;
  destockShortOnSHort?: Maybe<Scalars['Boolean']>;
  proportionalBoxesOnConfirm?: Maybe<Scalars['Boolean']>;
  allowLoadAnySeq?: Maybe<Scalars['Boolean']>;
  MBPLPControl?: Maybe<Scalars['Boolean']>;
  MBPUseSODespMeth?: Maybe<Scalars['Boolean']>;
  noDespNotes?: Maybe<Scalars['Boolean']>;
  previewDespNote?: Maybe<Scalars['Boolean']>;
  BOMSToStock?: Maybe<Scalars['Boolean']>;
  delayDespatch?: Maybe<Scalars['Boolean']>;
  RFWarnInPckConf?: Maybe<Scalars['Boolean']>;
  noReplenPckConf?: Maybe<Scalars['Boolean']>;
  despNotePerList?: Maybe<Scalars['Boolean']>;
  printBoxLbls?: Maybe<Scalars['Boolean']>;
  disablImmDesp?: Maybe<Scalars['Boolean']>;
  allowFutureDespDates?: Maybe<Scalars['Boolean']>;
  MBPCaptureConsNo?: Maybe<Scalars['Boolean']>;
  optConsNo?: Maybe<Scalars['Boolean']>;
  boxLblsPickConf?: Maybe<Scalars['Boolean']>;
  useLPIdsPickConfirm?: Maybe<Scalars['Boolean']>;
  authMBP?: Maybe<Scalars['Boolean']>;
  mandContainerType?: Maybe<Scalars['Boolean']>;
  PDFDespNotes?: Maybe<Scalars['Boolean']>;
  useDespPrefix?: Maybe<Scalars['Boolean']>;
  noOfDespNotes?: Maybe<Scalars['Boolean']>;
  confWholePick?: Maybe<Scalars['Boolean']>;
  capReasonDelayDesp?: Maybe<Scalars['Boolean']>;
  MBPDespNoteBreakdwn?: Maybe<Scalars['Boolean']>;
  dontCloseOrderOnLblFail?: Maybe<Scalars['Boolean']>;
  capBoxesPerOrder?: Maybe<Scalars['Boolean']>;
  carrierNotReq?: Maybe<Scalars['Boolean']>;
  noCarrLblsPckConf?: Maybe<Scalars['Boolean']>;
  copyCarrToBckOrd?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['Int']>;
};

export type StockOwnerResult = StockOwner | DatabaseError | ValidationError;

export type OperationOfStockOwnerInput = {
  value?: Maybe<Scalars['Any']>;
  path?: Maybe<Scalars['String']>;
  op?: Maybe<Scalars['String']>;
  from?: Maybe<Scalars['String']>;
};

export type ProductStatusUpdateInput = {
  stockOwnerId: Scalars['Int'];
  stockOwner?: Maybe<StockOwnerUpdateInput>;
  code?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  adjustStock?: Maybe<Scalars['Boolean']>;
  processStatus?: Maybe<ProductProcessStatus>;
  targetStatuses?: Maybe<Array<Maybe<Scalars['String']>>>;
  id?: Maybe<Scalars['Int']>;
};

export type CategoryDefinitionUpdateInput = {
  id?: Maybe<Scalars['Int']>;
  stockOwner?: Maybe<StockOwnerUpdateInput>;
  stockOwnerId: Scalars['Int'];
  code?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
};

export type PickMethodUpdateInput = {
  stockOwnerId: Scalars['Int'];
  stockOwner?: Maybe<StockOwnerUpdateInput>;
  name?: Maybe<Scalars['String']>;
  default?: Maybe<Scalars['Boolean']>;
  prePickMethod?: Maybe<Scalars['String']>;
  pickingMethod?: Maybe<Scalars['String']>;
  postPickMethod?: Maybe<Scalars['String']>;
  outputMethod?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
};

export type PickConfirmMethodUpdateInput = {
  stockOwnerId: Scalars['Int'];
  stockOwner?: Maybe<StockOwnerUpdateInput>;
  name?: Maybe<Scalars['String']>;
  default?: Maybe<Scalars['Boolean']>;
  pickConfMethod?: Maybe<Scalars['String']>;
  postConfMethod?: Maybe<Scalars['String']>;
  packingMethod?: Maybe<Scalars['String']>;
  despatchMethod?: Maybe<Scalars['String']>;
  loadCloseMethod?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
};

export type OrderStatusUpdateInput = {
  stockOwnerId: Scalars['Int'];
  stockOwner?: Maybe<StockOwnerUpdateInput>;
  code?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  purpose?: Maybe<OrderStatusPurpose>;
  id?: Maybe<Scalars['Int']>;
};

export type HandlingTypeFilterInput = {
  and?: Maybe<Array<HandlingTypeFilterInput>>;
  or?: Maybe<Array<HandlingTypeFilterInput>>;
  id?: Maybe<ComparableNullableOfInt32OperationFilterInput>;
  code?: Maybe<StringOperationFilterInput>;
  description?: Maybe<StringOperationFilterInput>;
  storageTypes?: Maybe<ListFilterInputTypeOfHandlingStorageTypeFilterInput>;
};

export type HandlingTypeSortInput = {
  id?: Maybe<SortEnumType>;
  code?: Maybe<SortEnumType>;
  description?: Maybe<SortEnumType>;
};

/** A connection to a list of items. */
export type HandlingTypesConnection = {
  __typename?: 'HandlingTypesConnection';
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A list of edges. */
  edges?: Maybe<Array<HandlingTypesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<HandlingType>>>;
  totalCount: Scalars['Int'];
};

export type HandlingTypeUpdateInput = {
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
};

export type WarehouseSortInput = {
  id?: Maybe<SortEnumType>;
  code?: Maybe<SortEnumType>;
  companyName?: Maybe<SortEnumType>;
  warehouseName?: Maybe<SortEnumType>;
  address?: Maybe<AddressSortInput>;
  telephone?: Maybe<SortEnumType>;
  VATNumber?: Maybe<SortEnumType>;
  customsId?: Maybe<SortEnumType>;
};

export type WarehouseZoneFilterInput = {
  and?: Maybe<Array<WarehouseZoneFilterInput>>;
  or?: Maybe<Array<WarehouseZoneFilterInput>>;
  id?: Maybe<ComparableNullableOfInt32OperationFilterInput>;
  warehouse?: Maybe<WarehouseFilterInput>;
  code?: Maybe<StringOperationFilterInput>;
  description?: Maybe<StringOperationFilterInput>;
  zoneType?: Maybe<StringOperationFilterInput>;
};

export type WarehouseZoneSortInput = {
  id?: Maybe<SortEnumType>;
  warehouse?: Maybe<WarehouseSortInput>;
  code?: Maybe<SortEnumType>;
  description?: Maybe<SortEnumType>;
  zoneType?: Maybe<SortEnumType>;
};

/** A connection to a list of items. */
export type WarehousesConnection = {
  __typename?: 'WarehousesConnection';
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A list of edges. */
  edges?: Maybe<Array<WarehousesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<Warehouse>>>;
  totalCount: Scalars['Int'];
};

/** A connection to a list of items. */
export type WarehouseZonesConnection = {
  __typename?: 'WarehouseZonesConnection';
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A list of edges. */
  edges?: Maybe<Array<WarehouseZonesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<WarehouseZone>>>;
  totalCount: Scalars['Int'];
};

export type WarehouseUpdateInput = {
  companyName?: Maybe<Scalars['String']>;
  warehouseName?: Maybe<Scalars['String']>;
  address?: Maybe<AddressUpdateInput>;
  telephone?: Maybe<Scalars['String']>;
  VATNumber?: Maybe<Scalars['String']>;
  customsId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
};

export type WarehouseZoneUpdateInput = {
  warehouseId?: Maybe<Scalars['Int']>;
  code?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  zoneType?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
};

export type UserPermissionFilterInput = {
  and?: Maybe<Array<UserPermissionFilterInput>>;
  or?: Maybe<Array<UserPermissionFilterInput>>;
  id?: Maybe<ComparableNullableOfInt32OperationFilterInput>;
  userId?: Maybe<StringOperationFilterInput>;
  warehouseId?: Maybe<ComparableNullableOfInt32OperationFilterInput>;
  warehouse?: Maybe<WarehouseFilterInput>;
  stockOwnerId?: Maybe<ComparableNullableOfInt32OperationFilterInput>;
  stockOwner?: Maybe<StockOwnerFilterInput>;
  permissions?: Maybe<ListPermissionOperationFilterInput>;
};

export type UserPermissionSortInput = {
  id?: Maybe<SortEnumType>;
  userId?: Maybe<SortEnumType>;
  warehouseId?: Maybe<SortEnumType>;
  warehouse?: Maybe<WarehouseSortInput>;
  stockOwnerId?: Maybe<SortEnumType>;
  stockOwner?: Maybe<StockOwnerSortInput>;
};

/** A connection to a list of items. */
export type UserPermissionsConnection = {
  __typename?: 'UserPermissionsConnection';
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A list of edges. */
  edges?: Maybe<Array<UserPermissionsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<UserPermission>>>;
  totalCount: Scalars['Int'];
};

export type UserPermissionUpdateInput = {
  userId?: Maybe<Scalars['String']>;
  warehouseId?: Maybe<Scalars['Int']>;
  warehouse?: Maybe<WarehouseUpdateInput>;
  stockOwnerId?: Maybe<Scalars['Int']>;
  stockOwner?: Maybe<StockOwnerUpdateInput>;
  permissions?: Maybe<Array<Permission>>;
  id?: Maybe<Scalars['Int']>;
};

export type LocationSortInput = {
  id?: Maybe<SortEnumType>;
  warehouse?: Maybe<WarehouseSortInput>;
  code?: Maybe<SortEnumType>;
  /** The physical characteristics of the location such as whether it is drive-in or conventional racking */
  physicalCharacteristics?: Maybe<SortEnumType>;
  /** The process characteristics of the location such as whether it is uses a a picking face or despatch area */
  processCharacteristics?: Maybe<SortEnumType>;
  /** The storage temperature type of the location. e.g. Ambient, chilled or frozen */
  temperatureType?: Maybe<SortEnumType>;
  /** Additional location specific attributes (yet to be defined) */
  attributes?: Maybe<SortEnumType>;
  storageTypeId?: Maybe<SortEnumType>;
  storageType?: Maybe<StorageTypeSortInput>;
  aisle?: Maybe<SortEnumType>;
  status?: Maybe<SortEnumType>;
  checkCode?: Maybe<SortEnumType>;
  beam?: Maybe<SortEnumType>;
  beamSequence?: Maybe<SortEnumType>;
  zone?: Maybe<SortEnumType>;
  countZone?: Maybe<SortEnumType>;
  tier?: Maybe<SortEnumType>;
  elevation?: Maybe<SortEnumType>;
  dimensions?: Maybe<DimensionSortInput>;
  maxWeight?: Maybe<SortEnumType>;
  pickZone?: Maybe<SortEnumType>;
  reservedProductId?: Maybe<SortEnumType>;
};

/** A connection to a list of items. */
export type LocationsConnection = {
  __typename?: 'LocationsConnection';
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A list of edges. */
  edges?: Maybe<Array<LocationsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<Location>>>;
  totalCount: Scalars['Int'];
};

export type LocationPhysicalTypeMetadata = {
  __typename?: 'LocationPhysicalTypeMetadata';
  id?: Maybe<Scalars['Int']>;
  value?: Maybe<LocationPhysicalType>;
  displayName?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  group?: Maybe<Scalars['String']>;
};

export type LocationProcessTypeMetadata = {
  __typename?: 'LocationProcessTypeMetadata';
  id?: Maybe<Scalars['Int']>;
  value?: Maybe<LocationProcessType>;
  displayName?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  group?: Maybe<Scalars['String']>;
};

export type LocationResult = Location | DatabaseError | ValidationError;

export type LocationUpdateInput = {
  warehouseId?: Maybe<Scalars['Int']>;
  warehouse?: Maybe<WarehouseUpdateInput>;
  physicalCharacteristics?: Maybe<LocationPhysicalType>;
  processCharacteristics?: Maybe<LocationProcessType>;
  temperatureType?: Maybe<LocationTemperatureType>;
  attributes?: Maybe<Scalars['String']>;
  storageTypeId?: Maybe<Scalars['Int']>;
  storageType?: Maybe<StorageTypeUpdateInput>;
  aisle?: Maybe<Scalars['String']>;
  status?: Maybe<LocationStatus>;
  checkCode?: Maybe<Scalars['String']>;
  beam?: Maybe<Scalars['String']>;
  beamSequence?: Maybe<Scalars['String']>;
  zone?: Maybe<Scalars['String']>;
  countZone?: Maybe<Scalars['String']>;
  tier?: Maybe<Scalars['Int']>;
  elevation?: Maybe<Scalars['Decimal']>;
  dimensions?: Maybe<DimensionUpdateInput>;
  maxWeight?: Maybe<Scalars['Decimal']>;
  pickZone?: Maybe<Scalars['String']>;
  reservedProductId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

export type OperationOfLocationInput = {
  value?: Maybe<Scalars['Any']>;
  path?: Maybe<Scalars['String']>;
  op?: Maybe<Scalars['String']>;
  from?: Maybe<Scalars['String']>;
};

export type BudgetHolderFilterInput = {
  and?: Maybe<Array<BudgetHolderFilterInput>>;
  or?: Maybe<Array<BudgetHolderFilterInput>>;
  id?: Maybe<ComparableNullableOfInt32OperationFilterInput>;
  code?: Maybe<StringOperationFilterInput>;
  description?: Maybe<StringOperationFilterInput>;
  status?: Maybe<NullableOfStateOperationFilterInput>;
  stockOwner?: Maybe<StockOwnerFilterInput>;
  warehouse?: Maybe<WarehouseFilterInput>;
};

export type BudgetHolderSortInput = {
  id?: Maybe<SortEnumType>;
  code?: Maybe<SortEnumType>;
  description?: Maybe<SortEnumType>;
  status?: Maybe<SortEnumType>;
  stockOwner?: Maybe<StockOwnerSortInput>;
  warehouse?: Maybe<WarehouseSortInput>;
};

/** A connection to a list of items. */
export type BudgetHoldersConnection = {
  __typename?: 'BudgetHoldersConnection';
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A list of edges. */
  edges?: Maybe<Array<BudgetHoldersEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<BudgetHolder>>>;
  totalCount: Scalars['Int'];
};

export type BudgetHolderUpdateInput = {
  description?: Maybe<Scalars['String']>;
  status?: Maybe<State>;
  id?: Maybe<Scalars['Int']>;
};

export type ProductFilterInput = {
  and?: Maybe<Array<ProductFilterInput>>;
  or?: Maybe<Array<ProductFilterInput>>;
  id?: Maybe<ComparableNullableOfInt32OperationFilterInput>;
  stockOwner?: Maybe<StockOwnerFilterInput>;
  /** The unique code for the product definition */
  code?: Maybe<StringOperationFilterInput>;
  /** Alternative code for product */
  altCode?: Maybe<StringOperationFilterInput>;
  /** GTIN (Global Trade Item Number) for product */
  gTIN?: Maybe<StringOperationFilterInput>;
  /** Substitute product */
  substitute?: Maybe<StringOperationFilterInput>;
  /** Description of the product */
  description?: Maybe<StringOperationFilterInput>;
  /** Long description of the product */
  longDesc?: Maybe<StringOperationFilterInput>;
  /** Generic linking code for similar products */
  linkCode?: Maybe<StringOperationFilterInput>;
  /**
   * List of categories defined for the product
   * Mutations:
   *
   * CreateProductCategory
   * DeleteProductCategory
   * UpdateProductCategory
   */
  categories?: Maybe<ListFilterInputTypeOfProductCategoryFilterInput>;
  /**
   * List of components for the product, should only be populated
   * if the SKUType of the product is set to either STOCK or NONSTOCK.
   * Mutations:
   *
   * CreateBOMDefinition
   * DeleteBOMDefinition
   * UpdateBOMDefinition
   */
  components?: Maybe<ListFilterInputTypeOfBomDefinitionFilterInput>;
  /**
   * List of suppliers for the product.
   * Mutations:
   *
   * CreateProductSupplier
   * DeleteProductSupplier
   * UpdateProductSupplier
   */
  suppliers?: Maybe<ListFilterInputTypeOfProductSupplierFilterInput>;
  /**
   * List of licence plates defined for the product.
   *             Mutations:
   *
   * CreateLPDefinition
   * DeleteLPDefinition
   * UpdateLPDefinition
   */
  licencePlates?: Maybe<ListFilterInputTypeOfLpDefinitionFilterInput>;
  /**
   * List of barcodes for the product.
   * Mutations:
   *
   * CreateProductBarcode
   * DeleteProductBarcode
   * UpdateProductBarcode
   */
  barcodes?: Maybe<ListFilterInputTypeOfProductBarcodeFilterInput>;
  /**
   * List of Documents for the product.
   * Mutations:
   *
   * CreateProductDocument
   * DeleteProductDocument
   * UpdateProductDocument
   */
  documents?: Maybe<ListFilterInputTypeOfProductDocumentFilterInput>;
  require?: Maybe<ProductRequiredDataFilterInput>;
  /** BOM type of the product */
  SKUType?: Maybe<NullableOfBomTypeOperationFilterInput>;
  /** INCI (International Nomenclature of Cosmetic ingredients) code for product */
  INCICode?: Maybe<StringOperationFilterInput>;
  /** Defines how stock will be used (i.e. for picking) */
  rotation?: Maybe<NullableOfRotationRuleOperationFilterInput>;
  /** Type of the product */
  type?: Maybe<StringOperationFilterInput>;
  /** Storage type of the product */
  StorageType?: Maybe<StringOperationFilterInput>;
  /** Facility category */
  facilityCat?: Maybe<StringOperationFilterInput>;
  /** Default budget holder for the product */
  defBudhol?: Maybe<StringOperationFilterInput>;
  /** Default warehouse for the product */
  defWH?: Maybe<StringOperationFilterInput>;
  /** Default handling type for product */
  defHandType?: Maybe<StringOperationFilterInput>;
  /** Default pack type of the product */
  defPackType?: Maybe<StringOperationFilterInput>;
  /** Department code for the product */
  depCode?: Maybe<StringOperationFilterInput>;
  /** Product rank */
  rank?: Maybe<StringOperationFilterInput>;
  /** UN Code for the product */
  uNCode?: Maybe<StringOperationFilterInput>;
  /** Band Quantity */
  bandQty?: Maybe<ComparableNullableOfInt32OperationFilterInput>;
  manufacturerCode?: Maybe<StringOperationFilterInput>;
  /** Life cycle status */
  lifeCycleStatus?: Maybe<StringOperationFilterInput>;
  /** Validate batch at packing */
  packValidateBatch?: Maybe<BooleanOperationFilterInput>;
  /** Collect packing type at packing */
  capturePackType?: Maybe<BooleanOperationFilterInput>;
  /** Pick part pallets as full pallets */
  pickPartPalletsAsFull?: Maybe<BooleanOperationFilterInput>;
  /** Pick in singles */
  pickSingles?: Maybe<BooleanOperationFilterInput>;
  pickDefId?: Maybe<ComparableNullableOfInt32OperationFilterInput>;
  /** Default pick definition for the product */
  defPickDefinition?: Maybe<PickMethodFilterInput>;
  /**
   * List of pickface definitions for the product
   * Mutations:
   *
   * CreateProductPickface
   * DeleteProductPickface
   * UpdateProductPickface
   */
  pickfaces?: Maybe<ListFilterInputTypeOfProductPickfaceFilterInput>;
  /** Code for the default goods receipt status */
  defGRStatus?: Maybe<StringOperationFilterInput>;
  /** Minimum receipt shelf life */
  minRShlfLife?: Maybe<ComparableNullableOfInt32OperationFilterInput>;
  /** Minimum picking shelf life */
  minPShlfLife?: Maybe<ComparableNullableOfInt32OperationFilterInput>;
  /** Total shelf life */
  totShlfLife?: Maybe<ComparableNullableOfInt32OperationFilterInput>;
};

export type ProductSortInput = {
  id?: Maybe<SortEnumType>;
  stockOwner?: Maybe<StockOwnerSortInput>;
  /** The unique code for the product definition */
  code?: Maybe<SortEnumType>;
  /** Alternative code for product */
  altCode?: Maybe<SortEnumType>;
  /** GTIN (Global Trade Item Number) for product */
  gTIN?: Maybe<SortEnumType>;
  /** Substitute product */
  substitute?: Maybe<SortEnumType>;
  /** Description of the product */
  description?: Maybe<SortEnumType>;
  /** Long description of the product */
  longDesc?: Maybe<SortEnumType>;
  /** Generic linking code for similar products */
  linkCode?: Maybe<SortEnumType>;
  require?: Maybe<ProductRequiredDataSortInput>;
  /** BOM type of the product */
  SKUType?: Maybe<SortEnumType>;
  /** INCI (International Nomenclature of Cosmetic ingredients) code for product */
  INCICode?: Maybe<SortEnumType>;
  /** Defines how stock will be used (i.e. for picking) */
  rotation?: Maybe<SortEnumType>;
  /** Type of the product */
  type?: Maybe<SortEnumType>;
  /** Storage type of the product */
  StorageType?: Maybe<SortEnumType>;
  /** Facility category */
  facilityCat?: Maybe<SortEnumType>;
  /** Default budget holder for the product */
  defBudhol?: Maybe<SortEnumType>;
  /** Default warehouse for the product */
  defWH?: Maybe<SortEnumType>;
  /** Default handling type for product */
  defHandType?: Maybe<SortEnumType>;
  /** Default pack type of the product */
  defPackType?: Maybe<SortEnumType>;
  /** Department code for the product */
  depCode?: Maybe<SortEnumType>;
  /** Product rank */
  rank?: Maybe<SortEnumType>;
  /** UN Code for the product */
  uNCode?: Maybe<SortEnumType>;
  /** Band Quantity */
  bandQty?: Maybe<SortEnumType>;
  manufacturerCode?: Maybe<SortEnumType>;
  /** Life cycle status */
  lifeCycleStatus?: Maybe<SortEnumType>;
  /** Validate batch at packing */
  packValidateBatch?: Maybe<SortEnumType>;
  /** Collect packing type at packing */
  capturePackType?: Maybe<SortEnumType>;
  /** Pick part pallets as full pallets */
  pickPartPalletsAsFull?: Maybe<SortEnumType>;
  /** Pick in singles */
  pickSingles?: Maybe<SortEnumType>;
  pickDefId?: Maybe<SortEnumType>;
  /** Default pick definition for the product */
  defPickDefinition?: Maybe<PickMethodSortInput>;
  /** Code for the default goods receipt status */
  defGRStatus?: Maybe<SortEnumType>;
  /** Minimum receipt shelf life */
  minRShlfLife?: Maybe<SortEnumType>;
  /** Minimum picking shelf life */
  minPShlfLife?: Maybe<SortEnumType>;
  /** Total shelf life */
  totShlfLife?: Maybe<SortEnumType>;
};

/** A connection to a list of items. */
export type ProductConnection = {
  __typename?: 'ProductConnection';
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A list of edges. */
  edges?: Maybe<Array<ProductEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<Product>>>;
  totalCount: Scalars['Int'];
};

export type ProductUpdateInput = {
  stockOwnerId?: Maybe<Scalars['Int']>;
  code?: Maybe<Scalars['String']>;
  altCode?: Maybe<Scalars['String']>;
  gTIN?: Maybe<Scalars['String']>;
  substitute?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  longDesc?: Maybe<Scalars['String']>;
  linkCode?: Maybe<Scalars['String']>;
  require?: Maybe<ProductRequiredDataUpdateInput>;
  SKUType?: Maybe<BomType>;
  INCICode?: Maybe<Scalars['String']>;
  rotation?: Maybe<RotationRule>;
  type?: Maybe<Scalars['String']>;
  StorageType?: Maybe<Scalars['String']>;
  facilityCat?: Maybe<Scalars['String']>;
  defBudhol?: Maybe<Scalars['String']>;
  defWH?: Maybe<Scalars['String']>;
  defHandType?: Maybe<Scalars['String']>;
  defPackType?: Maybe<Scalars['String']>;
  depCode?: Maybe<Scalars['String']>;
  rank?: Maybe<Scalars['String']>;
  uNCode?: Maybe<Scalars['String']>;
  bandQty?: Maybe<Scalars['Int']>;
  manufacturerCode?: Maybe<Scalars['String']>;
  lifeCycleStatus?: Maybe<Scalars['String']>;
  packValidateBatch?: Maybe<Scalars['Boolean']>;
  capturePackType?: Maybe<Scalars['Boolean']>;
  pickPartPalletsAsFull?: Maybe<Scalars['Boolean']>;
  pickSingles?: Maybe<Scalars['Boolean']>;
  pickDefId?: Maybe<Scalars['Int']>;
  defGRStatus?: Maybe<Scalars['String']>;
  minRShlfLife?: Maybe<Scalars['Int']>;
  minPShlfLife?: Maybe<Scalars['Int']>;
  totShlfLife?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

export type BomDefinitionUpdateInput = {
  childId?: Maybe<Scalars['Int']>;
  qty?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

export type ProductCategoryUpdateInput = {
  productId: Scalars['Int'];
  product?: Maybe<ProductUpdateInput>;
  category?: Maybe<Scalars['String']>;
  attribute?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
};

export type ProductPickfaceUpdateInput = {
  product?: Maybe<ProductUpdateInput>;
  warehouse?: Maybe<Scalars['String']>;
  budhol?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['String']>;
  pickZone?: Maybe<Scalars['String']>;
  maxFaceQty?: Maybe<Scalars['Int']>;
  replenTriggr?: Maybe<Scalars['Int']>;
  replenMulti?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

export type ProductSupplierUpdateInput = {
  product?: Maybe<ProductUpdateInput>;
  supplierId?: Maybe<Scalars['Int']>;
  warehouseId?: Maybe<Scalars['Int']>;
  warehouse?: Maybe<WarehouseUpdateInput>;
  active?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['Int']>;
};

export type LpDefinitionUpdateInput = {
  handType?: Maybe<Scalars['String']>;
  packType?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['Int']>;
  diagram?: Maybe<Scalars['String']>;
  height?: Maybe<Scalars['Decimal']>;
  width?: Maybe<Scalars['Decimal']>;
  depth?: Maybe<Scalars['Decimal']>;
  weight?: Maybe<Scalars['Decimal']>;
  layerQty?: Maybe<Scalars['Int']>;
  maxLayerQty?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

export type ProductBarcodeUpdateInput = {
  barcode?: Maybe<Scalars['String']>;
  symbology?: Maybe<Scalars['String']>;
  factor: Scalars['Int'];
  unitType?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
};

export type ProductDocumentUpdateInput = {
  product?: Maybe<ProductUpdateInput>;
  name?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  usage?: Maybe<Scalars['String']>;
  uploaded?: Maybe<Scalars['DateTime']>;
  uploadBy?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
};

export type SupplierFilterInput = {
  and?: Maybe<Array<SupplierFilterInput>>;
  or?: Maybe<Array<SupplierFilterInput>>;
  id?: Maybe<ComparableNullableOfInt32OperationFilterInput>;
  /** Internal code of the supplier */
  code?: Maybe<StringOperationFilterInput>;
  /** Master supplier */
  master?: Maybe<StringOperationFilterInput>;
  /** Name of the supplier */
  name?: Maybe<StringOperationFilterInput>;
  /** The main address of the supplier */
  address?: Maybe<AddressFilterInput>;
  /** Currency used by the supplier */
  currency?: Maybe<NullableOfCurrencyOperationFilterInput>;
  /**
   * File Transmission Method.
   * Default value of None.
   */
  fileTransMeth?: Maybe<NullableOfFileTransmissionOperationFilterInput>;
  /** File Format */
  fileFormat?: Maybe<NullableOfFileFormatOperationFilterInput>;
  /** Must order in layer quantities */
  mustOrderLayerQty?: Maybe<BooleanOperationFilterInput>;
  /** Maximum weekly spend */
  maxWeekSpend?: Maybe<ComparableNullableOfDecimalOperationFilterInput>;
  /** Lead Time in Days */
  leadTime?: Maybe<ComparableNullableOfInt32OperationFilterInput>;
  orderDays?: Maybe<ListDayOfWeekOperationFilterInput>;
};

export type SupplierSortInput = {
  id?: Maybe<SortEnumType>;
  /** Internal code of the supplier */
  code?: Maybe<SortEnumType>;
  /** Master supplier */
  master?: Maybe<SortEnumType>;
  /** Name of the supplier */
  name?: Maybe<SortEnumType>;
  /** The main address of the supplier */
  address?: Maybe<AddressSortInput>;
  /** Currency used by the supplier */
  currency?: Maybe<SortEnumType>;
  /**
   * File Transmission Method.
   * Default value of None.
   */
  fileTransMeth?: Maybe<SortEnumType>;
  /** File Format */
  fileFormat?: Maybe<SortEnumType>;
  /** Must order in layer quantities */
  mustOrderLayerQty?: Maybe<SortEnumType>;
  /** Maximum weekly spend */
  maxWeekSpend?: Maybe<SortEnumType>;
  /** Lead Time in Days */
  leadTime?: Maybe<SortEnumType>;
};

/** A connection to a list of items. */
export type SuppliersConnection = {
  __typename?: 'SuppliersConnection';
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A list of edges. */
  edges?: Maybe<Array<SuppliersEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<Supplier>>>;
  totalCount: Scalars['Int'];
};

export type SupplierUpdateInput = {
  master?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  address?: Maybe<AddressUpdateInput>;
  currency?: Maybe<Currency>;
  fileTransMeth?: Maybe<FileTransmission>;
  fileFormat?: Maybe<FileFormat>;
  mustOrderLayerQty?: Maybe<Scalars['Boolean']>;
  maxWeekSpend?: Maybe<Scalars['Decimal']>;
  leadTime?: Maybe<Scalars['Int']>;
  orderDays?: Maybe<Array<DayOfWeek>>;
  id?: Maybe<Scalars['Int']>;
};

export type ExchangeRateFilter = {
  AND?: Maybe<Array<ExchangeRateFilter>>;
  OR?: Maybe<Array<ExchangeRateFilter>>;
  id?: Maybe<Scalars['Int']>;
  id_not?: Maybe<Scalars['Int']>;
  id_in?: Maybe<Array<Maybe<Scalars['Int']>>>;
  id_not_in?: Maybe<Array<Maybe<Scalars['Int']>>>;
  id_gt?: Maybe<Scalars['Int']>;
  id_not_gt?: Maybe<Scalars['Int']>;
  id_gte?: Maybe<Scalars['Int']>;
  id_not_gte?: Maybe<Scalars['Int']>;
  id_lt?: Maybe<Scalars['Int']>;
  id_not_lt?: Maybe<Scalars['Int']>;
  id_lte?: Maybe<Scalars['Int']>;
  id_not_lte?: Maybe<Scalars['Int']>;
  currency?: Maybe<Currency>;
  currency_not?: Maybe<Currency>;
  currency_in?: Maybe<Array<Currency>>;
  currency_not_in?: Maybe<Array<Currency>>;
  currency_gt?: Maybe<Currency>;
  currency_not_gt?: Maybe<Currency>;
  currency_gte?: Maybe<Currency>;
  currency_not_gte?: Maybe<Currency>;
  currency_lt?: Maybe<Currency>;
  currency_not_lt?: Maybe<Currency>;
  currency_lte?: Maybe<Currency>;
  currency_not_lte?: Maybe<Currency>;
  target?: Maybe<Currency>;
  target_not?: Maybe<Currency>;
  target_in?: Maybe<Array<Currency>>;
  target_not_in?: Maybe<Array<Currency>>;
  target_gt?: Maybe<Currency>;
  target_not_gt?: Maybe<Currency>;
  target_gte?: Maybe<Currency>;
  target_not_gte?: Maybe<Currency>;
  target_lt?: Maybe<Currency>;
  target_not_lt?: Maybe<Currency>;
  target_lte?: Maybe<Currency>;
  target_not_lte?: Maybe<Currency>;
  startDate?: Maybe<Scalars['DateTime']>;
  startDate_not?: Maybe<Scalars['DateTime']>;
  startDate_in?: Maybe<Array<Scalars['DateTime']>>;
  startDate_not_in?: Maybe<Array<Scalars['DateTime']>>;
  startDate_gt?: Maybe<Scalars['DateTime']>;
  startDate_not_gt?: Maybe<Scalars['DateTime']>;
  startDate_gte?: Maybe<Scalars['DateTime']>;
  startDate_not_gte?: Maybe<Scalars['DateTime']>;
  startDate_lt?: Maybe<Scalars['DateTime']>;
  startDate_not_lt?: Maybe<Scalars['DateTime']>;
  startDate_lte?: Maybe<Scalars['DateTime']>;
  startDate_not_lte?: Maybe<Scalars['DateTime']>;
  rate?: Maybe<Scalars['Decimal']>;
  rate_not?: Maybe<Scalars['Decimal']>;
  rate_in?: Maybe<Array<Scalars['Decimal']>>;
  rate_not_in?: Maybe<Array<Scalars['Decimal']>>;
  rate_gt?: Maybe<Scalars['Decimal']>;
  rate_not_gt?: Maybe<Scalars['Decimal']>;
  rate_gte?: Maybe<Scalars['Decimal']>;
  rate_not_gte?: Maybe<Scalars['Decimal']>;
  rate_lt?: Maybe<Scalars['Decimal']>;
  rate_not_lt?: Maybe<Scalars['Decimal']>;
  rate_lte?: Maybe<Scalars['Decimal']>;
  rate_not_lte?: Maybe<Scalars['Decimal']>;
};

export type ExchangeRateSort = {
  id?: Maybe<SortOperationKind>;
  currency?: Maybe<SortOperationKind>;
  target?: Maybe<SortOperationKind>;
  startDate?: Maybe<SortOperationKind>;
  rate?: Maybe<SortOperationKind>;
};

/** A connection to a list of items. */
export type ExchangeRatesConnection = {
  __typename?: 'ExchangeRatesConnection';
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A list of edges. */
  edges?: Maybe<Array<ExchangeRatesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<ExchangeRate>>>;
  totalCount: Scalars['Int'];
};

/** A connection to a list of items. */
export type ExchangeRatesForCurrencyConnection = {
  __typename?: 'ExchangeRatesForCurrencyConnection';
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A list of edges. */
  edges?: Maybe<Array<ExchangeRatesForCurrencyEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<ExchangeRate>>>;
  totalCount: Scalars['Int'];
};

export type ExchangeRateUpdateInput = {
  startDate?: Maybe<Scalars['DateTime']>;
  rate?: Maybe<Scalars['Decimal']>;
  id?: Maybe<Scalars['Int']>;
};

export type DestinationFilterInput = {
  and?: Maybe<Array<DestinationFilterInput>>;
  or?: Maybe<Array<DestinationFilterInput>>;
  id?: Maybe<ComparableNullableOfInt32OperationFilterInput>;
  code?: Maybe<StringOperationFilterInput>;
  name?: Maybe<StringOperationFilterInput>;
  address?: Maybe<AddressFilterInput>;
  status?: Maybe<NullableOfStateOperationFilterInput>;
  contact?: Maybe<ContactFilterInput>;
  salesman?: Maybe<StringOperationFilterInput>;
  VATNo?: Maybe<StringOperationFilterInput>;
  facility?: Maybe<StringOperationFilterInput>;
  category?: Maybe<StringOperationFilterInput>;
  stockOwnerId?: Maybe<ComparableNullableOfInt32OperationFilterInput>;
  owner?: Maybe<StockOwnerFilterInput>;
  masterAcc?: Maybe<StringOperationFilterInput>;
  budgetholder?: Maybe<StringOperationFilterInput>;
  area?: Maybe<StringOperationFilterInput>;
  /** Default route for destination */
  defRoute?: Maybe<StringOperationFilterInput>;
  /**
   * Location to pick to (if pick to location flag
   * is set to true)
   */
  pickLocation?: Maybe<StringOperationFilterInput>;
  /** Display customer stock codes on depatch notes */
  custStkCodeOnDespNotes?: Maybe<BooleanOperationFilterInput>;
  /** Despatch note format */
  despNoteFormat?: Maybe<ComparableNullableOfInt32OperationFilterInput>;
  /** Print despatch notes on delayed despatch */
  printNotesDelayDesp?: Maybe<BooleanOperationFilterInput>;
  /** Do not print despatch notes */
  noDespNotes?: Maybe<BooleanOperationFilterInput>;
  /** Print Box Notes */
  printBoxNotes?: Maybe<BooleanOperationFilterInput>;
  /** Print box Labels */
  printBoxLbls?: Maybe<BooleanOperationFilterInput>;
  /** FTP Account for despatch notes */
  FTPAcc?: Maybe<StringOperationFilterInput>;
  /** Depot for this destination */
  depot?: Maybe<StringOperationFilterInput>;
  /** Master hub for this destination */
  masterHub?: Maybe<StringOperationFilterInput>;
  /** Sub hub for this destination */
  subHub?: Maybe<StringOperationFilterInput>;
  GLN?: Maybe<StringOperationFilterInput>;
  customsId?: Maybe<StringOperationFilterInput>;
  defDelGroup?: Maybe<StringOperationFilterInput>;
  despNoteEmail?: Maybe<StringOperationFilterInput>;
  useDespMethMBP?: Maybe<BooleanOperationFilterInput>;
  /** Routing information for this destination */
  routing?: Maybe<ListFilterInputTypeOfDestinationRouteFilterInput>;
  /** List of budgets for this destination */
  budgets?: Maybe<ListFilterInputTypeOfDestinationBudgetFilterInput>;
  /**
   * Default order type for orders going to
   * this destination
   */
  defOrderType?: Maybe<StringOperationFilterInput>;
  /**
   * Default order priority for orders going to
   * this destination
   */
  defOrderPri?: Maybe<StringOperationFilterInput>;
  /** Despatch method to be invoked */
  despMethod?: Maybe<StringOperationFilterInput>;
  /**
   * Transit lifetime from despatch to destination
   * (in days)
   */
  transitTime?: Maybe<ComparableNullableOfInt32OperationFilterInput>;
  /**
   * Default despatch lane for orders going to this
   * destination
   */
  defDespLane?: Maybe<StringOperationFilterInput>;
  /**
   * How often orders are despatched to this
   * destination
   */
  orderFreq?: Maybe<NullableOfFrequencyOperationFilterInput>;
  /**
   * Day that orders are despatched to this
   * destination
   */
  orderDay?: Maybe<NullableOfDayOfWeekOperationFilterInput>;
  /** Default special instructions */
  defSpecIns?: Maybe<StringOperationFilterInput>;
  /** Minimum pick value */
  minPickValue?: Maybe<ComparableNullableOfInt32OperationFilterInput>;
  /**
   * Requires a manifest to be sent along
   * with goods despatched
   */
  reqManifest?: Maybe<BooleanOperationFilterInput>;
  /** Use pallet method at Box packing */
  usePalletMethod?: Maybe<BooleanOperationFilterInput>;
  /** Pallet method to be invoked */
  palletMethod?: Maybe<StringOperationFilterInput>;
  /** Create ASN for orders despatched */
  ASNOnDespatch?: Maybe<BooleanOperationFilterInput>;
  /** ASN method to be invoked */
  ASNMethod?: Maybe<StringOperationFilterInput>;
  /** Capture serial numbers on despatch */
  captureSerialOnDesp?: Maybe<BooleanOperationFilterInput>;
  /** Suppress back order closure on Load close */
  suppressBackOrdClose?: Maybe<BooleanOperationFilterInput>;
  /** Prevent pick consolidation */
  noPickConsolidation?: Maybe<BooleanOperationFilterInput>;
};

export type DestinationSortInput = {
  id?: Maybe<SortEnumType>;
  code?: Maybe<SortEnumType>;
  name?: Maybe<SortEnumType>;
  address?: Maybe<AddressSortInput>;
  status?: Maybe<SortEnumType>;
  contact?: Maybe<ContactSortInput>;
  salesman?: Maybe<SortEnumType>;
  VATNo?: Maybe<SortEnumType>;
  facility?: Maybe<SortEnumType>;
  category?: Maybe<SortEnumType>;
  stockOwnerId?: Maybe<SortEnumType>;
  owner?: Maybe<StockOwnerSortInput>;
  masterAcc?: Maybe<SortEnumType>;
  budgetholder?: Maybe<SortEnumType>;
  area?: Maybe<SortEnumType>;
  /** Default route for destination */
  defRoute?: Maybe<SortEnumType>;
  /**
   * Location to pick to (if pick to location flag
   * is set to true)
   */
  pickLocation?: Maybe<SortEnumType>;
  /** Display customer stock codes on depatch notes */
  custStkCodeOnDespNotes?: Maybe<SortEnumType>;
  /** Despatch note format */
  despNoteFormat?: Maybe<SortEnumType>;
  /** Print despatch notes on delayed despatch */
  printNotesDelayDesp?: Maybe<SortEnumType>;
  /** Do not print despatch notes */
  noDespNotes?: Maybe<SortEnumType>;
  /** Print Box Notes */
  printBoxNotes?: Maybe<SortEnumType>;
  /** Print box Labels */
  printBoxLbls?: Maybe<SortEnumType>;
  /** FTP Account for despatch notes */
  FTPAcc?: Maybe<SortEnumType>;
  /** Depot for this destination */
  depot?: Maybe<SortEnumType>;
  /** Master hub for this destination */
  masterHub?: Maybe<SortEnumType>;
  /** Sub hub for this destination */
  subHub?: Maybe<SortEnumType>;
  GLN?: Maybe<SortEnumType>;
  customsId?: Maybe<SortEnumType>;
  defDelGroup?: Maybe<SortEnumType>;
  despNoteEmail?: Maybe<SortEnumType>;
  useDespMethMBP?: Maybe<SortEnumType>;
  /**
   * Default order type for orders going to
   * this destination
   */
  defOrderType?: Maybe<SortEnumType>;
  /**
   * Default order priority for orders going to
   * this destination
   */
  defOrderPri?: Maybe<SortEnumType>;
  /** Despatch method to be invoked */
  despMethod?: Maybe<SortEnumType>;
  /**
   * Transit lifetime from despatch to destination
   * (in days)
   */
  transitTime?: Maybe<SortEnumType>;
  /**
   * Default despatch lane for orders going to this
   * destination
   */
  defDespLane?: Maybe<SortEnumType>;
  /**
   * How often orders are despatched to this
   * destination
   */
  orderFreq?: Maybe<SortEnumType>;
  /**
   * Day that orders are despatched to this
   * destination
   */
  orderDay?: Maybe<SortEnumType>;
  /** Default special instructions */
  defSpecIns?: Maybe<SortEnumType>;
  /** Minimum pick value */
  minPickValue?: Maybe<SortEnumType>;
  /**
   * Requires a manifest to be sent along
   * with goods despatched
   */
  reqManifest?: Maybe<SortEnumType>;
  /** Use pallet method at Box packing */
  usePalletMethod?: Maybe<SortEnumType>;
  /** Pallet method to be invoked */
  palletMethod?: Maybe<SortEnumType>;
  /** Create ASN for orders despatched */
  ASNOnDespatch?: Maybe<SortEnumType>;
  /** ASN method to be invoked */
  ASNMethod?: Maybe<SortEnumType>;
  /** Capture serial numbers on despatch */
  captureSerialOnDesp?: Maybe<SortEnumType>;
  /** Suppress back order closure on Load close */
  suppressBackOrdClose?: Maybe<SortEnumType>;
  /** Prevent pick consolidation */
  noPickConsolidation?: Maybe<SortEnumType>;
};

/** A connection to a list of items. */
export type DestinationsConnection = {
  __typename?: 'DestinationsConnection';
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A list of edges. */
  edges?: Maybe<Array<DestinationsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<Destination>>>;
  totalCount: Scalars['Int'];
};

export type DestinationUpdateInput = {
  code?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  address?: Maybe<AddressUpdateInput>;
  status?: Maybe<State>;
  contact?: Maybe<ContactUpdateInput>;
  salesman?: Maybe<Scalars['String']>;
  VATNo?: Maybe<Scalars['String']>;
  facility?: Maybe<Scalars['String']>;
  category?: Maybe<Scalars['String']>;
  stockOwnerId?: Maybe<Scalars['Int']>;
  owner?: Maybe<StockOwnerUpdateInput>;
  masterAcc?: Maybe<Scalars['String']>;
  budgetholder?: Maybe<Scalars['String']>;
  area?: Maybe<Scalars['String']>;
  defRoute?: Maybe<Scalars['String']>;
  pickLocation?: Maybe<Scalars['String']>;
  custStkCodeOnDespNotes?: Maybe<Scalars['Boolean']>;
  despNoteFormat?: Maybe<Scalars['Int']>;
  printNotesDelayDesp?: Maybe<Scalars['Boolean']>;
  noDespNotes?: Maybe<Scalars['Boolean']>;
  printBoxNotes?: Maybe<Scalars['Boolean']>;
  printBoxLbls?: Maybe<Scalars['Boolean']>;
  FTPAcc?: Maybe<Scalars['String']>;
  depot?: Maybe<Scalars['String']>;
  masterHub?: Maybe<Scalars['String']>;
  subHub?: Maybe<Scalars['String']>;
  GLN?: Maybe<Scalars['String']>;
  customsId?: Maybe<Scalars['String']>;
  defDelGroup?: Maybe<Scalars['String']>;
  despNoteEmail?: Maybe<Scalars['String']>;
  useDespMethMBP?: Maybe<Scalars['Boolean']>;
  defOrderType?: Maybe<Scalars['String']>;
  defOrderPri?: Maybe<Scalars['String']>;
  despMethod?: Maybe<Scalars['String']>;
  transitTime?: Maybe<Scalars['Int']>;
  defDespLane?: Maybe<Scalars['String']>;
  orderFreq?: Maybe<Frequency>;
  orderDay?: Maybe<DayOfWeek>;
  defSpecIns?: Maybe<Scalars['String']>;
  minPickValue?: Maybe<Scalars['Int']>;
  reqManifest?: Maybe<Scalars['Boolean']>;
  usePalletMethod?: Maybe<Scalars['Boolean']>;
  palletMethod?: Maybe<Scalars['String']>;
  ASNOnDespatch?: Maybe<Scalars['Boolean']>;
  ASNMethod?: Maybe<Scalars['String']>;
  captureSerialOnDesp?: Maybe<Scalars['Boolean']>;
  suppressBackOrdClose?: Maybe<Scalars['Boolean']>;
  noPickConsolidation?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['Int']>;
};

export type DestinationRouteUpdateInput = {
  route?: Maybe<Scalars['String']>;
  days?: Maybe<Array<DayOfWeek>>;
  dropNumber?: Maybe<Scalars['Int']>;
  frequency?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

export type DestinationBudgetUpdateInput = {
  startDate: Scalars['DateTime'];
  maxSpend?: Maybe<Scalars['Decimal']>;
  spent?: Maybe<Scalars['Decimal']>;
  id?: Maybe<Scalars['Int']>;
};

export type MaterialHandlingEquipmentSortInput = {
  id?: Maybe<SortEnumType>;
  code?: Maybe<SortEnumType>;
  description?: Maybe<SortEnumType>;
  /** Maximum weight this MHE can handle */
  maximumWeight?: Maybe<SortEnumType>;
  /** Nominal width of MHE. */
  width?: Maybe<SortEnumType>;
  /** Maximum location elevation accessible from this MHE. */
  heightLimit?: Maybe<SortEnumType>;
  /** The class of MHE. This determines available processes. */
  class?: Maybe<SortEnumType>;
};

/** A connection to a list of items. */
export type MaterialHandlingEquipmentConnection = {
  __typename?: 'MaterialHandlingEquipmentConnection';
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A list of edges. */
  edges?: Maybe<Array<MaterialHandlingEquipmentEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<MaterialHandlingEquipment>>>;
  totalCount: Scalars['Int'];
};

export type MaterialHandlingEquipmentUpdateInput = {
  description?: Maybe<Scalars['String']>;
  maximumWeight?: Maybe<Scalars['Decimal']>;
  width?: Maybe<Scalars['Decimal']>;
  heightLimit?: Maybe<Scalars['Decimal']>;
  class?: Maybe<MheClass>;
  id?: Maybe<Scalars['Int']>;
};

export type UdCodeFilterInput = {
  and?: Maybe<Array<UdCodeFilterInput>>;
  or?: Maybe<Array<UdCodeFilterInput>>;
  id?: Maybe<ComparableNullableOfInt32OperationFilterInput>;
  codeType?: Maybe<StringOperationFilterInput>;
  code?: Maybe<StringOperationFilterInput>;
  description?: Maybe<StringOperationFilterInput>;
  longDescription?: Maybe<StringOperationFilterInput>;
  stockOwnerId?: Maybe<ComparableNullableOfInt32OperationFilterInput>;
  stockOwner?: Maybe<StockOwnerFilterInput>;
};

export type UdCodeSortInput = {
  id?: Maybe<SortEnumType>;
  codeType?: Maybe<SortEnumType>;
  code?: Maybe<SortEnumType>;
  description?: Maybe<SortEnumType>;
  longDescription?: Maybe<SortEnumType>;
  stockOwnerId?: Maybe<SortEnumType>;
  stockOwner?: Maybe<StockOwnerSortInput>;
};

export type CodeDefinitionFilterInput = {
  and?: Maybe<Array<CodeDefinitionFilterInput>>;
  or?: Maybe<Array<CodeDefinitionFilterInput>>;
  description?: Maybe<StringOperationFilterInput>;
  name?: Maybe<StringOperationFilterInput>;
  id?: Maybe<ComparableInt32OperationFilterInput>;
};

export type CodeDefinitionSortInput = {
  description?: Maybe<SortEnumType>;
  name?: Maybe<SortEnumType>;
  id?: Maybe<SortEnumType>;
};

/** A connection to a list of items. */
export type CodesConnection = {
  __typename?: 'CodesConnection';
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A list of edges. */
  edges?: Maybe<Array<CodesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<UdCode>>>;
  totalCount: Scalars['Int'];
};

/** A connection to a list of items. */
export type CodesForTypeConnection = {
  __typename?: 'CodesForTypeConnection';
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A list of edges. */
  edges?: Maybe<Array<CodesForTypeEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<UdCode>>>;
  totalCount: Scalars['Int'];
};

/** A connection to a list of items. */
export type CodeDefinitionsConnection = {
  __typename?: 'CodeDefinitionsConnection';
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A list of edges. */
  edges?: Maybe<Array<CodeDefinitionsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<CodeDefinition>>>;
  totalCount: Scalars['Int'];
};

export type UdCodeUpdateInput = {
  codeType?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  longDescription?: Maybe<Scalars['String']>;
  stockOwnerId?: Maybe<Scalars['Int']>;
  stockOwner?: Maybe<StockOwnerUpdateInput>;
  id?: Maybe<Scalars['Int']>;
};

export type CountryFilterInput = {
  and?: Maybe<Array<CountryFilterInput>>;
  or?: Maybe<Array<CountryFilterInput>>;
  id?: Maybe<ComparableInt32OperationFilterInput>;
  code?: Maybe<StringOperationFilterInput>;
  name?: Maybe<StringOperationFilterInput>;
  currency?: Maybe<StringOperationFilterInput>;
  depotId?: Maybe<StringOperationFilterInput>;
  groupCode?: Maybe<StringOperationFilterInput>;
  typeCode?: Maybe<StringOperationFilterInput>;
  iSO3?: Maybe<StringOperationFilterInput>;
  iSO2?: Maybe<StringOperationFilterInput>;
  iSONumber?: Maybe<ComparableNullableOfInt32OperationFilterInput>;
};

export type CountrySortInput = {
  id?: Maybe<SortEnumType>;
  code?: Maybe<SortEnumType>;
  name?: Maybe<SortEnumType>;
  currency?: Maybe<SortEnumType>;
  depotId?: Maybe<SortEnumType>;
  groupCode?: Maybe<SortEnumType>;
  typeCode?: Maybe<SortEnumType>;
  iSO3?: Maybe<SortEnumType>;
  iSO2?: Maybe<SortEnumType>;
  iSONumber?: Maybe<SortEnumType>;
};

/** A connection to a list of items. */
export type CountriesConnection = {
  __typename?: 'CountriesConnection';
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A list of edges. */
  edges?: Maybe<Array<CountriesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<Country>>>;
  totalCount: Scalars['Int'];
};

export type CarrierFilterInput = {
  and?: Maybe<Array<CarrierFilterInput>>;
  or?: Maybe<Array<CarrierFilterInput>>;
  id?: Maybe<ComparableNullableOfInt32OperationFilterInput>;
  code?: Maybe<StringOperationFilterInput>;
  name?: Maybe<StringOperationFilterInput>;
  module?: Maybe<StringOperationFilterInput>;
  telephone?: Maybe<StringOperationFilterInput>;
  defDespatchLane?: Maybe<StringOperationFilterInput>;
  requireService?: Maybe<BooleanOperationFilterInput>;
  captureDelNo?: Maybe<BooleanOperationFilterInput>;
  defService?: Maybe<StringOperationFilterInput>;
  services?: Maybe<ListFilterInputTypeOfCarrierServiceFilterInput>;
  accounts?: Maybe<ListFilterInputTypeOfCarrierAccountFilterInput>;
};

export type CarrierSortInput = {
  id?: Maybe<SortEnumType>;
  code?: Maybe<SortEnumType>;
  name?: Maybe<SortEnumType>;
  module?: Maybe<SortEnumType>;
  telephone?: Maybe<SortEnumType>;
  defDespatchLane?: Maybe<SortEnumType>;
  requireService?: Maybe<SortEnumType>;
  captureDelNo?: Maybe<SortEnumType>;
  defService?: Maybe<SortEnumType>;
};

/** A connection to a list of items. */
export type CarriersConnection = {
  __typename?: 'CarriersConnection';
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A list of edges. */
  edges?: Maybe<Array<CarriersEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<Carrier>>>;
  totalCount: Scalars['Int'];
};

export type CarrierUpdateInput = {
  id?: Maybe<Scalars['Int']>;
  code?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  module?: Maybe<Scalars['String']>;
  telephone?: Maybe<Scalars['String']>;
  defDespatchLane?: Maybe<Scalars['String']>;
  requireService?: Maybe<Scalars['Boolean']>;
  captureDelNo?: Maybe<Scalars['Boolean']>;
  defService?: Maybe<Scalars['String']>;
};

export type CarrierServiceUpdateInput = {
  id?: Maybe<Scalars['Int']>;
  code?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  references?: Maybe<Array<Maybe<Scalars['String']>>>;
  maxWeight?: Maybe<Scalars['Decimal']>;
  maxHeight?: Maybe<Scalars['Decimal']>;
  maxWidth?: Maybe<Scalars['Decimal']>;
  maxLength?: Maybe<Scalars['Decimal']>;
  nextDay?: Maybe<Scalars['Boolean']>;
  saturday?: Maybe<Scalars['Boolean']>;
  sunday?: Maybe<Scalars['Boolean']>;
  collection?: Maybe<Scalars['Boolean']>;
  localCollect?: Maybe<Scalars['Boolean']>;
  signReq?: Maybe<Scalars['Boolean']>;
  trackingReq?: Maybe<Scalars['Boolean']>;
  recordDelivery?: Maybe<Scalars['Boolean']>;
  notifySMS?: Maybe<Scalars['Boolean']>;
  notifyEmail?: Maybe<Scalars['Boolean']>;
  extraBoxInfo?: Maybe<Scalars['Boolean']>;
};

export type CarrierAccountUpdateInput = {
  id?: Maybe<Scalars['Int']>;
  account?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  allowedServices?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type CarrierConfigUpdateInput = {
  value?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
};

export type WmsUserSortInput = {
  concurrencyStamp?: Maybe<SortEnumType>;
  emailConfirmed?: Maybe<SortEnumType>;
  normalizedEmail?: Maybe<SortEnumType>;
  passwordHash?: Maybe<SortEnumType>;
  securityStamp?: Maybe<SortEnumType>;
  forename?: Maybe<SortEnumType>;
  surname?: Maybe<SortEnumType>;
  culture?: Maybe<SortEnumType>;
  id?: Maybe<SortEnumType>;
  userName?: Maybe<SortEnumType>;
  normalizedUserName?: Maybe<SortEnumType>;
  email?: Maybe<SortEnumType>;
  phoneNumber?: Maybe<SortEnumType>;
  phoneNumberConfirmed?: Maybe<SortEnumType>;
  twoFactorEnabled?: Maybe<SortEnumType>;
  lockoutEnd?: Maybe<SortEnumType>;
  lockoutEnabled?: Maybe<SortEnumType>;
  accessFailedCount?: Maybe<SortEnumType>;
};

/** A connection to a list of items. */
export type UsersConnection = {
  __typename?: 'UsersConnection';
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A list of edges. */
  edges?: Maybe<Array<UsersEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<WmsUserResult>>>;
  totalCount: Scalars['Int'];
};

export type TablePresetFilterInput = {
  and?: Maybe<Array<TablePresetFilterInput>>;
  or?: Maybe<Array<TablePresetFilterInput>>;
  id?: Maybe<ComparableNullableOfInt32OperationFilterInput>;
  table?: Maybe<StringOperationFilterInput>;
  userId?: Maybe<StringOperationFilterInput>;
  title?: Maybe<StringOperationFilterInput>;
  columns?: Maybe<ListFilterInputTypeOfTableColumnFilterInput>;
};

export type TablePresetSortInput = {
  id?: Maybe<SortEnumType>;
  table?: Maybe<SortEnumType>;
  userId?: Maybe<SortEnumType>;
  title?: Maybe<SortEnumType>;
};

export type TablePresetResult = TablePreset | DatabaseError | ValidationError;

/** A connection to a list of items. */
export type PresetsForTableConnection = {
  __typename?: 'PresetsForTableConnection';
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A list of edges. */
  edges?: Maybe<Array<PresetsForTableEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<TablePresetResult>>>;
};

export type AuditEntrySortInput = {
  id?: Maybe<SortEnumType>;
  warehouseId?: Maybe<SortEnumType>;
  warehouse?: Maybe<WarehouseSortInput>;
  stockOwnerId?: Maybe<SortEnumType>;
  stockOwner?: Maybe<StockOwnerSortInput>;
  eventTime?: Maybe<SortEnumType>;
  auditCode?: Maybe<AuditCodeSortInput>;
  code?: Maybe<SortEnumType>;
  userId?: Maybe<SortEnumType>;
  user?: Maybe<WmsUserSortInput>;
  toLocationId?: Maybe<SortEnumType>;
  toLocation?: Maybe<LocationSortInput>;
  fromLocationId?: Maybe<SortEnumType>;
  fromLocation?: Maybe<LocationSortInput>;
  attributeId?: Maybe<SortEnumType>;
  attributes?: Maybe<IwmsAttributesSortInput>;
  status?: Maybe<SortEnumType>;
  packType?: Maybe<SortEnumType>;
  packs?: Maybe<SortEnumType>;
  singles?: Maybe<SortEnumType>;
};

export type AuditCodeSortInput = {
  id?: Maybe<SortEnumType>;
  name?: Maybe<SortEnumType>;
  description?: Maybe<SortEnumType>;
  message?: Maybe<SortEnumType>;
};

/** A connection to a list of items. */
export type AuditsConnection = {
  __typename?: 'AuditsConnection';
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A list of edges. */
  edges?: Maybe<Array<AuditsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<AuditEntry>>>;
  totalCount: Scalars['Int'];
};

/** A connection to a list of items. */
export type AuditCodesConnection = {
  __typename?: 'AuditCodesConnection';
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A list of edges. */
  edges?: Maybe<Array<AuditCodesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<AuditCode>>>;
  totalCount: Scalars['Int'];
};

export enum FileTransmission {
  Ftp = 'FTP',
  Sftp = 'SFTP',
  Smtp = 'SMTP',
  Int = 'INT',
  None = 'NONE'
}

export enum CollectWeight {
  None = 'NONE',
  Carton = 'CARTON',
  Pallet = 'PALLET'
}

export type StorageType = {
  __typename?: 'StorageType';
  MHEs?: Maybe<Array<Maybe<StorageTypeMhe>>>;
  code: Scalars['String'];
  description: Scalars['String'];
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

/** An edge in a connection. */
export type StorageTypesEdge = {
  __typename?: 'StorageTypesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<StorageType>;
};

export type ContactSortInput = {
  name?: Maybe<SortEnumType>;
  telephone?: Maybe<SortEnumType>;
  fax?: Maybe<SortEnumType>;
  email?: Maybe<SortEnumType>;
};

export type AddressSortInput = {
  /** Property or business name */
  name?: Maybe<SortEnumType>;
  /** Street address including house number and road */
  street1?: Maybe<SortEnumType>;
  /** Optional additional street name when Street1 is used for an apartment or block */
  street2?: Maybe<SortEnumType>;
  /** City, Town or Village */
  city?: Maybe<SortEnumType>;
  /** County or State */
  county?: Maybe<SortEnumType>;
  /** Postal or Zip code */
  postCode?: Maybe<SortEnumType>;
  /** Postal Country */
  country?: Maybe<SortEnumType>;
};

/** An edge in a connection. */
export type StockOwnersEdge = {
  __typename?: 'StockOwnersEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<StockOwner>;
};


export type ListFilterInputTypeOfHandlingStorageTypeFilterInput = {
  all?: Maybe<HandlingStorageTypeFilterInput>;
  none?: Maybe<HandlingStorageTypeFilterInput>;
  some?: Maybe<HandlingStorageTypeFilterInput>;
  any?: Maybe<Scalars['Boolean']>;
};

export type HandlingType = {
  __typename?: 'HandlingType';
  id?: Maybe<Scalars['Int']>;
  code: Scalars['String'];
  description: Scalars['String'];
  storageTypes?: Maybe<Array<Maybe<HandlingStorageType>>>;
};

/** An edge in a connection. */
export type HandlingTypesEdge = {
  __typename?: 'HandlingTypesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<HandlingType>;
};

/** An edge in a connection. */
export type WarehousesEdge = {
  __typename?: 'WarehousesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<Warehouse>;
};

export type WarehouseZone = {
  __typename?: 'WarehouseZone';
  id?: Maybe<Scalars['Int']>;
  warehouse?: Maybe<Warehouse>;
  code: Scalars['String'];
  description: Scalars['String'];
  zoneType: Scalars['String'];
};

/** An edge in a connection. */
export type WarehouseZonesEdge = {
  __typename?: 'WarehouseZonesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<WarehouseZone>;
};

export type ListPermissionOperationFilterInput = {
  all?: Maybe<PermissionOperationFilterInput>;
  none?: Maybe<PermissionOperationFilterInput>;
  some?: Maybe<PermissionOperationFilterInput>;
  any?: Maybe<Scalars['Boolean']>;
};

/** An edge in a connection. */
export type UserPermissionsEdge = {
  __typename?: 'UserPermissionsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<UserPermission>;
};

export type DimensionSortInput = {
  height?: Maybe<SortEnumType>;
  width?: Maybe<SortEnumType>;
  depth?: Maybe<SortEnumType>;
  volume?: Maybe<SortEnumType>;
};

/** An edge in a connection. */
export type LocationsEdge = {
  __typename?: 'LocationsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<Location>;
};

/** An edge in a connection. */
export type BudgetHoldersEdge = {
  __typename?: 'BudgetHoldersEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<BudgetHolder>;
};

export type ListFilterInputTypeOfProductCategoryFilterInput = {
  all?: Maybe<ProductCategoryFilterInput>;
  none?: Maybe<ProductCategoryFilterInput>;
  some?: Maybe<ProductCategoryFilterInput>;
  any?: Maybe<Scalars['Boolean']>;
};

export type ListFilterInputTypeOfBomDefinitionFilterInput = {
  all?: Maybe<BomDefinitionFilterInput>;
  none?: Maybe<BomDefinitionFilterInput>;
  some?: Maybe<BomDefinitionFilterInput>;
  any?: Maybe<Scalars['Boolean']>;
};

export type ListFilterInputTypeOfProductSupplierFilterInput = {
  all?: Maybe<ProductSupplierFilterInput>;
  none?: Maybe<ProductSupplierFilterInput>;
  some?: Maybe<ProductSupplierFilterInput>;
  any?: Maybe<Scalars['Boolean']>;
};

export type ListFilterInputTypeOfLpDefinitionFilterInput = {
  all?: Maybe<LpDefinitionFilterInput>;
  none?: Maybe<LpDefinitionFilterInput>;
  some?: Maybe<LpDefinitionFilterInput>;
  any?: Maybe<Scalars['Boolean']>;
};

export type ListFilterInputTypeOfProductBarcodeFilterInput = {
  all?: Maybe<ProductBarcodeFilterInput>;
  none?: Maybe<ProductBarcodeFilterInput>;
  some?: Maybe<ProductBarcodeFilterInput>;
  any?: Maybe<Scalars['Boolean']>;
};

export type ListFilterInputTypeOfProductDocumentFilterInput = {
  all?: Maybe<ProductDocumentFilterInput>;
  none?: Maybe<ProductDocumentFilterInput>;
  some?: Maybe<ProductDocumentFilterInput>;
  any?: Maybe<Scalars['Boolean']>;
};

export type ProductRequiredDataFilterInput = {
  and?: Maybe<Array<ProductRequiredDataFilterInput>>;
  or?: Maybe<Array<ProductRequiredDataFilterInput>>;
  /** Capture Expiry date */
  expiry?: Maybe<NullableOfFieldVisibilityOperationFilterInput>;
  /** Capture Best before data */
  bestBefore?: Maybe<NullableOfFieldVisibilityOperationFilterInput>;
  /** Capture Batch */
  batch?: Maybe<NullableOfFieldVisibilityOperationFilterInput>;
  /** Capture Product status */
  status?: Maybe<NullableOfFieldVisibilityOperationFilterInput>;
  /** Capture Pack Type */
  packType?: Maybe<NullableOfFieldVisibilityOperationFilterInput>;
  /** Capture Handling Type */
  handlingType?: Maybe<NullableOfFieldVisibilityOperationFilterInput>;
  /** Capture Serial Number (Singular) */
  serial?: Maybe<NullableOfFieldVisibilityOperationFilterInput>;
  /** Capture Carton licence plate */
  cartonLP?: Maybe<NullableOfFieldVisibilityOperationFilterInput>;
  /** Capture Pallet licence plate */
  palletLP?: Maybe<NullableOfFieldVisibilityOperationFilterInput>;
  /** Capture Temperature on arrival */
  arrivalTemp?: Maybe<NullableOfFieldVisibilityOperationFilterInput>;
  /** Capture Country of origin */
  originCntry?: Maybe<NullableOfFieldVisibilityOperationFilterInput>;
  /** Capture Additional Batch Information */
  batchInfo?: Maybe<NullableOfFieldVisibilityOperationFilterInput>;
  /** Capture Production date */
  productionDte?: Maybe<NullableOfFieldVisibilityOperationFilterInput>;
  /** Capture Kill date */
  killDte?: Maybe<NullableOfFieldVisibilityOperationFilterInput>;
  /** Capture Slaughter code */
  slaughterCode?: Maybe<NullableOfFieldVisibilityOperationFilterInput>;
  /** Capture Budgetholder */
  budgetHolder?: Maybe<NullableOfFieldVisibilityOperationFilterInput>;
  /** Collect serial numbers (Plural) */
  serials?: Maybe<NullableOfFieldVisibilityOperationFilterInput>;
  /** Collect Weight */
  weight?: Maybe<NullableOfCollectWeightOperationFilterInput>;
};

export type NullableOfBomTypeOperationFilterInput = {
  eq?: Maybe<BomType>;
  neq?: Maybe<BomType>;
  in?: Maybe<Array<Maybe<BomType>>>;
  nin?: Maybe<Array<Maybe<BomType>>>;
};

export type NullableOfRotationRuleOperationFilterInput = {
  eq?: Maybe<RotationRule>;
  neq?: Maybe<RotationRule>;
  in?: Maybe<Array<Maybe<RotationRule>>>;
  nin?: Maybe<Array<Maybe<RotationRule>>>;
};

export type ListFilterInputTypeOfProductPickfaceFilterInput = {
  all?: Maybe<ProductPickfaceFilterInput>;
  none?: Maybe<ProductPickfaceFilterInput>;
  some?: Maybe<ProductPickfaceFilterInput>;
  any?: Maybe<Scalars['Boolean']>;
};

export type ProductRequiredDataSortInput = {
  /** Capture Expiry date */
  expiry?: Maybe<SortEnumType>;
  /** Capture Best before data */
  bestBefore?: Maybe<SortEnumType>;
  /** Capture Batch */
  batch?: Maybe<SortEnumType>;
  /** Capture Product status */
  status?: Maybe<SortEnumType>;
  /** Capture Pack Type */
  packType?: Maybe<SortEnumType>;
  /** Capture Handling Type */
  handlingType?: Maybe<SortEnumType>;
  /** Capture Serial Number (Singular) */
  serial?: Maybe<SortEnumType>;
  /** Capture Carton licence plate */
  cartonLP?: Maybe<SortEnumType>;
  /** Capture Pallet licence plate */
  palletLP?: Maybe<SortEnumType>;
  /** Capture Temperature on arrival */
  arrivalTemp?: Maybe<SortEnumType>;
  /** Capture Country of origin */
  originCntry?: Maybe<SortEnumType>;
  /** Capture Additional Batch Information */
  batchInfo?: Maybe<SortEnumType>;
  /** Capture Production date */
  productionDte?: Maybe<SortEnumType>;
  /** Capture Kill date */
  killDte?: Maybe<SortEnumType>;
  /** Capture Slaughter code */
  slaughterCode?: Maybe<SortEnumType>;
  /** Capture Budgetholder */
  budgetHolder?: Maybe<SortEnumType>;
  /** Collect serial numbers (Plural) */
  serials?: Maybe<SortEnumType>;
  /** Collect Weight */
  weight?: Maybe<SortEnumType>;
};

export type PickMethodSortInput = {
  id?: Maybe<SortEnumType>;
  stockOwner?: Maybe<StockOwnerSortInput>;
  /** Name of the pick method definition */
  name?: Maybe<SortEnumType>;
  /** Should this definition be used by default */
  default?: Maybe<SortEnumType>;
  /** Pre pick creation method to be executed */
  prePickMethod?: Maybe<SortEnumType>;
  /** pick creation method to be executed */
  pickingMethod?: Maybe<SortEnumType>;
  /** post pick creation method to be executed */
  postPickMethod?: Maybe<SortEnumType>;
  /** output method to be executed */
  outputMethod?: Maybe<SortEnumType>;
};

/** An edge in a connection. */
export type ProductEdge = {
  __typename?: 'ProductEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<Product>;
};

export type NullableOfCurrencyOperationFilterInput = {
  eq?: Maybe<Currency>;
  neq?: Maybe<Currency>;
  in?: Maybe<Array<Maybe<Currency>>>;
  nin?: Maybe<Array<Maybe<Currency>>>;
};

export type NullableOfFileTransmissionOperationFilterInput = {
  eq?: Maybe<FileTransmission>;
  neq?: Maybe<FileTransmission>;
  in?: Maybe<Array<Maybe<FileTransmission>>>;
  nin?: Maybe<Array<Maybe<FileTransmission>>>;
};

export type NullableOfFileFormatOperationFilterInput = {
  eq?: Maybe<FileFormat>;
  neq?: Maybe<FileFormat>;
  in?: Maybe<Array<Maybe<FileFormat>>>;
  nin?: Maybe<Array<Maybe<FileFormat>>>;
};

export type ListDayOfWeekOperationFilterInput = {
  all?: Maybe<DayOfWeekOperationFilterInput>;
  none?: Maybe<DayOfWeekOperationFilterInput>;
  some?: Maybe<DayOfWeekOperationFilterInput>;
  any?: Maybe<Scalars['Boolean']>;
};

/** An edge in a connection. */
export type SuppliersEdge = {
  __typename?: 'SuppliersEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<Supplier>;
};

export enum SortOperationKind {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type ExchangeRate = {
  __typename?: 'ExchangeRate';
  id?: Maybe<Scalars['Int']>;
  /** Currency code that is being exchanged from */
  currency: Currency;
  /** Currency code that is being exchanged to */
  target: Currency;
  /** Date from which the rate will be in effect. */
  startDate: Scalars['DateTime'];
  /**
   * Exchange rate for the currency code to the target
   * currency code
   */
  rate: Scalars['Decimal'];
};

/** An edge in a connection. */
export type ExchangeRatesEdge = {
  __typename?: 'ExchangeRatesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<ExchangeRate>;
};

/** An edge in a connection. */
export type ExchangeRatesForCurrencyEdge = {
  __typename?: 'ExchangeRatesForCurrencyEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<ExchangeRate>;
};

export type ListFilterInputTypeOfDestinationRouteFilterInput = {
  all?: Maybe<DestinationRouteFilterInput>;
  none?: Maybe<DestinationRouteFilterInput>;
  some?: Maybe<DestinationRouteFilterInput>;
  any?: Maybe<Scalars['Boolean']>;
};

export type ListFilterInputTypeOfDestinationBudgetFilterInput = {
  all?: Maybe<DestinationBudgetFilterInput>;
  none?: Maybe<DestinationBudgetFilterInput>;
  some?: Maybe<DestinationBudgetFilterInput>;
  any?: Maybe<Scalars['Boolean']>;
};

export type NullableOfFrequencyOperationFilterInput = {
  eq?: Maybe<Frequency>;
  neq?: Maybe<Frequency>;
  in?: Maybe<Array<Maybe<Frequency>>>;
  nin?: Maybe<Array<Maybe<Frequency>>>;
};

export type NullableOfDayOfWeekOperationFilterInput = {
  eq?: Maybe<DayOfWeek>;
  neq?: Maybe<DayOfWeek>;
  in?: Maybe<Array<Maybe<DayOfWeek>>>;
  nin?: Maybe<Array<Maybe<DayOfWeek>>>;
};

export type Destination = {
  __typename?: 'Destination';
  id?: Maybe<Scalars['Int']>;
  code: Scalars['String'];
  name: Scalars['String'];
  address: Address;
  status: State;
  contact?: Maybe<Contact>;
  salesman?: Maybe<Scalars['String']>;
  VATNo?: Maybe<Scalars['String']>;
  facility?: Maybe<Scalars['String']>;
  category?: Maybe<Scalars['String']>;
  stockOwnerId?: Maybe<Scalars['Int']>;
  owner?: Maybe<StockOwner>;
  masterAcc?: Maybe<Scalars['String']>;
  budgetholder?: Maybe<Scalars['String']>;
  area?: Maybe<Scalars['String']>;
  /** Default route for destination */
  defRoute?: Maybe<Scalars['String']>;
  /**
   * Location to pick to (if pick to location flag
   * is set to true)
   */
  pickLocation?: Maybe<Scalars['String']>;
  /** Display customer stock codes on depatch notes */
  custStkCodeOnDespNotes?: Maybe<Scalars['Boolean']>;
  /** Despatch note format */
  despNoteFormat?: Maybe<Scalars['Int']>;
  /** Print despatch notes on delayed despatch */
  printNotesDelayDesp?: Maybe<Scalars['Boolean']>;
  /** Do not print despatch notes */
  noDespNotes?: Maybe<Scalars['Boolean']>;
  /** Print Box Notes */
  printBoxNotes?: Maybe<Scalars['Boolean']>;
  /** Print box Labels */
  printBoxLbls?: Maybe<Scalars['Boolean']>;
  /** FTP Account for despatch notes */
  FTPAcc?: Maybe<Scalars['String']>;
  /** Depot for this destination */
  depot?: Maybe<Scalars['String']>;
  /** Master hub for this destination */
  masterHub?: Maybe<Scalars['String']>;
  /** Sub hub for this destination */
  subHub?: Maybe<Scalars['String']>;
  GLN?: Maybe<Scalars['String']>;
  customsId?: Maybe<Scalars['String']>;
  defDelGroup?: Maybe<Scalars['String']>;
  despNoteEmail?: Maybe<Scalars['String']>;
  useDespMethMBP?: Maybe<Scalars['Boolean']>;
  /** Routing information for this destination */
  routing?: Maybe<Array<Maybe<DestinationRoute>>>;
  /** List of budgets for this destination */
  budgets?: Maybe<Array<Maybe<DestinationBudget>>>;
  /**
   * Default order type for orders going to
   * this destination
   */
  defOrderType?: Maybe<Scalars['String']>;
  /**
   * Default order priority for orders going to
   * this destination
   */
  defOrderPri?: Maybe<Scalars['String']>;
  /** Despatch method to be invoked */
  despMethod?: Maybe<Scalars['String']>;
  /**
   * Transit lifetime from despatch to destination
   * (in days)
   */
  transitTime?: Maybe<Scalars['Int']>;
  /**
   * Default despatch lane for orders going to this
   * destination
   */
  defDespLane?: Maybe<Scalars['String']>;
  /**
   * How often orders are despatched to this
   * destination
   */
  orderFreq?: Maybe<Frequency>;
  /**
   * Day that orders are despatched to this
   * destination
   */
  orderDay?: Maybe<DayOfWeek>;
  /** Default special instructions */
  defSpecIns?: Maybe<Scalars['String']>;
  /** Minimum pick value */
  minPickValue?: Maybe<Scalars['Int']>;
  /**
   * Requires a manifest to be sent along
   * with goods despatched
   */
  reqManifest?: Maybe<Scalars['Boolean']>;
  /** Use pallet method at Box packing */
  usePalletMethod?: Maybe<Scalars['Boolean']>;
  /** Pallet method to be invoked */
  palletMethod?: Maybe<Scalars['String']>;
  /** Create ASN for orders despatched */
  ASNOnDespatch?: Maybe<Scalars['Boolean']>;
  /** ASN method to be invoked */
  ASNMethod?: Maybe<Scalars['String']>;
  /** Capture serial numbers on despatch */
  captureSerialOnDesp?: Maybe<Scalars['Boolean']>;
  /** Suppress back order closure on Load close */
  suppressBackOrdClose?: Maybe<Scalars['Boolean']>;
  /** Prevent pick consolidation */
  noPickConsolidation?: Maybe<Scalars['Boolean']>;
};

/** An edge in a connection. */
export type DestinationsEdge = {
  __typename?: 'DestinationsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<Destination>;
};

export type MaterialHandlingEquipment = {
  __typename?: 'MaterialHandlingEquipment';
  id?: Maybe<Scalars['Int']>;
  code: Scalars['String'];
  description: Scalars['String'];
  /** Maximum weight this MHE can handle */
  maximumWeight?: Maybe<Scalars['Decimal']>;
  /** Nominal width of MHE. */
  width?: Maybe<Scalars['Decimal']>;
  /** Maximum location elevation accessible from this MHE. */
  heightLimit?: Maybe<Scalars['Decimal']>;
  /** The class of MHE. This determines available processes. */
  class: MheClass;
};

/** An edge in a connection. */
export type MaterialHandlingEquipmentEdge = {
  __typename?: 'MaterialHandlingEquipmentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<MaterialHandlingEquipment>;
};

/** An edge in a connection. */
export type CodesEdge = {
  __typename?: 'CodesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<UdCode>;
};

/** An edge in a connection. */
export type CodesForTypeEdge = {
  __typename?: 'CodesForTypeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<UdCode>;
};

/** An edge in a connection. */
export type CodeDefinitionsEdge = {
  __typename?: 'CodeDefinitionsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<CodeDefinition>;
};

export type Country = {
  __typename?: 'Country';
  id: Scalars['Int'];
  code?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  currency?: Maybe<Scalars['String']>;
  depotId?: Maybe<Scalars['String']>;
  groupCode?: Maybe<Scalars['String']>;
  typeCode?: Maybe<Scalars['String']>;
  iSO3?: Maybe<Scalars['String']>;
  iSO2?: Maybe<Scalars['String']>;
  iSONumber?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type CountriesEdge = {
  __typename?: 'CountriesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<Country>;
};

export type ListFilterInputTypeOfCarrierServiceFilterInput = {
  all?: Maybe<CarrierServiceFilterInput>;
  none?: Maybe<CarrierServiceFilterInput>;
  some?: Maybe<CarrierServiceFilterInput>;
  any?: Maybe<Scalars['Boolean']>;
};

export type ListFilterInputTypeOfCarrierAccountFilterInput = {
  all?: Maybe<CarrierAccountFilterInput>;
  none?: Maybe<CarrierAccountFilterInput>;
  some?: Maybe<CarrierAccountFilterInput>;
  any?: Maybe<Scalars['Boolean']>;
};

export type Carrier = {
  __typename?: 'Carrier';
  id?: Maybe<Scalars['Int']>;
  code: Scalars['String'];
  name: Scalars['String'];
  module?: Maybe<Scalars['String']>;
  telephone?: Maybe<Scalars['String']>;
  defDespatchLane?: Maybe<Scalars['String']>;
  requireService?: Maybe<Scalars['Boolean']>;
  captureDelNo?: Maybe<Scalars['Boolean']>;
  defService?: Maybe<Scalars['String']>;
  services?: Maybe<Array<Maybe<CarrierService>>>;
  accounts?: Maybe<Array<Maybe<CarrierAccount>>>;
};

/** An edge in a connection. */
export type CarriersEdge = {
  __typename?: 'CarriersEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<Carrier>;
};

/** An edge in a connection. */
export type UsersEdge = {
  __typename?: 'UsersEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<WmsUserResult>;
};

export type ListFilterInputTypeOfTableColumnFilterInput = {
  all?: Maybe<TableColumnFilterInput>;
  none?: Maybe<TableColumnFilterInput>;
  some?: Maybe<TableColumnFilterInput>;
  any?: Maybe<Scalars['Boolean']>;
};

export type TablePreset = {
  __typename?: 'TablePreset';
  id?: Maybe<Scalars['Int']>;
  table?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  columns?: Maybe<Array<Maybe<TableColumn>>>;
};

/** An edge in a connection. */
export type PresetsForTableEdge = {
  __typename?: 'PresetsForTableEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<TablePresetResult>;
};

export type IwmsAttributesSortInput = {
  id?: Maybe<SortEnumType>;
};

/** An edge in a connection. */
export type AuditsEdge = {
  __typename?: 'AuditsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<AuditEntry>;
};

/** An edge in a connection. */
export type AuditCodesEdge = {
  __typename?: 'AuditCodesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<AuditCode>;
};

export type HandlingStorageTypeFilterInput = {
  and?: Maybe<Array<HandlingStorageTypeFilterInput>>;
  or?: Maybe<Array<HandlingStorageTypeFilterInput>>;
  handlingTypeId?: Maybe<ComparableNullableOfInt32OperationFilterInput>;
  handlingType?: Maybe<HandlingTypeFilterInput>;
  storageTypeId?: Maybe<ComparableNullableOfInt32OperationFilterInput>;
  storageType?: Maybe<StorageTypeFilterInput>;
};

export type PermissionOperationFilterInput = {
  eq?: Maybe<Permission>;
  neq?: Maybe<Permission>;
  in?: Maybe<Array<Permission>>;
  nin?: Maybe<Array<Permission>>;
};

export type ProductCategoryFilterInput = {
  and?: Maybe<Array<ProductCategoryFilterInput>>;
  or?: Maybe<Array<ProductCategoryFilterInput>>;
  id?: Maybe<ComparableNullableOfInt32OperationFilterInput>;
  product?: Maybe<ProductFilterInput>;
  /** Name of product product category */
  category?: Maybe<StringOperationFilterInput>;
  /** Value of the product product for this product. */
  attribute?: Maybe<StringOperationFilterInput>;
};

export type BomDefinitionFilterInput = {
  and?: Maybe<Array<BomDefinitionFilterInput>>;
  or?: Maybe<Array<BomDefinitionFilterInput>>;
  id?: Maybe<ComparableNullableOfInt32OperationFilterInput>;
  /** Top level (Parent) SKU */
  parent?: Maybe<ProductFilterInput>;
  /** Id of the component product */
  childId?: Maybe<ComparableNullableOfInt32OperationFilterInput>;
  /** Component that forms part of the parent SKU */
  child?: Maybe<ProductFilterInput>;
  /** Quantity of component that forms part of the parent SKU */
  qty?: Maybe<ComparableNullableOfInt32OperationFilterInput>;
};

export type ProductSupplierFilterInput = {
  and?: Maybe<Array<ProductSupplierFilterInput>>;
  or?: Maybe<Array<ProductSupplierFilterInput>>;
  id?: Maybe<ComparableNullableOfInt32OperationFilterInput>;
  product?: Maybe<ProductFilterInput>;
  /** Id of the supplier */
  supplierId?: Maybe<ComparableNullableOfInt32OperationFilterInput>;
  supplier?: Maybe<SupplierFilterInput>;
  /** id of the associated warehouse */
  warehouseId?: Maybe<ComparableNullableOfInt32OperationFilterInput>;
  warehouse?: Maybe<WarehouseFilterInput>;
  /** Is the supplier active for this product */
  active?: Maybe<BooleanOperationFilterInput>;
};

/**
 * Table containing a list of licence plate definition for the products
 * configured
 */
export type LpDefinitionFilterInput = {
  and?: Maybe<Array<LpDefinitionFilterInput>>;
  or?: Maybe<Array<LpDefinitionFilterInput>>;
  id?: Maybe<ComparableNullableOfInt32OperationFilterInput>;
  product?: Maybe<ProductFilterInput>;
  /** Handling type for licence plate */
  handType?: Maybe<StringOperationFilterInput>;
  /** Pack type for licence plate */
  packType?: Maybe<StringOperationFilterInput>;
  /** Quantity for licence plate */
  quantity?: Maybe<ComparableNullableOfInt32OperationFilterInput>;
  /** Name of document containing stack diagram */
  diagram?: Maybe<StringOperationFilterInput>;
  /** Height of the unit associated with this licence plate */
  height?: Maybe<ComparableNullableOfDecimalOperationFilterInput>;
  /** Width of the unit associated with this licence plate */
  width?: Maybe<ComparableNullableOfDecimalOperationFilterInput>;
  /** Depth of the unit associated with this licence plate */
  depth?: Maybe<ComparableNullableOfDecimalOperationFilterInput>;
  /** Weight of the unit associated with this licence plate */
  weight?: Maybe<ComparableNullableOfDecimalOperationFilterInput>;
  /** Layer quantity */
  layerQty?: Maybe<ComparableNullableOfInt32OperationFilterInput>;
  /** Max layer Quantity */
  maxLayerQty?: Maybe<ComparableNullableOfInt32OperationFilterInput>;
};

export type ProductBarcodeFilterInput = {
  and?: Maybe<Array<ProductBarcodeFilterInput>>;
  or?: Maybe<Array<ProductBarcodeFilterInput>>;
  id?: Maybe<ComparableNullableOfInt32OperationFilterInput>;
  product?: Maybe<ProductFilterInput>;
  /** Code for the barcode */
  barcode?: Maybe<StringOperationFilterInput>;
  /** Symbology of the barcode */
  symbology?: Maybe<StringOperationFilterInput>;
  /** The quantity that the barcode represents */
  factor?: Maybe<ComparableInt32OperationFilterInput>;
  /** the type of unit that this barcode represents */
  unitType?: Maybe<StringOperationFilterInput>;
};

export type ProductDocumentFilterInput = {
  and?: Maybe<Array<ProductDocumentFilterInput>>;
  or?: Maybe<Array<ProductDocumentFilterInput>>;
  id?: Maybe<ComparableNullableOfInt32OperationFilterInput>;
  /** Product associated with this document */
  product?: Maybe<ProductFilterInput>;
  /** Name of the document */
  name?: Maybe<StringOperationFilterInput>;
  /** Type of the document */
  type?: Maybe<StringOperationFilterInput>;
  /** Usage of the document */
  usage?: Maybe<StringOperationFilterInput>;
  /**
   * Date and time the document was uploaded(/changed?)
   * Set by the server
   */
  uploaded?: Maybe<ComparableNullableOfDateTimeOperationFilterInput>;
  /** User who uplaoded the document */
  uploadBy?: Maybe<StringOperationFilterInput>;
};

export type NullableOfCollectWeightOperationFilterInput = {
  eq?: Maybe<CollectWeight>;
  neq?: Maybe<CollectWeight>;
  in?: Maybe<Array<Maybe<CollectWeight>>>;
  nin?: Maybe<Array<Maybe<CollectWeight>>>;
};

export type ProductPickfaceFilterInput = {
  and?: Maybe<Array<ProductPickfaceFilterInput>>;
  or?: Maybe<Array<ProductPickfaceFilterInput>>;
  id?: Maybe<ComparableNullableOfInt32OperationFilterInput>;
  /** Product related to this pick face definition */
  product?: Maybe<ProductFilterInput>;
  /** Warehouse where the pickface is located */
  warehouse?: Maybe<StringOperationFilterInput>;
  /** Budget holder of the pickface */
  budhol?: Maybe<StringOperationFilterInput>;
  /** Location name of the pickface */
  location?: Maybe<StringOperationFilterInput>;
  /** Pickzone of the pickface */
  pickZone?: Maybe<StringOperationFilterInput>;
  /** Maximum quantity allowed in the pickface */
  maxFaceQty?: Maybe<ComparableNullableOfInt32OperationFilterInput>;
  /** minimum quantity in the pickface before a replen is considered */
  replenTriggr?: Maybe<ComparableNullableOfInt32OperationFilterInput>;
  /** Replenishment multiple - replenishments will be in multiples of the quantity specified */
  replenMulti?: Maybe<ComparableNullableOfInt32OperationFilterInput>;
};

export type DestinationRouteFilterInput = {
  and?: Maybe<Array<DestinationRouteFilterInput>>;
  or?: Maybe<Array<DestinationRouteFilterInput>>;
  id?: Maybe<ComparableNullableOfInt32OperationFilterInput>;
  destination?: Maybe<DestinationFilterInput>;
  route?: Maybe<StringOperationFilterInput>;
  days?: Maybe<ListDayOfWeekOperationFilterInput>;
  dropNumber?: Maybe<ComparableNullableOfInt32OperationFilterInput>;
  /** Number of days between each drop off. */
  frequency?: Maybe<ComparableNullableOfInt32OperationFilterInput>;
};

export type DestinationBudgetFilterInput = {
  and?: Maybe<Array<DestinationBudgetFilterInput>>;
  or?: Maybe<Array<DestinationBudgetFilterInput>>;
  id?: Maybe<ComparableNullableOfInt32OperationFilterInput>;
  destination?: Maybe<DestinationFilterInput>;
  /**
   * Date that the budget for this destination
   * starts from
   */
  startDate?: Maybe<ComparableDateTimeOperationFilterInput>;
  /**
   * Maximum amount that can be spent by this
   * destination for this budget
   */
  maxSpend?: Maybe<ComparableNullableOfDecimalOperationFilterInput>;
  /**
   * Current spenditure by this destination
   * on this budget.
   */
  spent?: Maybe<ComparableNullableOfDecimalOperationFilterInput>;
};

export type CarrierServiceFilterInput = {
  and?: Maybe<Array<CarrierServiceFilterInput>>;
  or?: Maybe<Array<CarrierServiceFilterInput>>;
  id?: Maybe<ComparableNullableOfInt32OperationFilterInput>;
  code?: Maybe<StringOperationFilterInput>;
  description?: Maybe<StringOperationFilterInput>;
  references?: Maybe<ListStringOperationFilterInput>;
  maxWeight?: Maybe<ComparableNullableOfDecimalOperationFilterInput>;
  maxHeight?: Maybe<ComparableNullableOfDecimalOperationFilterInput>;
  maxWidth?: Maybe<ComparableNullableOfDecimalOperationFilterInput>;
  maxLength?: Maybe<ComparableNullableOfDecimalOperationFilterInput>;
  nextDay?: Maybe<BooleanOperationFilterInput>;
  saturday?: Maybe<BooleanOperationFilterInput>;
  sunday?: Maybe<BooleanOperationFilterInput>;
  collection?: Maybe<BooleanOperationFilterInput>;
  localCollect?: Maybe<BooleanOperationFilterInput>;
  signReq?: Maybe<BooleanOperationFilterInput>;
  trackingReq?: Maybe<BooleanOperationFilterInput>;
  recordDelivery?: Maybe<BooleanOperationFilterInput>;
  notifySMS?: Maybe<BooleanOperationFilterInput>;
  notifyEmail?: Maybe<BooleanOperationFilterInput>;
  extraBoxInfo?: Maybe<BooleanOperationFilterInput>;
};

export type CarrierAccountFilterInput = {
  and?: Maybe<Array<CarrierAccountFilterInput>>;
  or?: Maybe<Array<CarrierAccountFilterInput>>;
  id?: Maybe<ComparableNullableOfInt32OperationFilterInput>;
  account?: Maybe<StringOperationFilterInput>;
  description?: Maybe<StringOperationFilterInput>;
  allowedServices?: Maybe<ListStringOperationFilterInput>;
  configuration?: Maybe<ListFilterInputTypeOfCarrierConfigFilterInput>;
};

export type TableColumnFilterInput = {
  and?: Maybe<Array<TableColumnFilterInput>>;
  or?: Maybe<Array<TableColumnFilterInput>>;
  id?: Maybe<ComparableNullableOfInt32OperationFilterInput>;
  presetId?: Maybe<ComparableNullableOfInt32OperationFilterInput>;
  preset?: Maybe<TablePresetFilterInput>;
  fieldName?: Maybe<StringOperationFilterInput>;
  displayName?: Maybe<StringOperationFilterInput>;
  columnType?: Maybe<PresetColumnTypeOperationFilterInput>;
  isVisible?: Maybe<BooleanOperationFilterInput>;
  order?: Maybe<ComparableInt32OperationFilterInput>;
};

export type ComparableNullableOfDateTimeOperationFilterInput = {
  eq?: Maybe<Scalars['DateTime']>;
  neq?: Maybe<Scalars['DateTime']>;
  in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  nin?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  gt?: Maybe<Scalars['DateTime']>;
  ngt?: Maybe<Scalars['DateTime']>;
  gte?: Maybe<Scalars['DateTime']>;
  ngte?: Maybe<Scalars['DateTime']>;
  lt?: Maybe<Scalars['DateTime']>;
  nlt?: Maybe<Scalars['DateTime']>;
  lte?: Maybe<Scalars['DateTime']>;
  nlte?: Maybe<Scalars['DateTime']>;
};

export type ListFilterInputTypeOfCarrierConfigFilterInput = {
  all?: Maybe<CarrierConfigFilterInput>;
  none?: Maybe<CarrierConfigFilterInput>;
  some?: Maybe<CarrierConfigFilterInput>;
  any?: Maybe<Scalars['Boolean']>;
};

export type PresetColumnTypeOperationFilterInput = {
  eq?: Maybe<PresetColumnType>;
  neq?: Maybe<PresetColumnType>;
  in?: Maybe<Array<PresetColumnType>>;
  nin?: Maybe<Array<PresetColumnType>>;
};

export type CarrierConfigFilterInput = {
  and?: Maybe<Array<CarrierConfigFilterInput>>;
  or?: Maybe<Array<CarrierConfigFilterInput>>;
  id?: Maybe<ComparableNullableOfInt32OperationFilterInput>;
  setting?: Maybe<StringOperationFilterInput>;
  value?: Maybe<StringOperationFilterInput>;
};

export enum FileFormat {
  Csv = 'CSV',
  Edi = 'EDI',
  Xml = 'XML',
  Json = 'JSON'
}

export type AddressUpdateInput = {
  name?: Maybe<Scalars['String']>;
  street1?: Maybe<Scalars['String']>;
  street2?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  county?: Maybe<Scalars['String']>;
  postCode?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
};

export enum Severity {
  None = 'NONE',
  Fatal = 'FATAL',
  Error = 'ERROR',
  Warning = 'WARNING',
  Info = 'INFO',
  Debug = 'DEBUG',
  Trace = 'TRACE',
  Legacy = 'LEGACY'
}

export type ResourceString = {
  __typename?: 'ResourceString';
  localeId?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type ResourceItem = {
  __typename?: 'ResourceItem';
  resourceId?: Maybe<Scalars['String']>;
  resources?: Maybe<Array<Maybe<BasicResourceItem>>>;
};

export type Dimension = {
  __typename?: 'Dimension';
  height: Scalars['Decimal'];
  width: Scalars['Decimal'];
  depth: Scalars['Decimal'];
  volume: Scalars['Decimal'];
};

export type LpOwner = {
  __typename?: 'LPOwner';
  owner?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
};

export type LicencePlateType = {
  __typename?: 'LicencePlateType';
  id?: Maybe<Scalars['Int']>;
  code?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  size?: Maybe<Dimension>;
  tareWeight?: Maybe<Scalars['Decimal']>;
  material?: Maybe<Scalars['String']>;
  controlled?: Maybe<LpControlType>;
};


export enum PoInstructionType {
  GrInstruction = 'GR_INSTRUCTION',
  Misc = 'MISC'
}

export type UploadFileInfo = {
  __typename?: 'UploadFileInfo';
  filename?: Maybe<Scalars['String']>;
  mimeType?: Maybe<Scalars['String']>;
  fileSize?: Maybe<Scalars['Long']>;
  preview?: Maybe<PreviewTable>;
};

export type TablePresetInput = {
  id?: Maybe<Scalars['Int']>;
  table?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  columns?: Maybe<Array<Maybe<TableColumnInput>>>;
};

export type UserUpdateInput = {
  forename?: Maybe<Scalars['String']>;
  surname?: Maybe<Scalars['String']>;
  culture?: Maybe<Scalars['String']>;
  twoFactorEnabled?: Maybe<Scalars['Boolean']>;
  phoneNumber?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  userName?: Maybe<Scalars['String']>;
  lockoutEnabled?: Maybe<Scalars['Boolean']>;
  serverRole?: Maybe<ServerPermission>;
  userPermissions?: Maybe<UpdateCollectionOfUserPermissionInput>;
  userMenus?: Maybe<UpdateCollectionOfMenuEntryInput>;
};

export type UserInput = {
  forename?: Maybe<Scalars['String']>;
  surname?: Maybe<Scalars['String']>;
  culture?: Maybe<Scalars['String']>;
  twoFactorEnabled?: Maybe<Scalars['Boolean']>;
  phoneNumber?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  userName?: Maybe<Scalars['String']>;
  lockoutEnabled?: Maybe<Scalars['Boolean']>;
  serverRole: ServerPermission;
  userPermissions?: Maybe<UpdateCollectionOfUserPermissionInput>;
  userMenus?: Maybe<UpdateCollectionOfMenuEntryInput>;
};

export type CarrierConfigInput = {
  id?: Maybe<Scalars['Int']>;
  setting: Scalars['String'];
  value: Scalars['String'];
};

export type CarrierConfig = {
  __typename?: 'CarrierConfig';
  id?: Maybe<Scalars['Int']>;
  setting: Scalars['String'];
  value: Scalars['String'];
};

export type CarrierAccountInput = {
  id?: Maybe<Scalars['Int']>;
  account: Scalars['String'];
  description: Scalars['String'];
  allowedServices?: Maybe<Array<Maybe<Scalars['String']>>>;
  configuration?: Maybe<Array<Maybe<CarrierConfigInput>>>;
};

export type CarrierAccount = {
  __typename?: 'CarrierAccount';
  id?: Maybe<Scalars['Int']>;
  account: Scalars['String'];
  description: Scalars['String'];
  allowedServices?: Maybe<Array<Maybe<Scalars['String']>>>;
  configuration?: Maybe<Array<Maybe<CarrierConfig>>>;
};

export type CarrierServiceInput = {
  id?: Maybe<Scalars['Int']>;
  code: Scalars['String'];
  description: Scalars['String'];
  references?: Maybe<Array<Maybe<Scalars['String']>>>;
  maxWeight: Scalars['Int'];
  maxHeight: Scalars['Int'];
  maxWidth: Scalars['Int'];
  maxLength: Scalars['Int'];
  nextDay?: Maybe<Scalars['Boolean']>;
  saturday?: Maybe<Scalars['Boolean']>;
  sunday?: Maybe<Scalars['Boolean']>;
  collection?: Maybe<Scalars['Boolean']>;
  localCollect?: Maybe<Scalars['Boolean']>;
  signReq?: Maybe<Scalars['Boolean']>;
  trackingReq?: Maybe<Scalars['Boolean']>;
  recordDelivery?: Maybe<Scalars['Boolean']>;
  notifySMS?: Maybe<Scalars['Boolean']>;
  notifyEmail?: Maybe<Scalars['Boolean']>;
  extraBoxInfo?: Maybe<Scalars['Boolean']>;
};

export type CarrierService = {
  __typename?: 'CarrierService';
  id?: Maybe<Scalars['Int']>;
  code: Scalars['String'];
  description: Scalars['String'];
  references?: Maybe<Array<Maybe<Scalars['String']>>>;
  maxWeight?: Maybe<Scalars['Decimal']>;
  maxHeight?: Maybe<Scalars['Decimal']>;
  maxWidth?: Maybe<Scalars['Decimal']>;
  maxLength?: Maybe<Scalars['Decimal']>;
  nextDay?: Maybe<Scalars['Boolean']>;
  saturday?: Maybe<Scalars['Boolean']>;
  sunday?: Maybe<Scalars['Boolean']>;
  collection?: Maybe<Scalars['Boolean']>;
  localCollect?: Maybe<Scalars['Boolean']>;
  signReq?: Maybe<Scalars['Boolean']>;
  trackingReq?: Maybe<Scalars['Boolean']>;
  recordDelivery?: Maybe<Scalars['Boolean']>;
  notifySMS?: Maybe<Scalars['Boolean']>;
  notifyEmail?: Maybe<Scalars['Boolean']>;
  extraBoxInfo?: Maybe<Scalars['Boolean']>;
};

export type CarrierInput = {
  id?: Maybe<Scalars['Int']>;
  code: Scalars['String'];
  name: Scalars['String'];
  module?: Maybe<Scalars['String']>;
  telephone?: Maybe<Scalars['String']>;
  defDespatchLane?: Maybe<Scalars['String']>;
  requireService?: Maybe<Scalars['Boolean']>;
  captureDelNo?: Maybe<Scalars['Boolean']>;
  defService?: Maybe<Scalars['String']>;
  services?: Maybe<Array<Maybe<CarrierServiceInput>>>;
  accounts?: Maybe<Array<Maybe<CarrierAccountInput>>>;
};

export type ConfigOption = {
  __typename?: 'ConfigOption';
  label?: Maybe<Scalars['String']>;
  settingName?: Maybe<Scalars['String']>;
  position?: Maybe<Array<Scalars['Int']>>;
  type?: Maybe<Scalars['String']>;
  overrideRequired: Scalars['Boolean'];
};

export enum Frequency {
  Daily = 'DAILY',
  Weekly = 'WEEKLY',
  BiWeekly = 'BI_WEEKLY',
  Monthly = 'MONTHLY'
}

export type TableColumn = {
  __typename?: 'TableColumn';
  id?: Maybe<Scalars['Int']>;
  presetId?: Maybe<Scalars['Int']>;
  preset?: Maybe<TablePresetResult>;
  fieldName?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  columnType: PresetColumnType;
  isVisible: Scalars['Boolean'];
  order: Scalars['Int'];
};

export type UdCodeInput = {
  id?: Maybe<Scalars['Int']>;
  codeType?: Maybe<Scalars['String']>;
  code: Scalars['String'];
  description: Scalars['String'];
  longDescription?: Maybe<Scalars['String']>;
  stockOwnerId?: Maybe<Scalars['Int']>;
  stockOwner?: Maybe<StockOwnerInput>;
};

export type MaterialHandlingEquipmentInput = {
  id?: Maybe<Scalars['Int']>;
  code: Scalars['String'];
  description: Scalars['String'];
  /** Maximum weight this MHE can handle */
  maximumWeight?: Maybe<Scalars['Decimal']>;
  /** Nominal width of MHE. */
  width?: Maybe<Scalars['Decimal']>;
  /** Maximum location elevation accessible from this MHE. */
  heightLimit?: Maybe<Scalars['Decimal']>;
  /** The class of MHE. This determines available processes. */
  class: MheClass;
};

export enum PresetColumnType {
  Normal = 'NORMAL',
  Tags = 'TAGS',
  Input = 'INPUT',
  Number = 'NUMBER',
  Custom = 'CUSTOM'
}

export type DestinationBudgetInput = {
  id?: Maybe<Scalars['Int']>;
  destination?: Maybe<DestinationInput>;
  /**
   * Date that the budget for this destination
   * starts from
   */
  startDate: Scalars['DateTime'];
  /**
   * Maximum amount that can be spent by this
   * destination for this budget
   */
  maxSpend: Scalars['Decimal'];
  /**
   * Current spenditure by this destination
   * on this budget.
   */
  spent: Scalars['Int'];
};

export type DestinationBudget = {
  __typename?: 'DestinationBudget';
  id?: Maybe<Scalars['Int']>;
  destination?: Maybe<Destination>;
  /**
   * Date that the budget for this destination
   * starts from
   */
  startDate: Scalars['DateTime'];
  /**
   * Maximum amount that can be spent by this
   * destination for this budget
   */
  maxSpend: Scalars['Decimal'];
  /**
   * Current spenditure by this destination
   * on this budget.
   */
  spent?: Maybe<Scalars['Decimal']>;
};

export type DestinationRouteInput = {
  id?: Maybe<Scalars['Int']>;
  destination?: Maybe<DestinationInput>;
  route: Scalars['String'];
  days?: Maybe<Array<DayOfWeek>>;
  dropNumber?: Maybe<Scalars['Int']>;
  /** Number of days between each drop off. */
  frequency?: Maybe<Scalars['Int']>;
};

export type DestinationRoute = {
  __typename?: 'DestinationRoute';
  id?: Maybe<Scalars['Int']>;
  destination?: Maybe<Destination>;
  route: Scalars['String'];
  days?: Maybe<Array<DayOfWeek>>;
  dropNumber?: Maybe<Scalars['Int']>;
  /** Number of days between each drop off. */
  frequency?: Maybe<Scalars['Int']>;
};

export type DestinationInput = {
  id?: Maybe<Scalars['Int']>;
  code: Scalars['String'];
  name: Scalars['String'];
  address: AddressInput;
  status: State;
  contact?: Maybe<ContactInput>;
  salesman?: Maybe<Scalars['String']>;
  VATNo?: Maybe<Scalars['String']>;
  facility?: Maybe<Scalars['String']>;
  category?: Maybe<Scalars['String']>;
  stockOwnerId?: Maybe<Scalars['Int']>;
  owner?: Maybe<StockOwnerInput>;
  masterAcc?: Maybe<Scalars['String']>;
  budgetholder?: Maybe<Scalars['String']>;
  area?: Maybe<Scalars['String']>;
  /** Default route for destination */
  defRoute?: Maybe<Scalars['String']>;
  /**
   * Location to pick to (if pick to location flag
   * is set to true)
   */
  pickLocation?: Maybe<Scalars['String']>;
  /** Display customer stock codes on depatch notes */
  custStkCodeOnDespNotes: Scalars['Boolean'];
  /** Despatch note format */
  despNoteFormat?: Maybe<Scalars['Int']>;
  /** Print despatch notes on delayed despatch */
  printNotesDelayDesp: Scalars['Boolean'];
  /** Do not print despatch notes */
  noDespNotes: Scalars['Boolean'];
  /** Print Box Notes */
  printBoxNotes: Scalars['Boolean'];
  /** Print box Labels */
  printBoxLbls: Scalars['Boolean'];
  /** FTP Account for despatch notes */
  FTPAcc?: Maybe<Scalars['String']>;
  /** Depot for this destination */
  depot?: Maybe<Scalars['String']>;
  /** Master hub for this destination */
  masterHub?: Maybe<Scalars['String']>;
  /** Sub hub for this destination */
  subHub?: Maybe<Scalars['String']>;
  GLN?: Maybe<Scalars['String']>;
  customsId?: Maybe<Scalars['String']>;
  defDelGroup?: Maybe<Scalars['String']>;
  despNoteEmail?: Maybe<Scalars['String']>;
  useDespMethMBP: Scalars['Boolean'];
  /** Routing information for this destination */
  routing?: Maybe<Array<Maybe<DestinationRouteInput>>>;
  /** List of budgets for this destination */
  budgets?: Maybe<Array<Maybe<DestinationBudgetInput>>>;
  /**
   * Default order type for orders going to
   * this destination
   */
  defOrderType?: Maybe<Scalars['String']>;
  /**
   * Default order priority for orders going to
   * this destination
   */
  defOrderPri?: Maybe<Scalars['String']>;
  /** Despatch method to be invoked */
  despMethod?: Maybe<Scalars['String']>;
  /**
   * Transit lifetime from despatch to destination
   * (in days)
   */
  transitTime?: Maybe<Scalars['Int']>;
  /**
   * Default despatch lane for orders going to this
   * destination
   */
  defDespLane?: Maybe<Scalars['String']>;
  /**
   * How often orders are despatched to this
   * destination
   */
  orderFreq?: Maybe<Frequency>;
  /**
   * Day that orders are despatched to this
   * destination
   */
  orderDay?: Maybe<DayOfWeek>;
  /** Default special instructions */
  defSpecIns?: Maybe<Scalars['String']>;
  /** Minimum pick value */
  minPickValue?: Maybe<Scalars['Int']>;
  /**
   * Requires a manifest to be sent along
   * with goods despatched
   */
  reqManifest: Scalars['Boolean'];
  /** Use pallet method at Box packing */
  usePalletMethod: Scalars['Boolean'];
  /** Pallet method to be invoked */
  palletMethod?: Maybe<Scalars['String']>;
  /** Create ASN for orders despatched */
  ASNOnDespatch: Scalars['Boolean'];
  /** ASN method to be invoked */
  ASNMethod?: Maybe<Scalars['String']>;
  /** Capture serial numbers on despatch */
  captureSerialOnDesp: Scalars['Boolean'];
  /** Suppress back order closure on Load close */
  suppressBackOrdClose: Scalars['Boolean'];
  /** Prevent pick consolidation */
  noPickConsolidation: Scalars['Boolean'];
};

export type ExchangeRateInput = {
  id?: Maybe<Scalars['Int']>;
  /** Currency code that is being exchanged from */
  currency: Currency;
  /** Currency code that is being exchanged to */
  target: Currency;
  /** Date from which the rate will be in effect. */
  startDate: Scalars['DateTime'];
  /**
   * Exchange rate for the currency code to the target
   * currency code
   */
  rate: Scalars['Decimal'];
};

export type SupplierInput = {
  id?: Maybe<Scalars['Int']>;
  /** Internal code of the supplier */
  code: Scalars['String'];
  /** Master supplier */
  master?: Maybe<Scalars['String']>;
  /** Name of the supplier */
  name: Scalars['String'];
  /** The main address of the supplier */
  address: AddressInput;
  /** Currency used by the supplier */
  currency?: Maybe<Currency>;
  /**
   * File Transmission Method.
   * Default value of None.
   */
  fileTransMeth?: Maybe<FileTransmission>;
  /** File Format */
  fileFormat?: Maybe<FileFormat>;
  /** Must order in layer quantities */
  mustOrderLayerQty: Scalars['Boolean'];
  /** Maximum weekly spend */
  maxWeekSpend: Scalars['Int'];
  /** Lead Time in Days */
  leadTime: Scalars['Int'];
  orderDays?: Maybe<Array<DayOfWeek>>;
};

export type ProductDocumentInput = {
  id?: Maybe<Scalars['Int']>;
  /** Product associated with this document */
  product?: Maybe<ProductInput>;
  /** Name of the document */
  name: Scalars['String'];
  /** Type of the document */
  type?: Maybe<Scalars['String']>;
  /** Usage of the document */
  usage?: Maybe<Scalars['String']>;
  /**
   * Date and time the document was uploaded(/changed?)
   * Set by the server
   */
  uploaded?: Maybe<Scalars['DateTime']>;
  /** User who uplaoded the document */
  uploadBy?: Maybe<Scalars['String']>;
};

export type ProductBarcodeInput = {
  id?: Maybe<Scalars['Int']>;
  product?: Maybe<ProductInput>;
  /** Code for the barcode */
  barcode: Scalars['String'];
  /** Symbology of the barcode */
  symbology?: Maybe<Scalars['String']>;
  /** The quantity that the barcode represents */
  factor: Scalars['Int'];
  /** the type of unit that this barcode represents */
  unitType?: Maybe<Scalars['String']>;
};

/**
 * Table containing a list of licence plate definition for the products
 * configured
 */
export type LpDefinitionInput = {
  id?: Maybe<Scalars['Int']>;
  product?: Maybe<ProductInput>;
  /** Handling type for licence plate */
  handType: Scalars['String'];
  /** Pack type for licence plate */
  packType?: Maybe<Scalars['String']>;
  /** Quantity for licence plate */
  quantity: Scalars['Int'];
  /** Name of document containing stack diagram */
  diagram?: Maybe<Scalars['String']>;
  /** Height of the unit associated with this licence plate */
  height: Scalars['Int'];
  /** Width of the unit associated with this licence plate */
  width: Scalars['Int'];
  /** Depth of the unit associated with this licence plate */
  depth: Scalars['Int'];
  /** Weight of the unit associated with this licence plate */
  weight: Scalars['Int'];
  /** Layer quantity */
  layerQty: Scalars['Int'];
  /** Max layer Quantity */
  maxLayerQty: Scalars['Int'];
};

export type ProductSupplierInput = {
  id?: Maybe<Scalars['Int']>;
  product?: Maybe<ProductInput>;
  /** Id of the supplier */
  supplierId: Scalars['Int'];
  supplier?: Maybe<SupplierInput>;
  /** id of the associated warehouse */
  warehouseId?: Maybe<Scalars['Int']>;
  warehouse?: Maybe<WarehouseInput>;
  /** Is the supplier active for this product */
  active: Scalars['Boolean'];
};

export type ProductPickfaceInput = {
  id?: Maybe<Scalars['Int']>;
  /** Product related to this pick face definition */
  product?: Maybe<ProductInput>;
  /** Warehouse where the pickface is located */
  warehouse: Scalars['String'];
  /** Budget holder of the pickface */
  budhol?: Maybe<Scalars['String']>;
  /** Location name of the pickface */
  location?: Maybe<Scalars['String']>;
  /** Pickzone of the pickface */
  pickZone?: Maybe<Scalars['String']>;
  /** Maximum quantity allowed in the pickface */
  maxFaceQty: Scalars['Int'];
  /** minimum quantity in the pickface before a replen is considered */
  replenTriggr: Scalars['Int'];
  /** Replenishment multiple - replenishments will be in multiples of the quantity specified */
  replenMulti?: Maybe<Scalars['Int']>;
};

export type ProductCategoryInput = {
  id?: Maybe<Scalars['Int']>;
  product?: Maybe<ProductInput>;
  /** Name of product product category */
  category: Scalars['String'];
  /** Value of the product product for this product. */
  attribute: Scalars['String'];
};

export type BomDefinitionInput = {
  id?: Maybe<Scalars['Int']>;
  /** Top level (Parent) SKU */
  parent?: Maybe<ProductInput>;
  /** Id of the component product */
  childId: Scalars['Int'];
  /** Component that forms part of the parent SKU */
  child?: Maybe<ProductInput>;
  /** Quantity of component that forms part of the parent SKU */
  qty: Scalars['Int'];
};

export type ProductInput = {
  id?: Maybe<Scalars['Int']>;
  stockOwner?: Maybe<StockOwnerInput>;
  /** The unique code for the product definition */
  code: Scalars['String'];
  /** Alternative code for product */
  altCode?: Maybe<Scalars['String']>;
  /** GTIN (Global Trade Item Number) for product */
  gTIN?: Maybe<Scalars['String']>;
  /** Substitute product */
  substitute?: Maybe<Scalars['String']>;
  /** Description of the product */
  description: Scalars['String'];
  /** Long description of the product */
  longDesc?: Maybe<Scalars['String']>;
  /** Generic linking code for similar products */
  linkCode?: Maybe<Scalars['String']>;
  /**
   * List of categories defined for the product
   * Mutations:
   *
   * CreateProductCategory
   * DeleteProductCategory
   * UpdateProductCategory
   */
  categories?: Maybe<Array<Maybe<ProductCategoryInput>>>;
  /**
   * List of components for the product, should only be populated
   * if the SKUType of the product is set to either STOCK or NONSTOCK.
   * Mutations:
   *
   * CreateBOMDefinition
   * DeleteBOMDefinition
   * UpdateBOMDefinition
   */
  components?: Maybe<Array<Maybe<BomDefinitionInput>>>;
  /**
   * List of suppliers for the product.
   * Mutations:
   *
   * CreateProductSupplier
   * DeleteProductSupplier
   * UpdateProductSupplier
   */
  suppliers?: Maybe<Array<Maybe<ProductSupplierInput>>>;
  /**
   * List of licence plates defined for the product.
   *             Mutations:
   *
   * CreateLPDefinition
   * DeleteLPDefinition
   * UpdateLPDefinition
   */
  licencePlates?: Maybe<Array<Maybe<LpDefinitionInput>>>;
  /**
   * List of barcodes for the product.
   * Mutations:
   *
   * CreateProductBarcode
   * DeleteProductBarcode
   * UpdateProductBarcode
   */
  barcodes?: Maybe<Array<Maybe<ProductBarcodeInput>>>;
  /**
   * List of Documents for the product.
   * Mutations:
   *
   * CreateProductDocument
   * DeleteProductDocument
   * UpdateProductDocument
   */
  documents?: Maybe<Array<Maybe<ProductDocumentInput>>>;
  require?: Maybe<ProductRequiredDataInput>;
  /** BOM type of the product */
  SKUType: BomType;
  /** INCI (International Nomenclature of Cosmetic ingredients) code for product */
  INCICode?: Maybe<Scalars['String']>;
  /** Defines how stock will be used (i.e. for picking) */
  rotation: RotationRule;
  /** Type of the product */
  type?: Maybe<Scalars['String']>;
  /** Storage type of the product */
  StorageType?: Maybe<Scalars['String']>;
  /** Facility category */
  facilityCat?: Maybe<Scalars['String']>;
  /** Default budget holder for the product */
  defBudhol?: Maybe<Scalars['String']>;
  /** Default warehouse for the product */
  defWH?: Maybe<Scalars['String']>;
  /** Default handling type for product */
  defHandType?: Maybe<Scalars['String']>;
  /** Default pack type of the product */
  defPackType?: Maybe<Scalars['String']>;
  /** Department code for the product */
  depCode?: Maybe<Scalars['String']>;
  /** Product rank */
  rank?: Maybe<Scalars['String']>;
  /** UN Code for the product */
  uNCode?: Maybe<Scalars['String']>;
  /** Band Quantity */
  bandQty: Scalars['Int'];
  manufacturerCode?: Maybe<Scalars['String']>;
  /** Life cycle status */
  lifeCycleStatus?: Maybe<Scalars['String']>;
  /** Validate batch at packing */
  packValidateBatch: Scalars['Boolean'];
  /** Collect packing type at packing */
  capturePackType: Scalars['Boolean'];
  /** Pick part pallets as full pallets */
  pickPartPalletsAsFull: Scalars['Boolean'];
  /** Pick in singles */
  pickSingles: Scalars['Boolean'];
  pickDefId?: Maybe<Scalars['Int']>;
  /** Default pick definition for the product */
  defPickDefinition?: Maybe<PickMethodInput>;
  /**
   * List of pickface definitions for the product
   * Mutations:
   *
   * CreateProductPickface
   * DeleteProductPickface
   * UpdateProductPickface
   */
  pickfaces?: Maybe<Array<Maybe<ProductPickfaceInput>>>;
  /** Code for the default goods receipt status */
  defGRStatus: Scalars['String'];
  /** Minimum receipt shelf life */
  minRShlfLife?: Maybe<Scalars['Int']>;
  /** Minimum picking shelf life */
  minPShlfLife?: Maybe<Scalars['Int']>;
  /** Total shelf life */
  totShlfLife?: Maybe<Scalars['Int']>;
};

export type BudgetHolderInput = {
  id?: Maybe<Scalars['Int']>;
  code: Scalars['String'];
  description: Scalars['String'];
  status: State;
  stockOwner?: Maybe<StockOwnerInput>;
  warehouse?: Maybe<WarehouseInput>;
};

export type LocationInput = {
  id?: Maybe<Scalars['Int']>;
  warehouse?: Maybe<WarehouseInput>;
  code: Scalars['String'];
  /** The physical characteristics of the location such as whether it is drive-in or conventional racking */
  physicalCharacteristics: LocationPhysicalType;
  /** The process characteristics of the location such as whether it is uses a a picking face or despatch area */
  processCharacteristics: LocationProcessType;
  /** The storage temperature type of the location. e.g. Ambient, chilled or frozen */
  temperatureType: LocationTemperatureType;
  /** Additional location specific attributes (yet to be defined) */
  attributes?: Maybe<Scalars['String']>;
  storageTypeId: Scalars['Int'];
  storageType?: Maybe<StorageTypeInput>;
  aisle?: Maybe<Scalars['String']>;
  status: LocationStatus;
  checkCode?: Maybe<Scalars['String']>;
  beam?: Maybe<Scalars['String']>;
  beamSequence?: Maybe<Scalars['String']>;
  zone: Scalars['String'];
  countZone?: Maybe<Scalars['String']>;
  tier: Scalars['Int'];
  elevation: Scalars['Decimal'];
  dimensions: DimensionInput;
  maxWeight: Scalars['Decimal'];
  pickZone?: Maybe<Scalars['String']>;
  reservedProductId?: Maybe<Scalars['Int']>;
};

export type UserPermissionInput = {
  id?: Maybe<Scalars['Int']>;
  userId?: Maybe<Scalars['String']>;
  warehouseId?: Maybe<Scalars['Int']>;
  warehouse?: Maybe<WarehouseInput>;
  stockOwnerId?: Maybe<Scalars['Int']>;
  stockOwner?: Maybe<StockOwnerInput>;
  permissions?: Maybe<Array<Permission>>;
};

export type WarehouseZoneInput = {
  id?: Maybe<Scalars['Int']>;
  warehouse?: Maybe<WarehouseInput>;
  code: Scalars['String'];
  description: Scalars['String'];
  zoneType: Scalars['String'];
};

export type WarehouseInput = {
  id?: Maybe<Scalars['Int']>;
  code: Scalars['String'];
  companyName?: Maybe<Scalars['String']>;
  warehouseName: Scalars['String'];
  address: AddressInput;
  telephone?: Maybe<Scalars['String']>;
  VATNumber?: Maybe<Scalars['String']>;
  customsId?: Maybe<Scalars['String']>;
};

export type DimensionUpdateInput = {
  height?: Maybe<Scalars['Decimal']>;
  width?: Maybe<Scalars['Decimal']>;
  depth?: Maybe<Scalars['Decimal']>;
  volume?: Maybe<Scalars['Decimal']>;
  id?: Maybe<Scalars['Int']>;
};

export type HandlingStorageType = {
  __typename?: 'HandlingStorageType';
  handlingTypeId?: Maybe<Scalars['Int']>;
  handlingType?: Maybe<HandlingType>;
  storageTypeId?: Maybe<Scalars['Int']>;
  storageType?: Maybe<StorageType>;
};

export type HandlingTypeInput = {
  id?: Maybe<Scalars['Int']>;
  code: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  storageTypes?: Maybe<Array<Maybe<HandlingStorageTypeInput>>>;
};

export type ProductRequiredDataUpdateInput = {
  expiry?: Maybe<FieldVisibility>;
  bestBefore?: Maybe<FieldVisibility>;
  batch?: Maybe<FieldVisibility>;
  status?: Maybe<FieldVisibility>;
  packType?: Maybe<FieldVisibility>;
  handlingType?: Maybe<FieldVisibility>;
  serial?: Maybe<FieldVisibility>;
  cartonLP?: Maybe<FieldVisibility>;
  palletLP?: Maybe<FieldVisibility>;
  arrivalTemp?: Maybe<FieldVisibility>;
  originCntry?: Maybe<FieldVisibility>;
  batchInfo?: Maybe<FieldVisibility>;
  productionDte?: Maybe<FieldVisibility>;
  killDte?: Maybe<FieldVisibility>;
  slaughterCode?: Maybe<FieldVisibility>;
  budgetHolder?: Maybe<FieldVisibility>;
  serials?: Maybe<FieldVisibility>;
  weight?: Maybe<CollectWeight>;
  id?: Maybe<Scalars['Int']>;
};

export type OrderStatusInput = {
  id?: Maybe<Scalars['Int']>;
  stockOwner?: Maybe<StockOwnerInput>;
  code: Scalars['String'];
  /** Description of the status */
  description: Scalars['String'];
  /** Purpose of the status */
  purpose: OrderStatusPurpose;
};

export type PickConfirmMethodInput = {
  id?: Maybe<Scalars['Int']>;
  stockOwner?: Maybe<StockOwnerInput>;
  /** Name of the pick confirm definition */
  name: Scalars['String'];
  /** Should the definition used by default */
  default: Scalars['Boolean'];
  /** pick confirm method to be executed */
  pickConfMethod?: Maybe<Scalars['String']>;
  /** post confirm method to be executed */
  postConfMethod?: Maybe<Scalars['String']>;
  /** Packing method to be executed */
  packingMethod?: Maybe<Scalars['String']>;
  /** Despatch method to be executed */
  despatchMethod?: Maybe<Scalars['String']>;
  /** Load close method to be executed */
  loadCloseMethod?: Maybe<Scalars['String']>;
};

export type PickMethodInput = {
  id?: Maybe<Scalars['Int']>;
  stockOwner?: Maybe<StockOwnerInput>;
  /** Name of the pick method definition */
  name: Scalars['String'];
  /** Should this definition be used by default */
  default: Scalars['Boolean'];
  /** Pre pick creation method to be executed */
  prePickMethod?: Maybe<Scalars['String']>;
  /** pick creation method to be executed */
  pickingMethod?: Maybe<Scalars['String']>;
  /** post pick creation method to be executed */
  postPickMethod?: Maybe<Scalars['String']>;
  /** output method to be executed */
  outputMethod?: Maybe<Scalars['String']>;
};

export type CategoryDefinitionInput = {
  id?: Maybe<Scalars['Int']>;
  stockOwner?: Maybe<StockOwnerInput>;
  /** Code for the product category */
  code: Scalars['String'];
  /** Description for the category */
  description?: Maybe<Scalars['String']>;
};

export type ProductStatusInput = {
  id?: Maybe<Scalars['Int']>;
  stockOwner?: Maybe<StockOwnerInput>;
  code: Scalars['String'];
  description: Scalars['String'];
  adjustStock: Scalars['Boolean'];
  processStatus: ProductProcessStatus;
  targetStatuses?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type StockOwnerInput = {
  id?: Maybe<Scalars['Int']>;
  /** The unique code for this stock owner */
  code: Scalars['String'];
  /** The name of the stock owner */
  name: Scalars['String'];
  /** The status of the StockOwner. See  for possible values. */
  status: State;
  linkedStockOwners?: Maybe<Array<Maybe<StockOwnerLinkInput>>>;
  /** Contact for the stock owner */
  contact?: Maybe<ContactInput>;
  /** Address of the stock owner */
  address?: Maybe<AddressInput>;
  /** Cold storage ID associated with the stock owner */
  coldStoreID?: Maybe<Scalars['String']>;
  /** GLN (Global Location Number) for the stock owner */
  GLN?: Maybe<Scalars['String']>;
  /** VAT Number for the stock Owner */
  VATNumber?: Maybe<Scalars['String']>;
  /**
   * List of statuses available for the stock associated with the
   * stock owner
   * Mutations:
   *
   * createStockOwnerStatus
   * deleteStockOwnerStatus
   * updateStockOwnerStatus
   */
  productStatuses?: Maybe<Array<Maybe<ProductStatusInput>>>;
  /**
   * List of product categories available for the stock associated with the
   * stock owner
   * Mutations:
   *
   * createStockOwnerCategoryDefinition
   * updateStockOwnerCategoryDefinition
   * deleteStockOwnerCategoryDefinition
   */
  categories?: Maybe<Array<Maybe<CategoryDefinitionInput>>>;
  /**
   * Warn when moving stock to a location that contains
   * a different status
   */
  warnMoveDifStatus: Scalars['Boolean'];
  /** Require budget holder */
  requireBudhol: Scalars['Boolean'];
  /** Require Product categories */
  requireProdCategories: Scalars['Boolean'];
  /** Mask for barcodes that are scanned */
  scanBarcodeMask?: Maybe<Scalars['String']>;
  /** Mask for barcodes that are keyed in */
  keyedBarcodeMask?: Maybe<Scalars['String']>;
  /** Capture serials on receipt */
  captureSerialsOnRcpt: Scalars['Boolean'];
  /** Require pallet ID to be entered */
  requirePalletID: Scalars['Boolean'];
  /** Print pallet labels On Receipt */
  printPalLblsOnRcpt: Scalars['Boolean'];
  /** Capture PO number on receipt */
  capturePONumOnRcpt: Scalars['Boolean'];
  /** Allocation locations to pallet received */
  allocateLocOnRcpt: Scalars['Boolean'];
  /** Close PO when the Goods receipt has been completed */
  closeComPoOnRcpt: Scalars['Boolean'];
  /** Validate Batch against PO */
  validateBatchPO: Scalars['Boolean'];
  /** Capture packaging information on receipt */
  capturePkgInfoOnRcpt: Scalars['Boolean'];
  /** Putaway LP on Receipt */
  putwayLPOnRcpt: Scalars['Boolean'];
  /** Confirm putaways on Receipt */
  confirmPutawaysOnRcpt: Scalars['Boolean'];
  /** Goods receipt can only be closed by authorized user */
  reqAuthOnGRClose: Scalars['Boolean'];
  /** Unbooked receipts by default */
  defaultUnbookedRcpt: Scalars['Boolean'];
  /** Use identical pallets on Receipt */
  identicalPallets: Scalars['Boolean'];
  /** Strict PO date validation */
  strictPODateVal: Scalars['Boolean'];
  /** Receipt Verification - Split on Supplier Tollerance */
  splitSuppTolerance: Scalars['Boolean'];
  /** Receipt verification - Putaway to default location */
  RVPutToDefLoc: Scalars['Boolean'];
  /** RF Putaway Immediately */
  RFPutImmediately: Scalars['Boolean'];
  /** Disable Confirm Putaway for Specified Locations */
  disablePutForSpecificLocs: Scalars['Boolean'];
  /** Extra info must be entered on receipt */
  mandExtraInfoOnRcpt: Scalars['Boolean'];
  /** Capture container type on receipt */
  captureContainerType: Scalars['Boolean'];
  /** Only show booked products in the product F2 */
  F2ShowBookedProdsOnly: Scalars['Boolean'];
  /** Generate PO Number automatically */
  autoGeneratePONumber: Scalars['Boolean'];
  /** Allow Editing in Receipt verification */
  allowEditInRV: Scalars['Boolean'];
  /** Print Carton Labels with Pallet Labels */
  GRPrintCrtnLbls: Scalars['Boolean'];
  /** No Backflush when receiving from production */
  noBckFlushGRProduction: Scalars['Boolean'];
  /** Print labels when receiving from production */
  printLblsGRProduction: Scalars['Boolean'];
  /** Receipt and Booking Number must match */
  matchGRWithBookNo: Scalars['Boolean'];
  /** Receipt verification - Suppress merging of pick faces */
  RVSuppressMergePF: Scalars['Boolean'];
  /** Split PO lines on Print */
  spltPOLinesOnPrint: Scalars['Boolean'];
  /** Make GRN number the budgetholder for received stock */
  makeGRNBudhol: Scalars['Boolean'];
  /** Allow Short Shelf Life */
  allowShortShelfLife: Scalars['Boolean'];
  /** Add products to PO that were not expected */
  allowAddProdsToPO: Scalars['Boolean'];
  /** Capture Location on receipt */
  captureLocOnRcpt: Scalars['Boolean'];
  /** Capture temperature on receipt */
  captureTempOnRcpt: Scalars['Boolean'];
  /**
   * List of order statuses for the stock owner
   *
   * Mutations:
   *
   * CreateOrderStatus
   * DeleteOrderStatus
   * UpdateOrderStatus
   */
  orderStatuses?: Maybe<Array<Maybe<OrderStatusInput>>>;
  /** Generate order numbers automatically */
  autoGenOrderNum: Scalars['Boolean'];
  /** Display Errors in Order Entry */
  dispOrderEntryErrs: Scalars['Boolean'];
  /** Require Proof of Delivery */
  requirePOD: Scalars['Boolean'];
  /** Print Order Confirmation Report */
  printOrdConfRpt: Scalars['Boolean'];
  /** Create pick once an order has been saved in order entry */
  createPickOnOrdEntry: Scalars['Boolean'];
  /** Do not clear line customer reference */
  dontClearLineCustRef: Scalars['Boolean'];
  /** Mandatory Line customer reference */
  mandLineCustref: Scalars['Boolean'];
  /** Warn if there is a shortage of a product on the order */
  warnOnShortage: Scalars['Boolean'];
  /** Print order report with PickList */
  printOrdRptWithPick: Scalars['Boolean'];
  /** Print box packing Labels */
  printBoxPackLbls: Scalars['Boolean'];
  /** GDPR Controlled */
  GDPRControlled: Scalars['Boolean'];
  /** Force budgetholder to be entered in order entry */
  forceBudholOnEntry: Scalars['Boolean'];
  /** Prevent batch from being entered in order entry */
  preventBatchOnEntry: Scalars['Boolean'];
  /** Allow products to be swapped using generics in order entry. */
  swapGenericsOnEntry: Scalars['Boolean'];
  /** Force Department in order entry. */
  forceDepartmentOnEntry: Scalars['Boolean'];
  /**
   * List of pick definitions for the stock owner
   * Mutations:
   *
   * createStockOwnerPickMethod
   * deleteStockOwnerPickMethod
   * updateStockOwnerPickMethod
   */
  pickMethods?: Maybe<Array<Maybe<PickMethodInput>>>;
  /** Pick Orders without shortages only. */
  cleanOrdersOnly: Scalars['Boolean'];
  /** Create back orders when creating picks that are short */
  createBackOrders: Scalars['Boolean'];
  /** Allow Shortage swapping */
  allowShortageSwap: Scalars['Boolean'];
  /** Allow budgetholder swapping */
  allowBudholSwap: Scalars['Boolean'];
  /** Change trays based on Priority */
  chngeTraysOnPri: Scalars['Boolean'];
  /** Only create picks with no replens. */
  noReplenPicksOnly: Scalars['Boolean'];
  /** Allow status swapping */
  allowStatusSwap: Scalars['Boolean'];
  /** Pick cartons */
  pickCartons: Scalars['Boolean'];
  /** Manual Picking - Do not split lists */
  MPNoSplitLists: Scalars['Boolean'];
  /** Show Unpickable report */
  showUnpickableRpt: Scalars['Boolean'];
  /** Allow LP Swapping */
  allowLPSwap: Scalars['Boolean'];
  /** Allow Sell by date swapping */
  allowSBDSwap: Scalars['Boolean'];
  /** Find carton ID by Weight */
  findCartonByWgt: Scalars['Boolean'];
  /** Capture Carrier */
  captureCarrier: Scalars['Boolean'];
  /** Allow Location swapping */
  allowLocSwap: Scalars['Boolean'];
  /** Use BOM Picking */
  useBOMPicking: Scalars['Boolean'];
  /** Require Despatch note */
  requireDespNote: Scalars['Boolean'];
  /** RF Pick Assignment enumeration */
  RFPickAssignment?: Maybe<PickAssignment>;
  voicePickAssignment?: Maybe<PickAssignment>;
  /** Allow Batch swapping */
  allowBatchSwap: Scalars['Boolean'];
  /** Required to confirm product */
  requireConfProduct: Scalars['Boolean'];
  /** Require UPI check */
  requireUPICheck: Scalars['Boolean'];
  /** Perform pick cage validation */
  cageValidation: Scalars['Boolean'];
  /** Validate despatch note */
  despNoteValidation: Scalars['Boolean'];
  /** Suppress Replenishment option */
  suppressReplenOpt: Scalars['Boolean'];
  /** Use Loading */
  useLoading: Scalars['Boolean'];
  /** Produce RF Manifest */
  produceRFManifest: Scalars['Boolean'];
  /** Requires seal number to be entered */
  requireSealNo: Scalars['Boolean'];
  /** Require truck to be specified */
  requireTruck: Scalars['Boolean'];
  /** Require driver to be specified */
  requireDriver: Scalars['Boolean'];
  /** Use Load order */
  useLoadOrder: Scalars['Boolean'];
  loadOrder?: Maybe<LoadOrder>;
  /** Despatch lane for loading */
  despLane?: Maybe<Scalars['String']>;
  /** Maximum number of Loaders */
  maxLoaders?: Maybe<Scalars['Int']>;
  adhocLoading?: Maybe<Accessiblity>;
  /** Capture temperature at the start of Load */
  loadTempCaptureStart: Scalars['Boolean'];
  /** Capture temperature at the end of Load */
  loadTempCaptureEnd: Scalars['Boolean'];
  /** Capture temperature at LP Intervals */
  loadTempLPInterval: Scalars['Boolean'];
  /**
   * List of confirm methods for stock owner
   * Mutations:
   *
   * createStockOwnerConfirmMethod
   * deleteStockOwnerConfirmMethod
   * updateStockOwnerConfirmMethod
   */
  confirmMethods?: Maybe<Array<Maybe<PickConfirmMethodInput>>>;
  /** Capture time on pick confirm */
  captureTimeOnConfirm: FieldVisibility;
  /** Capture check on pick confirm */
  captureCheckerOnConfirm: FieldVisibility;
  /** Capture picker on pick confirm */
  capturePickerOnConfirm: FieldVisibility;
  /** Default pick fail code */
  defPickFailCode?: Maybe<Scalars['String']>;
  /** Require despatch lane */
  requireDespatchLane: Scalars['Boolean'];
  /** Use destination info for despatch email notification */
  useEmailFromDestination: Scalars['Boolean'];
  /** Allow despatch reprints for unconfirmed picklists */
  reprntUnfinishedLists: Scalars['Boolean'];
  /** Destock when short */
  destockShortOnSHort: Scalars['Boolean'];
  /** Proportional box records on pick confirm */
  proportionalBoxesOnConfirm: Scalars['Boolean'];
  /** Allow Loading in any Sequence */
  allowLoadAnySeq: Scalars['Boolean'];
  /** LP Control in Manual box packing */
  MBPLPControl: Scalars['Boolean'];
  /** Use stock owner defined despatch method in Manual box packing */
  MBPUseSODespMeth: Scalars['Boolean'];
  /** Do not create despatch notes */
  noDespNotes: Scalars['Boolean'];
  /** Preview despatch notes */
  previewDespNote: Scalars['Boolean'];
  /** Turn BOMS to stock */
  BOMSToStock: Scalars['Boolean'];
  /** Delay despatch */
  delayDespatch: Scalars['Boolean'];
  /** RF Warning in Pick confirm */
  RFWarnInPckConf: Scalars['Boolean'];
  /** No replen before pick confirm */
  noReplenPckConf: Scalars['Boolean'];
  /** Print despatch note per list */
  despNotePerList: Scalars['Boolean'];
  /** Always print box Labels */
  printBoxLbls: Scalars['Boolean'];
  /** Disable immediate despatch */
  disablImmDesp: Scalars['Boolean'];
  /** Allow future despatch dates */
  allowFutureDespDates: Scalars['Boolean'];
  /** Capture Consignment Number at MBP */
  MBPCaptureConsNo: Scalars['Boolean'];
  /** Optional consignment number */
  optConsNo: Scalars['Boolean'];
  /** Print box label at pick confirm */
  boxLblsPickConf: Scalars['Boolean'];
  /** Use LP IDs at Pick confirm */
  useLPIdsPickConfirm: Scalars['Boolean'];
  /** Authorised Manual box packing */
  authMBP: Scalars['Boolean'];
  /** Mandatory Container type */
  mandContainerType: Scalars['Boolean'];
  /** Create PDF despatch notes */
  PDFDespNotes: Scalars['Boolean'];
  /** Use despatch prefix */
  useDespPrefix: Scalars['Boolean'];
  /** Number of despatch notes */
  noOfDespNotes: Scalars['Boolean'];
  /** Confirm whole pick */
  confWholePick: Scalars['Boolean'];
  /** Capture reason for delayed despatch */
  capReasonDelayDesp: Scalars['Boolean'];
  /** Manual box packing - despatch note breakdown */
  MBPDespNoteBreakdwn: Scalars['Boolean'];
  /** Don't close order when errors occur during label generation */
  dontCloseOrderOnLblFail: Scalars['Boolean'];
  /** Capture the number of boxes per order */
  capBoxesPerOrder: Scalars['Boolean'];
  /** Do not require carrier to be entered */
  carrierNotReq: Scalars['Boolean'];
  /** Do not generate carrier labels at pick confirm */
  noCarrLblsPckConf: Scalars['Boolean'];
  /** Copy carrier from parent order to back orders */
  copyCarrToBckOrd: Scalars['Boolean'];
};

export type StorageTypeMhe = {
  __typename?: 'StorageTypeMHE';
  storageType?: Maybe<StorageType>;
  MHEId?: Maybe<Scalars['Int']>;
  materialHandlingEquipment?: Maybe<MaterialHandlingEquipment>;
};

export type StorageTypeInput = {
  id?: Maybe<Scalars['Int']>;
  code: Scalars['String'];
  description: Scalars['String'];
  MHEs?: Maybe<Array<Maybe<StorageTypeMheInput>>>;
};

export type ContactUpdateInput = {
  name?: Maybe<Scalars['String']>;
  telephone?: Maybe<Scalars['String']>;
  fax?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
};

export type UserContextInput = {
  warehouseId?: Maybe<Scalars['Int']>;
  stockOwnerId?: Maybe<Scalars['Int']>;
};

export type LicencePlateQueryType = {
  __typename?: 'LicencePlateQueryType';
  id?: Maybe<Scalars['String']>;
  licencePlates?: Maybe<LicencePlatesConnection>;
  licencePlate?: Maybe<LicencePlate>;
  licencePlateTypes?: Maybe<LicencePlateTypesConnection>;
};


export type LicencePlateQueryTypeLicencePlatesArgs = {
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  where?: Maybe<LicencePlateFilterInput>;
  order?: Maybe<Array<LicencePlateSortInput>>;
};


export type LicencePlateQueryTypeLicencePlateArgs = {
  id: Scalars['Int'];
};


export type LicencePlateQueryTypeLicencePlateTypesArgs = {
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  where?: Maybe<LicencePlateTypeFilterInput>;
  order?: Maybe<Array<LicencePlateTypeSortInput>>;
};

export type ProductPackTypeQueryType = {
  __typename?: 'ProductPackTypeQueryType';
  productPackTypes?: Maybe<Array<Maybe<ProductPackType>>>;
};


export type ProductPackTypeQueryTypeProductPackTypesArgs = {
  id: Scalars['Int'];
};

export type StockQueryType = {
  __typename?: 'StockQueryType';
  stock?: Maybe<StockConnection>;
};


export type StockQueryTypeStockArgs = {
  userContext?: Maybe<UserContextInput>;
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  where?: Maybe<StockFilterInput>;
  order?: Maybe<Array<StockSortInput>>;
};

export type GoodsReceiptMutationType = {
  __typename?: 'GoodsReceiptMutationType';
  createGoodsReceipt?: Maybe<GoodsReceiptResult>;
  updateGoodsReceipt?: Maybe<UpdatedLinesResult>;
  deleteGoodsReceipt?: Maybe<GoodsReceiptResult>;
  closeGoodsReceipt?: Maybe<GoodsReceiptResult>;
  addReceiptLine?: Maybe<UpdatedLinesResult>;
  removeReceiptLine?: Maybe<UpdatedLinesResult>;
};


export type GoodsReceiptMutationTypeCreateGoodsReceiptArgs = {
  userContext?: Maybe<UserContextInput>;
  input?: Maybe<TGoodsReceiptInput>;
};


export type GoodsReceiptMutationTypeUpdateGoodsReceiptArgs = {
  userContext?: Maybe<UserContextInput>;
  input?: Maybe<TGoodsReceiptUpdateInput>;
  id: Scalars['Int'];
};


export type GoodsReceiptMutationTypeDeleteGoodsReceiptArgs = {
  userContext?: Maybe<UserContextInput>;
  id: Scalars['Int'];
};


export type GoodsReceiptMutationTypeCloseGoodsReceiptArgs = {
  userContext?: Maybe<UserContextInput>;
  id: Scalars['Int'];
};


export type GoodsReceiptMutationTypeAddReceiptLineArgs = {
  userContext?: Maybe<UserContextInput>;
  goodsReceiptId: Scalars['Int'];
  input?: Maybe<Array<Maybe<GoodsReceiptLineInput>>>;
};


export type GoodsReceiptMutationTypeRemoveReceiptLineArgs = {
  userContext?: Maybe<UserContextInput>;
  goodsReceiptId: Scalars['Int'];
  ids?: Maybe<Array<Scalars['Int']>>;
};

export type GoodsReceiptQueryType = {
  __typename?: 'GoodsReceiptQueryType';
  id?: Maybe<Scalars['String']>;
  goodsReceipts?: Maybe<GoodsReceiptsConnection>;
  goodsReceiptById?: Maybe<GoodsReceipt>;
  goodsReceiptByNumber?: Maybe<GoodsReceipt>;
};


export type GoodsReceiptQueryTypeGoodsReceiptsArgs = {
  userContext?: Maybe<UserContextInput>;
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  where?: Maybe<GoodsReceiptFilterInput>;
  order?: Maybe<Array<GoodsReceiptSortInput>>;
};


export type GoodsReceiptQueryTypeGoodsReceiptByIdArgs = {
  userContext?: Maybe<UserContextInput>;
  id: Scalars['Int'];
};


export type GoodsReceiptQueryTypeGoodsReceiptByNumberArgs = {
  userContext?: Maybe<UserContextInput>;
  goodsReceiptNumber?: Maybe<Scalars['String']>;
};

export type PurchaseOrderMutationType = {
  __typename?: 'PurchaseOrderMutationType';
  createPurchaseOrder?: Maybe<PurchaseOrderResult>;
  updatePurchaseOrder?: Maybe<UpdatePoResponseResult>;
  deletePurchaseOrder?: Maybe<PurchaseOrderResult>;
};


export type PurchaseOrderMutationTypeCreatePurchaseOrderArgs = {
  userContext?: Maybe<UserContextInput>;
  input?: Maybe<TPurchaseOrderInput>;
};


export type PurchaseOrderMutationTypeUpdatePurchaseOrderArgs = {
  userContext?: Maybe<UserContextInput>;
  id: Scalars['Int'];
  input?: Maybe<PurchaseOrderUpdateInput>;
  items?: Maybe<UpdateCollectionOfPurchaseOrderItemInput>;
  instructions?: Maybe<UpdateCollectionOfPoInstructionInput>;
};


export type PurchaseOrderMutationTypeDeletePurchaseOrderArgs = {
  userContext?: Maybe<UserContextInput>;
  id: Scalars['Int'];
};

export type PurchaseOrderQueryType = {
  __typename?: 'PurchaseOrderQueryType';
  id?: Maybe<Scalars['String']>;
  purchaseOrders?: Maybe<PurchaseOrdersConnection>;
  purchaseOrderById?: Maybe<PurchaseOrder>;
  purchaseOrderByReference?: Maybe<PurchaseOrder>;
};


export type PurchaseOrderQueryTypePurchaseOrdersArgs = {
  userContext?: Maybe<UserContextInput>;
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  where?: Maybe<PurchaseOrderFilterInput>;
  order?: Maybe<Array<PurchaseOrderSortInput>>;
};


export type PurchaseOrderQueryTypePurchaseOrderByIdArgs = {
  userContext?: Maybe<UserContextInput>;
  id: Scalars['Int'];
};


export type PurchaseOrderQueryTypePurchaseOrderByReferenceArgs = {
  userContext?: Maybe<UserContextInput>;
  poNumber?: Maybe<Scalars['String']>;
};

export type UpdateCollectionOfUserPermissionInput = {
  create?: Maybe<Array<Maybe<UserPermissionInput>>>;
  update?: Maybe<Array<Maybe<UserPermissionUpdateInput>>>;
  delete?: Maybe<Array<Maybe<UserPermissionInput>>>;
};

export type UpdateCollectionOfMenuEntryInput = {
  create?: Maybe<Array<Maybe<MenuEntryInput>>>;
  update?: Maybe<Array<Maybe<MenuEntryUpdateInput>>>;
  delete?: Maybe<Array<Maybe<MenuEntryInput>>>;
};

export type LicencePlateFilterInput = {
  and?: Maybe<Array<LicencePlateFilterInput>>;
  or?: Maybe<Array<LicencePlateFilterInput>>;
  id?: Maybe<ComparableNullableOfInt32OperationFilterInput>;
  LPN?: Maybe<StringOperationFilterInput>;
  lPTypeId?: Maybe<ComparableNullableOfInt32OperationFilterInput>;
  LPType?: Maybe<LicencePlateTypeFilterInput>;
  locationId?: Maybe<ComparableNullableOfInt32OperationFilterInput>;
  location?: Maybe<LocationFilterInput>;
  outerId?: Maybe<ComparableNullableOfInt32OperationFilterInput>;
  outer?: Maybe<LicencePlateFilterInput>;
  inners?: Maybe<ListFilterInputTypeOfLicencePlateFilterInput>;
  owner?: Maybe<LpOwnerFilterInput>;
};

export type LicencePlateSortInput = {
  id?: Maybe<SortEnumType>;
  LPN?: Maybe<SortEnumType>;
  lPTypeId?: Maybe<SortEnumType>;
  LPType?: Maybe<LicencePlateTypeSortInput>;
  locationId?: Maybe<SortEnumType>;
  location?: Maybe<LocationSortInput>;
  outerId?: Maybe<SortEnumType>;
  outer?: Maybe<LicencePlateSortInput>;
  owner?: Maybe<LpOwnerSortInput>;
};

export type LicencePlateTypeFilterInput = {
  and?: Maybe<Array<LicencePlateTypeFilterInput>>;
  or?: Maybe<Array<LicencePlateTypeFilterInput>>;
  id?: Maybe<ComparableNullableOfInt32OperationFilterInput>;
  code?: Maybe<StringOperationFilterInput>;
  description?: Maybe<StringOperationFilterInput>;
  size?: Maybe<DimensionFilterInput>;
  tareWeight?: Maybe<ComparableNullableOfDecimalOperationFilterInput>;
  material?: Maybe<StringOperationFilterInput>;
  controlled?: Maybe<NullableOfLpControlTypeOperationFilterInput>;
};

export type LicencePlateTypeSortInput = {
  id?: Maybe<SortEnumType>;
  code?: Maybe<SortEnumType>;
  description?: Maybe<SortEnumType>;
  size?: Maybe<DimensionSortInput>;
  tareWeight?: Maybe<SortEnumType>;
  material?: Maybe<SortEnumType>;
  controlled?: Maybe<SortEnumType>;
};

/** A connection to a list of items. */
export type LicencePlatesConnection = {
  __typename?: 'LicencePlatesConnection';
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A list of edges. */
  edges?: Maybe<Array<LicencePlatesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<LicencePlate>>>;
  totalCount: Scalars['Int'];
};

/** A connection to a list of items. */
export type LicencePlateTypesConnection = {
  __typename?: 'LicencePlateTypesConnection';
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A list of edges. */
  edges?: Maybe<Array<LicencePlateTypesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<LicencePlateType>>>;
  totalCount: Scalars['Int'];
};

export type StockFilterInput = {
  and?: Maybe<Array<StockFilterInput>>;
  or?: Maybe<Array<StockFilterInput>>;
  id?: Maybe<ComparableNullableOfInt32OperationFilterInput>;
  warehouseId?: Maybe<ComparableNullableOfInt32OperationFilterInput>;
  warehouse?: Maybe<WarehouseFilterInput>;
  stockOwnerId?: Maybe<ComparableNullableOfInt32OperationFilterInput>;
  stockOwner?: Maybe<StockOwnerFilterInput>;
  productId?: Maybe<ComparableNullableOfInt32OperationFilterInput>;
  product?: Maybe<ProductFilterInput>;
  attributeId?: Maybe<ComparableNullableOfInt32OperationFilterInput>;
  attributes?: Maybe<StockAttributesFilterInput>;
  status?: Maybe<StringOperationFilterInput>;
  packType?: Maybe<StringOperationFilterInput>;
  packs?: Maybe<ComparableDecimalOperationFilterInput>;
  singles?: Maybe<ComparableDecimalOperationFilterInput>;
  allocated?: Maybe<ComparableDecimalOperationFilterInput>;
  locationId?: Maybe<ComparableNullableOfInt32OperationFilterInput>;
  location?: Maybe<LocationFilterInput>;
  licencePlateId?: Maybe<ComparableNullableOfInt32OperationFilterInput>;
  licencePlate?: Maybe<LicencePlateFilterInput>;
};

export type StockSortInput = {
  id?: Maybe<SortEnumType>;
  warehouseId?: Maybe<SortEnumType>;
  warehouse?: Maybe<WarehouseSortInput>;
  stockOwnerId?: Maybe<SortEnumType>;
  stockOwner?: Maybe<StockOwnerSortInput>;
  productId?: Maybe<SortEnumType>;
  product?: Maybe<ProductSortInput>;
  attributeId?: Maybe<SortEnumType>;
  attributes?: Maybe<StockAttributesSortInput>;
  status?: Maybe<SortEnumType>;
  packType?: Maybe<SortEnumType>;
  packs?: Maybe<SortEnumType>;
  singles?: Maybe<SortEnumType>;
  allocated?: Maybe<SortEnumType>;
  locationId?: Maybe<SortEnumType>;
  location?: Maybe<LocationSortInput>;
  licencePlateId?: Maybe<SortEnumType>;
  licencePlate?: Maybe<LicencePlateSortInput>;
};

/** A connection to a list of items. */
export type StockConnection = {
  __typename?: 'StockConnection';
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A list of edges. */
  edges?: Maybe<Array<StockEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<Stock>>>;
  totalCount: Scalars['Int'];
};

export type GoodsReceiptResult = GoodsReceipt | DatabaseError | ValidationError;

export type UpdatedLinesResult = UpdatedLines | DatabaseError | ValidationError;

export type GoodsReceiptFilterInput = {
  and?: Maybe<Array<GoodsReceiptFilterInput>>;
  or?: Maybe<Array<GoodsReceiptFilterInput>>;
  booked?: Maybe<ListFilterInputTypeOfGoodsBookLineFilterInput>;
  received?: Maybe<ListFilterInputTypeOfGoodsReceiptLineFilterInput>;
  id?: Maybe<ComparableNullableOfInt32OperationFilterInput>;
  goodsReceiptNumber?: Maybe<StringOperationFilterInput>;
  warehouseId?: Maybe<ComparableNullableOfInt32OperationFilterInput>;
  warehouse?: Maybe<WarehouseFilterInput>;
  stockOwnerId?: Maybe<ComparableNullableOfInt32OperationFilterInput>;
  stockOwner?: Maybe<StockOwnerFilterInput>;
  status?: Maybe<NullableOfGoodsReceiptStateOperationFilterInput>;
  isUnbooked?: Maybe<BooleanOperationFilterInput>;
  dateCreated?: Maybe<ComparableNullableOfDateTimeOperationFilterInput>;
  dateReceived?: Maybe<ComparableNullableOfDateTimeOperationFilterInput>;
  customerRef?: Maybe<StringOperationFilterInput>;
  invoiceRef?: Maybe<StringOperationFilterInput>;
  createdBy?: Maybe<StringOperationFilterInput>;
  extra?: Maybe<GoodsReceipt_ExtraDataFilterInput>;
};

export type GoodsReceiptSortInput = {
  id?: Maybe<SortEnumType>;
  goodsReceiptNumber?: Maybe<SortEnumType>;
  warehouseId?: Maybe<SortEnumType>;
  warehouse?: Maybe<WarehouseSortInput>;
  stockOwnerId?: Maybe<SortEnumType>;
  stockOwner?: Maybe<StockOwnerSortInput>;
  status?: Maybe<SortEnumType>;
  isUnbooked?: Maybe<SortEnumType>;
  dateCreated?: Maybe<SortEnumType>;
  dateReceived?: Maybe<SortEnumType>;
  customerRef?: Maybe<SortEnumType>;
  invoiceRef?: Maybe<SortEnumType>;
  createdBy?: Maybe<SortEnumType>;
  extra?: Maybe<GoodsReceipt_ExtraDataSortInput>;
};

/** A connection to a list of items. */
export type GoodsReceiptsConnection = {
  __typename?: 'GoodsReceiptsConnection';
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A list of edges. */
  edges?: Maybe<Array<GoodsReceiptsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<GoodsReceipt>>>;
  totalCount: Scalars['Int'];
};

export type PurchaseOrderResult = PurchaseOrder | DatabaseError | ValidationError;

export type UpdatePoResponseResult = UpdatePoResponse | DatabaseError | ValidationError;

export type PurchaseOrderUpdateInput = {
  stockOwner?: Maybe<StockOwnerUpdateInput>;
  warehouse?: Maybe<WarehouseUpdateInput>;
  stockOwnerId?: Maybe<Scalars['Int']>;
  warehouseId?: Maybe<Scalars['Int']>;
  custReferences?: Maybe<Array<Maybe<Scalars['String']>>>;
  status?: Maybe<PurchaseOrderState>;
  type?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['Int']>;
  supplierId?: Maybe<Scalars['Int']>;
  currency?: Maybe<Currency>;
  totalValue?: Maybe<Scalars['Decimal']>;
  enteredBy?: Maybe<Scalars['String']>;
  entered?: Maybe<Scalars['DateTime']>;
  after?: Maybe<Scalars['DateTime']>;
  before?: Maybe<Scalars['DateTime']>;
  budgetHolder?: Maybe<Scalars['String']>;
  containerNo?: Maybe<Scalars['String']>;
  billOfLading?: Maybe<Scalars['String']>;
  crossDock?: Maybe<Scalars['Boolean']>;
  message?: Maybe<Scalars['String']>;
  parent?: Maybe<Scalars['String']>;
  carrier?: Maybe<Scalars['String']>;
  carrierService?: Maybe<Scalars['String']>;
  exportBatch?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
};

export type UpdateCollectionOfPurchaseOrderItemInput = {
  create?: Maybe<Array<Maybe<PurchaseOrderItemInput>>>;
  update?: Maybe<Array<Maybe<PurchaseOrderItemUpdateInput>>>;
  delete?: Maybe<Array<Maybe<PurchaseOrderItemInput>>>;
};

export type UpdateCollectionOfPoInstructionInput = {
  create?: Maybe<Array<Maybe<PoInstructionInput>>>;
  update?: Maybe<Array<Maybe<PoInstructionUpdateInput>>>;
  delete?: Maybe<Array<Maybe<PoInstructionInput>>>;
};

export type PurchaseOrderFilterInput = {
  and?: Maybe<Array<PurchaseOrderFilterInput>>;
  or?: Maybe<Array<PurchaseOrderFilterInput>>;
  id?: Maybe<ComparableNullableOfInt32OperationFilterInput>;
  stockOwner?: Maybe<StockOwnerFilterInput>;
  warehouse?: Maybe<WarehouseFilterInput>;
  instructions?: Maybe<ListFilterInputTypeOfPoInstructionFilterInput>;
  items?: Maybe<ListFilterInputTypeOfPurchaseOrderItemFilterInput>;
  stockOwnerId?: Maybe<ComparableNullableOfInt32OperationFilterInput>;
  warehouseId?: Maybe<ComparableNullableOfInt32OperationFilterInput>;
  referenceNumber?: Maybe<StringOperationFilterInput>;
  custReferences?: Maybe<ListStringOperationFilterInput>;
  status?: Maybe<NullableOfPurchaseOrderStateOperationFilterInput>;
  type?: Maybe<StringOperationFilterInput>;
  version?: Maybe<ComparableNullableOfInt32OperationFilterInput>;
  supplierId?: Maybe<ComparableNullableOfInt32OperationFilterInput>;
  supplier?: Maybe<SupplierFilterInput>;
  currency?: Maybe<NullableOfCurrencyOperationFilterInput>;
  totalValue?: Maybe<ComparableNullableOfDecimalOperationFilterInput>;
  enteredBy?: Maybe<StringOperationFilterInput>;
  entered?: Maybe<ComparableNullableOfDateTimeOperationFilterInput>;
  after?: Maybe<ComparableNullableOfDateTimeOperationFilterInput>;
  before?: Maybe<ComparableNullableOfDateTimeOperationFilterInput>;
  budgetHolder?: Maybe<StringOperationFilterInput>;
  containerNo?: Maybe<StringOperationFilterInput>;
  billOfLading?: Maybe<StringOperationFilterInput>;
  crossDock?: Maybe<BooleanOperationFilterInput>;
  message?: Maybe<StringOperationFilterInput>;
  parent?: Maybe<StringOperationFilterInput>;
  carrier?: Maybe<StringOperationFilterInput>;
  carrierService?: Maybe<StringOperationFilterInput>;
  exportBatch?: Maybe<StringOperationFilterInput>;
};

export type PurchaseOrderSortInput = {
  id?: Maybe<SortEnumType>;
  stockOwner?: Maybe<StockOwnerSortInput>;
  warehouse?: Maybe<WarehouseSortInput>;
  stockOwnerId?: Maybe<SortEnumType>;
  warehouseId?: Maybe<SortEnumType>;
  referenceNumber?: Maybe<SortEnumType>;
  status?: Maybe<SortEnumType>;
  type?: Maybe<SortEnumType>;
  version?: Maybe<SortEnumType>;
  supplierId?: Maybe<SortEnumType>;
  supplier?: Maybe<SupplierSortInput>;
  currency?: Maybe<SortEnumType>;
  totalValue?: Maybe<SortEnumType>;
  enteredBy?: Maybe<SortEnumType>;
  entered?: Maybe<SortEnumType>;
  after?: Maybe<SortEnumType>;
  before?: Maybe<SortEnumType>;
  budgetHolder?: Maybe<SortEnumType>;
  containerNo?: Maybe<SortEnumType>;
  billOfLading?: Maybe<SortEnumType>;
  crossDock?: Maybe<SortEnumType>;
  message?: Maybe<SortEnumType>;
  parent?: Maybe<SortEnumType>;
  carrier?: Maybe<SortEnumType>;
  carrierService?: Maybe<SortEnumType>;
  exportBatch?: Maybe<SortEnumType>;
};

/** A connection to a list of items. */
export type PurchaseOrdersConnection = {
  __typename?: 'PurchaseOrdersConnection';
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A list of edges. */
  edges?: Maybe<Array<PurchaseOrdersEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<PurchaseOrder>>>;
  totalCount: Scalars['Int'];
};

export type MenuEntryInput = {
  id?: Maybe<Scalars['Int']>;
  userId?: Maybe<Scalars['String']>;
  parent?: Maybe<MenuEntryInput>;
  parentId?: Maybe<Scalars['Int']>;
  children?: Maybe<Array<Maybe<MenuEntryInput>>>;
  order?: Maybe<Scalars['Int']>;
  screenId?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
  enabled?: Maybe<Scalars['Boolean']>;
  defaultGroupId?: Maybe<Scalars['String']>;
};

export type MenuEntryUpdateInput = {
  userId?: Maybe<Scalars['String']>;
  parentId?: Maybe<Scalars['Int']>;
  order?: Maybe<Scalars['Int']>;
  screenId?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
  enabled?: Maybe<Scalars['Boolean']>;
  depth?: Maybe<Scalars['Int']>;
  defaultGroupId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
};

export type ListFilterInputTypeOfLicencePlateFilterInput = {
  all?: Maybe<LicencePlateFilterInput>;
  none?: Maybe<LicencePlateFilterInput>;
  some?: Maybe<LicencePlateFilterInput>;
  any?: Maybe<Scalars['Boolean']>;
};

export type LpOwnerFilterInput = {
  and?: Maybe<Array<LpOwnerFilterInput>>;
  or?: Maybe<Array<LpOwnerFilterInput>>;
  owner?: Maybe<StringOperationFilterInput>;
  id?: Maybe<StringOperationFilterInput>;
};

export type LpOwnerSortInput = {
  owner?: Maybe<SortEnumType>;
  id?: Maybe<SortEnumType>;
};

export type NullableOfLpControlTypeOperationFilterInput = {
  eq?: Maybe<LpControlType>;
  neq?: Maybe<LpControlType>;
  in?: Maybe<Array<Maybe<LpControlType>>>;
  nin?: Maybe<Array<Maybe<LpControlType>>>;
};

/** An edge in a connection. */
export type LicencePlatesEdge = {
  __typename?: 'LicencePlatesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<LicencePlate>;
};

/** An edge in a connection. */
export type LicencePlateTypesEdge = {
  __typename?: 'LicencePlateTypesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<LicencePlateType>;
};

export type StockAttributesFilterInput = {
  and?: Maybe<Array<StockAttributesFilterInput>>;
  or?: Maybe<Array<StockAttributesFilterInput>>;
  id?: Maybe<ComparableNullableOfInt32OperationFilterInput>;
  productId?: Maybe<ComparableNullableOfInt32OperationFilterInput>;
  product?: Maybe<ProductFilterInput>;
  batch?: Maybe<StringOperationFilterInput>;
  sellByDate?: Maybe<ComparableNullableOfDateTimeOperationFilterInput>;
  GRN?: Maybe<StringOperationFilterInput>;
  PONumber?: Maybe<StringOperationFilterInput>;
  serialNumber?: Maybe<StringOperationFilterInput>;
  budgetHolder?: Maybe<StringOperationFilterInput>;
  catchWeight?: Maybe<ComparableNullableOfDecimalOperationFilterInput>;
  bestBeforeDate?: Maybe<ComparableNullableOfDateTimeOperationFilterInput>;
  killDate?: Maybe<ComparableNullableOfDateTimeOperationFilterInput>;
  productionDate?: Maybe<ComparableNullableOfDateTimeOperationFilterInput>;
  slaughterCode?: Maybe<StringOperationFilterInput>;
  batchInfo?: Maybe<StringOperationFilterInput>;
};

export type ComparableDecimalOperationFilterInput = {
  eq?: Maybe<Scalars['Decimal']>;
  neq?: Maybe<Scalars['Decimal']>;
  in?: Maybe<Array<Scalars['Decimal']>>;
  nin?: Maybe<Array<Scalars['Decimal']>>;
  gt?: Maybe<Scalars['Decimal']>;
  ngt?: Maybe<Scalars['Decimal']>;
  gte?: Maybe<Scalars['Decimal']>;
  ngte?: Maybe<Scalars['Decimal']>;
  lt?: Maybe<Scalars['Decimal']>;
  nlt?: Maybe<Scalars['Decimal']>;
  lte?: Maybe<Scalars['Decimal']>;
  nlte?: Maybe<Scalars['Decimal']>;
};

export type StockAttributesSortInput = {
  id?: Maybe<SortEnumType>;
  productId?: Maybe<SortEnumType>;
  product?: Maybe<ProductSortInput>;
  batch?: Maybe<SortEnumType>;
  sellByDate?: Maybe<SortEnumType>;
  GRN?: Maybe<SortEnumType>;
  PONumber?: Maybe<SortEnumType>;
  serialNumber?: Maybe<SortEnumType>;
  budgetHolder?: Maybe<SortEnumType>;
  catchWeight?: Maybe<SortEnumType>;
  bestBeforeDate?: Maybe<SortEnumType>;
  killDate?: Maybe<SortEnumType>;
  productionDate?: Maybe<SortEnumType>;
  slaughterCode?: Maybe<SortEnumType>;
  batchInfo?: Maybe<SortEnumType>;
};

/** An edge in a connection. */
export type StockEdge = {
  __typename?: 'StockEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<Stock>;
};

export type ListFilterInputTypeOfGoodsBookLineFilterInput = {
  all?: Maybe<GoodsBookLineFilterInput>;
  none?: Maybe<GoodsBookLineFilterInput>;
  some?: Maybe<GoodsBookLineFilterInput>;
  any?: Maybe<Scalars['Boolean']>;
};

export type ListFilterInputTypeOfGoodsReceiptLineFilterInput = {
  all?: Maybe<GoodsReceiptLineFilterInput>;
  none?: Maybe<GoodsReceiptLineFilterInput>;
  some?: Maybe<GoodsReceiptLineFilterInput>;
  any?: Maybe<Scalars['Boolean']>;
};

export type NullableOfGoodsReceiptStateOperationFilterInput = {
  eq?: Maybe<GoodsReceiptState>;
  neq?: Maybe<GoodsReceiptState>;
  in?: Maybe<Array<Maybe<GoodsReceiptState>>>;
  nin?: Maybe<Array<Maybe<GoodsReceiptState>>>;
};

export type GoodsReceipt_ExtraDataFilterInput = {
  and?: Maybe<Array<GoodsReceipt_ExtraDataFilterInput>>;
  or?: Maybe<Array<GoodsReceipt_ExtraDataFilterInput>>;
  type?: Maybe<StringOperationFilterInput>;
  containerNo?: Maybe<StringOperationFilterInput>;
  containerType?: Maybe<StringOperationFilterInput>;
  condition?: Maybe<StringOperationFilterInput>;
  sealNo?: Maybe<StringOperationFilterInput>;
  carrier?: Maybe<StringOperationFilterInput>;
  freightCost?: Maybe<ComparableNullableOfDecimalOperationFilterInput>;
  vehicle?: Maybe<StringOperationFilterInput>;
  trailer?: Maybe<StringOperationFilterInput>;
  driver?: Maybe<StringOperationFilterInput>;
  alternativeRef?: Maybe<StringOperationFilterInput>;
  notes?: Maybe<ListStringOperationFilterInput>;
  expected?: Maybe<ComparableNullableOfDateTimeOperationFilterInput>;
  unLoadingTime?: Maybe<ComparableNullableOfTimeSpanOperationFilterInput>;
  unLoaders?: Maybe<ComparableNullableOfInt32OperationFilterInput>;
  assignedDock?: Maybe<StringOperationFilterInput>;
};

export type GoodsReceipt_ExtraDataSortInput = {
  type?: Maybe<SortEnumType>;
  containerNo?: Maybe<SortEnumType>;
  containerType?: Maybe<SortEnumType>;
  condition?: Maybe<SortEnumType>;
  sealNo?: Maybe<SortEnumType>;
  carrier?: Maybe<SortEnumType>;
  freightCost?: Maybe<SortEnumType>;
  vehicle?: Maybe<SortEnumType>;
  trailer?: Maybe<SortEnumType>;
  driver?: Maybe<SortEnumType>;
  alternativeRef?: Maybe<SortEnumType>;
  expected?: Maybe<SortEnumType>;
  unLoadingTime?: Maybe<SortEnumType>;
  unLoaders?: Maybe<SortEnumType>;
  assignedDock?: Maybe<SortEnumType>;
};

/** An edge in a connection. */
export type GoodsReceiptsEdge = {
  __typename?: 'GoodsReceiptsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<GoodsReceipt>;
};

export type PurchaseOrderItemInput = {
  id?: Maybe<Scalars['Int']>;
  lineNumber?: Maybe<Scalars['String']>;
  lineStatus?: Maybe<Scalars['String']>;
  attributeId?: Maybe<Scalars['Int']>;
  attributes: StockAttributesInput;
  productStatus?: Maybe<Scalars['String']>;
  price: Scalars['Int'];
  quantityOrdered: Scalars['Int'];
  quantityBooked: Scalars['Int'];
  quantityDelivered: Scalars['Int'];
  quantityManifested: Scalars['Int'];
  quantityShipped: Scalars['Int'];
  LPN?: Maybe<Scalars['String']>;
};

export type PurchaseOrderItemUpdateInput = {
  pOHeader?: Maybe<PurchaseOrderUpdateInput>;
  lineNumber?: Maybe<Scalars['String']>;
  lineStatus?: Maybe<Scalars['String']>;
  attributeId?: Maybe<Scalars['Int']>;
  attributes?: Maybe<StockAttributesUpdateInput>;
  productStatus?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['Decimal']>;
  quantityOrdered?: Maybe<Scalars['Decimal']>;
  quantityBooked?: Maybe<Scalars['Decimal']>;
  quantityDelivered?: Maybe<Scalars['Decimal']>;
  quantityManifested?: Maybe<Scalars['Decimal']>;
  quantityShipped?: Maybe<Scalars['Decimal']>;
  LPN?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
};

export type PoInstructionInput = {
  id?: Maybe<Scalars['Int']>;
  type: PoInstructionType;
  message: Scalars['String'];
};

export type PoInstructionUpdateInput = {
  pOHeader?: Maybe<PurchaseOrderUpdateInput>;
  type?: Maybe<PoInstructionType>;
  message?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
};

export type ListFilterInputTypeOfPoInstructionFilterInput = {
  all?: Maybe<PoInstructionFilterInput>;
  none?: Maybe<PoInstructionFilterInput>;
  some?: Maybe<PoInstructionFilterInput>;
  any?: Maybe<Scalars['Boolean']>;
};

export type ListFilterInputTypeOfPurchaseOrderItemFilterInput = {
  all?: Maybe<PurchaseOrderItemFilterInput>;
  none?: Maybe<PurchaseOrderItemFilterInput>;
  some?: Maybe<PurchaseOrderItemFilterInput>;
  any?: Maybe<Scalars['Boolean']>;
};

export type NullableOfPurchaseOrderStateOperationFilterInput = {
  eq?: Maybe<PurchaseOrderState>;
  neq?: Maybe<PurchaseOrderState>;
  in?: Maybe<Array<Maybe<PurchaseOrderState>>>;
  nin?: Maybe<Array<Maybe<PurchaseOrderState>>>;
};

/** An edge in a connection. */
export type PurchaseOrdersEdge = {
  __typename?: 'PurchaseOrdersEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<PurchaseOrder>;
};

export type GoodsBookLineFilterInput = {
  and?: Maybe<Array<GoodsBookLineFilterInput>>;
  or?: Maybe<Array<GoodsBookLineFilterInput>>;
  id?: Maybe<ComparableNullableOfInt32OperationFilterInput>;
  quantityExpected?: Maybe<ComparableDecimalOperationFilterInput>;
  LPN?: Maybe<StringOperationFilterInput>;
  unReceived?: Maybe<BooleanOperationFilterInput>;
  receipts?: Maybe<ListFilterInputTypeOfGoodsReceiptLineFilterInput>;
  header?: Maybe<GoodsReceiptFilterInput>;
  attributeId?: Maybe<ComparableNullableOfInt32OperationFilterInput>;
  attributes?: Maybe<StockAttributesFilterInput>;
  supplierId?: Maybe<ComparableNullableOfInt32OperationFilterInput>;
  supplier?: Maybe<SupplierFilterInput>;
  purchaseOrder?: Maybe<StringOperationFilterInput>;
  purchaseOrderLine?: Maybe<StringOperationFilterInput>;
  packType?: Maybe<StringOperationFilterInput>;
  productStatus?: Maybe<StringOperationFilterInput>;
  bookLine?: Maybe<GoodsBookLineFilterInput>;
  parentBookLineId?: Maybe<ComparableNullableOfInt32OperationFilterInput>;
};

export type GoodsReceiptLineFilterInput = {
  and?: Maybe<Array<GoodsReceiptLineFilterInput>>;
  or?: Maybe<Array<GoodsReceiptLineFilterInput>>;
  id?: Maybe<ComparableNullableOfInt32OperationFilterInput>;
  quantityReceived?: Maybe<ComparableDecimalOperationFilterInput>;
  licencePlateId?: Maybe<ComparableNullableOfInt32OperationFilterInput>;
  licencePlate?: Maybe<LicencePlateFilterInput>;
  adHoc?: Maybe<BooleanOperationFilterInput>;
  header?: Maybe<GoodsReceiptFilterInput>;
  attributeId?: Maybe<ComparableNullableOfInt32OperationFilterInput>;
  attributes?: Maybe<StockAttributesFilterInput>;
  supplierId?: Maybe<ComparableNullableOfInt32OperationFilterInput>;
  supplier?: Maybe<SupplierFilterInput>;
  purchaseOrder?: Maybe<StringOperationFilterInput>;
  purchaseOrderLine?: Maybe<StringOperationFilterInput>;
  packType?: Maybe<StringOperationFilterInput>;
  productStatus?: Maybe<StringOperationFilterInput>;
  bookLine?: Maybe<GoodsBookLineFilterInput>;
  parentBookLineId?: Maybe<ComparableNullableOfInt32OperationFilterInput>;
};

export type ComparableNullableOfTimeSpanOperationFilterInput = {
  eq?: Maybe<Scalars['TimeSpan']>;
  neq?: Maybe<Scalars['TimeSpan']>;
  in?: Maybe<Array<Maybe<Scalars['TimeSpan']>>>;
  nin?: Maybe<Array<Maybe<Scalars['TimeSpan']>>>;
  gt?: Maybe<Scalars['TimeSpan']>;
  ngt?: Maybe<Scalars['TimeSpan']>;
  gte?: Maybe<Scalars['TimeSpan']>;
  ngte?: Maybe<Scalars['TimeSpan']>;
  lt?: Maybe<Scalars['TimeSpan']>;
  nlt?: Maybe<Scalars['TimeSpan']>;
  lte?: Maybe<Scalars['TimeSpan']>;
  nlte?: Maybe<Scalars['TimeSpan']>;
};

export type PoInstructionFilterInput = {
  and?: Maybe<Array<PoInstructionFilterInput>>;
  or?: Maybe<Array<PoInstructionFilterInput>>;
  id?: Maybe<ComparableNullableOfInt32OperationFilterInput>;
  type?: Maybe<NullableOfPoInstructionTypeOperationFilterInput>;
  message?: Maybe<StringOperationFilterInput>;
};

export type PurchaseOrderItemFilterInput = {
  and?: Maybe<Array<PurchaseOrderItemFilterInput>>;
  or?: Maybe<Array<PurchaseOrderItemFilterInput>>;
  id?: Maybe<ComparableNullableOfInt32OperationFilterInput>;
  lineNumber?: Maybe<StringOperationFilterInput>;
  lineStatus?: Maybe<StringOperationFilterInput>;
  attributeId?: Maybe<ComparableNullableOfInt32OperationFilterInput>;
  attributes?: Maybe<StockAttributesFilterInput>;
  productStatus?: Maybe<StringOperationFilterInput>;
  price?: Maybe<ComparableNullableOfDecimalOperationFilterInput>;
  quantityOrdered?: Maybe<ComparableNullableOfDecimalOperationFilterInput>;
  quantityBooked?: Maybe<ComparableNullableOfDecimalOperationFilterInput>;
  quantityDelivered?: Maybe<ComparableNullableOfDecimalOperationFilterInput>;
  quantityManifested?: Maybe<ComparableNullableOfDecimalOperationFilterInput>;
  quantityShipped?: Maybe<ComparableNullableOfDecimalOperationFilterInput>;
  LPN?: Maybe<StringOperationFilterInput>;
};

export type NullableOfPoInstructionTypeOperationFilterInput = {
  eq?: Maybe<PoInstructionType>;
  neq?: Maybe<PoInstructionType>;
  in?: Maybe<Array<Maybe<PoInstructionType>>>;
  nin?: Maybe<Array<Maybe<PoInstructionType>>>;
};

export type StockAttributesUpdateInput = {
  productId?: Maybe<Scalars['Int']>;
  product?: Maybe<ProductUpdateInput>;
  batch?: Maybe<Scalars['String']>;
  sellByDate?: Maybe<Scalars['DateTime']>;
  GRN?: Maybe<Scalars['String']>;
  PONumber?: Maybe<Scalars['String']>;
  serialNumber?: Maybe<Scalars['String']>;
  budgetHolder?: Maybe<Scalars['String']>;
  catchWeight?: Maybe<Scalars['Decimal']>;
  bestBeforeDate?: Maybe<Scalars['DateTime']>;
  killDate?: Maybe<Scalars['DateTime']>;
  productionDate?: Maybe<Scalars['DateTime']>;
  slaughterCode?: Maybe<Scalars['String']>;
  batchInfo?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
};

export type StockAttributesInput = {
  id?: Maybe<Scalars['Int']>;
  productId?: Maybe<Scalars['Int']>;
  product?: Maybe<ProductInput>;
  batch?: Maybe<Scalars['String']>;
  sellByDate?: Maybe<Scalars['DateTime']>;
  GRN?: Maybe<Scalars['String']>;
  PONumber?: Maybe<Scalars['String']>;
  serialNumber?: Maybe<Scalars['String']>;
  budgetHolder?: Maybe<Scalars['String']>;
  catchWeight?: Maybe<Scalars['Decimal']>;
  bestBeforeDate?: Maybe<Scalars['DateTime']>;
  killDate?: Maybe<Scalars['DateTime']>;
  productionDate?: Maybe<Scalars['DateTime']>;
  slaughterCode?: Maybe<Scalars['String']>;
  batchInfo?: Maybe<Scalars['String']>;
};

export enum LpControlType {
  None = 'NONE',
  Serialized = 'SERIALIZED',
  Owned = 'OWNED'
}

export type TPurchaseOrderInput = {
  items?: Maybe<UpdateCollectionOfPurchaseOrderItemInput>;
  instructions?: Maybe<UpdateCollectionOfPoInstructionInput>;
  stockOwnerId?: Maybe<Scalars['Int']>;
  warehouseId?: Maybe<Scalars['Int']>;
  referenceNumber: Scalars['String'];
  custReferences?: Maybe<Array<Maybe<Scalars['String']>>>;
  status?: Maybe<PurchaseOrderState>;
  type?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['Int']>;
  supplierId?: Maybe<Scalars['Int']>;
  supplier?: Maybe<SupplierInput>;
  currency?: Maybe<Currency>;
  totalValue: Scalars['Int'];
  enteredBy?: Maybe<Scalars['String']>;
  entered?: Maybe<Scalars['DateTime']>;
  after?: Maybe<Scalars['DateTime']>;
  before?: Maybe<Scalars['DateTime']>;
  budgetHolder?: Maybe<Scalars['String']>;
  containerNo?: Maybe<Scalars['String']>;
  billOfLading?: Maybe<Scalars['String']>;
  crossDock: Scalars['Boolean'];
  message?: Maybe<Scalars['String']>;
  parent?: Maybe<Scalars['String']>;
  carrier?: Maybe<Scalars['String']>;
  carrierService?: Maybe<Scalars['String']>;
  exportBatch?: Maybe<Scalars['String']>;
};

export type GoodsReceiptLineInput = {
  id?: Maybe<Scalars['Int']>;
  quantityReceived: Scalars['Decimal'];
  licencePlateId?: Maybe<Scalars['Int']>;
  licencePlate: LicencePlateInput;
  adHoc: Scalars['Boolean'];
  header?: Maybe<GoodsReceiptInput>;
  attributeId?: Maybe<Scalars['Int']>;
  attributes: StockAttributesInput;
  supplierId?: Maybe<Scalars['Int']>;
  supplier?: Maybe<SupplierInput>;
  purchaseOrder?: Maybe<Scalars['String']>;
  purchaseOrderLine?: Maybe<Scalars['String']>;
  packType: Scalars['String'];
  productStatus: Scalars['String'];
  bookLine?: Maybe<GoodsBookLineInput>;
  parentBookLineId?: Maybe<Scalars['Int']>;
};

export type TGoodsReceiptUpdateInput = {
  isUnbooked?: Maybe<Scalars['Boolean']>;
  dateReceived?: Maybe<Scalars['DateTime']>;
  customerRef?: Maybe<Scalars['String']>;
  invoiceRef?: Maybe<Scalars['String']>;
  extra?: Maybe<TGoodsReceipt_ExtraInput>;
  bookLines?: Maybe<UpdateCollectionOfGoodsBookLineInput>;
};

export type TGoodsReceiptInput = {
  goodsReceiptNumber: Scalars['String'];
  warehouseId?: Maybe<Scalars['Int']>;
  stockOwnerId?: Maybe<Scalars['Int']>;
  isUnbooked: Scalars['Boolean'];
  dateCreated?: Maybe<Scalars['DateTime']>;
  dateReceived?: Maybe<Scalars['DateTime']>;
  customerRef?: Maybe<Scalars['String']>;
  invoiceRef?: Maybe<Scalars['String']>;
  extra?: Maybe<GoodsReceipt_ExtraDataInput>;
  bookLines?: Maybe<UpdateCollectionOfGoodsBookLineInput>;
};

export type ProductPackType = {
  __typename?: 'ProductPackType';
  productId?: Maybe<Scalars['Int']>;
  product?: Maybe<Product>;
  /** Pack type code. Selectable from system pack types */
  packType: Scalars['String'];
  /**
   * The number of inners in the pack.
   * Must be an integer if InnerPackType is specified.
   * May only include decimals if InnerPackType is blank.
   */
  packQuantity: Scalars['Decimal'];
  /** Controls whether pack can be split into smaller units. */
  splitable?: Maybe<Scalars['Boolean']>;
  /**
   * If set, this pack contains PackQuantity (integer) smaller packs of the specified type.
   * If blank, this pack contains loose product.
   */
  innerPackType?: Maybe<Scalars['String']>;
  /** Unit description corresponding to the PackQuantity */
  units?: Maybe<Scalars['String']>;
};

export type StorageTypeMheInput = {
  storageType?: Maybe<StorageTypeInput>;
  MHEId?: Maybe<Scalars['Int']>;
  materialHandlingEquipment?: Maybe<MaterialHandlingEquipmentInput>;
};

export type StockOwnerLinkInput = {
  parent?: Maybe<StockOwnerInput>;
  child?: Maybe<StockOwnerInput>;
};

export type HandlingStorageTypeInput = {
  handlingTypeId?: Maybe<Scalars['Int']>;
  handlingType?: Maybe<HandlingTypeInput>;
  storageTypeId?: Maybe<Scalars['Int']>;
  storageType?: Maybe<StorageTypeInput>;
};

export type DimensionInput = {
  height: Scalars['Decimal'];
  width: Scalars['Decimal'];
  depth: Scalars['Decimal'];
  volume: Scalars['Decimal'];
};

export type ProductRequiredDataInput = {
  /** Capture Expiry date */
  expiry: FieldVisibility;
  /** Capture Best before data */
  bestBefore: FieldVisibility;
  /** Capture Batch */
  batch: FieldVisibility;
  /** Capture Product status */
  status: FieldVisibility;
  /** Capture Pack Type */
  packType: FieldVisibility;
  /** Capture Handling Type */
  handlingType: FieldVisibility;
  /** Capture Serial Number (Singular) */
  serial: FieldVisibility;
  /** Capture Carton licence plate */
  cartonLP: FieldVisibility;
  /** Capture Pallet licence plate */
  palletLP: FieldVisibility;
  /** Capture Temperature on arrival */
  arrivalTemp: FieldVisibility;
  /** Capture Country of origin */
  originCntry: FieldVisibility;
  /** Capture Additional Batch Information */
  batchInfo: FieldVisibility;
  /** Capture Production date */
  productionDte: FieldVisibility;
  /** Capture Kill date */
  killDte: FieldVisibility;
  /** Capture Slaughter code */
  slaughterCode: FieldVisibility;
  /** Capture Budgetholder */
  budgetHolder: FieldVisibility;
  /** Collect serial numbers (Plural) */
  serials: FieldVisibility;
  /** Collect Weight */
  weight?: Maybe<CollectWeight>;
};

export type ContactInput = {
  name?: Maybe<Scalars['String']>;
  telephone?: Maybe<Scalars['String']>;
  fax?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
};

export type AddressInput = {
  /** Property or business name */
  name?: Maybe<Scalars['String']>;
  /** Street address including house number and road */
  street1: Scalars['String'];
  /** Optional additional street name when Street1 is used for an apartment or block */
  street2?: Maybe<Scalars['String']>;
  /** City, Town or Village */
  city?: Maybe<Scalars['String']>;
  /** County or State */
  county?: Maybe<Scalars['String']>;
  /** Postal or Zip code */
  postCode?: Maybe<Scalars['String']>;
  /** Postal Country */
  country?: Maybe<Scalars['String']>;
};

export type TableColumnInput = {
  id?: Maybe<Scalars['Int']>;
  presetId?: Maybe<Scalars['Int']>;
  preset?: Maybe<TablePresetInput>;
  fieldName?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  columnType: PresetColumnType;
  isVisible: Scalars['Boolean'];
  order: Scalars['Int'];
};

export type PreviewTable = {
  __typename?: 'PreviewTable';
  header?: Maybe<Array<Maybe<Scalars['String']>>>;
  records?: Maybe<Array<Maybe<Array<Maybe<Scalars['String']>>>>>;
};


export type BasicResourceItem = {
  __typename?: 'BasicResourceItem';
  resourceId?: Maybe<Scalars['String']>;
  localeId?: Maybe<Scalars['String']>;
  resourceSet?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type UpdateCollectionOfGoodsBookLineInput = {
  create?: Maybe<Array<Maybe<GoodsBookLineInput>>>;
  update?: Maybe<Array<Maybe<GoodsBookLineUpdateInput>>>;
  delete?: Maybe<Array<Maybe<GoodsBookLineInput>>>;
};

export type GoodsBookLineInput = {
  id?: Maybe<Scalars['Int']>;
  quantityExpected: Scalars['Decimal'];
  LPN?: Maybe<Scalars['String']>;
  unReceived?: Maybe<Scalars['Boolean']>;
  receipts?: Maybe<Array<Maybe<GoodsReceiptLineInput>>>;
  header?: Maybe<GoodsReceiptInput>;
  attributeId?: Maybe<Scalars['Int']>;
  attributes: StockAttributesInput;
  supplierId?: Maybe<Scalars['Int']>;
  supplier?: Maybe<SupplierInput>;
  purchaseOrder?: Maybe<Scalars['String']>;
  purchaseOrderLine?: Maybe<Scalars['String']>;
  packType: Scalars['String'];
  productStatus: Scalars['String'];
  bookLine?: Maybe<GoodsBookLineInput>;
  parentBookLineId?: Maybe<Scalars['Int']>;
};

export type GoodsBookLineUpdateInput = {
  quantityExpected: Scalars['Decimal'];
  LPN?: Maybe<Scalars['String']>;
  unReceived?: Maybe<Scalars['Boolean']>;
  attributeId?: Maybe<Scalars['Int']>;
  attributes?: Maybe<StockAttributesUpdateInput>;
  supplierId?: Maybe<Scalars['Int']>;
  purchaseOrder?: Maybe<Scalars['String']>;
  purchaseOrderLine?: Maybe<Scalars['String']>;
  packType?: Maybe<Scalars['String']>;
  productStatus?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
};

export type GoodsReceipt_ExtraDataInput = {
  type?: Maybe<Scalars['String']>;
  containerNo?: Maybe<Scalars['String']>;
  containerType?: Maybe<Scalars['String']>;
  condition?: Maybe<Scalars['String']>;
  sealNo?: Maybe<Scalars['String']>;
  carrier?: Maybe<Scalars['String']>;
  freightCost?: Maybe<Scalars['Decimal']>;
  vehicle?: Maybe<Scalars['String']>;
  trailer?: Maybe<Scalars['String']>;
  driver?: Maybe<Scalars['String']>;
  alternativeRef?: Maybe<Scalars['String']>;
  notes?: Maybe<Array<Maybe<Scalars['String']>>>;
  expected?: Maybe<Scalars['DateTime']>;
  unLoadingTime?: Maybe<Scalars['TimeSpan']>;
  unLoaders?: Maybe<Scalars['Int']>;
  assignedDock?: Maybe<Scalars['String']>;
};

export type TGoodsReceipt_ExtraInput = {
  type?: Maybe<Scalars['String']>;
  containerNo?: Maybe<Scalars['String']>;
  containerType?: Maybe<Scalars['String']>;
  condition?: Maybe<Scalars['String']>;
  sealNo?: Maybe<Scalars['String']>;
  carrier?: Maybe<Scalars['String']>;
  freightCost?: Maybe<Scalars['Decimal']>;
  vehicle?: Maybe<Scalars['String']>;
  trailer?: Maybe<Scalars['String']>;
  driver?: Maybe<Scalars['String']>;
  alternativeRef?: Maybe<Scalars['String']>;
  notes?: Maybe<Array<Maybe<Scalars['String']>>>;
  expected?: Maybe<Scalars['DateTime']>;
  unLoadingTime?: Maybe<Scalars['TimeSpan']>;
  unLoaders?: Maybe<Scalars['Int']>;
  assignedDock?: Maybe<Scalars['String']>;
};

export type GoodsReceiptInput = {
  booked?: Maybe<Array<Maybe<GoodsBookLineInput>>>;
  received?: Maybe<Array<Maybe<GoodsReceiptLineInput>>>;
  id?: Maybe<Scalars['Int']>;
  goodsReceiptNumber: Scalars['String'];
  warehouseId?: Maybe<Scalars['Int']>;
  warehouse?: Maybe<WarehouseInput>;
  stockOwnerId?: Maybe<Scalars['Int']>;
  stockOwner?: Maybe<StockOwnerInput>;
  status?: Maybe<GoodsReceiptState>;
  isUnbooked: Scalars['Boolean'];
  dateCreated?: Maybe<Scalars['DateTime']>;
  dateReceived?: Maybe<Scalars['DateTime']>;
  customerRef?: Maybe<Scalars['String']>;
  invoiceRef?: Maybe<Scalars['String']>;
  createdBy?: Maybe<Scalars['String']>;
  extra?: Maybe<GoodsReceipt_ExtraDataInput>;
};

export type LicencePlateInput = {
  id?: Maybe<Scalars['Int']>;
  LPN: Scalars['String'];
  lPTypeId?: Maybe<Scalars['Int']>;
  LPType?: Maybe<LicencePlateTypeInput>;
  locationId?: Maybe<Scalars['Int']>;
  location?: Maybe<LocationInput>;
  outerId?: Maybe<Scalars['Int']>;
  outer?: Maybe<LicencePlateInput>;
  inners?: Maybe<Array<Maybe<LicencePlateInput>>>;
  owner?: Maybe<LpOwnerInput>;
};

export type LpOwnerInput = {
  owner?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
};

export type LicencePlateTypeInput = {
  id?: Maybe<Scalars['Int']>;
  code?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  size?: Maybe<DimensionInput>;
  tareWeight?: Maybe<Scalars['Decimal']>;
  material?: Maybe<Scalars['String']>;
  controlled?: Maybe<LpControlType>;
};

export type Activity = {
  __typename?: 'Activity';
  id?: Maybe<Scalars['ID']>;
  code?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type CarrierLeadTime = {
  __typename?: 'CarrierLeadTime';
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
};

export type DestinationCode = {
  __typename?: 'DestinationCode';
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
};

export type MaxWeeklySpend = {
  __typename?: 'MaxWeeklySpend';
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
};

export type MaxWeeklySpendInput = {
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
};

export type OrderEntry = {
  __typename?: 'OrderEntry';
  id: Scalars['ID'];
  orderNumber: Scalars['String'];
  destinationCode: DestinationCode;
  budgetHolder: BudgetHolder;
  priority: Scalars['Int'];
  orderType: OrderType;
  soCustomerRef: Scalars['String'];
};

export type OrderFilter = {
  orderNumber_starts_with?: Maybe<Scalars['String']>;
  destinationCodeId?: Maybe<Scalars['ID']>;
  budgetHolderId?: Maybe<Scalars['ID']>;
};

export type CreateOrderEntryInput = {
  orderNumber: Scalars['String'];
  destinationCode: Scalars['ID'];
  budgetHolder: Scalars['ID'];
  priority: Scalars['Int'];
  orderType: Scalars['ID'];
  soCustomerRef: Scalars['String'];
};

export type UpdateOrderEntryInput = {
  destinationCode: Scalars['ID'];
  budgetHolder: Scalars['ID'];
  priority: Scalars['Int'];
  orderType: Scalars['ID'];
  soCustomerRef: Scalars['String'];
};

export type OrderType = {
  __typename?: 'OrderType';
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
};

export type PickListType = {
  __typename?: 'PickListType';
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
};

export type PoFormat = {
  __typename?: 'POFormat';
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
};

export type PoFormatInput = {
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
};

export type PoTransmissionMethod = {
  __typename?: 'POTransmissionMethod';
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
};

export type PoTransmissionMethodInput = {
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
};

export type Route = {
  __typename?: 'Route';
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
};

export type Service = {
  __typename?: 'Service';
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
};

export type ZoneType = {
  __typename?: 'ZoneType';
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
};

export type Zone = {
  __typename?: 'Zone';
  id?: Maybe<Scalars['ID']>;
  code?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  zoneType?: Maybe<ZoneType>;
};

export type ZoneFilter = {
  code_starts_with?: Maybe<Scalars['String']>;
  zoneTypeId?: Maybe<Scalars['ID']>;
};

export type ZoneInput = {
  code: Scalars['String'];
  description: Scalars['String'];
  zoneType?: Maybe<Scalars['ID']>;
};

/**
 * The fundamental unit of any GraphQL Schema is the type. There are many kinds of types in GraphQL as represented by the `__TypeKind` enum.
 *
 * Depending on the kind of a type, certain fields describe information about that type. Scalar types provide no information beyond a name, description and optional `specifiedByUrl`, while Enum types provide their values. Object and Interface types provide the fields they describe. Abstract types, Union and Interface, provide the Object types possible at runtime. List and NonNull types compose other types.
 */
export type __Type = {
  __typename?: '__Type';
  kind: __TypeKind;
  name?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  specifiedByUrl?: Maybe<Scalars['String']>;
  fields?: Maybe<Array<__Field>>;
  interfaces?: Maybe<Array<__Type>>;
  possibleTypes?: Maybe<Array<__Type>>;
  enumValues?: Maybe<Array<__EnumValue>>;
  inputFields?: Maybe<Array<__InputValue>>;
  ofType?: Maybe<__Type>;
};


/**
 * The fundamental unit of any GraphQL Schema is the type. There are many kinds of types in GraphQL as represented by the `__TypeKind` enum.
 *
 * Depending on the kind of a type, certain fields describe information about that type. Scalar types provide no information beyond a name, description and optional `specifiedByUrl`, while Enum types provide their values. Object and Interface types provide the fields they describe. Abstract types, Union and Interface, provide the Object types possible at runtime. List and NonNull types compose other types.
 */
export type __TypeFieldsArgs = {
  includeDeprecated?: Maybe<Scalars['Boolean']>;
};


/**
 * The fundamental unit of any GraphQL Schema is the type. There are many kinds of types in GraphQL as represented by the `__TypeKind` enum.
 *
 * Depending on the kind of a type, certain fields describe information about that type. Scalar types provide no information beyond a name, description and optional `specifiedByUrl`, while Enum types provide their values. Object and Interface types provide the fields they describe. Abstract types, Union and Interface, provide the Object types possible at runtime. List and NonNull types compose other types.
 */
export type __TypeEnumValuesArgs = {
  includeDeprecated?: Maybe<Scalars['Boolean']>;
};


/**
 * The fundamental unit of any GraphQL Schema is the type. There are many kinds of types in GraphQL as represented by the `__TypeKind` enum.
 *
 * Depending on the kind of a type, certain fields describe information about that type. Scalar types provide no information beyond a name, description and optional `specifiedByUrl`, while Enum types provide their values. Object and Interface types provide the fields they describe. Abstract types, Union and Interface, provide the Object types possible at runtime. List and NonNull types compose other types.
 */
export type __TypeInputFieldsArgs = {
  includeDeprecated?: Maybe<Scalars['Boolean']>;
};

/** An enum describing what kind of type a given `__Type` is. */
export enum __TypeKind {
  /** Indicates this type is a scalar. */
  Scalar = 'SCALAR',
  /** Indicates this type is an object. `fields` and `interfaces` are valid fields. */
  Object = 'OBJECT',
  /** Indicates this type is an interface. `fields`, `interfaces`, and `possibleTypes` are valid fields. */
  Interface = 'INTERFACE',
  /** Indicates this type is a union. `possibleTypes` is a valid field. */
  Union = 'UNION',
  /** Indicates this type is an enum. `enumValues` is a valid field. */
  Enum = 'ENUM',
  /** Indicates this type is an input object. `inputFields` is a valid field. */
  InputObject = 'INPUT_OBJECT',
  /** Indicates this type is a list. `ofType` is a valid field. */
  List = 'LIST',
  /** Indicates this type is a non-null. `ofType` is a valid field. */
  NonNull = 'NON_NULL'
}

/** Object and Interface types are described by a list of Fields, each of which has a name, potentially a list of arguments, and a return type. */
export type __Field = {
  __typename?: '__Field';
  name: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  args: Array<__InputValue>;
  type: __Type;
  isDeprecated: Scalars['Boolean'];
  deprecationReason?: Maybe<Scalars['String']>;
};


/** Object and Interface types are described by a list of Fields, each of which has a name, potentially a list of arguments, and a return type. */
export type __FieldArgsArgs = {
  includeDeprecated?: Maybe<Scalars['Boolean']>;
};

/** Arguments provided to Fields or Directives and the input fields of an InputObject are represented as Input Values which describe their type and optionally a default value. */
export type __InputValue = {
  __typename?: '__InputValue';
  name: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  type: __Type;
  /** A GraphQL-formatted string representing the default value for this input value. */
  defaultValue?: Maybe<Scalars['String']>;
  isDeprecated: Scalars['Boolean'];
  deprecationReason?: Maybe<Scalars['String']>;
};

/** One possible value for a given Enum. Enum values are unique values, not a placeholder for a string or numeric value. However an Enum value is returned in a JSON response as a string. */
export type __EnumValue = {
  __typename?: '__EnumValue';
  name: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  isDeprecated: Scalars['Boolean'];
  deprecationReason?: Maybe<Scalars['String']>;
};

export type ActivityFragment = (
  { __typename?: 'Activity' }
  & Pick<Activity, 'id' | 'code' | 'name'>
);

export type AddressFragment = (
  { __typename?: 'Address' }
  & Pick<Address, 'city' | 'country' | 'county' | 'postCode' | 'street1' | 'street2'>
);

export type AuditLogFragment = (
  { __typename?: 'AuditEntry' }
  & Pick<AuditEntry, 'id' | 'attributeId' | 'singles' | 'packs' | 'status' | 'packType' | 'fromLocationId' | 'toLocationId' | 'code' | 'eventTime' | 'message' | 'metadata' | 'stockOwnerId' | 'userId' | 'warehouseId'>
  & { fromLocation?: Maybe<(
    { __typename?: 'Location' }
    & Pick<Location, 'id' | 'code'>
  )>, toLocation?: Maybe<(
    { __typename?: 'Location' }
    & Pick<Location, 'id' | 'code'>
  )>, attributes?: Maybe<(
    { __typename?: 'StockAttributes' }
    & Pick<StockAttributes, 'id' | 'batch' | 'batchInfo' | 'bestBeforeDate' | 'budgetHolder' | 'catchWeight' | 'GRN' | 'killDate' | 'PONumber' | 'productId' | 'productionDate' | 'sellByDate' | 'serialNumber' | 'slaughterCode'>
    & { product?: Maybe<(
      { __typename?: 'Product' }
      & Pick<Product, 'code' | 'description'>
    )> }
  )>, stockOwner?: Maybe<(
    { __typename?: 'StockOwner' }
    & Pick<StockOwner, 'code'>
  )>, user?: Maybe<(
    { __typename?: 'WMSUser' }
    & Pick<WmsUser, 'userName'>
  )>, warehouse?: Maybe<(
    { __typename?: 'Warehouse' }
    & Pick<Warehouse, 'code'>
  )> }
);

export type BudgetHolderFragment = (
  { __typename?: 'BudgetHolder' }
  & Pick<BudgetHolder, 'id' | 'code' | 'description' | 'status'>
);

export type BudgetFragment = (
  { __typename?: 'DestinationBudget' }
  & Pick<DestinationBudget, 'id' | 'maxSpend' | 'spent' | 'startDate'>
);

export type CarrierFragment = (
  { __typename?: 'Carrier' }
  & Pick<Carrier, 'id' | 'code' | 'captureDelNo' | 'defDespatchLane' | 'defService' | 'module' | 'name' | 'requireService' | 'telephone'>
);

export type CarrierAccountFragment = (
  { __typename?: 'CarrierAccount' }
  & Pick<CarrierAccount, 'id' | 'account' | 'allowedServices' | 'description'>
  & { configuration?: Maybe<Array<Maybe<(
    { __typename?: 'CarrierConfig' }
    & Pick<CarrierConfig, 'id' | 'setting' | 'value'>
  )>>> }
);

export type CarrierServiceFragment = (
  { __typename?: 'CarrierService' }
  & Pick<CarrierService, 'code' | 'collection' | 'description' | 'extraBoxInfo' | 'id' | 'localCollect' | 'maxHeight' | 'maxLength' | 'maxWeight' | 'maxWidth' | 'nextDay' | 'notifyEmail' | 'notifySMS' | 'recordDelivery' | 'references' | 'saturday' | 'signReq' | 'sunday' | 'trackingReq'>
);

export type CategoryFragment = (
  { __typename?: 'CategoryDefinition' }
  & Pick<CategoryDefinition, 'id' | 'code' | 'description'>
);

export type CodeFragment = (
  { __typename?: 'UDCode' }
  & Pick<UdCode, 'id' | 'code' | 'codeType' | 'description' | 'longDescription'>
);

export type CodeDefinitionFragment = (
  { __typename?: 'CodeDefinition' }
  & Pick<CodeDefinition, 'id' | 'name' | 'description'>
);

export type PresetForTableFragment = (
  { __typename: 'TablePreset' }
  & Pick<TablePreset, 'id' | 'table' | 'title' | 'userId'>
  & { columns?: Maybe<Array<Maybe<(
    { __typename?: 'TableColumn' }
    & Pick<TableColumn, 'id' | 'displayName' | 'fieldName' | 'columnType' | 'isVisible' | 'order' | 'presetId'>
  )>>> }
);

export type ContactFragment = (
  { __typename?: 'Contact' }
  & Pick<Contact, 'email' | 'fax' | 'name' | 'telephone'>
);

export type DestinationFragment = (
  { __typename?: 'Destination' }
  & Pick<Destination, 'area' | 'ASNMethod' | 'ASNOnDespatch' | 'budgetholder' | 'captureSerialOnDesp' | 'category' | 'code' | 'custStkCodeOnDespNotes' | 'defDespLane' | 'defOrderPri' | 'defOrderType' | 'defRoute' | 'defSpecIns' | 'despMethod' | 'despNoteFormat' | 'facility' | 'FTPAcc' | 'id' | 'masterAcc' | 'name' | 'noDespNotes' | 'orderDay' | 'orderFreq' | 'palletMethod' | 'pickLocation' | 'printBoxLbls' | 'printBoxNotes' | 'printNotesDelayDesp' | 'reqManifest' | 'salesman' | 'suppressBackOrdClose' | 'transitTime' | 'usePalletMethod' | 'VATNo' | 'depot' | 'masterHub' | 'subHub' | 'status' | 'GLN' | 'customsId' | 'defDelGroup' | 'minPickValue' | 'noPickConsolidation'>
  & { owner?: Maybe<(
    { __typename?: 'StockOwner' }
    & Pick<StockOwner, 'id' | 'code'>
  )> }
);

export type DestinationCodeFragment = (
  { __typename?: 'DestinationCode' }
  & Pick<DestinationCode, 'id' | 'name' | 'description'>
);

export type GoodReceiptAttributesFragment = (
  { __typename?: 'StockAttributes' }
  & Pick<StockAttributes, 'id' | 'productId' | 'batch' | 'batchInfo' | 'serialNumber' | 'slaughterCode' | 'sellByDate' | 'killDate' | 'PONumber' | 'budgetHolder' | 'catchWeight' | 'bestBeforeDate' | 'productionDate'>
  & { product?: Maybe<(
    { __typename?: 'Product' }
    & Pick<Product, 'id' | 'code' | 'description'>
    & { require?: Maybe<(
      { __typename?: 'ProductRequiredData' }
      & Pick<ProductRequiredData, 'batch' | 'batchInfo' | 'bestBefore' | 'budgetHolder' | 'expiry' | 'killDte' | 'packType' | 'productionDte' | 'serial' | 'serials' | 'slaughterCode' | 'status' | 'weight'>
    )> }
  )> }
);

export type BookedFragment = (
  { __typename?: 'GoodsBookLine' }
  & Pick<GoodsBookLine, 'id' | 'purchaseOrder' | 'purchaseOrderLine' | 'productStatus' | 'quantityExpected' | 'supplierId' | 'packType' | 'LPN' | 'attributeId'>
  & { supplier?: Maybe<(
    { __typename?: 'Supplier' }
    & Pick<Supplier, 'code'>
  )>, attributes?: Maybe<(
    { __typename?: 'StockAttributes' }
    & GoodReceiptAttributesFragment
  )> }
);

export type ExtraFragment = (
  { __typename?: 'GoodsReceipt_ExtraData' }
  & Pick<GoodsReceipt_ExtraData, 'type' | 'containerNo' | 'containerType' | 'condition' | 'sealNo' | 'carrier' | 'freightCost' | 'vehicle' | 'trailer' | 'driver' | 'notes' | 'expected' | 'unLoadingTime' | 'unLoaders' | 'assignedDock' | 'alternativeRef'>
);

export type ReceivedFragment = (
  { __typename?: 'GoodsReceiptLine' }
  & Pick<GoodsReceiptLine, 'id' | 'productStatus' | 'purchaseOrder' | 'purchaseOrderLine' | 'packType' | 'quantityReceived' | 'attributeId'>
  & { supplier?: Maybe<(
    { __typename?: 'Supplier' }
    & Pick<Supplier, 'code'>
  )>, licencePlate?: Maybe<(
    { __typename?: 'LicencePlate' }
    & Pick<LicencePlate, 'LPN' | 'lPTypeId'>
    & { LPType?: Maybe<(
      { __typename?: 'LicencePlateType' }
      & Pick<LicencePlateType, 'code'>
    )> }
  )>, attributes?: Maybe<(
    { __typename?: 'StockAttributes' }
    & GoodReceiptAttributesFragment
  )> }
);

export type HandlingTypeFragment = (
  { __typename?: 'HandlingType' }
  & Pick<HandlingType, 'id' | 'code' | 'description'>
);

export type LocationFragment = (
  { __typename?: 'Location' }
  & Pick<Location, 'id' | 'aisle' | 'attributes' | 'beam' | 'beamSequence' | 'checkCode' | 'code' | 'countZone' | 'elevation' | 'maxWeight' | 'pickZone' | 'physicalCharacteristics' | 'processCharacteristics' | 'status' | 'temperatureType' | 'tier' | 'zone'>
  & { dimensions: (
    { __typename?: 'Dimension' }
    & Pick<Dimension, 'depth' | 'height' | 'width' | 'volume'>
  ), storageType?: Maybe<(
    { __typename?: 'StorageType' }
    & StorageTypeFragment
  )> }
);

export type MaxWeeklySpendFragment = (
  { __typename?: 'MaxWeeklySpend' }
  & Pick<MaxWeeklySpend, 'id' | 'name'>
);

export type ScreenFragment = (
  { __typename?: 'Screen' }
  & Pick<Screen, 'id' | 'action' | 'compareTo' | 'defaultTitle' | 'description' | 'screenCode'>
);

export type MenuEntryFragment = (
  { __typename?: 'MenuEntry' }
  & Pick<MenuEntry, 'id' | 'enabled' | 'depth' | 'defaultGroupId' | 'parentId' | 'screenId' | 'userId' | 'title' | 'order'>
  & { parent?: Maybe<(
    { __typename?: 'MenuEntry' }
    & Pick<MenuEntry, 'id' | 'enabled' | 'depth' | 'defaultGroupId' | 'parentId' | 'screenId' | 'userId' | 'title' | 'order'>
    & { screen?: Maybe<(
      { __typename?: 'Screen' }
      & ScreenFragment
    )> }
  )> }
);

export type MheFragment = (
  { __typename?: 'MaterialHandlingEquipment' }
  & Pick<MaterialHandlingEquipment, 'id' | 'code' | 'class' | 'description' | 'heightLimit' | 'maximumWeight' | 'width'>
);

export type OrderEntryFragment = (
  { __typename?: 'OrderEntry' }
  & Pick<OrderEntry, 'id' | 'orderNumber' | 'priority' | 'soCustomerRef'>
);

export type OrderStatusFragment = (
  { __typename?: 'OrderStatus' }
  & Pick<OrderStatus, 'id' | 'code' | 'description' | 'purpose'>
);

export type OrderTypeFragment = (
  { __typename?: 'OrderType' }
  & Pick<OrderType, 'id' | 'name'>
);

export type PoFormatFragment = (
  { __typename?: 'POFormat' }
  & Pick<PoFormat, 'id' | 'name'>
);

export type PoTransmissionMethodFragment = (
  { __typename?: 'POTransmissionMethod' }
  & Pick<PoTransmissionMethod, 'id' | 'name'>
);

export type PickfaceFragment = (
  { __typename?: 'ProductPickface' }
  & Pick<ProductPickface, 'id' | 'budhol' | 'location' | 'maxFaceQty' | 'pickZone' | 'replenMulti' | 'replenTriggr' | 'warehouse'>
);

export type ProductFragment = (
  { __typename?: 'Product' }
  & Pick<Product, 'id' | 'code' | 'altCode' | 'gTIN' | 'substitute' | 'linkCode' | 'description' | 'longDesc' | 'defGRStatus' | 'SKUType' | 'type' | 'INCICode' | 'manufacturerCode' | 'StorageType' | 'rotation' | 'facilityCat' | 'defBudhol' | 'defWH' | 'defHandType' | 'defPackType' | 'depCode' | 'lifeCycleStatus' | 'rank' | 'uNCode' | 'bandQty' | 'minPShlfLife' | 'minRShlfLife' | 'totShlfLife' | 'packValidateBatch' | 'capturePackType' | 'pickPartPalletsAsFull' | 'pickSingles' | 'pickDefId'>
  & { require?: Maybe<(
    { __typename?: 'ProductRequiredData' }
    & Pick<ProductRequiredData, 'arrivalTemp' | 'batch' | 'batchInfo' | 'bestBefore' | 'budgetHolder' | 'cartonLP' | 'expiry' | 'handlingType' | 'killDte' | 'originCntry' | 'packType' | 'palletLP' | 'productionDte' | 'serial' | 'serials' | 'slaughterCode' | 'status' | 'weight'>
  )>, suppliers?: Maybe<Array<Maybe<(
    { __typename?: 'ProductSupplier' }
    & Pick<ProductSupplier, 'id' | 'active' | 'supplierId' | 'warehouseId'>
    & { warehouse?: Maybe<(
      { __typename?: 'Warehouse' }
      & Pick<Warehouse, 'code' | 'warehouseName'>
    )>, supplier?: Maybe<(
      { __typename?: 'Supplier' }
      & Pick<Supplier, 'code' | 'name'>
    )> }
  )>>>, components?: Maybe<Array<Maybe<(
    { __typename?: 'BOMDefinition' }
    & Pick<BomDefinition, 'id' | 'childId' | 'qty'>
    & { parent?: Maybe<(
      { __typename?: 'Product' }
      & Pick<Product, 'code'>
    )>, child?: Maybe<(
      { __typename?: 'Product' }
      & Pick<Product, 'code' | 'description'>
    )> }
  )>>> }
);

export type DocumentFragment = (
  { __typename?: 'ProductDocument' }
  & Pick<ProductDocument, 'id' | 'name' | 'type' | 'uploadBy' | 'uploaded' | 'usage'>
);

export type LicencePlateFragment = (
  { __typename?: 'LPDefinition' }
  & Pick<LpDefinition, 'id' | 'depth' | 'diagram' | 'handType' | 'height' | 'layerQty' | 'maxLayerQty' | 'packType' | 'quantity' | 'weight' | 'width'>
);

export type ProductStatusesFragment = (
  { __typename?: 'ProductStatus' }
  & Pick<ProductStatus, 'id' | 'code' | 'description' | 'adjustStock' | 'processStatus' | 'targetStatuses'>
);

export type ProductSupplierFragment = (
  { __typename?: 'ProductSupplier' }
  & Pick<ProductSupplier, 'id' | 'active' | 'supplierId' | 'warehouseId'>
);

export type PurchaseOrderFragment = (
  { __typename?: 'PurchaseOrder' }
  & Pick<PurchaseOrder, 'id' | 'after' | 'before' | 'billOfLading' | 'budgetHolder' | 'carrier' | 'carrierService' | 'containerNo' | 'crossDock' | 'currency' | 'custReferences' | 'entered' | 'enteredBy' | 'exportBatch' | 'message' | 'parent' | 'referenceNumber' | 'status' | 'type' | 'supplierId'>
  & { supplier?: Maybe<(
    { __typename?: 'Supplier' }
    & Pick<Supplier, 'code' | 'name'>
  )>, instructions?: Maybe<Array<Maybe<(
    { __typename?: 'POInstruction' }
    & PoInstructionsFragment
  )>>>, items?: Maybe<Array<Maybe<(
    { __typename?: 'PurchaseOrderItem' }
    & ItemsFragment
  )>>>, stockOwner?: Maybe<(
    { __typename?: 'StockOwner' }
    & Pick<StockOwner, 'id' | 'code' | 'name'>
  )> }
);

export type PoInstructionsFragment = (
  { __typename?: 'POInstruction' }
  & Pick<PoInstruction, 'id' | 'message' | 'type'>
);

export type ItemsFragment = (
  { __typename?: 'PurchaseOrderItem' }
  & Pick<PurchaseOrderItem, 'attributeId' | 'id' | 'lineNumber' | 'lineStatus' | 'LPN' | 'price' | 'productStatus' | 'quantityBooked' | 'quantityDelivered' | 'quantityManifested' | 'quantityOrdered' | 'quantityShipped'>
  & { attributes?: Maybe<(
    { __typename?: 'StockAttributes' }
    & GoodReceiptAttributesFragment
  )> }
);

export type RoutingFragment = (
  { __typename?: 'DestinationRoute' }
  & Pick<DestinationRoute, 'days' | 'dropNumber' | 'frequency' | 'id' | 'route'>
  & { destination?: Maybe<(
    { __typename?: 'Destination' }
    & Pick<Destination, 'id' | 'code'>
  )> }
);

export type StockFragment = (
  { __typename?: 'Stock' }
  & Pick<Stock, 'locationId' | 'productId' | 'status' | 'licencePlateId' | 'packType' | 'packs' | 'singles' | 'allocated'>
  & { location?: Maybe<(
    { __typename?: 'Location' }
    & Pick<Location, 'id' | 'code'>
  )>, product?: Maybe<(
    { __typename?: 'Product' }
    & Pick<Product, 'id' | 'code'>
  )>, licencePlate?: Maybe<(
    { __typename?: 'LicencePlate' }
    & Pick<LicencePlate, 'id' | 'LPN'>
  )>, attributes?: Maybe<(
    { __typename?: 'StockAttributes' }
    & Pick<StockAttributes, 'id' | 'batch' | 'batchInfo' | 'bestBeforeDate' | 'budgetHolder' | 'catchWeight' | 'GRN' | 'killDate' | 'PONumber' | 'productId' | 'productionDate' | 'sellByDate' | 'serialNumber' | 'slaughterCode'>
  )> }
);

export type StockOwnerFragment = (
  { __typename?: 'StockOwner' }
  & Pick<StockOwner, 'id' | 'code' | 'name' | 'status' | 'GLN' | 'coldStoreID' | 'VATNumber' | 'warnMoveDifStatus' | 'requireBudhol' | 'requireProdCategories' | 'scanBarcodeMask' | 'keyedBarcodeMask' | 'captureSerialsOnRcpt' | 'requirePalletID' | 'printPalLblsOnRcpt' | 'capturePONumOnRcpt' | 'allocateLocOnRcpt' | 'closeComPoOnRcpt' | 'validateBatchPO' | 'capturePkgInfoOnRcpt' | 'putwayLPOnRcpt' | 'confirmPutawaysOnRcpt' | 'reqAuthOnGRClose' | 'defaultUnbookedRcpt' | 'strictPODateVal' | 'splitSuppTolerance' | 'RVPutToDefLoc' | 'disablePutForSpecificLocs' | 'mandExtraInfoOnRcpt' | 'captureContainerType' | 'F2ShowBookedProdsOnly' | 'autoGeneratePONumber' | 'allowEditInRV' | 'GRPrintCrtnLbls' | 'identicalPallets' | 'noBckFlushGRProduction' | 'matchGRWithBookNo' | 'RVSuppressMergePF' | 'spltPOLinesOnPrint' | 'makeGRNBudhol' | 'allowShortShelfLife' | 'allowAddProdsToPO' | 'captureLocOnRcpt' | 'captureTempOnRcpt' | 'printLblsGRProduction' | 'autoGenOrderNum' | 'dispOrderEntryErrs' | 'requirePOD' | 'createPickOnOrdEntry' | 'dontClearLineCustRef' | 'mandLineCustref' | 'warnOnShortage' | 'printOrdRptWithPick' | 'forceBudholOnEntry' | 'preventBatchOnEntry' | 'swapGenericsOnEntry' | 'GDPRControlled' | 'printOrdConfRpt' | 'printBoxPackLbls' | 'cleanOrdersOnly' | 'createBackOrders' | 'allowShortageSwap' | 'allowBudholSwap' | 'chngeTraysOnPri' | 'noReplenPicksOnly' | 'allowStatusSwap' | 'pickCartons' | 'MPNoSplitLists' | 'showUnpickableRpt' | 'forceDepartmentOnEntry' | 'allowLPSwap' | 'allowSBDSwap' | 'findCartonByWgt' | 'captureCarrier' | 'allowLocSwap' | 'useBOMPicking' | 'requireDespNote' | 'voicePickAssignment' | 'allowBatchSwap' | 'requireConfProduct' | 'requireUPICheck' | 'cageValidation' | 'suppressReplenOpt' | 'despNoteValidation' | 'RFPickAssignment' | 'useLoading' | 'produceRFManifest' | 'requireSealNo' | 'useLoadOrder' | 'requireTruck' | 'requireDriver' | 'loadOrder' | 'despLane' | 'maxLoaders' | 'adhocLoading' | 'loadTempCaptureStart' | 'loadTempCaptureEnd' | 'loadTempLPInterval' | 'captureTimeOnConfirm' | 'captureCheckerOnConfirm' | 'capturePickerOnConfirm' | 'defPickFailCode' | 'requireDespatchLane' | 'useEmailFromDestination' | 'reprntUnfinishedLists' | 'destockShortOnSHort' | 'proportionalBoxesOnConfirm' | 'allowLoadAnySeq' | 'MBPLPControl' | 'MBPUseSODespMeth' | 'noDespNotes' | 'previewDespNote' | 'BOMSToStock' | 'delayDespatch' | 'RFWarnInPckConf' | 'noReplenPckConf' | 'despNotePerList' | 'disablImmDesp' | 'allowFutureDespDates' | 'MBPCaptureConsNo' | 'optConsNo' | 'boxLblsPickConf' | 'useLPIdsPickConfirm' | 'authMBP' | 'mandContainerType' | 'PDFDespNotes' | 'useDespPrefix' | 'noOfDespNotes' | 'confWholePick' | 'capReasonDelayDesp' | 'MBPDespNoteBreakdwn' | 'dontCloseOrderOnLblFail' | 'capBoxesPerOrder' | 'carrierNotReq' | 'copyCarrToBckOrd' | 'printBoxLbls' | 'noCarrLblsPckConf'>
);

export type CategoryDefinitionFragment = (
  { __typename?: 'CategoryDefinition' }
  & Pick<CategoryDefinition, 'id' | 'code' | 'description'>
);

export type PickConfirmMethodFragment = (
  { __typename?: 'PickConfirmMethod' }
  & Pick<PickConfirmMethod, 'id' | 'name' | 'default' | 'pickConfMethod' | 'postConfMethod' | 'packingMethod' | 'despatchMethod' | 'loadCloseMethod'>
);

export type PickMethodFragment = (
  { __typename?: 'PickMethod' }
  & Pick<PickMethod, 'id' | 'default' | 'name' | 'outputMethod' | 'pickingMethod' | 'postPickMethod' | 'prePickMethod'>
);

export type StorageTypeFragment = (
  { __typename?: 'StorageType' }
  & Pick<StorageType, 'id' | 'code' | 'description'>
  & { MHEs?: Maybe<Array<Maybe<(
    { __typename?: 'StorageTypeMHE' }
    & { materialHandlingEquipment?: Maybe<(
      { __typename?: 'MaterialHandlingEquipment' }
      & Pick<MaterialHandlingEquipment, 'id' | 'code'>
    )> }
  )>>> }
);

export type SupplierFragment = (
  { __typename?: 'Supplier' }
  & Pick<Supplier, 'id' | 'code' | 'name' | 'currency' | 'fileFormat' | 'fileTransMeth' | 'leadTime' | 'master' | 'maxWeekSpend' | 'mustOrderLayerQty' | 'orderDays'>
);

export type UserFragment = (
  { __typename?: 'WMSUser' }
  & Pick<WmsUser, 'id' | 'userName' | 'accessFailedCount' | 'culture' | 'email' | 'forename' | 'lockoutEnd' | 'normalizedUserName' | 'phoneNumber' | 'serverRole' | 'surname' | 'twoFactorEnabled'>
);

export type CurrentUserFragment = (
  { __typename?: 'WMSUser' }
  & Pick<WmsUser, 'id' | 'userName' | 'forename' | 'surname' | 'culture' | 'serverRole'>
);

export type UserMenusFragment = (
  { __typename?: 'WMSUser' }
  & { userMenus?: Maybe<Array<Maybe<(
    { __typename?: 'MenuEntry' }
    & { screen?: Maybe<(
      { __typename?: 'Screen' }
      & ScreenFragment
    )>, parent?: Maybe<(
      { __typename?: 'MenuEntry' }
      & { screen?: Maybe<(
        { __typename?: 'Screen' }
        & ScreenFragment
      )> }
      & MenuEntryFragment
    )>, children?: Maybe<Array<Maybe<(
      { __typename?: 'MenuEntry' }
      & { screen?: Maybe<(
        { __typename?: 'Screen' }
        & ScreenFragment
      )>, children?: Maybe<Array<Maybe<(
        { __typename?: 'MenuEntry' }
        & { screen?: Maybe<(
          { __typename?: 'Screen' }
          & ScreenFragment
        )>, children?: Maybe<Array<Maybe<(
          { __typename?: 'MenuEntry' }
          & { screen?: Maybe<(
            { __typename?: 'Screen' }
            & ScreenFragment
          )>, children?: Maybe<Array<Maybe<(
            { __typename?: 'MenuEntry' }
            & { screen?: Maybe<(
              { __typename?: 'Screen' }
              & ScreenFragment
            )> }
            & MenuEntryFragment
          )>>> }
          & MenuEntryFragment
        )>>> }
        & MenuEntryFragment
      )>>> }
      & MenuEntryFragment
    )>>> }
    & MenuEntryFragment
  )>>> }
);

export type UserPermissionFragment = (
  { __typename?: 'UserPermission' }
  & Pick<UserPermission, 'id' | 'permissions' | 'stockOwnerId' | 'userId' | 'warehouseId'>
  & { warehouse?: Maybe<(
    { __typename?: 'Warehouse' }
    & Pick<Warehouse, 'code' | 'warehouseName'>
  )>, stockOwner?: Maybe<(
    { __typename?: 'StockOwner' }
    & Pick<StockOwner, 'code' | 'name'>
  )> }
);

export type WarehouseFragment = (
  { __typename?: 'Warehouse' }
  & Pick<Warehouse, 'id' | 'code' | 'warehouseName' | 'companyName' | 'telephone' | 'VATNumber' | 'customsId'>
);

export type ZoneFragment = (
  { __typename?: 'Zone' }
  & Pick<Zone, 'id' | 'code' | 'description'>
);

export type WarehouseZoneFragment = (
  { __typename?: 'WarehouseZone' }
  & Pick<WarehouseZone, 'id' | 'code' | 'description'>
);

export type ZoneTypeFragment = (
  { __typename?: 'ZoneType' }
  & Pick<ZoneType, 'id' | 'name'>
);

export type CreateBudgetHolderMutationVariables = Exact<{
  input?: Maybe<BudgetHolderInput>;
  userContext?: Maybe<UserContextInput>;
}>;


export type CreateBudgetHolderMutation = (
  { __typename?: 'Mutation' }
  & { createBudgetHolder?: Maybe<(
    { __typename?: 'BudgetHolder' }
    & BudgetHolderFragment
  )> }
);

export type UpdateBudgetHolderMutationVariables = Exact<{
  id: Scalars['Int'];
  input?: Maybe<BudgetHolderUpdateInput>;
  userContext?: Maybe<UserContextInput>;
}>;


export type UpdateBudgetHolderMutation = (
  { __typename?: 'Mutation' }
  & { updateBudgetHolder?: Maybe<(
    { __typename?: 'BudgetHolder' }
    & BudgetHolderFragment
  )> }
);

export type DeleteBudgetHolderMutationVariables = Exact<{
  id: Scalars['Int'];
  userContext?: Maybe<UserContextInput>;
}>;


export type DeleteBudgetHolderMutation = (
  { __typename?: 'Mutation' }
  & { deleteBudgetHolder?: Maybe<(
    { __typename?: 'BudgetHolder' }
    & Pick<BudgetHolder, 'id'>
  )> }
);

export type CreateCarrierMutationVariables = Exact<{
  input?: Maybe<CarrierInput>;
  userContext?: Maybe<UserContextInput>;
}>;


export type CreateCarrierMutation = (
  { __typename?: 'Mutation' }
  & { createCarrier?: Maybe<(
    { __typename?: 'Carrier' }
    & { accounts?: Maybe<Array<Maybe<(
      { __typename?: 'CarrierAccount' }
      & CarrierAccountFragment
    )>>>, services?: Maybe<Array<Maybe<(
      { __typename?: 'CarrierService' }
      & CarrierServiceFragment
    )>>> }
    & CarrierFragment
  )> }
);

export type UpdateCarrierMutationVariables = Exact<{
  id: Scalars['Int'];
  input?: Maybe<CarrierUpdateInput>;
  userContext?: Maybe<UserContextInput>;
}>;


export type UpdateCarrierMutation = (
  { __typename?: 'Mutation' }
  & { updateCarrier?: Maybe<(
    { __typename?: 'Carrier' }
    & { accounts?: Maybe<Array<Maybe<(
      { __typename?: 'CarrierAccount' }
      & CarrierAccountFragment
    )>>>, services?: Maybe<Array<Maybe<(
      { __typename?: 'CarrierService' }
      & CarrierServiceFragment
    )>>> }
    & CarrierFragment
  )> }
);

export type DeleteCarrierMutationVariables = Exact<{
  id: Scalars['Int'];
  userContext?: Maybe<UserContextInput>;
}>;


export type DeleteCarrierMutation = (
  { __typename?: 'Mutation' }
  & { deleteCarrier?: Maybe<(
    { __typename?: 'Carrier' }
    & Pick<Carrier, 'id'>
  )> }
);

export type CreateCarrierAccountMutationVariables = Exact<{
  carrierId: Scalars['Int'];
  input?: Maybe<CarrierAccountInput>;
  userContext?: Maybe<UserContextInput>;
}>;


export type CreateCarrierAccountMutation = (
  { __typename?: 'Mutation' }
  & { createCarrierAccount?: Maybe<(
    { __typename?: 'CarrierAccount' }
    & Pick<CarrierAccount, 'id' | 'account'>
  )> }
);

export type UpdateCarrierAccountMutationVariables = Exact<{
  id: Scalars['Int'];
  carrierId: Scalars['Int'];
  input?: Maybe<CarrierAccountUpdateInput>;
  userContext?: Maybe<UserContextInput>;
}>;


export type UpdateCarrierAccountMutation = (
  { __typename?: 'Mutation' }
  & { updateCarrierAccount?: Maybe<(
    { __typename?: 'CarrierAccount' }
    & Pick<CarrierAccount, 'id' | 'account'>
  )> }
);

export type DeleteCarrierAccountMutationVariables = Exact<{
  id: Scalars['Int'];
  carrierId: Scalars['Int'];
  userContext?: Maybe<UserContextInput>;
}>;


export type DeleteCarrierAccountMutation = (
  { __typename?: 'Mutation' }
  & { deleteCarrierAccount?: Maybe<(
    { __typename?: 'CarrierAccount' }
    & Pick<CarrierAccount, 'id' | 'account'>
  )> }
);

export type AddCarrierConfigMutationVariables = Exact<{
  accountId: Scalars['Int'];
  carrierId: Scalars['Int'];
  config?: Maybe<CarrierConfigInput>;
  userContext?: Maybe<UserContextInput>;
}>;


export type AddCarrierConfigMutation = (
  { __typename?: 'Mutation' }
  & { addCarrierConfig?: Maybe<(
    { __typename?: 'CarrierConfig' }
    & Pick<CarrierConfig, 'id' | 'setting' | 'value'>
  )> }
);

export type UpdateCarrierConfigMutationVariables = Exact<{
  accountId: Scalars['Int'];
  carrierId: Scalars['Int'];
  id: Scalars['Int'];
  config?: Maybe<CarrierConfigUpdateInput>;
  userContext?: Maybe<UserContextInput>;
}>;


export type UpdateCarrierConfigMutation = (
  { __typename?: 'Mutation' }
  & { updateCarrierConfig?: Maybe<(
    { __typename?: 'CarrierConfig' }
    & Pick<CarrierConfig, 'id' | 'setting' | 'value'>
  )> }
);

export type RemoveCarrierConfigMutationVariables = Exact<{
  accountId: Scalars['Int'];
  carrierId: Scalars['Int'];
  id: Scalars['Int'];
  userContext?: Maybe<UserContextInput>;
}>;


export type RemoveCarrierConfigMutation = (
  { __typename?: 'Mutation' }
  & { removeCarrierConfig?: Maybe<(
    { __typename?: 'CarrierConfig' }
    & Pick<CarrierConfig, 'id' | 'setting' | 'value'>
  )> }
);

export type CreatCarrierServiceMutationVariables = Exact<{
  carrierId: Scalars['Int'];
  input?: Maybe<CarrierServiceInput>;
  userContext?: Maybe<UserContextInput>;
}>;


export type CreatCarrierServiceMutation = (
  { __typename?: 'Mutation' }
  & { createCarrierService?: Maybe<(
    { __typename?: 'CarrierService' }
    & Pick<CarrierService, 'id' | 'code'>
  )> }
);

export type UpdateCarrierServiceMutationVariables = Exact<{
  id: Scalars['Int'];
  carrierId: Scalars['Int'];
  input?: Maybe<CarrierServiceUpdateInput>;
  userContext?: Maybe<UserContextInput>;
}>;


export type UpdateCarrierServiceMutation = (
  { __typename?: 'Mutation' }
  & { updateCarrierService?: Maybe<(
    { __typename?: 'CarrierService' }
    & Pick<CarrierService, 'id' | 'code'>
  )> }
);

export type DeleteCarrierServiceMutationVariables = Exact<{
  id: Scalars['Int'];
  carrierId: Scalars['Int'];
  userContext?: Maybe<UserContextInput>;
}>;


export type DeleteCarrierServiceMutation = (
  { __typename?: 'Mutation' }
  & { deleteCarrierService?: Maybe<(
    { __typename?: 'CarrierService' }
    & Pick<CarrierService, 'id' | 'code'>
  )> }
);

export type CreateUdcMutationVariables = Exact<{
  input?: Maybe<UdCodeInput>;
  userContext?: Maybe<UserContextInput>;
}>;


export type CreateUdcMutation = (
  { __typename?: 'Mutation' }
  & { createUDC?: Maybe<(
    { __typename?: 'UDCode' }
    & CodeFragment
  )> }
);

export type UpdateUdcMutationVariables = Exact<{
  id: Scalars['Int'];
  input?: Maybe<UdCodeUpdateInput>;
  userContext?: Maybe<UserContextInput>;
}>;


export type UpdateUdcMutation = (
  { __typename?: 'Mutation' }
  & { updateUDC?: Maybe<(
    { __typename?: 'UDCode' }
    & CodeFragment
  )> }
);

export type DeleteUdcMutationVariables = Exact<{
  id: Scalars['Int'];
  userContext?: Maybe<UserContextInput>;
}>;


export type DeleteUdcMutation = (
  { __typename?: 'Mutation' }
  & { deleteUDC?: Maybe<(
    { __typename?: 'UDCode' }
    & CodeFragment
  )> }
);

export type CreatePresetMutationVariables = Exact<{
  tableName?: Maybe<Scalars['String']>;
  preset?: Maybe<TablePresetInput>;
}>;


export type CreatePresetMutation = (
  { __typename?: 'Mutation' }
  & { createPreset?: Maybe<(
    { __typename?: 'TablePreset' }
    & Pick<TablePreset, 'id'>
  ) | (
    { __typename?: 'DatabaseError' }
    & Pick<DatabaseError, 'message'>
    & { dbErrorId: DatabaseError['id'] }
  ) | (
    { __typename?: 'ValidationError' }
    & Pick<ValidationError, 'field' | 'messages'>
    & { vError: ValidationError['id'] }
  )> }
);

export type UpdatePresetMutationVariables = Exact<{
  preset?: Maybe<TablePresetInput>;
}>;


export type UpdatePresetMutation = (
  { __typename?: 'Mutation' }
  & { updatePreset?: Maybe<(
    { __typename?: 'TablePreset' }
    & Pick<TablePreset, 'id'>
  ) | (
    { __typename?: 'DatabaseError' }
    & Pick<DatabaseError, 'message'>
    & { dbErrorId: DatabaseError['id'] }
  ) | (
    { __typename?: 'ValidationError' }
    & Pick<ValidationError, 'field' | 'messages'>
    & { vError: ValidationError['id'] }
  )> }
);

export type DeletePresetMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DeletePresetMutation = (
  { __typename?: 'Mutation' }
  & { deletePreset?: Maybe<(
    { __typename?: 'TablePreset' }
    & Pick<TablePreset, 'id'>
  ) | (
    { __typename?: 'DatabaseError' }
    & Pick<DatabaseError, 'message'>
    & { dbErrorId: DatabaseError['id'] }
  ) | (
    { __typename?: 'ValidationError' }
    & Pick<ValidationError, 'field' | 'messages'>
    & { vError: ValidationError['id'] }
  )> }
);

export type CreateBookingGoodsReceiptMutationVariables = Exact<{
  input?: Maybe<TGoodsReceiptInput>;
  userContext?: Maybe<UserContextInput>;
}>;


export type CreateBookingGoodsReceiptMutation = (
  { __typename?: 'Mutation' }
  & { goodsReceipt?: Maybe<(
    { __typename?: 'GoodsReceiptMutationType' }
    & { createGoodsReceipt?: Maybe<(
      { __typename: 'GoodsReceipt' }
      & Pick<GoodsReceipt, 'goodsReceiptNumber'>
      & { grnId: GoodsReceipt['id'] }
    ) | (
      { __typename: 'DatabaseError' }
      & Pick<DatabaseError, 'id' | 'message'>
    ) | (
      { __typename: 'ValidationError' }
      & Pick<ValidationError, 'id' | 'field' | 'messages'>
    )> }
  )> }
);

export type UpdateBookingGoodsReceiptMutationVariables = Exact<{
  id: Scalars['Int'];
  input?: Maybe<TGoodsReceiptUpdateInput>;
  userContext?: Maybe<UserContextInput>;
}>;


export type UpdateBookingGoodsReceiptMutation = (
  { __typename?: 'Mutation' }
  & { goodsReceipt?: Maybe<(
    { __typename?: 'GoodsReceiptMutationType' }
    & { updateGoodsReceipt?: Maybe<(
      { __typename: 'UpdatedLines' }
      & { headerUpdated?: Maybe<(
        { __typename?: 'GoodsReceiptHeader' }
        & Pick<GoodsReceiptHeader, 'id' | 'customerRef' | 'dateReceived' | 'goodsReceiptNumber' | 'status'>
      )> }
    ) | (
      { __typename: 'DatabaseError' }
      & Pick<DatabaseError, 'id' | 'message'>
    ) | (
      { __typename: 'ValidationError' }
      & Pick<ValidationError, 'id' | 'field' | 'messages'>
    )> }
  )> }
);

export type DeleteBookingGoodsReceiptMutationVariables = Exact<{
  id: Scalars['Int'];
  userContext?: Maybe<UserContextInput>;
}>;


export type DeleteBookingGoodsReceiptMutation = (
  { __typename?: 'Mutation' }
  & { goodsReceipt?: Maybe<(
    { __typename?: 'GoodsReceiptMutationType' }
    & { deleteGoodsReceipt?: Maybe<(
      { __typename: 'GoodsReceipt' }
      & Pick<GoodsReceipt, 'goodsReceiptNumber'>
      & { grnId: GoodsReceipt['id'] }
    ) | (
      { __typename: 'DatabaseError' }
      & Pick<DatabaseError, 'id' | 'message'>
    ) | (
      { __typename: 'ValidationError' }
      & Pick<ValidationError, 'id' | 'field' | 'messages'>
    )> }
  )> }
);

export type CreateDestinationMutationVariables = Exact<{
  input?: Maybe<DestinationInput>;
  userContext?: Maybe<UserContextInput>;
}>;


export type CreateDestinationMutation = (
  { __typename?: 'Mutation' }
  & { createDestination?: Maybe<(
    { __typename?: 'Destination' }
    & { address: (
      { __typename?: 'Address' }
      & AddressFragment
    ), budgets?: Maybe<Array<Maybe<(
      { __typename?: 'DestinationBudget' }
      & BudgetFragment
    )>>>, contact?: Maybe<(
      { __typename?: 'Contact' }
      & ContactFragment
    )>, routing?: Maybe<Array<Maybe<(
      { __typename?: 'DestinationRoute' }
      & RoutingFragment
    )>>> }
    & DestinationFragment
  )> }
);

export type UpdateDestinationMutationVariables = Exact<{
  id: Scalars['Int'];
  input?: Maybe<DestinationUpdateInput>;
  userContext?: Maybe<UserContextInput>;
}>;


export type UpdateDestinationMutation = (
  { __typename?: 'Mutation' }
  & { updateDestination?: Maybe<(
    { __typename?: 'Destination' }
    & { address: (
      { __typename?: 'Address' }
      & AddressFragment
    ), budgets?: Maybe<Array<Maybe<(
      { __typename?: 'DestinationBudget' }
      & BudgetFragment
    )>>>, contact?: Maybe<(
      { __typename?: 'Contact' }
      & ContactFragment
    )>, routing?: Maybe<Array<Maybe<(
      { __typename?: 'DestinationRoute' }
      & RoutingFragment
    )>>> }
    & DestinationFragment
  )> }
);

export type DeleteDestinationMutationVariables = Exact<{
  id: Scalars['Int'];
  userContext?: Maybe<UserContextInput>;
}>;


export type DeleteDestinationMutation = (
  { __typename?: 'Mutation' }
  & { deleteDestination?: Maybe<(
    { __typename?: 'Destination' }
    & Pick<Destination, 'id'>
  )> }
);

export type CreateDestiantnionBudgetMutationVariables = Exact<{
  destinationId: Scalars['Int'];
  input?: Maybe<DestinationBudgetInput>;
  userContext?: Maybe<UserContextInput>;
}>;


export type CreateDestiantnionBudgetMutation = (
  { __typename?: 'Mutation' }
  & { createDestinationBudget?: Maybe<(
    { __typename?: 'DestinationBudget' }
    & Pick<DestinationBudget, 'id'>
  )> }
);

export type UpdateDestiantnionBudgetMutationVariables = Exact<{
  destinationId: Scalars['Int'];
  id: Scalars['Int'];
  input?: Maybe<DestinationBudgetUpdateInput>;
  userContext?: Maybe<UserContextInput>;
}>;


export type UpdateDestiantnionBudgetMutation = (
  { __typename?: 'Mutation' }
  & { updateDestinationBudget?: Maybe<(
    { __typename?: 'DestinationBudget' }
    & Pick<DestinationBudget, 'id'>
  )> }
);

export type DeleteDestinationBudgetMutationVariables = Exact<{
  destinationId: Scalars['Int'];
  id: Scalars['Int'];
  userContext?: Maybe<UserContextInput>;
}>;


export type DeleteDestinationBudgetMutation = (
  { __typename?: 'Mutation' }
  & { deleteDestinationBudget?: Maybe<(
    { __typename?: 'DestinationBudget' }
    & Pick<DestinationBudget, 'id'>
  )> }
);

export type CreateDestinationRouteMutationVariables = Exact<{
  destinationId: Scalars['Int'];
  input?: Maybe<DestinationRouteInput>;
  userContext?: Maybe<UserContextInput>;
}>;


export type CreateDestinationRouteMutation = (
  { __typename?: 'Mutation' }
  & { createDestinationRoute?: Maybe<(
    { __typename?: 'DestinationRoute' }
    & RoutingFragment
  )> }
);

export type UpdateDestinationRouteMutationVariables = Exact<{
  id: Scalars['Int'];
  destinationId: Scalars['Int'];
  input?: Maybe<DestinationRouteUpdateInput>;
  userContext?: Maybe<UserContextInput>;
}>;


export type UpdateDestinationRouteMutation = (
  { __typename?: 'Mutation' }
  & { updateDestinationRoute?: Maybe<(
    { __typename?: 'DestinationRoute' }
    & RoutingFragment
  )> }
);

export type DeleteDestinationRouteMutationVariables = Exact<{
  id: Scalars['Int'];
  destinationId: Scalars['Int'];
  userContext?: Maybe<UserContextInput>;
}>;


export type DeleteDestinationRouteMutation = (
  { __typename?: 'Mutation' }
  & { deleteDestinationRoute?: Maybe<(
    { __typename?: 'DestinationRoute' }
    & Pick<DestinationRoute, 'id'>
  )> }
);

export type RemoveReceiptLineMutationVariables = Exact<{
  goodsReceiptId: Scalars['Int'];
  ids?: Maybe<Array<Scalars['Int']> | Scalars['Int']>;
  userContext?: Maybe<UserContextInput>;
}>;


export type RemoveReceiptLineMutation = (
  { __typename?: 'Mutation' }
  & { goodsReceipt?: Maybe<(
    { __typename?: 'GoodsReceiptMutationType' }
    & { removeReceiptLine?: Maybe<(
      { __typename: 'UpdatedLines' }
      & { bookLinesAdded?: Maybe<Array<Maybe<(
        { __typename?: 'GoodsBookLine' }
        & BookedFragment
      )>>>, bookLinesDeleted?: Maybe<Array<Maybe<(
        { __typename?: 'GoodsBookLine' }
        & BookedFragment
      )>>>, headerUpdated?: Maybe<(
        { __typename?: 'GoodsReceiptHeader' }
        & Pick<GoodsReceiptHeader, 'id' | 'goodsReceiptNumber'>
      )>, receiptLinesAdded?: Maybe<Array<Maybe<(
        { __typename?: 'GoodsReceiptLine' }
        & ReceivedFragment
      )>>>, receiptLinesDeleted?: Maybe<Array<Maybe<(
        { __typename?: 'GoodsReceiptLine' }
        & ReceivedFragment
      )>>> }
    ) | (
      { __typename: 'DatabaseError' }
      & Pick<DatabaseError, 'id' | 'message'>
    ) | (
      { __typename: 'ValidationError' }
      & Pick<ValidationError, 'id' | 'field' | 'messages'>
    )> }
  )> }
);

export type AddReceiptLineMutationVariables = Exact<{
  goodsReceiptId: Scalars['Int'];
  input?: Maybe<Array<Maybe<GoodsReceiptLineInput>> | Maybe<GoodsReceiptLineInput>>;
  userContext?: Maybe<UserContextInput>;
}>;


export type AddReceiptLineMutation = (
  { __typename?: 'Mutation' }
  & { goodsReceipt?: Maybe<(
    { __typename?: 'GoodsReceiptMutationType' }
    & { addReceiptLine?: Maybe<(
      { __typename: 'UpdatedLines' }
      & { bookLinesAdded?: Maybe<Array<Maybe<(
        { __typename?: 'GoodsBookLine' }
        & BookedFragment
      )>>>, bookLinesDeleted?: Maybe<Array<Maybe<(
        { __typename?: 'GoodsBookLine' }
        & BookedFragment
      )>>>, headerUpdated?: Maybe<(
        { __typename?: 'GoodsReceiptHeader' }
        & Pick<GoodsReceiptHeader, 'id' | 'goodsReceiptNumber'>
      )>, receiptLinesAdded?: Maybe<Array<Maybe<(
        { __typename?: 'GoodsReceiptLine' }
        & ReceivedFragment
      )>>>, receiptLinesDeleted?: Maybe<Array<Maybe<(
        { __typename?: 'GoodsReceiptLine' }
        & ReceivedFragment
      )>>> }
    ) | (
      { __typename: 'DatabaseError' }
      & Pick<DatabaseError, 'id' | 'message'>
    ) | (
      { __typename: 'ValidationError' }
      & Pick<ValidationError, 'id' | 'field' | 'messages'>
    )> }
  )> }
);

export type UpdateGoodsReceiptMutationVariables = Exact<{
  id: Scalars['Int'];
  input?: Maybe<TGoodsReceiptUpdateInput>;
  userContext?: Maybe<UserContextInput>;
}>;


export type UpdateGoodsReceiptMutation = (
  { __typename?: 'Mutation' }
  & { goodsReceipt?: Maybe<(
    { __typename?: 'GoodsReceiptMutationType' }
    & { updateGoodsReceipt?: Maybe<(
      { __typename: 'UpdatedLines' }
      & { headerUpdated?: Maybe<(
        { __typename?: 'GoodsReceiptHeader' }
        & Pick<GoodsReceiptHeader, 'id' | 'customerRef' | 'dateReceived' | 'goodsReceiptNumber' | 'status'>
      )> }
    ) | (
      { __typename: 'DatabaseError' }
      & Pick<DatabaseError, 'id' | 'message'>
    ) | (
      { __typename: 'ValidationError' }
      & Pick<ValidationError, 'id' | 'field' | 'messages'>
    )> }
  )> }
);

export type DeleteGoodsReceiptMutationVariables = Exact<{
  id: Scalars['Int'];
  userContext?: Maybe<UserContextInput>;
}>;


export type DeleteGoodsReceiptMutation = (
  { __typename?: 'Mutation' }
  & { goodsReceipt?: Maybe<(
    { __typename?: 'GoodsReceiptMutationType' }
    & { deleteGoodsReceipt?: Maybe<(
      { __typename?: 'GoodsReceipt' }
      & Pick<GoodsReceipt, 'goodsReceiptNumber'>
    ) | (
      { __typename?: 'DatabaseError' }
      & Pick<DatabaseError, 'id' | 'message'>
    ) | (
      { __typename?: 'ValidationError' }
      & Pick<ValidationError, 'id' | 'field' | 'messages'>
    )> }
  )> }
);

export type CreateAdhocGoodsReceiptMutationVariables = Exact<{
  input?: Maybe<TGoodsReceiptInput>;
  userContext?: Maybe<UserContextInput>;
}>;


export type CreateAdhocGoodsReceiptMutation = (
  { __typename?: 'Mutation' }
  & { goodsReceipt?: Maybe<(
    { __typename?: 'GoodsReceiptMutationType' }
    & { createGoodsReceipt?: Maybe<(
      { __typename: 'GoodsReceipt' }
      & Pick<GoodsReceipt, 'goodsReceiptNumber'>
      & { grnId: GoodsReceipt['id'] }
    ) | (
      { __typename: 'DatabaseError' }
      & Pick<DatabaseError, 'id' | 'message'>
    ) | (
      { __typename: 'ValidationError' }
      & Pick<ValidationError, 'id' | 'field' | 'messages'>
    )> }
  )> }
);

export type CreateHandlingTypeMutationVariables = Exact<{
  input?: Maybe<HandlingTypeInput>;
  userContext?: Maybe<UserContextInput>;
}>;


export type CreateHandlingTypeMutation = (
  { __typename?: 'Mutation' }
  & { createHandlingType?: Maybe<(
    { __typename?: 'HandlingType' }
    & { storageTypes?: Maybe<Array<Maybe<(
      { __typename?: 'HandlingStorageType' }
      & { storageType?: Maybe<(
        { __typename?: 'StorageType' }
        & StorageTypeFragment
      )> }
    )>>> }
    & HandlingTypeFragment
  )> }
);

export type DeleteHandlingTypeMutationVariables = Exact<{
  id: Scalars['Int'];
  userContext?: Maybe<UserContextInput>;
}>;


export type DeleteHandlingTypeMutation = (
  { __typename?: 'Mutation' }
  & { deleteHandlingType?: Maybe<(
    { __typename?: 'HandlingType' }
    & HandlingTypeFragment
  )> }
);

export type UpdateHandlingTypeMutationVariables = Exact<{
  id: Scalars['Int'];
  input?: Maybe<HandlingTypeUpdateInput>;
  userContext?: Maybe<UserContextInput>;
}>;


export type UpdateHandlingTypeMutation = (
  { __typename?: 'Mutation' }
  & { updateHandlingType?: Maybe<(
    { __typename?: 'HandlingType' }
    & { storageTypes?: Maybe<Array<Maybe<(
      { __typename?: 'HandlingStorageType' }
      & { storageType?: Maybe<(
        { __typename?: 'StorageType' }
        & StorageTypeFragment
      )> }
    )>>> }
    & HandlingTypeFragment
  )> }
);

export type AddHandlingStorageTypeMutationVariables = Exact<{
  id: Scalars['Int'];
  storageTypeId: Scalars['Int'];
  userContext?: Maybe<UserContextInput>;
}>;


export type AddHandlingStorageTypeMutation = (
  { __typename?: 'Mutation' }
  & { addHandlingStorageType?: Maybe<(
    { __typename?: 'HandlingStorageType' }
    & Pick<HandlingStorageType, 'handlingTypeId' | 'storageTypeId'>
  )> }
);

export type RemoveHandlingStorageTypeMutationVariables = Exact<{
  id: Scalars['Int'];
  storageTypeId: Scalars['Int'];
  userContext?: Maybe<UserContextInput>;
}>;


export type RemoveHandlingStorageTypeMutation = (
  { __typename?: 'Mutation' }
  & { removeHandlingStorageType?: Maybe<(
    { __typename?: 'HandlingStorageType' }
    & Pick<HandlingStorageType, 'handlingTypeId' | 'storageTypeId'>
  )> }
);

export type AddStockOwnerLinkMutationVariables = Exact<{
  linkedStockOwnerId: Scalars['Int'];
  stockOwnerId: Scalars['Int'];
}>;


export type AddStockOwnerLinkMutation = (
  { __typename?: 'Mutation' }
  & { addStockOwnerLink?: Maybe<(
    { __typename?: 'StockOwnerLink' }
    & { child?: Maybe<(
      { __typename?: 'StockOwner' }
      & Pick<StockOwner, 'code'>
    )> }
  )> }
);

export type RemoveStockOwnerLinkMutationVariables = Exact<{
  linkedStockOwnerId: Scalars['Int'];
  stockOwnerId: Scalars['Int'];
}>;


export type RemoveStockOwnerLinkMutation = (
  { __typename?: 'Mutation' }
  & { removeStockOwnerLink?: Maybe<(
    { __typename?: 'StockOwnerLink' }
    & { child?: Maybe<(
      { __typename?: 'StockOwner' }
      & Pick<StockOwner, 'code'>
    )> }
  )> }
);

export type CreateLocationMutationVariables = Exact<{
  input?: Maybe<LocationInput>;
  userContext?: Maybe<UserContextInput>;
}>;


export type CreateLocationMutation = (
  { __typename?: 'Mutation' }
  & { createLocation?: Maybe<(
    { __typename?: 'Location' }
    & Pick<Location, 'id'>
  ) | (
    { __typename?: 'DatabaseError' }
    & Pick<DatabaseError, 'message'>
    & { DatabaseErrorId: DatabaseError['id'] }
  ) | (
    { __typename?: 'ValidationError' }
    & Pick<ValidationError, 'any' | 'messages'>
    & { ValidationErrorId: ValidationError['id'] }
    & { errors?: Maybe<Array<Maybe<(
      { __typename?: 'FieldError' }
      & Pick<FieldError, 'fieldName' | 'message' | 'severity'>
    )>>> }
  )> }
);

export type UpdateLocationMutationVariables = Exact<{
  id: Scalars['Int'];
  input?: Maybe<LocationUpdateInput>;
  userContext?: Maybe<UserContextInput>;
}>;


export type UpdateLocationMutation = (
  { __typename?: 'Mutation' }
  & { updateLocation?: Maybe<(
    { __typename?: 'Location' }
    & Pick<Location, 'id'>
  ) | (
    { __typename?: 'DatabaseError' }
    & Pick<DatabaseError, 'message'>
    & { DatabaseErrorId: DatabaseError['id'] }
  ) | (
    { __typename?: 'ValidationError' }
    & Pick<ValidationError, 'any' | 'messages'>
    & { ValidationErrorId: ValidationError['id'] }
    & { errors?: Maybe<Array<Maybe<(
      { __typename?: 'FieldError' }
      & Pick<FieldError, 'fieldName' | 'message' | 'severity'>
    )>>> }
  )> }
);

export type DeleteLocationMutationVariables = Exact<{
  id: Scalars['Int'];
  userContext?: Maybe<UserContextInput>;
}>;


export type DeleteLocationMutation = (
  { __typename?: 'Mutation' }
  & { deleteLocation?: Maybe<(
    { __typename?: 'Location' }
    & Pick<Location, 'id'>
  ) | (
    { __typename?: 'DatabaseError' }
    & Pick<DatabaseError, 'message'>
    & { DatabaseErrorId: DatabaseError['id'] }
  ) | (
    { __typename?: 'ValidationError' }
    & Pick<ValidationError, 'any' | 'messages'>
    & { ValidationErrorId: ValidationError['id'] }
    & { errors?: Maybe<Array<Maybe<(
      { __typename?: 'FieldError' }
      & Pick<FieldError, 'fieldName' | 'message' | 'severity'>
    )>>> }
  )> }
);

export type UpdateLocationPatchMutationVariables = Exact<{
  id: Scalars['Int'];
  userContext?: Maybe<UserContextInput>;
  input?: Maybe<Array<Maybe<OperationOfLocationInput>> | Maybe<OperationOfLocationInput>>;
}>;


export type UpdateLocationPatchMutation = (
  { __typename?: 'Mutation' }
  & { updateLocationEx?: Maybe<(
    { __typename?: 'Location' }
    & Pick<Location, 'id'>
  ) | (
    { __typename?: 'DatabaseError' }
    & Pick<DatabaseError, 'message'>
    & { DatabaseErrorId: DatabaseError['id'] }
  ) | (
    { __typename?: 'ValidationError' }
    & Pick<ValidationError, 'any' | 'messages'>
    & { ValidationErrorId: ValidationError['id'] }
    & { errors?: Maybe<Array<Maybe<(
      { __typename?: 'FieldError' }
      & Pick<FieldError, 'fieldName' | 'message' | 'severity'>
    )>>> }
  )> }
);

export type CreateMheMutationVariables = Exact<{
  input?: Maybe<MaterialHandlingEquipmentInput>;
  userContext?: Maybe<UserContextInput>;
}>;


export type CreateMheMutation = (
  { __typename?: 'Mutation' }
  & { createMaterialHandlingEquipment?: Maybe<(
    { __typename?: 'MaterialHandlingEquipment' }
    & MheFragment
  )> }
);

export type UpdateMheMutationVariables = Exact<{
  id: Scalars['Int'];
  input?: Maybe<MaterialHandlingEquipmentUpdateInput>;
  userContext?: Maybe<UserContextInput>;
}>;


export type UpdateMheMutation = (
  { __typename?: 'Mutation' }
  & { updateMaterialHandlingEquipment?: Maybe<(
    { __typename?: 'MaterialHandlingEquipment' }
    & MheFragment
  )> }
);

export type DeleteMheMutationVariables = Exact<{
  id: Scalars['Int'];
  userContext?: Maybe<UserContextInput>;
}>;


export type DeleteMheMutation = (
  { __typename?: 'Mutation' }
  & { deleteMaterialHandlingEquipment?: Maybe<(
    { __typename?: 'MaterialHandlingEquipment' }
    & Pick<MaterialHandlingEquipment, 'id'>
  )> }
);

export type CreateOrderEntryMutationVariables = Exact<{
  input: CreateOrderEntryInput;
}>;


export type CreateOrderEntryMutation = (
  { __typename?: 'Mutation' }
  & { createOrderEntry?: Maybe<(
    { __typename?: 'OrderEntry' }
    & { destinationCode: (
      { __typename?: 'DestinationCode' }
      & DestinationCodeFragment
    ), budgetHolder: (
      { __typename?: 'BudgetHolder' }
      & BudgetHolderFragment
    ), orderType: (
      { __typename?: 'OrderType' }
      & OrderTypeFragment
    ) }
    & OrderEntryFragment
  )> }
);

export type DeleteOrderEntryMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteOrderEntryMutation = (
  { __typename?: 'Mutation' }
  & { deleteOrderEntry?: Maybe<(
    { __typename?: 'OrderEntry' }
    & OrderEntryFragment
  )> }
);

export type UpdateOrderEntryMutationVariables = Exact<{
  id: Scalars['ID'];
  input: UpdateOrderEntryInput;
}>;


export type UpdateOrderEntryMutation = (
  { __typename?: 'Mutation' }
  & { updateOrderEntry?: Maybe<(
    { __typename?: 'OrderEntry' }
    & { destinationCode: (
      { __typename?: 'DestinationCode' }
      & DestinationCodeFragment
    ), budgetHolder: (
      { __typename?: 'BudgetHolder' }
      & BudgetHolderFragment
    ), orderType: (
      { __typename?: 'OrderType' }
      & OrderTypeFragment
    ) }
    & OrderEntryFragment
  )> }
);

export type CreateProductMutationVariables = Exact<{
  input?: Maybe<ProductInput>;
  userContext?: Maybe<UserContextInput>;
}>;


export type CreateProductMutation = (
  { __typename?: 'Mutation' }
  & { createProduct?: Maybe<(
    { __typename?: 'Product' }
    & ProductFragment
  )> }
);

export type UpdateProductMutationVariables = Exact<{
  id: Scalars['Int'];
  input?: Maybe<ProductUpdateInput>;
  userContext?: Maybe<UserContextInput>;
}>;


export type UpdateProductMutation = (
  { __typename?: 'Mutation' }
  & { updateProduct?: Maybe<(
    { __typename?: 'Product' }
    & ProductFragment
  )> }
);

export type DeleteProductMutationVariables = Exact<{
  id: Scalars['Int'];
  userContext?: Maybe<UserContextInput>;
}>;


export type DeleteProductMutation = (
  { __typename?: 'Mutation' }
  & { deleteProduct?: Maybe<(
    { __typename?: 'Product' }
    & ProductFragment
  )> }
);

export type CreateProductBomMutationVariables = Exact<{
  component?: Maybe<BomDefinitionInput>;
  productId: Scalars['Int'];
  userContext?: Maybe<UserContextInput>;
}>;


export type CreateProductBomMutation = (
  { __typename?: 'Mutation' }
  & { createBOMDefinition?: Maybe<(
    { __typename?: 'BOMDefinition' }
    & Pick<BomDefinition, 'id' | 'childId' | 'qty'>
  )> }
);

export type UpdateProductBomMutationVariables = Exact<{
  componentId: Scalars['Int'];
  productId: Scalars['Int'];
  update?: Maybe<BomDefinitionUpdateInput>;
  userContext?: Maybe<UserContextInput>;
}>;


export type UpdateProductBomMutation = (
  { __typename?: 'Mutation' }
  & { updateBOMDefinition?: Maybe<(
    { __typename?: 'BOMDefinition' }
    & Pick<BomDefinition, 'id' | 'childId' | 'qty'>
  )> }
);

export type DeleteProductBomMutationVariables = Exact<{
  componentId: Scalars['Int'];
  productId: Scalars['Int'];
  userContext?: Maybe<UserContextInput>;
}>;


export type DeleteProductBomMutation = (
  { __typename?: 'Mutation' }
  & { deleteBOMDefinition?: Maybe<(
    { __typename?: 'BOMDefinition' }
    & Pick<BomDefinition, 'id'>
  )> }
);

export type CreateProductDocumentMutationVariables = Exact<{
  productId: Scalars['Int'];
  productDocument?: Maybe<ProductDocumentInput>;
  userContext?: Maybe<UserContextInput>;
}>;


export type CreateProductDocumentMutation = (
  { __typename?: 'Mutation' }
  & { createProductDocument?: Maybe<(
    { __typename?: 'ProductDocument' }
    & DocumentFragment
  )> }
);

export type UpdateProductDocumentMutationVariables = Exact<{
  id: Scalars['Int'];
  productId: Scalars['Int'];
  update?: Maybe<ProductDocumentUpdateInput>;
  userContext?: Maybe<UserContextInput>;
}>;


export type UpdateProductDocumentMutation = (
  { __typename?: 'Mutation' }
  & { updateProductDocument?: Maybe<(
    { __typename?: 'ProductDocument' }
    & DocumentFragment
  )> }
);

export type DeleteProductDocumentMutationVariables = Exact<{
  id: Scalars['Int'];
  productId: Scalars['Int'];
  userContext?: Maybe<UserContextInput>;
}>;


export type DeleteProductDocumentMutation = (
  { __typename?: 'Mutation' }
  & { deleteProductDocument?: Maybe<(
    { __typename?: 'ProductDocument' }
    & Pick<ProductDocument, 'id'>
  )> }
);

export type CreateProductLicencePlateMutationVariables = Exact<{
  licencePlate?: Maybe<LpDefinitionInput>;
  productId: Scalars['Int'];
  userContext?: Maybe<UserContextInput>;
}>;


export type CreateProductLicencePlateMutation = (
  { __typename?: 'Mutation' }
  & { createProductLicencePlate?: Maybe<(
    { __typename?: 'LPDefinition' }
    & LicencePlateFragment
  )> }
);

export type UpdateProductLicencePlateMutationVariables = Exact<{
  id: Scalars['Int'];
  productId: Scalars['Int'];
  update?: Maybe<LpDefinitionUpdateInput>;
  userContext?: Maybe<UserContextInput>;
}>;


export type UpdateProductLicencePlateMutation = (
  { __typename?: 'Mutation' }
  & { updateProductLicencePlate?: Maybe<(
    { __typename?: 'LPDefinition' }
    & LicencePlateFragment
  )> }
);

export type DeleteProductLicencePlateMutationVariables = Exact<{
  id: Scalars['Int'];
  productId: Scalars['Int'];
  userContext?: Maybe<UserContextInput>;
}>;


export type DeleteProductLicencePlateMutation = (
  { __typename?: 'Mutation' }
  & { deleteProductLicencePlate?: Maybe<(
    { __typename?: 'LPDefinition' }
    & Pick<LpDefinition, 'id'>
  )> }
);

export type CreateProductPickfaceMutationVariables = Exact<{
  input?: Maybe<ProductPickfaceInput>;
  productId: Scalars['Int'];
  userContext?: Maybe<UserContextInput>;
}>;


export type CreateProductPickfaceMutation = (
  { __typename?: 'Mutation' }
  & { createProductPickface?: Maybe<(
    { __typename?: 'ProductPickface' }
    & PickfaceFragment
  )> }
);

export type UpdateProductPickfaceMutationVariables = Exact<{
  update?: Maybe<ProductPickfaceUpdateInput>;
  id: Scalars['Int'];
  productId: Scalars['Int'];
  userContext?: Maybe<UserContextInput>;
}>;


export type UpdateProductPickfaceMutation = (
  { __typename?: 'Mutation' }
  & { updateProductPickface?: Maybe<(
    { __typename?: 'ProductPickface' }
    & PickfaceFragment
  )> }
);

export type DeleteProductPickfaceMutationVariables = Exact<{
  id: Scalars['Int'];
  productId: Scalars['Int'];
  userContext?: Maybe<UserContextInput>;
}>;


export type DeleteProductPickfaceMutation = (
  { __typename?: 'Mutation' }
  & { deleteProductPickface?: Maybe<(
    { __typename?: 'ProductPickface' }
    & Pick<ProductPickface, 'id'>
  )> }
);

export type UpdateProductSupplierMutationVariables = Exact<{
  id: Scalars['Int'];
  productId: Scalars['Int'];
  input?: Maybe<ProductSupplierUpdateInput>;
  userContext?: Maybe<UserContextInput>;
}>;


export type UpdateProductSupplierMutation = (
  { __typename?: 'Mutation' }
  & { updateProductSupplier?: Maybe<(
    { __typename?: 'ProductSupplier' }
    & ProductSupplierFragment
  )> }
);

export type CreateProductSupplierMutationVariables = Exact<{
  productId: Scalars['Int'];
  input?: Maybe<ProductSupplierInput>;
  userContext?: Maybe<UserContextInput>;
}>;


export type CreateProductSupplierMutation = (
  { __typename?: 'Mutation' }
  & { createProductSupplier?: Maybe<(
    { __typename?: 'ProductSupplier' }
    & ProductSupplierFragment
  )> }
);

export type DeleteProductSupplierMutationVariables = Exact<{
  id: Scalars['Int'];
  productId: Scalars['Int'];
  userContext?: Maybe<UserContextInput>;
}>;


export type DeleteProductSupplierMutation = (
  { __typename?: 'Mutation' }
  & { deleteProductSupplier?: Maybe<(
    { __typename?: 'ProductSupplier' }
    & Pick<ProductSupplier, 'id'>
  )> }
);

export type CreatePurchaseOrderMutationVariables = Exact<{
  input?: Maybe<TPurchaseOrderInput>;
  userContext?: Maybe<UserContextInput>;
}>;


export type CreatePurchaseOrderMutation = (
  { __typename?: 'Mutation' }
  & { purchaseOrder?: Maybe<(
    { __typename?: 'PurchaseOrderMutationType' }
    & { createPurchaseOrder?: Maybe<(
      { __typename?: 'PurchaseOrder' }
      & PurchaseOrderFragment
    ) | (
      { __typename?: 'DatabaseError' }
      & Pick<DatabaseError, 'message'>
      & { DBErrorId: DatabaseError['id'] }
    ) | (
      { __typename?: 'ValidationError' }
      & Pick<ValidationError, 'field' | 'messages'>
      & { ValidationErrorId: ValidationError['id'] }
    )> }
  )> }
);

export type UpdatePurchaseOrderMutationVariables = Exact<{
  id: Scalars['Int'];
  input?: Maybe<PurchaseOrderUpdateInput>;
  items?: Maybe<UpdateCollectionOfPurchaseOrderItemInput>;
  instructions?: Maybe<UpdateCollectionOfPoInstructionInput>;
  userContext?: Maybe<UserContextInput>;
}>;


export type UpdatePurchaseOrderMutation = (
  { __typename?: 'Mutation' }
  & { purchaseOrder?: Maybe<(
    { __typename?: 'PurchaseOrderMutationType' }
    & { updatePurchaseOrder?: Maybe<(
      { __typename?: 'UpdatePOResponse' }
      & { headerUpdated?: Maybe<(
        { __typename?: 'PurchaseOrderHeader' }
        & Pick<PurchaseOrderHeader, 'referenceNumber'>
      )>, pOInstructionsDeleted?: Maybe<Array<Maybe<(
        { __typename?: 'POInstruction' }
        & Pick<PoInstruction, 'id' | 'message' | 'type'>
      )>>>, pOInstructionsModified?: Maybe<Array<Maybe<(
        { __typename?: 'POInstruction' }
        & Pick<PoInstruction, 'id' | 'message' | 'type'>
      )>>>, purchaseOrderItemsDeleted?: Maybe<Array<Maybe<(
        { __typename?: 'PurchaseOrderItem' }
        & Pick<PurchaseOrderItem, 'id'>
      )>>>, purchaseOrderItemsModified?: Maybe<Array<Maybe<(
        { __typename?: 'PurchaseOrderItem' }
        & Pick<PurchaseOrderItem, 'id'>
      )>>> }
    ) | (
      { __typename?: 'DatabaseError' }
      & Pick<DatabaseError, 'id' | 'message'>
    ) | (
      { __typename?: 'ValidationError' }
      & Pick<ValidationError, 'field' | 'messages'>
    )> }
  )> }
);

export type DeletePurchaseOrderMutationVariables = Exact<{
  id: Scalars['Int'];
  userContext?: Maybe<UserContextInput>;
}>;


export type DeletePurchaseOrderMutation = (
  { __typename?: 'Mutation' }
  & { purchaseOrder?: Maybe<(
    { __typename?: 'PurchaseOrderMutationType' }
    & { deletePurchaseOrder?: Maybe<(
      { __typename?: 'PurchaseOrder' }
      & Pick<PurchaseOrder, 'id'>
    ) | { __typename?: 'DatabaseError' } | { __typename?: 'ValidationError' }> }
  )> }
);

export type CreateStockOwnerMutationVariables = Exact<{
  input?: Maybe<StockOwnerInput>;
}>;


export type CreateStockOwnerMutation = (
  { __typename?: 'Mutation' }
  & { createStockOwner?: Maybe<(
    { __typename?: 'StockOwner' }
    & StockOwnerFragment
  )> }
);

export type UpdateStockOwnerMutationVariables = Exact<{
  id: Scalars['Int'];
  input?: Maybe<StockOwnerUpdateInput>;
  userContext?: Maybe<UserContextInput>;
}>;


export type UpdateStockOwnerMutation = (
  { __typename?: 'Mutation' }
  & { updateStockOwner?: Maybe<(
    { __typename?: 'StockOwner' }
    & StockOwnerFragment
  )> }
);

export type DeleteStockOwnerMutationVariables = Exact<{
  id: Scalars['Int'];
  userContext?: Maybe<UserContextInput>;
}>;


export type DeleteStockOwnerMutation = (
  { __typename?: 'Mutation' }
  & { deleteStockOwner?: Maybe<(
    { __typename?: 'StockOwner' }
    & StockOwnerFragment
  )> }
);

export type UpdateStockOwnerCategoryMutationVariables = Exact<{
  id: Scalars['Int'];
  stockOwnerId: Scalars['Int'];
  input?: Maybe<CategoryDefinitionUpdateInput>;
}>;


export type UpdateStockOwnerCategoryMutation = (
  { __typename?: 'Mutation' }
  & { updateStockOwnerCategoryDefinition?: Maybe<(
    { __typename?: 'CategoryDefinition' }
    & CategoryDefinitionFragment
  )> }
);

export type CreateStockOwnerCategoyMutationVariables = Exact<{
  stockOwnerId: Scalars['Int'];
  input?: Maybe<CategoryDefinitionInput>;
}>;


export type CreateStockOwnerCategoyMutation = (
  { __typename?: 'Mutation' }
  & { createStockOwnerCategoryDefinition?: Maybe<(
    { __typename?: 'CategoryDefinition' }
    & CategoryDefinitionFragment
  )> }
);

export type DeleteStockOwnerCategoryMutationVariables = Exact<{
  stockOwnerId: Scalars['Int'];
  id: Scalars['Int'];
}>;


export type DeleteStockOwnerCategoryMutation = (
  { __typename?: 'Mutation' }
  & { deleteStockOwnerCategoryDefinition?: Maybe<(
    { __typename?: 'CategoryDefinition' }
    & Pick<CategoryDefinition, 'id'>
  )> }
);

export type UpdateStockOwnerPickConfirmMethodMutationVariables = Exact<{
  id: Scalars['Int'];
  stockOwnerId: Scalars['Int'];
  input?: Maybe<PickConfirmMethodUpdateInput>;
}>;


export type UpdateStockOwnerPickConfirmMethodMutation = (
  { __typename?: 'Mutation' }
  & { updateStockOwnerPickConfirmMethod?: Maybe<(
    { __typename?: 'PickConfirmMethod' }
    & PickConfirmMethodFragment
  )> }
);

export type CreateStockOwnerPickConfirmMethodMutationVariables = Exact<{
  stockOwnerId: Scalars['Int'];
  input?: Maybe<PickConfirmMethodInput>;
}>;


export type CreateStockOwnerPickConfirmMethodMutation = (
  { __typename?: 'Mutation' }
  & { createStockOwnerPickConfirmMethod?: Maybe<(
    { __typename?: 'PickConfirmMethod' }
    & PickConfirmMethodFragment
  )> }
);

export type DeleteStockOwnerPickConfirmMethodMutationVariables = Exact<{
  stockOwnerId: Scalars['Int'];
  id: Scalars['Int'];
}>;


export type DeleteStockOwnerPickConfirmMethodMutation = (
  { __typename?: 'Mutation' }
  & { deleteStockOwnerPickConfirmMethod?: Maybe<(
    { __typename?: 'PickConfirmMethod' }
    & Pick<PickConfirmMethod, 'id'>
  )> }
);

export type UpdateOrderStatusMutationVariables = Exact<{
  id: Scalars['Int'];
  stockOwnerId: Scalars['Int'];
  input?: Maybe<OrderStatusUpdateInput>;
}>;


export type UpdateOrderStatusMutation = (
  { __typename?: 'Mutation' }
  & { updateOrderStatus?: Maybe<(
    { __typename?: 'OrderStatus' }
    & OrderStatusFragment
  )> }
);

export type CreateOrderStatusMutationVariables = Exact<{
  stockOwnerId: Scalars['Int'];
  input?: Maybe<OrderStatusInput>;
}>;


export type CreateOrderStatusMutation = (
  { __typename?: 'Mutation' }
  & { createOrderStatus?: Maybe<(
    { __typename?: 'OrderStatus' }
    & OrderStatusFragment
  )> }
);

export type DeleteOrderStatusMutationVariables = Exact<{
  stockOwnerId: Scalars['Int'];
  id: Scalars['Int'];
}>;


export type DeleteOrderStatusMutation = (
  { __typename?: 'Mutation' }
  & { deleteOrderStatus?: Maybe<(
    { __typename?: 'OrderStatus' }
    & OrderStatusFragment
  )> }
);

export type UpdateStockOwnerPickMethodMutationVariables = Exact<{
  id: Scalars['Int'];
  stockOwnerId: Scalars['Int'];
  input?: Maybe<PickMethodUpdateInput>;
}>;


export type UpdateStockOwnerPickMethodMutation = (
  { __typename?: 'Mutation' }
  & { updateStockOwnerPickMethod?: Maybe<(
    { __typename?: 'PickMethod' }
    & PickMethodFragment
  )> }
);

export type CreateStockOwnerPickMethodMutationVariables = Exact<{
  stockOwnerId: Scalars['Int'];
  input?: Maybe<PickMethodInput>;
}>;


export type CreateStockOwnerPickMethodMutation = (
  { __typename?: 'Mutation' }
  & { createStockOwnerPickMethod?: Maybe<(
    { __typename?: 'PickMethod' }
    & PickMethodFragment
  )> }
);

export type DeleteStockOwnerPickMethodMutationVariables = Exact<{
  stockOwnerId: Scalars['Int'];
  id: Scalars['Int'];
}>;


export type DeleteStockOwnerPickMethodMutation = (
  { __typename?: 'Mutation' }
  & { deleteStockOwnerPickMethod?: Maybe<(
    { __typename?: 'PickMethod' }
    & Pick<PickMethod, 'id'>
  )> }
);

export type UpdateProductStatusMutationVariables = Exact<{
  id: Scalars['Int'];
  stockOwnerId: Scalars['Int'];
  input?: Maybe<ProductStatusUpdateInput>;
}>;


export type UpdateProductStatusMutation = (
  { __typename?: 'Mutation' }
  & { updateProductStatus?: Maybe<(
    { __typename?: 'ProductStatus' }
    & ProductStatusesFragment
  )> }
);

export type CreateProductStatusMutationVariables = Exact<{
  stockOwnerId: Scalars['Int'];
  input?: Maybe<ProductStatusInput>;
}>;


export type CreateProductStatusMutation = (
  { __typename?: 'Mutation' }
  & { createProductStatus?: Maybe<(
    { __typename?: 'ProductStatus' }
    & ProductStatusesFragment
  )> }
);

export type DeleteProductStatusMutationVariables = Exact<{
  stockOwnerId: Scalars['Int'];
  id: Scalars['Int'];
}>;


export type DeleteProductStatusMutation = (
  { __typename?: 'Mutation' }
  & { deleteProductStatus?: Maybe<(
    { __typename?: 'ProductStatus' }
    & ProductStatusesFragment
  )> }
);

export type CreateStorageTypeMutationVariables = Exact<{
  input?: Maybe<StorageTypeInput>;
  userContext?: Maybe<UserContextInput>;
}>;


export type CreateStorageTypeMutation = (
  { __typename?: 'Mutation' }
  & { createStorageType?: Maybe<(
    { __typename?: 'StorageType' }
    & StorageTypeFragment
  )> }
);

export type UpdateStorageTypeMutationVariables = Exact<{
  id: Scalars['Int'];
  input?: Maybe<StorageTypeUpdateInput>;
  userContext?: Maybe<UserContextInput>;
}>;


export type UpdateStorageTypeMutation = (
  { __typename?: 'Mutation' }
  & { updateStorageType?: Maybe<(
    { __typename?: 'StorageType' }
    & StorageTypeFragment
  )> }
);

export type DeleteStorageTypeMutationVariables = Exact<{
  id: Scalars['Int'];
  userContext?: Maybe<UserContextInput>;
}>;


export type DeleteStorageTypeMutation = (
  { __typename?: 'Mutation' }
  & { deleteStorageType?: Maybe<(
    { __typename?: 'StorageType' }
    & StorageTypeFragment
  )> }
);

export type AddStorageTypeMheMutationVariables = Exact<{
  id: Scalars['Int'];
  MHEId: Scalars['Int'];
}>;


export type AddStorageTypeMheMutation = (
  { __typename?: 'Mutation' }
  & { addStorageTypeMHE?: Maybe<(
    { __typename?: 'StorageTypeMHE' }
    & { storageType?: Maybe<(
      { __typename?: 'StorageType' }
      & StorageTypeFragment
    )> }
  )> }
);

export type RemoveStorageTypeMheMutationVariables = Exact<{
  id: Scalars['Int'];
  MHEId: Scalars['Int'];
}>;


export type RemoveStorageTypeMheMutation = (
  { __typename?: 'Mutation' }
  & { removeStorageTypeMHE?: Maybe<(
    { __typename?: 'StorageTypeMHE' }
    & { storageType?: Maybe<(
      { __typename?: 'StorageType' }
      & StorageTypeFragment
    )> }
  )> }
);

export type CreateSupplierMutationVariables = Exact<{
  input?: Maybe<SupplierInput>;
}>;


export type CreateSupplierMutation = (
  { __typename?: 'Mutation' }
  & { createSupplier?: Maybe<(
    { __typename?: 'Supplier' }
    & SupplierFragment
  )> }
);

export type UpdateSupplierMutationVariables = Exact<{
  id: Scalars['Int'];
  input?: Maybe<SupplierUpdateInput>;
}>;


export type UpdateSupplierMutation = (
  { __typename?: 'Mutation' }
  & { updateSupplier?: Maybe<(
    { __typename?: 'Supplier' }
    & SupplierFragment
  )> }
);

export type DeleteSupplierMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DeleteSupplierMutation = (
  { __typename?: 'Mutation' }
  & { deleteSupplier?: Maybe<(
    { __typename?: 'Supplier' }
    & SupplierFragment
  )> }
);

export type UploadFileMutationVariables = Exact<{
  file: Scalars['Upload'];
}>;


export type UploadFileMutation = (
  { __typename?: 'Mutation' }
  & { uploadFile?: Maybe<(
    { __typename?: 'UploadFileInfo' }
    & Pick<UploadFileInfo, 'filename' | 'fileSize' | 'mimeType'>
    & { preview?: Maybe<(
      { __typename?: 'PreviewTable' }
      & Pick<PreviewTable, 'header' | 'records'>
    )> }
  )> }
);

export type AddUserMutationVariables = Exact<{
  input?: Maybe<UserInput>;
}>;


export type AddUserMutation = (
  { __typename?: 'Mutation' }
  & { addUser?: Maybe<(
    { __typename: 'WMSUser' }
    & Pick<WmsUser, 'id' | 'userName'>
  ) | { __typename: 'DatabaseError' } | { __typename: 'ValidationError' }> }
);

export type UpdateUserMutationVariables = Exact<{
  id?: Maybe<Scalars['String']>;
  input?: Maybe<UserUpdateInput>;
}>;


export type UpdateUserMutation = (
  { __typename?: 'Mutation' }
  & { updateUser?: Maybe<(
    { __typename: 'WMSUser' }
    & Pick<WmsUser, 'id' | 'userName'>
  ) | (
    { __typename: 'DatabaseError' }
    & Pick<DatabaseError, 'message'>
  ) | (
    { __typename: 'ValidationError' }
    & Pick<ValidationError, 'messages'>
  )> }
);

export type UpdateUserMenusMutationVariables = Exact<{
  id?: Maybe<Scalars['String']>;
  input?: Maybe<UserUpdateInput>;
}>;


export type UpdateUserMenusMutation = (
  { __typename?: 'Mutation' }
  & { updateUser?: Maybe<(
    { __typename: 'WMSUser' }
    & Pick<WmsUser, 'id'>
    & { userMenus?: Maybe<Array<Maybe<(
      { __typename?: 'MenuEntry' }
      & { screen?: Maybe<(
        { __typename?: 'Screen' }
        & ScreenFragment
      )>, parent?: Maybe<(
        { __typename?: 'MenuEntry' }
        & { screen?: Maybe<(
          { __typename?: 'Screen' }
          & ScreenFragment
        )> }
        & MenuEntryFragment
      )>, children?: Maybe<Array<Maybe<(
        { __typename?: 'MenuEntry' }
        & { screen?: Maybe<(
          { __typename?: 'Screen' }
          & ScreenFragment
        )>, children?: Maybe<Array<Maybe<(
          { __typename?: 'MenuEntry' }
          & { screen?: Maybe<(
            { __typename?: 'Screen' }
            & ScreenFragment
          )>, children?: Maybe<Array<Maybe<(
            { __typename?: 'MenuEntry' }
            & { screen?: Maybe<(
              { __typename?: 'Screen' }
              & ScreenFragment
            )>, children?: Maybe<Array<Maybe<(
              { __typename?: 'MenuEntry' }
              & { screen?: Maybe<(
                { __typename?: 'Screen' }
                & ScreenFragment
              )> }
              & MenuEntryFragment
            )>>> }
            & MenuEntryFragment
          )>>> }
          & MenuEntryFragment
        )>>> }
        & MenuEntryFragment
      )>>> }
      & MenuEntryFragment
    )>>> }
  ) | (
    { __typename: 'DatabaseError' }
    & Pick<DatabaseError, 'message'>
  ) | (
    { __typename: 'ValidationError' }
    & Pick<ValidationError, 'messages'>
  )> }
);

export type DeleteUserMutationVariables = Exact<{
  id?: Maybe<Scalars['String']>;
}>;


export type DeleteUserMutation = (
  { __typename?: 'Mutation' }
  & { deleteUser?: Maybe<(
    { __typename: 'WMSUser' }
    & Pick<WmsUser, 'id' | 'userName'>
  ) | { __typename: 'DatabaseError' } | { __typename: 'ValidationError' }> }
);

export type ChangePasswordMutationVariables = Exact<{
  newPassword?: Maybe<Scalars['String']>;
  oldPassword?: Maybe<Scalars['String']>;
}>;


export type ChangePasswordMutation = (
  { __typename?: 'Mutation' }
  & { changePassword?: Maybe<(
    { __typename: 'WMSUser' }
    & Pick<WmsUser, 'userName'>
  ) | (
    { __typename: 'DatabaseError' }
    & Pick<DatabaseError, 'message'>
  ) | (
    { __typename: 'ValidationError' }
    & Pick<ValidationError, 'field' | 'messages'>
  )> }
);

export type CreateUserPermissionMutationVariables = Exact<{
  input?: Maybe<UserPermissionInput>;
}>;


export type CreateUserPermissionMutation = (
  { __typename?: 'Mutation' }
  & { createUserPermission?: Maybe<(
    { __typename?: 'UserPermission' }
    & Pick<UserPermission, 'id'>
  )> }
);

export type UpdateUserPermissionMutationVariables = Exact<{
  id: Scalars['Int'];
  input?: Maybe<UserPermissionUpdateInput>;
  userContext?: Maybe<UserContextInput>;
}>;


export type UpdateUserPermissionMutation = (
  { __typename?: 'Mutation' }
  & { updateUserPermission?: Maybe<(
    { __typename?: 'UserPermission' }
    & Pick<UserPermission, 'id'>
  )> }
);

export type DeleteUserPermissionMutationVariables = Exact<{
  id: Scalars['Int'];
  userContext?: Maybe<UserContextInput>;
}>;


export type DeleteUserPermissionMutation = (
  { __typename?: 'Mutation' }
  & { deleteUserPermission?: Maybe<(
    { __typename?: 'UserPermission' }
    & Pick<UserPermission, 'id'>
  )> }
);

export type CreateWarehouseMutationVariables = Exact<{
  input?: Maybe<WarehouseInput>;
}>;


export type CreateWarehouseMutation = (
  { __typename?: 'Mutation' }
  & { createWarehouse?: Maybe<(
    { __typename?: 'Warehouse' }
    & { address: (
      { __typename?: 'Address' }
      & AddressFragment
    ) }
    & WarehouseFragment
  )> }
);

export type UpdateWarehouseMutationVariables = Exact<{
  id: Scalars['Int'];
  input?: Maybe<WarehouseUpdateInput>;
}>;


export type UpdateWarehouseMutation = (
  { __typename?: 'Mutation' }
  & { updateWarehouse?: Maybe<(
    { __typename?: 'Warehouse' }
    & { address: (
      { __typename?: 'Address' }
      & AddressFragment
    ) }
    & WarehouseFragment
  )> }
);

export type DeleteWarehouseMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DeleteWarehouseMutation = (
  { __typename?: 'Mutation' }
  & { deleteWarehouse?: Maybe<(
    { __typename?: 'Warehouse' }
    & WarehouseFragment
  )> }
);

export type CreateWarehouseZoneMutationVariables = Exact<{
  input?: Maybe<WarehouseZoneInput>;
  userContext?: Maybe<UserContextInput>;
}>;


export type CreateWarehouseZoneMutation = (
  { __typename?: 'Mutation' }
  & { createWarehouseZone?: Maybe<(
    { __typename?: 'WarehouseZone' }
    & WarehouseZoneFragment
  )> }
);

export type UpdateWarehouseZoneMutationVariables = Exact<{
  id: Scalars['Int'];
  input?: Maybe<WarehouseZoneUpdateInput>;
  userContext?: Maybe<UserContextInput>;
}>;


export type UpdateWarehouseZoneMutation = (
  { __typename?: 'Mutation' }
  & { updateWarehouseZone?: Maybe<(
    { __typename?: 'WarehouseZone' }
    & WarehouseZoneFragment
  )> }
);

export type DeleteWarehouseZoneMutationVariables = Exact<{
  id: Scalars['Int'];
  userContext?: Maybe<UserContextInput>;
}>;


export type DeleteWarehouseZoneMutation = (
  { __typename?: 'Mutation' }
  & { deleteWarehouseZone?: Maybe<(
    { __typename?: 'WarehouseZone' }
    & Pick<WarehouseZone, 'id'>
  )> }
);

export type EnumQueryVariables = Exact<{
  name: Scalars['String'];
}>;


export type EnumQuery = (
  { __typename?: 'Query' }
  & { enum?: Maybe<(
    { __typename?: '__Type' }
    & { values?: Maybe<Array<(
      { __typename?: '__EnumValue' }
      & Pick<__EnumValue, 'name'>
    )>> }
  )> }
);

export type ActivitiesQueryVariables = Exact<{ [key: string]: never; }>;


export type ActivitiesQuery = (
  { __typename?: 'Query' }
  & { activities?: Maybe<Array<Maybe<(
    { __typename?: 'Activity' }
    & ActivityFragment
  )>>> }
);

export type AuditsQueryVariables = Exact<{
  filterInput?: Maybe<AuditEntryFilterInput>;
  userContext?: Maybe<UserContextInput>;
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
}>;


export type AuditsQuery = (
  { __typename?: 'Query' }
  & { audits?: Maybe<(
    { __typename?: 'AuditsConnection' }
    & Pick<AuditsConnection, 'totalCount'>
    & { pageInfo: (
      { __typename?: 'PageInfo' }
      & Pick<PageInfo, 'hasNextPage' | 'startCursor' | 'endCursor'>
    ), nodes?: Maybe<Array<Maybe<(
      { __typename?: 'AuditEntry' }
      & AuditLogFragment
    )>>> }
  )> }
);

export type AuditCodesQueryVariables = Exact<{ [key: string]: never; }>;


export type AuditCodesQuery = (
  { __typename?: 'Query' }
  & { auditCodes?: Maybe<(
    { __typename?: 'AuditCodesConnection' }
    & { nodes?: Maybe<Array<Maybe<(
      { __typename?: 'AuditCode' }
      & Pick<AuditCode, 'id' | 'code' | 'description' | 'message'>
    )>>> }
  )> }
);

export type BudgetHoldersQueryVariables = Exact<{
  filterInput?: Maybe<BudgetHolderFilterInput>;
  userContext?: Maybe<UserContextInput>;
}>;


export type BudgetHoldersQuery = (
  { __typename?: 'Query' }
  & { budgetHolders?: Maybe<(
    { __typename?: 'BudgetHoldersConnection' }
    & { nodes?: Maybe<Array<Maybe<(
      { __typename?: 'BudgetHolder' }
      & BudgetHolderFragment
    )>>> }
  )> }
);

export type BudgetHoldersPaginatedQueryVariables = Exact<{
  filterInput?: Maybe<BudgetHolderFilterInput>;
  userContext?: Maybe<UserContextInput>;
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
}>;


export type BudgetHoldersPaginatedQuery = (
  { __typename?: 'Query' }
  & { budgetHolders?: Maybe<(
    { __typename?: 'BudgetHoldersConnection' }
    & Pick<BudgetHoldersConnection, 'totalCount'>
    & { pageInfo: (
      { __typename?: 'PageInfo' }
      & Pick<PageInfo, 'endCursor' | 'startCursor' | 'hasNextPage' | 'hasPreviousPage'>
    ), nodes?: Maybe<Array<Maybe<(
      { __typename?: 'BudgetHolder' }
      & BudgetHolderFragment
    )>>> }
  )> }
);

export type BudgetHolderByIdQueryVariables = Exact<{
  id: Scalars['Int'];
  userContext?: Maybe<UserContextInput>;
}>;


export type BudgetHolderByIdQuery = (
  { __typename?: 'Query' }
  & { budgetHolderById?: Maybe<(
    { __typename?: 'BudgetHolder' }
    & BudgetHolderFragment
  )> }
);

export type CarriersQueryVariables = Exact<{
  filterInput?: Maybe<CarrierFilterInput>;
  userContext?: Maybe<UserContextInput>;
}>;


export type CarriersQuery = (
  { __typename?: 'Query' }
  & { carriers?: Maybe<(
    { __typename?: 'CarriersConnection' }
    & { nodes?: Maybe<Array<Maybe<(
      { __typename?: 'Carrier' }
      & { accounts?: Maybe<Array<Maybe<(
        { __typename?: 'CarrierAccount' }
        & CarrierAccountFragment
      )>>>, services?: Maybe<Array<Maybe<(
        { __typename?: 'CarrierService' }
        & CarrierServiceFragment
      )>>> }
      & CarrierFragment
    )>>> }
  )> }
);

export type CarrierByIdQueryVariables = Exact<{
  id: Scalars['Int'];
  userContext?: Maybe<UserContextInput>;
}>;


export type CarrierByIdQuery = (
  { __typename?: 'Query' }
  & { carrierById?: Maybe<(
    { __typename?: 'Carrier' }
    & { accounts?: Maybe<Array<Maybe<(
      { __typename?: 'CarrierAccount' }
      & CarrierAccountFragment
    )>>>, services?: Maybe<Array<Maybe<(
      { __typename?: 'CarrierService' }
      & CarrierServiceFragment
    )>>> }
    & CarrierFragment
  )> }
);

export type CarriersPaginaterQueryVariables = Exact<{
  filterInput?: Maybe<CarrierFilterInput>;
  userContext?: Maybe<UserContextInput>;
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
}>;


export type CarriersPaginaterQuery = (
  { __typename?: 'Query' }
  & { carriers?: Maybe<(
    { __typename?: 'CarriersConnection' }
    & Pick<CarriersConnection, 'totalCount'>
    & { pageInfo: (
      { __typename?: 'PageInfo' }
      & Pick<PageInfo, 'hasNextPage' | 'endCursor'>
    ), nodes?: Maybe<Array<Maybe<(
      { __typename?: 'Carrier' }
      & Pick<Carrier, 'id' | 'code' | 'name'>
    )>>> }
  )> }
);

export type CarrierModulesQueryVariables = Exact<{ [key: string]: never; }>;


export type CarrierModulesQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'carrierModules'>
);

export type ConfigurationForModuleQueryVariables = Exact<{
  module?: Maybe<Scalars['String']>;
  userContext?: Maybe<UserContextInput>;
}>;


export type ConfigurationForModuleQuery = (
  { __typename?: 'Query' }
  & { configurationForModule?: Maybe<Array<Maybe<(
    { __typename?: 'ConfigOption' }
    & Pick<ConfigOption, 'label' | 'overrideRequired' | 'position' | 'settingName' | 'type'>
  )>>> }
);

export type CodesQueryVariables = Exact<{
  filterInput?: Maybe<UdCodeFilterInput>;
  userContext?: Maybe<UserContextInput>;
}>;


export type CodesQuery = (
  { __typename?: 'Query' }
  & { codes?: Maybe<(
    { __typename?: 'CodesConnection' }
    & { nodes?: Maybe<Array<Maybe<(
      { __typename?: 'UDCode' }
      & CodeFragment
    )>>> }
  )> }
);

export type CodeForTypeQueryVariables = Exact<{
  codeType?: Maybe<Scalars['String']>;
}>;


export type CodeForTypeQuery = (
  { __typename?: 'Query' }
  & { codesForType?: Maybe<(
    { __typename?: 'CodesForTypeConnection' }
    & { nodes?: Maybe<Array<Maybe<(
      { __typename?: 'UDCode' }
      & CodeFragment
    )>>> }
  )> }
);

export type CodesPaginatedQueryVariables = Exact<{
  filterInput?: Maybe<UdCodeFilterInput>;
  userContext?: Maybe<UserContextInput>;
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
}>;


export type CodesPaginatedQuery = (
  { __typename?: 'Query' }
  & { codes?: Maybe<(
    { __typename?: 'CodesConnection' }
    & Pick<CodesConnection, 'totalCount'>
    & { pageInfo: (
      { __typename?: 'PageInfo' }
      & Pick<PageInfo, 'hasNextPage' | 'startCursor' | 'endCursor'>
    ), nodes?: Maybe<Array<Maybe<(
      { __typename?: 'UDCode' }
      & CodeFragment
    )>>> }
  )> }
);

export type CodeForTypePaginatedQueryVariables = Exact<{
  codeType?: Maybe<Scalars['String']>;
  userContext?: Maybe<UserContextInput>;
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
}>;


export type CodeForTypePaginatedQuery = (
  { __typename?: 'Query' }
  & { codesForType?: Maybe<(
    { __typename?: 'CodesForTypeConnection' }
    & Pick<CodesForTypeConnection, 'totalCount'>
    & { pageInfo: (
      { __typename?: 'PageInfo' }
      & Pick<PageInfo, 'hasNextPage' | 'startCursor' | 'endCursor'>
    ), nodes?: Maybe<Array<Maybe<(
      { __typename?: 'UDCode' }
      & CodeFragment
    )>>> }
  )> }
);

export type CodeDefinitionsQueryVariables = Exact<{ [key: string]: never; }>;


export type CodeDefinitionsQuery = (
  { __typename?: 'Query' }
  & { codeDefinitions?: Maybe<(
    { __typename?: 'CodeDefinitionsConnection' }
    & { nodes?: Maybe<Array<Maybe<(
      { __typename?: 'CodeDefinition' }
      & CodeDefinitionFragment
    )>>> }
  )> }
);

export type PresetsForTableQueryVariables = Exact<{
  tableName?: Maybe<Scalars['String']>;
}>;


export type PresetsForTableQuery = (
  { __typename?: 'Query' }
  & { presetsForTable?: Maybe<(
    { __typename?: 'PresetsForTableConnection' }
    & { nodes?: Maybe<Array<Maybe<(
      { __typename?: 'TablePreset' }
      & PresetForTableFragment
    ) | (
      { __typename?: 'DatabaseError' }
      & Pick<DatabaseError, 'message'>
      & { dbErrorId: DatabaseError['id'] }
    ) | (
      { __typename?: 'ValidationError' }
      & Pick<ValidationError, 'field' | 'messages'>
      & { vError: ValidationError['id'] }
    )>>> }
  )> }
);

export type DefaultForTableQueryVariables = Exact<{ [key: string]: never; }>;


export type DefaultForTableQuery = (
  { __typename?: 'Query' }
  & { defaultForTable?: Maybe<(
    { __typename?: 'TablePreset' }
    & PresetForTableFragment
  ) | (
    { __typename?: 'DatabaseError' }
    & Pick<DatabaseError, 'message'>
    & { dbErrorId: DatabaseError['id'] }
  ) | (
    { __typename?: 'ValidationError' }
    & Pick<ValidationError, 'field' | 'messages'>
    & { vError: ValidationError['id'] }
  )> }
);

export type DestinationsQueryVariables = Exact<{
  filterInput?: Maybe<DestinationFilterInput>;
  userContext?: Maybe<UserContextInput>;
}>;


export type DestinationsQuery = (
  { __typename?: 'Query' }
  & { destinations?: Maybe<(
    { __typename?: 'DestinationsConnection' }
    & { nodes?: Maybe<Array<Maybe<(
      { __typename?: 'Destination' }
      & { address: (
        { __typename?: 'Address' }
        & AddressFragment
      ), budgets?: Maybe<Array<Maybe<(
        { __typename?: 'DestinationBudget' }
        & BudgetFragment
      )>>>, contact?: Maybe<(
        { __typename?: 'Contact' }
        & ContactFragment
      )>, routing?: Maybe<Array<Maybe<(
        { __typename?: 'DestinationRoute' }
        & RoutingFragment
      )>>> }
      & DestinationFragment
    )>>> }
  )> }
);

export type DestinationsPaginatedQueryVariables = Exact<{
  filterInput?: Maybe<DestinationFilterInput>;
  userContext?: Maybe<UserContextInput>;
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
}>;


export type DestinationsPaginatedQuery = (
  { __typename?: 'Query' }
  & { destinations?: Maybe<(
    { __typename?: 'DestinationsConnection' }
    & Pick<DestinationsConnection, 'totalCount'>
    & { pageInfo: (
      { __typename?: 'PageInfo' }
      & Pick<PageInfo, 'endCursor' | 'startCursor' | 'hasNextPage' | 'hasPreviousPage'>
    ), nodes?: Maybe<Array<Maybe<(
      { __typename?: 'Destination' }
      & Pick<Destination, 'id' | 'code' | 'name'>
    )>>> }
  )> }
);

export type DestinationByIdQueryVariables = Exact<{
  id: Scalars['Int'];
  userContext?: Maybe<UserContextInput>;
}>;


export type DestinationByIdQuery = (
  { __typename?: 'Query' }
  & { destinationById?: Maybe<(
    { __typename?: 'Destination' }
    & { address: (
      { __typename?: 'Address' }
      & AddressFragment
    ), budgets?: Maybe<Array<Maybe<(
      { __typename?: 'DestinationBudget' }
      & BudgetFragment
    )>>>, contact?: Maybe<(
      { __typename?: 'Contact' }
      & ContactFragment
    )>, routing?: Maybe<Array<Maybe<(
      { __typename?: 'DestinationRoute' }
      & RoutingFragment
    )>>> }
    & DestinationFragment
  )> }
);

export type DestinationCodesQueryVariables = Exact<{ [key: string]: never; }>;


export type DestinationCodesQuery = (
  { __typename?: 'Query' }
  & { destinationCodes?: Maybe<Array<Maybe<(
    { __typename?: 'DestinationCode' }
    & DestinationCodeFragment
  )>>> }
);

export type GoodsReceiptByIdQueryVariables = Exact<{
  id: Scalars['Int'];
  userContext?: Maybe<UserContextInput>;
}>;


export type GoodsReceiptByIdQuery = (
  { __typename?: 'Query' }
  & { goodsReceipt?: Maybe<(
    { __typename?: 'GoodsReceiptQueryType' }
    & Pick<GoodsReceiptQueryType, 'id'>
    & { goodsReceiptById?: Maybe<(
      { __typename?: 'GoodsReceipt' }
      & Pick<GoodsReceipt, 'id' | 'goodsReceiptNumber' | 'customerRef' | 'invoiceRef' | 'status' | 'dateReceived'>
      & { stockOwner?: Maybe<(
        { __typename?: 'StockOwner' }
        & Pick<StockOwner, 'code'>
      )>, warehouse?: Maybe<(
        { __typename?: 'Warehouse' }
        & Pick<Warehouse, 'code'>
      )>, extra?: Maybe<(
        { __typename?: 'GoodsReceipt_ExtraData' }
        & ExtraFragment
      )>, booked?: Maybe<Array<Maybe<(
        { __typename?: 'GoodsBookLine' }
        & BookedFragment
      )>>>, received?: Maybe<Array<Maybe<(
        { __typename?: 'GoodsReceiptLine' }
        & ReceivedFragment
      )>>> }
    )> }
  )> }
);

export type GoodsReceiptByNumberQueryVariables = Exact<{
  goodsReceiptNumber?: Maybe<Scalars['String']>;
  userContext?: Maybe<UserContextInput>;
}>;


export type GoodsReceiptByNumberQuery = (
  { __typename?: 'Query' }
  & { goodsReceipt?: Maybe<(
    { __typename?: 'GoodsReceiptQueryType' }
    & Pick<GoodsReceiptQueryType, 'id'>
    & { goodsReceiptByNumber?: Maybe<(
      { __typename?: 'GoodsReceipt' }
      & Pick<GoodsReceipt, 'id' | 'goodsReceiptNumber' | 'customerRef' | 'invoiceRef' | 'status' | 'dateReceived'>
      & { stockOwner?: Maybe<(
        { __typename?: 'StockOwner' }
        & Pick<StockOwner, 'code'>
      )>, warehouse?: Maybe<(
        { __typename?: 'Warehouse' }
        & Pick<Warehouse, 'code'>
      )>, extra?: Maybe<(
        { __typename?: 'GoodsReceipt_ExtraData' }
        & ExtraFragment
      )>, booked?: Maybe<Array<Maybe<(
        { __typename?: 'GoodsBookLine' }
        & BookedFragment
      )>>>, received?: Maybe<Array<Maybe<(
        { __typename?: 'GoodsReceiptLine' }
        & ReceivedFragment
      )>>> }
    )> }
  )> }
);

export type GoodsReceiptsQueryVariables = Exact<{
  filterInput?: Maybe<GoodsReceiptFilterInput>;
  userContext?: Maybe<UserContextInput>;
}>;


export type GoodsReceiptsQuery = (
  { __typename?: 'Query' }
  & { goodsReceipt?: Maybe<(
    { __typename?: 'GoodsReceiptQueryType' }
    & Pick<GoodsReceiptQueryType, 'id'>
    & { goodsReceipts?: Maybe<(
      { __typename?: 'GoodsReceiptsConnection' }
      & Pick<GoodsReceiptsConnection, 'totalCount'>
      & { nodes?: Maybe<Array<Maybe<(
        { __typename?: 'GoodsReceipt' }
        & Pick<GoodsReceipt, 'id' | 'goodsReceiptNumber' | 'customerRef' | 'invoiceRef' | 'status' | 'dateReceived'>
        & { stockOwner?: Maybe<(
          { __typename?: 'StockOwner' }
          & Pick<StockOwner, 'code'>
        )>, warehouse?: Maybe<(
          { __typename?: 'Warehouse' }
          & Pick<Warehouse, 'code'>
        )>, extra?: Maybe<(
          { __typename?: 'GoodsReceipt_ExtraData' }
          & ExtraFragment
        )>, booked?: Maybe<Array<Maybe<(
          { __typename?: 'GoodsBookLine' }
          & BookedFragment
        )>>>, received?: Maybe<Array<Maybe<(
          { __typename?: 'GoodsReceiptLine' }
          & ReceivedFragment
        )>>> }
      )>>> }
    )> }
  )> }
);

export type GoodsReceiptsPaginatedQueryVariables = Exact<{
  filterInput?: Maybe<GoodsReceiptFilterInput>;
  userContext?: Maybe<UserContextInput>;
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
}>;


export type GoodsReceiptsPaginatedQuery = (
  { __typename?: 'Query' }
  & { goodsReceipt?: Maybe<(
    { __typename?: 'GoodsReceiptQueryType' }
    & Pick<GoodsReceiptQueryType, 'id'>
    & { goodsReceipts?: Maybe<(
      { __typename?: 'GoodsReceiptsConnection' }
      & Pick<GoodsReceiptsConnection, 'totalCount'>
      & { pageInfo: (
        { __typename?: 'PageInfo' }
        & Pick<PageInfo, 'endCursor' | 'startCursor' | 'hasNextPage' | 'hasPreviousPage'>
      ), nodes?: Maybe<Array<Maybe<(
        { __typename?: 'GoodsReceipt' }
        & Pick<GoodsReceipt, 'id' | 'goodsReceiptNumber'>
      )>>> }
    )> }
  )> }
);

export type HandlingTypesQueryVariables = Exact<{
  filterInput?: Maybe<HandlingTypeFilterInput>;
  userContext?: Maybe<UserContextInput>;
}>;


export type HandlingTypesQuery = (
  { __typename?: 'Query' }
  & { handlingTypes?: Maybe<(
    { __typename?: 'HandlingTypesConnection' }
    & { nodes?: Maybe<Array<Maybe<(
      { __typename?: 'HandlingType' }
      & { storageTypes?: Maybe<Array<Maybe<(
        { __typename?: 'HandlingStorageType' }
        & { storageType?: Maybe<(
          { __typename?: 'StorageType' }
          & StorageTypeFragment
        )> }
      )>>> }
      & HandlingTypeFragment
    )>>> }
  )> }
);

export type SelectHandlingTypesQueryVariables = Exact<{
  filterInput?: Maybe<HandlingTypeFilterInput>;
  userContext?: Maybe<UserContextInput>;
}>;


export type SelectHandlingTypesQuery = (
  { __typename?: 'Query' }
  & { handlingTypes?: Maybe<(
    { __typename?: 'HandlingTypesConnection' }
    & { nodes?: Maybe<Array<Maybe<(
      { __typename?: 'HandlingType' }
      & HandlingTypeFragment
    )>>> }
  )> }
);

export type HandlingTypesPaginatedQueryVariables = Exact<{
  filterInput?: Maybe<HandlingTypeFilterInput>;
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
}>;


export type HandlingTypesPaginatedQuery = (
  { __typename?: 'Query' }
  & { handlingTypes?: Maybe<(
    { __typename?: 'HandlingTypesConnection' }
    & Pick<HandlingTypesConnection, 'totalCount'>
    & { pageInfo: (
      { __typename?: 'PageInfo' }
      & Pick<PageInfo, 'endCursor' | 'startCursor' | 'hasNextPage' | 'hasPreviousPage'>
    ), nodes?: Maybe<Array<Maybe<(
      { __typename?: 'HandlingType' }
      & { storageTypes?: Maybe<Array<Maybe<(
        { __typename?: 'HandlingStorageType' }
        & { storageType?: Maybe<(
          { __typename?: 'StorageType' }
          & StorageTypeFragment
        )> }
      )>>> }
      & HandlingTypeFragment
    )>>> }
  )> }
);

export type HandlingTypeByIdQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type HandlingTypeByIdQuery = (
  { __typename?: 'Query' }
  & { handlingTypeById?: Maybe<(
    { __typename?: 'HandlingType' }
    & { storageTypes?: Maybe<Array<Maybe<(
      { __typename?: 'HandlingStorageType' }
      & { storageType?: Maybe<(
        { __typename?: 'StorageType' }
        & StorageTypeFragment
      )> }
    )>>> }
    & HandlingTypeFragment
  )> }
);

export type LicencePlateTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type LicencePlateTypesQuery = (
  { __typename?: 'Query' }
  & { licencePlate?: Maybe<(
    { __typename?: 'LicencePlateQueryType' }
    & { licencePlateTypes?: Maybe<(
      { __typename?: 'LicencePlateTypesConnection' }
      & { nodes?: Maybe<Array<Maybe<(
        { __typename?: 'LicencePlateType' }
        & Pick<LicencePlateType, 'id' | 'code' | 'description'>
      )>>> }
    )> }
  )> }
);

export type LocationsQueryVariables = Exact<{
  filterInput?: Maybe<LocationFilterInput>;
  userContext?: Maybe<UserContextInput>;
}>;


export type LocationsQuery = (
  { __typename?: 'Query' }
  & { locations?: Maybe<(
    { __typename?: 'LocationsConnection' }
    & { nodes?: Maybe<Array<Maybe<(
      { __typename?: 'Location' }
      & LocationFragment
    )>>> }
  )> }
);

export type LocationByIdQueryVariables = Exact<{
  id: Scalars['Int'];
  userContext?: Maybe<UserContextInput>;
}>;


export type LocationByIdQuery = (
  { __typename?: 'Query' }
  & { locationById?: Maybe<(
    { __typename?: 'Location' }
    & { storageType?: Maybe<(
      { __typename?: 'StorageType' }
      & StorageTypeFragment
    )> }
    & LocationFragment
  )> }
);

export type LocationIdByCodeQueryVariables = Exact<{
  code?: Maybe<Scalars['String']>;
  userContext?: Maybe<UserContextInput>;
}>;


export type LocationIdByCodeQuery = (
  { __typename?: 'Query' }
  & { locationByCode?: Maybe<(
    { __typename?: 'Location' }
    & Pick<Location, 'id' | 'code'>
  )> }
);

export type LocationProcessTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type LocationProcessTypesQuery = (
  { __typename?: 'Query' }
  & { locationProcessTypes?: Maybe<Array<Maybe<(
    { __typename?: 'LocationProcessTypeMetadata' }
    & Pick<LocationProcessTypeMetadata, 'displayName' | 'description' | 'value'>
  )>>> }
);

export type LocationPhysicalTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type LocationPhysicalTypesQuery = (
  { __typename?: 'Query' }
  & { locationPhysicalTypes?: Maybe<Array<Maybe<(
    { __typename?: 'LocationPhysicalTypeMetadata' }
    & Pick<LocationPhysicalTypeMetadata, 'displayName' | 'description' | 'value'>
  )>>> }
);

export type SelectLocationsQueryVariables = Exact<{
  filterInput?: Maybe<LocationFilterInput>;
  userContext?: Maybe<UserContextInput>;
}>;


export type SelectLocationsQuery = (
  { __typename?: 'Query' }
  & { locations?: Maybe<(
    { __typename?: 'LocationsConnection' }
    & { nodes?: Maybe<Array<Maybe<(
      { __typename?: 'Location' }
      & Pick<Location, 'id' | 'code'>
    )>>> }
  )> }
);

export type LocationsPaginatedQueryVariables = Exact<{
  filterInput?: Maybe<LocationFilterInput>;
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  userContext?: Maybe<UserContextInput>;
}>;


export type LocationsPaginatedQuery = (
  { __typename?: 'Query' }
  & { locations?: Maybe<(
    { __typename?: 'LocationsConnection' }
    & Pick<LocationsConnection, 'totalCount'>
    & { pageInfo: (
      { __typename?: 'PageInfo' }
      & Pick<PageInfo, 'endCursor' | 'startCursor' | 'hasNextPage' | 'hasPreviousPage'>
    ), nodes?: Maybe<Array<Maybe<(
      { __typename?: 'Location' }
      & Pick<Location, 'id' | 'aisle' | 'code' | 'zone'>
      & { storageType?: Maybe<(
        { __typename?: 'StorageType' }
        & StorageTypeFragment
      )> }
    )>>> }
  )> }
);

export type MaxWeeklySpendsQueryVariables = Exact<{ [key: string]: never; }>;


export type MaxWeeklySpendsQuery = (
  { __typename?: 'Query' }
  & { maxWeeklySpends?: Maybe<Array<Maybe<(
    { __typename?: 'MaxWeeklySpend' }
    & MaxWeeklySpendFragment
  )>>> }
);

export type AllMenusQueryVariables = Exact<{ [key: string]: never; }>;


export type AllMenusQuery = (
  { __typename?: 'Query' }
  & { allMenus?: Maybe<Array<Maybe<(
    { __typename?: 'Screen' }
    & Pick<Screen, 'id' | 'action' | 'compareTo' | 'defaultTitle' | 'description' | 'screenCode'>
  )>>> }
);

export type DefaultMenuQueryVariables = Exact<{ [key: string]: never; }>;


export type DefaultMenuQuery = (
  { __typename?: 'Query' }
  & { defaultMenu?: Maybe<Array<Maybe<(
    { __typename?: 'MenuEntry' }
    & { screen?: Maybe<(
      { __typename?: 'Screen' }
      & ScreenFragment
    )>, parent?: Maybe<(
      { __typename?: 'MenuEntry' }
      & { screen?: Maybe<(
        { __typename?: 'Screen' }
        & ScreenFragment
      )> }
      & MenuEntryFragment
    )>, children?: Maybe<Array<Maybe<(
      { __typename?: 'MenuEntry' }
      & { screen?: Maybe<(
        { __typename?: 'Screen' }
        & ScreenFragment
      )> }
      & MenuEntryFragment
    )>>> }
    & MenuEntryFragment
  )>>> }
);

export type ConfirmMethodsQueryVariables = Exact<{ [key: string]: never; }>;


export type ConfirmMethodsQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'pickConfirmMethods' | 'postPickConfirmMethods' | 'packingMethods' | 'despatchMethods' | 'closeLoadMethods'>
);

export type PickCreationmethodsQueryVariables = Exact<{ [key: string]: never; }>;


export type PickCreationmethodsQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'prePickCreationMethods' | 'pickCreationMethods' | 'postPickCreationMethods' | 'pickOutputMethods'>
);

export type MaterialHandlingEquipmentsQueryVariables = Exact<{
  filterInput?: Maybe<MaterialHandlingEquipmentFilterInput>;
  userContext?: Maybe<UserContextInput>;
}>;


export type MaterialHandlingEquipmentsQuery = (
  { __typename?: 'Query' }
  & { materialHandlingEquipment?: Maybe<(
    { __typename?: 'MaterialHandlingEquipmentConnection' }
    & { nodes?: Maybe<Array<Maybe<(
      { __typename?: 'MaterialHandlingEquipment' }
      & MheFragment
    )>>> }
  )> }
);

export type MaterialHandlingEquipmentsPaginatedQueryVariables = Exact<{
  filterInput?: Maybe<MaterialHandlingEquipmentFilterInput>;
  userContext?: Maybe<UserContextInput>;
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
}>;


export type MaterialHandlingEquipmentsPaginatedQuery = (
  { __typename?: 'Query' }
  & { materialHandlingEquipment?: Maybe<(
    { __typename?: 'MaterialHandlingEquipmentConnection' }
    & Pick<MaterialHandlingEquipmentConnection, 'totalCount'>
    & { pageInfo: (
      { __typename?: 'PageInfo' }
      & Pick<PageInfo, 'endCursor' | 'startCursor' | 'hasNextPage' | 'hasPreviousPage'>
    ), nodes?: Maybe<Array<Maybe<(
      { __typename?: 'MaterialHandlingEquipment' }
      & Pick<MaterialHandlingEquipment, 'id' | 'code' | 'description' | 'class'>
    )>>> }
  )> }
);

export type MaterialHandlingEquipmentByIdQueryVariables = Exact<{
  id: Scalars['Int'];
  userContext?: Maybe<UserContextInput>;
}>;


export type MaterialHandlingEquipmentByIdQuery = (
  { __typename?: 'Query' }
  & { materialHandlingEquipmentById?: Maybe<(
    { __typename?: 'MaterialHandlingEquipment' }
    & MheFragment
  )> }
);

export type SupplierOnBlurQueryVariables = Exact<{
  code?: Maybe<Scalars['String']>;
  userContext?: Maybe<UserContextInput>;
}>;


export type SupplierOnBlurQuery = (
  { __typename?: 'Query' }
  & { supplierByCode?: Maybe<(
    { __typename?: 'Supplier' }
    & Pick<Supplier, 'id' | 'code'>
  )> }
);

export type CarrierOnBlurQueryVariables = Exact<{
  code?: Maybe<Scalars['String']>;
  userContext?: Maybe<UserContextInput>;
}>;


export type CarrierOnBlurQuery = (
  { __typename?: 'Query' }
  & { carrierByCode?: Maybe<(
    { __typename?: 'Carrier' }
    & Pick<Carrier, 'id' | 'code'>
  )> }
);

export type BudgetHolderOnBlurQueryVariables = Exact<{
  code?: Maybe<Scalars['String']>;
  userContext?: Maybe<UserContextInput>;
}>;


export type BudgetHolderOnBlurQuery = (
  { __typename?: 'Query' }
  & { budgetHolderByCode?: Maybe<(
    { __typename?: 'BudgetHolder' }
    & Pick<BudgetHolder, 'id' | 'code'>
  )> }
);

export type PurchaseOrderOnBlurQueryVariables = Exact<{
  poNumber?: Maybe<Scalars['String']>;
  userContext?: Maybe<UserContextInput>;
}>;


export type PurchaseOrderOnBlurQuery = (
  { __typename?: 'Query' }
  & { purchaseOrder?: Maybe<(
    { __typename?: 'PurchaseOrderQueryType' }
    & { purchaseOrderByReference?: Maybe<(
      { __typename?: 'PurchaseOrder' }
      & Pick<PurchaseOrder, 'id' | 'referenceNumber'>
    )> }
  )> }
);

export type ProductOnBlurQueryVariables = Exact<{
  code?: Maybe<Scalars['String']>;
  userContext?: Maybe<UserContextInput>;
}>;


export type ProductOnBlurQuery = (
  { __typename?: 'Query' }
  & { productByCode?: Maybe<(
    { __typename?: 'Product' }
    & Pick<Product, 'id' | 'code'>
  )> }
);

export type OrderEntryQueryVariables = Exact<{
  code: Scalars['String'];
}>;


export type OrderEntryQuery = (
  { __typename?: 'Query' }
  & { orderEntry?: Maybe<(
    { __typename?: 'OrderEntry' }
    & { destinationCode: (
      { __typename?: 'DestinationCode' }
      & DestinationCodeFragment
    ), budgetHolder: (
      { __typename?: 'BudgetHolder' }
      & BudgetHolderFragment
    ), orderType: (
      { __typename?: 'OrderType' }
      & OrderTypeFragment
    ) }
    & OrderEntryFragment
  )> }
);

export type OrderEntriesQueryVariables = Exact<{
  filterInput?: Maybe<OrderFilter>;
}>;


export type OrderEntriesQuery = (
  { __typename?: 'Query' }
  & { orderEntries?: Maybe<Array<Maybe<(
    { __typename?: 'OrderEntry' }
    & { destinationCode: (
      { __typename?: 'DestinationCode' }
      & DestinationCodeFragment
    ), budgetHolder: (
      { __typename?: 'BudgetHolder' }
      & BudgetHolderFragment
    ), orderType: (
      { __typename?: 'OrderType' }
      & OrderTypeFragment
    ) }
    & OrderEntryFragment
  )>>> }
);

export type OrderTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type OrderTypesQuery = (
  { __typename?: 'Query' }
  & { orderTypes?: Maybe<Array<Maybe<(
    { __typename?: 'OrderType' }
    & OrderTypeFragment
  )>>> }
);

export type PoFormatsQueryVariables = Exact<{ [key: string]: never; }>;


export type PoFormatsQuery = (
  { __typename?: 'Query' }
  & { poFormats?: Maybe<Array<Maybe<(
    { __typename?: 'POFormat' }
    & PoFormatFragment
  )>>> }
);

export type PoTransmissionMethodsQueryVariables = Exact<{ [key: string]: never; }>;


export type PoTransmissionMethodsQuery = (
  { __typename?: 'Query' }
  & { poTransmissionMethods?: Maybe<Array<Maybe<(
    { __typename?: 'POTransmissionMethod' }
    & PoTransmissionMethodFragment
  )>>> }
);

export type ProductsQueryVariables = Exact<{
  filterInput?: Maybe<ProductFilterInput>;
  userContext?: Maybe<UserContextInput>;
  includeLinked: Scalars['Boolean'];
}>;


export type ProductsQuery = (
  { __typename?: 'Query' }
  & { product?: Maybe<(
    { __typename?: 'ProductConnection' }
    & { nodes?: Maybe<Array<Maybe<(
      { __typename?: 'Product' }
      & { pickfaces?: Maybe<Array<Maybe<(
        { __typename?: 'ProductPickface' }
        & PickfaceFragment
      )>>>, licencePlates?: Maybe<Array<Maybe<(
        { __typename?: 'LPDefinition' }
        & LicencePlateFragment
        & LicencePlateFragment
      )>>>, documents?: Maybe<Array<Maybe<(
        { __typename?: 'ProductDocument' }
        & DocumentFragment
      )>>> }
      & ProductFragment
    )>>> }
  )> }
);

export type SelectProductsQueryVariables = Exact<{
  filterInput?: Maybe<ProductFilterInput>;
  userContext?: Maybe<UserContextInput>;
  includeLinked: Scalars['Boolean'];
}>;


export type SelectProductsQuery = (
  { __typename?: 'Query' }
  & { product?: Maybe<(
    { __typename?: 'ProductConnection' }
    & { nodes?: Maybe<Array<Maybe<(
      { __typename?: 'Product' }
      & Pick<Product, 'id' | 'code' | 'description'>
    )>>> }
  )> }
);

export type ProductsPaginatedQueryVariables = Exact<{
  filterInput?: Maybe<ProductFilterInput>;
  userContext?: Maybe<UserContextInput>;
  includeLinked: Scalars['Boolean'];
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
}>;


export type ProductsPaginatedQuery = (
  { __typename?: 'Query' }
  & { product?: Maybe<(
    { __typename?: 'ProductConnection' }
    & Pick<ProductConnection, 'totalCount'>
    & { pageInfo: (
      { __typename?: 'PageInfo' }
      & Pick<PageInfo, 'endCursor' | 'startCursor' | 'hasNextPage' | 'hasPreviousPage'>
    ), nodes?: Maybe<Array<Maybe<(
      { __typename?: 'Product' }
      & Pick<Product, 'id' | 'code' | 'description'>
      & { stockOwner?: Maybe<(
        { __typename?: 'StockOwner' }
        & Pick<StockOwner, 'name'>
      )> }
    )>>> }
  )> }
);

export type ProductByIdQueryVariables = Exact<{
  id: Scalars['Int'];
  userContext?: Maybe<UserContextInput>;
}>;


export type ProductByIdQuery = (
  { __typename?: 'Query' }
  & { productById?: Maybe<(
    { __typename?: 'Product' }
    & { pickfaces?: Maybe<Array<Maybe<(
      { __typename?: 'ProductPickface' }
      & PickfaceFragment
    )>>>, licencePlates?: Maybe<Array<Maybe<(
      { __typename?: 'LPDefinition' }
      & LicencePlateFragment
      & LicencePlateFragment
    )>>>, documents?: Maybe<Array<Maybe<(
      { __typename?: 'ProductDocument' }
      & DocumentFragment
    )>>> }
    & ProductFragment
  )> }
);

export type RequiredDataQueryVariables = Exact<{
  code: Scalars['String'];
  userContext?: Maybe<UserContextInput>;
}>;


export type RequiredDataQuery = (
  { __typename?: 'Query' }
  & { productByCode?: Maybe<(
    { __typename?: 'Product' }
    & Pick<Product, 'id' | 'description'>
    & { require?: Maybe<(
      { __typename?: 'ProductRequiredData' }
      & Pick<ProductRequiredData, 'arrivalTemp' | 'batch' | 'batchInfo' | 'bestBefore' | 'budgetHolder' | 'cartonLP' | 'expiry' | 'handlingType' | 'killDte' | 'originCntry' | 'packType' | 'productionDte' | 'serial' | 'serials' | 'slaughterCode' | 'status' | 'weight'>
    )> }
  )> }
);

export type PurchaseOrdersQueryVariables = Exact<{
  filterInput?: Maybe<PurchaseOrderFilterInput>;
  userContext?: Maybe<UserContextInput>;
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
}>;


export type PurchaseOrdersQuery = (
  { __typename?: 'Query' }
  & { purchaseOrder?: Maybe<(
    { __typename?: 'PurchaseOrderQueryType' }
    & Pick<PurchaseOrderQueryType, 'id'>
    & { purchaseOrders?: Maybe<(
      { __typename?: 'PurchaseOrdersConnection' }
      & Pick<PurchaseOrdersConnection, 'totalCount'>
      & { pageInfo: (
        { __typename?: 'PageInfo' }
        & Pick<PageInfo, 'hasNextPage' | 'startCursor' | 'endCursor'>
      ), nodes?: Maybe<Array<Maybe<(
        { __typename?: 'PurchaseOrder' }
        & PurchaseOrderFragment
      )>>> }
    )> }
  )> }
);

export type PurchaseOrderByIdQueryVariables = Exact<{
  id: Scalars['Int'];
  userContext?: Maybe<UserContextInput>;
}>;


export type PurchaseOrderByIdQuery = (
  { __typename?: 'Query' }
  & { purchaseOrder?: Maybe<(
    { __typename?: 'PurchaseOrderQueryType' }
    & Pick<PurchaseOrderQueryType, 'id'>
    & { purchaseOrderById?: Maybe<(
      { __typename?: 'PurchaseOrder' }
      & PurchaseOrderFragment
    )> }
  )> }
);

export type PurchaseOrderByReferenceQueryVariables = Exact<{
  poNumber?: Maybe<Scalars['String']>;
  userContext?: Maybe<UserContextInput>;
}>;


export type PurchaseOrderByReferenceQuery = (
  { __typename?: 'Query' }
  & { purchaseOrder?: Maybe<(
    { __typename?: 'PurchaseOrderQueryType' }
    & Pick<PurchaseOrderQueryType, 'id'>
    & { purchaseOrderByReference?: Maybe<(
      { __typename?: 'PurchaseOrder' }
      & PurchaseOrderFragment
    )> }
  )> }
);

export type CultureQueryVariables = Exact<{
  resourceSet: Scalars['String'];
}>;


export type CultureQuery = (
  { __typename?: 'Query' }
  & { resources?: Maybe<(
    { __typename?: 'ResourcesQuery' }
    & { allLocaleIds?: Maybe<Array<Maybe<(
      { __typename?: 'CultureInfo' }
      & Pick<CultureInfo, 'name' | 'displayName' | 'nativeName' | 'englishName'>
    )>>> }
  )> }
);

export type CultureByNameQueryVariables = Exact<{
  filterInput?: Maybe<CultureInfoFilterInput>;
}>;


export type CultureByNameQuery = (
  { __typename?: 'Query' }
  & { resources?: Maybe<(
    { __typename?: 'ResourcesQuery' }
    & { cultures?: Maybe<(
      { __typename?: 'CulturesConnection' }
      & { nodes?: Maybe<Array<Maybe<(
        { __typename?: 'CultureInfo' }
        & Pick<CultureInfo, 'LCID' | 'name' | 'displayName' | 'nativeName' | 'englishName'>
      )>>> }
    )> }
  )> }
);

export type StockEnquiryQueryVariables = Exact<{
  filterInput?: Maybe<StockFilterInput>;
  userContext?: Maybe<UserContextInput>;
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
}>;


export type StockEnquiryQuery = (
  { __typename?: 'Query' }
  & { stock?: Maybe<(
    { __typename?: 'StockQueryType' }
    & { stock?: Maybe<(
      { __typename?: 'StockConnection' }
      & Pick<StockConnection, 'totalCount'>
      & { pageInfo: (
        { __typename?: 'PageInfo' }
        & Pick<PageInfo, 'hasNextPage' | 'startCursor' | 'endCursor'>
      ), nodes?: Maybe<Array<Maybe<(
        { __typename?: 'Stock' }
        & StockFragment
      )>>> }
    )> }
  )> }
);

export type StockOwnersQueryVariables = Exact<{
  filterInput?: Maybe<StockOwnerFilterInput>;
}>;


export type StockOwnersQuery = (
  { __typename?: 'Query' }
  & { stockOwners?: Maybe<(
    { __typename?: 'StockOwnersConnection' }
    & { nodes?: Maybe<Array<Maybe<(
      { __typename?: 'StockOwner' }
      & { linkedStockOwners?: Maybe<Array<Maybe<(
        { __typename?: 'StockOwnerLink' }
        & { child?: Maybe<(
          { __typename?: 'StockOwner' }
          & Pick<StockOwner, 'id' | 'code'>
        )> }
      )>>>, address?: Maybe<(
        { __typename?: 'Address' }
        & AddressFragment
      )>, categories?: Maybe<Array<Maybe<(
        { __typename?: 'CategoryDefinition' }
        & CategoryFragment
      )>>>, contact?: Maybe<(
        { __typename?: 'Contact' }
        & ContactFragment
      )>, productStatuses?: Maybe<Array<Maybe<(
        { __typename?: 'ProductStatus' }
        & ProductStatusesFragment
      )>>>, orderStatuses?: Maybe<Array<Maybe<(
        { __typename?: 'OrderStatus' }
        & OrderStatusFragment
      )>>>, pickMethods?: Maybe<Array<Maybe<(
        { __typename?: 'PickMethod' }
        & PickMethodFragment
      )>>>, confirmMethods?: Maybe<Array<Maybe<(
        { __typename?: 'PickConfirmMethod' }
        & PickConfirmMethodFragment
      )>>> }
      & StockOwnerFragment
    )>>> }
  )> }
);

export type StockOwnerCategoriesQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type StockOwnerCategoriesQuery = (
  { __typename?: 'Query' }
  & { stockOwnerById?: Maybe<(
    { __typename?: 'StockOwner' }
    & { categories?: Maybe<Array<Maybe<(
      { __typename?: 'CategoryDefinition' }
      & Pick<CategoryDefinition, 'code' | 'description'>
    )>>> }
  )> }
);

export type StockOwnerProductStatusesQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type StockOwnerProductStatusesQuery = (
  { __typename?: 'Query' }
  & { stockOwnerById?: Maybe<(
    { __typename?: 'StockOwner' }
    & { productStatuses?: Maybe<Array<Maybe<(
      { __typename?: 'ProductStatus' }
      & ProductStatusesFragment
    )>>> }
  )> }
);

export type StockOwnerPickMethodsQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type StockOwnerPickMethodsQuery = (
  { __typename?: 'Query' }
  & { stockOwnerById?: Maybe<(
    { __typename?: 'StockOwner' }
    & { pickMethods?: Maybe<Array<Maybe<(
      { __typename?: 'PickMethod' }
      & Pick<PickMethod, 'id' | 'name'>
    )>>> }
  )> }
);

export type LinkedStockOwnersQueryVariables = Exact<{ [key: string]: never; }>;


export type LinkedStockOwnersQuery = (
  { __typename?: 'Query' }
  & { stockOwners?: Maybe<(
    { __typename?: 'StockOwnersConnection' }
    & { nodes?: Maybe<Array<Maybe<(
      { __typename?: 'StockOwner' }
      & Pick<StockOwner, 'id' | 'code'>
    )>>> }
  )> }
);

export type SelectStockOwnersQueryVariables = Exact<{ [key: string]: never; }>;


export type SelectStockOwnersQuery = (
  { __typename?: 'Query' }
  & { stockOwners?: Maybe<(
    { __typename?: 'StockOwnersConnection' }
    & { nodes?: Maybe<Array<Maybe<(
      { __typename?: 'StockOwner' }
      & Pick<StockOwner, 'id' | 'code' | 'name'>
    )>>> }
  )> }
);

export type StockOwnerPaginatedQueryVariables = Exact<{
  filterInput?: Maybe<StockOwnerFilterInput>;
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
}>;


export type StockOwnerPaginatedQuery = (
  { __typename?: 'Query' }
  & { stockOwners?: Maybe<(
    { __typename?: 'StockOwnersConnection' }
    & Pick<StockOwnersConnection, 'totalCount'>
    & { pageInfo: (
      { __typename?: 'PageInfo' }
      & Pick<PageInfo, 'endCursor' | 'startCursor' | 'hasNextPage' | 'hasPreviousPage'>
    ), nodes?: Maybe<Array<Maybe<(
      { __typename?: 'StockOwner' }
      & Pick<StockOwner, 'id' | 'code' | 'name' | 'status'>
    )>>> }
  )> }
);

export type StockOwnerByIdQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type StockOwnerByIdQuery = (
  { __typename?: 'Query' }
  & { stockOwnerById?: Maybe<(
    { __typename?: 'StockOwner' }
    & { linkedStockOwners?: Maybe<Array<Maybe<(
      { __typename?: 'StockOwnerLink' }
      & { child?: Maybe<(
        { __typename?: 'StockOwner' }
        & Pick<StockOwner, 'id' | 'code'>
      )> }
    )>>>, address?: Maybe<(
      { __typename?: 'Address' }
      & AddressFragment
    )>, categories?: Maybe<Array<Maybe<(
      { __typename?: 'CategoryDefinition' }
      & CategoryFragment
    )>>>, contact?: Maybe<(
      { __typename?: 'Contact' }
      & ContactFragment
    )>, productStatuses?: Maybe<Array<Maybe<(
      { __typename?: 'ProductStatus' }
      & ProductStatusesFragment
    )>>>, orderStatuses?: Maybe<Array<Maybe<(
      { __typename?: 'OrderStatus' }
      & OrderStatusFragment
    )>>>, pickMethods?: Maybe<Array<Maybe<(
      { __typename?: 'PickMethod' }
      & PickMethodFragment
    )>>>, confirmMethods?: Maybe<Array<Maybe<(
      { __typename?: 'PickConfirmMethod' }
      & PickConfirmMethodFragment
    )>>> }
    & StockOwnerFragment
  )> }
);

export type StorageTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type StorageTypesQuery = (
  { __typename?: 'Query' }
  & { storageTypes?: Maybe<(
    { __typename?: 'StorageTypesConnection' }
    & { nodes?: Maybe<Array<Maybe<(
      { __typename?: 'StorageType' }
      & StorageTypeFragment
    )>>> }
  )> }
);

export type StorageTypesPaginatedQueryVariables = Exact<{
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
}>;


export type StorageTypesPaginatedQuery = (
  { __typename?: 'Query' }
  & { storageTypes?: Maybe<(
    { __typename?: 'StorageTypesConnection' }
    & Pick<StorageTypesConnection, 'totalCount'>
    & { pageInfo: (
      { __typename?: 'PageInfo' }
      & Pick<PageInfo, 'hasNextPage' | 'startCursor' | 'endCursor'>
    ), nodes?: Maybe<Array<Maybe<(
      { __typename?: 'StorageType' }
      & StorageTypeFragment
    )>>> }
  )> }
);

export type SuppliersQueryVariables = Exact<{
  filterInput?: Maybe<SupplierFilterInput>;
}>;


export type SuppliersQuery = (
  { __typename?: 'Query' }
  & { suppliers?: Maybe<(
    { __typename?: 'SuppliersConnection' }
    & { nodes?: Maybe<Array<Maybe<(
      { __typename?: 'Supplier' }
      & { address: (
        { __typename?: 'Address' }
        & AddressFragment
      ) }
      & SupplierFragment
    )>>> }
  )> }
);

export type SelectSuppliersQueryVariables = Exact<{
  filterInput?: Maybe<SupplierFilterInput>;
}>;


export type SelectSuppliersQuery = (
  { __typename?: 'Query' }
  & { suppliers?: Maybe<(
    { __typename?: 'SuppliersConnection' }
    & { nodes?: Maybe<Array<Maybe<(
      { __typename?: 'Supplier' }
      & Pick<Supplier, 'id' | 'code' | 'name'>
    )>>> }
  )> }
);

export type SupplierByIdQueryVariables = Exact<{
  id: Scalars['Int'];
  userContext?: Maybe<UserContextInput>;
}>;


export type SupplierByIdQuery = (
  { __typename?: 'Query' }
  & { supplierById?: Maybe<(
    { __typename?: 'Supplier' }
    & { address: (
      { __typename?: 'Address' }
      & AddressFragment
    ) }
    & SupplierFragment
  )> }
);

export type SuppliersPaginatedQueryVariables = Exact<{
  filterInput?: Maybe<SupplierFilterInput>;
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  userContext?: Maybe<UserContextInput>;
}>;


export type SuppliersPaginatedQuery = (
  { __typename?: 'Query' }
  & { suppliers?: Maybe<(
    { __typename?: 'SuppliersConnection' }
    & Pick<SuppliersConnection, 'totalCount'>
    & { pageInfo: (
      { __typename?: 'PageInfo' }
      & Pick<PageInfo, 'endCursor' | 'startCursor' | 'hasNextPage' | 'hasPreviousPage'>
    ), nodes?: Maybe<Array<Maybe<(
      { __typename?: 'Supplier' }
      & Pick<Supplier, 'id' | 'code' | 'name'>
    )>>> }
  )> }
);

export type CurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserQuery = (
  { __typename?: 'Query' }
  & { currentUser?: Maybe<(
    { __typename: 'WMSUser' }
    & CurrentUserFragment
    & UserMenusFragment
  ) | (
    { __typename: 'DatabaseError' }
    & Pick<DatabaseError, 'message'>
    & { DBErrorId: DatabaseError['id'] }
  ) | (
    { __typename: 'ValidationError' }
    & Pick<ValidationError, 'field' | 'messages'>
    & { ValidationErrorId: ValidationError['id'] }
  )> }
);

export type UsersQueryVariables = Exact<{
  filterInput?: Maybe<WmsUserFilterInput>;
}>;


export type UsersQuery = (
  { __typename?: 'Query' }
  & { users?: Maybe<(
    { __typename?: 'UsersConnection' }
    & { nodes?: Maybe<Array<Maybe<(
      { __typename: 'WMSUser' }
      & UserFragment
    ) | { __typename: 'DatabaseError' } | { __typename: 'ValidationError' }>>> }
  )> }
);

export type UserByIdQueryVariables = Exact<{
  id?: Maybe<Scalars['String']>;
}>;


export type UserByIdQuery = (
  { __typename?: 'Query' }
  & { userById?: Maybe<(
    { __typename: 'WMSUser' }
    & { userPermissions?: Maybe<Array<Maybe<(
      { __typename?: 'UserPermission' }
      & UserPermissionFragment
    )>>>, userMenus?: Maybe<Array<Maybe<(
      { __typename?: 'MenuEntry' }
      & { screen?: Maybe<(
        { __typename?: 'Screen' }
        & ScreenFragment
      )>, parent?: Maybe<(
        { __typename?: 'MenuEntry' }
        & { screen?: Maybe<(
          { __typename?: 'Screen' }
          & ScreenFragment
        )> }
        & MenuEntryFragment
      )>, children?: Maybe<Array<Maybe<(
        { __typename?: 'MenuEntry' }
        & { screen?: Maybe<(
          { __typename?: 'Screen' }
          & ScreenFragment
        )>, children?: Maybe<Array<Maybe<(
          { __typename?: 'MenuEntry' }
          & { screen?: Maybe<(
            { __typename?: 'Screen' }
            & ScreenFragment
          )>, children?: Maybe<Array<Maybe<(
            { __typename?: 'MenuEntry' }
            & { screen?: Maybe<(
              { __typename?: 'Screen' }
              & ScreenFragment
            )>, children?: Maybe<Array<Maybe<(
              { __typename?: 'MenuEntry' }
              & { screen?: Maybe<(
                { __typename?: 'Screen' }
                & ScreenFragment
              )> }
              & MenuEntryFragment
            )>>> }
            & MenuEntryFragment
          )>>> }
          & MenuEntryFragment
        )>>> }
        & MenuEntryFragment
      )>>> }
      & MenuEntryFragment
    )>>> }
    & UserFragment
  ) | (
    { __typename: 'DatabaseError' }
    & Pick<DatabaseError, 'message'>
    & { DBErrorId: DatabaseError['id'] }
  ) | (
    { __typename: 'ValidationError' }
    & Pick<ValidationError, 'field' | 'messages'>
    & { ValidationErrorId: ValidationError['id'] }
  )> }
);

export type UserByUsernameQueryVariables = Exact<{
  username?: Maybe<Scalars['String']>;
}>;


export type UserByUsernameQuery = (
  { __typename?: 'Query' }
  & { userByUsername?: Maybe<(
    { __typename: 'WMSUser' }
    & UserFragment
  ) | { __typename: 'DatabaseError' } | { __typename: 'ValidationError' }> }
);

export type UsersPaginatedQueryVariables = Exact<{
  filterInput?: Maybe<WmsUserFilterInput>;
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
}>;


export type UsersPaginatedQuery = (
  { __typename?: 'Query' }
  & { users?: Maybe<(
    { __typename?: 'UsersConnection' }
    & Pick<UsersConnection, 'totalCount'>
    & { pageInfo: (
      { __typename?: 'PageInfo' }
      & Pick<PageInfo, 'endCursor' | 'startCursor' | 'hasNextPage' | 'hasPreviousPage'>
    ), nodes?: Maybe<Array<Maybe<(
      { __typename?: 'WMSUser' }
      & Pick<WmsUser, 'id' | 'forename' | 'surname' | 'userName'>
    ) | { __typename?: 'DatabaseError' } | { __typename?: 'ValidationError' }>>> }
  )> }
);

export type UserMenuByUserIdQueryVariables = Exact<{
  id?: Maybe<Scalars['String']>;
}>;


export type UserMenuByUserIdQuery = (
  { __typename?: 'Query' }
  & { userById?: Maybe<(
    { __typename: 'WMSUser' }
    & Pick<WmsUser, 'id'>
    & { userMenus?: Maybe<Array<Maybe<(
      { __typename?: 'MenuEntry' }
      & { screen?: Maybe<(
        { __typename?: 'Screen' }
        & ScreenFragment
      )>, parent?: Maybe<(
        { __typename?: 'MenuEntry' }
        & { screen?: Maybe<(
          { __typename?: 'Screen' }
          & ScreenFragment
        )> }
        & MenuEntryFragment
      )>, children?: Maybe<Array<Maybe<(
        { __typename?: 'MenuEntry' }
        & { screen?: Maybe<(
          { __typename?: 'Screen' }
          & ScreenFragment
        )>, children?: Maybe<Array<Maybe<(
          { __typename?: 'MenuEntry' }
          & { screen?: Maybe<(
            { __typename?: 'Screen' }
            & ScreenFragment
          )>, children?: Maybe<Array<Maybe<(
            { __typename?: 'MenuEntry' }
            & { screen?: Maybe<(
              { __typename?: 'Screen' }
              & ScreenFragment
            )>, children?: Maybe<Array<Maybe<(
              { __typename?: 'MenuEntry' }
              & { screen?: Maybe<(
                { __typename?: 'Screen' }
                & ScreenFragment
              )> }
              & MenuEntryFragment
            )>>> }
            & MenuEntryFragment
          )>>> }
          & MenuEntryFragment
        )>>> }
        & MenuEntryFragment
      )>>> }
      & MenuEntryFragment
    )>>> }
  ) | (
    { __typename: 'DatabaseError' }
    & Pick<DatabaseError, 'message'>
    & { DBErrorId: DatabaseError['id'] }
  ) | (
    { __typename: 'ValidationError' }
    & Pick<ValidationError, 'field' | 'messages'>
    & { ValidationErrorId: ValidationError['id'] }
  )> }
);

export type SetPasswordForUserMutationVariables = Exact<{
  id?: Maybe<Scalars['String']>;
  newPassword?: Maybe<Scalars['String']>;
}>;


export type SetPasswordForUserMutation = (
  { __typename?: 'Mutation' }
  & { setPasswordForUser?: Maybe<(
    { __typename?: 'WMSUser' }
    & Pick<WmsUser, 'userName'>
  ) | (
    { __typename?: 'DatabaseError' }
    & Pick<DatabaseError, 'id' | 'message'>
  ) | (
    { __typename?: 'ValidationError' }
    & Pick<ValidationError, 'id' | 'messages'>
  )> }
);

export type UserPermissionsQueryVariables = Exact<{
  filterInput?: Maybe<UserPermissionFilterInput>;
}>;


export type UserPermissionsQuery = (
  { __typename?: 'Query' }
  & { userPermissions?: Maybe<(
    { __typename?: 'UserPermissionsConnection' }
    & { nodes?: Maybe<Array<Maybe<(
      { __typename?: 'UserPermission' }
      & UserPermissionFragment
    )>>> }
  )> }
);

export type UserPermissionQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type UserPermissionQuery = (
  { __typename?: 'Query' }
  & { userPermission?: Maybe<(
    { __typename?: 'UserPermission' }
    & UserPermissionFragment
  )> }
);

export type WarehouseByIdQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type WarehouseByIdQuery = (
  { __typename?: 'Query' }
  & { warehouseById?: Maybe<(
    { __typename?: 'Warehouse' }
    & { address: (
      { __typename?: 'Address' }
      & AddressFragment
    ) }
    & WarehouseFragment
  )> }
);

export type WarehouseByCodeQueryVariables = Exact<{
  code: Scalars['String'];
}>;


export type WarehouseByCodeQuery = (
  { __typename?: 'Query' }
  & { warehouseByCode?: Maybe<(
    { __typename?: 'Warehouse' }
    & { address: (
      { __typename?: 'Address' }
      & AddressFragment
    ) }
    & WarehouseFragment
  )> }
);

export type WarehousesQueryVariables = Exact<{
  filterInput?: Maybe<WarehouseFilterInput>;
}>;


export type WarehousesQuery = (
  { __typename?: 'Query' }
  & { warehouses?: Maybe<(
    { __typename?: 'WarehousesConnection' }
    & Pick<WarehousesConnection, 'totalCount'>
    & { pageInfo: (
      { __typename?: 'PageInfo' }
      & Pick<PageInfo, 'endCursor' | 'startCursor' | 'hasNextPage' | 'hasPreviousPage'>
    ), nodes?: Maybe<Array<Maybe<(
      { __typename?: 'Warehouse' }
      & { address: (
        { __typename?: 'Address' }
        & AddressFragment
      ) }
      & WarehouseFragment
    )>>> }
  )> }
);

export type WarehousesPaginatedQueryVariables = Exact<{
  filterInput?: Maybe<WarehouseFilterInput>;
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
}>;


export type WarehousesPaginatedQuery = (
  { __typename?: 'Query' }
  & { warehouses?: Maybe<(
    { __typename?: 'WarehousesConnection' }
    & Pick<WarehousesConnection, 'totalCount'>
    & { pageInfo: (
      { __typename?: 'PageInfo' }
      & Pick<PageInfo, 'endCursor' | 'startCursor' | 'hasNextPage' | 'hasPreviousPage'>
    ), nodes?: Maybe<Array<Maybe<(
      { __typename?: 'Warehouse' }
      & Pick<Warehouse, 'id' | 'code' | 'warehouseName' | 'companyName'>
    )>>> }
  )> }
);

export type SelectWarehousesQueryVariables = Exact<{ [key: string]: never; }>;


export type SelectWarehousesQuery = (
  { __typename?: 'Query' }
  & { warehouses?: Maybe<(
    { __typename?: 'WarehousesConnection' }
    & { nodes?: Maybe<Array<Maybe<(
      { __typename?: 'Warehouse' }
      & Pick<Warehouse, 'id' | 'code' | 'warehouseName'>
    )>>> }
  )> }
);

export type WarehouseZonesQueryVariables = Exact<{
  filterInput?: Maybe<WarehouseZoneFilterInput>;
  userContext?: Maybe<UserContextInput>;
}>;


export type WarehouseZonesQuery = (
  { __typename?: 'Query' }
  & { warehouseZones?: Maybe<(
    { __typename?: 'WarehouseZonesConnection' }
    & { nodes?: Maybe<Array<Maybe<(
      { __typename?: 'WarehouseZone' }
      & Pick<WarehouseZone, 'zoneType'>
      & WarehouseZoneFragment
    )>>> }
  )> }
);

export type WarehouseZonesPaginatedQueryVariables = Exact<{
  filterInput?: Maybe<WarehouseZoneFilterInput>;
  userContext?: Maybe<UserContextInput>;
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
}>;


export type WarehouseZonesPaginatedQuery = (
  { __typename?: 'Query' }
  & { warehouseZones?: Maybe<(
    { __typename?: 'WarehouseZonesConnection' }
    & Pick<WarehouseZonesConnection, 'totalCount'>
    & { pageInfo: (
      { __typename?: 'PageInfo' }
      & Pick<PageInfo, 'hasNextPage' | 'startCursor' | 'endCursor'>
    ), nodes?: Maybe<Array<Maybe<(
      { __typename?: 'WarehouseZone' }
      & Pick<WarehouseZone, 'zoneType'>
      & WarehouseZoneFragment
    )>>> }
  )> }
);

export type WarehouseZoneByIdQueryVariables = Exact<{
  id: Scalars['Int'];
  userContext?: Maybe<UserContextInput>;
}>;


export type WarehouseZoneByIdQuery = (
  { __typename?: 'Query' }
  & { warehouseZone?: Maybe<(
    { __typename?: 'WarehouseZone' }
    & Pick<WarehouseZone, 'zoneType'>
    & WarehouseZoneFragment
  )> }
);

export type ZoneTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type ZoneTypesQuery = (
  { __typename?: 'Query' }
  & { zoneTypes?: Maybe<Array<Maybe<(
    { __typename?: 'ZoneType' }
    & ZoneTypeFragment
  )>>> }
);

export const ActivityFragmentDoc = gql`
    fragment activity on Activity {
  id
  code
  name
}
    `;
export const AddressFragmentDoc = gql`
    fragment address on Address {
  city
  country
  county
  postCode
  street1
  street2
}
    `;
export const AuditLogFragmentDoc = gql`
    fragment auditLog on AuditEntry {
  id
  attributeId
  singles
  packs
  status
  packType
  fromLocationId
  fromLocation {
    id
    code
  }
  toLocationId
  toLocation {
    id
    code
  }
  attributes {
    id
    ... on StockAttributes {
      id
      batch
      batchInfo
      bestBeforeDate
      budgetHolder
      catchWeight
      GRN
      killDate
      PONumber
      product {
        code
        description
      }
      productId
      productionDate
      sellByDate
      serialNumber
      slaughterCode
    }
    ... on IWMSAttributes {
      id
    }
  }
  code
  eventTime
  message
  metadata
  stockOwner {
    code
  }
  stockOwnerId
  user {
    userName
  }
  userId
  warehouse {
    code
  }
  warehouseId
}
    `;
export const BudgetHolderFragmentDoc = gql`
    fragment budgetHolder on BudgetHolder {
  id
  code
  description
  status
}
    `;
export const BudgetFragmentDoc = gql`
    fragment budget on DestinationBudget {
  id
  maxSpend
  spent
  startDate
}
    `;
export const CarrierFragmentDoc = gql`
    fragment carrier on Carrier {
  id
  code
  captureDelNo
  defDespatchLane
  defService
  module
  name
  requireService
  telephone
}
    `;
export const CarrierAccountFragmentDoc = gql`
    fragment carrierAccount on CarrierAccount {
  id
  account
  allowedServices
  description
  configuration {
    id
    setting
    value
  }
}
    `;
export const CarrierServiceFragmentDoc = gql`
    fragment carrierService on CarrierService {
  code
  collection
  description
  extraBoxInfo
  id
  localCollect
  maxHeight
  maxLength
  maxWeight
  maxWidth
  nextDay
  notifyEmail
  notifySMS
  recordDelivery
  references
  saturday
  signReq
  sunday
  trackingReq
}
    `;
export const CategoryFragmentDoc = gql`
    fragment category on CategoryDefinition {
  id
  code
  description
}
    `;
export const CodeFragmentDoc = gql`
    fragment code on UDCode {
  id
  code
  codeType
  description
  longDescription
}
    `;
export const CodeDefinitionFragmentDoc = gql`
    fragment codeDefinition on CodeDefinition {
  id
  name
  description
}
    `;
export const PresetForTableFragmentDoc = gql`
    fragment presetForTable on TablePreset {
  __typename
  id
  table
  title
  userId
  columns {
    id
    displayName
    fieldName
    columnType
    isVisible
    order
    presetId
  }
}
    `;
export const ContactFragmentDoc = gql`
    fragment contact on Contact {
  email
  fax
  name
  telephone
}
    `;
export const DestinationFragmentDoc = gql`
    fragment destination on Destination {
  area
  ASNMethod
  ASNOnDespatch
  budgetholder
  captureSerialOnDesp
  category
  code
  custStkCodeOnDespNotes
  defDespLane
  defOrderPri
  defOrderType
  defRoute
  defSpecIns
  despMethod
  despNoteFormat
  facility
  FTPAcc
  id
  masterAcc
  name
  noDespNotes
  orderDay
  orderFreq
  owner {
    id
    code
  }
  palletMethod
  pickLocation
  printBoxLbls
  printBoxNotes
  printNotesDelayDesp
  reqManifest
  salesman
  suppressBackOrdClose
  transitTime
  usePalletMethod
  VATNo
  depot
  masterHub
  subHub
  status
  GLN
  customsId
  defDelGroup
  minPickValue
  suppressBackOrdClose
  noPickConsolidation
}
    `;
export const DestinationCodeFragmentDoc = gql`
    fragment destinationCode on DestinationCode {
  id
  name
  description
}
    `;
export const GoodReceiptAttributesFragmentDoc = gql`
    fragment GoodReceiptAttributes on StockAttributes {
  id
  productId
  product {
    id
    code
    description
    require {
      batch
      batchInfo
      bestBefore
      budgetHolder
      expiry
      killDte
      packType
      productionDte
      serial
      serials
      slaughterCode
      status
      weight
    }
  }
  batch
  batchInfo
  serialNumber
  slaughterCode
  sellByDate
  killDate
  PONumber
  budgetHolder
  catchWeight
  bestBeforeDate
  productionDate
}
    `;
export const BookedFragmentDoc = gql`
    fragment booked on GoodsBookLine {
  id
  purchaseOrder
  purchaseOrderLine
  productStatus
  quantityExpected
  supplierId
  supplier {
    code
  }
  packType
  LPN
  supplier {
    code
  }
  attributeId
  attributes {
    ...GoodReceiptAttributes
  }
}
    ${GoodReceiptAttributesFragmentDoc}`;
export const ExtraFragmentDoc = gql`
    fragment extra on GoodsReceipt_ExtraData {
  type
  containerNo
  containerType
  condition
  sealNo
  carrier
  freightCost
  vehicle
  trailer
  driver
  notes
  expected
  unLoadingTime
  unLoaders
  assignedDock
  alternativeRef
}
    `;
export const ReceivedFragmentDoc = gql`
    fragment received on GoodsReceiptLine {
  id
  productStatus
  purchaseOrder
  purchaseOrderLine
  supplier {
    code
  }
  packType
  licencePlate {
    LPN
    lPTypeId
    LPType {
      code
    }
  }
  quantityReceived
  attributeId
  attributes {
    ...GoodReceiptAttributes
  }
}
    ${GoodReceiptAttributesFragmentDoc}`;
export const HandlingTypeFragmentDoc = gql`
    fragment handlingType on HandlingType {
  id
  code
  description
}
    `;
export const StorageTypeFragmentDoc = gql`
    fragment storageType on StorageType {
  id
  code
  description
  MHEs {
    materialHandlingEquipment {
      id
      code
    }
  }
}
    `;
export const LocationFragmentDoc = gql`
    fragment location on Location {
  id
  aisle
  attributes
  beam
  beamSequence
  checkCode
  code
  countZone
  dimensions {
    depth
    height
    width
    volume
  }
  elevation
  maxWeight
  pickZone
  physicalCharacteristics
  processCharacteristics
  status
  storageType {
    ...storageType
  }
  temperatureType
  tier
  zone
}
    ${StorageTypeFragmentDoc}`;
export const MaxWeeklySpendFragmentDoc = gql`
    fragment maxWeeklySpend on MaxWeeklySpend {
  id
  name
}
    `;
export const MheFragmentDoc = gql`
    fragment mhe on MaterialHandlingEquipment {
  id
  code
  class
  description
  heightLimit
  maximumWeight
  width
}
    `;
export const OrderEntryFragmentDoc = gql`
    fragment orderEntry on OrderEntry {
  id
  orderNumber
  priority
  soCustomerRef
}
    `;
export const OrderStatusFragmentDoc = gql`
    fragment orderStatus on OrderStatus {
  id
  code
  description
  purpose
}
    `;
export const OrderTypeFragmentDoc = gql`
    fragment orderType on OrderType {
  id
  name
}
    `;
export const PoFormatFragmentDoc = gql`
    fragment poFormat on POFormat {
  id
  name
}
    `;
export const PoTransmissionMethodFragmentDoc = gql`
    fragment poTransmissionMethod on POTransmissionMethod {
  id
  name
}
    `;
export const PickfaceFragmentDoc = gql`
    fragment pickface on ProductPickface {
  id
  budhol
  location
  maxFaceQty
  pickZone
  replenMulti
  replenTriggr
  warehouse
}
    `;
export const ProductFragmentDoc = gql`
    fragment product on Product {
  id
  code
  altCode
  gTIN
  substitute
  linkCode
  description
  longDesc
  defGRStatus
  SKUType
  type
  INCICode
  manufacturerCode
  StorageType
  rotation
  facilityCat
  defBudhol
  defWH
  defHandType
  defPackType
  depCode
  lifeCycleStatus
  rank
  uNCode
  bandQty
  minPShlfLife
  minRShlfLife
  totShlfLife
  packValidateBatch
  capturePackType
  pickPartPalletsAsFull
  pickSingles
  pickDefId
  require {
    arrivalTemp
    batch
    batchInfo
    bestBefore
    budgetHolder
    cartonLP
    expiry
    handlingType
    killDte
    originCntry
    packType
    palletLP
    productionDte
    serial
    serials
    slaughterCode
    status
    weight
  }
  suppliers {
    id
    active
    supplierId
    warehouseId
    warehouse {
      code
      warehouseName
    }
    supplier {
      code
      name
    }
  }
  components {
    id
    childId
    qty
    parent {
      code
    }
    child {
      code
      description
    }
  }
}
    `;
export const DocumentFragmentDoc = gql`
    fragment document on ProductDocument {
  id
  name
  type
  uploadBy
  uploaded
  usage
}
    `;
export const LicencePlateFragmentDoc = gql`
    fragment licencePlate on LPDefinition {
  id
  depth
  diagram
  handType
  height
  layerQty
  maxLayerQty
  packType
  quantity
  weight
  width
}
    `;
export const ProductStatusesFragmentDoc = gql`
    fragment productStatuses on ProductStatus {
  id
  code
  description
  adjustStock
  processStatus
  targetStatuses
}
    `;
export const ProductSupplierFragmentDoc = gql`
    fragment productSupplier on ProductSupplier {
  id
  active
  supplierId
  warehouseId
}
    `;
export const PoInstructionsFragmentDoc = gql`
    fragment poInstructions on POInstruction {
  id
  message
  type
}
    `;
export const ItemsFragmentDoc = gql`
    fragment items on PurchaseOrderItem {
  attributeId
  attributes {
    ...GoodReceiptAttributes
  }
  id
  lineNumber
  lineStatus
  LPN
  price
  productStatus
  quantityBooked
  quantityDelivered
  quantityManifested
  quantityOrdered
  quantityShipped
}
    ${GoodReceiptAttributesFragmentDoc}`;
export const PurchaseOrderFragmentDoc = gql`
    fragment purchaseOrder on PurchaseOrder {
  id
  after
  before
  billOfLading
  budgetHolder
  carrier
  carrierService
  containerNo
  crossDock
  currency
  custReferences
  entered
  enteredBy
  exportBatch
  message
  parent
  referenceNumber
  status
  type
  supplierId
  supplier {
    code
    name
  }
  instructions {
    ...poInstructions
  }
  items {
    ...items
  }
  stockOwner {
    id
    code
    name
  }
}
    ${PoInstructionsFragmentDoc}
${ItemsFragmentDoc}`;
export const RoutingFragmentDoc = gql`
    fragment routing on DestinationRoute {
  days
  destination {
    id
    code
  }
  dropNumber
  frequency
  id
  route
}
    `;
export const StockFragmentDoc = gql`
    fragment stock on Stock {
  locationId
  location {
    id
    code
  }
  productId
  product {
    id
    code
  }
  status
  licencePlateId
  licencePlate {
    id
    LPN
  }
  packType
  packs
  singles
  allocated
  attributes {
    ... on StockAttributes {
      id
      batch
      batchInfo
      bestBeforeDate
      budgetHolder
      catchWeight
      GRN
      killDate
      PONumber
      productId
      productionDate
      sellByDate
      serialNumber
      slaughterCode
    }
  }
}
    `;
export const StockOwnerFragmentDoc = gql`
    fragment stockOwner on StockOwner {
  id
  code
  name
  status
  GLN
  coldStoreID
  VATNumber
  warnMoveDifStatus
  requireBudhol
  requireProdCategories
  scanBarcodeMask
  keyedBarcodeMask
  captureSerialsOnRcpt
  requirePalletID
  printPalLblsOnRcpt
  capturePONumOnRcpt
  allocateLocOnRcpt
  closeComPoOnRcpt
  validateBatchPO
  capturePkgInfoOnRcpt
  putwayLPOnRcpt
  confirmPutawaysOnRcpt
  reqAuthOnGRClose
  defaultUnbookedRcpt
  strictPODateVal
  splitSuppTolerance
  RVPutToDefLoc
  disablePutForSpecificLocs
  mandExtraInfoOnRcpt
  captureContainerType
  F2ShowBookedProdsOnly
  autoGeneratePONumber
  allowEditInRV
  GRPrintCrtnLbls
  identicalPallets
  noBckFlushGRProduction
  matchGRWithBookNo
  RVSuppressMergePF
  spltPOLinesOnPrint
  makeGRNBudhol
  allowShortShelfLife
  allowAddProdsToPO
  captureLocOnRcpt
  captureTempOnRcpt
  printLblsGRProduction
  autoGenOrderNum
  dispOrderEntryErrs
  requirePOD
  createPickOnOrdEntry
  dontClearLineCustRef
  mandLineCustref
  warnOnShortage
  printOrdRptWithPick
  forceBudholOnEntry
  preventBatchOnEntry
  swapGenericsOnEntry
  GDPRControlled
  printOrdConfRpt
  printBoxPackLbls
  cleanOrdersOnly
  createBackOrders
  allowShortageSwap
  allowBudholSwap
  chngeTraysOnPri
  noReplenPicksOnly
  allowStatusSwap
  pickCartons
  MPNoSplitLists
  showUnpickableRpt
  createPickOnOrdEntry
  forceBudholOnEntry
  forceDepartmentOnEntry
  preventBatchOnEntry
  swapGenericsOnEntry
  allowLPSwap
  allowSBDSwap
  findCartonByWgt
  captureCarrier
  allowLocSwap
  useBOMPicking
  requireDespNote
  voicePickAssignment
  allowBatchSwap
  requireConfProduct
  requireUPICheck
  cageValidation
  suppressReplenOpt
  despNoteValidation
  RFPickAssignment
  useLoading
  produceRFManifest
  requireSealNo
  useLoadOrder
  requireTruck
  requireDriver
  loadOrder
  despLane
  maxLoaders
  adhocLoading
  loadTempCaptureStart
  loadTempCaptureEnd
  loadTempLPInterval
  captureTimeOnConfirm
  captureCheckerOnConfirm
  capturePickerOnConfirm
  defPickFailCode
  requireDespatchLane
  useEmailFromDestination
  reprntUnfinishedLists
  destockShortOnSHort
  proportionalBoxesOnConfirm
  allowLoadAnySeq
  MBPLPControl
  MBPUseSODespMeth
  noDespNotes
  previewDespNote
  BOMSToStock
  delayDespatch
  RFWarnInPckConf
  noReplenPckConf
  despNotePerList
  disablImmDesp
  allowFutureDespDates
  MBPCaptureConsNo
  optConsNo
  boxLblsPickConf
  useLPIdsPickConfirm
  authMBP
  mandContainerType
  PDFDespNotes
  useDespPrefix
  noOfDespNotes
  confWholePick
  capReasonDelayDesp
  MBPDespNoteBreakdwn
  dontCloseOrderOnLblFail
  capBoxesPerOrder
  carrierNotReq
  copyCarrToBckOrd
  printBoxLbls
  noCarrLblsPckConf
}
    `;
export const CategoryDefinitionFragmentDoc = gql`
    fragment categoryDefinition on CategoryDefinition {
  id
  code
  description
}
    `;
export const PickConfirmMethodFragmentDoc = gql`
    fragment pickConfirmMethod on PickConfirmMethod {
  id
  name
  default
  pickConfMethod
  postConfMethod
  packingMethod
  despatchMethod
  loadCloseMethod
}
    `;
export const PickMethodFragmentDoc = gql`
    fragment pickMethod on PickMethod {
  id
  default
  name
  outputMethod
  pickingMethod
  postPickMethod
  prePickMethod
}
    `;
export const SupplierFragmentDoc = gql`
    fragment supplier on Supplier {
  id
  code
  name
  currency
  fileFormat
  fileTransMeth
  leadTime
  master
  maxWeekSpend
  mustOrderLayerQty
  orderDays
}
    `;
export const UserFragmentDoc = gql`
    fragment user on WMSUser {
  id
  userName
  accessFailedCount
  culture
  email
  forename
  lockoutEnd
  normalizedUserName
  phoneNumber
  serverRole
  surname
  twoFactorEnabled
}
    `;
export const CurrentUserFragmentDoc = gql`
    fragment currentUser on WMSUser {
  id
  userName
  forename
  surname
  culture
  serverRole
}
    `;
export const ScreenFragmentDoc = gql`
    fragment screen on Screen {
  id
  action
  compareTo
  defaultTitle
  description
  screenCode
}
    `;
export const MenuEntryFragmentDoc = gql`
    fragment menuEntry on MenuEntry {
  id
  enabled
  depth
  defaultGroupId
  parentId
  parent {
    id
    enabled
    depth
    defaultGroupId
    parentId
    screen {
      ...screen
    }
    screenId
    userId
    title
    order
  }
  screenId
  userId
  title
  order
}
    ${ScreenFragmentDoc}`;
export const UserMenusFragmentDoc = gql`
    fragment userMenus on WMSUser {
  userMenus {
    ...menuEntry
    screen {
      ...screen
    }
    parent {
      ...menuEntry
      screen {
        ...screen
      }
    }
    children {
      ...menuEntry
      screen {
        ...screen
      }
      children {
        ...menuEntry
        screen {
          ...screen
        }
        children {
          ...menuEntry
          screen {
            ...screen
          }
          children {
            ...menuEntry
            screen {
              ...screen
            }
          }
        }
      }
    }
  }
}
    ${MenuEntryFragmentDoc}
${ScreenFragmentDoc}`;
export const UserPermissionFragmentDoc = gql`
    fragment userPermission on UserPermission {
  id
  permissions
  stockOwnerId
  userId
  warehouseId
  warehouse {
    code
    warehouseName
  }
  stockOwner {
    code
    name
  }
}
    `;
export const WarehouseFragmentDoc = gql`
    fragment warehouse on Warehouse {
  id
  code
  warehouseName
  companyName
  telephone
  VATNumber
  customsId
}
    `;
export const ZoneFragmentDoc = gql`
    fragment zone on Zone {
  id
  code
  description
}
    `;
export const WarehouseZoneFragmentDoc = gql`
    fragment warehouseZone on WarehouseZone {
  id
  code
  description
}
    `;
export const ZoneTypeFragmentDoc = gql`
    fragment zoneType on ZoneType {
  id
  name
}
    `;
export const CreateBudgetHolderDocument = gql`
    mutation createBudgetHolder($input: BudgetHolderInput, $userContext: UserContextInput) {
  createBudgetHolder(input: $input, userContext: $userContext) {
    ...budgetHolder
  }
}
    ${BudgetHolderFragmentDoc}`;
export type CreateBudgetHolderMutationFn = Apollo.MutationFunction<CreateBudgetHolderMutation, CreateBudgetHolderMutationVariables>;

/**
 * __useCreateBudgetHolderMutation__
 *
 * To run a mutation, you first call `useCreateBudgetHolderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBudgetHolderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBudgetHolderMutation, { data, loading, error }] = useCreateBudgetHolderMutation({
 *   variables: {
 *      input: // value for 'input'
 *      userContext: // value for 'userContext'
 *   },
 * });
 */
export function useCreateBudgetHolderMutation(baseOptions?: Apollo.MutationHookOptions<CreateBudgetHolderMutation, CreateBudgetHolderMutationVariables>) {
        return Apollo.useMutation<CreateBudgetHolderMutation, CreateBudgetHolderMutationVariables>(CreateBudgetHolderDocument, baseOptions);
      }
export type CreateBudgetHolderMutationHookResult = ReturnType<typeof useCreateBudgetHolderMutation>;
export type CreateBudgetHolderMutationResult = Apollo.MutationResult<CreateBudgetHolderMutation>;
export type CreateBudgetHolderMutationOptions = Apollo.BaseMutationOptions<CreateBudgetHolderMutation, CreateBudgetHolderMutationVariables>;
export const UpdateBudgetHolderDocument = gql`
    mutation updateBudgetHolder($id: Int!, $input: BudgetHolderUpdateInput, $userContext: UserContextInput) {
  updateBudgetHolder(id: $id, input: $input, userContext: $userContext) {
    ...budgetHolder
  }
}
    ${BudgetHolderFragmentDoc}`;
export type UpdateBudgetHolderMutationFn = Apollo.MutationFunction<UpdateBudgetHolderMutation, UpdateBudgetHolderMutationVariables>;

/**
 * __useUpdateBudgetHolderMutation__
 *
 * To run a mutation, you first call `useUpdateBudgetHolderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBudgetHolderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBudgetHolderMutation, { data, loading, error }] = useUpdateBudgetHolderMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *      userContext: // value for 'userContext'
 *   },
 * });
 */
export function useUpdateBudgetHolderMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBudgetHolderMutation, UpdateBudgetHolderMutationVariables>) {
        return Apollo.useMutation<UpdateBudgetHolderMutation, UpdateBudgetHolderMutationVariables>(UpdateBudgetHolderDocument, baseOptions);
      }
export type UpdateBudgetHolderMutationHookResult = ReturnType<typeof useUpdateBudgetHolderMutation>;
export type UpdateBudgetHolderMutationResult = Apollo.MutationResult<UpdateBudgetHolderMutation>;
export type UpdateBudgetHolderMutationOptions = Apollo.BaseMutationOptions<UpdateBudgetHolderMutation, UpdateBudgetHolderMutationVariables>;
export const DeleteBudgetHolderDocument = gql`
    mutation deleteBudgetHolder($id: Int!, $userContext: UserContextInput) {
  deleteBudgetHolder(id: $id, userContext: $userContext) {
    id
  }
}
    `;
export type DeleteBudgetHolderMutationFn = Apollo.MutationFunction<DeleteBudgetHolderMutation, DeleteBudgetHolderMutationVariables>;

/**
 * __useDeleteBudgetHolderMutation__
 *
 * To run a mutation, you first call `useDeleteBudgetHolderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteBudgetHolderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteBudgetHolderMutation, { data, loading, error }] = useDeleteBudgetHolderMutation({
 *   variables: {
 *      id: // value for 'id'
 *      userContext: // value for 'userContext'
 *   },
 * });
 */
export function useDeleteBudgetHolderMutation(baseOptions?: Apollo.MutationHookOptions<DeleteBudgetHolderMutation, DeleteBudgetHolderMutationVariables>) {
        return Apollo.useMutation<DeleteBudgetHolderMutation, DeleteBudgetHolderMutationVariables>(DeleteBudgetHolderDocument, baseOptions);
      }
export type DeleteBudgetHolderMutationHookResult = ReturnType<typeof useDeleteBudgetHolderMutation>;
export type DeleteBudgetHolderMutationResult = Apollo.MutationResult<DeleteBudgetHolderMutation>;
export type DeleteBudgetHolderMutationOptions = Apollo.BaseMutationOptions<DeleteBudgetHolderMutation, DeleteBudgetHolderMutationVariables>;
export const CreateCarrierDocument = gql`
    mutation createCarrier($input: CarrierInput, $userContext: UserContextInput) {
  createCarrier(input: $input, userContext: $userContext) {
    ...carrier
    accounts {
      ...carrierAccount
    }
    services {
      ...carrierService
    }
  }
}
    ${CarrierFragmentDoc}
${CarrierAccountFragmentDoc}
${CarrierServiceFragmentDoc}`;
export type CreateCarrierMutationFn = Apollo.MutationFunction<CreateCarrierMutation, CreateCarrierMutationVariables>;

/**
 * __useCreateCarrierMutation__
 *
 * To run a mutation, you first call `useCreateCarrierMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCarrierMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCarrierMutation, { data, loading, error }] = useCreateCarrierMutation({
 *   variables: {
 *      input: // value for 'input'
 *      userContext: // value for 'userContext'
 *   },
 * });
 */
export function useCreateCarrierMutation(baseOptions?: Apollo.MutationHookOptions<CreateCarrierMutation, CreateCarrierMutationVariables>) {
        return Apollo.useMutation<CreateCarrierMutation, CreateCarrierMutationVariables>(CreateCarrierDocument, baseOptions);
      }
export type CreateCarrierMutationHookResult = ReturnType<typeof useCreateCarrierMutation>;
export type CreateCarrierMutationResult = Apollo.MutationResult<CreateCarrierMutation>;
export type CreateCarrierMutationOptions = Apollo.BaseMutationOptions<CreateCarrierMutation, CreateCarrierMutationVariables>;
export const UpdateCarrierDocument = gql`
    mutation updateCarrier($id: Int!, $input: CarrierUpdateInput, $userContext: UserContextInput) {
  updateCarrier(id: $id, input: $input, userContext: $userContext) {
    ...carrier
    accounts {
      ...carrierAccount
    }
    services {
      ...carrierService
    }
  }
}
    ${CarrierFragmentDoc}
${CarrierAccountFragmentDoc}
${CarrierServiceFragmentDoc}`;
export type UpdateCarrierMutationFn = Apollo.MutationFunction<UpdateCarrierMutation, UpdateCarrierMutationVariables>;

/**
 * __useUpdateCarrierMutation__
 *
 * To run a mutation, you first call `useUpdateCarrierMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCarrierMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCarrierMutation, { data, loading, error }] = useUpdateCarrierMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *      userContext: // value for 'userContext'
 *   },
 * });
 */
export function useUpdateCarrierMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCarrierMutation, UpdateCarrierMutationVariables>) {
        return Apollo.useMutation<UpdateCarrierMutation, UpdateCarrierMutationVariables>(UpdateCarrierDocument, baseOptions);
      }
export type UpdateCarrierMutationHookResult = ReturnType<typeof useUpdateCarrierMutation>;
export type UpdateCarrierMutationResult = Apollo.MutationResult<UpdateCarrierMutation>;
export type UpdateCarrierMutationOptions = Apollo.BaseMutationOptions<UpdateCarrierMutation, UpdateCarrierMutationVariables>;
export const DeleteCarrierDocument = gql`
    mutation deleteCarrier($id: Int!, $userContext: UserContextInput) {
  deleteCarrier(id: $id, userContext: $userContext) {
    id
  }
}
    `;
export type DeleteCarrierMutationFn = Apollo.MutationFunction<DeleteCarrierMutation, DeleteCarrierMutationVariables>;

/**
 * __useDeleteCarrierMutation__
 *
 * To run a mutation, you first call `useDeleteCarrierMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCarrierMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCarrierMutation, { data, loading, error }] = useDeleteCarrierMutation({
 *   variables: {
 *      id: // value for 'id'
 *      userContext: // value for 'userContext'
 *   },
 * });
 */
export function useDeleteCarrierMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCarrierMutation, DeleteCarrierMutationVariables>) {
        return Apollo.useMutation<DeleteCarrierMutation, DeleteCarrierMutationVariables>(DeleteCarrierDocument, baseOptions);
      }
export type DeleteCarrierMutationHookResult = ReturnType<typeof useDeleteCarrierMutation>;
export type DeleteCarrierMutationResult = Apollo.MutationResult<DeleteCarrierMutation>;
export type DeleteCarrierMutationOptions = Apollo.BaseMutationOptions<DeleteCarrierMutation, DeleteCarrierMutationVariables>;
export const CreateCarrierAccountDocument = gql`
    mutation createCarrierAccount($carrierId: Int!, $input: CarrierAccountInput, $userContext: UserContextInput) {
  createCarrierAccount(
    carrierId: $carrierId
    input: $input
    userContext: $userContext
  ) {
    id
    account
  }
}
    `;
export type CreateCarrierAccountMutationFn = Apollo.MutationFunction<CreateCarrierAccountMutation, CreateCarrierAccountMutationVariables>;

/**
 * __useCreateCarrierAccountMutation__
 *
 * To run a mutation, you first call `useCreateCarrierAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCarrierAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCarrierAccountMutation, { data, loading, error }] = useCreateCarrierAccountMutation({
 *   variables: {
 *      carrierId: // value for 'carrierId'
 *      input: // value for 'input'
 *      userContext: // value for 'userContext'
 *   },
 * });
 */
export function useCreateCarrierAccountMutation(baseOptions?: Apollo.MutationHookOptions<CreateCarrierAccountMutation, CreateCarrierAccountMutationVariables>) {
        return Apollo.useMutation<CreateCarrierAccountMutation, CreateCarrierAccountMutationVariables>(CreateCarrierAccountDocument, baseOptions);
      }
export type CreateCarrierAccountMutationHookResult = ReturnType<typeof useCreateCarrierAccountMutation>;
export type CreateCarrierAccountMutationResult = Apollo.MutationResult<CreateCarrierAccountMutation>;
export type CreateCarrierAccountMutationOptions = Apollo.BaseMutationOptions<CreateCarrierAccountMutation, CreateCarrierAccountMutationVariables>;
export const UpdateCarrierAccountDocument = gql`
    mutation updateCarrierAccount($id: Int!, $carrierId: Int!, $input: CarrierAccountUpdateInput, $userContext: UserContextInput) {
  updateCarrierAccount(
    id: $id
    carrierId: $carrierId
    input: $input
    userContext: $userContext
  ) {
    id
    account
  }
}
    `;
export type UpdateCarrierAccountMutationFn = Apollo.MutationFunction<UpdateCarrierAccountMutation, UpdateCarrierAccountMutationVariables>;

/**
 * __useUpdateCarrierAccountMutation__
 *
 * To run a mutation, you first call `useUpdateCarrierAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCarrierAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCarrierAccountMutation, { data, loading, error }] = useUpdateCarrierAccountMutation({
 *   variables: {
 *      id: // value for 'id'
 *      carrierId: // value for 'carrierId'
 *      input: // value for 'input'
 *      userContext: // value for 'userContext'
 *   },
 * });
 */
export function useUpdateCarrierAccountMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCarrierAccountMutation, UpdateCarrierAccountMutationVariables>) {
        return Apollo.useMutation<UpdateCarrierAccountMutation, UpdateCarrierAccountMutationVariables>(UpdateCarrierAccountDocument, baseOptions);
      }
export type UpdateCarrierAccountMutationHookResult = ReturnType<typeof useUpdateCarrierAccountMutation>;
export type UpdateCarrierAccountMutationResult = Apollo.MutationResult<UpdateCarrierAccountMutation>;
export type UpdateCarrierAccountMutationOptions = Apollo.BaseMutationOptions<UpdateCarrierAccountMutation, UpdateCarrierAccountMutationVariables>;
export const DeleteCarrierAccountDocument = gql`
    mutation deleteCarrierAccount($id: Int!, $carrierId: Int!, $userContext: UserContextInput) {
  deleteCarrierAccount(id: $id, carrierId: $carrierId, userContext: $userContext) {
    id
    account
  }
}
    `;
export type DeleteCarrierAccountMutationFn = Apollo.MutationFunction<DeleteCarrierAccountMutation, DeleteCarrierAccountMutationVariables>;

/**
 * __useDeleteCarrierAccountMutation__
 *
 * To run a mutation, you first call `useDeleteCarrierAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCarrierAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCarrierAccountMutation, { data, loading, error }] = useDeleteCarrierAccountMutation({
 *   variables: {
 *      id: // value for 'id'
 *      carrierId: // value for 'carrierId'
 *      userContext: // value for 'userContext'
 *   },
 * });
 */
export function useDeleteCarrierAccountMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCarrierAccountMutation, DeleteCarrierAccountMutationVariables>) {
        return Apollo.useMutation<DeleteCarrierAccountMutation, DeleteCarrierAccountMutationVariables>(DeleteCarrierAccountDocument, baseOptions);
      }
export type DeleteCarrierAccountMutationHookResult = ReturnType<typeof useDeleteCarrierAccountMutation>;
export type DeleteCarrierAccountMutationResult = Apollo.MutationResult<DeleteCarrierAccountMutation>;
export type DeleteCarrierAccountMutationOptions = Apollo.BaseMutationOptions<DeleteCarrierAccountMutation, DeleteCarrierAccountMutationVariables>;
export const AddCarrierConfigDocument = gql`
    mutation addCarrierConfig($accountId: Int!, $carrierId: Int!, $config: CarrierConfigInput, $userContext: UserContextInput) {
  addCarrierConfig(
    accountId: $accountId
    carrierId: $carrierId
    config: $config
    userContext: $userContext
  ) {
    id
    setting
    value
  }
}
    `;
export type AddCarrierConfigMutationFn = Apollo.MutationFunction<AddCarrierConfigMutation, AddCarrierConfigMutationVariables>;

/**
 * __useAddCarrierConfigMutation__
 *
 * To run a mutation, you first call `useAddCarrierConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCarrierConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCarrierConfigMutation, { data, loading, error }] = useAddCarrierConfigMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      carrierId: // value for 'carrierId'
 *      config: // value for 'config'
 *      userContext: // value for 'userContext'
 *   },
 * });
 */
export function useAddCarrierConfigMutation(baseOptions?: Apollo.MutationHookOptions<AddCarrierConfigMutation, AddCarrierConfigMutationVariables>) {
        return Apollo.useMutation<AddCarrierConfigMutation, AddCarrierConfigMutationVariables>(AddCarrierConfigDocument, baseOptions);
      }
export type AddCarrierConfigMutationHookResult = ReturnType<typeof useAddCarrierConfigMutation>;
export type AddCarrierConfigMutationResult = Apollo.MutationResult<AddCarrierConfigMutation>;
export type AddCarrierConfigMutationOptions = Apollo.BaseMutationOptions<AddCarrierConfigMutation, AddCarrierConfigMutationVariables>;
export const UpdateCarrierConfigDocument = gql`
    mutation updateCarrierConfig($accountId: Int!, $carrierId: Int!, $id: Int!, $config: CarrierConfigUpdateInput, $userContext: UserContextInput) {
  updateCarrierConfig(
    accountId: $accountId
    carrierId: $carrierId
    id: $id
    input: $config
    userContext: $userContext
  ) {
    id
    setting
    value
  }
}
    `;
export type UpdateCarrierConfigMutationFn = Apollo.MutationFunction<UpdateCarrierConfigMutation, UpdateCarrierConfigMutationVariables>;

/**
 * __useUpdateCarrierConfigMutation__
 *
 * To run a mutation, you first call `useUpdateCarrierConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCarrierConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCarrierConfigMutation, { data, loading, error }] = useUpdateCarrierConfigMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      carrierId: // value for 'carrierId'
 *      id: // value for 'id'
 *      config: // value for 'config'
 *      userContext: // value for 'userContext'
 *   },
 * });
 */
export function useUpdateCarrierConfigMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCarrierConfigMutation, UpdateCarrierConfigMutationVariables>) {
        return Apollo.useMutation<UpdateCarrierConfigMutation, UpdateCarrierConfigMutationVariables>(UpdateCarrierConfigDocument, baseOptions);
      }
export type UpdateCarrierConfigMutationHookResult = ReturnType<typeof useUpdateCarrierConfigMutation>;
export type UpdateCarrierConfigMutationResult = Apollo.MutationResult<UpdateCarrierConfigMutation>;
export type UpdateCarrierConfigMutationOptions = Apollo.BaseMutationOptions<UpdateCarrierConfigMutation, UpdateCarrierConfigMutationVariables>;
export const RemoveCarrierConfigDocument = gql`
    mutation removeCarrierConfig($accountId: Int!, $carrierId: Int!, $id: Int!, $userContext: UserContextInput) {
  removeCarrierConfig(
    accountId: $accountId
    carrierId: $carrierId
    id: $id
    userContext: $userContext
  ) {
    id
    setting
    value
  }
}
    `;
export type RemoveCarrierConfigMutationFn = Apollo.MutationFunction<RemoveCarrierConfigMutation, RemoveCarrierConfigMutationVariables>;

/**
 * __useRemoveCarrierConfigMutation__
 *
 * To run a mutation, you first call `useRemoveCarrierConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveCarrierConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeCarrierConfigMutation, { data, loading, error }] = useRemoveCarrierConfigMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      carrierId: // value for 'carrierId'
 *      id: // value for 'id'
 *      userContext: // value for 'userContext'
 *   },
 * });
 */
export function useRemoveCarrierConfigMutation(baseOptions?: Apollo.MutationHookOptions<RemoveCarrierConfigMutation, RemoveCarrierConfigMutationVariables>) {
        return Apollo.useMutation<RemoveCarrierConfigMutation, RemoveCarrierConfigMutationVariables>(RemoveCarrierConfigDocument, baseOptions);
      }
export type RemoveCarrierConfigMutationHookResult = ReturnType<typeof useRemoveCarrierConfigMutation>;
export type RemoveCarrierConfigMutationResult = Apollo.MutationResult<RemoveCarrierConfigMutation>;
export type RemoveCarrierConfigMutationOptions = Apollo.BaseMutationOptions<RemoveCarrierConfigMutation, RemoveCarrierConfigMutationVariables>;
export const CreatCarrierServiceDocument = gql`
    mutation creatCarrierService($carrierId: Int!, $input: CarrierServiceInput, $userContext: UserContextInput) {
  createCarrierService(
    carrierId: $carrierId
    input: $input
    userContext: $userContext
  ) {
    id
    code
  }
}
    `;
export type CreatCarrierServiceMutationFn = Apollo.MutationFunction<CreatCarrierServiceMutation, CreatCarrierServiceMutationVariables>;

/**
 * __useCreatCarrierServiceMutation__
 *
 * To run a mutation, you first call `useCreatCarrierServiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatCarrierServiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [creatCarrierServiceMutation, { data, loading, error }] = useCreatCarrierServiceMutation({
 *   variables: {
 *      carrierId: // value for 'carrierId'
 *      input: // value for 'input'
 *      userContext: // value for 'userContext'
 *   },
 * });
 */
export function useCreatCarrierServiceMutation(baseOptions?: Apollo.MutationHookOptions<CreatCarrierServiceMutation, CreatCarrierServiceMutationVariables>) {
        return Apollo.useMutation<CreatCarrierServiceMutation, CreatCarrierServiceMutationVariables>(CreatCarrierServiceDocument, baseOptions);
      }
export type CreatCarrierServiceMutationHookResult = ReturnType<typeof useCreatCarrierServiceMutation>;
export type CreatCarrierServiceMutationResult = Apollo.MutationResult<CreatCarrierServiceMutation>;
export type CreatCarrierServiceMutationOptions = Apollo.BaseMutationOptions<CreatCarrierServiceMutation, CreatCarrierServiceMutationVariables>;
export const UpdateCarrierServiceDocument = gql`
    mutation updateCarrierService($id: Int!, $carrierId: Int!, $input: CarrierServiceUpdateInput, $userContext: UserContextInput) {
  updateCarrierService(
    carrierId: $carrierId
    id: $id
    input: $input
    userContext: $userContext
  ) {
    id
    code
  }
}
    `;
export type UpdateCarrierServiceMutationFn = Apollo.MutationFunction<UpdateCarrierServiceMutation, UpdateCarrierServiceMutationVariables>;

/**
 * __useUpdateCarrierServiceMutation__
 *
 * To run a mutation, you first call `useUpdateCarrierServiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCarrierServiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCarrierServiceMutation, { data, loading, error }] = useUpdateCarrierServiceMutation({
 *   variables: {
 *      id: // value for 'id'
 *      carrierId: // value for 'carrierId'
 *      input: // value for 'input'
 *      userContext: // value for 'userContext'
 *   },
 * });
 */
export function useUpdateCarrierServiceMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCarrierServiceMutation, UpdateCarrierServiceMutationVariables>) {
        return Apollo.useMutation<UpdateCarrierServiceMutation, UpdateCarrierServiceMutationVariables>(UpdateCarrierServiceDocument, baseOptions);
      }
export type UpdateCarrierServiceMutationHookResult = ReturnType<typeof useUpdateCarrierServiceMutation>;
export type UpdateCarrierServiceMutationResult = Apollo.MutationResult<UpdateCarrierServiceMutation>;
export type UpdateCarrierServiceMutationOptions = Apollo.BaseMutationOptions<UpdateCarrierServiceMutation, UpdateCarrierServiceMutationVariables>;
export const DeleteCarrierServiceDocument = gql`
    mutation deleteCarrierService($id: Int!, $carrierId: Int!, $userContext: UserContextInput) {
  deleteCarrierService(carrierId: $carrierId, id: $id, userContext: $userContext) {
    id
    code
  }
}
    `;
export type DeleteCarrierServiceMutationFn = Apollo.MutationFunction<DeleteCarrierServiceMutation, DeleteCarrierServiceMutationVariables>;

/**
 * __useDeleteCarrierServiceMutation__
 *
 * To run a mutation, you first call `useDeleteCarrierServiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCarrierServiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCarrierServiceMutation, { data, loading, error }] = useDeleteCarrierServiceMutation({
 *   variables: {
 *      id: // value for 'id'
 *      carrierId: // value for 'carrierId'
 *      userContext: // value for 'userContext'
 *   },
 * });
 */
export function useDeleteCarrierServiceMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCarrierServiceMutation, DeleteCarrierServiceMutationVariables>) {
        return Apollo.useMutation<DeleteCarrierServiceMutation, DeleteCarrierServiceMutationVariables>(DeleteCarrierServiceDocument, baseOptions);
      }
export type DeleteCarrierServiceMutationHookResult = ReturnType<typeof useDeleteCarrierServiceMutation>;
export type DeleteCarrierServiceMutationResult = Apollo.MutationResult<DeleteCarrierServiceMutation>;
export type DeleteCarrierServiceMutationOptions = Apollo.BaseMutationOptions<DeleteCarrierServiceMutation, DeleteCarrierServiceMutationVariables>;
export const CreateUdcDocument = gql`
    mutation createUDC($input: UDCodeInput, $userContext: UserContextInput) {
  createUDC(input: $input, userContext: $userContext) {
    ...code
  }
}
    ${CodeFragmentDoc}`;
export type CreateUdcMutationFn = Apollo.MutationFunction<CreateUdcMutation, CreateUdcMutationVariables>;

/**
 * __useCreateUdcMutation__
 *
 * To run a mutation, you first call `useCreateUdcMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUdcMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUdcMutation, { data, loading, error }] = useCreateUdcMutation({
 *   variables: {
 *      input: // value for 'input'
 *      userContext: // value for 'userContext'
 *   },
 * });
 */
export function useCreateUdcMutation(baseOptions?: Apollo.MutationHookOptions<CreateUdcMutation, CreateUdcMutationVariables>) {
        return Apollo.useMutation<CreateUdcMutation, CreateUdcMutationVariables>(CreateUdcDocument, baseOptions);
      }
export type CreateUdcMutationHookResult = ReturnType<typeof useCreateUdcMutation>;
export type CreateUdcMutationResult = Apollo.MutationResult<CreateUdcMutation>;
export type CreateUdcMutationOptions = Apollo.BaseMutationOptions<CreateUdcMutation, CreateUdcMutationVariables>;
export const UpdateUdcDocument = gql`
    mutation updateUDC($id: Int!, $input: UDCodeUpdateInput, $userContext: UserContextInput) {
  updateUDC(id: $id, input: $input, userContext: $userContext) {
    ...code
  }
}
    ${CodeFragmentDoc}`;
export type UpdateUdcMutationFn = Apollo.MutationFunction<UpdateUdcMutation, UpdateUdcMutationVariables>;

/**
 * __useUpdateUdcMutation__
 *
 * To run a mutation, you first call `useUpdateUdcMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUdcMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUdcMutation, { data, loading, error }] = useUpdateUdcMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *      userContext: // value for 'userContext'
 *   },
 * });
 */
export function useUpdateUdcMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUdcMutation, UpdateUdcMutationVariables>) {
        return Apollo.useMutation<UpdateUdcMutation, UpdateUdcMutationVariables>(UpdateUdcDocument, baseOptions);
      }
export type UpdateUdcMutationHookResult = ReturnType<typeof useUpdateUdcMutation>;
export type UpdateUdcMutationResult = Apollo.MutationResult<UpdateUdcMutation>;
export type UpdateUdcMutationOptions = Apollo.BaseMutationOptions<UpdateUdcMutation, UpdateUdcMutationVariables>;
export const DeleteUdcDocument = gql`
    mutation deleteUDC($id: Int!, $userContext: UserContextInput) {
  deleteUDC(id: $id, userContext: $userContext) {
    ...code
  }
}
    ${CodeFragmentDoc}`;
export type DeleteUdcMutationFn = Apollo.MutationFunction<DeleteUdcMutation, DeleteUdcMutationVariables>;

/**
 * __useDeleteUdcMutation__
 *
 * To run a mutation, you first call `useDeleteUdcMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUdcMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUdcMutation, { data, loading, error }] = useDeleteUdcMutation({
 *   variables: {
 *      id: // value for 'id'
 *      userContext: // value for 'userContext'
 *   },
 * });
 */
export function useDeleteUdcMutation(baseOptions?: Apollo.MutationHookOptions<DeleteUdcMutation, DeleteUdcMutationVariables>) {
        return Apollo.useMutation<DeleteUdcMutation, DeleteUdcMutationVariables>(DeleteUdcDocument, baseOptions);
      }
export type DeleteUdcMutationHookResult = ReturnType<typeof useDeleteUdcMutation>;
export type DeleteUdcMutationResult = Apollo.MutationResult<DeleteUdcMutation>;
export type DeleteUdcMutationOptions = Apollo.BaseMutationOptions<DeleteUdcMutation, DeleteUdcMutationVariables>;
export const CreatePresetDocument = gql`
    mutation createPreset($tableName: String, $preset: TablePresetInput) {
  createPreset(tableName: $tableName, preset: $preset) {
    ... on TablePreset {
      id
    }
    ... on DatabaseError {
      dbErrorId: id
      message
    }
    ... on ValidationError {
      vError: id
      field
      messages
    }
  }
}
    `;
export type CreatePresetMutationFn = Apollo.MutationFunction<CreatePresetMutation, CreatePresetMutationVariables>;

/**
 * __useCreatePresetMutation__
 *
 * To run a mutation, you first call `useCreatePresetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePresetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPresetMutation, { data, loading, error }] = useCreatePresetMutation({
 *   variables: {
 *      tableName: // value for 'tableName'
 *      preset: // value for 'preset'
 *   },
 * });
 */
export function useCreatePresetMutation(baseOptions?: Apollo.MutationHookOptions<CreatePresetMutation, CreatePresetMutationVariables>) {
        return Apollo.useMutation<CreatePresetMutation, CreatePresetMutationVariables>(CreatePresetDocument, baseOptions);
      }
export type CreatePresetMutationHookResult = ReturnType<typeof useCreatePresetMutation>;
export type CreatePresetMutationResult = Apollo.MutationResult<CreatePresetMutation>;
export type CreatePresetMutationOptions = Apollo.BaseMutationOptions<CreatePresetMutation, CreatePresetMutationVariables>;
export const UpdatePresetDocument = gql`
    mutation updatePreset($preset: TablePresetInput) {
  updatePreset(preset: $preset) {
    ... on TablePreset {
      id
    }
    ... on DatabaseError {
      dbErrorId: id
      message
    }
    ... on ValidationError {
      vError: id
      field
      messages
    }
  }
}
    `;
export type UpdatePresetMutationFn = Apollo.MutationFunction<UpdatePresetMutation, UpdatePresetMutationVariables>;

/**
 * __useUpdatePresetMutation__
 *
 * To run a mutation, you first call `useUpdatePresetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePresetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePresetMutation, { data, loading, error }] = useUpdatePresetMutation({
 *   variables: {
 *      preset: // value for 'preset'
 *   },
 * });
 */
export function useUpdatePresetMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePresetMutation, UpdatePresetMutationVariables>) {
        return Apollo.useMutation<UpdatePresetMutation, UpdatePresetMutationVariables>(UpdatePresetDocument, baseOptions);
      }
export type UpdatePresetMutationHookResult = ReturnType<typeof useUpdatePresetMutation>;
export type UpdatePresetMutationResult = Apollo.MutationResult<UpdatePresetMutation>;
export type UpdatePresetMutationOptions = Apollo.BaseMutationOptions<UpdatePresetMutation, UpdatePresetMutationVariables>;
export const DeletePresetDocument = gql`
    mutation deletePreset($id: Int!) {
  deletePreset(id: $id) {
    ... on TablePreset {
      id
    }
    ... on DatabaseError {
      dbErrorId: id
      message
    }
    ... on ValidationError {
      vError: id
      field
      messages
    }
  }
}
    `;
export type DeletePresetMutationFn = Apollo.MutationFunction<DeletePresetMutation, DeletePresetMutationVariables>;

/**
 * __useDeletePresetMutation__
 *
 * To run a mutation, you first call `useDeletePresetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePresetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePresetMutation, { data, loading, error }] = useDeletePresetMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeletePresetMutation(baseOptions?: Apollo.MutationHookOptions<DeletePresetMutation, DeletePresetMutationVariables>) {
        return Apollo.useMutation<DeletePresetMutation, DeletePresetMutationVariables>(DeletePresetDocument, baseOptions);
      }
export type DeletePresetMutationHookResult = ReturnType<typeof useDeletePresetMutation>;
export type DeletePresetMutationResult = Apollo.MutationResult<DeletePresetMutation>;
export type DeletePresetMutationOptions = Apollo.BaseMutationOptions<DeletePresetMutation, DeletePresetMutationVariables>;
export const CreateBookingGoodsReceiptDocument = gql`
    mutation createBookingGoodsReceipt($input: TGoodsReceiptInput, $userContext: UserContextInput) {
  goodsReceipt {
    createGoodsReceipt(userContext: $userContext, input: $input) {
      __typename
      ... on GoodsReceipt {
        grnId: id
        goodsReceiptNumber
      }
      ... on DatabaseError {
        id
        message
      }
      ... on ValidationError {
        id
        field
        messages
      }
    }
  }
}
    `;
export type CreateBookingGoodsReceiptMutationFn = Apollo.MutationFunction<CreateBookingGoodsReceiptMutation, CreateBookingGoodsReceiptMutationVariables>;

/**
 * __useCreateBookingGoodsReceiptMutation__
 *
 * To run a mutation, you first call `useCreateBookingGoodsReceiptMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBookingGoodsReceiptMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBookingGoodsReceiptMutation, { data, loading, error }] = useCreateBookingGoodsReceiptMutation({
 *   variables: {
 *      input: // value for 'input'
 *      userContext: // value for 'userContext'
 *   },
 * });
 */
export function useCreateBookingGoodsReceiptMutation(baseOptions?: Apollo.MutationHookOptions<CreateBookingGoodsReceiptMutation, CreateBookingGoodsReceiptMutationVariables>) {
        return Apollo.useMutation<CreateBookingGoodsReceiptMutation, CreateBookingGoodsReceiptMutationVariables>(CreateBookingGoodsReceiptDocument, baseOptions);
      }
export type CreateBookingGoodsReceiptMutationHookResult = ReturnType<typeof useCreateBookingGoodsReceiptMutation>;
export type CreateBookingGoodsReceiptMutationResult = Apollo.MutationResult<CreateBookingGoodsReceiptMutation>;
export type CreateBookingGoodsReceiptMutationOptions = Apollo.BaseMutationOptions<CreateBookingGoodsReceiptMutation, CreateBookingGoodsReceiptMutationVariables>;
export const UpdateBookingGoodsReceiptDocument = gql`
    mutation updateBookingGoodsReceipt($id: Int!, $input: TGoodsReceiptUpdateInput, $userContext: UserContextInput) {
  goodsReceipt {
    updateGoodsReceipt(id: $id, userContext: $userContext, input: $input) {
      __typename
      ... on UpdatedLines {
        headerUpdated {
          id
          customerRef
          dateReceived
          goodsReceiptNumber
          status
        }
      }
      ... on DatabaseError {
        id
        message
      }
      ... on ValidationError {
        id
        field
        messages
      }
    }
  }
}
    `;
export type UpdateBookingGoodsReceiptMutationFn = Apollo.MutationFunction<UpdateBookingGoodsReceiptMutation, UpdateBookingGoodsReceiptMutationVariables>;

/**
 * __useUpdateBookingGoodsReceiptMutation__
 *
 * To run a mutation, you first call `useUpdateBookingGoodsReceiptMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBookingGoodsReceiptMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBookingGoodsReceiptMutation, { data, loading, error }] = useUpdateBookingGoodsReceiptMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *      userContext: // value for 'userContext'
 *   },
 * });
 */
export function useUpdateBookingGoodsReceiptMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBookingGoodsReceiptMutation, UpdateBookingGoodsReceiptMutationVariables>) {
        return Apollo.useMutation<UpdateBookingGoodsReceiptMutation, UpdateBookingGoodsReceiptMutationVariables>(UpdateBookingGoodsReceiptDocument, baseOptions);
      }
export type UpdateBookingGoodsReceiptMutationHookResult = ReturnType<typeof useUpdateBookingGoodsReceiptMutation>;
export type UpdateBookingGoodsReceiptMutationResult = Apollo.MutationResult<UpdateBookingGoodsReceiptMutation>;
export type UpdateBookingGoodsReceiptMutationOptions = Apollo.BaseMutationOptions<UpdateBookingGoodsReceiptMutation, UpdateBookingGoodsReceiptMutationVariables>;
export const DeleteBookingGoodsReceiptDocument = gql`
    mutation deleteBookingGoodsReceipt($id: Int!, $userContext: UserContextInput) {
  goodsReceipt {
    deleteGoodsReceipt(id: $id, userContext: $userContext) {
      __typename
      ... on GoodsReceipt {
        grnId: id
        goodsReceiptNumber
      }
      ... on DatabaseError {
        id
        message
      }
      ... on ValidationError {
        id
        field
        messages
      }
    }
  }
}
    `;
export type DeleteBookingGoodsReceiptMutationFn = Apollo.MutationFunction<DeleteBookingGoodsReceiptMutation, DeleteBookingGoodsReceiptMutationVariables>;

/**
 * __useDeleteBookingGoodsReceiptMutation__
 *
 * To run a mutation, you first call `useDeleteBookingGoodsReceiptMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteBookingGoodsReceiptMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteBookingGoodsReceiptMutation, { data, loading, error }] = useDeleteBookingGoodsReceiptMutation({
 *   variables: {
 *      id: // value for 'id'
 *      userContext: // value for 'userContext'
 *   },
 * });
 */
export function useDeleteBookingGoodsReceiptMutation(baseOptions?: Apollo.MutationHookOptions<DeleteBookingGoodsReceiptMutation, DeleteBookingGoodsReceiptMutationVariables>) {
        return Apollo.useMutation<DeleteBookingGoodsReceiptMutation, DeleteBookingGoodsReceiptMutationVariables>(DeleteBookingGoodsReceiptDocument, baseOptions);
      }
export type DeleteBookingGoodsReceiptMutationHookResult = ReturnType<typeof useDeleteBookingGoodsReceiptMutation>;
export type DeleteBookingGoodsReceiptMutationResult = Apollo.MutationResult<DeleteBookingGoodsReceiptMutation>;
export type DeleteBookingGoodsReceiptMutationOptions = Apollo.BaseMutationOptions<DeleteBookingGoodsReceiptMutation, DeleteBookingGoodsReceiptMutationVariables>;
export const CreateDestinationDocument = gql`
    mutation createDestination($input: DestinationInput, $userContext: UserContextInput) {
  createDestination(input: $input, userContext: $userContext) {
    ...destination
    address {
      ...address
    }
    budgets {
      ...budget
    }
    contact {
      ...contact
    }
    routing {
      ...routing
    }
  }
}
    ${DestinationFragmentDoc}
${AddressFragmentDoc}
${BudgetFragmentDoc}
${ContactFragmentDoc}
${RoutingFragmentDoc}`;
export type CreateDestinationMutationFn = Apollo.MutationFunction<CreateDestinationMutation, CreateDestinationMutationVariables>;

/**
 * __useCreateDestinationMutation__
 *
 * To run a mutation, you first call `useCreateDestinationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDestinationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDestinationMutation, { data, loading, error }] = useCreateDestinationMutation({
 *   variables: {
 *      input: // value for 'input'
 *      userContext: // value for 'userContext'
 *   },
 * });
 */
export function useCreateDestinationMutation(baseOptions?: Apollo.MutationHookOptions<CreateDestinationMutation, CreateDestinationMutationVariables>) {
        return Apollo.useMutation<CreateDestinationMutation, CreateDestinationMutationVariables>(CreateDestinationDocument, baseOptions);
      }
export type CreateDestinationMutationHookResult = ReturnType<typeof useCreateDestinationMutation>;
export type CreateDestinationMutationResult = Apollo.MutationResult<CreateDestinationMutation>;
export type CreateDestinationMutationOptions = Apollo.BaseMutationOptions<CreateDestinationMutation, CreateDestinationMutationVariables>;
export const UpdateDestinationDocument = gql`
    mutation updateDestination($id: Int!, $input: DestinationUpdateInput, $userContext: UserContextInput) {
  updateDestination(id: $id, input: $input, userContext: $userContext) {
    ...destination
    address {
      ...address
    }
    budgets {
      ...budget
    }
    contact {
      ...contact
    }
    routing {
      ...routing
    }
  }
}
    ${DestinationFragmentDoc}
${AddressFragmentDoc}
${BudgetFragmentDoc}
${ContactFragmentDoc}
${RoutingFragmentDoc}`;
export type UpdateDestinationMutationFn = Apollo.MutationFunction<UpdateDestinationMutation, UpdateDestinationMutationVariables>;

/**
 * __useUpdateDestinationMutation__
 *
 * To run a mutation, you first call `useUpdateDestinationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDestinationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDestinationMutation, { data, loading, error }] = useUpdateDestinationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *      userContext: // value for 'userContext'
 *   },
 * });
 */
export function useUpdateDestinationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDestinationMutation, UpdateDestinationMutationVariables>) {
        return Apollo.useMutation<UpdateDestinationMutation, UpdateDestinationMutationVariables>(UpdateDestinationDocument, baseOptions);
      }
export type UpdateDestinationMutationHookResult = ReturnType<typeof useUpdateDestinationMutation>;
export type UpdateDestinationMutationResult = Apollo.MutationResult<UpdateDestinationMutation>;
export type UpdateDestinationMutationOptions = Apollo.BaseMutationOptions<UpdateDestinationMutation, UpdateDestinationMutationVariables>;
export const DeleteDestinationDocument = gql`
    mutation deleteDestination($id: Int!, $userContext: UserContextInput) {
  deleteDestination(id: $id, userContext: $userContext) {
    id
  }
}
    `;
export type DeleteDestinationMutationFn = Apollo.MutationFunction<DeleteDestinationMutation, DeleteDestinationMutationVariables>;

/**
 * __useDeleteDestinationMutation__
 *
 * To run a mutation, you first call `useDeleteDestinationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDestinationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDestinationMutation, { data, loading, error }] = useDeleteDestinationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      userContext: // value for 'userContext'
 *   },
 * });
 */
export function useDeleteDestinationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteDestinationMutation, DeleteDestinationMutationVariables>) {
        return Apollo.useMutation<DeleteDestinationMutation, DeleteDestinationMutationVariables>(DeleteDestinationDocument, baseOptions);
      }
export type DeleteDestinationMutationHookResult = ReturnType<typeof useDeleteDestinationMutation>;
export type DeleteDestinationMutationResult = Apollo.MutationResult<DeleteDestinationMutation>;
export type DeleteDestinationMutationOptions = Apollo.BaseMutationOptions<DeleteDestinationMutation, DeleteDestinationMutationVariables>;
export const CreateDestiantnionBudgetDocument = gql`
    mutation createDestiantnionBudget($destinationId: Int!, $input: DestinationBudgetInput, $userContext: UserContextInput) {
  createDestinationBudget(
    destinationId: $destinationId
    input: $input
    userContext: $userContext
  ) {
    id
  }
}
    `;
export type CreateDestiantnionBudgetMutationFn = Apollo.MutationFunction<CreateDestiantnionBudgetMutation, CreateDestiantnionBudgetMutationVariables>;

/**
 * __useCreateDestiantnionBudgetMutation__
 *
 * To run a mutation, you first call `useCreateDestiantnionBudgetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDestiantnionBudgetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDestiantnionBudgetMutation, { data, loading, error }] = useCreateDestiantnionBudgetMutation({
 *   variables: {
 *      destinationId: // value for 'destinationId'
 *      input: // value for 'input'
 *      userContext: // value for 'userContext'
 *   },
 * });
 */
export function useCreateDestiantnionBudgetMutation(baseOptions?: Apollo.MutationHookOptions<CreateDestiantnionBudgetMutation, CreateDestiantnionBudgetMutationVariables>) {
        return Apollo.useMutation<CreateDestiantnionBudgetMutation, CreateDestiantnionBudgetMutationVariables>(CreateDestiantnionBudgetDocument, baseOptions);
      }
export type CreateDestiantnionBudgetMutationHookResult = ReturnType<typeof useCreateDestiantnionBudgetMutation>;
export type CreateDestiantnionBudgetMutationResult = Apollo.MutationResult<CreateDestiantnionBudgetMutation>;
export type CreateDestiantnionBudgetMutationOptions = Apollo.BaseMutationOptions<CreateDestiantnionBudgetMutation, CreateDestiantnionBudgetMutationVariables>;
export const UpdateDestiantnionBudgetDocument = gql`
    mutation updateDestiantnionBudget($destinationId: Int!, $id: Int!, $input: DestinationBudgetUpdateInput, $userContext: UserContextInput) {
  updateDestinationBudget(
    destinationId: $destinationId
    id: $id
    input: $input
    userContext: $userContext
  ) {
    id
  }
}
    `;
export type UpdateDestiantnionBudgetMutationFn = Apollo.MutationFunction<UpdateDestiantnionBudgetMutation, UpdateDestiantnionBudgetMutationVariables>;

/**
 * __useUpdateDestiantnionBudgetMutation__
 *
 * To run a mutation, you first call `useUpdateDestiantnionBudgetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDestiantnionBudgetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDestiantnionBudgetMutation, { data, loading, error }] = useUpdateDestiantnionBudgetMutation({
 *   variables: {
 *      destinationId: // value for 'destinationId'
 *      id: // value for 'id'
 *      input: // value for 'input'
 *      userContext: // value for 'userContext'
 *   },
 * });
 */
export function useUpdateDestiantnionBudgetMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDestiantnionBudgetMutation, UpdateDestiantnionBudgetMutationVariables>) {
        return Apollo.useMutation<UpdateDestiantnionBudgetMutation, UpdateDestiantnionBudgetMutationVariables>(UpdateDestiantnionBudgetDocument, baseOptions);
      }
export type UpdateDestiantnionBudgetMutationHookResult = ReturnType<typeof useUpdateDestiantnionBudgetMutation>;
export type UpdateDestiantnionBudgetMutationResult = Apollo.MutationResult<UpdateDestiantnionBudgetMutation>;
export type UpdateDestiantnionBudgetMutationOptions = Apollo.BaseMutationOptions<UpdateDestiantnionBudgetMutation, UpdateDestiantnionBudgetMutationVariables>;
export const DeleteDestinationBudgetDocument = gql`
    mutation deleteDestinationBudget($destinationId: Int!, $id: Int!, $userContext: UserContextInput) {
  deleteDestinationBudget(
    destinationId: $destinationId
    id: $id
    userContext: $userContext
  ) {
    id
  }
}
    `;
export type DeleteDestinationBudgetMutationFn = Apollo.MutationFunction<DeleteDestinationBudgetMutation, DeleteDestinationBudgetMutationVariables>;

/**
 * __useDeleteDestinationBudgetMutation__
 *
 * To run a mutation, you first call `useDeleteDestinationBudgetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDestinationBudgetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDestinationBudgetMutation, { data, loading, error }] = useDeleteDestinationBudgetMutation({
 *   variables: {
 *      destinationId: // value for 'destinationId'
 *      id: // value for 'id'
 *      userContext: // value for 'userContext'
 *   },
 * });
 */
export function useDeleteDestinationBudgetMutation(baseOptions?: Apollo.MutationHookOptions<DeleteDestinationBudgetMutation, DeleteDestinationBudgetMutationVariables>) {
        return Apollo.useMutation<DeleteDestinationBudgetMutation, DeleteDestinationBudgetMutationVariables>(DeleteDestinationBudgetDocument, baseOptions);
      }
export type DeleteDestinationBudgetMutationHookResult = ReturnType<typeof useDeleteDestinationBudgetMutation>;
export type DeleteDestinationBudgetMutationResult = Apollo.MutationResult<DeleteDestinationBudgetMutation>;
export type DeleteDestinationBudgetMutationOptions = Apollo.BaseMutationOptions<DeleteDestinationBudgetMutation, DeleteDestinationBudgetMutationVariables>;
export const CreateDestinationRouteDocument = gql`
    mutation createDestinationRoute($destinationId: Int!, $input: DestinationRouteInput, $userContext: UserContextInput) {
  createDestinationRoute(
    destinationId: $destinationId
    input: $input
    userContext: $userContext
  ) {
    ...routing
  }
}
    ${RoutingFragmentDoc}`;
export type CreateDestinationRouteMutationFn = Apollo.MutationFunction<CreateDestinationRouteMutation, CreateDestinationRouteMutationVariables>;

/**
 * __useCreateDestinationRouteMutation__
 *
 * To run a mutation, you first call `useCreateDestinationRouteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDestinationRouteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDestinationRouteMutation, { data, loading, error }] = useCreateDestinationRouteMutation({
 *   variables: {
 *      destinationId: // value for 'destinationId'
 *      input: // value for 'input'
 *      userContext: // value for 'userContext'
 *   },
 * });
 */
export function useCreateDestinationRouteMutation(baseOptions?: Apollo.MutationHookOptions<CreateDestinationRouteMutation, CreateDestinationRouteMutationVariables>) {
        return Apollo.useMutation<CreateDestinationRouteMutation, CreateDestinationRouteMutationVariables>(CreateDestinationRouteDocument, baseOptions);
      }
export type CreateDestinationRouteMutationHookResult = ReturnType<typeof useCreateDestinationRouteMutation>;
export type CreateDestinationRouteMutationResult = Apollo.MutationResult<CreateDestinationRouteMutation>;
export type CreateDestinationRouteMutationOptions = Apollo.BaseMutationOptions<CreateDestinationRouteMutation, CreateDestinationRouteMutationVariables>;
export const UpdateDestinationRouteDocument = gql`
    mutation updateDestinationRoute($id: Int!, $destinationId: Int!, $input: DestinationRouteUpdateInput, $userContext: UserContextInput) {
  updateDestinationRoute(
    id: $id
    destinationId: $destinationId
    input: $input
    userContext: $userContext
  ) {
    ...routing
  }
}
    ${RoutingFragmentDoc}`;
export type UpdateDestinationRouteMutationFn = Apollo.MutationFunction<UpdateDestinationRouteMutation, UpdateDestinationRouteMutationVariables>;

/**
 * __useUpdateDestinationRouteMutation__
 *
 * To run a mutation, you first call `useUpdateDestinationRouteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDestinationRouteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDestinationRouteMutation, { data, loading, error }] = useUpdateDestinationRouteMutation({
 *   variables: {
 *      id: // value for 'id'
 *      destinationId: // value for 'destinationId'
 *      input: // value for 'input'
 *      userContext: // value for 'userContext'
 *   },
 * });
 */
export function useUpdateDestinationRouteMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDestinationRouteMutation, UpdateDestinationRouteMutationVariables>) {
        return Apollo.useMutation<UpdateDestinationRouteMutation, UpdateDestinationRouteMutationVariables>(UpdateDestinationRouteDocument, baseOptions);
      }
export type UpdateDestinationRouteMutationHookResult = ReturnType<typeof useUpdateDestinationRouteMutation>;
export type UpdateDestinationRouteMutationResult = Apollo.MutationResult<UpdateDestinationRouteMutation>;
export type UpdateDestinationRouteMutationOptions = Apollo.BaseMutationOptions<UpdateDestinationRouteMutation, UpdateDestinationRouteMutationVariables>;
export const DeleteDestinationRouteDocument = gql`
    mutation deleteDestinationRoute($id: Int!, $destinationId: Int!, $userContext: UserContextInput) {
  deleteDestinationRoute(
    id: $id
    destinationId: $destinationId
    userContext: $userContext
  ) {
    id
  }
}
    `;
export type DeleteDestinationRouteMutationFn = Apollo.MutationFunction<DeleteDestinationRouteMutation, DeleteDestinationRouteMutationVariables>;

/**
 * __useDeleteDestinationRouteMutation__
 *
 * To run a mutation, you first call `useDeleteDestinationRouteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDestinationRouteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDestinationRouteMutation, { data, loading, error }] = useDeleteDestinationRouteMutation({
 *   variables: {
 *      id: // value for 'id'
 *      destinationId: // value for 'destinationId'
 *      userContext: // value for 'userContext'
 *   },
 * });
 */
export function useDeleteDestinationRouteMutation(baseOptions?: Apollo.MutationHookOptions<DeleteDestinationRouteMutation, DeleteDestinationRouteMutationVariables>) {
        return Apollo.useMutation<DeleteDestinationRouteMutation, DeleteDestinationRouteMutationVariables>(DeleteDestinationRouteDocument, baseOptions);
      }
export type DeleteDestinationRouteMutationHookResult = ReturnType<typeof useDeleteDestinationRouteMutation>;
export type DeleteDestinationRouteMutationResult = Apollo.MutationResult<DeleteDestinationRouteMutation>;
export type DeleteDestinationRouteMutationOptions = Apollo.BaseMutationOptions<DeleteDestinationRouteMutation, DeleteDestinationRouteMutationVariables>;
export const RemoveReceiptLineDocument = gql`
    mutation removeReceiptLine($goodsReceiptId: Int!, $ids: [Int!], $userContext: UserContextInput) {
  goodsReceipt {
    removeReceiptLine(
      goodsReceiptId: $goodsReceiptId
      ids: $ids
      userContext: $userContext
    ) {
      __typename
      ... on UpdatedLines {
        bookLinesAdded {
          ...booked
        }
        bookLinesDeleted {
          ...booked
        }
        headerUpdated {
          id
          goodsReceiptNumber
        }
        receiptLinesAdded {
          ...received
        }
        receiptLinesDeleted {
          ...received
        }
      }
      ... on DatabaseError {
        id
        message
      }
      ... on ValidationError {
        id
        field
        messages
      }
    }
  }
}
    ${BookedFragmentDoc}
${ReceivedFragmentDoc}`;
export type RemoveReceiptLineMutationFn = Apollo.MutationFunction<RemoveReceiptLineMutation, RemoveReceiptLineMutationVariables>;

/**
 * __useRemoveReceiptLineMutation__
 *
 * To run a mutation, you first call `useRemoveReceiptLineMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveReceiptLineMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeReceiptLineMutation, { data, loading, error }] = useRemoveReceiptLineMutation({
 *   variables: {
 *      goodsReceiptId: // value for 'goodsReceiptId'
 *      ids: // value for 'ids'
 *      userContext: // value for 'userContext'
 *   },
 * });
 */
export function useRemoveReceiptLineMutation(baseOptions?: Apollo.MutationHookOptions<RemoveReceiptLineMutation, RemoveReceiptLineMutationVariables>) {
        return Apollo.useMutation<RemoveReceiptLineMutation, RemoveReceiptLineMutationVariables>(RemoveReceiptLineDocument, baseOptions);
      }
export type RemoveReceiptLineMutationHookResult = ReturnType<typeof useRemoveReceiptLineMutation>;
export type RemoveReceiptLineMutationResult = Apollo.MutationResult<RemoveReceiptLineMutation>;
export type RemoveReceiptLineMutationOptions = Apollo.BaseMutationOptions<RemoveReceiptLineMutation, RemoveReceiptLineMutationVariables>;
export const AddReceiptLineDocument = gql`
    mutation addReceiptLine($goodsReceiptId: Int!, $input: [GoodsReceiptLineInput], $userContext: UserContextInput) {
  goodsReceipt {
    addReceiptLine(
      goodsReceiptId: $goodsReceiptId
      input: $input
      userContext: $userContext
    ) {
      __typename
      ... on UpdatedLines {
        bookLinesAdded {
          ...booked
        }
        bookLinesDeleted {
          ...booked
        }
        headerUpdated {
          id
          goodsReceiptNumber
        }
        receiptLinesAdded {
          ...received
        }
        receiptLinesDeleted {
          ...received
        }
      }
      ... on DatabaseError {
        id
        message
      }
      ... on ValidationError {
        id
        field
        messages
      }
    }
  }
}
    ${BookedFragmentDoc}
${ReceivedFragmentDoc}`;
export type AddReceiptLineMutationFn = Apollo.MutationFunction<AddReceiptLineMutation, AddReceiptLineMutationVariables>;

/**
 * __useAddReceiptLineMutation__
 *
 * To run a mutation, you first call `useAddReceiptLineMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddReceiptLineMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addReceiptLineMutation, { data, loading, error }] = useAddReceiptLineMutation({
 *   variables: {
 *      goodsReceiptId: // value for 'goodsReceiptId'
 *      input: // value for 'input'
 *      userContext: // value for 'userContext'
 *   },
 * });
 */
export function useAddReceiptLineMutation(baseOptions?: Apollo.MutationHookOptions<AddReceiptLineMutation, AddReceiptLineMutationVariables>) {
        return Apollo.useMutation<AddReceiptLineMutation, AddReceiptLineMutationVariables>(AddReceiptLineDocument, baseOptions);
      }
export type AddReceiptLineMutationHookResult = ReturnType<typeof useAddReceiptLineMutation>;
export type AddReceiptLineMutationResult = Apollo.MutationResult<AddReceiptLineMutation>;
export type AddReceiptLineMutationOptions = Apollo.BaseMutationOptions<AddReceiptLineMutation, AddReceiptLineMutationVariables>;
export const UpdateGoodsReceiptDocument = gql`
    mutation updateGoodsReceipt($id: Int!, $input: TGoodsReceiptUpdateInput, $userContext: UserContextInput) {
  goodsReceipt {
    updateGoodsReceipt(id: $id, input: $input, userContext: $userContext) {
      __typename
      ... on UpdatedLines {
        headerUpdated {
          id
          customerRef
          dateReceived
          goodsReceiptNumber
          status
        }
      }
      ... on DatabaseError {
        id
        message
      }
      ... on ValidationError {
        id
        field
        messages
      }
    }
  }
}
    `;
export type UpdateGoodsReceiptMutationFn = Apollo.MutationFunction<UpdateGoodsReceiptMutation, UpdateGoodsReceiptMutationVariables>;

/**
 * __useUpdateGoodsReceiptMutation__
 *
 * To run a mutation, you first call `useUpdateGoodsReceiptMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGoodsReceiptMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGoodsReceiptMutation, { data, loading, error }] = useUpdateGoodsReceiptMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *      userContext: // value for 'userContext'
 *   },
 * });
 */
export function useUpdateGoodsReceiptMutation(baseOptions?: Apollo.MutationHookOptions<UpdateGoodsReceiptMutation, UpdateGoodsReceiptMutationVariables>) {
        return Apollo.useMutation<UpdateGoodsReceiptMutation, UpdateGoodsReceiptMutationVariables>(UpdateGoodsReceiptDocument, baseOptions);
      }
export type UpdateGoodsReceiptMutationHookResult = ReturnType<typeof useUpdateGoodsReceiptMutation>;
export type UpdateGoodsReceiptMutationResult = Apollo.MutationResult<UpdateGoodsReceiptMutation>;
export type UpdateGoodsReceiptMutationOptions = Apollo.BaseMutationOptions<UpdateGoodsReceiptMutation, UpdateGoodsReceiptMutationVariables>;
export const DeleteGoodsReceiptDocument = gql`
    mutation deleteGoodsReceipt($id: Int!, $userContext: UserContextInput) {
  goodsReceipt {
    deleteGoodsReceipt(id: $id, userContext: $userContext) {
      ... on GoodsReceipt {
        goodsReceiptNumber
      }
      ... on DatabaseError {
        id
        message
      }
      ... on ValidationError {
        id
        field
        messages
      }
    }
  }
}
    `;
export type DeleteGoodsReceiptMutationFn = Apollo.MutationFunction<DeleteGoodsReceiptMutation, DeleteGoodsReceiptMutationVariables>;

/**
 * __useDeleteGoodsReceiptMutation__
 *
 * To run a mutation, you first call `useDeleteGoodsReceiptMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteGoodsReceiptMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteGoodsReceiptMutation, { data, loading, error }] = useDeleteGoodsReceiptMutation({
 *   variables: {
 *      id: // value for 'id'
 *      userContext: // value for 'userContext'
 *   },
 * });
 */
export function useDeleteGoodsReceiptMutation(baseOptions?: Apollo.MutationHookOptions<DeleteGoodsReceiptMutation, DeleteGoodsReceiptMutationVariables>) {
        return Apollo.useMutation<DeleteGoodsReceiptMutation, DeleteGoodsReceiptMutationVariables>(DeleteGoodsReceiptDocument, baseOptions);
      }
export type DeleteGoodsReceiptMutationHookResult = ReturnType<typeof useDeleteGoodsReceiptMutation>;
export type DeleteGoodsReceiptMutationResult = Apollo.MutationResult<DeleteGoodsReceiptMutation>;
export type DeleteGoodsReceiptMutationOptions = Apollo.BaseMutationOptions<DeleteGoodsReceiptMutation, DeleteGoodsReceiptMutationVariables>;
export const CreateAdhocGoodsReceiptDocument = gql`
    mutation createAdhocGoodsReceipt($input: TGoodsReceiptInput, $userContext: UserContextInput) {
  goodsReceipt {
    createGoodsReceipt(userContext: $userContext, input: $input) {
      __typename
      ... on GoodsReceipt {
        grnId: id
        goodsReceiptNumber
      }
      ... on DatabaseError {
        id
        message
      }
      ... on ValidationError {
        id
        field
        messages
      }
    }
  }
}
    `;
export type CreateAdhocGoodsReceiptMutationFn = Apollo.MutationFunction<CreateAdhocGoodsReceiptMutation, CreateAdhocGoodsReceiptMutationVariables>;

/**
 * __useCreateAdhocGoodsReceiptMutation__
 *
 * To run a mutation, you first call `useCreateAdhocGoodsReceiptMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAdhocGoodsReceiptMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAdhocGoodsReceiptMutation, { data, loading, error }] = useCreateAdhocGoodsReceiptMutation({
 *   variables: {
 *      input: // value for 'input'
 *      userContext: // value for 'userContext'
 *   },
 * });
 */
export function useCreateAdhocGoodsReceiptMutation(baseOptions?: Apollo.MutationHookOptions<CreateAdhocGoodsReceiptMutation, CreateAdhocGoodsReceiptMutationVariables>) {
        return Apollo.useMutation<CreateAdhocGoodsReceiptMutation, CreateAdhocGoodsReceiptMutationVariables>(CreateAdhocGoodsReceiptDocument, baseOptions);
      }
export type CreateAdhocGoodsReceiptMutationHookResult = ReturnType<typeof useCreateAdhocGoodsReceiptMutation>;
export type CreateAdhocGoodsReceiptMutationResult = Apollo.MutationResult<CreateAdhocGoodsReceiptMutation>;
export type CreateAdhocGoodsReceiptMutationOptions = Apollo.BaseMutationOptions<CreateAdhocGoodsReceiptMutation, CreateAdhocGoodsReceiptMutationVariables>;
export const CreateHandlingTypeDocument = gql`
    mutation createHandlingType($input: HandlingTypeInput, $userContext: UserContextInput) {
  createHandlingType(input: $input, userContext: $userContext) {
    ...handlingType
    storageTypes {
      storageType {
        ...storageType
      }
    }
  }
}
    ${HandlingTypeFragmentDoc}
${StorageTypeFragmentDoc}`;
export type CreateHandlingTypeMutationFn = Apollo.MutationFunction<CreateHandlingTypeMutation, CreateHandlingTypeMutationVariables>;

/**
 * __useCreateHandlingTypeMutation__
 *
 * To run a mutation, you first call `useCreateHandlingTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateHandlingTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createHandlingTypeMutation, { data, loading, error }] = useCreateHandlingTypeMutation({
 *   variables: {
 *      input: // value for 'input'
 *      userContext: // value for 'userContext'
 *   },
 * });
 */
export function useCreateHandlingTypeMutation(baseOptions?: Apollo.MutationHookOptions<CreateHandlingTypeMutation, CreateHandlingTypeMutationVariables>) {
        return Apollo.useMutation<CreateHandlingTypeMutation, CreateHandlingTypeMutationVariables>(CreateHandlingTypeDocument, baseOptions);
      }
export type CreateHandlingTypeMutationHookResult = ReturnType<typeof useCreateHandlingTypeMutation>;
export type CreateHandlingTypeMutationResult = Apollo.MutationResult<CreateHandlingTypeMutation>;
export type CreateHandlingTypeMutationOptions = Apollo.BaseMutationOptions<CreateHandlingTypeMutation, CreateHandlingTypeMutationVariables>;
export const DeleteHandlingTypeDocument = gql`
    mutation deleteHandlingType($id: Int!, $userContext: UserContextInput) {
  deleteHandlingType(id: $id, userContext: $userContext) {
    ...handlingType
  }
}
    ${HandlingTypeFragmentDoc}`;
export type DeleteHandlingTypeMutationFn = Apollo.MutationFunction<DeleteHandlingTypeMutation, DeleteHandlingTypeMutationVariables>;

/**
 * __useDeleteHandlingTypeMutation__
 *
 * To run a mutation, you first call `useDeleteHandlingTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteHandlingTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteHandlingTypeMutation, { data, loading, error }] = useDeleteHandlingTypeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      userContext: // value for 'userContext'
 *   },
 * });
 */
export function useDeleteHandlingTypeMutation(baseOptions?: Apollo.MutationHookOptions<DeleteHandlingTypeMutation, DeleteHandlingTypeMutationVariables>) {
        return Apollo.useMutation<DeleteHandlingTypeMutation, DeleteHandlingTypeMutationVariables>(DeleteHandlingTypeDocument, baseOptions);
      }
export type DeleteHandlingTypeMutationHookResult = ReturnType<typeof useDeleteHandlingTypeMutation>;
export type DeleteHandlingTypeMutationResult = Apollo.MutationResult<DeleteHandlingTypeMutation>;
export type DeleteHandlingTypeMutationOptions = Apollo.BaseMutationOptions<DeleteHandlingTypeMutation, DeleteHandlingTypeMutationVariables>;
export const UpdateHandlingTypeDocument = gql`
    mutation updateHandlingType($id: Int!, $input: HandlingTypeUpdateInput, $userContext: UserContextInput) {
  updateHandlingType(id: $id, input: $input, userContext: $userContext) {
    ...handlingType
    storageTypes {
      storageType {
        ...storageType
      }
    }
  }
}
    ${HandlingTypeFragmentDoc}
${StorageTypeFragmentDoc}`;
export type UpdateHandlingTypeMutationFn = Apollo.MutationFunction<UpdateHandlingTypeMutation, UpdateHandlingTypeMutationVariables>;

/**
 * __useUpdateHandlingTypeMutation__
 *
 * To run a mutation, you first call `useUpdateHandlingTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateHandlingTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateHandlingTypeMutation, { data, loading, error }] = useUpdateHandlingTypeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *      userContext: // value for 'userContext'
 *   },
 * });
 */
export function useUpdateHandlingTypeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateHandlingTypeMutation, UpdateHandlingTypeMutationVariables>) {
        return Apollo.useMutation<UpdateHandlingTypeMutation, UpdateHandlingTypeMutationVariables>(UpdateHandlingTypeDocument, baseOptions);
      }
export type UpdateHandlingTypeMutationHookResult = ReturnType<typeof useUpdateHandlingTypeMutation>;
export type UpdateHandlingTypeMutationResult = Apollo.MutationResult<UpdateHandlingTypeMutation>;
export type UpdateHandlingTypeMutationOptions = Apollo.BaseMutationOptions<UpdateHandlingTypeMutation, UpdateHandlingTypeMutationVariables>;
export const AddHandlingStorageTypeDocument = gql`
    mutation addHandlingStorageType($id: Int!, $storageTypeId: Int!, $userContext: UserContextInput) {
  addHandlingStorageType(
    id: $id
    storageTypeId: $storageTypeId
    userContext: $userContext
  ) {
    handlingTypeId
    storageTypeId
  }
}
    `;
export type AddHandlingStorageTypeMutationFn = Apollo.MutationFunction<AddHandlingStorageTypeMutation, AddHandlingStorageTypeMutationVariables>;

/**
 * __useAddHandlingStorageTypeMutation__
 *
 * To run a mutation, you first call `useAddHandlingStorageTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddHandlingStorageTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addHandlingStorageTypeMutation, { data, loading, error }] = useAddHandlingStorageTypeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      storageTypeId: // value for 'storageTypeId'
 *      userContext: // value for 'userContext'
 *   },
 * });
 */
export function useAddHandlingStorageTypeMutation(baseOptions?: Apollo.MutationHookOptions<AddHandlingStorageTypeMutation, AddHandlingStorageTypeMutationVariables>) {
        return Apollo.useMutation<AddHandlingStorageTypeMutation, AddHandlingStorageTypeMutationVariables>(AddHandlingStorageTypeDocument, baseOptions);
      }
export type AddHandlingStorageTypeMutationHookResult = ReturnType<typeof useAddHandlingStorageTypeMutation>;
export type AddHandlingStorageTypeMutationResult = Apollo.MutationResult<AddHandlingStorageTypeMutation>;
export type AddHandlingStorageTypeMutationOptions = Apollo.BaseMutationOptions<AddHandlingStorageTypeMutation, AddHandlingStorageTypeMutationVariables>;
export const RemoveHandlingStorageTypeDocument = gql`
    mutation removeHandlingStorageType($id: Int!, $storageTypeId: Int!, $userContext: UserContextInput) {
  removeHandlingStorageType(
    id: $id
    storageTypeId: $storageTypeId
    userContext: $userContext
  ) {
    handlingTypeId
    storageTypeId
  }
}
    `;
export type RemoveHandlingStorageTypeMutationFn = Apollo.MutationFunction<RemoveHandlingStorageTypeMutation, RemoveHandlingStorageTypeMutationVariables>;

/**
 * __useRemoveHandlingStorageTypeMutation__
 *
 * To run a mutation, you first call `useRemoveHandlingStorageTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveHandlingStorageTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeHandlingStorageTypeMutation, { data, loading, error }] = useRemoveHandlingStorageTypeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      storageTypeId: // value for 'storageTypeId'
 *      userContext: // value for 'userContext'
 *   },
 * });
 */
export function useRemoveHandlingStorageTypeMutation(baseOptions?: Apollo.MutationHookOptions<RemoveHandlingStorageTypeMutation, RemoveHandlingStorageTypeMutationVariables>) {
        return Apollo.useMutation<RemoveHandlingStorageTypeMutation, RemoveHandlingStorageTypeMutationVariables>(RemoveHandlingStorageTypeDocument, baseOptions);
      }
export type RemoveHandlingStorageTypeMutationHookResult = ReturnType<typeof useRemoveHandlingStorageTypeMutation>;
export type RemoveHandlingStorageTypeMutationResult = Apollo.MutationResult<RemoveHandlingStorageTypeMutation>;
export type RemoveHandlingStorageTypeMutationOptions = Apollo.BaseMutationOptions<RemoveHandlingStorageTypeMutation, RemoveHandlingStorageTypeMutationVariables>;
export const AddStockOwnerLinkDocument = gql`
    mutation addStockOwnerLink($linkedStockOwnerId: Int!, $stockOwnerId: Int!) {
  addStockOwnerLink(
    linkedStockOwnerId: $linkedStockOwnerId
    stockOwnerId: $stockOwnerId
  ) {
    child {
      code
    }
  }
}
    `;
export type AddStockOwnerLinkMutationFn = Apollo.MutationFunction<AddStockOwnerLinkMutation, AddStockOwnerLinkMutationVariables>;

/**
 * __useAddStockOwnerLinkMutation__
 *
 * To run a mutation, you first call `useAddStockOwnerLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddStockOwnerLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addStockOwnerLinkMutation, { data, loading, error }] = useAddStockOwnerLinkMutation({
 *   variables: {
 *      linkedStockOwnerId: // value for 'linkedStockOwnerId'
 *      stockOwnerId: // value for 'stockOwnerId'
 *   },
 * });
 */
export function useAddStockOwnerLinkMutation(baseOptions?: Apollo.MutationHookOptions<AddStockOwnerLinkMutation, AddStockOwnerLinkMutationVariables>) {
        return Apollo.useMutation<AddStockOwnerLinkMutation, AddStockOwnerLinkMutationVariables>(AddStockOwnerLinkDocument, baseOptions);
      }
export type AddStockOwnerLinkMutationHookResult = ReturnType<typeof useAddStockOwnerLinkMutation>;
export type AddStockOwnerLinkMutationResult = Apollo.MutationResult<AddStockOwnerLinkMutation>;
export type AddStockOwnerLinkMutationOptions = Apollo.BaseMutationOptions<AddStockOwnerLinkMutation, AddStockOwnerLinkMutationVariables>;
export const RemoveStockOwnerLinkDocument = gql`
    mutation removeStockOwnerLink($linkedStockOwnerId: Int!, $stockOwnerId: Int!) {
  removeStockOwnerLink(
    linkedStockOwnerId: $linkedStockOwnerId
    stockOwnerId: $stockOwnerId
  ) {
    child {
      code
    }
  }
}
    `;
export type RemoveStockOwnerLinkMutationFn = Apollo.MutationFunction<RemoveStockOwnerLinkMutation, RemoveStockOwnerLinkMutationVariables>;

/**
 * __useRemoveStockOwnerLinkMutation__
 *
 * To run a mutation, you first call `useRemoveStockOwnerLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveStockOwnerLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeStockOwnerLinkMutation, { data, loading, error }] = useRemoveStockOwnerLinkMutation({
 *   variables: {
 *      linkedStockOwnerId: // value for 'linkedStockOwnerId'
 *      stockOwnerId: // value for 'stockOwnerId'
 *   },
 * });
 */
export function useRemoveStockOwnerLinkMutation(baseOptions?: Apollo.MutationHookOptions<RemoveStockOwnerLinkMutation, RemoveStockOwnerLinkMutationVariables>) {
        return Apollo.useMutation<RemoveStockOwnerLinkMutation, RemoveStockOwnerLinkMutationVariables>(RemoveStockOwnerLinkDocument, baseOptions);
      }
export type RemoveStockOwnerLinkMutationHookResult = ReturnType<typeof useRemoveStockOwnerLinkMutation>;
export type RemoveStockOwnerLinkMutationResult = Apollo.MutationResult<RemoveStockOwnerLinkMutation>;
export type RemoveStockOwnerLinkMutationOptions = Apollo.BaseMutationOptions<RemoveStockOwnerLinkMutation, RemoveStockOwnerLinkMutationVariables>;
export const CreateLocationDocument = gql`
    mutation createLocation($input: LocationInput, $userContext: UserContextInput) {
  createLocation(input: $input, userContext: $userContext) {
    ... on Location {
      id
    }
    ... on DatabaseError {
      DatabaseErrorId: id
      message
    }
    ... on ValidationError {
      ValidationErrorId: id
      any
      messages
      errors {
        fieldName
        message
        severity
      }
    }
  }
}
    `;
export type CreateLocationMutationFn = Apollo.MutationFunction<CreateLocationMutation, CreateLocationMutationVariables>;

/**
 * __useCreateLocationMutation__
 *
 * To run a mutation, you first call `useCreateLocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLocationMutation, { data, loading, error }] = useCreateLocationMutation({
 *   variables: {
 *      input: // value for 'input'
 *      userContext: // value for 'userContext'
 *   },
 * });
 */
export function useCreateLocationMutation(baseOptions?: Apollo.MutationHookOptions<CreateLocationMutation, CreateLocationMutationVariables>) {
        return Apollo.useMutation<CreateLocationMutation, CreateLocationMutationVariables>(CreateLocationDocument, baseOptions);
      }
export type CreateLocationMutationHookResult = ReturnType<typeof useCreateLocationMutation>;
export type CreateLocationMutationResult = Apollo.MutationResult<CreateLocationMutation>;
export type CreateLocationMutationOptions = Apollo.BaseMutationOptions<CreateLocationMutation, CreateLocationMutationVariables>;
export const UpdateLocationDocument = gql`
    mutation updateLocation($id: Int!, $input: LocationUpdateInput, $userContext: UserContextInput) {
  updateLocation(id: $id, input: $input, userContext: $userContext) {
    ... on Location {
      id
    }
    ... on DatabaseError {
      DatabaseErrorId: id
      message
    }
    ... on ValidationError {
      ValidationErrorId: id
      any
      messages
      errors {
        fieldName
        message
        severity
      }
    }
  }
}
    `;
export type UpdateLocationMutationFn = Apollo.MutationFunction<UpdateLocationMutation, UpdateLocationMutationVariables>;

/**
 * __useUpdateLocationMutation__
 *
 * To run a mutation, you first call `useUpdateLocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLocationMutation, { data, loading, error }] = useUpdateLocationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *      userContext: // value for 'userContext'
 *   },
 * });
 */
export function useUpdateLocationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLocationMutation, UpdateLocationMutationVariables>) {
        return Apollo.useMutation<UpdateLocationMutation, UpdateLocationMutationVariables>(UpdateLocationDocument, baseOptions);
      }
export type UpdateLocationMutationHookResult = ReturnType<typeof useUpdateLocationMutation>;
export type UpdateLocationMutationResult = Apollo.MutationResult<UpdateLocationMutation>;
export type UpdateLocationMutationOptions = Apollo.BaseMutationOptions<UpdateLocationMutation, UpdateLocationMutationVariables>;
export const DeleteLocationDocument = gql`
    mutation deleteLocation($id: Int!, $userContext: UserContextInput) {
  deleteLocation(id: $id, userContext: $userContext) {
    ... on Location {
      id
    }
    ... on DatabaseError {
      DatabaseErrorId: id
      message
    }
    ... on ValidationError {
      ValidationErrorId: id
      any
      messages
      errors {
        fieldName
        message
        severity
      }
    }
  }
}
    `;
export type DeleteLocationMutationFn = Apollo.MutationFunction<DeleteLocationMutation, DeleteLocationMutationVariables>;

/**
 * __useDeleteLocationMutation__
 *
 * To run a mutation, you first call `useDeleteLocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLocationMutation, { data, loading, error }] = useDeleteLocationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      userContext: // value for 'userContext'
 *   },
 * });
 */
export function useDeleteLocationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteLocationMutation, DeleteLocationMutationVariables>) {
        return Apollo.useMutation<DeleteLocationMutation, DeleteLocationMutationVariables>(DeleteLocationDocument, baseOptions);
      }
export type DeleteLocationMutationHookResult = ReturnType<typeof useDeleteLocationMutation>;
export type DeleteLocationMutationResult = Apollo.MutationResult<DeleteLocationMutation>;
export type DeleteLocationMutationOptions = Apollo.BaseMutationOptions<DeleteLocationMutation, DeleteLocationMutationVariables>;
export const UpdateLocationPatchDocument = gql`
    mutation updateLocationPatch($id: Int!, $userContext: UserContextInput, $input: [OperationOfLocationInput]) {
  updateLocationEx(id: $id, userContext: $userContext, input: $input) {
    ... on Location {
      id
    }
    ... on DatabaseError {
      DatabaseErrorId: id
      message
    }
    ... on ValidationError {
      ValidationErrorId: id
      any
      messages
      errors {
        fieldName
        message
        severity
      }
    }
  }
}
    `;
export type UpdateLocationPatchMutationFn = Apollo.MutationFunction<UpdateLocationPatchMutation, UpdateLocationPatchMutationVariables>;

/**
 * __useUpdateLocationPatchMutation__
 *
 * To run a mutation, you first call `useUpdateLocationPatchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLocationPatchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLocationPatchMutation, { data, loading, error }] = useUpdateLocationPatchMutation({
 *   variables: {
 *      id: // value for 'id'
 *      userContext: // value for 'userContext'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateLocationPatchMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLocationPatchMutation, UpdateLocationPatchMutationVariables>) {
        return Apollo.useMutation<UpdateLocationPatchMutation, UpdateLocationPatchMutationVariables>(UpdateLocationPatchDocument, baseOptions);
      }
export type UpdateLocationPatchMutationHookResult = ReturnType<typeof useUpdateLocationPatchMutation>;
export type UpdateLocationPatchMutationResult = Apollo.MutationResult<UpdateLocationPatchMutation>;
export type UpdateLocationPatchMutationOptions = Apollo.BaseMutationOptions<UpdateLocationPatchMutation, UpdateLocationPatchMutationVariables>;
export const CreateMheDocument = gql`
    mutation createMHE($input: MaterialHandlingEquipmentInput, $userContext: UserContextInput) {
  createMaterialHandlingEquipment(input: $input, userContext: $userContext) {
    ...mhe
  }
}
    ${MheFragmentDoc}`;
export type CreateMheMutationFn = Apollo.MutationFunction<CreateMheMutation, CreateMheMutationVariables>;

/**
 * __useCreateMheMutation__
 *
 * To run a mutation, you first call `useCreateMheMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMheMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMheMutation, { data, loading, error }] = useCreateMheMutation({
 *   variables: {
 *      input: // value for 'input'
 *      userContext: // value for 'userContext'
 *   },
 * });
 */
export function useCreateMheMutation(baseOptions?: Apollo.MutationHookOptions<CreateMheMutation, CreateMheMutationVariables>) {
        return Apollo.useMutation<CreateMheMutation, CreateMheMutationVariables>(CreateMheDocument, baseOptions);
      }
export type CreateMheMutationHookResult = ReturnType<typeof useCreateMheMutation>;
export type CreateMheMutationResult = Apollo.MutationResult<CreateMheMutation>;
export type CreateMheMutationOptions = Apollo.BaseMutationOptions<CreateMheMutation, CreateMheMutationVariables>;
export const UpdateMheDocument = gql`
    mutation updateMHE($id: Int!, $input: MaterialHandlingEquipmentUpdateInput, $userContext: UserContextInput) {
  updateMaterialHandlingEquipment(
    id: $id
    input: $input
    userContext: $userContext
  ) {
    ...mhe
  }
}
    ${MheFragmentDoc}`;
export type UpdateMheMutationFn = Apollo.MutationFunction<UpdateMheMutation, UpdateMheMutationVariables>;

/**
 * __useUpdateMheMutation__
 *
 * To run a mutation, you first call `useUpdateMheMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMheMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMheMutation, { data, loading, error }] = useUpdateMheMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *      userContext: // value for 'userContext'
 *   },
 * });
 */
export function useUpdateMheMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMheMutation, UpdateMheMutationVariables>) {
        return Apollo.useMutation<UpdateMheMutation, UpdateMheMutationVariables>(UpdateMheDocument, baseOptions);
      }
export type UpdateMheMutationHookResult = ReturnType<typeof useUpdateMheMutation>;
export type UpdateMheMutationResult = Apollo.MutationResult<UpdateMheMutation>;
export type UpdateMheMutationOptions = Apollo.BaseMutationOptions<UpdateMheMutation, UpdateMheMutationVariables>;
export const DeleteMheDocument = gql`
    mutation deleteMHE($id: Int!, $userContext: UserContextInput) {
  deleteMaterialHandlingEquipment(id: $id, userContext: $userContext) {
    id
  }
}
    `;
export type DeleteMheMutationFn = Apollo.MutationFunction<DeleteMheMutation, DeleteMheMutationVariables>;

/**
 * __useDeleteMheMutation__
 *
 * To run a mutation, you first call `useDeleteMheMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMheMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMheMutation, { data, loading, error }] = useDeleteMheMutation({
 *   variables: {
 *      id: // value for 'id'
 *      userContext: // value for 'userContext'
 *   },
 * });
 */
export function useDeleteMheMutation(baseOptions?: Apollo.MutationHookOptions<DeleteMheMutation, DeleteMheMutationVariables>) {
        return Apollo.useMutation<DeleteMheMutation, DeleteMheMutationVariables>(DeleteMheDocument, baseOptions);
      }
export type DeleteMheMutationHookResult = ReturnType<typeof useDeleteMheMutation>;
export type DeleteMheMutationResult = Apollo.MutationResult<DeleteMheMutation>;
export type DeleteMheMutationOptions = Apollo.BaseMutationOptions<DeleteMheMutation, DeleteMheMutationVariables>;
export const CreateOrderEntryDocument = gql`
    mutation createOrderEntry($input: CreateOrderEntryInput!) {
  createOrderEntry(input: $input) @client {
    ...orderEntry
    destinationCode {
      ...destinationCode
    }
    budgetHolder {
      ...budgetHolder
    }
    orderType {
      ...orderType
    }
  }
}
    ${OrderEntryFragmentDoc}
${DestinationCodeFragmentDoc}
${BudgetHolderFragmentDoc}
${OrderTypeFragmentDoc}`;
export type CreateOrderEntryMutationFn = Apollo.MutationFunction<CreateOrderEntryMutation, CreateOrderEntryMutationVariables>;

/**
 * __useCreateOrderEntryMutation__
 *
 * To run a mutation, you first call `useCreateOrderEntryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrderEntryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrderEntryMutation, { data, loading, error }] = useCreateOrderEntryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOrderEntryMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrderEntryMutation, CreateOrderEntryMutationVariables>) {
        return Apollo.useMutation<CreateOrderEntryMutation, CreateOrderEntryMutationVariables>(CreateOrderEntryDocument, baseOptions);
      }
export type CreateOrderEntryMutationHookResult = ReturnType<typeof useCreateOrderEntryMutation>;
export type CreateOrderEntryMutationResult = Apollo.MutationResult<CreateOrderEntryMutation>;
export type CreateOrderEntryMutationOptions = Apollo.BaseMutationOptions<CreateOrderEntryMutation, CreateOrderEntryMutationVariables>;
export const DeleteOrderEntryDocument = gql`
    mutation deleteOrderEntry($id: ID!) {
  deleteOrderEntry(id: $id) @client {
    ...orderEntry
  }
}
    ${OrderEntryFragmentDoc}`;
export type DeleteOrderEntryMutationFn = Apollo.MutationFunction<DeleteOrderEntryMutation, DeleteOrderEntryMutationVariables>;

/**
 * __useDeleteOrderEntryMutation__
 *
 * To run a mutation, you first call `useDeleteOrderEntryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOrderEntryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOrderEntryMutation, { data, loading, error }] = useDeleteOrderEntryMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteOrderEntryMutation(baseOptions?: Apollo.MutationHookOptions<DeleteOrderEntryMutation, DeleteOrderEntryMutationVariables>) {
        return Apollo.useMutation<DeleteOrderEntryMutation, DeleteOrderEntryMutationVariables>(DeleteOrderEntryDocument, baseOptions);
      }
export type DeleteOrderEntryMutationHookResult = ReturnType<typeof useDeleteOrderEntryMutation>;
export type DeleteOrderEntryMutationResult = Apollo.MutationResult<DeleteOrderEntryMutation>;
export type DeleteOrderEntryMutationOptions = Apollo.BaseMutationOptions<DeleteOrderEntryMutation, DeleteOrderEntryMutationVariables>;
export const UpdateOrderEntryDocument = gql`
    mutation updateOrderEntry($id: ID!, $input: UpdateOrderEntryInput!) {
  updateOrderEntry(id: $id, input: $input) @client {
    ...orderEntry
    destinationCode {
      ...destinationCode
    }
    budgetHolder {
      ...budgetHolder
    }
    orderType {
      ...orderType
    }
  }
}
    ${OrderEntryFragmentDoc}
${DestinationCodeFragmentDoc}
${BudgetHolderFragmentDoc}
${OrderTypeFragmentDoc}`;
export type UpdateOrderEntryMutationFn = Apollo.MutationFunction<UpdateOrderEntryMutation, UpdateOrderEntryMutationVariables>;

/**
 * __useUpdateOrderEntryMutation__
 *
 * To run a mutation, you first call `useUpdateOrderEntryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrderEntryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrderEntryMutation, { data, loading, error }] = useUpdateOrderEntryMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOrderEntryMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrderEntryMutation, UpdateOrderEntryMutationVariables>) {
        return Apollo.useMutation<UpdateOrderEntryMutation, UpdateOrderEntryMutationVariables>(UpdateOrderEntryDocument, baseOptions);
      }
export type UpdateOrderEntryMutationHookResult = ReturnType<typeof useUpdateOrderEntryMutation>;
export type UpdateOrderEntryMutationResult = Apollo.MutationResult<UpdateOrderEntryMutation>;
export type UpdateOrderEntryMutationOptions = Apollo.BaseMutationOptions<UpdateOrderEntryMutation, UpdateOrderEntryMutationVariables>;
export const CreateProductDocument = gql`
    mutation createProduct($input: ProductInput, $userContext: UserContextInput) {
  createProduct(input: $input, userContext: $userContext) {
    ...product
  }
}
    ${ProductFragmentDoc}`;
export type CreateProductMutationFn = Apollo.MutationFunction<CreateProductMutation, CreateProductMutationVariables>;

/**
 * __useCreateProductMutation__
 *
 * To run a mutation, you first call `useCreateProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProductMutation, { data, loading, error }] = useCreateProductMutation({
 *   variables: {
 *      input: // value for 'input'
 *      userContext: // value for 'userContext'
 *   },
 * });
 */
export function useCreateProductMutation(baseOptions?: Apollo.MutationHookOptions<CreateProductMutation, CreateProductMutationVariables>) {
        return Apollo.useMutation<CreateProductMutation, CreateProductMutationVariables>(CreateProductDocument, baseOptions);
      }
export type CreateProductMutationHookResult = ReturnType<typeof useCreateProductMutation>;
export type CreateProductMutationResult = Apollo.MutationResult<CreateProductMutation>;
export type CreateProductMutationOptions = Apollo.BaseMutationOptions<CreateProductMutation, CreateProductMutationVariables>;
export const UpdateProductDocument = gql`
    mutation updateProduct($id: Int!, $input: ProductUpdateInput, $userContext: UserContextInput) {
  updateProduct(id: $id, input: $input, userContext: $userContext) {
    ...product
  }
}
    ${ProductFragmentDoc}`;
export type UpdateProductMutationFn = Apollo.MutationFunction<UpdateProductMutation, UpdateProductMutationVariables>;

/**
 * __useUpdateProductMutation__
 *
 * To run a mutation, you first call `useUpdateProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProductMutation, { data, loading, error }] = useUpdateProductMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *      userContext: // value for 'userContext'
 *   },
 * });
 */
export function useUpdateProductMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProductMutation, UpdateProductMutationVariables>) {
        return Apollo.useMutation<UpdateProductMutation, UpdateProductMutationVariables>(UpdateProductDocument, baseOptions);
      }
export type UpdateProductMutationHookResult = ReturnType<typeof useUpdateProductMutation>;
export type UpdateProductMutationResult = Apollo.MutationResult<UpdateProductMutation>;
export type UpdateProductMutationOptions = Apollo.BaseMutationOptions<UpdateProductMutation, UpdateProductMutationVariables>;
export const DeleteProductDocument = gql`
    mutation deleteProduct($id: Int!, $userContext: UserContextInput) {
  deleteProduct(id: $id, userContext: $userContext) {
    ...product
  }
}
    ${ProductFragmentDoc}`;
export type DeleteProductMutationFn = Apollo.MutationFunction<DeleteProductMutation, DeleteProductMutationVariables>;

/**
 * __useDeleteProductMutation__
 *
 * To run a mutation, you first call `useDeleteProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProductMutation, { data, loading, error }] = useDeleteProductMutation({
 *   variables: {
 *      id: // value for 'id'
 *      userContext: // value for 'userContext'
 *   },
 * });
 */
export function useDeleteProductMutation(baseOptions?: Apollo.MutationHookOptions<DeleteProductMutation, DeleteProductMutationVariables>) {
        return Apollo.useMutation<DeleteProductMutation, DeleteProductMutationVariables>(DeleteProductDocument, baseOptions);
      }
export type DeleteProductMutationHookResult = ReturnType<typeof useDeleteProductMutation>;
export type DeleteProductMutationResult = Apollo.MutationResult<DeleteProductMutation>;
export type DeleteProductMutationOptions = Apollo.BaseMutationOptions<DeleteProductMutation, DeleteProductMutationVariables>;
export const CreateProductBomDocument = gql`
    mutation createProductBOM($component: BOMDefinitionInput, $productId: Int!, $userContext: UserContextInput) {
  createBOMDefinition(
    component: $component
    productId: $productId
    userContext: $userContext
  ) {
    id
    childId
    qty
  }
}
    `;
export type CreateProductBomMutationFn = Apollo.MutationFunction<CreateProductBomMutation, CreateProductBomMutationVariables>;

/**
 * __useCreateProductBomMutation__
 *
 * To run a mutation, you first call `useCreateProductBomMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProductBomMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProductBomMutation, { data, loading, error }] = useCreateProductBomMutation({
 *   variables: {
 *      component: // value for 'component'
 *      productId: // value for 'productId'
 *      userContext: // value for 'userContext'
 *   },
 * });
 */
export function useCreateProductBomMutation(baseOptions?: Apollo.MutationHookOptions<CreateProductBomMutation, CreateProductBomMutationVariables>) {
        return Apollo.useMutation<CreateProductBomMutation, CreateProductBomMutationVariables>(CreateProductBomDocument, baseOptions);
      }
export type CreateProductBomMutationHookResult = ReturnType<typeof useCreateProductBomMutation>;
export type CreateProductBomMutationResult = Apollo.MutationResult<CreateProductBomMutation>;
export type CreateProductBomMutationOptions = Apollo.BaseMutationOptions<CreateProductBomMutation, CreateProductBomMutationVariables>;
export const UpdateProductBomDocument = gql`
    mutation updateProductBOM($componentId: Int!, $productId: Int!, $update: BOMDefinitionUpdateInput, $userContext: UserContextInput) {
  updateBOMDefinition(
    componentId: $componentId
    productId: $productId
    input: $update
    userContext: $userContext
  ) {
    id
    childId
    qty
  }
}
    `;
export type UpdateProductBomMutationFn = Apollo.MutationFunction<UpdateProductBomMutation, UpdateProductBomMutationVariables>;

/**
 * __useUpdateProductBomMutation__
 *
 * To run a mutation, you first call `useUpdateProductBomMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProductBomMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProductBomMutation, { data, loading, error }] = useUpdateProductBomMutation({
 *   variables: {
 *      componentId: // value for 'componentId'
 *      productId: // value for 'productId'
 *      update: // value for 'update'
 *      userContext: // value for 'userContext'
 *   },
 * });
 */
export function useUpdateProductBomMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProductBomMutation, UpdateProductBomMutationVariables>) {
        return Apollo.useMutation<UpdateProductBomMutation, UpdateProductBomMutationVariables>(UpdateProductBomDocument, baseOptions);
      }
export type UpdateProductBomMutationHookResult = ReturnType<typeof useUpdateProductBomMutation>;
export type UpdateProductBomMutationResult = Apollo.MutationResult<UpdateProductBomMutation>;
export type UpdateProductBomMutationOptions = Apollo.BaseMutationOptions<UpdateProductBomMutation, UpdateProductBomMutationVariables>;
export const DeleteProductBomDocument = gql`
    mutation deleteProductBOM($componentId: Int!, $productId: Int!, $userContext: UserContextInput) {
  deleteBOMDefinition(
    componentId: $componentId
    productId: $productId
    userContext: $userContext
  ) {
    id
  }
}
    `;
export type DeleteProductBomMutationFn = Apollo.MutationFunction<DeleteProductBomMutation, DeleteProductBomMutationVariables>;

/**
 * __useDeleteProductBomMutation__
 *
 * To run a mutation, you first call `useDeleteProductBomMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProductBomMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProductBomMutation, { data, loading, error }] = useDeleteProductBomMutation({
 *   variables: {
 *      componentId: // value for 'componentId'
 *      productId: // value for 'productId'
 *      userContext: // value for 'userContext'
 *   },
 * });
 */
export function useDeleteProductBomMutation(baseOptions?: Apollo.MutationHookOptions<DeleteProductBomMutation, DeleteProductBomMutationVariables>) {
        return Apollo.useMutation<DeleteProductBomMutation, DeleteProductBomMutationVariables>(DeleteProductBomDocument, baseOptions);
      }
export type DeleteProductBomMutationHookResult = ReturnType<typeof useDeleteProductBomMutation>;
export type DeleteProductBomMutationResult = Apollo.MutationResult<DeleteProductBomMutation>;
export type DeleteProductBomMutationOptions = Apollo.BaseMutationOptions<DeleteProductBomMutation, DeleteProductBomMutationVariables>;
export const CreateProductDocumentDocument = gql`
    mutation createProductDocument($productId: Int!, $productDocument: ProductDocumentInput, $userContext: UserContextInput) {
  createProductDocument(
    productId: $productId
    productDocument: $productDocument
    userContext: $userContext
  ) {
    ...document
  }
}
    ${DocumentFragmentDoc}`;
export type CreateProductDocumentMutationFn = Apollo.MutationFunction<CreateProductDocumentMutation, CreateProductDocumentMutationVariables>;

/**
 * __useCreateProductDocumentMutation__
 *
 * To run a mutation, you first call `useCreateProductDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProductDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProductDocumentMutation, { data, loading, error }] = useCreateProductDocumentMutation({
 *   variables: {
 *      productId: // value for 'productId'
 *      productDocument: // value for 'productDocument'
 *      userContext: // value for 'userContext'
 *   },
 * });
 */
export function useCreateProductDocumentMutation(baseOptions?: Apollo.MutationHookOptions<CreateProductDocumentMutation, CreateProductDocumentMutationVariables>) {
        return Apollo.useMutation<CreateProductDocumentMutation, CreateProductDocumentMutationVariables>(CreateProductDocumentDocument, baseOptions);
      }
export type CreateProductDocumentMutationHookResult = ReturnType<typeof useCreateProductDocumentMutation>;
export type CreateProductDocumentMutationResult = Apollo.MutationResult<CreateProductDocumentMutation>;
export type CreateProductDocumentMutationOptions = Apollo.BaseMutationOptions<CreateProductDocumentMutation, CreateProductDocumentMutationVariables>;
export const UpdateProductDocumentDocument = gql`
    mutation updateProductDocument($id: Int!, $productId: Int!, $update: ProductDocumentUpdateInput, $userContext: UserContextInput) {
  updateProductDocument(
    id: $id
    productId: $productId
    input: $update
    userContext: $userContext
  ) {
    ...document
  }
}
    ${DocumentFragmentDoc}`;
export type UpdateProductDocumentMutationFn = Apollo.MutationFunction<UpdateProductDocumentMutation, UpdateProductDocumentMutationVariables>;

/**
 * __useUpdateProductDocumentMutation__
 *
 * To run a mutation, you first call `useUpdateProductDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProductDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProductDocumentMutation, { data, loading, error }] = useUpdateProductDocumentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      productId: // value for 'productId'
 *      update: // value for 'update'
 *      userContext: // value for 'userContext'
 *   },
 * });
 */
export function useUpdateProductDocumentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProductDocumentMutation, UpdateProductDocumentMutationVariables>) {
        return Apollo.useMutation<UpdateProductDocumentMutation, UpdateProductDocumentMutationVariables>(UpdateProductDocumentDocument, baseOptions);
      }
export type UpdateProductDocumentMutationHookResult = ReturnType<typeof useUpdateProductDocumentMutation>;
export type UpdateProductDocumentMutationResult = Apollo.MutationResult<UpdateProductDocumentMutation>;
export type UpdateProductDocumentMutationOptions = Apollo.BaseMutationOptions<UpdateProductDocumentMutation, UpdateProductDocumentMutationVariables>;
export const DeleteProductDocumentDocument = gql`
    mutation deleteProductDocument($id: Int!, $productId: Int!, $userContext: UserContextInput) {
  deleteProductDocument(id: $id, productId: $productId, userContext: $userContext) {
    id
  }
}
    `;
export type DeleteProductDocumentMutationFn = Apollo.MutationFunction<DeleteProductDocumentMutation, DeleteProductDocumentMutationVariables>;

/**
 * __useDeleteProductDocumentMutation__
 *
 * To run a mutation, you first call `useDeleteProductDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProductDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProductDocumentMutation, { data, loading, error }] = useDeleteProductDocumentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      productId: // value for 'productId'
 *      userContext: // value for 'userContext'
 *   },
 * });
 */
export function useDeleteProductDocumentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteProductDocumentMutation, DeleteProductDocumentMutationVariables>) {
        return Apollo.useMutation<DeleteProductDocumentMutation, DeleteProductDocumentMutationVariables>(DeleteProductDocumentDocument, baseOptions);
      }
export type DeleteProductDocumentMutationHookResult = ReturnType<typeof useDeleteProductDocumentMutation>;
export type DeleteProductDocumentMutationResult = Apollo.MutationResult<DeleteProductDocumentMutation>;
export type DeleteProductDocumentMutationOptions = Apollo.BaseMutationOptions<DeleteProductDocumentMutation, DeleteProductDocumentMutationVariables>;
export const CreateProductLicencePlateDocument = gql`
    mutation createProductLicencePlate($licencePlate: LPDefinitionInput, $productId: Int!, $userContext: UserContextInput) {
  createProductLicencePlate(
    licencePlate: $licencePlate
    productId: $productId
    userContext: $userContext
  ) {
    ...licencePlate
  }
}
    ${LicencePlateFragmentDoc}`;
export type CreateProductLicencePlateMutationFn = Apollo.MutationFunction<CreateProductLicencePlateMutation, CreateProductLicencePlateMutationVariables>;

/**
 * __useCreateProductLicencePlateMutation__
 *
 * To run a mutation, you first call `useCreateProductLicencePlateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProductLicencePlateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProductLicencePlateMutation, { data, loading, error }] = useCreateProductLicencePlateMutation({
 *   variables: {
 *      licencePlate: // value for 'licencePlate'
 *      productId: // value for 'productId'
 *      userContext: // value for 'userContext'
 *   },
 * });
 */
export function useCreateProductLicencePlateMutation(baseOptions?: Apollo.MutationHookOptions<CreateProductLicencePlateMutation, CreateProductLicencePlateMutationVariables>) {
        return Apollo.useMutation<CreateProductLicencePlateMutation, CreateProductLicencePlateMutationVariables>(CreateProductLicencePlateDocument, baseOptions);
      }
export type CreateProductLicencePlateMutationHookResult = ReturnType<typeof useCreateProductLicencePlateMutation>;
export type CreateProductLicencePlateMutationResult = Apollo.MutationResult<CreateProductLicencePlateMutation>;
export type CreateProductLicencePlateMutationOptions = Apollo.BaseMutationOptions<CreateProductLicencePlateMutation, CreateProductLicencePlateMutationVariables>;
export const UpdateProductLicencePlateDocument = gql`
    mutation updateProductLicencePlate($id: Int!, $productId: Int!, $update: LPDefinitionUpdateInput, $userContext: UserContextInput) {
  updateProductLicencePlate(
    id: $id
    productId: $productId
    input: $update
    userContext: $userContext
  ) {
    ...licencePlate
  }
}
    ${LicencePlateFragmentDoc}`;
export type UpdateProductLicencePlateMutationFn = Apollo.MutationFunction<UpdateProductLicencePlateMutation, UpdateProductLicencePlateMutationVariables>;

/**
 * __useUpdateProductLicencePlateMutation__
 *
 * To run a mutation, you first call `useUpdateProductLicencePlateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProductLicencePlateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProductLicencePlateMutation, { data, loading, error }] = useUpdateProductLicencePlateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      productId: // value for 'productId'
 *      update: // value for 'update'
 *      userContext: // value for 'userContext'
 *   },
 * });
 */
export function useUpdateProductLicencePlateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProductLicencePlateMutation, UpdateProductLicencePlateMutationVariables>) {
        return Apollo.useMutation<UpdateProductLicencePlateMutation, UpdateProductLicencePlateMutationVariables>(UpdateProductLicencePlateDocument, baseOptions);
      }
export type UpdateProductLicencePlateMutationHookResult = ReturnType<typeof useUpdateProductLicencePlateMutation>;
export type UpdateProductLicencePlateMutationResult = Apollo.MutationResult<UpdateProductLicencePlateMutation>;
export type UpdateProductLicencePlateMutationOptions = Apollo.BaseMutationOptions<UpdateProductLicencePlateMutation, UpdateProductLicencePlateMutationVariables>;
export const DeleteProductLicencePlateDocument = gql`
    mutation deleteProductLicencePlate($id: Int!, $productId: Int!, $userContext: UserContextInput) {
  deleteProductLicencePlate(
    id: $id
    productId: $productId
    userContext: $userContext
  ) {
    id
  }
}
    `;
export type DeleteProductLicencePlateMutationFn = Apollo.MutationFunction<DeleteProductLicencePlateMutation, DeleteProductLicencePlateMutationVariables>;

/**
 * __useDeleteProductLicencePlateMutation__
 *
 * To run a mutation, you first call `useDeleteProductLicencePlateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProductLicencePlateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProductLicencePlateMutation, { data, loading, error }] = useDeleteProductLicencePlateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      productId: // value for 'productId'
 *      userContext: // value for 'userContext'
 *   },
 * });
 */
export function useDeleteProductLicencePlateMutation(baseOptions?: Apollo.MutationHookOptions<DeleteProductLicencePlateMutation, DeleteProductLicencePlateMutationVariables>) {
        return Apollo.useMutation<DeleteProductLicencePlateMutation, DeleteProductLicencePlateMutationVariables>(DeleteProductLicencePlateDocument, baseOptions);
      }
export type DeleteProductLicencePlateMutationHookResult = ReturnType<typeof useDeleteProductLicencePlateMutation>;
export type DeleteProductLicencePlateMutationResult = Apollo.MutationResult<DeleteProductLicencePlateMutation>;
export type DeleteProductLicencePlateMutationOptions = Apollo.BaseMutationOptions<DeleteProductLicencePlateMutation, DeleteProductLicencePlateMutationVariables>;
export const CreateProductPickfaceDocument = gql`
    mutation createProductPickface($input: ProductPickfaceInput, $productId: Int!, $userContext: UserContextInput) {
  createProductPickface(
    pickface: $input
    productId: $productId
    userContext: $userContext
  ) {
    ...pickface
  }
}
    ${PickfaceFragmentDoc}`;
export type CreateProductPickfaceMutationFn = Apollo.MutationFunction<CreateProductPickfaceMutation, CreateProductPickfaceMutationVariables>;

/**
 * __useCreateProductPickfaceMutation__
 *
 * To run a mutation, you first call `useCreateProductPickfaceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProductPickfaceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProductPickfaceMutation, { data, loading, error }] = useCreateProductPickfaceMutation({
 *   variables: {
 *      input: // value for 'input'
 *      productId: // value for 'productId'
 *      userContext: // value for 'userContext'
 *   },
 * });
 */
export function useCreateProductPickfaceMutation(baseOptions?: Apollo.MutationHookOptions<CreateProductPickfaceMutation, CreateProductPickfaceMutationVariables>) {
        return Apollo.useMutation<CreateProductPickfaceMutation, CreateProductPickfaceMutationVariables>(CreateProductPickfaceDocument, baseOptions);
      }
export type CreateProductPickfaceMutationHookResult = ReturnType<typeof useCreateProductPickfaceMutation>;
export type CreateProductPickfaceMutationResult = Apollo.MutationResult<CreateProductPickfaceMutation>;
export type CreateProductPickfaceMutationOptions = Apollo.BaseMutationOptions<CreateProductPickfaceMutation, CreateProductPickfaceMutationVariables>;
export const UpdateProductPickfaceDocument = gql`
    mutation updateProductPickface($update: ProductPickfaceUpdateInput, $id: Int!, $productId: Int!, $userContext: UserContextInput) {
  updateProductPickface(
    input: $update
    id: $id
    productId: $productId
    userContext: $userContext
  ) {
    ...pickface
  }
}
    ${PickfaceFragmentDoc}`;
export type UpdateProductPickfaceMutationFn = Apollo.MutationFunction<UpdateProductPickfaceMutation, UpdateProductPickfaceMutationVariables>;

/**
 * __useUpdateProductPickfaceMutation__
 *
 * To run a mutation, you first call `useUpdateProductPickfaceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProductPickfaceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProductPickfaceMutation, { data, loading, error }] = useUpdateProductPickfaceMutation({
 *   variables: {
 *      update: // value for 'update'
 *      id: // value for 'id'
 *      productId: // value for 'productId'
 *      userContext: // value for 'userContext'
 *   },
 * });
 */
export function useUpdateProductPickfaceMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProductPickfaceMutation, UpdateProductPickfaceMutationVariables>) {
        return Apollo.useMutation<UpdateProductPickfaceMutation, UpdateProductPickfaceMutationVariables>(UpdateProductPickfaceDocument, baseOptions);
      }
export type UpdateProductPickfaceMutationHookResult = ReturnType<typeof useUpdateProductPickfaceMutation>;
export type UpdateProductPickfaceMutationResult = Apollo.MutationResult<UpdateProductPickfaceMutation>;
export type UpdateProductPickfaceMutationOptions = Apollo.BaseMutationOptions<UpdateProductPickfaceMutation, UpdateProductPickfaceMutationVariables>;
export const DeleteProductPickfaceDocument = gql`
    mutation deleteProductPickface($id: Int!, $productId: Int!, $userContext: UserContextInput) {
  deleteProductPickface(id: $id, productId: $productId, userContext: $userContext) {
    id
  }
}
    `;
export type DeleteProductPickfaceMutationFn = Apollo.MutationFunction<DeleteProductPickfaceMutation, DeleteProductPickfaceMutationVariables>;

/**
 * __useDeleteProductPickfaceMutation__
 *
 * To run a mutation, you first call `useDeleteProductPickfaceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProductPickfaceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProductPickfaceMutation, { data, loading, error }] = useDeleteProductPickfaceMutation({
 *   variables: {
 *      id: // value for 'id'
 *      productId: // value for 'productId'
 *      userContext: // value for 'userContext'
 *   },
 * });
 */
export function useDeleteProductPickfaceMutation(baseOptions?: Apollo.MutationHookOptions<DeleteProductPickfaceMutation, DeleteProductPickfaceMutationVariables>) {
        return Apollo.useMutation<DeleteProductPickfaceMutation, DeleteProductPickfaceMutationVariables>(DeleteProductPickfaceDocument, baseOptions);
      }
export type DeleteProductPickfaceMutationHookResult = ReturnType<typeof useDeleteProductPickfaceMutation>;
export type DeleteProductPickfaceMutationResult = Apollo.MutationResult<DeleteProductPickfaceMutation>;
export type DeleteProductPickfaceMutationOptions = Apollo.BaseMutationOptions<DeleteProductPickfaceMutation, DeleteProductPickfaceMutationVariables>;
export const UpdateProductSupplierDocument = gql`
    mutation updateProductSupplier($id: Int!, $productId: Int!, $input: ProductSupplierUpdateInput, $userContext: UserContextInput) {
  updateProductSupplier(
    id: $id
    productId: $productId
    input: $input
    userContext: $userContext
  ) {
    ...productSupplier
  }
}
    ${ProductSupplierFragmentDoc}`;
export type UpdateProductSupplierMutationFn = Apollo.MutationFunction<UpdateProductSupplierMutation, UpdateProductSupplierMutationVariables>;

/**
 * __useUpdateProductSupplierMutation__
 *
 * To run a mutation, you first call `useUpdateProductSupplierMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProductSupplierMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProductSupplierMutation, { data, loading, error }] = useUpdateProductSupplierMutation({
 *   variables: {
 *      id: // value for 'id'
 *      productId: // value for 'productId'
 *      input: // value for 'input'
 *      userContext: // value for 'userContext'
 *   },
 * });
 */
export function useUpdateProductSupplierMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProductSupplierMutation, UpdateProductSupplierMutationVariables>) {
        return Apollo.useMutation<UpdateProductSupplierMutation, UpdateProductSupplierMutationVariables>(UpdateProductSupplierDocument, baseOptions);
      }
export type UpdateProductSupplierMutationHookResult = ReturnType<typeof useUpdateProductSupplierMutation>;
export type UpdateProductSupplierMutationResult = Apollo.MutationResult<UpdateProductSupplierMutation>;
export type UpdateProductSupplierMutationOptions = Apollo.BaseMutationOptions<UpdateProductSupplierMutation, UpdateProductSupplierMutationVariables>;
export const CreateProductSupplierDocument = gql`
    mutation createProductSupplier($productId: Int!, $input: ProductSupplierInput, $userContext: UserContextInput) {
  createProductSupplier(
    productId: $productId
    productSupplier: $input
    userContext: $userContext
  ) {
    ...productSupplier
  }
}
    ${ProductSupplierFragmentDoc}`;
export type CreateProductSupplierMutationFn = Apollo.MutationFunction<CreateProductSupplierMutation, CreateProductSupplierMutationVariables>;

/**
 * __useCreateProductSupplierMutation__
 *
 * To run a mutation, you first call `useCreateProductSupplierMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProductSupplierMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProductSupplierMutation, { data, loading, error }] = useCreateProductSupplierMutation({
 *   variables: {
 *      productId: // value for 'productId'
 *      input: // value for 'input'
 *      userContext: // value for 'userContext'
 *   },
 * });
 */
export function useCreateProductSupplierMutation(baseOptions?: Apollo.MutationHookOptions<CreateProductSupplierMutation, CreateProductSupplierMutationVariables>) {
        return Apollo.useMutation<CreateProductSupplierMutation, CreateProductSupplierMutationVariables>(CreateProductSupplierDocument, baseOptions);
      }
export type CreateProductSupplierMutationHookResult = ReturnType<typeof useCreateProductSupplierMutation>;
export type CreateProductSupplierMutationResult = Apollo.MutationResult<CreateProductSupplierMutation>;
export type CreateProductSupplierMutationOptions = Apollo.BaseMutationOptions<CreateProductSupplierMutation, CreateProductSupplierMutationVariables>;
export const DeleteProductSupplierDocument = gql`
    mutation deleteProductSupplier($id: Int!, $productId: Int!, $userContext: UserContextInput) {
  deleteProductSupplier(productId: $productId, id: $id, userContext: $userContext) {
    id
  }
}
    `;
export type DeleteProductSupplierMutationFn = Apollo.MutationFunction<DeleteProductSupplierMutation, DeleteProductSupplierMutationVariables>;

/**
 * __useDeleteProductSupplierMutation__
 *
 * To run a mutation, you first call `useDeleteProductSupplierMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProductSupplierMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProductSupplierMutation, { data, loading, error }] = useDeleteProductSupplierMutation({
 *   variables: {
 *      id: // value for 'id'
 *      productId: // value for 'productId'
 *      userContext: // value for 'userContext'
 *   },
 * });
 */
export function useDeleteProductSupplierMutation(baseOptions?: Apollo.MutationHookOptions<DeleteProductSupplierMutation, DeleteProductSupplierMutationVariables>) {
        return Apollo.useMutation<DeleteProductSupplierMutation, DeleteProductSupplierMutationVariables>(DeleteProductSupplierDocument, baseOptions);
      }
export type DeleteProductSupplierMutationHookResult = ReturnType<typeof useDeleteProductSupplierMutation>;
export type DeleteProductSupplierMutationResult = Apollo.MutationResult<DeleteProductSupplierMutation>;
export type DeleteProductSupplierMutationOptions = Apollo.BaseMutationOptions<DeleteProductSupplierMutation, DeleteProductSupplierMutationVariables>;
export const CreatePurchaseOrderDocument = gql`
    mutation createPurchaseOrder($input: TPurchaseOrderInput, $userContext: UserContextInput) {
  purchaseOrder {
    createPurchaseOrder(userContext: $userContext, input: $input) {
      ... on PurchaseOrder {
        ...purchaseOrder
      }
      ... on DatabaseError {
        DBErrorId: id
        message
      }
      ... on ValidationError {
        ValidationErrorId: id
        field
        messages
      }
    }
  }
}
    ${PurchaseOrderFragmentDoc}`;
export type CreatePurchaseOrderMutationFn = Apollo.MutationFunction<CreatePurchaseOrderMutation, CreatePurchaseOrderMutationVariables>;

/**
 * __useCreatePurchaseOrderMutation__
 *
 * To run a mutation, you first call `useCreatePurchaseOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePurchaseOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPurchaseOrderMutation, { data, loading, error }] = useCreatePurchaseOrderMutation({
 *   variables: {
 *      input: // value for 'input'
 *      userContext: // value for 'userContext'
 *   },
 * });
 */
export function useCreatePurchaseOrderMutation(baseOptions?: Apollo.MutationHookOptions<CreatePurchaseOrderMutation, CreatePurchaseOrderMutationVariables>) {
        return Apollo.useMutation<CreatePurchaseOrderMutation, CreatePurchaseOrderMutationVariables>(CreatePurchaseOrderDocument, baseOptions);
      }
export type CreatePurchaseOrderMutationHookResult = ReturnType<typeof useCreatePurchaseOrderMutation>;
export type CreatePurchaseOrderMutationResult = Apollo.MutationResult<CreatePurchaseOrderMutation>;
export type CreatePurchaseOrderMutationOptions = Apollo.BaseMutationOptions<CreatePurchaseOrderMutation, CreatePurchaseOrderMutationVariables>;
export const UpdatePurchaseOrderDocument = gql`
    mutation updatePurchaseOrder($id: Int!, $input: PurchaseOrderUpdateInput, $items: UpdateCollectionOfPurchaseOrderItemInput, $instructions: UpdateCollectionOfPOInstructionInput, $userContext: UserContextInput) {
  purchaseOrder {
    updatePurchaseOrder(
      id: $id
      input: $input
      instructions: $instructions
      items: $items
      userContext: $userContext
    ) {
      ... on UpdatePOResponse {
        headerUpdated {
          referenceNumber
        }
        pOInstructionsDeleted {
          id
          message
          type
        }
        pOInstructionsModified {
          id
          message
          type
        }
        purchaseOrderItemsDeleted {
          id
        }
        purchaseOrderItemsModified {
          id
        }
      }
      ... on ValidationError {
        field
        messages
      }
      ... on DatabaseError {
        id
        message
      }
    }
  }
}
    `;
export type UpdatePurchaseOrderMutationFn = Apollo.MutationFunction<UpdatePurchaseOrderMutation, UpdatePurchaseOrderMutationVariables>;

/**
 * __useUpdatePurchaseOrderMutation__
 *
 * To run a mutation, you first call `useUpdatePurchaseOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePurchaseOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePurchaseOrderMutation, { data, loading, error }] = useUpdatePurchaseOrderMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *      items: // value for 'items'
 *      instructions: // value for 'instructions'
 *      userContext: // value for 'userContext'
 *   },
 * });
 */
export function useUpdatePurchaseOrderMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePurchaseOrderMutation, UpdatePurchaseOrderMutationVariables>) {
        return Apollo.useMutation<UpdatePurchaseOrderMutation, UpdatePurchaseOrderMutationVariables>(UpdatePurchaseOrderDocument, baseOptions);
      }
export type UpdatePurchaseOrderMutationHookResult = ReturnType<typeof useUpdatePurchaseOrderMutation>;
export type UpdatePurchaseOrderMutationResult = Apollo.MutationResult<UpdatePurchaseOrderMutation>;
export type UpdatePurchaseOrderMutationOptions = Apollo.BaseMutationOptions<UpdatePurchaseOrderMutation, UpdatePurchaseOrderMutationVariables>;
export const DeletePurchaseOrderDocument = gql`
    mutation deletePurchaseOrder($id: Int!, $userContext: UserContextInput) {
  purchaseOrder {
    deletePurchaseOrder(id: $id, userContext: $userContext) {
      ... on PurchaseOrder {
        id
      }
    }
  }
}
    `;
export type DeletePurchaseOrderMutationFn = Apollo.MutationFunction<DeletePurchaseOrderMutation, DeletePurchaseOrderMutationVariables>;

/**
 * __useDeletePurchaseOrderMutation__
 *
 * To run a mutation, you first call `useDeletePurchaseOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePurchaseOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePurchaseOrderMutation, { data, loading, error }] = useDeletePurchaseOrderMutation({
 *   variables: {
 *      id: // value for 'id'
 *      userContext: // value for 'userContext'
 *   },
 * });
 */
export function useDeletePurchaseOrderMutation(baseOptions?: Apollo.MutationHookOptions<DeletePurchaseOrderMutation, DeletePurchaseOrderMutationVariables>) {
        return Apollo.useMutation<DeletePurchaseOrderMutation, DeletePurchaseOrderMutationVariables>(DeletePurchaseOrderDocument, baseOptions);
      }
export type DeletePurchaseOrderMutationHookResult = ReturnType<typeof useDeletePurchaseOrderMutation>;
export type DeletePurchaseOrderMutationResult = Apollo.MutationResult<DeletePurchaseOrderMutation>;
export type DeletePurchaseOrderMutationOptions = Apollo.BaseMutationOptions<DeletePurchaseOrderMutation, DeletePurchaseOrderMutationVariables>;
export const CreateStockOwnerDocument = gql`
    mutation createStockOwner($input: StockOwnerInput) {
  createStockOwner(input: $input) {
    ...stockOwner
  }
}
    ${StockOwnerFragmentDoc}`;
export type CreateStockOwnerMutationFn = Apollo.MutationFunction<CreateStockOwnerMutation, CreateStockOwnerMutationVariables>;

/**
 * __useCreateStockOwnerMutation__
 *
 * To run a mutation, you first call `useCreateStockOwnerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateStockOwnerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createStockOwnerMutation, { data, loading, error }] = useCreateStockOwnerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateStockOwnerMutation(baseOptions?: Apollo.MutationHookOptions<CreateStockOwnerMutation, CreateStockOwnerMutationVariables>) {
        return Apollo.useMutation<CreateStockOwnerMutation, CreateStockOwnerMutationVariables>(CreateStockOwnerDocument, baseOptions);
      }
export type CreateStockOwnerMutationHookResult = ReturnType<typeof useCreateStockOwnerMutation>;
export type CreateStockOwnerMutationResult = Apollo.MutationResult<CreateStockOwnerMutation>;
export type CreateStockOwnerMutationOptions = Apollo.BaseMutationOptions<CreateStockOwnerMutation, CreateStockOwnerMutationVariables>;
export const UpdateStockOwnerDocument = gql`
    mutation updateStockOwner($id: Int!, $input: StockOwnerUpdateInput, $userContext: UserContextInput) {
  updateStockOwner(id: $id, input: $input, userContext: $userContext) {
    ...stockOwner
  }
}
    ${StockOwnerFragmentDoc}`;
export type UpdateStockOwnerMutationFn = Apollo.MutationFunction<UpdateStockOwnerMutation, UpdateStockOwnerMutationVariables>;

/**
 * __useUpdateStockOwnerMutation__
 *
 * To run a mutation, you first call `useUpdateStockOwnerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateStockOwnerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateStockOwnerMutation, { data, loading, error }] = useUpdateStockOwnerMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *      userContext: // value for 'userContext'
 *   },
 * });
 */
export function useUpdateStockOwnerMutation(baseOptions?: Apollo.MutationHookOptions<UpdateStockOwnerMutation, UpdateStockOwnerMutationVariables>) {
        return Apollo.useMutation<UpdateStockOwnerMutation, UpdateStockOwnerMutationVariables>(UpdateStockOwnerDocument, baseOptions);
      }
export type UpdateStockOwnerMutationHookResult = ReturnType<typeof useUpdateStockOwnerMutation>;
export type UpdateStockOwnerMutationResult = Apollo.MutationResult<UpdateStockOwnerMutation>;
export type UpdateStockOwnerMutationOptions = Apollo.BaseMutationOptions<UpdateStockOwnerMutation, UpdateStockOwnerMutationVariables>;
export const DeleteStockOwnerDocument = gql`
    mutation deleteStockOwner($id: Int!, $userContext: UserContextInput) {
  deleteStockOwner(id: $id, userContext: $userContext) {
    ...stockOwner
  }
}
    ${StockOwnerFragmentDoc}`;
export type DeleteStockOwnerMutationFn = Apollo.MutationFunction<DeleteStockOwnerMutation, DeleteStockOwnerMutationVariables>;

/**
 * __useDeleteStockOwnerMutation__
 *
 * To run a mutation, you first call `useDeleteStockOwnerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteStockOwnerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteStockOwnerMutation, { data, loading, error }] = useDeleteStockOwnerMutation({
 *   variables: {
 *      id: // value for 'id'
 *      userContext: // value for 'userContext'
 *   },
 * });
 */
export function useDeleteStockOwnerMutation(baseOptions?: Apollo.MutationHookOptions<DeleteStockOwnerMutation, DeleteStockOwnerMutationVariables>) {
        return Apollo.useMutation<DeleteStockOwnerMutation, DeleteStockOwnerMutationVariables>(DeleteStockOwnerDocument, baseOptions);
      }
export type DeleteStockOwnerMutationHookResult = ReturnType<typeof useDeleteStockOwnerMutation>;
export type DeleteStockOwnerMutationResult = Apollo.MutationResult<DeleteStockOwnerMutation>;
export type DeleteStockOwnerMutationOptions = Apollo.BaseMutationOptions<DeleteStockOwnerMutation, DeleteStockOwnerMutationVariables>;
export const UpdateStockOwnerCategoryDocument = gql`
    mutation updateStockOwnerCategory($id: Int!, $stockOwnerId: Int!, $input: CategoryDefinitionUpdateInput) {
  updateStockOwnerCategoryDefinition(
    id: $id
    stockOwnerId: $stockOwnerId
    input: $input
  ) {
    ...categoryDefinition
  }
}
    ${CategoryDefinitionFragmentDoc}`;
export type UpdateStockOwnerCategoryMutationFn = Apollo.MutationFunction<UpdateStockOwnerCategoryMutation, UpdateStockOwnerCategoryMutationVariables>;

/**
 * __useUpdateStockOwnerCategoryMutation__
 *
 * To run a mutation, you first call `useUpdateStockOwnerCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateStockOwnerCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateStockOwnerCategoryMutation, { data, loading, error }] = useUpdateStockOwnerCategoryMutation({
 *   variables: {
 *      id: // value for 'id'
 *      stockOwnerId: // value for 'stockOwnerId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateStockOwnerCategoryMutation(baseOptions?: Apollo.MutationHookOptions<UpdateStockOwnerCategoryMutation, UpdateStockOwnerCategoryMutationVariables>) {
        return Apollo.useMutation<UpdateStockOwnerCategoryMutation, UpdateStockOwnerCategoryMutationVariables>(UpdateStockOwnerCategoryDocument, baseOptions);
      }
export type UpdateStockOwnerCategoryMutationHookResult = ReturnType<typeof useUpdateStockOwnerCategoryMutation>;
export type UpdateStockOwnerCategoryMutationResult = Apollo.MutationResult<UpdateStockOwnerCategoryMutation>;
export type UpdateStockOwnerCategoryMutationOptions = Apollo.BaseMutationOptions<UpdateStockOwnerCategoryMutation, UpdateStockOwnerCategoryMutationVariables>;
export const CreateStockOwnerCategoyDocument = gql`
    mutation createStockOwnerCategoy($stockOwnerId: Int!, $input: CategoryDefinitionInput) {
  createStockOwnerCategoryDefinition(stockOwnerId: $stockOwnerId, input: $input) {
    ...categoryDefinition
  }
}
    ${CategoryDefinitionFragmentDoc}`;
export type CreateStockOwnerCategoyMutationFn = Apollo.MutationFunction<CreateStockOwnerCategoyMutation, CreateStockOwnerCategoyMutationVariables>;

/**
 * __useCreateStockOwnerCategoyMutation__
 *
 * To run a mutation, you first call `useCreateStockOwnerCategoyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateStockOwnerCategoyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createStockOwnerCategoyMutation, { data, loading, error }] = useCreateStockOwnerCategoyMutation({
 *   variables: {
 *      stockOwnerId: // value for 'stockOwnerId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateStockOwnerCategoyMutation(baseOptions?: Apollo.MutationHookOptions<CreateStockOwnerCategoyMutation, CreateStockOwnerCategoyMutationVariables>) {
        return Apollo.useMutation<CreateStockOwnerCategoyMutation, CreateStockOwnerCategoyMutationVariables>(CreateStockOwnerCategoyDocument, baseOptions);
      }
export type CreateStockOwnerCategoyMutationHookResult = ReturnType<typeof useCreateStockOwnerCategoyMutation>;
export type CreateStockOwnerCategoyMutationResult = Apollo.MutationResult<CreateStockOwnerCategoyMutation>;
export type CreateStockOwnerCategoyMutationOptions = Apollo.BaseMutationOptions<CreateStockOwnerCategoyMutation, CreateStockOwnerCategoyMutationVariables>;
export const DeleteStockOwnerCategoryDocument = gql`
    mutation deleteStockOwnerCategory($stockOwnerId: Int!, $id: Int!) {
  deleteStockOwnerCategoryDefinition(stockOwnerId: $stockOwnerId, id: $id) {
    id
  }
}
    `;
export type DeleteStockOwnerCategoryMutationFn = Apollo.MutationFunction<DeleteStockOwnerCategoryMutation, DeleteStockOwnerCategoryMutationVariables>;

/**
 * __useDeleteStockOwnerCategoryMutation__
 *
 * To run a mutation, you first call `useDeleteStockOwnerCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteStockOwnerCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteStockOwnerCategoryMutation, { data, loading, error }] = useDeleteStockOwnerCategoryMutation({
 *   variables: {
 *      stockOwnerId: // value for 'stockOwnerId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteStockOwnerCategoryMutation(baseOptions?: Apollo.MutationHookOptions<DeleteStockOwnerCategoryMutation, DeleteStockOwnerCategoryMutationVariables>) {
        return Apollo.useMutation<DeleteStockOwnerCategoryMutation, DeleteStockOwnerCategoryMutationVariables>(DeleteStockOwnerCategoryDocument, baseOptions);
      }
export type DeleteStockOwnerCategoryMutationHookResult = ReturnType<typeof useDeleteStockOwnerCategoryMutation>;
export type DeleteStockOwnerCategoryMutationResult = Apollo.MutationResult<DeleteStockOwnerCategoryMutation>;
export type DeleteStockOwnerCategoryMutationOptions = Apollo.BaseMutationOptions<DeleteStockOwnerCategoryMutation, DeleteStockOwnerCategoryMutationVariables>;
export const UpdateStockOwnerPickConfirmMethodDocument = gql`
    mutation updateStockOwnerPickConfirmMethod($id: Int!, $stockOwnerId: Int!, $input: PickConfirmMethodUpdateInput) {
  updateStockOwnerPickConfirmMethod(
    id: $id
    stockOwnerId: $stockOwnerId
    input: $input
  ) {
    ...pickConfirmMethod
  }
}
    ${PickConfirmMethodFragmentDoc}`;
export type UpdateStockOwnerPickConfirmMethodMutationFn = Apollo.MutationFunction<UpdateStockOwnerPickConfirmMethodMutation, UpdateStockOwnerPickConfirmMethodMutationVariables>;

/**
 * __useUpdateStockOwnerPickConfirmMethodMutation__
 *
 * To run a mutation, you first call `useUpdateStockOwnerPickConfirmMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateStockOwnerPickConfirmMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateStockOwnerPickConfirmMethodMutation, { data, loading, error }] = useUpdateStockOwnerPickConfirmMethodMutation({
 *   variables: {
 *      id: // value for 'id'
 *      stockOwnerId: // value for 'stockOwnerId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateStockOwnerPickConfirmMethodMutation(baseOptions?: Apollo.MutationHookOptions<UpdateStockOwnerPickConfirmMethodMutation, UpdateStockOwnerPickConfirmMethodMutationVariables>) {
        return Apollo.useMutation<UpdateStockOwnerPickConfirmMethodMutation, UpdateStockOwnerPickConfirmMethodMutationVariables>(UpdateStockOwnerPickConfirmMethodDocument, baseOptions);
      }
export type UpdateStockOwnerPickConfirmMethodMutationHookResult = ReturnType<typeof useUpdateStockOwnerPickConfirmMethodMutation>;
export type UpdateStockOwnerPickConfirmMethodMutationResult = Apollo.MutationResult<UpdateStockOwnerPickConfirmMethodMutation>;
export type UpdateStockOwnerPickConfirmMethodMutationOptions = Apollo.BaseMutationOptions<UpdateStockOwnerPickConfirmMethodMutation, UpdateStockOwnerPickConfirmMethodMutationVariables>;
export const CreateStockOwnerPickConfirmMethodDocument = gql`
    mutation createStockOwnerPickConfirmMethod($stockOwnerId: Int!, $input: PickConfirmMethodInput) {
  createStockOwnerPickConfirmMethod(stockOwnerId: $stockOwnerId, input: $input) {
    ...pickConfirmMethod
  }
}
    ${PickConfirmMethodFragmentDoc}`;
export type CreateStockOwnerPickConfirmMethodMutationFn = Apollo.MutationFunction<CreateStockOwnerPickConfirmMethodMutation, CreateStockOwnerPickConfirmMethodMutationVariables>;

/**
 * __useCreateStockOwnerPickConfirmMethodMutation__
 *
 * To run a mutation, you first call `useCreateStockOwnerPickConfirmMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateStockOwnerPickConfirmMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createStockOwnerPickConfirmMethodMutation, { data, loading, error }] = useCreateStockOwnerPickConfirmMethodMutation({
 *   variables: {
 *      stockOwnerId: // value for 'stockOwnerId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateStockOwnerPickConfirmMethodMutation(baseOptions?: Apollo.MutationHookOptions<CreateStockOwnerPickConfirmMethodMutation, CreateStockOwnerPickConfirmMethodMutationVariables>) {
        return Apollo.useMutation<CreateStockOwnerPickConfirmMethodMutation, CreateStockOwnerPickConfirmMethodMutationVariables>(CreateStockOwnerPickConfirmMethodDocument, baseOptions);
      }
export type CreateStockOwnerPickConfirmMethodMutationHookResult = ReturnType<typeof useCreateStockOwnerPickConfirmMethodMutation>;
export type CreateStockOwnerPickConfirmMethodMutationResult = Apollo.MutationResult<CreateStockOwnerPickConfirmMethodMutation>;
export type CreateStockOwnerPickConfirmMethodMutationOptions = Apollo.BaseMutationOptions<CreateStockOwnerPickConfirmMethodMutation, CreateStockOwnerPickConfirmMethodMutationVariables>;
export const DeleteStockOwnerPickConfirmMethodDocument = gql`
    mutation deleteStockOwnerPickConfirmMethod($stockOwnerId: Int!, $id: Int!) {
  deleteStockOwnerPickConfirmMethod(stockOwnerId: $stockOwnerId, id: $id) {
    id
  }
}
    `;
export type DeleteStockOwnerPickConfirmMethodMutationFn = Apollo.MutationFunction<DeleteStockOwnerPickConfirmMethodMutation, DeleteStockOwnerPickConfirmMethodMutationVariables>;

/**
 * __useDeleteStockOwnerPickConfirmMethodMutation__
 *
 * To run a mutation, you first call `useDeleteStockOwnerPickConfirmMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteStockOwnerPickConfirmMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteStockOwnerPickConfirmMethodMutation, { data, loading, error }] = useDeleteStockOwnerPickConfirmMethodMutation({
 *   variables: {
 *      stockOwnerId: // value for 'stockOwnerId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteStockOwnerPickConfirmMethodMutation(baseOptions?: Apollo.MutationHookOptions<DeleteStockOwnerPickConfirmMethodMutation, DeleteStockOwnerPickConfirmMethodMutationVariables>) {
        return Apollo.useMutation<DeleteStockOwnerPickConfirmMethodMutation, DeleteStockOwnerPickConfirmMethodMutationVariables>(DeleteStockOwnerPickConfirmMethodDocument, baseOptions);
      }
export type DeleteStockOwnerPickConfirmMethodMutationHookResult = ReturnType<typeof useDeleteStockOwnerPickConfirmMethodMutation>;
export type DeleteStockOwnerPickConfirmMethodMutationResult = Apollo.MutationResult<DeleteStockOwnerPickConfirmMethodMutation>;
export type DeleteStockOwnerPickConfirmMethodMutationOptions = Apollo.BaseMutationOptions<DeleteStockOwnerPickConfirmMethodMutation, DeleteStockOwnerPickConfirmMethodMutationVariables>;
export const UpdateOrderStatusDocument = gql`
    mutation updateOrderStatus($id: Int!, $stockOwnerId: Int!, $input: OrderStatusUpdateInput) {
  updateOrderStatus(id: $id, stockOwnerId: $stockOwnerId, input: $input) {
    ...orderStatus
  }
}
    ${OrderStatusFragmentDoc}`;
export type UpdateOrderStatusMutationFn = Apollo.MutationFunction<UpdateOrderStatusMutation, UpdateOrderStatusMutationVariables>;

/**
 * __useUpdateOrderStatusMutation__
 *
 * To run a mutation, you first call `useUpdateOrderStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrderStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrderStatusMutation, { data, loading, error }] = useUpdateOrderStatusMutation({
 *   variables: {
 *      id: // value for 'id'
 *      stockOwnerId: // value for 'stockOwnerId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOrderStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrderStatusMutation, UpdateOrderStatusMutationVariables>) {
        return Apollo.useMutation<UpdateOrderStatusMutation, UpdateOrderStatusMutationVariables>(UpdateOrderStatusDocument, baseOptions);
      }
export type UpdateOrderStatusMutationHookResult = ReturnType<typeof useUpdateOrderStatusMutation>;
export type UpdateOrderStatusMutationResult = Apollo.MutationResult<UpdateOrderStatusMutation>;
export type UpdateOrderStatusMutationOptions = Apollo.BaseMutationOptions<UpdateOrderStatusMutation, UpdateOrderStatusMutationVariables>;
export const CreateOrderStatusDocument = gql`
    mutation createOrderStatus($stockOwnerId: Int!, $input: OrderStatusInput) {
  createOrderStatus(stockOwnerId: $stockOwnerId, input: $input) {
    ...orderStatus
  }
}
    ${OrderStatusFragmentDoc}`;
export type CreateOrderStatusMutationFn = Apollo.MutationFunction<CreateOrderStatusMutation, CreateOrderStatusMutationVariables>;

/**
 * __useCreateOrderStatusMutation__
 *
 * To run a mutation, you first call `useCreateOrderStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrderStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrderStatusMutation, { data, loading, error }] = useCreateOrderStatusMutation({
 *   variables: {
 *      stockOwnerId: // value for 'stockOwnerId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOrderStatusMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrderStatusMutation, CreateOrderStatusMutationVariables>) {
        return Apollo.useMutation<CreateOrderStatusMutation, CreateOrderStatusMutationVariables>(CreateOrderStatusDocument, baseOptions);
      }
export type CreateOrderStatusMutationHookResult = ReturnType<typeof useCreateOrderStatusMutation>;
export type CreateOrderStatusMutationResult = Apollo.MutationResult<CreateOrderStatusMutation>;
export type CreateOrderStatusMutationOptions = Apollo.BaseMutationOptions<CreateOrderStatusMutation, CreateOrderStatusMutationVariables>;
export const DeleteOrderStatusDocument = gql`
    mutation deleteOrderStatus($stockOwnerId: Int!, $id: Int!) {
  deleteOrderStatus(stockOwnerId: $stockOwnerId, id: $id) {
    ...orderStatus
  }
}
    ${OrderStatusFragmentDoc}`;
export type DeleteOrderStatusMutationFn = Apollo.MutationFunction<DeleteOrderStatusMutation, DeleteOrderStatusMutationVariables>;

/**
 * __useDeleteOrderStatusMutation__
 *
 * To run a mutation, you first call `useDeleteOrderStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOrderStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOrderStatusMutation, { data, loading, error }] = useDeleteOrderStatusMutation({
 *   variables: {
 *      stockOwnerId: // value for 'stockOwnerId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteOrderStatusMutation(baseOptions?: Apollo.MutationHookOptions<DeleteOrderStatusMutation, DeleteOrderStatusMutationVariables>) {
        return Apollo.useMutation<DeleteOrderStatusMutation, DeleteOrderStatusMutationVariables>(DeleteOrderStatusDocument, baseOptions);
      }
export type DeleteOrderStatusMutationHookResult = ReturnType<typeof useDeleteOrderStatusMutation>;
export type DeleteOrderStatusMutationResult = Apollo.MutationResult<DeleteOrderStatusMutation>;
export type DeleteOrderStatusMutationOptions = Apollo.BaseMutationOptions<DeleteOrderStatusMutation, DeleteOrderStatusMutationVariables>;
export const UpdateStockOwnerPickMethodDocument = gql`
    mutation updateStockOwnerPickMethod($id: Int!, $stockOwnerId: Int!, $input: PickMethodUpdateInput) {
  updateStockOwnerPickMethod(id: $id, stockOwnerId: $stockOwnerId, input: $input) {
    ...pickMethod
  }
}
    ${PickMethodFragmentDoc}`;
export type UpdateStockOwnerPickMethodMutationFn = Apollo.MutationFunction<UpdateStockOwnerPickMethodMutation, UpdateStockOwnerPickMethodMutationVariables>;

/**
 * __useUpdateStockOwnerPickMethodMutation__
 *
 * To run a mutation, you first call `useUpdateStockOwnerPickMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateStockOwnerPickMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateStockOwnerPickMethodMutation, { data, loading, error }] = useUpdateStockOwnerPickMethodMutation({
 *   variables: {
 *      id: // value for 'id'
 *      stockOwnerId: // value for 'stockOwnerId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateStockOwnerPickMethodMutation(baseOptions?: Apollo.MutationHookOptions<UpdateStockOwnerPickMethodMutation, UpdateStockOwnerPickMethodMutationVariables>) {
        return Apollo.useMutation<UpdateStockOwnerPickMethodMutation, UpdateStockOwnerPickMethodMutationVariables>(UpdateStockOwnerPickMethodDocument, baseOptions);
      }
export type UpdateStockOwnerPickMethodMutationHookResult = ReturnType<typeof useUpdateStockOwnerPickMethodMutation>;
export type UpdateStockOwnerPickMethodMutationResult = Apollo.MutationResult<UpdateStockOwnerPickMethodMutation>;
export type UpdateStockOwnerPickMethodMutationOptions = Apollo.BaseMutationOptions<UpdateStockOwnerPickMethodMutation, UpdateStockOwnerPickMethodMutationVariables>;
export const CreateStockOwnerPickMethodDocument = gql`
    mutation createStockOwnerPickMethod($stockOwnerId: Int!, $input: PickMethodInput) {
  createStockOwnerPickMethod(stockOwnerId: $stockOwnerId, input: $input) {
    ...pickMethod
  }
}
    ${PickMethodFragmentDoc}`;
export type CreateStockOwnerPickMethodMutationFn = Apollo.MutationFunction<CreateStockOwnerPickMethodMutation, CreateStockOwnerPickMethodMutationVariables>;

/**
 * __useCreateStockOwnerPickMethodMutation__
 *
 * To run a mutation, you first call `useCreateStockOwnerPickMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateStockOwnerPickMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createStockOwnerPickMethodMutation, { data, loading, error }] = useCreateStockOwnerPickMethodMutation({
 *   variables: {
 *      stockOwnerId: // value for 'stockOwnerId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateStockOwnerPickMethodMutation(baseOptions?: Apollo.MutationHookOptions<CreateStockOwnerPickMethodMutation, CreateStockOwnerPickMethodMutationVariables>) {
        return Apollo.useMutation<CreateStockOwnerPickMethodMutation, CreateStockOwnerPickMethodMutationVariables>(CreateStockOwnerPickMethodDocument, baseOptions);
      }
export type CreateStockOwnerPickMethodMutationHookResult = ReturnType<typeof useCreateStockOwnerPickMethodMutation>;
export type CreateStockOwnerPickMethodMutationResult = Apollo.MutationResult<CreateStockOwnerPickMethodMutation>;
export type CreateStockOwnerPickMethodMutationOptions = Apollo.BaseMutationOptions<CreateStockOwnerPickMethodMutation, CreateStockOwnerPickMethodMutationVariables>;
export const DeleteStockOwnerPickMethodDocument = gql`
    mutation deleteStockOwnerPickMethod($stockOwnerId: Int!, $id: Int!) {
  deleteStockOwnerPickMethod(stockOwnerId: $stockOwnerId, id: $id) {
    id
  }
}
    `;
export type DeleteStockOwnerPickMethodMutationFn = Apollo.MutationFunction<DeleteStockOwnerPickMethodMutation, DeleteStockOwnerPickMethodMutationVariables>;

/**
 * __useDeleteStockOwnerPickMethodMutation__
 *
 * To run a mutation, you first call `useDeleteStockOwnerPickMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteStockOwnerPickMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteStockOwnerPickMethodMutation, { data, loading, error }] = useDeleteStockOwnerPickMethodMutation({
 *   variables: {
 *      stockOwnerId: // value for 'stockOwnerId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteStockOwnerPickMethodMutation(baseOptions?: Apollo.MutationHookOptions<DeleteStockOwnerPickMethodMutation, DeleteStockOwnerPickMethodMutationVariables>) {
        return Apollo.useMutation<DeleteStockOwnerPickMethodMutation, DeleteStockOwnerPickMethodMutationVariables>(DeleteStockOwnerPickMethodDocument, baseOptions);
      }
export type DeleteStockOwnerPickMethodMutationHookResult = ReturnType<typeof useDeleteStockOwnerPickMethodMutation>;
export type DeleteStockOwnerPickMethodMutationResult = Apollo.MutationResult<DeleteStockOwnerPickMethodMutation>;
export type DeleteStockOwnerPickMethodMutationOptions = Apollo.BaseMutationOptions<DeleteStockOwnerPickMethodMutation, DeleteStockOwnerPickMethodMutationVariables>;
export const UpdateProductStatusDocument = gql`
    mutation updateProductStatus($id: Int!, $stockOwnerId: Int!, $input: ProductStatusUpdateInput) {
  updateProductStatus(id: $id, stockOwnerId: $stockOwnerId, input: $input) {
    ...productStatuses
  }
}
    ${ProductStatusesFragmentDoc}`;
export type UpdateProductStatusMutationFn = Apollo.MutationFunction<UpdateProductStatusMutation, UpdateProductStatusMutationVariables>;

/**
 * __useUpdateProductStatusMutation__
 *
 * To run a mutation, you first call `useUpdateProductStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProductStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProductStatusMutation, { data, loading, error }] = useUpdateProductStatusMutation({
 *   variables: {
 *      id: // value for 'id'
 *      stockOwnerId: // value for 'stockOwnerId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateProductStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProductStatusMutation, UpdateProductStatusMutationVariables>) {
        return Apollo.useMutation<UpdateProductStatusMutation, UpdateProductStatusMutationVariables>(UpdateProductStatusDocument, baseOptions);
      }
export type UpdateProductStatusMutationHookResult = ReturnType<typeof useUpdateProductStatusMutation>;
export type UpdateProductStatusMutationResult = Apollo.MutationResult<UpdateProductStatusMutation>;
export type UpdateProductStatusMutationOptions = Apollo.BaseMutationOptions<UpdateProductStatusMutation, UpdateProductStatusMutationVariables>;
export const CreateProductStatusDocument = gql`
    mutation createProductStatus($stockOwnerId: Int!, $input: ProductStatusInput) {
  createProductStatus(stockOwnerId: $stockOwnerId, input: $input) {
    ...productStatuses
  }
}
    ${ProductStatusesFragmentDoc}`;
export type CreateProductStatusMutationFn = Apollo.MutationFunction<CreateProductStatusMutation, CreateProductStatusMutationVariables>;

/**
 * __useCreateProductStatusMutation__
 *
 * To run a mutation, you first call `useCreateProductStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProductStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProductStatusMutation, { data, loading, error }] = useCreateProductStatusMutation({
 *   variables: {
 *      stockOwnerId: // value for 'stockOwnerId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateProductStatusMutation(baseOptions?: Apollo.MutationHookOptions<CreateProductStatusMutation, CreateProductStatusMutationVariables>) {
        return Apollo.useMutation<CreateProductStatusMutation, CreateProductStatusMutationVariables>(CreateProductStatusDocument, baseOptions);
      }
export type CreateProductStatusMutationHookResult = ReturnType<typeof useCreateProductStatusMutation>;
export type CreateProductStatusMutationResult = Apollo.MutationResult<CreateProductStatusMutation>;
export type CreateProductStatusMutationOptions = Apollo.BaseMutationOptions<CreateProductStatusMutation, CreateProductStatusMutationVariables>;
export const DeleteProductStatusDocument = gql`
    mutation deleteProductStatus($stockOwnerId: Int!, $id: Int!) {
  deleteProductStatus(stockOwnerId: $stockOwnerId, id: $id) {
    ...productStatuses
  }
}
    ${ProductStatusesFragmentDoc}`;
export type DeleteProductStatusMutationFn = Apollo.MutationFunction<DeleteProductStatusMutation, DeleteProductStatusMutationVariables>;

/**
 * __useDeleteProductStatusMutation__
 *
 * To run a mutation, you first call `useDeleteProductStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProductStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProductStatusMutation, { data, loading, error }] = useDeleteProductStatusMutation({
 *   variables: {
 *      stockOwnerId: // value for 'stockOwnerId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteProductStatusMutation(baseOptions?: Apollo.MutationHookOptions<DeleteProductStatusMutation, DeleteProductStatusMutationVariables>) {
        return Apollo.useMutation<DeleteProductStatusMutation, DeleteProductStatusMutationVariables>(DeleteProductStatusDocument, baseOptions);
      }
export type DeleteProductStatusMutationHookResult = ReturnType<typeof useDeleteProductStatusMutation>;
export type DeleteProductStatusMutationResult = Apollo.MutationResult<DeleteProductStatusMutation>;
export type DeleteProductStatusMutationOptions = Apollo.BaseMutationOptions<DeleteProductStatusMutation, DeleteProductStatusMutationVariables>;
export const CreateStorageTypeDocument = gql`
    mutation createStorageType($input: StorageTypeInput, $userContext: UserContextInput) {
  createStorageType(input: $input, userContext: $userContext) {
    ...storageType
  }
}
    ${StorageTypeFragmentDoc}`;
export type CreateStorageTypeMutationFn = Apollo.MutationFunction<CreateStorageTypeMutation, CreateStorageTypeMutationVariables>;

/**
 * __useCreateStorageTypeMutation__
 *
 * To run a mutation, you first call `useCreateStorageTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateStorageTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createStorageTypeMutation, { data, loading, error }] = useCreateStorageTypeMutation({
 *   variables: {
 *      input: // value for 'input'
 *      userContext: // value for 'userContext'
 *   },
 * });
 */
export function useCreateStorageTypeMutation(baseOptions?: Apollo.MutationHookOptions<CreateStorageTypeMutation, CreateStorageTypeMutationVariables>) {
        return Apollo.useMutation<CreateStorageTypeMutation, CreateStorageTypeMutationVariables>(CreateStorageTypeDocument, baseOptions);
      }
export type CreateStorageTypeMutationHookResult = ReturnType<typeof useCreateStorageTypeMutation>;
export type CreateStorageTypeMutationResult = Apollo.MutationResult<CreateStorageTypeMutation>;
export type CreateStorageTypeMutationOptions = Apollo.BaseMutationOptions<CreateStorageTypeMutation, CreateStorageTypeMutationVariables>;
export const UpdateStorageTypeDocument = gql`
    mutation updateStorageType($id: Int!, $input: StorageTypeUpdateInput, $userContext: UserContextInput) {
  updateStorageType(id: $id, input: $input, userContext: $userContext) {
    ...storageType
  }
}
    ${StorageTypeFragmentDoc}`;
export type UpdateStorageTypeMutationFn = Apollo.MutationFunction<UpdateStorageTypeMutation, UpdateStorageTypeMutationVariables>;

/**
 * __useUpdateStorageTypeMutation__
 *
 * To run a mutation, you first call `useUpdateStorageTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateStorageTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateStorageTypeMutation, { data, loading, error }] = useUpdateStorageTypeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *      userContext: // value for 'userContext'
 *   },
 * });
 */
export function useUpdateStorageTypeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateStorageTypeMutation, UpdateStorageTypeMutationVariables>) {
        return Apollo.useMutation<UpdateStorageTypeMutation, UpdateStorageTypeMutationVariables>(UpdateStorageTypeDocument, baseOptions);
      }
export type UpdateStorageTypeMutationHookResult = ReturnType<typeof useUpdateStorageTypeMutation>;
export type UpdateStorageTypeMutationResult = Apollo.MutationResult<UpdateStorageTypeMutation>;
export type UpdateStorageTypeMutationOptions = Apollo.BaseMutationOptions<UpdateStorageTypeMutation, UpdateStorageTypeMutationVariables>;
export const DeleteStorageTypeDocument = gql`
    mutation deleteStorageType($id: Int!, $userContext: UserContextInput) {
  deleteStorageType(id: $id, userContext: $userContext) {
    ...storageType
  }
}
    ${StorageTypeFragmentDoc}`;
export type DeleteStorageTypeMutationFn = Apollo.MutationFunction<DeleteStorageTypeMutation, DeleteStorageTypeMutationVariables>;

/**
 * __useDeleteStorageTypeMutation__
 *
 * To run a mutation, you first call `useDeleteStorageTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteStorageTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteStorageTypeMutation, { data, loading, error }] = useDeleteStorageTypeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      userContext: // value for 'userContext'
 *   },
 * });
 */
export function useDeleteStorageTypeMutation(baseOptions?: Apollo.MutationHookOptions<DeleteStorageTypeMutation, DeleteStorageTypeMutationVariables>) {
        return Apollo.useMutation<DeleteStorageTypeMutation, DeleteStorageTypeMutationVariables>(DeleteStorageTypeDocument, baseOptions);
      }
export type DeleteStorageTypeMutationHookResult = ReturnType<typeof useDeleteStorageTypeMutation>;
export type DeleteStorageTypeMutationResult = Apollo.MutationResult<DeleteStorageTypeMutation>;
export type DeleteStorageTypeMutationOptions = Apollo.BaseMutationOptions<DeleteStorageTypeMutation, DeleteStorageTypeMutationVariables>;
export const AddStorageTypeMheDocument = gql`
    mutation addStorageTypeMHE($id: Int!, $MHEId: Int!) {
  addStorageTypeMHE(id: $id, MHEId: $MHEId) {
    storageType {
      ...storageType
    }
  }
}
    ${StorageTypeFragmentDoc}`;
export type AddStorageTypeMheMutationFn = Apollo.MutationFunction<AddStorageTypeMheMutation, AddStorageTypeMheMutationVariables>;

/**
 * __useAddStorageTypeMheMutation__
 *
 * To run a mutation, you first call `useAddStorageTypeMheMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddStorageTypeMheMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addStorageTypeMheMutation, { data, loading, error }] = useAddStorageTypeMheMutation({
 *   variables: {
 *      id: // value for 'id'
 *      MHEId: // value for 'MHEId'
 *   },
 * });
 */
export function useAddStorageTypeMheMutation(baseOptions?: Apollo.MutationHookOptions<AddStorageTypeMheMutation, AddStorageTypeMheMutationVariables>) {
        return Apollo.useMutation<AddStorageTypeMheMutation, AddStorageTypeMheMutationVariables>(AddStorageTypeMheDocument, baseOptions);
      }
export type AddStorageTypeMheMutationHookResult = ReturnType<typeof useAddStorageTypeMheMutation>;
export type AddStorageTypeMheMutationResult = Apollo.MutationResult<AddStorageTypeMheMutation>;
export type AddStorageTypeMheMutationOptions = Apollo.BaseMutationOptions<AddStorageTypeMheMutation, AddStorageTypeMheMutationVariables>;
export const RemoveStorageTypeMheDocument = gql`
    mutation removeStorageTypeMHE($id: Int!, $MHEId: Int!) {
  removeStorageTypeMHE(id: $id, MHEId: $MHEId) {
    storageType {
      ...storageType
    }
  }
}
    ${StorageTypeFragmentDoc}`;
export type RemoveStorageTypeMheMutationFn = Apollo.MutationFunction<RemoveStorageTypeMheMutation, RemoveStorageTypeMheMutationVariables>;

/**
 * __useRemoveStorageTypeMheMutation__
 *
 * To run a mutation, you first call `useRemoveStorageTypeMheMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveStorageTypeMheMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeStorageTypeMheMutation, { data, loading, error }] = useRemoveStorageTypeMheMutation({
 *   variables: {
 *      id: // value for 'id'
 *      MHEId: // value for 'MHEId'
 *   },
 * });
 */
export function useRemoveStorageTypeMheMutation(baseOptions?: Apollo.MutationHookOptions<RemoveStorageTypeMheMutation, RemoveStorageTypeMheMutationVariables>) {
        return Apollo.useMutation<RemoveStorageTypeMheMutation, RemoveStorageTypeMheMutationVariables>(RemoveStorageTypeMheDocument, baseOptions);
      }
export type RemoveStorageTypeMheMutationHookResult = ReturnType<typeof useRemoveStorageTypeMheMutation>;
export type RemoveStorageTypeMheMutationResult = Apollo.MutationResult<RemoveStorageTypeMheMutation>;
export type RemoveStorageTypeMheMutationOptions = Apollo.BaseMutationOptions<RemoveStorageTypeMheMutation, RemoveStorageTypeMheMutationVariables>;
export const CreateSupplierDocument = gql`
    mutation createSupplier($input: SupplierInput) {
  createSupplier(input: $input) {
    ...supplier
  }
}
    ${SupplierFragmentDoc}`;
export type CreateSupplierMutationFn = Apollo.MutationFunction<CreateSupplierMutation, CreateSupplierMutationVariables>;

/**
 * __useCreateSupplierMutation__
 *
 * To run a mutation, you first call `useCreateSupplierMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSupplierMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSupplierMutation, { data, loading, error }] = useCreateSupplierMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSupplierMutation(baseOptions?: Apollo.MutationHookOptions<CreateSupplierMutation, CreateSupplierMutationVariables>) {
        return Apollo.useMutation<CreateSupplierMutation, CreateSupplierMutationVariables>(CreateSupplierDocument, baseOptions);
      }
export type CreateSupplierMutationHookResult = ReturnType<typeof useCreateSupplierMutation>;
export type CreateSupplierMutationResult = Apollo.MutationResult<CreateSupplierMutation>;
export type CreateSupplierMutationOptions = Apollo.BaseMutationOptions<CreateSupplierMutation, CreateSupplierMutationVariables>;
export const UpdateSupplierDocument = gql`
    mutation updateSupplier($id: Int!, $input: SupplierUpdateInput) {
  updateSupplier(id: $id, input: $input) {
    ...supplier
  }
}
    ${SupplierFragmentDoc}`;
export type UpdateSupplierMutationFn = Apollo.MutationFunction<UpdateSupplierMutation, UpdateSupplierMutationVariables>;

/**
 * __useUpdateSupplierMutation__
 *
 * To run a mutation, you first call `useUpdateSupplierMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSupplierMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSupplierMutation, { data, loading, error }] = useUpdateSupplierMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSupplierMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSupplierMutation, UpdateSupplierMutationVariables>) {
        return Apollo.useMutation<UpdateSupplierMutation, UpdateSupplierMutationVariables>(UpdateSupplierDocument, baseOptions);
      }
export type UpdateSupplierMutationHookResult = ReturnType<typeof useUpdateSupplierMutation>;
export type UpdateSupplierMutationResult = Apollo.MutationResult<UpdateSupplierMutation>;
export type UpdateSupplierMutationOptions = Apollo.BaseMutationOptions<UpdateSupplierMutation, UpdateSupplierMutationVariables>;
export const DeleteSupplierDocument = gql`
    mutation deleteSupplier($id: Int!) {
  deleteSupplier(id: $id) {
    ...supplier
  }
}
    ${SupplierFragmentDoc}`;
export type DeleteSupplierMutationFn = Apollo.MutationFunction<DeleteSupplierMutation, DeleteSupplierMutationVariables>;

/**
 * __useDeleteSupplierMutation__
 *
 * To run a mutation, you first call `useDeleteSupplierMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSupplierMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSupplierMutation, { data, loading, error }] = useDeleteSupplierMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteSupplierMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSupplierMutation, DeleteSupplierMutationVariables>) {
        return Apollo.useMutation<DeleteSupplierMutation, DeleteSupplierMutationVariables>(DeleteSupplierDocument, baseOptions);
      }
export type DeleteSupplierMutationHookResult = ReturnType<typeof useDeleteSupplierMutation>;
export type DeleteSupplierMutationResult = Apollo.MutationResult<DeleteSupplierMutation>;
export type DeleteSupplierMutationOptions = Apollo.BaseMutationOptions<DeleteSupplierMutation, DeleteSupplierMutationVariables>;
export const UploadFileDocument = gql`
    mutation uploadFile($file: Upload!) {
  uploadFile(file: $file) {
    filename
    fileSize
    mimeType
    preview {
      header
      records
    }
  }
}
    `;
export type UploadFileMutationFn = Apollo.MutationFunction<UploadFileMutation, UploadFileMutationVariables>;

/**
 * __useUploadFileMutation__
 *
 * To run a mutation, you first call `useUploadFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadFileMutation, { data, loading, error }] = useUploadFileMutation({
 *   variables: {
 *      file: // value for 'file'
 *   },
 * });
 */
export function useUploadFileMutation(baseOptions?: Apollo.MutationHookOptions<UploadFileMutation, UploadFileMutationVariables>) {
        return Apollo.useMutation<UploadFileMutation, UploadFileMutationVariables>(UploadFileDocument, baseOptions);
      }
export type UploadFileMutationHookResult = ReturnType<typeof useUploadFileMutation>;
export type UploadFileMutationResult = Apollo.MutationResult<UploadFileMutation>;
export type UploadFileMutationOptions = Apollo.BaseMutationOptions<UploadFileMutation, UploadFileMutationVariables>;
export const AddUserDocument = gql`
    mutation addUser($input: UserInput) {
  addUser(input: $input) {
    __typename
    ... on WMSUser {
      id
      userName
    }
  }
}
    `;
export type AddUserMutationFn = Apollo.MutationFunction<AddUserMutation, AddUserMutationVariables>;

/**
 * __useAddUserMutation__
 *
 * To run a mutation, you first call `useAddUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addUserMutation, { data, loading, error }] = useAddUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddUserMutation(baseOptions?: Apollo.MutationHookOptions<AddUserMutation, AddUserMutationVariables>) {
        return Apollo.useMutation<AddUserMutation, AddUserMutationVariables>(AddUserDocument, baseOptions);
      }
export type AddUserMutationHookResult = ReturnType<typeof useAddUserMutation>;
export type AddUserMutationResult = Apollo.MutationResult<AddUserMutation>;
export type AddUserMutationOptions = Apollo.BaseMutationOptions<AddUserMutation, AddUserMutationVariables>;
export const UpdateUserDocument = gql`
    mutation updateUser($id: String, $input: UserUpdateInput) {
  updateUser(id: $id, input: $input) {
    __typename
    ... on WMSUser {
      id
      userName
    }
    ... on ValidationError {
      messages
    }
    ... on DatabaseError {
      message
    }
  }
}
    `;
export type UpdateUserMutationFn = Apollo.MutationFunction<UpdateUserMutation, UpdateUserMutationVariables>;

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdateUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserMutation, UpdateUserMutationVariables>) {
        return Apollo.useMutation<UpdateUserMutation, UpdateUserMutationVariables>(UpdateUserDocument, baseOptions);
      }
export type UpdateUserMutationHookResult = ReturnType<typeof useUpdateUserMutation>;
export type UpdateUserMutationResult = Apollo.MutationResult<UpdateUserMutation>;
export type UpdateUserMutationOptions = Apollo.BaseMutationOptions<UpdateUserMutation, UpdateUserMutationVariables>;
export const UpdateUserMenusDocument = gql`
    mutation updateUserMenus($id: String, $input: UserUpdateInput) {
  updateUser(id: $id, input: $input) {
    __typename
    ... on WMSUser {
      id
      userMenus {
        ...menuEntry
        screen {
          ...screen
        }
        parent {
          ...menuEntry
          screen {
            ...screen
          }
        }
        children {
          ...menuEntry
          screen {
            ...screen
          }
          children {
            ...menuEntry
            screen {
              ...screen
            }
            children {
              ...menuEntry
              screen {
                ...screen
              }
              children {
                ...menuEntry
                screen {
                  ...screen
                }
              }
            }
          }
        }
      }
    }
    ... on ValidationError {
      messages
    }
    ... on DatabaseError {
      message
    }
  }
}
    ${MenuEntryFragmentDoc}
${ScreenFragmentDoc}`;
export type UpdateUserMenusMutationFn = Apollo.MutationFunction<UpdateUserMenusMutation, UpdateUserMenusMutationVariables>;

/**
 * __useUpdateUserMenusMutation__
 *
 * To run a mutation, you first call `useUpdateUserMenusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMenusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMenusMutation, { data, loading, error }] = useUpdateUserMenusMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserMenusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserMenusMutation, UpdateUserMenusMutationVariables>) {
        return Apollo.useMutation<UpdateUserMenusMutation, UpdateUserMenusMutationVariables>(UpdateUserMenusDocument, baseOptions);
      }
export type UpdateUserMenusMutationHookResult = ReturnType<typeof useUpdateUserMenusMutation>;
export type UpdateUserMenusMutationResult = Apollo.MutationResult<UpdateUserMenusMutation>;
export type UpdateUserMenusMutationOptions = Apollo.BaseMutationOptions<UpdateUserMenusMutation, UpdateUserMenusMutationVariables>;
export const DeleteUserDocument = gql`
    mutation deleteUser($id: String) {
  deleteUser(id: $id) {
    __typename
    ... on WMSUser {
      id
      userName
    }
  }
}
    `;
export type DeleteUserMutationFn = Apollo.MutationFunction<DeleteUserMutation, DeleteUserMutationVariables>;

/**
 * __useDeleteUserMutation__
 *
 * To run a mutation, you first call `useDeleteUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserMutation, { data, loading, error }] = useDeleteUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteUserMutation(baseOptions?: Apollo.MutationHookOptions<DeleteUserMutation, DeleteUserMutationVariables>) {
        return Apollo.useMutation<DeleteUserMutation, DeleteUserMutationVariables>(DeleteUserDocument, baseOptions);
      }
export type DeleteUserMutationHookResult = ReturnType<typeof useDeleteUserMutation>;
export type DeleteUserMutationResult = Apollo.MutationResult<DeleteUserMutation>;
export type DeleteUserMutationOptions = Apollo.BaseMutationOptions<DeleteUserMutation, DeleteUserMutationVariables>;
export const ChangePasswordDocument = gql`
    mutation changePassword($newPassword: String, $oldPassword: String) {
  changePassword(newPassword: $newPassword, oldPassword: $oldPassword) {
    __typename
    ... on WMSUser {
      userName
    }
    ... on ValidationError {
      field
      messages
    }
    ... on DatabaseError {
      message
    }
  }
}
    `;
export type ChangePasswordMutationFn = Apollo.MutationFunction<ChangePasswordMutation, ChangePasswordMutationVariables>;

/**
 * __useChangePasswordMutation__
 *
 * To run a mutation, you first call `useChangePasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangePasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changePasswordMutation, { data, loading, error }] = useChangePasswordMutation({
 *   variables: {
 *      newPassword: // value for 'newPassword'
 *      oldPassword: // value for 'oldPassword'
 *   },
 * });
 */
export function useChangePasswordMutation(baseOptions?: Apollo.MutationHookOptions<ChangePasswordMutation, ChangePasswordMutationVariables>) {
        return Apollo.useMutation<ChangePasswordMutation, ChangePasswordMutationVariables>(ChangePasswordDocument, baseOptions);
      }
export type ChangePasswordMutationHookResult = ReturnType<typeof useChangePasswordMutation>;
export type ChangePasswordMutationResult = Apollo.MutationResult<ChangePasswordMutation>;
export type ChangePasswordMutationOptions = Apollo.BaseMutationOptions<ChangePasswordMutation, ChangePasswordMutationVariables>;
export const CreateUserPermissionDocument = gql`
    mutation createUserPermission($input: UserPermissionInput) {
  createUserPermission(input: $input) {
    id
  }
}
    `;
export type CreateUserPermissionMutationFn = Apollo.MutationFunction<CreateUserPermissionMutation, CreateUserPermissionMutationVariables>;

/**
 * __useCreateUserPermissionMutation__
 *
 * To run a mutation, you first call `useCreateUserPermissionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserPermissionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserPermissionMutation, { data, loading, error }] = useCreateUserPermissionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateUserPermissionMutation(baseOptions?: Apollo.MutationHookOptions<CreateUserPermissionMutation, CreateUserPermissionMutationVariables>) {
        return Apollo.useMutation<CreateUserPermissionMutation, CreateUserPermissionMutationVariables>(CreateUserPermissionDocument, baseOptions);
      }
export type CreateUserPermissionMutationHookResult = ReturnType<typeof useCreateUserPermissionMutation>;
export type CreateUserPermissionMutationResult = Apollo.MutationResult<CreateUserPermissionMutation>;
export type CreateUserPermissionMutationOptions = Apollo.BaseMutationOptions<CreateUserPermissionMutation, CreateUserPermissionMutationVariables>;
export const UpdateUserPermissionDocument = gql`
    mutation updateUserPermission($id: Int!, $input: UserPermissionUpdateInput, $userContext: UserContextInput) {
  updateUserPermission(id: $id, input: $input, userContext: $userContext) {
    id
  }
}
    `;
export type UpdateUserPermissionMutationFn = Apollo.MutationFunction<UpdateUserPermissionMutation, UpdateUserPermissionMutationVariables>;

/**
 * __useUpdateUserPermissionMutation__
 *
 * To run a mutation, you first call `useUpdateUserPermissionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserPermissionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserPermissionMutation, { data, loading, error }] = useUpdateUserPermissionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *      userContext: // value for 'userContext'
 *   },
 * });
 */
export function useUpdateUserPermissionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserPermissionMutation, UpdateUserPermissionMutationVariables>) {
        return Apollo.useMutation<UpdateUserPermissionMutation, UpdateUserPermissionMutationVariables>(UpdateUserPermissionDocument, baseOptions);
      }
export type UpdateUserPermissionMutationHookResult = ReturnType<typeof useUpdateUserPermissionMutation>;
export type UpdateUserPermissionMutationResult = Apollo.MutationResult<UpdateUserPermissionMutation>;
export type UpdateUserPermissionMutationOptions = Apollo.BaseMutationOptions<UpdateUserPermissionMutation, UpdateUserPermissionMutationVariables>;
export const DeleteUserPermissionDocument = gql`
    mutation deleteUserPermission($id: Int!, $userContext: UserContextInput) {
  deleteUserPermission(id: $id, userContext: $userContext) {
    id
  }
}
    `;
export type DeleteUserPermissionMutationFn = Apollo.MutationFunction<DeleteUserPermissionMutation, DeleteUserPermissionMutationVariables>;

/**
 * __useDeleteUserPermissionMutation__
 *
 * To run a mutation, you first call `useDeleteUserPermissionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserPermissionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserPermissionMutation, { data, loading, error }] = useDeleteUserPermissionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      userContext: // value for 'userContext'
 *   },
 * });
 */
export function useDeleteUserPermissionMutation(baseOptions?: Apollo.MutationHookOptions<DeleteUserPermissionMutation, DeleteUserPermissionMutationVariables>) {
        return Apollo.useMutation<DeleteUserPermissionMutation, DeleteUserPermissionMutationVariables>(DeleteUserPermissionDocument, baseOptions);
      }
export type DeleteUserPermissionMutationHookResult = ReturnType<typeof useDeleteUserPermissionMutation>;
export type DeleteUserPermissionMutationResult = Apollo.MutationResult<DeleteUserPermissionMutation>;
export type DeleteUserPermissionMutationOptions = Apollo.BaseMutationOptions<DeleteUserPermissionMutation, DeleteUserPermissionMutationVariables>;
export const CreateWarehouseDocument = gql`
    mutation createWarehouse($input: WarehouseInput) {
  createWarehouse(input: $input) {
    ...warehouse
    address {
      ...address
    }
  }
}
    ${WarehouseFragmentDoc}
${AddressFragmentDoc}`;
export type CreateWarehouseMutationFn = Apollo.MutationFunction<CreateWarehouseMutation, CreateWarehouseMutationVariables>;

/**
 * __useCreateWarehouseMutation__
 *
 * To run a mutation, you first call `useCreateWarehouseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWarehouseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWarehouseMutation, { data, loading, error }] = useCreateWarehouseMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateWarehouseMutation(baseOptions?: Apollo.MutationHookOptions<CreateWarehouseMutation, CreateWarehouseMutationVariables>) {
        return Apollo.useMutation<CreateWarehouseMutation, CreateWarehouseMutationVariables>(CreateWarehouseDocument, baseOptions);
      }
export type CreateWarehouseMutationHookResult = ReturnType<typeof useCreateWarehouseMutation>;
export type CreateWarehouseMutationResult = Apollo.MutationResult<CreateWarehouseMutation>;
export type CreateWarehouseMutationOptions = Apollo.BaseMutationOptions<CreateWarehouseMutation, CreateWarehouseMutationVariables>;
export const UpdateWarehouseDocument = gql`
    mutation updateWarehouse($id: Int!, $input: WarehouseUpdateInput) {
  updateWarehouse(id: $id, input: $input) {
    ...warehouse
    address {
      ...address
    }
  }
}
    ${WarehouseFragmentDoc}
${AddressFragmentDoc}`;
export type UpdateWarehouseMutationFn = Apollo.MutationFunction<UpdateWarehouseMutation, UpdateWarehouseMutationVariables>;

/**
 * __useUpdateWarehouseMutation__
 *
 * To run a mutation, you first call `useUpdateWarehouseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWarehouseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWarehouseMutation, { data, loading, error }] = useUpdateWarehouseMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateWarehouseMutation(baseOptions?: Apollo.MutationHookOptions<UpdateWarehouseMutation, UpdateWarehouseMutationVariables>) {
        return Apollo.useMutation<UpdateWarehouseMutation, UpdateWarehouseMutationVariables>(UpdateWarehouseDocument, baseOptions);
      }
export type UpdateWarehouseMutationHookResult = ReturnType<typeof useUpdateWarehouseMutation>;
export type UpdateWarehouseMutationResult = Apollo.MutationResult<UpdateWarehouseMutation>;
export type UpdateWarehouseMutationOptions = Apollo.BaseMutationOptions<UpdateWarehouseMutation, UpdateWarehouseMutationVariables>;
export const DeleteWarehouseDocument = gql`
    mutation deleteWarehouse($id: Int!) {
  deleteWarehouse(id: $id) {
    ...warehouse
  }
}
    ${WarehouseFragmentDoc}`;
export type DeleteWarehouseMutationFn = Apollo.MutationFunction<DeleteWarehouseMutation, DeleteWarehouseMutationVariables>;

/**
 * __useDeleteWarehouseMutation__
 *
 * To run a mutation, you first call `useDeleteWarehouseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteWarehouseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteWarehouseMutation, { data, loading, error }] = useDeleteWarehouseMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteWarehouseMutation(baseOptions?: Apollo.MutationHookOptions<DeleteWarehouseMutation, DeleteWarehouseMutationVariables>) {
        return Apollo.useMutation<DeleteWarehouseMutation, DeleteWarehouseMutationVariables>(DeleteWarehouseDocument, baseOptions);
      }
export type DeleteWarehouseMutationHookResult = ReturnType<typeof useDeleteWarehouseMutation>;
export type DeleteWarehouseMutationResult = Apollo.MutationResult<DeleteWarehouseMutation>;
export type DeleteWarehouseMutationOptions = Apollo.BaseMutationOptions<DeleteWarehouseMutation, DeleteWarehouseMutationVariables>;
export const CreateWarehouseZoneDocument = gql`
    mutation createWarehouseZone($input: WarehouseZoneInput, $userContext: UserContextInput) {
  createWarehouseZone(input: $input, userContext: $userContext) {
    ...warehouseZone
  }
}
    ${WarehouseZoneFragmentDoc}`;
export type CreateWarehouseZoneMutationFn = Apollo.MutationFunction<CreateWarehouseZoneMutation, CreateWarehouseZoneMutationVariables>;

/**
 * __useCreateWarehouseZoneMutation__
 *
 * To run a mutation, you first call `useCreateWarehouseZoneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWarehouseZoneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWarehouseZoneMutation, { data, loading, error }] = useCreateWarehouseZoneMutation({
 *   variables: {
 *      input: // value for 'input'
 *      userContext: // value for 'userContext'
 *   },
 * });
 */
export function useCreateWarehouseZoneMutation(baseOptions?: Apollo.MutationHookOptions<CreateWarehouseZoneMutation, CreateWarehouseZoneMutationVariables>) {
        return Apollo.useMutation<CreateWarehouseZoneMutation, CreateWarehouseZoneMutationVariables>(CreateWarehouseZoneDocument, baseOptions);
      }
export type CreateWarehouseZoneMutationHookResult = ReturnType<typeof useCreateWarehouseZoneMutation>;
export type CreateWarehouseZoneMutationResult = Apollo.MutationResult<CreateWarehouseZoneMutation>;
export type CreateWarehouseZoneMutationOptions = Apollo.BaseMutationOptions<CreateWarehouseZoneMutation, CreateWarehouseZoneMutationVariables>;
export const UpdateWarehouseZoneDocument = gql`
    mutation updateWarehouseZone($id: Int!, $input: WarehouseZoneUpdateInput, $userContext: UserContextInput) {
  updateWarehouseZone(id: $id, input: $input, userContext: $userContext) {
    ...warehouseZone
  }
}
    ${WarehouseZoneFragmentDoc}`;
export type UpdateWarehouseZoneMutationFn = Apollo.MutationFunction<UpdateWarehouseZoneMutation, UpdateWarehouseZoneMutationVariables>;

/**
 * __useUpdateWarehouseZoneMutation__
 *
 * To run a mutation, you first call `useUpdateWarehouseZoneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWarehouseZoneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWarehouseZoneMutation, { data, loading, error }] = useUpdateWarehouseZoneMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *      userContext: // value for 'userContext'
 *   },
 * });
 */
export function useUpdateWarehouseZoneMutation(baseOptions?: Apollo.MutationHookOptions<UpdateWarehouseZoneMutation, UpdateWarehouseZoneMutationVariables>) {
        return Apollo.useMutation<UpdateWarehouseZoneMutation, UpdateWarehouseZoneMutationVariables>(UpdateWarehouseZoneDocument, baseOptions);
      }
export type UpdateWarehouseZoneMutationHookResult = ReturnType<typeof useUpdateWarehouseZoneMutation>;
export type UpdateWarehouseZoneMutationResult = Apollo.MutationResult<UpdateWarehouseZoneMutation>;
export type UpdateWarehouseZoneMutationOptions = Apollo.BaseMutationOptions<UpdateWarehouseZoneMutation, UpdateWarehouseZoneMutationVariables>;
export const DeleteWarehouseZoneDocument = gql`
    mutation deleteWarehouseZone($id: Int!, $userContext: UserContextInput) {
  deleteWarehouseZone(id: $id, userContext: $userContext) {
    id
  }
}
    `;
export type DeleteWarehouseZoneMutationFn = Apollo.MutationFunction<DeleteWarehouseZoneMutation, DeleteWarehouseZoneMutationVariables>;

/**
 * __useDeleteWarehouseZoneMutation__
 *
 * To run a mutation, you first call `useDeleteWarehouseZoneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteWarehouseZoneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteWarehouseZoneMutation, { data, loading, error }] = useDeleteWarehouseZoneMutation({
 *   variables: {
 *      id: // value for 'id'
 *      userContext: // value for 'userContext'
 *   },
 * });
 */
export function useDeleteWarehouseZoneMutation(baseOptions?: Apollo.MutationHookOptions<DeleteWarehouseZoneMutation, DeleteWarehouseZoneMutationVariables>) {
        return Apollo.useMutation<DeleteWarehouseZoneMutation, DeleteWarehouseZoneMutationVariables>(DeleteWarehouseZoneDocument, baseOptions);
      }
export type DeleteWarehouseZoneMutationHookResult = ReturnType<typeof useDeleteWarehouseZoneMutation>;
export type DeleteWarehouseZoneMutationResult = Apollo.MutationResult<DeleteWarehouseZoneMutation>;
export type DeleteWarehouseZoneMutationOptions = Apollo.BaseMutationOptions<DeleteWarehouseZoneMutation, DeleteWarehouseZoneMutationVariables>;
export const EnumDocument = gql`
    query Enum($name: String!) {
  enum: __type(name: $name) {
    values: enumValues {
      name
    }
  }
}
    `;

/**
 * __useEnumQuery__
 *
 * To run a query within a React component, call `useEnumQuery` and pass it any options that fit your needs.
 * When your component renders, `useEnumQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEnumQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useEnumQuery(baseOptions: Apollo.QueryHookOptions<EnumQuery, EnumQueryVariables>) {
        return Apollo.useQuery<EnumQuery, EnumQueryVariables>(EnumDocument, baseOptions);
      }
export function useEnumLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EnumQuery, EnumQueryVariables>) {
          return Apollo.useLazyQuery<EnumQuery, EnumQueryVariables>(EnumDocument, baseOptions);
        }
export type EnumQueryHookResult = ReturnType<typeof useEnumQuery>;
export type EnumLazyQueryHookResult = ReturnType<typeof useEnumLazyQuery>;
export type EnumQueryResult = Apollo.QueryResult<EnumQuery, EnumQueryVariables>;
export const ActivitiesDocument = gql`
    query activities {
  activities @client {
    ...activity
  }
}
    ${ActivityFragmentDoc}`;

/**
 * __useActivitiesQuery__
 *
 * To run a query within a React component, call `useActivitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useActivitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActivitiesQuery({
 *   variables: {
 *   },
 * });
 */
export function useActivitiesQuery(baseOptions?: Apollo.QueryHookOptions<ActivitiesQuery, ActivitiesQueryVariables>) {
        return Apollo.useQuery<ActivitiesQuery, ActivitiesQueryVariables>(ActivitiesDocument, baseOptions);
      }
export function useActivitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ActivitiesQuery, ActivitiesQueryVariables>) {
          return Apollo.useLazyQuery<ActivitiesQuery, ActivitiesQueryVariables>(ActivitiesDocument, baseOptions);
        }
export type ActivitiesQueryHookResult = ReturnType<typeof useActivitiesQuery>;
export type ActivitiesLazyQueryHookResult = ReturnType<typeof useActivitiesLazyQuery>;
export type ActivitiesQueryResult = Apollo.QueryResult<ActivitiesQuery, ActivitiesQueryVariables>;
export const AuditsDocument = gql`
    query audits($filterInput: AuditEntryFilterInput, $userContext: UserContextInput, $first: Int, $after: String, $before: String) {
  audits(
    where: $filterInput
    userContext: $userContext
    first: $first
    after: $after
    before: $before
  ) {
    totalCount
    pageInfo {
      hasNextPage
      startCursor
      endCursor
      startCursor
    }
    nodes {
      ...auditLog
    }
  }
}
    ${AuditLogFragmentDoc}`;

/**
 * __useAuditsQuery__
 *
 * To run a query within a React component, call `useAuditsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAuditsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAuditsQuery({
 *   variables: {
 *      filterInput: // value for 'filterInput'
 *      userContext: // value for 'userContext'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *   },
 * });
 */
export function useAuditsQuery(baseOptions?: Apollo.QueryHookOptions<AuditsQuery, AuditsQueryVariables>) {
        return Apollo.useQuery<AuditsQuery, AuditsQueryVariables>(AuditsDocument, baseOptions);
      }
export function useAuditsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AuditsQuery, AuditsQueryVariables>) {
          return Apollo.useLazyQuery<AuditsQuery, AuditsQueryVariables>(AuditsDocument, baseOptions);
        }
export type AuditsQueryHookResult = ReturnType<typeof useAuditsQuery>;
export type AuditsLazyQueryHookResult = ReturnType<typeof useAuditsLazyQuery>;
export type AuditsQueryResult = Apollo.QueryResult<AuditsQuery, AuditsQueryVariables>;
export const AuditCodesDocument = gql`
    query auditCodes {
  auditCodes {
    nodes {
      id
      code
      description
      message
    }
  }
}
    `;

/**
 * __useAuditCodesQuery__
 *
 * To run a query within a React component, call `useAuditCodesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAuditCodesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAuditCodesQuery({
 *   variables: {
 *   },
 * });
 */
export function useAuditCodesQuery(baseOptions?: Apollo.QueryHookOptions<AuditCodesQuery, AuditCodesQueryVariables>) {
        return Apollo.useQuery<AuditCodesQuery, AuditCodesQueryVariables>(AuditCodesDocument, baseOptions);
      }
export function useAuditCodesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AuditCodesQuery, AuditCodesQueryVariables>) {
          return Apollo.useLazyQuery<AuditCodesQuery, AuditCodesQueryVariables>(AuditCodesDocument, baseOptions);
        }
export type AuditCodesQueryHookResult = ReturnType<typeof useAuditCodesQuery>;
export type AuditCodesLazyQueryHookResult = ReturnType<typeof useAuditCodesLazyQuery>;
export type AuditCodesQueryResult = Apollo.QueryResult<AuditCodesQuery, AuditCodesQueryVariables>;
export const BudgetHoldersDocument = gql`
    query budgetHolders($filterInput: BudgetHolderFilterInput, $userContext: UserContextInput) {
  budgetHolders(where: $filterInput, userContext: $userContext) {
    nodes {
      ...budgetHolder
    }
  }
}
    ${BudgetHolderFragmentDoc}`;

/**
 * __useBudgetHoldersQuery__
 *
 * To run a query within a React component, call `useBudgetHoldersQuery` and pass it any options that fit your needs.
 * When your component renders, `useBudgetHoldersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBudgetHoldersQuery({
 *   variables: {
 *      filterInput: // value for 'filterInput'
 *      userContext: // value for 'userContext'
 *   },
 * });
 */
export function useBudgetHoldersQuery(baseOptions?: Apollo.QueryHookOptions<BudgetHoldersQuery, BudgetHoldersQueryVariables>) {
        return Apollo.useQuery<BudgetHoldersQuery, BudgetHoldersQueryVariables>(BudgetHoldersDocument, baseOptions);
      }
export function useBudgetHoldersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BudgetHoldersQuery, BudgetHoldersQueryVariables>) {
          return Apollo.useLazyQuery<BudgetHoldersQuery, BudgetHoldersQueryVariables>(BudgetHoldersDocument, baseOptions);
        }
export type BudgetHoldersQueryHookResult = ReturnType<typeof useBudgetHoldersQuery>;
export type BudgetHoldersLazyQueryHookResult = ReturnType<typeof useBudgetHoldersLazyQuery>;
export type BudgetHoldersQueryResult = Apollo.QueryResult<BudgetHoldersQuery, BudgetHoldersQueryVariables>;
export const BudgetHoldersPaginatedDocument = gql`
    query budgetHoldersPaginated($filterInput: BudgetHolderFilterInput, $userContext: UserContextInput, $first: Int, $after: String) {
  budgetHolders(
    where: $filterInput
    userContext: $userContext
    first: $first
    after: $after
  ) {
    pageInfo {
      endCursor
      startCursor
      hasNextPage
      hasPreviousPage
    }
    totalCount
    nodes {
      ...budgetHolder
    }
  }
}
    ${BudgetHolderFragmentDoc}`;

/**
 * __useBudgetHoldersPaginatedQuery__
 *
 * To run a query within a React component, call `useBudgetHoldersPaginatedQuery` and pass it any options that fit your needs.
 * When your component renders, `useBudgetHoldersPaginatedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBudgetHoldersPaginatedQuery({
 *   variables: {
 *      filterInput: // value for 'filterInput'
 *      userContext: // value for 'userContext'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useBudgetHoldersPaginatedQuery(baseOptions?: Apollo.QueryHookOptions<BudgetHoldersPaginatedQuery, BudgetHoldersPaginatedQueryVariables>) {
        return Apollo.useQuery<BudgetHoldersPaginatedQuery, BudgetHoldersPaginatedQueryVariables>(BudgetHoldersPaginatedDocument, baseOptions);
      }
export function useBudgetHoldersPaginatedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BudgetHoldersPaginatedQuery, BudgetHoldersPaginatedQueryVariables>) {
          return Apollo.useLazyQuery<BudgetHoldersPaginatedQuery, BudgetHoldersPaginatedQueryVariables>(BudgetHoldersPaginatedDocument, baseOptions);
        }
export type BudgetHoldersPaginatedQueryHookResult = ReturnType<typeof useBudgetHoldersPaginatedQuery>;
export type BudgetHoldersPaginatedLazyQueryHookResult = ReturnType<typeof useBudgetHoldersPaginatedLazyQuery>;
export type BudgetHoldersPaginatedQueryResult = Apollo.QueryResult<BudgetHoldersPaginatedQuery, BudgetHoldersPaginatedQueryVariables>;
export const BudgetHolderByIdDocument = gql`
    query budgetHolderById($id: Int!, $userContext: UserContextInput) {
  budgetHolderById(id: $id, userContext: $userContext) {
    ...budgetHolder
  }
}
    ${BudgetHolderFragmentDoc}`;

/**
 * __useBudgetHolderByIdQuery__
 *
 * To run a query within a React component, call `useBudgetHolderByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useBudgetHolderByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBudgetHolderByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *      userContext: // value for 'userContext'
 *   },
 * });
 */
export function useBudgetHolderByIdQuery(baseOptions: Apollo.QueryHookOptions<BudgetHolderByIdQuery, BudgetHolderByIdQueryVariables>) {
        return Apollo.useQuery<BudgetHolderByIdQuery, BudgetHolderByIdQueryVariables>(BudgetHolderByIdDocument, baseOptions);
      }
export function useBudgetHolderByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BudgetHolderByIdQuery, BudgetHolderByIdQueryVariables>) {
          return Apollo.useLazyQuery<BudgetHolderByIdQuery, BudgetHolderByIdQueryVariables>(BudgetHolderByIdDocument, baseOptions);
        }
export type BudgetHolderByIdQueryHookResult = ReturnType<typeof useBudgetHolderByIdQuery>;
export type BudgetHolderByIdLazyQueryHookResult = ReturnType<typeof useBudgetHolderByIdLazyQuery>;
export type BudgetHolderByIdQueryResult = Apollo.QueryResult<BudgetHolderByIdQuery, BudgetHolderByIdQueryVariables>;
export const CarriersDocument = gql`
    query carriers($filterInput: CarrierFilterInput, $userContext: UserContextInput) {
  carriers(where: $filterInput, userContext: $userContext) {
    nodes {
      ...carrier
      accounts {
        ...carrierAccount
      }
      services {
        ...carrierService
      }
    }
  }
}
    ${CarrierFragmentDoc}
${CarrierAccountFragmentDoc}
${CarrierServiceFragmentDoc}`;

/**
 * __useCarriersQuery__
 *
 * To run a query within a React component, call `useCarriersQuery` and pass it any options that fit your needs.
 * When your component renders, `useCarriersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCarriersQuery({
 *   variables: {
 *      filterInput: // value for 'filterInput'
 *      userContext: // value for 'userContext'
 *   },
 * });
 */
export function useCarriersQuery(baseOptions?: Apollo.QueryHookOptions<CarriersQuery, CarriersQueryVariables>) {
        return Apollo.useQuery<CarriersQuery, CarriersQueryVariables>(CarriersDocument, baseOptions);
      }
export function useCarriersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CarriersQuery, CarriersQueryVariables>) {
          return Apollo.useLazyQuery<CarriersQuery, CarriersQueryVariables>(CarriersDocument, baseOptions);
        }
export type CarriersQueryHookResult = ReturnType<typeof useCarriersQuery>;
export type CarriersLazyQueryHookResult = ReturnType<typeof useCarriersLazyQuery>;
export type CarriersQueryResult = Apollo.QueryResult<CarriersQuery, CarriersQueryVariables>;
export const CarrierByIdDocument = gql`
    query carrierById($id: Int!, $userContext: UserContextInput) {
  carrierById(id: $id, userContext: $userContext) {
    ...carrier
    accounts {
      ...carrierAccount
    }
    services {
      ...carrierService
    }
  }
}
    ${CarrierFragmentDoc}
${CarrierAccountFragmentDoc}
${CarrierServiceFragmentDoc}`;

/**
 * __useCarrierByIdQuery__
 *
 * To run a query within a React component, call `useCarrierByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useCarrierByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCarrierByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *      userContext: // value for 'userContext'
 *   },
 * });
 */
export function useCarrierByIdQuery(baseOptions: Apollo.QueryHookOptions<CarrierByIdQuery, CarrierByIdQueryVariables>) {
        return Apollo.useQuery<CarrierByIdQuery, CarrierByIdQueryVariables>(CarrierByIdDocument, baseOptions);
      }
export function useCarrierByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CarrierByIdQuery, CarrierByIdQueryVariables>) {
          return Apollo.useLazyQuery<CarrierByIdQuery, CarrierByIdQueryVariables>(CarrierByIdDocument, baseOptions);
        }
export type CarrierByIdQueryHookResult = ReturnType<typeof useCarrierByIdQuery>;
export type CarrierByIdLazyQueryHookResult = ReturnType<typeof useCarrierByIdLazyQuery>;
export type CarrierByIdQueryResult = Apollo.QueryResult<CarrierByIdQuery, CarrierByIdQueryVariables>;
export const CarriersPaginaterDocument = gql`
    query carriersPaginater($filterInput: CarrierFilterInput, $userContext: UserContextInput, $first: Int, $after: String) {
  carriers(
    where: $filterInput
    userContext: $userContext
    first: $first
    after: $after
  ) {
    totalCount
    pageInfo {
      hasNextPage
      endCursor
    }
    nodes {
      id
      code
      name
    }
  }
}
    `;

/**
 * __useCarriersPaginaterQuery__
 *
 * To run a query within a React component, call `useCarriersPaginaterQuery` and pass it any options that fit your needs.
 * When your component renders, `useCarriersPaginaterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCarriersPaginaterQuery({
 *   variables: {
 *      filterInput: // value for 'filterInput'
 *      userContext: // value for 'userContext'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useCarriersPaginaterQuery(baseOptions?: Apollo.QueryHookOptions<CarriersPaginaterQuery, CarriersPaginaterQueryVariables>) {
        return Apollo.useQuery<CarriersPaginaterQuery, CarriersPaginaterQueryVariables>(CarriersPaginaterDocument, baseOptions);
      }
export function useCarriersPaginaterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CarriersPaginaterQuery, CarriersPaginaterQueryVariables>) {
          return Apollo.useLazyQuery<CarriersPaginaterQuery, CarriersPaginaterQueryVariables>(CarriersPaginaterDocument, baseOptions);
        }
export type CarriersPaginaterQueryHookResult = ReturnType<typeof useCarriersPaginaterQuery>;
export type CarriersPaginaterLazyQueryHookResult = ReturnType<typeof useCarriersPaginaterLazyQuery>;
export type CarriersPaginaterQueryResult = Apollo.QueryResult<CarriersPaginaterQuery, CarriersPaginaterQueryVariables>;
export const CarrierModulesDocument = gql`
    query carrierModules {
  carrierModules
}
    `;

/**
 * __useCarrierModulesQuery__
 *
 * To run a query within a React component, call `useCarrierModulesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCarrierModulesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCarrierModulesQuery({
 *   variables: {
 *   },
 * });
 */
export function useCarrierModulesQuery(baseOptions?: Apollo.QueryHookOptions<CarrierModulesQuery, CarrierModulesQueryVariables>) {
        return Apollo.useQuery<CarrierModulesQuery, CarrierModulesQueryVariables>(CarrierModulesDocument, baseOptions);
      }
export function useCarrierModulesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CarrierModulesQuery, CarrierModulesQueryVariables>) {
          return Apollo.useLazyQuery<CarrierModulesQuery, CarrierModulesQueryVariables>(CarrierModulesDocument, baseOptions);
        }
export type CarrierModulesQueryHookResult = ReturnType<typeof useCarrierModulesQuery>;
export type CarrierModulesLazyQueryHookResult = ReturnType<typeof useCarrierModulesLazyQuery>;
export type CarrierModulesQueryResult = Apollo.QueryResult<CarrierModulesQuery, CarrierModulesQueryVariables>;
export const ConfigurationForModuleDocument = gql`
    query configurationForModule($module: String, $userContext: UserContextInput) {
  configurationForModule(module: $module, userContext: $userContext) {
    label
    overrideRequired
    position
    settingName
    type
  }
}
    `;

/**
 * __useConfigurationForModuleQuery__
 *
 * To run a query within a React component, call `useConfigurationForModuleQuery` and pass it any options that fit your needs.
 * When your component renders, `useConfigurationForModuleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConfigurationForModuleQuery({
 *   variables: {
 *      module: // value for 'module'
 *      userContext: // value for 'userContext'
 *   },
 * });
 */
export function useConfigurationForModuleQuery(baseOptions?: Apollo.QueryHookOptions<ConfigurationForModuleQuery, ConfigurationForModuleQueryVariables>) {
        return Apollo.useQuery<ConfigurationForModuleQuery, ConfigurationForModuleQueryVariables>(ConfigurationForModuleDocument, baseOptions);
      }
export function useConfigurationForModuleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ConfigurationForModuleQuery, ConfigurationForModuleQueryVariables>) {
          return Apollo.useLazyQuery<ConfigurationForModuleQuery, ConfigurationForModuleQueryVariables>(ConfigurationForModuleDocument, baseOptions);
        }
export type ConfigurationForModuleQueryHookResult = ReturnType<typeof useConfigurationForModuleQuery>;
export type ConfigurationForModuleLazyQueryHookResult = ReturnType<typeof useConfigurationForModuleLazyQuery>;
export type ConfigurationForModuleQueryResult = Apollo.QueryResult<ConfigurationForModuleQuery, ConfigurationForModuleQueryVariables>;
export const CodesDocument = gql`
    query codes($filterInput: UDCodeFilterInput, $userContext: UserContextInput) {
  codes(where: $filterInput, userContext: $userContext) {
    nodes {
      ...code
    }
  }
}
    ${CodeFragmentDoc}`;

/**
 * __useCodesQuery__
 *
 * To run a query within a React component, call `useCodesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCodesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCodesQuery({
 *   variables: {
 *      filterInput: // value for 'filterInput'
 *      userContext: // value for 'userContext'
 *   },
 * });
 */
export function useCodesQuery(baseOptions?: Apollo.QueryHookOptions<CodesQuery, CodesQueryVariables>) {
        return Apollo.useQuery<CodesQuery, CodesQueryVariables>(CodesDocument, baseOptions);
      }
export function useCodesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CodesQuery, CodesQueryVariables>) {
          return Apollo.useLazyQuery<CodesQuery, CodesQueryVariables>(CodesDocument, baseOptions);
        }
export type CodesQueryHookResult = ReturnType<typeof useCodesQuery>;
export type CodesLazyQueryHookResult = ReturnType<typeof useCodesLazyQuery>;
export type CodesQueryResult = Apollo.QueryResult<CodesQuery, CodesQueryVariables>;
export const CodeForTypeDocument = gql`
    query codeForType($codeType: String) {
  codesForType(codeType: $codeType) {
    nodes {
      ...code
    }
  }
}
    ${CodeFragmentDoc}`;

/**
 * __useCodeForTypeQuery__
 *
 * To run a query within a React component, call `useCodeForTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useCodeForTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCodeForTypeQuery({
 *   variables: {
 *      codeType: // value for 'codeType'
 *   },
 * });
 */
export function useCodeForTypeQuery(baseOptions?: Apollo.QueryHookOptions<CodeForTypeQuery, CodeForTypeQueryVariables>) {
        return Apollo.useQuery<CodeForTypeQuery, CodeForTypeQueryVariables>(CodeForTypeDocument, baseOptions);
      }
export function useCodeForTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CodeForTypeQuery, CodeForTypeQueryVariables>) {
          return Apollo.useLazyQuery<CodeForTypeQuery, CodeForTypeQueryVariables>(CodeForTypeDocument, baseOptions);
        }
export type CodeForTypeQueryHookResult = ReturnType<typeof useCodeForTypeQuery>;
export type CodeForTypeLazyQueryHookResult = ReturnType<typeof useCodeForTypeLazyQuery>;
export type CodeForTypeQueryResult = Apollo.QueryResult<CodeForTypeQuery, CodeForTypeQueryVariables>;
export const CodesPaginatedDocument = gql`
    query codesPaginated($filterInput: UDCodeFilterInput, $userContext: UserContextInput, $first: Int, $after: String, $before: String) {
  codes(
    where: $filterInput
    userContext: $userContext
    first: $first
    after: $after
    before: $before
  ) {
    totalCount
    pageInfo {
      hasNextPage
      startCursor
      endCursor
      startCursor
    }
    nodes {
      ...code
    }
  }
}
    ${CodeFragmentDoc}`;

/**
 * __useCodesPaginatedQuery__
 *
 * To run a query within a React component, call `useCodesPaginatedQuery` and pass it any options that fit your needs.
 * When your component renders, `useCodesPaginatedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCodesPaginatedQuery({
 *   variables: {
 *      filterInput: // value for 'filterInput'
 *      userContext: // value for 'userContext'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *   },
 * });
 */
export function useCodesPaginatedQuery(baseOptions?: Apollo.QueryHookOptions<CodesPaginatedQuery, CodesPaginatedQueryVariables>) {
        return Apollo.useQuery<CodesPaginatedQuery, CodesPaginatedQueryVariables>(CodesPaginatedDocument, baseOptions);
      }
export function useCodesPaginatedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CodesPaginatedQuery, CodesPaginatedQueryVariables>) {
          return Apollo.useLazyQuery<CodesPaginatedQuery, CodesPaginatedQueryVariables>(CodesPaginatedDocument, baseOptions);
        }
export type CodesPaginatedQueryHookResult = ReturnType<typeof useCodesPaginatedQuery>;
export type CodesPaginatedLazyQueryHookResult = ReturnType<typeof useCodesPaginatedLazyQuery>;
export type CodesPaginatedQueryResult = Apollo.QueryResult<CodesPaginatedQuery, CodesPaginatedQueryVariables>;
export const CodeForTypePaginatedDocument = gql`
    query codeForTypePaginated($codeType: String, $userContext: UserContextInput, $first: Int, $after: String, $before: String) {
  codesForType(
    codeType: $codeType
    userContext: $userContext
    first: $first
    after: $after
    before: $before
  ) {
    totalCount
    pageInfo {
      hasNextPage
      startCursor
      endCursor
      startCursor
    }
    nodes {
      ...code
    }
  }
}
    ${CodeFragmentDoc}`;

/**
 * __useCodeForTypePaginatedQuery__
 *
 * To run a query within a React component, call `useCodeForTypePaginatedQuery` and pass it any options that fit your needs.
 * When your component renders, `useCodeForTypePaginatedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCodeForTypePaginatedQuery({
 *   variables: {
 *      codeType: // value for 'codeType'
 *      userContext: // value for 'userContext'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *   },
 * });
 */
export function useCodeForTypePaginatedQuery(baseOptions?: Apollo.QueryHookOptions<CodeForTypePaginatedQuery, CodeForTypePaginatedQueryVariables>) {
        return Apollo.useQuery<CodeForTypePaginatedQuery, CodeForTypePaginatedQueryVariables>(CodeForTypePaginatedDocument, baseOptions);
      }
export function useCodeForTypePaginatedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CodeForTypePaginatedQuery, CodeForTypePaginatedQueryVariables>) {
          return Apollo.useLazyQuery<CodeForTypePaginatedQuery, CodeForTypePaginatedQueryVariables>(CodeForTypePaginatedDocument, baseOptions);
        }
export type CodeForTypePaginatedQueryHookResult = ReturnType<typeof useCodeForTypePaginatedQuery>;
export type CodeForTypePaginatedLazyQueryHookResult = ReturnType<typeof useCodeForTypePaginatedLazyQuery>;
export type CodeForTypePaginatedQueryResult = Apollo.QueryResult<CodeForTypePaginatedQuery, CodeForTypePaginatedQueryVariables>;
export const CodeDefinitionsDocument = gql`
    query codeDefinitions {
  codeDefinitions {
    nodes {
      ...codeDefinition
    }
  }
}
    ${CodeDefinitionFragmentDoc}`;

/**
 * __useCodeDefinitionsQuery__
 *
 * To run a query within a React component, call `useCodeDefinitionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCodeDefinitionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCodeDefinitionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCodeDefinitionsQuery(baseOptions?: Apollo.QueryHookOptions<CodeDefinitionsQuery, CodeDefinitionsQueryVariables>) {
        return Apollo.useQuery<CodeDefinitionsQuery, CodeDefinitionsQueryVariables>(CodeDefinitionsDocument, baseOptions);
      }
export function useCodeDefinitionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CodeDefinitionsQuery, CodeDefinitionsQueryVariables>) {
          return Apollo.useLazyQuery<CodeDefinitionsQuery, CodeDefinitionsQueryVariables>(CodeDefinitionsDocument, baseOptions);
        }
export type CodeDefinitionsQueryHookResult = ReturnType<typeof useCodeDefinitionsQuery>;
export type CodeDefinitionsLazyQueryHookResult = ReturnType<typeof useCodeDefinitionsLazyQuery>;
export type CodeDefinitionsQueryResult = Apollo.QueryResult<CodeDefinitionsQuery, CodeDefinitionsQueryVariables>;
export const PresetsForTableDocument = gql`
    query presetsForTable($tableName: String) {
  presetsForTable(tableName: $tableName) {
    nodes {
      ... on TablePreset {
        ...presetForTable
      }
      ... on DatabaseError {
        dbErrorId: id
        message
      }
      ... on ValidationError {
        vError: id
        field
        messages
      }
    }
  }
}
    ${PresetForTableFragmentDoc}`;

/**
 * __usePresetsForTableQuery__
 *
 * To run a query within a React component, call `usePresetsForTableQuery` and pass it any options that fit your needs.
 * When your component renders, `usePresetsForTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePresetsForTableQuery({
 *   variables: {
 *      tableName: // value for 'tableName'
 *   },
 * });
 */
export function usePresetsForTableQuery(baseOptions?: Apollo.QueryHookOptions<PresetsForTableQuery, PresetsForTableQueryVariables>) {
        return Apollo.useQuery<PresetsForTableQuery, PresetsForTableQueryVariables>(PresetsForTableDocument, baseOptions);
      }
export function usePresetsForTableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PresetsForTableQuery, PresetsForTableQueryVariables>) {
          return Apollo.useLazyQuery<PresetsForTableQuery, PresetsForTableQueryVariables>(PresetsForTableDocument, baseOptions);
        }
export type PresetsForTableQueryHookResult = ReturnType<typeof usePresetsForTableQuery>;
export type PresetsForTableLazyQueryHookResult = ReturnType<typeof usePresetsForTableLazyQuery>;
export type PresetsForTableQueryResult = Apollo.QueryResult<PresetsForTableQuery, PresetsForTableQueryVariables>;
export const DefaultForTableDocument = gql`
    query defaultForTable {
  defaultForTable(tableName: "user") {
    ... on TablePreset {
      ...presetForTable
    }
    ... on DatabaseError {
      dbErrorId: id
      message
    }
    ... on ValidationError {
      vError: id
      field
      messages
    }
  }
}
    ${PresetForTableFragmentDoc}`;

/**
 * __useDefaultForTableQuery__
 *
 * To run a query within a React component, call `useDefaultForTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useDefaultForTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDefaultForTableQuery({
 *   variables: {
 *   },
 * });
 */
export function useDefaultForTableQuery(baseOptions?: Apollo.QueryHookOptions<DefaultForTableQuery, DefaultForTableQueryVariables>) {
        return Apollo.useQuery<DefaultForTableQuery, DefaultForTableQueryVariables>(DefaultForTableDocument, baseOptions);
      }
export function useDefaultForTableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DefaultForTableQuery, DefaultForTableQueryVariables>) {
          return Apollo.useLazyQuery<DefaultForTableQuery, DefaultForTableQueryVariables>(DefaultForTableDocument, baseOptions);
        }
export type DefaultForTableQueryHookResult = ReturnType<typeof useDefaultForTableQuery>;
export type DefaultForTableLazyQueryHookResult = ReturnType<typeof useDefaultForTableLazyQuery>;
export type DefaultForTableQueryResult = Apollo.QueryResult<DefaultForTableQuery, DefaultForTableQueryVariables>;
export const DestinationsDocument = gql`
    query destinations($filterInput: DestinationFilterInput, $userContext: UserContextInput) {
  destinations(where: $filterInput, userContext: $userContext) {
    nodes {
      ...destination
      address {
        ...address
      }
      budgets {
        ...budget
      }
      contact {
        ...contact
      }
      routing {
        ...routing
      }
    }
  }
}
    ${DestinationFragmentDoc}
${AddressFragmentDoc}
${BudgetFragmentDoc}
${ContactFragmentDoc}
${RoutingFragmentDoc}`;

/**
 * __useDestinationsQuery__
 *
 * To run a query within a React component, call `useDestinationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDestinationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDestinationsQuery({
 *   variables: {
 *      filterInput: // value for 'filterInput'
 *      userContext: // value for 'userContext'
 *   },
 * });
 */
export function useDestinationsQuery(baseOptions?: Apollo.QueryHookOptions<DestinationsQuery, DestinationsQueryVariables>) {
        return Apollo.useQuery<DestinationsQuery, DestinationsQueryVariables>(DestinationsDocument, baseOptions);
      }
export function useDestinationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DestinationsQuery, DestinationsQueryVariables>) {
          return Apollo.useLazyQuery<DestinationsQuery, DestinationsQueryVariables>(DestinationsDocument, baseOptions);
        }
export type DestinationsQueryHookResult = ReturnType<typeof useDestinationsQuery>;
export type DestinationsLazyQueryHookResult = ReturnType<typeof useDestinationsLazyQuery>;
export type DestinationsQueryResult = Apollo.QueryResult<DestinationsQuery, DestinationsQueryVariables>;
export const DestinationsPaginatedDocument = gql`
    query destinationsPaginated($filterInput: DestinationFilterInput, $userContext: UserContextInput, $first: Int, $after: String) {
  destinations(
    where: $filterInput
    userContext: $userContext
    first: $first
    after: $after
  ) {
    pageInfo {
      endCursor
      startCursor
      hasNextPage
      hasPreviousPage
    }
    totalCount
    nodes {
      id
      code
      name
    }
  }
}
    `;

/**
 * __useDestinationsPaginatedQuery__
 *
 * To run a query within a React component, call `useDestinationsPaginatedQuery` and pass it any options that fit your needs.
 * When your component renders, `useDestinationsPaginatedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDestinationsPaginatedQuery({
 *   variables: {
 *      filterInput: // value for 'filterInput'
 *      userContext: // value for 'userContext'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useDestinationsPaginatedQuery(baseOptions?: Apollo.QueryHookOptions<DestinationsPaginatedQuery, DestinationsPaginatedQueryVariables>) {
        return Apollo.useQuery<DestinationsPaginatedQuery, DestinationsPaginatedQueryVariables>(DestinationsPaginatedDocument, baseOptions);
      }
export function useDestinationsPaginatedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DestinationsPaginatedQuery, DestinationsPaginatedQueryVariables>) {
          return Apollo.useLazyQuery<DestinationsPaginatedQuery, DestinationsPaginatedQueryVariables>(DestinationsPaginatedDocument, baseOptions);
        }
export type DestinationsPaginatedQueryHookResult = ReturnType<typeof useDestinationsPaginatedQuery>;
export type DestinationsPaginatedLazyQueryHookResult = ReturnType<typeof useDestinationsPaginatedLazyQuery>;
export type DestinationsPaginatedQueryResult = Apollo.QueryResult<DestinationsPaginatedQuery, DestinationsPaginatedQueryVariables>;
export const DestinationByIdDocument = gql`
    query destinationById($id: Int!, $userContext: UserContextInput) {
  destinationById(id: $id, userContext: $userContext) {
    ...destination
    address {
      ...address
    }
    budgets {
      ...budget
    }
    contact {
      ...contact
    }
    routing {
      ...routing
    }
  }
}
    ${DestinationFragmentDoc}
${AddressFragmentDoc}
${BudgetFragmentDoc}
${ContactFragmentDoc}
${RoutingFragmentDoc}`;

/**
 * __useDestinationByIdQuery__
 *
 * To run a query within a React component, call `useDestinationByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useDestinationByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDestinationByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *      userContext: // value for 'userContext'
 *   },
 * });
 */
export function useDestinationByIdQuery(baseOptions: Apollo.QueryHookOptions<DestinationByIdQuery, DestinationByIdQueryVariables>) {
        return Apollo.useQuery<DestinationByIdQuery, DestinationByIdQueryVariables>(DestinationByIdDocument, baseOptions);
      }
export function useDestinationByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DestinationByIdQuery, DestinationByIdQueryVariables>) {
          return Apollo.useLazyQuery<DestinationByIdQuery, DestinationByIdQueryVariables>(DestinationByIdDocument, baseOptions);
        }
export type DestinationByIdQueryHookResult = ReturnType<typeof useDestinationByIdQuery>;
export type DestinationByIdLazyQueryHookResult = ReturnType<typeof useDestinationByIdLazyQuery>;
export type DestinationByIdQueryResult = Apollo.QueryResult<DestinationByIdQuery, DestinationByIdQueryVariables>;
export const DestinationCodesDocument = gql`
    query destinationCodes {
  destinationCodes @client {
    ...destinationCode
  }
}
    ${DestinationCodeFragmentDoc}`;

/**
 * __useDestinationCodesQuery__
 *
 * To run a query within a React component, call `useDestinationCodesQuery` and pass it any options that fit your needs.
 * When your component renders, `useDestinationCodesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDestinationCodesQuery({
 *   variables: {
 *   },
 * });
 */
export function useDestinationCodesQuery(baseOptions?: Apollo.QueryHookOptions<DestinationCodesQuery, DestinationCodesQueryVariables>) {
        return Apollo.useQuery<DestinationCodesQuery, DestinationCodesQueryVariables>(DestinationCodesDocument, baseOptions);
      }
export function useDestinationCodesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DestinationCodesQuery, DestinationCodesQueryVariables>) {
          return Apollo.useLazyQuery<DestinationCodesQuery, DestinationCodesQueryVariables>(DestinationCodesDocument, baseOptions);
        }
export type DestinationCodesQueryHookResult = ReturnType<typeof useDestinationCodesQuery>;
export type DestinationCodesLazyQueryHookResult = ReturnType<typeof useDestinationCodesLazyQuery>;
export type DestinationCodesQueryResult = Apollo.QueryResult<DestinationCodesQuery, DestinationCodesQueryVariables>;
export const GoodsReceiptByIdDocument = gql`
    query goodsReceiptById($id: Int!, $userContext: UserContextInput) {
  goodsReceipt {
    id
    goodsReceiptById(id: $id, userContext: $userContext) {
      id
      goodsReceiptNumber
      customerRef
      invoiceRef
      status
      dateReceived
      stockOwner {
        code
      }
      warehouse {
        code
      }
      extra {
        ...extra
      }
      booked {
        ...booked
      }
      received {
        ...received
      }
    }
  }
}
    ${ExtraFragmentDoc}
${BookedFragmentDoc}
${ReceivedFragmentDoc}`;

/**
 * __useGoodsReceiptByIdQuery__
 *
 * To run a query within a React component, call `useGoodsReceiptByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGoodsReceiptByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGoodsReceiptByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *      userContext: // value for 'userContext'
 *   },
 * });
 */
export function useGoodsReceiptByIdQuery(baseOptions: Apollo.QueryHookOptions<GoodsReceiptByIdQuery, GoodsReceiptByIdQueryVariables>) {
        return Apollo.useQuery<GoodsReceiptByIdQuery, GoodsReceiptByIdQueryVariables>(GoodsReceiptByIdDocument, baseOptions);
      }
export function useGoodsReceiptByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GoodsReceiptByIdQuery, GoodsReceiptByIdQueryVariables>) {
          return Apollo.useLazyQuery<GoodsReceiptByIdQuery, GoodsReceiptByIdQueryVariables>(GoodsReceiptByIdDocument, baseOptions);
        }
export type GoodsReceiptByIdQueryHookResult = ReturnType<typeof useGoodsReceiptByIdQuery>;
export type GoodsReceiptByIdLazyQueryHookResult = ReturnType<typeof useGoodsReceiptByIdLazyQuery>;
export type GoodsReceiptByIdQueryResult = Apollo.QueryResult<GoodsReceiptByIdQuery, GoodsReceiptByIdQueryVariables>;
export const GoodsReceiptByNumberDocument = gql`
    query goodsReceiptByNumber($goodsReceiptNumber: String, $userContext: UserContextInput) {
  goodsReceipt {
    id
    goodsReceiptByNumber(
      goodsReceiptNumber: $goodsReceiptNumber
      userContext: $userContext
    ) {
      id
      goodsReceiptNumber
      customerRef
      invoiceRef
      status
      dateReceived
      stockOwner {
        code
      }
      warehouse {
        code
      }
      extra {
        ...extra
      }
      booked {
        ...booked
      }
      received {
        ...received
      }
    }
  }
}
    ${ExtraFragmentDoc}
${BookedFragmentDoc}
${ReceivedFragmentDoc}`;

/**
 * __useGoodsReceiptByNumberQuery__
 *
 * To run a query within a React component, call `useGoodsReceiptByNumberQuery` and pass it any options that fit your needs.
 * When your component renders, `useGoodsReceiptByNumberQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGoodsReceiptByNumberQuery({
 *   variables: {
 *      goodsReceiptNumber: // value for 'goodsReceiptNumber'
 *      userContext: // value for 'userContext'
 *   },
 * });
 */
export function useGoodsReceiptByNumberQuery(baseOptions?: Apollo.QueryHookOptions<GoodsReceiptByNumberQuery, GoodsReceiptByNumberQueryVariables>) {
        return Apollo.useQuery<GoodsReceiptByNumberQuery, GoodsReceiptByNumberQueryVariables>(GoodsReceiptByNumberDocument, baseOptions);
      }
export function useGoodsReceiptByNumberLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GoodsReceiptByNumberQuery, GoodsReceiptByNumberQueryVariables>) {
          return Apollo.useLazyQuery<GoodsReceiptByNumberQuery, GoodsReceiptByNumberQueryVariables>(GoodsReceiptByNumberDocument, baseOptions);
        }
export type GoodsReceiptByNumberQueryHookResult = ReturnType<typeof useGoodsReceiptByNumberQuery>;
export type GoodsReceiptByNumberLazyQueryHookResult = ReturnType<typeof useGoodsReceiptByNumberLazyQuery>;
export type GoodsReceiptByNumberQueryResult = Apollo.QueryResult<GoodsReceiptByNumberQuery, GoodsReceiptByNumberQueryVariables>;
export const GoodsReceiptsDocument = gql`
    query goodsReceipts($filterInput: GoodsReceiptFilterInput, $userContext: UserContextInput) {
  goodsReceipt {
    id
    goodsReceipts(where: $filterInput, userContext: $userContext) {
      totalCount
      nodes {
        id
        goodsReceiptNumber
        customerRef
        invoiceRef
        status
        dateReceived
        stockOwner {
          code
        }
        warehouse {
          code
        }
        extra {
          ...extra
        }
        booked {
          ...booked
        }
        received {
          ...received
        }
      }
    }
  }
}
    ${ExtraFragmentDoc}
${BookedFragmentDoc}
${ReceivedFragmentDoc}`;

/**
 * __useGoodsReceiptsQuery__
 *
 * To run a query within a React component, call `useGoodsReceiptsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGoodsReceiptsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGoodsReceiptsQuery({
 *   variables: {
 *      filterInput: // value for 'filterInput'
 *      userContext: // value for 'userContext'
 *   },
 * });
 */
export function useGoodsReceiptsQuery(baseOptions?: Apollo.QueryHookOptions<GoodsReceiptsQuery, GoodsReceiptsQueryVariables>) {
        return Apollo.useQuery<GoodsReceiptsQuery, GoodsReceiptsQueryVariables>(GoodsReceiptsDocument, baseOptions);
      }
export function useGoodsReceiptsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GoodsReceiptsQuery, GoodsReceiptsQueryVariables>) {
          return Apollo.useLazyQuery<GoodsReceiptsQuery, GoodsReceiptsQueryVariables>(GoodsReceiptsDocument, baseOptions);
        }
export type GoodsReceiptsQueryHookResult = ReturnType<typeof useGoodsReceiptsQuery>;
export type GoodsReceiptsLazyQueryHookResult = ReturnType<typeof useGoodsReceiptsLazyQuery>;
export type GoodsReceiptsQueryResult = Apollo.QueryResult<GoodsReceiptsQuery, GoodsReceiptsQueryVariables>;
export const GoodsReceiptsPaginatedDocument = gql`
    query goodsReceiptsPaginated($filterInput: GoodsReceiptFilterInput, $userContext: UserContextInput, $first: Int, $after: String) {
  goodsReceipt {
    id
    goodsReceipts(
      where: $filterInput
      userContext: $userContext
      first: $first
      after: $after
    ) {
      pageInfo {
        endCursor
        startCursor
        hasNextPage
        hasPreviousPage
      }
      totalCount
      nodes {
        id
        goodsReceiptNumber
      }
    }
  }
}
    `;

/**
 * __useGoodsReceiptsPaginatedQuery__
 *
 * To run a query within a React component, call `useGoodsReceiptsPaginatedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGoodsReceiptsPaginatedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGoodsReceiptsPaginatedQuery({
 *   variables: {
 *      filterInput: // value for 'filterInput'
 *      userContext: // value for 'userContext'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGoodsReceiptsPaginatedQuery(baseOptions?: Apollo.QueryHookOptions<GoodsReceiptsPaginatedQuery, GoodsReceiptsPaginatedQueryVariables>) {
        return Apollo.useQuery<GoodsReceiptsPaginatedQuery, GoodsReceiptsPaginatedQueryVariables>(GoodsReceiptsPaginatedDocument, baseOptions);
      }
export function useGoodsReceiptsPaginatedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GoodsReceiptsPaginatedQuery, GoodsReceiptsPaginatedQueryVariables>) {
          return Apollo.useLazyQuery<GoodsReceiptsPaginatedQuery, GoodsReceiptsPaginatedQueryVariables>(GoodsReceiptsPaginatedDocument, baseOptions);
        }
export type GoodsReceiptsPaginatedQueryHookResult = ReturnType<typeof useGoodsReceiptsPaginatedQuery>;
export type GoodsReceiptsPaginatedLazyQueryHookResult = ReturnType<typeof useGoodsReceiptsPaginatedLazyQuery>;
export type GoodsReceiptsPaginatedQueryResult = Apollo.QueryResult<GoodsReceiptsPaginatedQuery, GoodsReceiptsPaginatedQueryVariables>;
export const HandlingTypesDocument = gql`
    query handlingTypes($filterInput: HandlingTypeFilterInput, $userContext: UserContextInput) {
  handlingTypes(where: $filterInput, userContext: $userContext) {
    nodes {
      ...handlingType
      storageTypes {
        storageType {
          ...storageType
        }
      }
    }
  }
}
    ${HandlingTypeFragmentDoc}
${StorageTypeFragmentDoc}`;

/**
 * __useHandlingTypesQuery__
 *
 * To run a query within a React component, call `useHandlingTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useHandlingTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHandlingTypesQuery({
 *   variables: {
 *      filterInput: // value for 'filterInput'
 *      userContext: // value for 'userContext'
 *   },
 * });
 */
export function useHandlingTypesQuery(baseOptions?: Apollo.QueryHookOptions<HandlingTypesQuery, HandlingTypesQueryVariables>) {
        return Apollo.useQuery<HandlingTypesQuery, HandlingTypesQueryVariables>(HandlingTypesDocument, baseOptions);
      }
export function useHandlingTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HandlingTypesQuery, HandlingTypesQueryVariables>) {
          return Apollo.useLazyQuery<HandlingTypesQuery, HandlingTypesQueryVariables>(HandlingTypesDocument, baseOptions);
        }
export type HandlingTypesQueryHookResult = ReturnType<typeof useHandlingTypesQuery>;
export type HandlingTypesLazyQueryHookResult = ReturnType<typeof useHandlingTypesLazyQuery>;
export type HandlingTypesQueryResult = Apollo.QueryResult<HandlingTypesQuery, HandlingTypesQueryVariables>;
export const SelectHandlingTypesDocument = gql`
    query selectHandlingTypes($filterInput: HandlingTypeFilterInput, $userContext: UserContextInput) {
  handlingTypes(userContext: $userContext, where: $filterInput) {
    nodes {
      ...handlingType
    }
  }
}
    ${HandlingTypeFragmentDoc}`;

/**
 * __useSelectHandlingTypesQuery__
 *
 * To run a query within a React component, call `useSelectHandlingTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSelectHandlingTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSelectHandlingTypesQuery({
 *   variables: {
 *      filterInput: // value for 'filterInput'
 *      userContext: // value for 'userContext'
 *   },
 * });
 */
export function useSelectHandlingTypesQuery(baseOptions?: Apollo.QueryHookOptions<SelectHandlingTypesQuery, SelectHandlingTypesQueryVariables>) {
        return Apollo.useQuery<SelectHandlingTypesQuery, SelectHandlingTypesQueryVariables>(SelectHandlingTypesDocument, baseOptions);
      }
export function useSelectHandlingTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SelectHandlingTypesQuery, SelectHandlingTypesQueryVariables>) {
          return Apollo.useLazyQuery<SelectHandlingTypesQuery, SelectHandlingTypesQueryVariables>(SelectHandlingTypesDocument, baseOptions);
        }
export type SelectHandlingTypesQueryHookResult = ReturnType<typeof useSelectHandlingTypesQuery>;
export type SelectHandlingTypesLazyQueryHookResult = ReturnType<typeof useSelectHandlingTypesLazyQuery>;
export type SelectHandlingTypesQueryResult = Apollo.QueryResult<SelectHandlingTypesQuery, SelectHandlingTypesQueryVariables>;
export const HandlingTypesPaginatedDocument = gql`
    query handlingTypesPaginated($filterInput: HandlingTypeFilterInput, $first: Int, $after: String, $before: String) {
  handlingTypes(
    where: $filterInput
    first: $first
    after: $after
    before: $before
  ) {
    pageInfo {
      endCursor
      startCursor
      hasNextPage
      hasPreviousPage
    }
    totalCount
    nodes {
      ...handlingType
      storageTypes {
        storageType {
          ...storageType
        }
      }
    }
  }
}
    ${HandlingTypeFragmentDoc}
${StorageTypeFragmentDoc}`;

/**
 * __useHandlingTypesPaginatedQuery__
 *
 * To run a query within a React component, call `useHandlingTypesPaginatedQuery` and pass it any options that fit your needs.
 * When your component renders, `useHandlingTypesPaginatedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHandlingTypesPaginatedQuery({
 *   variables: {
 *      filterInput: // value for 'filterInput'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *   },
 * });
 */
export function useHandlingTypesPaginatedQuery(baseOptions?: Apollo.QueryHookOptions<HandlingTypesPaginatedQuery, HandlingTypesPaginatedQueryVariables>) {
        return Apollo.useQuery<HandlingTypesPaginatedQuery, HandlingTypesPaginatedQueryVariables>(HandlingTypesPaginatedDocument, baseOptions);
      }
export function useHandlingTypesPaginatedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HandlingTypesPaginatedQuery, HandlingTypesPaginatedQueryVariables>) {
          return Apollo.useLazyQuery<HandlingTypesPaginatedQuery, HandlingTypesPaginatedQueryVariables>(HandlingTypesPaginatedDocument, baseOptions);
        }
export type HandlingTypesPaginatedQueryHookResult = ReturnType<typeof useHandlingTypesPaginatedQuery>;
export type HandlingTypesPaginatedLazyQueryHookResult = ReturnType<typeof useHandlingTypesPaginatedLazyQuery>;
export type HandlingTypesPaginatedQueryResult = Apollo.QueryResult<HandlingTypesPaginatedQuery, HandlingTypesPaginatedQueryVariables>;
export const HandlingTypeByIdDocument = gql`
    query handlingTypeById($id: Int!) {
  handlingTypeById(id: $id) {
    ...handlingType
    storageTypes {
      storageType {
        ...storageType
      }
    }
  }
}
    ${HandlingTypeFragmentDoc}
${StorageTypeFragmentDoc}`;

/**
 * __useHandlingTypeByIdQuery__
 *
 * To run a query within a React component, call `useHandlingTypeByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useHandlingTypeByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHandlingTypeByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useHandlingTypeByIdQuery(baseOptions: Apollo.QueryHookOptions<HandlingTypeByIdQuery, HandlingTypeByIdQueryVariables>) {
        return Apollo.useQuery<HandlingTypeByIdQuery, HandlingTypeByIdQueryVariables>(HandlingTypeByIdDocument, baseOptions);
      }
export function useHandlingTypeByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HandlingTypeByIdQuery, HandlingTypeByIdQueryVariables>) {
          return Apollo.useLazyQuery<HandlingTypeByIdQuery, HandlingTypeByIdQueryVariables>(HandlingTypeByIdDocument, baseOptions);
        }
export type HandlingTypeByIdQueryHookResult = ReturnType<typeof useHandlingTypeByIdQuery>;
export type HandlingTypeByIdLazyQueryHookResult = ReturnType<typeof useHandlingTypeByIdLazyQuery>;
export type HandlingTypeByIdQueryResult = Apollo.QueryResult<HandlingTypeByIdQuery, HandlingTypeByIdQueryVariables>;
export const LicencePlateTypesDocument = gql`
    query licencePlateTypes {
  licencePlate {
    licencePlateTypes {
      nodes {
        id
        code
        description
      }
    }
  }
}
    `;

/**
 * __useLicencePlateTypesQuery__
 *
 * To run a query within a React component, call `useLicencePlateTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useLicencePlateTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLicencePlateTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useLicencePlateTypesQuery(baseOptions?: Apollo.QueryHookOptions<LicencePlateTypesQuery, LicencePlateTypesQueryVariables>) {
        return Apollo.useQuery<LicencePlateTypesQuery, LicencePlateTypesQueryVariables>(LicencePlateTypesDocument, baseOptions);
      }
export function useLicencePlateTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LicencePlateTypesQuery, LicencePlateTypesQueryVariables>) {
          return Apollo.useLazyQuery<LicencePlateTypesQuery, LicencePlateTypesQueryVariables>(LicencePlateTypesDocument, baseOptions);
        }
export type LicencePlateTypesQueryHookResult = ReturnType<typeof useLicencePlateTypesQuery>;
export type LicencePlateTypesLazyQueryHookResult = ReturnType<typeof useLicencePlateTypesLazyQuery>;
export type LicencePlateTypesQueryResult = Apollo.QueryResult<LicencePlateTypesQuery, LicencePlateTypesQueryVariables>;
export const LocationsDocument = gql`
    query locations($filterInput: LocationFilterInput, $userContext: UserContextInput) {
  locations(where: $filterInput, userContext: $userContext) {
    nodes {
      ... on Location {
        ...location
      }
    }
  }
}
    ${LocationFragmentDoc}`;

/**
 * __useLocationsQuery__
 *
 * To run a query within a React component, call `useLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLocationsQuery({
 *   variables: {
 *      filterInput: // value for 'filterInput'
 *      userContext: // value for 'userContext'
 *   },
 * });
 */
export function useLocationsQuery(baseOptions?: Apollo.QueryHookOptions<LocationsQuery, LocationsQueryVariables>) {
        return Apollo.useQuery<LocationsQuery, LocationsQueryVariables>(LocationsDocument, baseOptions);
      }
export function useLocationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LocationsQuery, LocationsQueryVariables>) {
          return Apollo.useLazyQuery<LocationsQuery, LocationsQueryVariables>(LocationsDocument, baseOptions);
        }
export type LocationsQueryHookResult = ReturnType<typeof useLocationsQuery>;
export type LocationsLazyQueryHookResult = ReturnType<typeof useLocationsLazyQuery>;
export type LocationsQueryResult = Apollo.QueryResult<LocationsQuery, LocationsQueryVariables>;
export const LocationByIdDocument = gql`
    query locationById($id: Int!, $userContext: UserContextInput) {
  locationById(id: $id, userContext: $userContext) {
    ... on Location {
      ...location
      storageType {
        ...storageType
      }
    }
  }
}
    ${LocationFragmentDoc}
${StorageTypeFragmentDoc}`;

/**
 * __useLocationByIdQuery__
 *
 * To run a query within a React component, call `useLocationByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useLocationByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLocationByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *      userContext: // value for 'userContext'
 *   },
 * });
 */
export function useLocationByIdQuery(baseOptions: Apollo.QueryHookOptions<LocationByIdQuery, LocationByIdQueryVariables>) {
        return Apollo.useQuery<LocationByIdQuery, LocationByIdQueryVariables>(LocationByIdDocument, baseOptions);
      }
export function useLocationByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LocationByIdQuery, LocationByIdQueryVariables>) {
          return Apollo.useLazyQuery<LocationByIdQuery, LocationByIdQueryVariables>(LocationByIdDocument, baseOptions);
        }
export type LocationByIdQueryHookResult = ReturnType<typeof useLocationByIdQuery>;
export type LocationByIdLazyQueryHookResult = ReturnType<typeof useLocationByIdLazyQuery>;
export type LocationByIdQueryResult = Apollo.QueryResult<LocationByIdQuery, LocationByIdQueryVariables>;
export const LocationIdByCodeDocument = gql`
    query locationIdByCode($code: String, $userContext: UserContextInput) {
  locationByCode(code: $code, userContext: $userContext) {
    ... on Location {
      id
      code
    }
  }
}
    `;

/**
 * __useLocationIdByCodeQuery__
 *
 * To run a query within a React component, call `useLocationIdByCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useLocationIdByCodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLocationIdByCodeQuery({
 *   variables: {
 *      code: // value for 'code'
 *      userContext: // value for 'userContext'
 *   },
 * });
 */
export function useLocationIdByCodeQuery(baseOptions?: Apollo.QueryHookOptions<LocationIdByCodeQuery, LocationIdByCodeQueryVariables>) {
        return Apollo.useQuery<LocationIdByCodeQuery, LocationIdByCodeQueryVariables>(LocationIdByCodeDocument, baseOptions);
      }
export function useLocationIdByCodeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LocationIdByCodeQuery, LocationIdByCodeQueryVariables>) {
          return Apollo.useLazyQuery<LocationIdByCodeQuery, LocationIdByCodeQueryVariables>(LocationIdByCodeDocument, baseOptions);
        }
export type LocationIdByCodeQueryHookResult = ReturnType<typeof useLocationIdByCodeQuery>;
export type LocationIdByCodeLazyQueryHookResult = ReturnType<typeof useLocationIdByCodeLazyQuery>;
export type LocationIdByCodeQueryResult = Apollo.QueryResult<LocationIdByCodeQuery, LocationIdByCodeQueryVariables>;
export const LocationProcessTypesDocument = gql`
    query locationProcessTypes {
  locationProcessTypes {
    displayName
    description
    value
  }
}
    `;

/**
 * __useLocationProcessTypesQuery__
 *
 * To run a query within a React component, call `useLocationProcessTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useLocationProcessTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLocationProcessTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useLocationProcessTypesQuery(baseOptions?: Apollo.QueryHookOptions<LocationProcessTypesQuery, LocationProcessTypesQueryVariables>) {
        return Apollo.useQuery<LocationProcessTypesQuery, LocationProcessTypesQueryVariables>(LocationProcessTypesDocument, baseOptions);
      }
export function useLocationProcessTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LocationProcessTypesQuery, LocationProcessTypesQueryVariables>) {
          return Apollo.useLazyQuery<LocationProcessTypesQuery, LocationProcessTypesQueryVariables>(LocationProcessTypesDocument, baseOptions);
        }
export type LocationProcessTypesQueryHookResult = ReturnType<typeof useLocationProcessTypesQuery>;
export type LocationProcessTypesLazyQueryHookResult = ReturnType<typeof useLocationProcessTypesLazyQuery>;
export type LocationProcessTypesQueryResult = Apollo.QueryResult<LocationProcessTypesQuery, LocationProcessTypesQueryVariables>;
export const LocationPhysicalTypesDocument = gql`
    query locationPhysicalTypes {
  locationPhysicalTypes {
    displayName
    description
    value
  }
}
    `;

/**
 * __useLocationPhysicalTypesQuery__
 *
 * To run a query within a React component, call `useLocationPhysicalTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useLocationPhysicalTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLocationPhysicalTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useLocationPhysicalTypesQuery(baseOptions?: Apollo.QueryHookOptions<LocationPhysicalTypesQuery, LocationPhysicalTypesQueryVariables>) {
        return Apollo.useQuery<LocationPhysicalTypesQuery, LocationPhysicalTypesQueryVariables>(LocationPhysicalTypesDocument, baseOptions);
      }
export function useLocationPhysicalTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LocationPhysicalTypesQuery, LocationPhysicalTypesQueryVariables>) {
          return Apollo.useLazyQuery<LocationPhysicalTypesQuery, LocationPhysicalTypesQueryVariables>(LocationPhysicalTypesDocument, baseOptions);
        }
export type LocationPhysicalTypesQueryHookResult = ReturnType<typeof useLocationPhysicalTypesQuery>;
export type LocationPhysicalTypesLazyQueryHookResult = ReturnType<typeof useLocationPhysicalTypesLazyQuery>;
export type LocationPhysicalTypesQueryResult = Apollo.QueryResult<LocationPhysicalTypesQuery, LocationPhysicalTypesQueryVariables>;
export const SelectLocationsDocument = gql`
    query selectLocations($filterInput: LocationFilterInput, $userContext: UserContextInput) {
  locations(where: $filterInput, userContext: $userContext) {
    nodes {
      ... on Location {
        id
        code
      }
    }
  }
}
    `;

/**
 * __useSelectLocationsQuery__
 *
 * To run a query within a React component, call `useSelectLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSelectLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSelectLocationsQuery({
 *   variables: {
 *      filterInput: // value for 'filterInput'
 *      userContext: // value for 'userContext'
 *   },
 * });
 */
export function useSelectLocationsQuery(baseOptions?: Apollo.QueryHookOptions<SelectLocationsQuery, SelectLocationsQueryVariables>) {
        return Apollo.useQuery<SelectLocationsQuery, SelectLocationsQueryVariables>(SelectLocationsDocument, baseOptions);
      }
export function useSelectLocationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SelectLocationsQuery, SelectLocationsQueryVariables>) {
          return Apollo.useLazyQuery<SelectLocationsQuery, SelectLocationsQueryVariables>(SelectLocationsDocument, baseOptions);
        }
export type SelectLocationsQueryHookResult = ReturnType<typeof useSelectLocationsQuery>;
export type SelectLocationsLazyQueryHookResult = ReturnType<typeof useSelectLocationsLazyQuery>;
export type SelectLocationsQueryResult = Apollo.QueryResult<SelectLocationsQuery, SelectLocationsQueryVariables>;
export const LocationsPaginatedDocument = gql`
    query locationsPaginated($filterInput: LocationFilterInput, $first: Int, $after: String, $before: String, $userContext: UserContextInput) {
  locations(
    where: $filterInput
    first: $first
    after: $after
    before: $before
    userContext: $userContext
  ) {
    pageInfo {
      endCursor
      startCursor
      hasNextPage
      hasPreviousPage
    }
    totalCount
    nodes {
      ... on Location {
        id
        aisle
        code
        zone
        storageType {
          ...storageType
        }
      }
    }
  }
}
    ${StorageTypeFragmentDoc}`;

/**
 * __useLocationsPaginatedQuery__
 *
 * To run a query within a React component, call `useLocationsPaginatedQuery` and pass it any options that fit your needs.
 * When your component renders, `useLocationsPaginatedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLocationsPaginatedQuery({
 *   variables: {
 *      filterInput: // value for 'filterInput'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      userContext: // value for 'userContext'
 *   },
 * });
 */
export function useLocationsPaginatedQuery(baseOptions?: Apollo.QueryHookOptions<LocationsPaginatedQuery, LocationsPaginatedQueryVariables>) {
        return Apollo.useQuery<LocationsPaginatedQuery, LocationsPaginatedQueryVariables>(LocationsPaginatedDocument, baseOptions);
      }
export function useLocationsPaginatedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LocationsPaginatedQuery, LocationsPaginatedQueryVariables>) {
          return Apollo.useLazyQuery<LocationsPaginatedQuery, LocationsPaginatedQueryVariables>(LocationsPaginatedDocument, baseOptions);
        }
export type LocationsPaginatedQueryHookResult = ReturnType<typeof useLocationsPaginatedQuery>;
export type LocationsPaginatedLazyQueryHookResult = ReturnType<typeof useLocationsPaginatedLazyQuery>;
export type LocationsPaginatedQueryResult = Apollo.QueryResult<LocationsPaginatedQuery, LocationsPaginatedQueryVariables>;
export const MaxWeeklySpendsDocument = gql`
    query maxWeeklySpends {
  maxWeeklySpends @client {
    ...maxWeeklySpend
  }
}
    ${MaxWeeklySpendFragmentDoc}`;

/**
 * __useMaxWeeklySpendsQuery__
 *
 * To run a query within a React component, call `useMaxWeeklySpendsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMaxWeeklySpendsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMaxWeeklySpendsQuery({
 *   variables: {
 *   },
 * });
 */
export function useMaxWeeklySpendsQuery(baseOptions?: Apollo.QueryHookOptions<MaxWeeklySpendsQuery, MaxWeeklySpendsQueryVariables>) {
        return Apollo.useQuery<MaxWeeklySpendsQuery, MaxWeeklySpendsQueryVariables>(MaxWeeklySpendsDocument, baseOptions);
      }
export function useMaxWeeklySpendsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MaxWeeklySpendsQuery, MaxWeeklySpendsQueryVariables>) {
          return Apollo.useLazyQuery<MaxWeeklySpendsQuery, MaxWeeklySpendsQueryVariables>(MaxWeeklySpendsDocument, baseOptions);
        }
export type MaxWeeklySpendsQueryHookResult = ReturnType<typeof useMaxWeeklySpendsQuery>;
export type MaxWeeklySpendsLazyQueryHookResult = ReturnType<typeof useMaxWeeklySpendsLazyQuery>;
export type MaxWeeklySpendsQueryResult = Apollo.QueryResult<MaxWeeklySpendsQuery, MaxWeeklySpendsQueryVariables>;
export const AllMenusDocument = gql`
    query allMenus {
  allMenus {
    id
    action
    compareTo
    defaultTitle
    description
    screenCode
  }
}
    `;

/**
 * __useAllMenusQuery__
 *
 * To run a query within a React component, call `useAllMenusQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllMenusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllMenusQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllMenusQuery(baseOptions?: Apollo.QueryHookOptions<AllMenusQuery, AllMenusQueryVariables>) {
        return Apollo.useQuery<AllMenusQuery, AllMenusQueryVariables>(AllMenusDocument, baseOptions);
      }
export function useAllMenusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllMenusQuery, AllMenusQueryVariables>) {
          return Apollo.useLazyQuery<AllMenusQuery, AllMenusQueryVariables>(AllMenusDocument, baseOptions);
        }
export type AllMenusQueryHookResult = ReturnType<typeof useAllMenusQuery>;
export type AllMenusLazyQueryHookResult = ReturnType<typeof useAllMenusLazyQuery>;
export type AllMenusQueryResult = Apollo.QueryResult<AllMenusQuery, AllMenusQueryVariables>;
export const DefaultMenuDocument = gql`
    query defaultMenu {
  defaultMenu {
    ...menuEntry
    screen {
      ...screen
    }
    parent {
      ...menuEntry
      screen {
        ...screen
      }
    }
    children {
      ...menuEntry
      screen {
        ...screen
      }
    }
  }
}
    ${MenuEntryFragmentDoc}
${ScreenFragmentDoc}`;

/**
 * __useDefaultMenuQuery__
 *
 * To run a query within a React component, call `useDefaultMenuQuery` and pass it any options that fit your needs.
 * When your component renders, `useDefaultMenuQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDefaultMenuQuery({
 *   variables: {
 *   },
 * });
 */
export function useDefaultMenuQuery(baseOptions?: Apollo.QueryHookOptions<DefaultMenuQuery, DefaultMenuQueryVariables>) {
        return Apollo.useQuery<DefaultMenuQuery, DefaultMenuQueryVariables>(DefaultMenuDocument, baseOptions);
      }
export function useDefaultMenuLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DefaultMenuQuery, DefaultMenuQueryVariables>) {
          return Apollo.useLazyQuery<DefaultMenuQuery, DefaultMenuQueryVariables>(DefaultMenuDocument, baseOptions);
        }
export type DefaultMenuQueryHookResult = ReturnType<typeof useDefaultMenuQuery>;
export type DefaultMenuLazyQueryHookResult = ReturnType<typeof useDefaultMenuLazyQuery>;
export type DefaultMenuQueryResult = Apollo.QueryResult<DefaultMenuQuery, DefaultMenuQueryVariables>;
export const ConfirmMethodsDocument = gql`
    query confirmMethods {
  pickConfirmMethods
  postPickConfirmMethods
  packingMethods
  despatchMethods
  closeLoadMethods
}
    `;

/**
 * __useConfirmMethodsQuery__
 *
 * To run a query within a React component, call `useConfirmMethodsQuery` and pass it any options that fit your needs.
 * When your component renders, `useConfirmMethodsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConfirmMethodsQuery({
 *   variables: {
 *   },
 * });
 */
export function useConfirmMethodsQuery(baseOptions?: Apollo.QueryHookOptions<ConfirmMethodsQuery, ConfirmMethodsQueryVariables>) {
        return Apollo.useQuery<ConfirmMethodsQuery, ConfirmMethodsQueryVariables>(ConfirmMethodsDocument, baseOptions);
      }
export function useConfirmMethodsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ConfirmMethodsQuery, ConfirmMethodsQueryVariables>) {
          return Apollo.useLazyQuery<ConfirmMethodsQuery, ConfirmMethodsQueryVariables>(ConfirmMethodsDocument, baseOptions);
        }
export type ConfirmMethodsQueryHookResult = ReturnType<typeof useConfirmMethodsQuery>;
export type ConfirmMethodsLazyQueryHookResult = ReturnType<typeof useConfirmMethodsLazyQuery>;
export type ConfirmMethodsQueryResult = Apollo.QueryResult<ConfirmMethodsQuery, ConfirmMethodsQueryVariables>;
export const PickCreationmethodsDocument = gql`
    query pickCreationmethods {
  prePickCreationMethods
  pickCreationMethods
  postPickCreationMethods
  pickOutputMethods
}
    `;

/**
 * __usePickCreationmethodsQuery__
 *
 * To run a query within a React component, call `usePickCreationmethodsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePickCreationmethodsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePickCreationmethodsQuery({
 *   variables: {
 *   },
 * });
 */
export function usePickCreationmethodsQuery(baseOptions?: Apollo.QueryHookOptions<PickCreationmethodsQuery, PickCreationmethodsQueryVariables>) {
        return Apollo.useQuery<PickCreationmethodsQuery, PickCreationmethodsQueryVariables>(PickCreationmethodsDocument, baseOptions);
      }
export function usePickCreationmethodsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PickCreationmethodsQuery, PickCreationmethodsQueryVariables>) {
          return Apollo.useLazyQuery<PickCreationmethodsQuery, PickCreationmethodsQueryVariables>(PickCreationmethodsDocument, baseOptions);
        }
export type PickCreationmethodsQueryHookResult = ReturnType<typeof usePickCreationmethodsQuery>;
export type PickCreationmethodsLazyQueryHookResult = ReturnType<typeof usePickCreationmethodsLazyQuery>;
export type PickCreationmethodsQueryResult = Apollo.QueryResult<PickCreationmethodsQuery, PickCreationmethodsQueryVariables>;
export const MaterialHandlingEquipmentsDocument = gql`
    query materialHandlingEquipments($filterInput: MaterialHandlingEquipmentFilterInput, $userContext: UserContextInput) {
  materialHandlingEquipment(where: $filterInput, userContext: $userContext) {
    nodes {
      ...mhe
    }
  }
}
    ${MheFragmentDoc}`;

/**
 * __useMaterialHandlingEquipmentsQuery__
 *
 * To run a query within a React component, call `useMaterialHandlingEquipmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMaterialHandlingEquipmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMaterialHandlingEquipmentsQuery({
 *   variables: {
 *      filterInput: // value for 'filterInput'
 *      userContext: // value for 'userContext'
 *   },
 * });
 */
export function useMaterialHandlingEquipmentsQuery(baseOptions?: Apollo.QueryHookOptions<MaterialHandlingEquipmentsQuery, MaterialHandlingEquipmentsQueryVariables>) {
        return Apollo.useQuery<MaterialHandlingEquipmentsQuery, MaterialHandlingEquipmentsQueryVariables>(MaterialHandlingEquipmentsDocument, baseOptions);
      }
export function useMaterialHandlingEquipmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MaterialHandlingEquipmentsQuery, MaterialHandlingEquipmentsQueryVariables>) {
          return Apollo.useLazyQuery<MaterialHandlingEquipmentsQuery, MaterialHandlingEquipmentsQueryVariables>(MaterialHandlingEquipmentsDocument, baseOptions);
        }
export type MaterialHandlingEquipmentsQueryHookResult = ReturnType<typeof useMaterialHandlingEquipmentsQuery>;
export type MaterialHandlingEquipmentsLazyQueryHookResult = ReturnType<typeof useMaterialHandlingEquipmentsLazyQuery>;
export type MaterialHandlingEquipmentsQueryResult = Apollo.QueryResult<MaterialHandlingEquipmentsQuery, MaterialHandlingEquipmentsQueryVariables>;
export const MaterialHandlingEquipmentsPaginatedDocument = gql`
    query materialHandlingEquipmentsPaginated($filterInput: MaterialHandlingEquipmentFilterInput, $userContext: UserContextInput, $first: Int, $after: String) {
  materialHandlingEquipment(
    where: $filterInput
    userContext: $userContext
    first: $first
    after: $after
  ) {
    pageInfo {
      endCursor
      startCursor
      hasNextPage
      hasPreviousPage
    }
    totalCount
    nodes {
      id
      code
      description
      class
    }
  }
}
    `;

/**
 * __useMaterialHandlingEquipmentsPaginatedQuery__
 *
 * To run a query within a React component, call `useMaterialHandlingEquipmentsPaginatedQuery` and pass it any options that fit your needs.
 * When your component renders, `useMaterialHandlingEquipmentsPaginatedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMaterialHandlingEquipmentsPaginatedQuery({
 *   variables: {
 *      filterInput: // value for 'filterInput'
 *      userContext: // value for 'userContext'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useMaterialHandlingEquipmentsPaginatedQuery(baseOptions?: Apollo.QueryHookOptions<MaterialHandlingEquipmentsPaginatedQuery, MaterialHandlingEquipmentsPaginatedQueryVariables>) {
        return Apollo.useQuery<MaterialHandlingEquipmentsPaginatedQuery, MaterialHandlingEquipmentsPaginatedQueryVariables>(MaterialHandlingEquipmentsPaginatedDocument, baseOptions);
      }
export function useMaterialHandlingEquipmentsPaginatedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MaterialHandlingEquipmentsPaginatedQuery, MaterialHandlingEquipmentsPaginatedQueryVariables>) {
          return Apollo.useLazyQuery<MaterialHandlingEquipmentsPaginatedQuery, MaterialHandlingEquipmentsPaginatedQueryVariables>(MaterialHandlingEquipmentsPaginatedDocument, baseOptions);
        }
export type MaterialHandlingEquipmentsPaginatedQueryHookResult = ReturnType<typeof useMaterialHandlingEquipmentsPaginatedQuery>;
export type MaterialHandlingEquipmentsPaginatedLazyQueryHookResult = ReturnType<typeof useMaterialHandlingEquipmentsPaginatedLazyQuery>;
export type MaterialHandlingEquipmentsPaginatedQueryResult = Apollo.QueryResult<MaterialHandlingEquipmentsPaginatedQuery, MaterialHandlingEquipmentsPaginatedQueryVariables>;
export const MaterialHandlingEquipmentByIdDocument = gql`
    query materialHandlingEquipmentById($id: Int!, $userContext: UserContextInput) {
  materialHandlingEquipmentById(id: $id, userContext: $userContext) {
    ...mhe
  }
}
    ${MheFragmentDoc}`;

/**
 * __useMaterialHandlingEquipmentByIdQuery__
 *
 * To run a query within a React component, call `useMaterialHandlingEquipmentByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useMaterialHandlingEquipmentByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMaterialHandlingEquipmentByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *      userContext: // value for 'userContext'
 *   },
 * });
 */
export function useMaterialHandlingEquipmentByIdQuery(baseOptions: Apollo.QueryHookOptions<MaterialHandlingEquipmentByIdQuery, MaterialHandlingEquipmentByIdQueryVariables>) {
        return Apollo.useQuery<MaterialHandlingEquipmentByIdQuery, MaterialHandlingEquipmentByIdQueryVariables>(MaterialHandlingEquipmentByIdDocument, baseOptions);
      }
export function useMaterialHandlingEquipmentByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MaterialHandlingEquipmentByIdQuery, MaterialHandlingEquipmentByIdQueryVariables>) {
          return Apollo.useLazyQuery<MaterialHandlingEquipmentByIdQuery, MaterialHandlingEquipmentByIdQueryVariables>(MaterialHandlingEquipmentByIdDocument, baseOptions);
        }
export type MaterialHandlingEquipmentByIdQueryHookResult = ReturnType<typeof useMaterialHandlingEquipmentByIdQuery>;
export type MaterialHandlingEquipmentByIdLazyQueryHookResult = ReturnType<typeof useMaterialHandlingEquipmentByIdLazyQuery>;
export type MaterialHandlingEquipmentByIdQueryResult = Apollo.QueryResult<MaterialHandlingEquipmentByIdQuery, MaterialHandlingEquipmentByIdQueryVariables>;
export const SupplierOnBlurDocument = gql`
    query supplierOnBlur($code: String, $userContext: UserContextInput) {
  supplierByCode(code: $code, userContext: $userContext) {
    id
    code
  }
}
    `;

/**
 * __useSupplierOnBlurQuery__
 *
 * To run a query within a React component, call `useSupplierOnBlurQuery` and pass it any options that fit your needs.
 * When your component renders, `useSupplierOnBlurQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSupplierOnBlurQuery({
 *   variables: {
 *      code: // value for 'code'
 *      userContext: // value for 'userContext'
 *   },
 * });
 */
export function useSupplierOnBlurQuery(baseOptions?: Apollo.QueryHookOptions<SupplierOnBlurQuery, SupplierOnBlurQueryVariables>) {
        return Apollo.useQuery<SupplierOnBlurQuery, SupplierOnBlurQueryVariables>(SupplierOnBlurDocument, baseOptions);
      }
export function useSupplierOnBlurLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SupplierOnBlurQuery, SupplierOnBlurQueryVariables>) {
          return Apollo.useLazyQuery<SupplierOnBlurQuery, SupplierOnBlurQueryVariables>(SupplierOnBlurDocument, baseOptions);
        }
export type SupplierOnBlurQueryHookResult = ReturnType<typeof useSupplierOnBlurQuery>;
export type SupplierOnBlurLazyQueryHookResult = ReturnType<typeof useSupplierOnBlurLazyQuery>;
export type SupplierOnBlurQueryResult = Apollo.QueryResult<SupplierOnBlurQuery, SupplierOnBlurQueryVariables>;
export const CarrierOnBlurDocument = gql`
    query carrierOnBlur($code: String, $userContext: UserContextInput) {
  carrierByCode(code: $code, userContext: $userContext) {
    id
    code
  }
}
    `;

/**
 * __useCarrierOnBlurQuery__
 *
 * To run a query within a React component, call `useCarrierOnBlurQuery` and pass it any options that fit your needs.
 * When your component renders, `useCarrierOnBlurQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCarrierOnBlurQuery({
 *   variables: {
 *      code: // value for 'code'
 *      userContext: // value for 'userContext'
 *   },
 * });
 */
export function useCarrierOnBlurQuery(baseOptions?: Apollo.QueryHookOptions<CarrierOnBlurQuery, CarrierOnBlurQueryVariables>) {
        return Apollo.useQuery<CarrierOnBlurQuery, CarrierOnBlurQueryVariables>(CarrierOnBlurDocument, baseOptions);
      }
export function useCarrierOnBlurLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CarrierOnBlurQuery, CarrierOnBlurQueryVariables>) {
          return Apollo.useLazyQuery<CarrierOnBlurQuery, CarrierOnBlurQueryVariables>(CarrierOnBlurDocument, baseOptions);
        }
export type CarrierOnBlurQueryHookResult = ReturnType<typeof useCarrierOnBlurQuery>;
export type CarrierOnBlurLazyQueryHookResult = ReturnType<typeof useCarrierOnBlurLazyQuery>;
export type CarrierOnBlurQueryResult = Apollo.QueryResult<CarrierOnBlurQuery, CarrierOnBlurQueryVariables>;
export const BudgetHolderOnBlurDocument = gql`
    query budgetHolderOnBlur($code: String, $userContext: UserContextInput) {
  budgetHolderByCode(code: $code, userContext: $userContext) {
    id
    code
  }
}
    `;

/**
 * __useBudgetHolderOnBlurQuery__
 *
 * To run a query within a React component, call `useBudgetHolderOnBlurQuery` and pass it any options that fit your needs.
 * When your component renders, `useBudgetHolderOnBlurQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBudgetHolderOnBlurQuery({
 *   variables: {
 *      code: // value for 'code'
 *      userContext: // value for 'userContext'
 *   },
 * });
 */
export function useBudgetHolderOnBlurQuery(baseOptions?: Apollo.QueryHookOptions<BudgetHolderOnBlurQuery, BudgetHolderOnBlurQueryVariables>) {
        return Apollo.useQuery<BudgetHolderOnBlurQuery, BudgetHolderOnBlurQueryVariables>(BudgetHolderOnBlurDocument, baseOptions);
      }
export function useBudgetHolderOnBlurLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BudgetHolderOnBlurQuery, BudgetHolderOnBlurQueryVariables>) {
          return Apollo.useLazyQuery<BudgetHolderOnBlurQuery, BudgetHolderOnBlurQueryVariables>(BudgetHolderOnBlurDocument, baseOptions);
        }
export type BudgetHolderOnBlurQueryHookResult = ReturnType<typeof useBudgetHolderOnBlurQuery>;
export type BudgetHolderOnBlurLazyQueryHookResult = ReturnType<typeof useBudgetHolderOnBlurLazyQuery>;
export type BudgetHolderOnBlurQueryResult = Apollo.QueryResult<BudgetHolderOnBlurQuery, BudgetHolderOnBlurQueryVariables>;
export const PurchaseOrderOnBlurDocument = gql`
    query purchaseOrderOnBlur($poNumber: String, $userContext: UserContextInput) {
  purchaseOrder {
    purchaseOrderByReference(poNumber: $poNumber, userContext: $userContext) {
      id
      referenceNumber
    }
  }
}
    `;

/**
 * __usePurchaseOrderOnBlurQuery__
 *
 * To run a query within a React component, call `usePurchaseOrderOnBlurQuery` and pass it any options that fit your needs.
 * When your component renders, `usePurchaseOrderOnBlurQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePurchaseOrderOnBlurQuery({
 *   variables: {
 *      poNumber: // value for 'poNumber'
 *      userContext: // value for 'userContext'
 *   },
 * });
 */
export function usePurchaseOrderOnBlurQuery(baseOptions?: Apollo.QueryHookOptions<PurchaseOrderOnBlurQuery, PurchaseOrderOnBlurQueryVariables>) {
        return Apollo.useQuery<PurchaseOrderOnBlurQuery, PurchaseOrderOnBlurQueryVariables>(PurchaseOrderOnBlurDocument, baseOptions);
      }
export function usePurchaseOrderOnBlurLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PurchaseOrderOnBlurQuery, PurchaseOrderOnBlurQueryVariables>) {
          return Apollo.useLazyQuery<PurchaseOrderOnBlurQuery, PurchaseOrderOnBlurQueryVariables>(PurchaseOrderOnBlurDocument, baseOptions);
        }
export type PurchaseOrderOnBlurQueryHookResult = ReturnType<typeof usePurchaseOrderOnBlurQuery>;
export type PurchaseOrderOnBlurLazyQueryHookResult = ReturnType<typeof usePurchaseOrderOnBlurLazyQuery>;
export type PurchaseOrderOnBlurQueryResult = Apollo.QueryResult<PurchaseOrderOnBlurQuery, PurchaseOrderOnBlurQueryVariables>;
export const ProductOnBlurDocument = gql`
    query productOnBlur($code: String, $userContext: UserContextInput) {
  productByCode(code: $code, context: $userContext) {
    id
    code
  }
}
    `;

/**
 * __useProductOnBlurQuery__
 *
 * To run a query within a React component, call `useProductOnBlurQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductOnBlurQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductOnBlurQuery({
 *   variables: {
 *      code: // value for 'code'
 *      userContext: // value for 'userContext'
 *   },
 * });
 */
export function useProductOnBlurQuery(baseOptions?: Apollo.QueryHookOptions<ProductOnBlurQuery, ProductOnBlurQueryVariables>) {
        return Apollo.useQuery<ProductOnBlurQuery, ProductOnBlurQueryVariables>(ProductOnBlurDocument, baseOptions);
      }
export function useProductOnBlurLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductOnBlurQuery, ProductOnBlurQueryVariables>) {
          return Apollo.useLazyQuery<ProductOnBlurQuery, ProductOnBlurQueryVariables>(ProductOnBlurDocument, baseOptions);
        }
export type ProductOnBlurQueryHookResult = ReturnType<typeof useProductOnBlurQuery>;
export type ProductOnBlurLazyQueryHookResult = ReturnType<typeof useProductOnBlurLazyQuery>;
export type ProductOnBlurQueryResult = Apollo.QueryResult<ProductOnBlurQuery, ProductOnBlurQueryVariables>;
export const OrderEntryDocument = gql`
    query orderEntry($code: String!) {
  orderEntry(code: $code) @client {
    ...orderEntry
    destinationCode {
      ...destinationCode
    }
    budgetHolder {
      ...budgetHolder
    }
    orderType {
      ...orderType
    }
  }
}
    ${OrderEntryFragmentDoc}
${DestinationCodeFragmentDoc}
${BudgetHolderFragmentDoc}
${OrderTypeFragmentDoc}`;

/**
 * __useOrderEntryQuery__
 *
 * To run a query within a React component, call `useOrderEntryQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderEntryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderEntryQuery({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useOrderEntryQuery(baseOptions: Apollo.QueryHookOptions<OrderEntryQuery, OrderEntryQueryVariables>) {
        return Apollo.useQuery<OrderEntryQuery, OrderEntryQueryVariables>(OrderEntryDocument, baseOptions);
      }
export function useOrderEntryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrderEntryQuery, OrderEntryQueryVariables>) {
          return Apollo.useLazyQuery<OrderEntryQuery, OrderEntryQueryVariables>(OrderEntryDocument, baseOptions);
        }
export type OrderEntryQueryHookResult = ReturnType<typeof useOrderEntryQuery>;
export type OrderEntryLazyQueryHookResult = ReturnType<typeof useOrderEntryLazyQuery>;
export type OrderEntryQueryResult = Apollo.QueryResult<OrderEntryQuery, OrderEntryQueryVariables>;
export const OrderEntriesDocument = gql`
    query orderEntries($filterInput: OrderFilter) {
  orderEntries(where: $filterInput) @client {
    ...orderEntry
    destinationCode {
      ...destinationCode
    }
    budgetHolder {
      ...budgetHolder
    }
    orderType {
      ...orderType
    }
  }
}
    ${OrderEntryFragmentDoc}
${DestinationCodeFragmentDoc}
${BudgetHolderFragmentDoc}
${OrderTypeFragmentDoc}`;

/**
 * __useOrderEntriesQuery__
 *
 * To run a query within a React component, call `useOrderEntriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderEntriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderEntriesQuery({
 *   variables: {
 *      filterInput: // value for 'filterInput'
 *   },
 * });
 */
export function useOrderEntriesQuery(baseOptions?: Apollo.QueryHookOptions<OrderEntriesQuery, OrderEntriesQueryVariables>) {
        return Apollo.useQuery<OrderEntriesQuery, OrderEntriesQueryVariables>(OrderEntriesDocument, baseOptions);
      }
export function useOrderEntriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrderEntriesQuery, OrderEntriesQueryVariables>) {
          return Apollo.useLazyQuery<OrderEntriesQuery, OrderEntriesQueryVariables>(OrderEntriesDocument, baseOptions);
        }
export type OrderEntriesQueryHookResult = ReturnType<typeof useOrderEntriesQuery>;
export type OrderEntriesLazyQueryHookResult = ReturnType<typeof useOrderEntriesLazyQuery>;
export type OrderEntriesQueryResult = Apollo.QueryResult<OrderEntriesQuery, OrderEntriesQueryVariables>;
export const OrderTypesDocument = gql`
    query orderTypes {
  orderTypes @client {
    ...orderType
  }
}
    ${OrderTypeFragmentDoc}`;

/**
 * __useOrderTypesQuery__
 *
 * To run a query within a React component, call `useOrderTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useOrderTypesQuery(baseOptions?: Apollo.QueryHookOptions<OrderTypesQuery, OrderTypesQueryVariables>) {
        return Apollo.useQuery<OrderTypesQuery, OrderTypesQueryVariables>(OrderTypesDocument, baseOptions);
      }
export function useOrderTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrderTypesQuery, OrderTypesQueryVariables>) {
          return Apollo.useLazyQuery<OrderTypesQuery, OrderTypesQueryVariables>(OrderTypesDocument, baseOptions);
        }
export type OrderTypesQueryHookResult = ReturnType<typeof useOrderTypesQuery>;
export type OrderTypesLazyQueryHookResult = ReturnType<typeof useOrderTypesLazyQuery>;
export type OrderTypesQueryResult = Apollo.QueryResult<OrderTypesQuery, OrderTypesQueryVariables>;
export const PoFormatsDocument = gql`
    query poFormats {
  poFormats @client {
    ...poFormat
  }
}
    ${PoFormatFragmentDoc}`;

/**
 * __usePoFormatsQuery__
 *
 * To run a query within a React component, call `usePoFormatsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePoFormatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePoFormatsQuery({
 *   variables: {
 *   },
 * });
 */
export function usePoFormatsQuery(baseOptions?: Apollo.QueryHookOptions<PoFormatsQuery, PoFormatsQueryVariables>) {
        return Apollo.useQuery<PoFormatsQuery, PoFormatsQueryVariables>(PoFormatsDocument, baseOptions);
      }
export function usePoFormatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PoFormatsQuery, PoFormatsQueryVariables>) {
          return Apollo.useLazyQuery<PoFormatsQuery, PoFormatsQueryVariables>(PoFormatsDocument, baseOptions);
        }
export type PoFormatsQueryHookResult = ReturnType<typeof usePoFormatsQuery>;
export type PoFormatsLazyQueryHookResult = ReturnType<typeof usePoFormatsLazyQuery>;
export type PoFormatsQueryResult = Apollo.QueryResult<PoFormatsQuery, PoFormatsQueryVariables>;
export const PoTransmissionMethodsDocument = gql`
    query poTransmissionMethods {
  poTransmissionMethods @client {
    ...poTransmissionMethod
  }
}
    ${PoTransmissionMethodFragmentDoc}`;

/**
 * __usePoTransmissionMethodsQuery__
 *
 * To run a query within a React component, call `usePoTransmissionMethodsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePoTransmissionMethodsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePoTransmissionMethodsQuery({
 *   variables: {
 *   },
 * });
 */
export function usePoTransmissionMethodsQuery(baseOptions?: Apollo.QueryHookOptions<PoTransmissionMethodsQuery, PoTransmissionMethodsQueryVariables>) {
        return Apollo.useQuery<PoTransmissionMethodsQuery, PoTransmissionMethodsQueryVariables>(PoTransmissionMethodsDocument, baseOptions);
      }
export function usePoTransmissionMethodsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PoTransmissionMethodsQuery, PoTransmissionMethodsQueryVariables>) {
          return Apollo.useLazyQuery<PoTransmissionMethodsQuery, PoTransmissionMethodsQueryVariables>(PoTransmissionMethodsDocument, baseOptions);
        }
export type PoTransmissionMethodsQueryHookResult = ReturnType<typeof usePoTransmissionMethodsQuery>;
export type PoTransmissionMethodsLazyQueryHookResult = ReturnType<typeof usePoTransmissionMethodsLazyQuery>;
export type PoTransmissionMethodsQueryResult = Apollo.QueryResult<PoTransmissionMethodsQuery, PoTransmissionMethodsQueryVariables>;
export const ProductsDocument = gql`
    query products($filterInput: ProductFilterInput, $userContext: UserContextInput, $includeLinked: Boolean!) {
  product(
    where: $filterInput
    context: $userContext
    includeLinked: $includeLinked
  ) {
    nodes {
      ...product
      pickfaces {
        ...pickface
      }
      licencePlates {
        ...licencePlate
        ...licencePlate
      }
      licencePlates {
        ...licencePlate
      }
      documents {
        ...document
      }
    }
  }
}
    ${ProductFragmentDoc}
${PickfaceFragmentDoc}
${LicencePlateFragmentDoc}
${DocumentFragmentDoc}`;

/**
 * __useProductsQuery__
 *
 * To run a query within a React component, call `useProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductsQuery({
 *   variables: {
 *      filterInput: // value for 'filterInput'
 *      userContext: // value for 'userContext'
 *      includeLinked: // value for 'includeLinked'
 *   },
 * });
 */
export function useProductsQuery(baseOptions: Apollo.QueryHookOptions<ProductsQuery, ProductsQueryVariables>) {
        return Apollo.useQuery<ProductsQuery, ProductsQueryVariables>(ProductsDocument, baseOptions);
      }
export function useProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductsQuery, ProductsQueryVariables>) {
          return Apollo.useLazyQuery<ProductsQuery, ProductsQueryVariables>(ProductsDocument, baseOptions);
        }
export type ProductsQueryHookResult = ReturnType<typeof useProductsQuery>;
export type ProductsLazyQueryHookResult = ReturnType<typeof useProductsLazyQuery>;
export type ProductsQueryResult = Apollo.QueryResult<ProductsQuery, ProductsQueryVariables>;
export const SelectProductsDocument = gql`
    query selectProducts($filterInput: ProductFilterInput, $userContext: UserContextInput, $includeLinked: Boolean!) {
  product(
    where: $filterInput
    context: $userContext
    includeLinked: $includeLinked
  ) {
    nodes {
      id
      code
      description
    }
  }
}
    `;

/**
 * __useSelectProductsQuery__
 *
 * To run a query within a React component, call `useSelectProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSelectProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSelectProductsQuery({
 *   variables: {
 *      filterInput: // value for 'filterInput'
 *      userContext: // value for 'userContext'
 *      includeLinked: // value for 'includeLinked'
 *   },
 * });
 */
export function useSelectProductsQuery(baseOptions: Apollo.QueryHookOptions<SelectProductsQuery, SelectProductsQueryVariables>) {
        return Apollo.useQuery<SelectProductsQuery, SelectProductsQueryVariables>(SelectProductsDocument, baseOptions);
      }
export function useSelectProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SelectProductsQuery, SelectProductsQueryVariables>) {
          return Apollo.useLazyQuery<SelectProductsQuery, SelectProductsQueryVariables>(SelectProductsDocument, baseOptions);
        }
export type SelectProductsQueryHookResult = ReturnType<typeof useSelectProductsQuery>;
export type SelectProductsLazyQueryHookResult = ReturnType<typeof useSelectProductsLazyQuery>;
export type SelectProductsQueryResult = Apollo.QueryResult<SelectProductsQuery, SelectProductsQueryVariables>;
export const ProductsPaginatedDocument = gql`
    query productsPaginated($filterInput: ProductFilterInput, $userContext: UserContextInput, $includeLinked: Boolean!, $first: Int, $after: String) {
  product(
    where: $filterInput
    context: $userContext
    includeLinked: $includeLinked
    first: $first
    after: $after
  ) {
    totalCount
    pageInfo {
      endCursor
      startCursor
      hasNextPage
      hasPreviousPage
    }
    nodes {
      id
      code
      description
      stockOwner {
        name
      }
    }
  }
}
    `;

/**
 * __useProductsPaginatedQuery__
 *
 * To run a query within a React component, call `useProductsPaginatedQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductsPaginatedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductsPaginatedQuery({
 *   variables: {
 *      filterInput: // value for 'filterInput'
 *      userContext: // value for 'userContext'
 *      includeLinked: // value for 'includeLinked'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useProductsPaginatedQuery(baseOptions: Apollo.QueryHookOptions<ProductsPaginatedQuery, ProductsPaginatedQueryVariables>) {
        return Apollo.useQuery<ProductsPaginatedQuery, ProductsPaginatedQueryVariables>(ProductsPaginatedDocument, baseOptions);
      }
export function useProductsPaginatedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductsPaginatedQuery, ProductsPaginatedQueryVariables>) {
          return Apollo.useLazyQuery<ProductsPaginatedQuery, ProductsPaginatedQueryVariables>(ProductsPaginatedDocument, baseOptions);
        }
export type ProductsPaginatedQueryHookResult = ReturnType<typeof useProductsPaginatedQuery>;
export type ProductsPaginatedLazyQueryHookResult = ReturnType<typeof useProductsPaginatedLazyQuery>;
export type ProductsPaginatedQueryResult = Apollo.QueryResult<ProductsPaginatedQuery, ProductsPaginatedQueryVariables>;
export const ProductByIdDocument = gql`
    query productById($id: Int!, $userContext: UserContextInput) {
  productById(id: $id, context: $userContext) {
    ...product
    pickfaces {
      ...pickface
    }
    licencePlates {
      ...licencePlate
      ...licencePlate
    }
    licencePlates {
      ...licencePlate
    }
    documents {
      ...document
    }
  }
}
    ${ProductFragmentDoc}
${PickfaceFragmentDoc}
${LicencePlateFragmentDoc}
${DocumentFragmentDoc}`;

/**
 * __useProductByIdQuery__
 *
 * To run a query within a React component, call `useProductByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *      userContext: // value for 'userContext'
 *   },
 * });
 */
export function useProductByIdQuery(baseOptions: Apollo.QueryHookOptions<ProductByIdQuery, ProductByIdQueryVariables>) {
        return Apollo.useQuery<ProductByIdQuery, ProductByIdQueryVariables>(ProductByIdDocument, baseOptions);
      }
export function useProductByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductByIdQuery, ProductByIdQueryVariables>) {
          return Apollo.useLazyQuery<ProductByIdQuery, ProductByIdQueryVariables>(ProductByIdDocument, baseOptions);
        }
export type ProductByIdQueryHookResult = ReturnType<typeof useProductByIdQuery>;
export type ProductByIdLazyQueryHookResult = ReturnType<typeof useProductByIdLazyQuery>;
export type ProductByIdQueryResult = Apollo.QueryResult<ProductByIdQuery, ProductByIdQueryVariables>;
export const RequiredDataDocument = gql`
    query requiredData($code: String!, $userContext: UserContextInput) {
  productByCode(code: $code, context: $userContext) {
    ... on Product {
      id
      description
      require {
        arrivalTemp
        batch
        batchInfo
        bestBefore
        budgetHolder
        cartonLP
        expiry
        handlingType
        killDte
        originCntry
        packType
        productionDte
        serial
        serials
        slaughterCode
        status
        weight
      }
    }
  }
}
    `;

/**
 * __useRequiredDataQuery__
 *
 * To run a query within a React component, call `useRequiredDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useRequiredDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRequiredDataQuery({
 *   variables: {
 *      code: // value for 'code'
 *      userContext: // value for 'userContext'
 *   },
 * });
 */
export function useRequiredDataQuery(baseOptions: Apollo.QueryHookOptions<RequiredDataQuery, RequiredDataQueryVariables>) {
        return Apollo.useQuery<RequiredDataQuery, RequiredDataQueryVariables>(RequiredDataDocument, baseOptions);
      }
export function useRequiredDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RequiredDataQuery, RequiredDataQueryVariables>) {
          return Apollo.useLazyQuery<RequiredDataQuery, RequiredDataQueryVariables>(RequiredDataDocument, baseOptions);
        }
export type RequiredDataQueryHookResult = ReturnType<typeof useRequiredDataQuery>;
export type RequiredDataLazyQueryHookResult = ReturnType<typeof useRequiredDataLazyQuery>;
export type RequiredDataQueryResult = Apollo.QueryResult<RequiredDataQuery, RequiredDataQueryVariables>;
export const PurchaseOrdersDocument = gql`
    query purchaseOrders($filterInput: PurchaseOrderFilterInput, $userContext: UserContextInput, $first: Int, $after: String, $before: String) {
  purchaseOrder {
    id
    purchaseOrders(
      where: $filterInput
      userContext: $userContext
      first: $first
      after: $after
      before: $before
    ) {
      totalCount
      pageInfo {
        hasNextPage
        startCursor
        endCursor
        startCursor
      }
      nodes {
        ...purchaseOrder
      }
    }
  }
}
    ${PurchaseOrderFragmentDoc}`;

/**
 * __usePurchaseOrdersQuery__
 *
 * To run a query within a React component, call `usePurchaseOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `usePurchaseOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePurchaseOrdersQuery({
 *   variables: {
 *      filterInput: // value for 'filterInput'
 *      userContext: // value for 'userContext'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *   },
 * });
 */
export function usePurchaseOrdersQuery(baseOptions?: Apollo.QueryHookOptions<PurchaseOrdersQuery, PurchaseOrdersQueryVariables>) {
        return Apollo.useQuery<PurchaseOrdersQuery, PurchaseOrdersQueryVariables>(PurchaseOrdersDocument, baseOptions);
      }
export function usePurchaseOrdersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PurchaseOrdersQuery, PurchaseOrdersQueryVariables>) {
          return Apollo.useLazyQuery<PurchaseOrdersQuery, PurchaseOrdersQueryVariables>(PurchaseOrdersDocument, baseOptions);
        }
export type PurchaseOrdersQueryHookResult = ReturnType<typeof usePurchaseOrdersQuery>;
export type PurchaseOrdersLazyQueryHookResult = ReturnType<typeof usePurchaseOrdersLazyQuery>;
export type PurchaseOrdersQueryResult = Apollo.QueryResult<PurchaseOrdersQuery, PurchaseOrdersQueryVariables>;
export const PurchaseOrderByIdDocument = gql`
    query purchaseOrderById($id: Int!, $userContext: UserContextInput) {
  purchaseOrder {
    id
    purchaseOrderById(id: $id, userContext: $userContext) {
      ...purchaseOrder
    }
  }
}
    ${PurchaseOrderFragmentDoc}`;

/**
 * __usePurchaseOrderByIdQuery__
 *
 * To run a query within a React component, call `usePurchaseOrderByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `usePurchaseOrderByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePurchaseOrderByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *      userContext: // value for 'userContext'
 *   },
 * });
 */
export function usePurchaseOrderByIdQuery(baseOptions: Apollo.QueryHookOptions<PurchaseOrderByIdQuery, PurchaseOrderByIdQueryVariables>) {
        return Apollo.useQuery<PurchaseOrderByIdQuery, PurchaseOrderByIdQueryVariables>(PurchaseOrderByIdDocument, baseOptions);
      }
export function usePurchaseOrderByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PurchaseOrderByIdQuery, PurchaseOrderByIdQueryVariables>) {
          return Apollo.useLazyQuery<PurchaseOrderByIdQuery, PurchaseOrderByIdQueryVariables>(PurchaseOrderByIdDocument, baseOptions);
        }
export type PurchaseOrderByIdQueryHookResult = ReturnType<typeof usePurchaseOrderByIdQuery>;
export type PurchaseOrderByIdLazyQueryHookResult = ReturnType<typeof usePurchaseOrderByIdLazyQuery>;
export type PurchaseOrderByIdQueryResult = Apollo.QueryResult<PurchaseOrderByIdQuery, PurchaseOrderByIdQueryVariables>;
export const PurchaseOrderByReferenceDocument = gql`
    query purchaseOrderByReference($poNumber: String, $userContext: UserContextInput) {
  purchaseOrder {
    id
    purchaseOrderByReference(poNumber: $poNumber, userContext: $userContext) {
      ...purchaseOrder
    }
  }
}
    ${PurchaseOrderFragmentDoc}`;

/**
 * __usePurchaseOrderByReferenceQuery__
 *
 * To run a query within a React component, call `usePurchaseOrderByReferenceQuery` and pass it any options that fit your needs.
 * When your component renders, `usePurchaseOrderByReferenceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePurchaseOrderByReferenceQuery({
 *   variables: {
 *      poNumber: // value for 'poNumber'
 *      userContext: // value for 'userContext'
 *   },
 * });
 */
export function usePurchaseOrderByReferenceQuery(baseOptions?: Apollo.QueryHookOptions<PurchaseOrderByReferenceQuery, PurchaseOrderByReferenceQueryVariables>) {
        return Apollo.useQuery<PurchaseOrderByReferenceQuery, PurchaseOrderByReferenceQueryVariables>(PurchaseOrderByReferenceDocument, baseOptions);
      }
export function usePurchaseOrderByReferenceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PurchaseOrderByReferenceQuery, PurchaseOrderByReferenceQueryVariables>) {
          return Apollo.useLazyQuery<PurchaseOrderByReferenceQuery, PurchaseOrderByReferenceQueryVariables>(PurchaseOrderByReferenceDocument, baseOptions);
        }
export type PurchaseOrderByReferenceQueryHookResult = ReturnType<typeof usePurchaseOrderByReferenceQuery>;
export type PurchaseOrderByReferenceLazyQueryHookResult = ReturnType<typeof usePurchaseOrderByReferenceLazyQuery>;
export type PurchaseOrderByReferenceQueryResult = Apollo.QueryResult<PurchaseOrderByReferenceQuery, PurchaseOrderByReferenceQueryVariables>;
export const CultureDocument = gql`
    query culture($resourceSet: String!) {
  resources {
    allLocaleIds(resourceSet: $resourceSet) {
      name
      displayName
      nativeName
      englishName
    }
  }
}
    `;

/**
 * __useCultureQuery__
 *
 * To run a query within a React component, call `useCultureQuery` and pass it any options that fit your needs.
 * When your component renders, `useCultureQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCultureQuery({
 *   variables: {
 *      resourceSet: // value for 'resourceSet'
 *   },
 * });
 */
export function useCultureQuery(baseOptions: Apollo.QueryHookOptions<CultureQuery, CultureQueryVariables>) {
        return Apollo.useQuery<CultureQuery, CultureQueryVariables>(CultureDocument, baseOptions);
      }
export function useCultureLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CultureQuery, CultureQueryVariables>) {
          return Apollo.useLazyQuery<CultureQuery, CultureQueryVariables>(CultureDocument, baseOptions);
        }
export type CultureQueryHookResult = ReturnType<typeof useCultureQuery>;
export type CultureLazyQueryHookResult = ReturnType<typeof useCultureLazyQuery>;
export type CultureQueryResult = Apollo.QueryResult<CultureQuery, CultureQueryVariables>;
export const CultureByNameDocument = gql`
    query cultureByName($filterInput: CultureInfoFilterInput) {
  resources {
    cultures(where: $filterInput) {
      nodes {
        LCID
        name
        displayName
        nativeName
        englishName
      }
    }
  }
}
    `;

/**
 * __useCultureByNameQuery__
 *
 * To run a query within a React component, call `useCultureByNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useCultureByNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCultureByNameQuery({
 *   variables: {
 *      filterInput: // value for 'filterInput'
 *   },
 * });
 */
export function useCultureByNameQuery(baseOptions?: Apollo.QueryHookOptions<CultureByNameQuery, CultureByNameQueryVariables>) {
        return Apollo.useQuery<CultureByNameQuery, CultureByNameQueryVariables>(CultureByNameDocument, baseOptions);
      }
export function useCultureByNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CultureByNameQuery, CultureByNameQueryVariables>) {
          return Apollo.useLazyQuery<CultureByNameQuery, CultureByNameQueryVariables>(CultureByNameDocument, baseOptions);
        }
export type CultureByNameQueryHookResult = ReturnType<typeof useCultureByNameQuery>;
export type CultureByNameLazyQueryHookResult = ReturnType<typeof useCultureByNameLazyQuery>;
export type CultureByNameQueryResult = Apollo.QueryResult<CultureByNameQuery, CultureByNameQueryVariables>;
export const StockEnquiryDocument = gql`
    query stockEnquiry($filterInput: StockFilterInput, $userContext: UserContextInput, $first: Int, $after: String, $before: String) {
  stock {
    stock(
      where: $filterInput
      userContext: $userContext
      first: $first
      after: $after
      before: $before
    ) {
      totalCount
      pageInfo {
        hasNextPage
        startCursor
        endCursor
        startCursor
      }
      nodes {
        ...stock
      }
    }
  }
}
    ${StockFragmentDoc}`;

/**
 * __useStockEnquiryQuery__
 *
 * To run a query within a React component, call `useStockEnquiryQuery` and pass it any options that fit your needs.
 * When your component renders, `useStockEnquiryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStockEnquiryQuery({
 *   variables: {
 *      filterInput: // value for 'filterInput'
 *      userContext: // value for 'userContext'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *   },
 * });
 */
export function useStockEnquiryQuery(baseOptions?: Apollo.QueryHookOptions<StockEnquiryQuery, StockEnquiryQueryVariables>) {
        return Apollo.useQuery<StockEnquiryQuery, StockEnquiryQueryVariables>(StockEnquiryDocument, baseOptions);
      }
export function useStockEnquiryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StockEnquiryQuery, StockEnquiryQueryVariables>) {
          return Apollo.useLazyQuery<StockEnquiryQuery, StockEnquiryQueryVariables>(StockEnquiryDocument, baseOptions);
        }
export type StockEnquiryQueryHookResult = ReturnType<typeof useStockEnquiryQuery>;
export type StockEnquiryLazyQueryHookResult = ReturnType<typeof useStockEnquiryLazyQuery>;
export type StockEnquiryQueryResult = Apollo.QueryResult<StockEnquiryQuery, StockEnquiryQueryVariables>;
export const StockOwnersDocument = gql`
    query stockOwners($filterInput: StockOwnerFilterInput) {
  stockOwners(where: $filterInput) {
    nodes {
      ...stockOwner
      linkedStockOwners {
        child {
          id
          code
        }
      }
      address {
        ...address
      }
      categories {
        ...category
      }
      contact {
        ...contact
      }
      productStatuses {
        ...productStatuses
      }
      orderStatuses {
        ...orderStatus
      }
      pickMethods {
        ...pickMethod
      }
      confirmMethods {
        ...pickConfirmMethod
      }
    }
  }
}
    ${StockOwnerFragmentDoc}
${AddressFragmentDoc}
${CategoryFragmentDoc}
${ContactFragmentDoc}
${ProductStatusesFragmentDoc}
${OrderStatusFragmentDoc}
${PickMethodFragmentDoc}
${PickConfirmMethodFragmentDoc}`;

/**
 * __useStockOwnersQuery__
 *
 * To run a query within a React component, call `useStockOwnersQuery` and pass it any options that fit your needs.
 * When your component renders, `useStockOwnersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStockOwnersQuery({
 *   variables: {
 *      filterInput: // value for 'filterInput'
 *   },
 * });
 */
export function useStockOwnersQuery(baseOptions?: Apollo.QueryHookOptions<StockOwnersQuery, StockOwnersQueryVariables>) {
        return Apollo.useQuery<StockOwnersQuery, StockOwnersQueryVariables>(StockOwnersDocument, baseOptions);
      }
export function useStockOwnersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StockOwnersQuery, StockOwnersQueryVariables>) {
          return Apollo.useLazyQuery<StockOwnersQuery, StockOwnersQueryVariables>(StockOwnersDocument, baseOptions);
        }
export type StockOwnersQueryHookResult = ReturnType<typeof useStockOwnersQuery>;
export type StockOwnersLazyQueryHookResult = ReturnType<typeof useStockOwnersLazyQuery>;
export type StockOwnersQueryResult = Apollo.QueryResult<StockOwnersQuery, StockOwnersQueryVariables>;
export const StockOwnerCategoriesDocument = gql`
    query stockOwnerCategories($id: Int!) {
  stockOwnerById(id: $id) {
    categories {
      code
      description
    }
  }
}
    `;

/**
 * __useStockOwnerCategoriesQuery__
 *
 * To run a query within a React component, call `useStockOwnerCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useStockOwnerCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStockOwnerCategoriesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useStockOwnerCategoriesQuery(baseOptions: Apollo.QueryHookOptions<StockOwnerCategoriesQuery, StockOwnerCategoriesQueryVariables>) {
        return Apollo.useQuery<StockOwnerCategoriesQuery, StockOwnerCategoriesQueryVariables>(StockOwnerCategoriesDocument, baseOptions);
      }
export function useStockOwnerCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StockOwnerCategoriesQuery, StockOwnerCategoriesQueryVariables>) {
          return Apollo.useLazyQuery<StockOwnerCategoriesQuery, StockOwnerCategoriesQueryVariables>(StockOwnerCategoriesDocument, baseOptions);
        }
export type StockOwnerCategoriesQueryHookResult = ReturnType<typeof useStockOwnerCategoriesQuery>;
export type StockOwnerCategoriesLazyQueryHookResult = ReturnType<typeof useStockOwnerCategoriesLazyQuery>;
export type StockOwnerCategoriesQueryResult = Apollo.QueryResult<StockOwnerCategoriesQuery, StockOwnerCategoriesQueryVariables>;
export const StockOwnerProductStatusesDocument = gql`
    query stockOwnerProductStatuses($id: Int!) {
  stockOwnerById(id: $id) {
    productStatuses {
      ...productStatuses
    }
  }
}
    ${ProductStatusesFragmentDoc}`;

/**
 * __useStockOwnerProductStatusesQuery__
 *
 * To run a query within a React component, call `useStockOwnerProductStatusesQuery` and pass it any options that fit your needs.
 * When your component renders, `useStockOwnerProductStatusesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStockOwnerProductStatusesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useStockOwnerProductStatusesQuery(baseOptions: Apollo.QueryHookOptions<StockOwnerProductStatusesQuery, StockOwnerProductStatusesQueryVariables>) {
        return Apollo.useQuery<StockOwnerProductStatusesQuery, StockOwnerProductStatusesQueryVariables>(StockOwnerProductStatusesDocument, baseOptions);
      }
export function useStockOwnerProductStatusesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StockOwnerProductStatusesQuery, StockOwnerProductStatusesQueryVariables>) {
          return Apollo.useLazyQuery<StockOwnerProductStatusesQuery, StockOwnerProductStatusesQueryVariables>(StockOwnerProductStatusesDocument, baseOptions);
        }
export type StockOwnerProductStatusesQueryHookResult = ReturnType<typeof useStockOwnerProductStatusesQuery>;
export type StockOwnerProductStatusesLazyQueryHookResult = ReturnType<typeof useStockOwnerProductStatusesLazyQuery>;
export type StockOwnerProductStatusesQueryResult = Apollo.QueryResult<StockOwnerProductStatusesQuery, StockOwnerProductStatusesQueryVariables>;
export const StockOwnerPickMethodsDocument = gql`
    query stockOwnerPickMethods($id: Int!) {
  stockOwnerById(id: $id) {
    pickMethods {
      id
      name
    }
  }
}
    `;

/**
 * __useStockOwnerPickMethodsQuery__
 *
 * To run a query within a React component, call `useStockOwnerPickMethodsQuery` and pass it any options that fit your needs.
 * When your component renders, `useStockOwnerPickMethodsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStockOwnerPickMethodsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useStockOwnerPickMethodsQuery(baseOptions: Apollo.QueryHookOptions<StockOwnerPickMethodsQuery, StockOwnerPickMethodsQueryVariables>) {
        return Apollo.useQuery<StockOwnerPickMethodsQuery, StockOwnerPickMethodsQueryVariables>(StockOwnerPickMethodsDocument, baseOptions);
      }
export function useStockOwnerPickMethodsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StockOwnerPickMethodsQuery, StockOwnerPickMethodsQueryVariables>) {
          return Apollo.useLazyQuery<StockOwnerPickMethodsQuery, StockOwnerPickMethodsQueryVariables>(StockOwnerPickMethodsDocument, baseOptions);
        }
export type StockOwnerPickMethodsQueryHookResult = ReturnType<typeof useStockOwnerPickMethodsQuery>;
export type StockOwnerPickMethodsLazyQueryHookResult = ReturnType<typeof useStockOwnerPickMethodsLazyQuery>;
export type StockOwnerPickMethodsQueryResult = Apollo.QueryResult<StockOwnerPickMethodsQuery, StockOwnerPickMethodsQueryVariables>;
export const LinkedStockOwnersDocument = gql`
    query linkedStockOwners {
  stockOwners {
    nodes {
      id
      code
    }
  }
}
    `;

/**
 * __useLinkedStockOwnersQuery__
 *
 * To run a query within a React component, call `useLinkedStockOwnersQuery` and pass it any options that fit your needs.
 * When your component renders, `useLinkedStockOwnersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLinkedStockOwnersQuery({
 *   variables: {
 *   },
 * });
 */
export function useLinkedStockOwnersQuery(baseOptions?: Apollo.QueryHookOptions<LinkedStockOwnersQuery, LinkedStockOwnersQueryVariables>) {
        return Apollo.useQuery<LinkedStockOwnersQuery, LinkedStockOwnersQueryVariables>(LinkedStockOwnersDocument, baseOptions);
      }
export function useLinkedStockOwnersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LinkedStockOwnersQuery, LinkedStockOwnersQueryVariables>) {
          return Apollo.useLazyQuery<LinkedStockOwnersQuery, LinkedStockOwnersQueryVariables>(LinkedStockOwnersDocument, baseOptions);
        }
export type LinkedStockOwnersQueryHookResult = ReturnType<typeof useLinkedStockOwnersQuery>;
export type LinkedStockOwnersLazyQueryHookResult = ReturnType<typeof useLinkedStockOwnersLazyQuery>;
export type LinkedStockOwnersQueryResult = Apollo.QueryResult<LinkedStockOwnersQuery, LinkedStockOwnersQueryVariables>;
export const SelectStockOwnersDocument = gql`
    query selectStockOwners {
  stockOwners {
    nodes {
      id
      code
      name
    }
  }
}
    `;

/**
 * __useSelectStockOwnersQuery__
 *
 * To run a query within a React component, call `useSelectStockOwnersQuery` and pass it any options that fit your needs.
 * When your component renders, `useSelectStockOwnersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSelectStockOwnersQuery({
 *   variables: {
 *   },
 * });
 */
export function useSelectStockOwnersQuery(baseOptions?: Apollo.QueryHookOptions<SelectStockOwnersQuery, SelectStockOwnersQueryVariables>) {
        return Apollo.useQuery<SelectStockOwnersQuery, SelectStockOwnersQueryVariables>(SelectStockOwnersDocument, baseOptions);
      }
export function useSelectStockOwnersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SelectStockOwnersQuery, SelectStockOwnersQueryVariables>) {
          return Apollo.useLazyQuery<SelectStockOwnersQuery, SelectStockOwnersQueryVariables>(SelectStockOwnersDocument, baseOptions);
        }
export type SelectStockOwnersQueryHookResult = ReturnType<typeof useSelectStockOwnersQuery>;
export type SelectStockOwnersLazyQueryHookResult = ReturnType<typeof useSelectStockOwnersLazyQuery>;
export type SelectStockOwnersQueryResult = Apollo.QueryResult<SelectStockOwnersQuery, SelectStockOwnersQueryVariables>;
export const StockOwnerPaginatedDocument = gql`
    query stockOwnerPaginated($filterInput: StockOwnerFilterInput, $first: Int, $after: String) {
  stockOwners(where: $filterInput, first: $first, after: $after) {
    pageInfo {
      endCursor
      startCursor
      hasNextPage
      hasPreviousPage
    }
    totalCount
    nodes {
      id
      code
      name
      status
    }
  }
}
    `;

/**
 * __useStockOwnerPaginatedQuery__
 *
 * To run a query within a React component, call `useStockOwnerPaginatedQuery` and pass it any options that fit your needs.
 * When your component renders, `useStockOwnerPaginatedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStockOwnerPaginatedQuery({
 *   variables: {
 *      filterInput: // value for 'filterInput'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useStockOwnerPaginatedQuery(baseOptions?: Apollo.QueryHookOptions<StockOwnerPaginatedQuery, StockOwnerPaginatedQueryVariables>) {
        return Apollo.useQuery<StockOwnerPaginatedQuery, StockOwnerPaginatedQueryVariables>(StockOwnerPaginatedDocument, baseOptions);
      }
export function useStockOwnerPaginatedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StockOwnerPaginatedQuery, StockOwnerPaginatedQueryVariables>) {
          return Apollo.useLazyQuery<StockOwnerPaginatedQuery, StockOwnerPaginatedQueryVariables>(StockOwnerPaginatedDocument, baseOptions);
        }
export type StockOwnerPaginatedQueryHookResult = ReturnType<typeof useStockOwnerPaginatedQuery>;
export type StockOwnerPaginatedLazyQueryHookResult = ReturnType<typeof useStockOwnerPaginatedLazyQuery>;
export type StockOwnerPaginatedQueryResult = Apollo.QueryResult<StockOwnerPaginatedQuery, StockOwnerPaginatedQueryVariables>;
export const StockOwnerByIdDocument = gql`
    query stockOwnerById($id: Int!) {
  stockOwnerById(id: $id) {
    ...stockOwner
    linkedStockOwners {
      child {
        id
        code
      }
    }
    address {
      ...address
    }
    categories {
      ...category
    }
    contact {
      ...contact
    }
    productStatuses {
      ...productStatuses
    }
    orderStatuses {
      ...orderStatus
    }
    pickMethods {
      ...pickMethod
    }
    confirmMethods {
      ...pickConfirmMethod
    }
  }
}
    ${StockOwnerFragmentDoc}
${AddressFragmentDoc}
${CategoryFragmentDoc}
${ContactFragmentDoc}
${ProductStatusesFragmentDoc}
${OrderStatusFragmentDoc}
${PickMethodFragmentDoc}
${PickConfirmMethodFragmentDoc}`;

/**
 * __useStockOwnerByIdQuery__
 *
 * To run a query within a React component, call `useStockOwnerByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useStockOwnerByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStockOwnerByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useStockOwnerByIdQuery(baseOptions: Apollo.QueryHookOptions<StockOwnerByIdQuery, StockOwnerByIdQueryVariables>) {
        return Apollo.useQuery<StockOwnerByIdQuery, StockOwnerByIdQueryVariables>(StockOwnerByIdDocument, baseOptions);
      }
export function useStockOwnerByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StockOwnerByIdQuery, StockOwnerByIdQueryVariables>) {
          return Apollo.useLazyQuery<StockOwnerByIdQuery, StockOwnerByIdQueryVariables>(StockOwnerByIdDocument, baseOptions);
        }
export type StockOwnerByIdQueryHookResult = ReturnType<typeof useStockOwnerByIdQuery>;
export type StockOwnerByIdLazyQueryHookResult = ReturnType<typeof useStockOwnerByIdLazyQuery>;
export type StockOwnerByIdQueryResult = Apollo.QueryResult<StockOwnerByIdQuery, StockOwnerByIdQueryVariables>;
export const StorageTypesDocument = gql`
    query storageTypes {
  storageTypes {
    nodes {
      ...storageType
    }
  }
}
    ${StorageTypeFragmentDoc}`;

/**
 * __useStorageTypesQuery__
 *
 * To run a query within a React component, call `useStorageTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useStorageTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStorageTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useStorageTypesQuery(baseOptions?: Apollo.QueryHookOptions<StorageTypesQuery, StorageTypesQueryVariables>) {
        return Apollo.useQuery<StorageTypesQuery, StorageTypesQueryVariables>(StorageTypesDocument, baseOptions);
      }
export function useStorageTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StorageTypesQuery, StorageTypesQueryVariables>) {
          return Apollo.useLazyQuery<StorageTypesQuery, StorageTypesQueryVariables>(StorageTypesDocument, baseOptions);
        }
export type StorageTypesQueryHookResult = ReturnType<typeof useStorageTypesQuery>;
export type StorageTypesLazyQueryHookResult = ReturnType<typeof useStorageTypesLazyQuery>;
export type StorageTypesQueryResult = Apollo.QueryResult<StorageTypesQuery, StorageTypesQueryVariables>;
export const StorageTypesPaginatedDocument = gql`
    query storageTypesPaginated($first: Int, $after: String) {
  storageTypes(first: $first, after: $after) {
    totalCount
    pageInfo {
      hasNextPage
      startCursor
      endCursor
    }
    nodes {
      ...storageType
    }
  }
}
    ${StorageTypeFragmentDoc}`;

/**
 * __useStorageTypesPaginatedQuery__
 *
 * To run a query within a React component, call `useStorageTypesPaginatedQuery` and pass it any options that fit your needs.
 * When your component renders, `useStorageTypesPaginatedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStorageTypesPaginatedQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useStorageTypesPaginatedQuery(baseOptions?: Apollo.QueryHookOptions<StorageTypesPaginatedQuery, StorageTypesPaginatedQueryVariables>) {
        return Apollo.useQuery<StorageTypesPaginatedQuery, StorageTypesPaginatedQueryVariables>(StorageTypesPaginatedDocument, baseOptions);
      }
export function useStorageTypesPaginatedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StorageTypesPaginatedQuery, StorageTypesPaginatedQueryVariables>) {
          return Apollo.useLazyQuery<StorageTypesPaginatedQuery, StorageTypesPaginatedQueryVariables>(StorageTypesPaginatedDocument, baseOptions);
        }
export type StorageTypesPaginatedQueryHookResult = ReturnType<typeof useStorageTypesPaginatedQuery>;
export type StorageTypesPaginatedLazyQueryHookResult = ReturnType<typeof useStorageTypesPaginatedLazyQuery>;
export type StorageTypesPaginatedQueryResult = Apollo.QueryResult<StorageTypesPaginatedQuery, StorageTypesPaginatedQueryVariables>;
export const SuppliersDocument = gql`
    query suppliers($filterInput: SupplierFilterInput) {
  suppliers(where: $filterInput) {
    nodes {
      ...supplier
      address {
        ...address
      }
    }
  }
}
    ${SupplierFragmentDoc}
${AddressFragmentDoc}`;

/**
 * __useSuppliersQuery__
 *
 * To run a query within a React component, call `useSuppliersQuery` and pass it any options that fit your needs.
 * When your component renders, `useSuppliersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSuppliersQuery({
 *   variables: {
 *      filterInput: // value for 'filterInput'
 *   },
 * });
 */
export function useSuppliersQuery(baseOptions?: Apollo.QueryHookOptions<SuppliersQuery, SuppliersQueryVariables>) {
        return Apollo.useQuery<SuppliersQuery, SuppliersQueryVariables>(SuppliersDocument, baseOptions);
      }
export function useSuppliersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SuppliersQuery, SuppliersQueryVariables>) {
          return Apollo.useLazyQuery<SuppliersQuery, SuppliersQueryVariables>(SuppliersDocument, baseOptions);
        }
export type SuppliersQueryHookResult = ReturnType<typeof useSuppliersQuery>;
export type SuppliersLazyQueryHookResult = ReturnType<typeof useSuppliersLazyQuery>;
export type SuppliersQueryResult = Apollo.QueryResult<SuppliersQuery, SuppliersQueryVariables>;
export const SelectSuppliersDocument = gql`
    query selectSuppliers($filterInput: SupplierFilterInput) {
  suppliers(where: $filterInput) {
    nodes {
      id
      code
      name
    }
  }
}
    `;

/**
 * __useSelectSuppliersQuery__
 *
 * To run a query within a React component, call `useSelectSuppliersQuery` and pass it any options that fit your needs.
 * When your component renders, `useSelectSuppliersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSelectSuppliersQuery({
 *   variables: {
 *      filterInput: // value for 'filterInput'
 *   },
 * });
 */
export function useSelectSuppliersQuery(baseOptions?: Apollo.QueryHookOptions<SelectSuppliersQuery, SelectSuppliersQueryVariables>) {
        return Apollo.useQuery<SelectSuppliersQuery, SelectSuppliersQueryVariables>(SelectSuppliersDocument, baseOptions);
      }
export function useSelectSuppliersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SelectSuppliersQuery, SelectSuppliersQueryVariables>) {
          return Apollo.useLazyQuery<SelectSuppliersQuery, SelectSuppliersQueryVariables>(SelectSuppliersDocument, baseOptions);
        }
export type SelectSuppliersQueryHookResult = ReturnType<typeof useSelectSuppliersQuery>;
export type SelectSuppliersLazyQueryHookResult = ReturnType<typeof useSelectSuppliersLazyQuery>;
export type SelectSuppliersQueryResult = Apollo.QueryResult<SelectSuppliersQuery, SelectSuppliersQueryVariables>;
export const SupplierByIdDocument = gql`
    query supplierById($id: Int!, $userContext: UserContextInput) {
  supplierById(id: $id, userContext: $userContext) {
    ...supplier
    address {
      ...address
    }
  }
}
    ${SupplierFragmentDoc}
${AddressFragmentDoc}`;

/**
 * __useSupplierByIdQuery__
 *
 * To run a query within a React component, call `useSupplierByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useSupplierByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSupplierByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *      userContext: // value for 'userContext'
 *   },
 * });
 */
export function useSupplierByIdQuery(baseOptions: Apollo.QueryHookOptions<SupplierByIdQuery, SupplierByIdQueryVariables>) {
        return Apollo.useQuery<SupplierByIdQuery, SupplierByIdQueryVariables>(SupplierByIdDocument, baseOptions);
      }
export function useSupplierByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SupplierByIdQuery, SupplierByIdQueryVariables>) {
          return Apollo.useLazyQuery<SupplierByIdQuery, SupplierByIdQueryVariables>(SupplierByIdDocument, baseOptions);
        }
export type SupplierByIdQueryHookResult = ReturnType<typeof useSupplierByIdQuery>;
export type SupplierByIdLazyQueryHookResult = ReturnType<typeof useSupplierByIdLazyQuery>;
export type SupplierByIdQueryResult = Apollo.QueryResult<SupplierByIdQuery, SupplierByIdQueryVariables>;
export const SuppliersPaginatedDocument = gql`
    query suppliersPaginated($filterInput: SupplierFilterInput, $first: Int, $after: String, $before: String, $userContext: UserContextInput) {
  suppliers(
    where: $filterInput
    first: $first
    after: $after
    before: $before
    userContext: $userContext
  ) {
    totalCount
    pageInfo {
      endCursor
      startCursor
      hasNextPage
      hasPreviousPage
    }
    nodes {
      id
      code
      name
    }
  }
}
    `;

/**
 * __useSuppliersPaginatedQuery__
 *
 * To run a query within a React component, call `useSuppliersPaginatedQuery` and pass it any options that fit your needs.
 * When your component renders, `useSuppliersPaginatedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSuppliersPaginatedQuery({
 *   variables: {
 *      filterInput: // value for 'filterInput'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      userContext: // value for 'userContext'
 *   },
 * });
 */
export function useSuppliersPaginatedQuery(baseOptions?: Apollo.QueryHookOptions<SuppliersPaginatedQuery, SuppliersPaginatedQueryVariables>) {
        return Apollo.useQuery<SuppliersPaginatedQuery, SuppliersPaginatedQueryVariables>(SuppliersPaginatedDocument, baseOptions);
      }
export function useSuppliersPaginatedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SuppliersPaginatedQuery, SuppliersPaginatedQueryVariables>) {
          return Apollo.useLazyQuery<SuppliersPaginatedQuery, SuppliersPaginatedQueryVariables>(SuppliersPaginatedDocument, baseOptions);
        }
export type SuppliersPaginatedQueryHookResult = ReturnType<typeof useSuppliersPaginatedQuery>;
export type SuppliersPaginatedLazyQueryHookResult = ReturnType<typeof useSuppliersPaginatedLazyQuery>;
export type SuppliersPaginatedQueryResult = Apollo.QueryResult<SuppliersPaginatedQuery, SuppliersPaginatedQueryVariables>;
export const CurrentUserDocument = gql`
    query currentUser {
  currentUser {
    __typename
    ... on WMSUser {
      ...currentUser
      ...userMenus
    }
    ... on DatabaseError {
      DBErrorId: id
      message
    }
    ... on ValidationError {
      field
      ValidationErrorId: id
      messages
    }
  }
}
    ${CurrentUserFragmentDoc}
${UserMenusFragmentDoc}`;

/**
 * __useCurrentUserQuery__
 *
 * To run a query within a React component, call `useCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentUserQuery(baseOptions?: Apollo.QueryHookOptions<CurrentUserQuery, CurrentUserQueryVariables>) {
        return Apollo.useQuery<CurrentUserQuery, CurrentUserQueryVariables>(CurrentUserDocument, baseOptions);
      }
export function useCurrentUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentUserQuery, CurrentUserQueryVariables>) {
          return Apollo.useLazyQuery<CurrentUserQuery, CurrentUserQueryVariables>(CurrentUserDocument, baseOptions);
        }
export type CurrentUserQueryHookResult = ReturnType<typeof useCurrentUserQuery>;
export type CurrentUserLazyQueryHookResult = ReturnType<typeof useCurrentUserLazyQuery>;
export type CurrentUserQueryResult = Apollo.QueryResult<CurrentUserQuery, CurrentUserQueryVariables>;
export const UsersDocument = gql`
    query users($filterInput: WMSUserFilterInput) {
  users(where: $filterInput) {
    nodes {
      __typename
      ... on WMSUser {
        ...user
      }
    }
  }
}
    ${UserFragmentDoc}`;

/**
 * __useUsersQuery__
 *
 * To run a query within a React component, call `useUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUsersQuery({
 *   variables: {
 *      filterInput: // value for 'filterInput'
 *   },
 * });
 */
export function useUsersQuery(baseOptions?: Apollo.QueryHookOptions<UsersQuery, UsersQueryVariables>) {
        return Apollo.useQuery<UsersQuery, UsersQueryVariables>(UsersDocument, baseOptions);
      }
export function useUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UsersQuery, UsersQueryVariables>) {
          return Apollo.useLazyQuery<UsersQuery, UsersQueryVariables>(UsersDocument, baseOptions);
        }
export type UsersQueryHookResult = ReturnType<typeof useUsersQuery>;
export type UsersLazyQueryHookResult = ReturnType<typeof useUsersLazyQuery>;
export type UsersQueryResult = Apollo.QueryResult<UsersQuery, UsersQueryVariables>;
export const UserByIdDocument = gql`
    query userById($id: String) {
  userById(id: $id) {
    __typename
    ... on WMSUser {
      ...user
      userPermissions {
        ...userPermission
      }
      userMenus {
        ...menuEntry
        screen {
          ...screen
        }
        parent {
          ...menuEntry
          screen {
            ...screen
          }
        }
        children {
          ...menuEntry
          screen {
            ...screen
          }
          children {
            ...menuEntry
            screen {
              ...screen
            }
            children {
              ...menuEntry
              screen {
                ...screen
              }
              children {
                ...menuEntry
                screen {
                  ...screen
                }
              }
            }
          }
        }
      }
    }
    ... on DatabaseError {
      DBErrorId: id
      message
    }
    ... on ValidationError {
      field
      ValidationErrorId: id
      messages
    }
  }
}
    ${UserFragmentDoc}
${UserPermissionFragmentDoc}
${MenuEntryFragmentDoc}
${ScreenFragmentDoc}`;

/**
 * __useUserByIdQuery__
 *
 * To run a query within a React component, call `useUserByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUserByIdQuery(baseOptions?: Apollo.QueryHookOptions<UserByIdQuery, UserByIdQueryVariables>) {
        return Apollo.useQuery<UserByIdQuery, UserByIdQueryVariables>(UserByIdDocument, baseOptions);
      }
export function useUserByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserByIdQuery, UserByIdQueryVariables>) {
          return Apollo.useLazyQuery<UserByIdQuery, UserByIdQueryVariables>(UserByIdDocument, baseOptions);
        }
export type UserByIdQueryHookResult = ReturnType<typeof useUserByIdQuery>;
export type UserByIdLazyQueryHookResult = ReturnType<typeof useUserByIdLazyQuery>;
export type UserByIdQueryResult = Apollo.QueryResult<UserByIdQuery, UserByIdQueryVariables>;
export const UserByUsernameDocument = gql`
    query userByUsername($username: String) {
  userByUsername(username: $username) {
    __typename
    ... on WMSUser {
      ...user
    }
  }
}
    ${UserFragmentDoc}`;

/**
 * __useUserByUsernameQuery__
 *
 * To run a query within a React component, call `useUserByUsernameQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserByUsernameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserByUsernameQuery({
 *   variables: {
 *      username: // value for 'username'
 *   },
 * });
 */
export function useUserByUsernameQuery(baseOptions?: Apollo.QueryHookOptions<UserByUsernameQuery, UserByUsernameQueryVariables>) {
        return Apollo.useQuery<UserByUsernameQuery, UserByUsernameQueryVariables>(UserByUsernameDocument, baseOptions);
      }
export function useUserByUsernameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserByUsernameQuery, UserByUsernameQueryVariables>) {
          return Apollo.useLazyQuery<UserByUsernameQuery, UserByUsernameQueryVariables>(UserByUsernameDocument, baseOptions);
        }
export type UserByUsernameQueryHookResult = ReturnType<typeof useUserByUsernameQuery>;
export type UserByUsernameLazyQueryHookResult = ReturnType<typeof useUserByUsernameLazyQuery>;
export type UserByUsernameQueryResult = Apollo.QueryResult<UserByUsernameQuery, UserByUsernameQueryVariables>;
export const UsersPaginatedDocument = gql`
    query usersPaginated($filterInput: WMSUserFilterInput, $first: Int, $after: String, $before: String) {
  users(where: $filterInput, first: $first, after: $after, before: $before) {
    pageInfo {
      endCursor
      startCursor
      hasNextPage
      hasPreviousPage
    }
    totalCount
    nodes {
      ... on WMSUser {
        id
        forename
        surname
        userName
      }
    }
  }
}
    `;

/**
 * __useUsersPaginatedQuery__
 *
 * To run a query within a React component, call `useUsersPaginatedQuery` and pass it any options that fit your needs.
 * When your component renders, `useUsersPaginatedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUsersPaginatedQuery({
 *   variables: {
 *      filterInput: // value for 'filterInput'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *   },
 * });
 */
export function useUsersPaginatedQuery(baseOptions?: Apollo.QueryHookOptions<UsersPaginatedQuery, UsersPaginatedQueryVariables>) {
        return Apollo.useQuery<UsersPaginatedQuery, UsersPaginatedQueryVariables>(UsersPaginatedDocument, baseOptions);
      }
export function useUsersPaginatedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UsersPaginatedQuery, UsersPaginatedQueryVariables>) {
          return Apollo.useLazyQuery<UsersPaginatedQuery, UsersPaginatedQueryVariables>(UsersPaginatedDocument, baseOptions);
        }
export type UsersPaginatedQueryHookResult = ReturnType<typeof useUsersPaginatedQuery>;
export type UsersPaginatedLazyQueryHookResult = ReturnType<typeof useUsersPaginatedLazyQuery>;
export type UsersPaginatedQueryResult = Apollo.QueryResult<UsersPaginatedQuery, UsersPaginatedQueryVariables>;
export const UserMenuByUserIdDocument = gql`
    query userMenuByUserId($id: String) {
  userById(id: $id) {
    __typename
    ... on WMSUser {
      id
      userMenus {
        ...menuEntry
        screen {
          ...screen
        }
        parent {
          ...menuEntry
          screen {
            ...screen
          }
        }
        children {
          ...menuEntry
          screen {
            ...screen
          }
          children {
            ...menuEntry
            screen {
              ...screen
            }
            children {
              ...menuEntry
              screen {
                ...screen
              }
              children {
                ...menuEntry
                screen {
                  ...screen
                }
              }
            }
          }
        }
      }
    }
    ... on DatabaseError {
      DBErrorId: id
      message
    }
    ... on ValidationError {
      field
      ValidationErrorId: id
      messages
    }
  }
}
    ${MenuEntryFragmentDoc}
${ScreenFragmentDoc}`;

/**
 * __useUserMenuByUserIdQuery__
 *
 * To run a query within a React component, call `useUserMenuByUserIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserMenuByUserIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserMenuByUserIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUserMenuByUserIdQuery(baseOptions?: Apollo.QueryHookOptions<UserMenuByUserIdQuery, UserMenuByUserIdQueryVariables>) {
        return Apollo.useQuery<UserMenuByUserIdQuery, UserMenuByUserIdQueryVariables>(UserMenuByUserIdDocument, baseOptions);
      }
export function useUserMenuByUserIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserMenuByUserIdQuery, UserMenuByUserIdQueryVariables>) {
          return Apollo.useLazyQuery<UserMenuByUserIdQuery, UserMenuByUserIdQueryVariables>(UserMenuByUserIdDocument, baseOptions);
        }
export type UserMenuByUserIdQueryHookResult = ReturnType<typeof useUserMenuByUserIdQuery>;
export type UserMenuByUserIdLazyQueryHookResult = ReturnType<typeof useUserMenuByUserIdLazyQuery>;
export type UserMenuByUserIdQueryResult = Apollo.QueryResult<UserMenuByUserIdQuery, UserMenuByUserIdQueryVariables>;
export const SetPasswordForUserDocument = gql`
    mutation setPasswordForUser($id: String, $newPassword: String) {
  setPasswordForUser(id: $id, newPassword: $newPassword) {
    ... on WMSUser {
      userName
    }
    ... on DatabaseError {
      id
      message
    }
    ... on ValidationError {
      id
      messages
    }
  }
}
    `;
export type SetPasswordForUserMutationFn = Apollo.MutationFunction<SetPasswordForUserMutation, SetPasswordForUserMutationVariables>;

/**
 * __useSetPasswordForUserMutation__
 *
 * To run a mutation, you first call `useSetPasswordForUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetPasswordForUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setPasswordForUserMutation, { data, loading, error }] = useSetPasswordForUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *      newPassword: // value for 'newPassword'
 *   },
 * });
 */
export function useSetPasswordForUserMutation(baseOptions?: Apollo.MutationHookOptions<SetPasswordForUserMutation, SetPasswordForUserMutationVariables>) {
        return Apollo.useMutation<SetPasswordForUserMutation, SetPasswordForUserMutationVariables>(SetPasswordForUserDocument, baseOptions);
      }
export type SetPasswordForUserMutationHookResult = ReturnType<typeof useSetPasswordForUserMutation>;
export type SetPasswordForUserMutationResult = Apollo.MutationResult<SetPasswordForUserMutation>;
export type SetPasswordForUserMutationOptions = Apollo.BaseMutationOptions<SetPasswordForUserMutation, SetPasswordForUserMutationVariables>;
export const UserPermissionsDocument = gql`
    query userPermissions($filterInput: UserPermissionFilterInput) {
  userPermissions(where: $filterInput) {
    nodes {
      ...userPermission
    }
  }
}
    ${UserPermissionFragmentDoc}`;

/**
 * __useUserPermissionsQuery__
 *
 * To run a query within a React component, call `useUserPermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserPermissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserPermissionsQuery({
 *   variables: {
 *      filterInput: // value for 'filterInput'
 *   },
 * });
 */
export function useUserPermissionsQuery(baseOptions?: Apollo.QueryHookOptions<UserPermissionsQuery, UserPermissionsQueryVariables>) {
        return Apollo.useQuery<UserPermissionsQuery, UserPermissionsQueryVariables>(UserPermissionsDocument, baseOptions);
      }
export function useUserPermissionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserPermissionsQuery, UserPermissionsQueryVariables>) {
          return Apollo.useLazyQuery<UserPermissionsQuery, UserPermissionsQueryVariables>(UserPermissionsDocument, baseOptions);
        }
export type UserPermissionsQueryHookResult = ReturnType<typeof useUserPermissionsQuery>;
export type UserPermissionsLazyQueryHookResult = ReturnType<typeof useUserPermissionsLazyQuery>;
export type UserPermissionsQueryResult = Apollo.QueryResult<UserPermissionsQuery, UserPermissionsQueryVariables>;
export const UserPermissionDocument = gql`
    query userPermission($id: Int!) {
  userPermission(id: $id) {
    ...userPermission
  }
}
    ${UserPermissionFragmentDoc}`;

/**
 * __useUserPermissionQuery__
 *
 * To run a query within a React component, call `useUserPermissionQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserPermissionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserPermissionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUserPermissionQuery(baseOptions: Apollo.QueryHookOptions<UserPermissionQuery, UserPermissionQueryVariables>) {
        return Apollo.useQuery<UserPermissionQuery, UserPermissionQueryVariables>(UserPermissionDocument, baseOptions);
      }
export function useUserPermissionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserPermissionQuery, UserPermissionQueryVariables>) {
          return Apollo.useLazyQuery<UserPermissionQuery, UserPermissionQueryVariables>(UserPermissionDocument, baseOptions);
        }
export type UserPermissionQueryHookResult = ReturnType<typeof useUserPermissionQuery>;
export type UserPermissionLazyQueryHookResult = ReturnType<typeof useUserPermissionLazyQuery>;
export type UserPermissionQueryResult = Apollo.QueryResult<UserPermissionQuery, UserPermissionQueryVariables>;
export const WarehouseByIdDocument = gql`
    query warehouseById($id: Int!) {
  warehouseById(id: $id) {
    ...warehouse
    address {
      ...address
    }
  }
}
    ${WarehouseFragmentDoc}
${AddressFragmentDoc}`;

/**
 * __useWarehouseByIdQuery__
 *
 * To run a query within a React component, call `useWarehouseByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useWarehouseByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWarehouseByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useWarehouseByIdQuery(baseOptions: Apollo.QueryHookOptions<WarehouseByIdQuery, WarehouseByIdQueryVariables>) {
        return Apollo.useQuery<WarehouseByIdQuery, WarehouseByIdQueryVariables>(WarehouseByIdDocument, baseOptions);
      }
export function useWarehouseByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WarehouseByIdQuery, WarehouseByIdQueryVariables>) {
          return Apollo.useLazyQuery<WarehouseByIdQuery, WarehouseByIdQueryVariables>(WarehouseByIdDocument, baseOptions);
        }
export type WarehouseByIdQueryHookResult = ReturnType<typeof useWarehouseByIdQuery>;
export type WarehouseByIdLazyQueryHookResult = ReturnType<typeof useWarehouseByIdLazyQuery>;
export type WarehouseByIdQueryResult = Apollo.QueryResult<WarehouseByIdQuery, WarehouseByIdQueryVariables>;
export const WarehouseByCodeDocument = gql`
    query warehouseByCode($code: String!) {
  warehouseByCode(code: $code) {
    ...warehouse
    address {
      ...address
    }
  }
}
    ${WarehouseFragmentDoc}
${AddressFragmentDoc}`;

/**
 * __useWarehouseByCodeQuery__
 *
 * To run a query within a React component, call `useWarehouseByCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useWarehouseByCodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWarehouseByCodeQuery({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useWarehouseByCodeQuery(baseOptions: Apollo.QueryHookOptions<WarehouseByCodeQuery, WarehouseByCodeQueryVariables>) {
        return Apollo.useQuery<WarehouseByCodeQuery, WarehouseByCodeQueryVariables>(WarehouseByCodeDocument, baseOptions);
      }
export function useWarehouseByCodeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WarehouseByCodeQuery, WarehouseByCodeQueryVariables>) {
          return Apollo.useLazyQuery<WarehouseByCodeQuery, WarehouseByCodeQueryVariables>(WarehouseByCodeDocument, baseOptions);
        }
export type WarehouseByCodeQueryHookResult = ReturnType<typeof useWarehouseByCodeQuery>;
export type WarehouseByCodeLazyQueryHookResult = ReturnType<typeof useWarehouseByCodeLazyQuery>;
export type WarehouseByCodeQueryResult = Apollo.QueryResult<WarehouseByCodeQuery, WarehouseByCodeQueryVariables>;
export const WarehousesDocument = gql`
    query warehouses($filterInput: WarehouseFilterInput) {
  warehouses(where: $filterInput, first: 10) {
    pageInfo {
      endCursor
      startCursor
      hasNextPage
      hasPreviousPage
    }
    totalCount
    nodes {
      ...warehouse
      address {
        ...address
      }
    }
  }
}
    ${WarehouseFragmentDoc}
${AddressFragmentDoc}`;

/**
 * __useWarehousesQuery__
 *
 * To run a query within a React component, call `useWarehousesQuery` and pass it any options that fit your needs.
 * When your component renders, `useWarehousesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWarehousesQuery({
 *   variables: {
 *      filterInput: // value for 'filterInput'
 *   },
 * });
 */
export function useWarehousesQuery(baseOptions?: Apollo.QueryHookOptions<WarehousesQuery, WarehousesQueryVariables>) {
        return Apollo.useQuery<WarehousesQuery, WarehousesQueryVariables>(WarehousesDocument, baseOptions);
      }
export function useWarehousesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WarehousesQuery, WarehousesQueryVariables>) {
          return Apollo.useLazyQuery<WarehousesQuery, WarehousesQueryVariables>(WarehousesDocument, baseOptions);
        }
export type WarehousesQueryHookResult = ReturnType<typeof useWarehousesQuery>;
export type WarehousesLazyQueryHookResult = ReturnType<typeof useWarehousesLazyQuery>;
export type WarehousesQueryResult = Apollo.QueryResult<WarehousesQuery, WarehousesQueryVariables>;
export const WarehousesPaginatedDocument = gql`
    query warehousesPaginated($filterInput: WarehouseFilterInput, $first: Int, $after: String, $before: String) {
  warehouses(where: $filterInput, first: $first, after: $after, before: $before) {
    pageInfo {
      endCursor
      startCursor
      hasNextPage
      hasPreviousPage
    }
    totalCount
    nodes {
      id
      code
      warehouseName
      companyName
    }
  }
}
    `;

/**
 * __useWarehousesPaginatedQuery__
 *
 * To run a query within a React component, call `useWarehousesPaginatedQuery` and pass it any options that fit your needs.
 * When your component renders, `useWarehousesPaginatedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWarehousesPaginatedQuery({
 *   variables: {
 *      filterInput: // value for 'filterInput'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *   },
 * });
 */
export function useWarehousesPaginatedQuery(baseOptions?: Apollo.QueryHookOptions<WarehousesPaginatedQuery, WarehousesPaginatedQueryVariables>) {
        return Apollo.useQuery<WarehousesPaginatedQuery, WarehousesPaginatedQueryVariables>(WarehousesPaginatedDocument, baseOptions);
      }
export function useWarehousesPaginatedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WarehousesPaginatedQuery, WarehousesPaginatedQueryVariables>) {
          return Apollo.useLazyQuery<WarehousesPaginatedQuery, WarehousesPaginatedQueryVariables>(WarehousesPaginatedDocument, baseOptions);
        }
export type WarehousesPaginatedQueryHookResult = ReturnType<typeof useWarehousesPaginatedQuery>;
export type WarehousesPaginatedLazyQueryHookResult = ReturnType<typeof useWarehousesPaginatedLazyQuery>;
export type WarehousesPaginatedQueryResult = Apollo.QueryResult<WarehousesPaginatedQuery, WarehousesPaginatedQueryVariables>;
export const SelectWarehousesDocument = gql`
    query selectWarehouses {
  warehouses {
    nodes {
      id
      code
      warehouseName
    }
  }
}
    `;

/**
 * __useSelectWarehousesQuery__
 *
 * To run a query within a React component, call `useSelectWarehousesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSelectWarehousesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSelectWarehousesQuery({
 *   variables: {
 *   },
 * });
 */
export function useSelectWarehousesQuery(baseOptions?: Apollo.QueryHookOptions<SelectWarehousesQuery, SelectWarehousesQueryVariables>) {
        return Apollo.useQuery<SelectWarehousesQuery, SelectWarehousesQueryVariables>(SelectWarehousesDocument, baseOptions);
      }
export function useSelectWarehousesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SelectWarehousesQuery, SelectWarehousesQueryVariables>) {
          return Apollo.useLazyQuery<SelectWarehousesQuery, SelectWarehousesQueryVariables>(SelectWarehousesDocument, baseOptions);
        }
export type SelectWarehousesQueryHookResult = ReturnType<typeof useSelectWarehousesQuery>;
export type SelectWarehousesLazyQueryHookResult = ReturnType<typeof useSelectWarehousesLazyQuery>;
export type SelectWarehousesQueryResult = Apollo.QueryResult<SelectWarehousesQuery, SelectWarehousesQueryVariables>;
export const WarehouseZonesDocument = gql`
    query warehouseZones($filterInput: WarehouseZoneFilterInput, $userContext: UserContextInput) {
  warehouseZones(where: $filterInput, userContext: $userContext) {
    nodes {
      ...warehouseZone
      zoneType
    }
  }
}
    ${WarehouseZoneFragmentDoc}`;

/**
 * __useWarehouseZonesQuery__
 *
 * To run a query within a React component, call `useWarehouseZonesQuery` and pass it any options that fit your needs.
 * When your component renders, `useWarehouseZonesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWarehouseZonesQuery({
 *   variables: {
 *      filterInput: // value for 'filterInput'
 *      userContext: // value for 'userContext'
 *   },
 * });
 */
export function useWarehouseZonesQuery(baseOptions?: Apollo.QueryHookOptions<WarehouseZonesQuery, WarehouseZonesQueryVariables>) {
        return Apollo.useQuery<WarehouseZonesQuery, WarehouseZonesQueryVariables>(WarehouseZonesDocument, baseOptions);
      }
export function useWarehouseZonesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WarehouseZonesQuery, WarehouseZonesQueryVariables>) {
          return Apollo.useLazyQuery<WarehouseZonesQuery, WarehouseZonesQueryVariables>(WarehouseZonesDocument, baseOptions);
        }
export type WarehouseZonesQueryHookResult = ReturnType<typeof useWarehouseZonesQuery>;
export type WarehouseZonesLazyQueryHookResult = ReturnType<typeof useWarehouseZonesLazyQuery>;
export type WarehouseZonesQueryResult = Apollo.QueryResult<WarehouseZonesQuery, WarehouseZonesQueryVariables>;
export const WarehouseZonesPaginatedDocument = gql`
    query warehouseZonesPaginated($filterInput: WarehouseZoneFilterInput, $userContext: UserContextInput, $first: Int, $after: String, $before: String) {
  warehouseZones(
    where: $filterInput
    userContext: $userContext
    first: $first
    after: $after
    before: $before
  ) {
    totalCount
    pageInfo {
      hasNextPage
      startCursor
      endCursor
      startCursor
    }
    nodes {
      ...warehouseZone
      zoneType
    }
  }
}
    ${WarehouseZoneFragmentDoc}`;

/**
 * __useWarehouseZonesPaginatedQuery__
 *
 * To run a query within a React component, call `useWarehouseZonesPaginatedQuery` and pass it any options that fit your needs.
 * When your component renders, `useWarehouseZonesPaginatedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWarehouseZonesPaginatedQuery({
 *   variables: {
 *      filterInput: // value for 'filterInput'
 *      userContext: // value for 'userContext'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *   },
 * });
 */
export function useWarehouseZonesPaginatedQuery(baseOptions?: Apollo.QueryHookOptions<WarehouseZonesPaginatedQuery, WarehouseZonesPaginatedQueryVariables>) {
        return Apollo.useQuery<WarehouseZonesPaginatedQuery, WarehouseZonesPaginatedQueryVariables>(WarehouseZonesPaginatedDocument, baseOptions);
      }
export function useWarehouseZonesPaginatedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WarehouseZonesPaginatedQuery, WarehouseZonesPaginatedQueryVariables>) {
          return Apollo.useLazyQuery<WarehouseZonesPaginatedQuery, WarehouseZonesPaginatedQueryVariables>(WarehouseZonesPaginatedDocument, baseOptions);
        }
export type WarehouseZonesPaginatedQueryHookResult = ReturnType<typeof useWarehouseZonesPaginatedQuery>;
export type WarehouseZonesPaginatedLazyQueryHookResult = ReturnType<typeof useWarehouseZonesPaginatedLazyQuery>;
export type WarehouseZonesPaginatedQueryResult = Apollo.QueryResult<WarehouseZonesPaginatedQuery, WarehouseZonesPaginatedQueryVariables>;
export const WarehouseZoneByIdDocument = gql`
    query warehouseZoneById($id: Int!, $userContext: UserContextInput) {
  warehouseZone(id: $id, userContext: $userContext) {
    ...warehouseZone
    zoneType
  }
}
    ${WarehouseZoneFragmentDoc}`;

/**
 * __useWarehouseZoneByIdQuery__
 *
 * To run a query within a React component, call `useWarehouseZoneByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useWarehouseZoneByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWarehouseZoneByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *      userContext: // value for 'userContext'
 *   },
 * });
 */
export function useWarehouseZoneByIdQuery(baseOptions: Apollo.QueryHookOptions<WarehouseZoneByIdQuery, WarehouseZoneByIdQueryVariables>) {
        return Apollo.useQuery<WarehouseZoneByIdQuery, WarehouseZoneByIdQueryVariables>(WarehouseZoneByIdDocument, baseOptions);
      }
export function useWarehouseZoneByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WarehouseZoneByIdQuery, WarehouseZoneByIdQueryVariables>) {
          return Apollo.useLazyQuery<WarehouseZoneByIdQuery, WarehouseZoneByIdQueryVariables>(WarehouseZoneByIdDocument, baseOptions);
        }
export type WarehouseZoneByIdQueryHookResult = ReturnType<typeof useWarehouseZoneByIdQuery>;
export type WarehouseZoneByIdLazyQueryHookResult = ReturnType<typeof useWarehouseZoneByIdLazyQuery>;
export type WarehouseZoneByIdQueryResult = Apollo.QueryResult<WarehouseZoneByIdQuery, WarehouseZoneByIdQueryVariables>;
export const ZoneTypesDocument = gql`
    query zoneTypes {
  zoneTypes @client {
    ...zoneType
  }
}
    ${ZoneTypeFragmentDoc}`;

/**
 * __useZoneTypesQuery__
 *
 * To run a query within a React component, call `useZoneTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useZoneTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useZoneTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useZoneTypesQuery(baseOptions?: Apollo.QueryHookOptions<ZoneTypesQuery, ZoneTypesQueryVariables>) {
        return Apollo.useQuery<ZoneTypesQuery, ZoneTypesQueryVariables>(ZoneTypesDocument, baseOptions);
      }
export function useZoneTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ZoneTypesQuery, ZoneTypesQueryVariables>) {
          return Apollo.useLazyQuery<ZoneTypesQuery, ZoneTypesQueryVariables>(ZoneTypesDocument, baseOptions);
        }
export type ZoneTypesQueryHookResult = ReturnType<typeof useZoneTypesQuery>;
export type ZoneTypesLazyQueryHookResult = ReturnType<typeof useZoneTypesLazyQuery>;
export type ZoneTypesQueryResult = Apollo.QueryResult<ZoneTypesQuery, ZoneTypesQueryVariables>;